
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4pSml", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $jqXx5 = parcelRequire("jqXx5");


var $aXG5V = parcelRequire("aXG5V");


var $dh538 = parcelRequire("dh538");

class $eaaa48412fa700db$export$7f66e9a3d953663f extends Error {
    constructor(message, position){
        super(`${message} at position ${position}`);
        this.position = position;
    }
}


const $d9f523dd935c0d45$var$codeSpace = 0x20; // " "
const $d9f523dd935c0d45$var$codeNewline = 0xa; // "\n"
const $d9f523dd935c0d45$var$codeTab = 0x9; // "\t"
const $d9f523dd935c0d45$var$codeReturn = 0xd; // "\r"
const $d9f523dd935c0d45$var$codeNonBreakingSpace = 0xa0;
const $d9f523dd935c0d45$var$codeEnQuad = 0x2000;
const $d9f523dd935c0d45$var$codeHairSpace = 0x200a;
const $d9f523dd935c0d45$var$codeNarrowNoBreakSpace = 0x202f;
const $d9f523dd935c0d45$var$codeMediumMathematicalSpace = 0x205f;
const $d9f523dd935c0d45$var$codeIdeographicSpace = 0x3000;
function $d9f523dd935c0d45$export$8a9b6341a7c96bc(char) {
    return /^[0-9A-Fa-f]$/.test(char);
}
function $d9f523dd935c0d45$export$727d9dbc4fbb948f(char) {
    return char >= '0' && char <= '9';
}
function $d9f523dd935c0d45$export$dbbf36b4f6aa0d0f(char) {
    // note that the valid range is between \u{0020} and \u{10ffff},
    // but in JavaScript it is not possible to create a code point larger than
    // \u{10ffff}, so there is no need to test for that here.
    return char >= '\u0020';
}
function $d9f523dd935c0d45$export$86c7871da6bb7199(char) {
    return ',:[]/{}()\n+'.includes(char);
}
function $d9f523dd935c0d45$export$a9f938b686e06012(char) {
    return char >= 'a' && char <= 'z' || char >= 'A' && char <= 'Z' || char === '_' || char === '$';
}
function $d9f523dd935c0d45$export$8a15811e203445b5(char) {
    return char >= 'a' && char <= 'z' || char >= 'A' && char <= 'Z' || char === '_' || char === '$' || char >= '0' && char <= '9';
}
const $d9f523dd935c0d45$export$c158d3099d715644 = /^(http|https|ftp|mailto|file|data|irc):\/\/$/;
const $d9f523dd935c0d45$export$7a3bbad2a762c5dc = /^[A-Za-z0-9-._~:/?#@!$&'()*+;=]$/;
function $d9f523dd935c0d45$export$5bb406697483408c(char) {
    return ',[]/{}\n+'.includes(char);
}
function $d9f523dd935c0d45$export$b04a8912877de42a(char) {
    return $d9f523dd935c0d45$export$6941feaafb12fc71(char) || $d9f523dd935c0d45$var$regexStartOfValue.test(char);
}
// alpha, number, minus, or opening bracket or brace
const $d9f523dd935c0d45$var$regexStartOfValue = /^[[{\w-]$/;
function $d9f523dd935c0d45$export$d4061b5fcfc97271(char) {
    return char === '\n' || char === '\r' || char === '\t' || char === '\b' || char === '\f';
}
function $d9f523dd935c0d45$export$a1ed01a3e6d5a08c(text, index) {
    const code = text.charCodeAt(index);
    return code === $d9f523dd935c0d45$var$codeSpace || code === $d9f523dd935c0d45$var$codeNewline || code === $d9f523dd935c0d45$var$codeTab || code === $d9f523dd935c0d45$var$codeReturn;
}
function $d9f523dd935c0d45$export$f1a13bc8c1848c88(text, index) {
    const code = text.charCodeAt(index);
    return code === $d9f523dd935c0d45$var$codeSpace || code === $d9f523dd935c0d45$var$codeTab || code === $d9f523dd935c0d45$var$codeReturn;
}
function $d9f523dd935c0d45$export$33a40d1f05d81339(text, index) {
    const code = text.charCodeAt(index);
    return code === $d9f523dd935c0d45$var$codeNonBreakingSpace || code >= $d9f523dd935c0d45$var$codeEnQuad && code <= $d9f523dd935c0d45$var$codeHairSpace || code === $d9f523dd935c0d45$var$codeNarrowNoBreakSpace || code === $d9f523dd935c0d45$var$codeMediumMathematicalSpace || code === $d9f523dd935c0d45$var$codeIdeographicSpace;
}
function $d9f523dd935c0d45$export$6941feaafb12fc71(char) {
    // the first check double quotes, since that occurs most often
    return $d9f523dd935c0d45$export$c90a32a645344adf(char) || $d9f523dd935c0d45$export$c7f0196107e4b230(char);
}
function $d9f523dd935c0d45$export$c90a32a645344adf(char) {
    return char === '"' || char === '\u201c' || char === '\u201d';
}
function $d9f523dd935c0d45$export$5c8e8205aa3e3b6(char) {
    return char === '"';
}
function $d9f523dd935c0d45$export$c7f0196107e4b230(char) {
    return char === "'" || char === '\u2018' || char === '\u2019' || char === '\u0060' || char === '\u00b4';
}
function $d9f523dd935c0d45$export$37fd706cc430e444(char) {
    return char === "'";
}
function $d9f523dd935c0d45$export$5eb0648ae3c2ee22(text, textToStrip) {
    let stripRemainingText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const index = text.lastIndexOf(textToStrip);
    return index !== -1 ? text.substring(0, index) + (stripRemainingText ? '' : text.substring(index + 1)) : text;
}
function $d9f523dd935c0d45$export$eca8654175d9510(text, textToInsert) {
    let index = text.length;
    if (!$d9f523dd935c0d45$export$a1ed01a3e6d5a08c(text, index - 1)) // no trailing whitespaces
    return text + textToInsert;
    while($d9f523dd935c0d45$export$a1ed01a3e6d5a08c(text, index - 1))index--;
    return text.substring(0, index) + textToInsert + text.substring(index);
}
function $d9f523dd935c0d45$export$a4b863a4658d38a8(text, start, count) {
    return text.substring(0, start) + text.substring(start + count);
}
function $d9f523dd935c0d45$export$c5b16edfd4cd7cdf(text) {
    return /[,\n][ \t\r]*$/.test(text);
}


const $c5edb56365253722$var$controlCharacters = {
    '\b': '\\b',
    '\f': '\\f',
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t'
};
// map with all escape characters
const $c5edb56365253722$var$escapeCharacters = {
    '"': '"',
    '\\': '\\',
    '/': '/',
    b: '\b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t'
};
function $c5edb56365253722$export$b7f9abe9df7056b9(text) {
    let i = 0; // current index in text
    let output = ''; // generated output
    parseMarkdownCodeBlock([
        '```',
        '[```',
        '{```'
    ]);
    const processed = parseValue();
    if (!processed) throwUnexpectedEnd();
    parseMarkdownCodeBlock([
        '```',
        '```]',
        '```}'
    ]);
    const processedComma = parseCharacter(',');
    if (processedComma) parseWhitespaceAndSkipComments();
    if ((0, $d9f523dd935c0d45$export$b04a8912877de42a)(text[i]) && (0, $d9f523dd935c0d45$export$c5b16edfd4cd7cdf)(output)) {
        // start of a new value after end of the root level object: looks like
        // newline delimited JSON -> turn into a root level array
        if (!processedComma) // repair missing comma
        output = (0, $d9f523dd935c0d45$export$eca8654175d9510)(output, ',');
        parseNewlineDelimitedJSON();
    } else if (processedComma) // repair: remove trailing comma
    output = (0, $d9f523dd935c0d45$export$5eb0648ae3c2ee22)(output, ',');
    // repair redundant end quotes
    while(text[i] === '}' || text[i] === ']'){
        i++;
        parseWhitespaceAndSkipComments();
    }
    if (i >= text.length) // reached the end of the document properly
    return output;
    throwUnexpectedCharacter();
    function parseValue() {
        parseWhitespaceAndSkipComments();
        const processed = parseObject() || parseArray() || parseString() || parseNumber() || parseKeywords() || parseUnquotedString(false) || parseRegex();
        parseWhitespaceAndSkipComments();
        return processed;
    }
    function parseWhitespaceAndSkipComments() {
        let skipNewline = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        const start = i;
        let changed = parseWhitespace(skipNewline);
        do {
            changed = parseComment();
            if (changed) changed = parseWhitespace(skipNewline);
        }while (changed);
        return i > start;
    }
    function parseWhitespace(skipNewline) {
        const _isWhiteSpace = skipNewline ? (0, $d9f523dd935c0d45$export$a1ed01a3e6d5a08c) : (0, $d9f523dd935c0d45$export$f1a13bc8c1848c88);
        let whitespace = '';
        while(true){
            if (_isWhiteSpace(text, i)) {
                whitespace += text[i];
                i++;
            } else if ((0, $d9f523dd935c0d45$export$33a40d1f05d81339)(text, i)) {
                // repair special whitespace
                whitespace += ' ';
                i++;
            } else break;
        }
        if (whitespace.length > 0) {
            output += whitespace;
            return true;
        }
        return false;
    }
    function parseComment() {
        // find a block comment '/* ... */'
        if (text[i] === '/' && text[i + 1] === '*') {
            // repair block comment by skipping it
            while(i < text.length && !$c5edb56365253722$var$atEndOfBlockComment(text, i))i++;
            i += 2;
            return true;
        }
        // find a line comment '// ...'
        if (text[i] === '/' && text[i + 1] === '/') {
            // repair line comment by skipping it
            while(i < text.length && text[i] !== '\n')i++;
            return true;
        }
        return false;
    }
    function parseMarkdownCodeBlock(blocks) {
        // find and skip over a Markdown fenced code block:
        //     ``` ... ```
        // or
        //     ```json ... ```
        if (skipMarkdownCodeBlock(blocks)) {
            if ((0, $d9f523dd935c0d45$export$a9f938b686e06012)(text[i])) // strip the optional language specifier like "json"
            while(i < text.length && (0, $d9f523dd935c0d45$export$8a15811e203445b5)(text[i]))i++;
            parseWhitespaceAndSkipComments();
            return true;
        }
        return false;
    }
    function skipMarkdownCodeBlock(blocks) {
        parseWhitespace(true);
        for (const block of blocks){
            const end = i + block.length;
            if (text.slice(i, end) === block) {
                i = end;
                return true;
            }
        }
        return false;
    }
    function parseCharacter(char) {
        if (text[i] === char) {
            output += text[i];
            i++;
            return true;
        }
        return false;
    }
    function skipCharacter(char) {
        if (text[i] === char) {
            i++;
            return true;
        }
        return false;
    }
    function skipEscapeCharacter() {
        return skipCharacter('\\');
    }
    /**
   * Skip ellipsis like "[1,2,3,...]" or "[1,2,3,...,9]" or "[...,7,8,9]"
   * or a similar construct in objects.
   */ function skipEllipsis() {
        parseWhitespaceAndSkipComments();
        if (text[i] === '.' && text[i + 1] === '.' && text[i + 2] === '.') {
            // repair: remove the ellipsis (three dots) and optionally a comma
            i += 3;
            parseWhitespaceAndSkipComments();
            skipCharacter(',');
            return true;
        }
        return false;
    }
    /**
   * Parse an object like '{"key": "value"}'
   */ function parseObject() {
        if (text[i] === '{') {
            output += '{';
            i++;
            parseWhitespaceAndSkipComments();
            // repair: skip leading comma like in {, message: "hi"}
            if (skipCharacter(',')) parseWhitespaceAndSkipComments();
            let initial = true;
            while(i < text.length && text[i] !== '}'){
                let processedComma;
                if (!initial) {
                    processedComma = parseCharacter(',');
                    if (!processedComma) // repair missing comma
                    output = (0, $d9f523dd935c0d45$export$eca8654175d9510)(output, ',');
                    parseWhitespaceAndSkipComments();
                } else {
                    processedComma = true;
                    initial = false;
                }
                skipEllipsis();
                const processedKey = parseString() || parseUnquotedString(true);
                if (!processedKey) {
                    if (text[i] === '}' || text[i] === '{' || text[i] === ']' || text[i] === '[' || text[i] === undefined) // repair trailing comma
                    output = (0, $d9f523dd935c0d45$export$5eb0648ae3c2ee22)(output, ',');
                    else throwObjectKeyExpected();
                    break;
                }
                parseWhitespaceAndSkipComments();
                const processedColon = parseCharacter(':');
                const truncatedText = i >= text.length;
                if (!processedColon) {
                    if ((0, $d9f523dd935c0d45$export$b04a8912877de42a)(text[i]) || truncatedText) // repair missing colon
                    output = (0, $d9f523dd935c0d45$export$eca8654175d9510)(output, ':');
                    else throwColonExpected();
                }
                const processedValue = parseValue();
                if (!processedValue) {
                    if (processedColon || truncatedText) // repair missing object value
                    output += 'null';
                    else throwColonExpected();
                }
            }
            if (text[i] === '}') {
                output += '}';
                i++;
            } else // repair missing end bracket
            output = (0, $d9f523dd935c0d45$export$eca8654175d9510)(output, '}');
            return true;
        }
        return false;
    }
    /**
   * Parse an array like '["item1", "item2", ...]'
   */ function parseArray() {
        if (text[i] === '[') {
            output += '[';
            i++;
            parseWhitespaceAndSkipComments();
            // repair: skip leading comma like in [,1,2,3]
            if (skipCharacter(',')) parseWhitespaceAndSkipComments();
            let initial = true;
            while(i < text.length && text[i] !== ']'){
                if (!initial) {
                    const processedComma = parseCharacter(',');
                    if (!processedComma) // repair missing comma
                    output = (0, $d9f523dd935c0d45$export$eca8654175d9510)(output, ',');
                } else initial = false;
                skipEllipsis();
                const processedValue = parseValue();
                if (!processedValue) {
                    // repair trailing comma
                    output = (0, $d9f523dd935c0d45$export$5eb0648ae3c2ee22)(output, ',');
                    break;
                }
            }
            if (text[i] === ']') {
                output += ']';
                i++;
            } else // repair missing closing array bracket
            output = (0, $d9f523dd935c0d45$export$eca8654175d9510)(output, ']');
            return true;
        }
        return false;
    }
    /**
   * Parse and repair Newline Delimited JSON (NDJSON):
   * multiple JSON objects separated by a newline character
   */ function parseNewlineDelimitedJSON() {
        // repair NDJSON
        let initial = true;
        let processedValue = true;
        while(processedValue){
            if (!initial) {
                // parse optional comma, insert when missing
                const processedComma = parseCharacter(',');
                if (!processedComma) // repair: add missing comma
                output = (0, $d9f523dd935c0d45$export$eca8654175d9510)(output, ',');
            } else initial = false;
            processedValue = parseValue();
        }
        if (!processedValue) // repair: remove trailing comma
        output = (0, $d9f523dd935c0d45$export$5eb0648ae3c2ee22)(output, ',');
        // repair: wrap the output inside array brackets
        output = `[\n${output}\n]`;
    }
    /**
   * Parse a string enclosed by double quotes "...". Can contain escaped quotes
   * Repair strings enclosed in single quotes or special quotes
   * Repair an escaped string
   *
   * The function can run in two stages:
   * - First, it assumes the string has a valid end quote
   * - If it turns out that the string does not have a valid end quote followed
   *   by a delimiter (which should be the case), the function runs again in a
   *   more conservative way, stopping the string at the first next delimiter
   *   and fixing the string by inserting a quote there, or stopping at a
   *   stop index detected in the first iteration.
   */ function parseString() {
        let stopAtDelimiter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        let stopAtIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        let skipEscapeChars = text[i] === '\\';
        if (skipEscapeChars) {
            // repair: remove the first escape character
            i++;
            skipEscapeChars = true;
        }
        if ((0, $d9f523dd935c0d45$export$6941feaafb12fc71)(text[i])) {
            // double quotes are correct JSON,
            // single quotes come from JavaScript for example, we assume it will have a correct single end quote too
            // otherwise, we will match any double-quote-like start with a double-quote-like end,
            // or any single-quote-like start with a single-quote-like end
            const isEndQuote = (0, $d9f523dd935c0d45$export$5c8e8205aa3e3b6)(text[i]) ? (0, $d9f523dd935c0d45$export$5c8e8205aa3e3b6) : (0, $d9f523dd935c0d45$export$37fd706cc430e444)(text[i]) ? (0, $d9f523dd935c0d45$export$37fd706cc430e444) : (0, $d9f523dd935c0d45$export$c7f0196107e4b230)(text[i]) ? (0, $d9f523dd935c0d45$export$c7f0196107e4b230) : (0, $d9f523dd935c0d45$export$c90a32a645344adf);
            const iBefore = i;
            const oBefore = output.length;
            let str = '"';
            i++;
            while(true){
                if (i >= text.length) {
                    // end of text, we are missing an end quote
                    const iPrev = prevNonWhitespaceIndex(i - 1);
                    if (!stopAtDelimiter && (0, $d9f523dd935c0d45$export$86c7871da6bb7199)(text.charAt(iPrev))) {
                        // if the text ends with a delimiter, like ["hello],
                        // so the missing end quote should be inserted before this delimiter
                        // retry parsing the string, stopping at the first next delimiter
                        i = iBefore;
                        output = output.substring(0, oBefore);
                        return parseString(true);
                    }
                    // repair missing quote
                    str = (0, $d9f523dd935c0d45$export$eca8654175d9510)(str, '"');
                    output += str;
                    return true;
                }
                if (i === stopAtIndex) {
                    // use the stop index detected in the first iteration, and repair end quote
                    str = (0, $d9f523dd935c0d45$export$eca8654175d9510)(str, '"');
                    output += str;
                    return true;
                }
                if (isEndQuote(text[i])) {
                    // end quote
                    // let us check what is before and after the quote to verify whether this is a legit end quote
                    const iQuote = i;
                    const oQuote = str.length;
                    str += '"';
                    i++;
                    output += str;
                    parseWhitespaceAndSkipComments(false);
                    if (stopAtDelimiter || i >= text.length || (0, $d9f523dd935c0d45$export$86c7871da6bb7199)(text[i]) || (0, $d9f523dd935c0d45$export$6941feaafb12fc71)(text[i]) || (0, $d9f523dd935c0d45$export$727d9dbc4fbb948f)(text[i])) {
                        // The quote is followed by the end of the text, a delimiter,
                        // or a next value. So the quote is indeed the end of the string.
                        parseConcatenatedString();
                        return true;
                    }
                    const iPrevChar = prevNonWhitespaceIndex(iQuote - 1);
                    const prevChar = text.charAt(iPrevChar);
                    if (prevChar === ',') {
                        // A comma followed by a quote, like '{"a":"b,c,"d":"e"}'.
                        // We assume that the quote is a start quote, and that the end quote
                        // should have been located right before the comma but is missing.
                        i = iBefore;
                        output = output.substring(0, oBefore);
                        return parseString(false, iPrevChar);
                    }
                    if ((0, $d9f523dd935c0d45$export$86c7871da6bb7199)(prevChar)) {
                        // This is not the right end quote: it is preceded by a delimiter,
                        // and NOT followed by a delimiter. So, there is an end quote missing
                        // parse the string again and then stop at the first next delimiter
                        i = iBefore;
                        output = output.substring(0, oBefore);
                        return parseString(true);
                    }
                    // revert to right after the quote but before any whitespace, and continue parsing the string
                    output = output.substring(0, oBefore);
                    i = iQuote + 1;
                    // repair unescaped quote
                    str = `${str.substring(0, oQuote)}\\${str.substring(oQuote)}`;
                } else if (stopAtDelimiter && (0, $d9f523dd935c0d45$export$5bb406697483408c)(text[i])) {
                    // we're in the mode to stop the string at the first delimiter
                    // because there is an end quote missing
                    // test start of an url like "https://..." (this would be parsed as a comment)
                    if (text[i - 1] === ':' && (0, $d9f523dd935c0d45$export$c158d3099d715644).test(text.substring(iBefore + 1, i + 2))) while(i < text.length && (0, $d9f523dd935c0d45$export$7a3bbad2a762c5dc).test(text[i])){
                        str += text[i];
                        i++;
                    }
                    // repair missing quote
                    str = (0, $d9f523dd935c0d45$export$eca8654175d9510)(str, '"');
                    output += str;
                    parseConcatenatedString();
                    return true;
                } else if (text[i] === '\\') {
                    // handle escaped content like \n or \u2605
                    const char = text.charAt(i + 1);
                    const escapeChar = $c5edb56365253722$var$escapeCharacters[char];
                    if (escapeChar !== undefined) {
                        str += text.slice(i, i + 2);
                        i += 2;
                    } else if (char === 'u') {
                        let j = 2;
                        while(j < 6 && (0, $d9f523dd935c0d45$export$8a9b6341a7c96bc)(text[i + j]))j++;
                        if (j === 6) {
                            str += text.slice(i, i + 6);
                            i += 6;
                        } else if (i + j >= text.length) // repair invalid or truncated unicode char at the end of the text
                        // by removing the unicode char and ending the string here
                        i = text.length;
                        else throwInvalidUnicodeCharacter();
                    } else {
                        // repair invalid escape character: remove it
                        str += char;
                        i += 2;
                    }
                } else {
                    // handle regular characters
                    const char = text.charAt(i);
                    if (char === '"' && text[i - 1] !== '\\') {
                        // repair unescaped double quote
                        str += `\\${char}`;
                        i++;
                    } else if ((0, $d9f523dd935c0d45$export$d4061b5fcfc97271)(char)) {
                        // unescaped control character
                        str += $c5edb56365253722$var$controlCharacters[char];
                        i++;
                    } else {
                        if (!(0, $d9f523dd935c0d45$export$dbbf36b4f6aa0d0f)(char)) throwInvalidCharacter(char);
                        str += char;
                        i++;
                    }
                }
                if (skipEscapeChars) // repair: skipped escape character (nothing to do)
                skipEscapeCharacter();
            }
        }
        return false;
    }
    /**
   * Repair concatenated strings like "hello" + "world", change this into "helloworld"
   */ function parseConcatenatedString() {
        let processed = false;
        parseWhitespaceAndSkipComments();
        while(text[i] === '+'){
            processed = true;
            i++;
            parseWhitespaceAndSkipComments();
            // repair: remove the end quote of the first string
            output = (0, $d9f523dd935c0d45$export$5eb0648ae3c2ee22)(output, '"', true);
            const start = output.length;
            const parsedStr = parseString();
            if (parsedStr) // repair: remove the start quote of the second string
            output = (0, $d9f523dd935c0d45$export$a4b863a4658d38a8)(output, start, 1);
            else // repair: remove the + because it is not followed by a string
            output = (0, $d9f523dd935c0d45$export$eca8654175d9510)(output, '"');
        }
        return processed;
    }
    /**
   * Parse a number like 2.4 or 2.4e6
   */ function parseNumber() {
        const start = i;
        if (text[i] === '-') {
            i++;
            if (atEndOfNumber()) {
                repairNumberEndingWithNumericSymbol(start);
                return true;
            }
            if (!(0, $d9f523dd935c0d45$export$727d9dbc4fbb948f)(text[i])) {
                i = start;
                return false;
            }
        }
        // Note that in JSON leading zeros like "00789" are not allowed.
        // We will allow all leading zeros here though and at the end of parseNumber
        // check against trailing zeros and repair that if needed.
        // Leading zeros can have meaning, so we should not clear them.
        while((0, $d9f523dd935c0d45$export$727d9dbc4fbb948f)(text[i]))i++;
        if (text[i] === '.') {
            i++;
            if (atEndOfNumber()) {
                repairNumberEndingWithNumericSymbol(start);
                return true;
            }
            if (!(0, $d9f523dd935c0d45$export$727d9dbc4fbb948f)(text[i])) {
                i = start;
                return false;
            }
            while((0, $d9f523dd935c0d45$export$727d9dbc4fbb948f)(text[i]))i++;
        }
        if (text[i] === 'e' || text[i] === 'E') {
            i++;
            if (text[i] === '-' || text[i] === '+') i++;
            if (atEndOfNumber()) {
                repairNumberEndingWithNumericSymbol(start);
                return true;
            }
            if (!(0, $d9f523dd935c0d45$export$727d9dbc4fbb948f)(text[i])) {
                i = start;
                return false;
            }
            while((0, $d9f523dd935c0d45$export$727d9dbc4fbb948f)(text[i]))i++;
        }
        // if we're not at the end of the number by this point, allow this to be parsed as another type
        if (!atEndOfNumber()) {
            i = start;
            return false;
        }
        if (i > start) {
            // repair a number with leading zeros like "00789"
            const num = text.slice(start, i);
            const hasInvalidLeadingZero = /^0\d/.test(num);
            output += hasInvalidLeadingZero ? `"${num}"` : num;
            return true;
        }
        return false;
    }
    /**
   * Parse keywords true, false, null
   * Repair Python keywords True, False, None
   */ function parseKeywords() {
        return parseKeyword('true', 'true') || parseKeyword('false', 'false') || parseKeyword('null', 'null') || // repair Python keywords True, False, None
        parseKeyword('True', 'true') || parseKeyword('False', 'false') || parseKeyword('None', 'null');
    }
    function parseKeyword(name, value) {
        if (text.slice(i, i + name.length) === name) {
            output += value;
            i += name.length;
            return true;
        }
        return false;
    }
    /**
   * Repair an unquoted string by adding quotes around it
   * Repair a MongoDB function call like NumberLong("2")
   * Repair a JSONP function call like callback({...});
   */ function parseUnquotedString(isKey) {
        // note that the symbol can end with whitespaces: we stop at the next delimiter
        // also, note that we allow strings to contain a slash / in order to support repairing regular expressions
        const start = i;
        if ((0, $d9f523dd935c0d45$export$a9f938b686e06012)(text[i])) {
            while(i < text.length && (0, $d9f523dd935c0d45$export$8a15811e203445b5)(text[i]))i++;
            let j = i;
            while((0, $d9f523dd935c0d45$export$a1ed01a3e6d5a08c)(text, j))j++;
            if (text[j] === '(') {
                // repair a MongoDB function call like NumberLong("2")
                // repair a JSONP function call like callback({...});
                i = j + 1;
                parseValue();
                if (text[i] === ')') {
                    // repair: skip close bracket of function call
                    i++;
                    if (text[i] === ';') // repair: skip semicolon after JSONP call
                    i++;
                }
                return true;
            }
        }
        while(i < text.length && !(0, $d9f523dd935c0d45$export$5bb406697483408c)(text[i]) && !(0, $d9f523dd935c0d45$export$6941feaafb12fc71)(text[i]) && (!isKey || text[i] !== ':'))i++;
        // test start of an url like "https://..." (this would be parsed as a comment)
        if (text[i - 1] === ':' && (0, $d9f523dd935c0d45$export$c158d3099d715644).test(text.substring(start, i + 2))) while(i < text.length && (0, $d9f523dd935c0d45$export$7a3bbad2a762c5dc).test(text[i]))i++;
        if (i > start) {
            // repair unquoted string
            // also, repair undefined into null
            // first, go back to prevent getting trailing whitespaces in the string
            while((0, $d9f523dd935c0d45$export$a1ed01a3e6d5a08c)(text, i - 1) && i > 0)i--;
            const symbol = text.slice(start, i);
            output += symbol === 'undefined' ? 'null' : JSON.stringify(symbol);
            if (text[i] === '"') // we had a missing start quote, but now we encountered the end quote, so we can skip that one
            i++;
            return true;
        }
    }
    function parseRegex() {
        if (text[i] === '/') {
            const start = i;
            i++;
            while(i < text.length && (text[i] !== '/' || text[i - 1] === '\\'))i++;
            i++;
            output += `"${text.substring(start, i)}"`;
            return true;
        }
    }
    function prevNonWhitespaceIndex(start) {
        let prev = start;
        while(prev > 0 && (0, $d9f523dd935c0d45$export$a1ed01a3e6d5a08c)(text, prev))prev--;
        return prev;
    }
    function atEndOfNumber() {
        return i >= text.length || (0, $d9f523dd935c0d45$export$86c7871da6bb7199)(text[i]) || (0, $d9f523dd935c0d45$export$a1ed01a3e6d5a08c)(text, i);
    }
    function repairNumberEndingWithNumericSymbol(start) {
        // repair numbers cut off at the end
        // this will only be called when we end after a '.', '-', or 'e' and does not
        // change the number more than it needs to make it valid JSON
        output += `${text.slice(start, i)}0`;
    }
    function throwInvalidCharacter(char) {
        throw new (0, $eaaa48412fa700db$export$7f66e9a3d953663f)(`Invalid character ${JSON.stringify(char)}`, i);
    }
    function throwUnexpectedCharacter() {
        throw new (0, $eaaa48412fa700db$export$7f66e9a3d953663f)(`Unexpected character ${JSON.stringify(text[i])}`, i);
    }
    function throwUnexpectedEnd() {
        throw new (0, $eaaa48412fa700db$export$7f66e9a3d953663f)('Unexpected end of json string', text.length);
    }
    function throwObjectKeyExpected() {
        throw new (0, $eaaa48412fa700db$export$7f66e9a3d953663f)('Object key expected', i);
    }
    function throwColonExpected() {
        throw new (0, $eaaa48412fa700db$export$7f66e9a3d953663f)('Colon expected', i);
    }
    function throwInvalidUnicodeCharacter() {
        const chars = text.slice(i, i + 6);
        throw new (0, $eaaa48412fa700db$export$7f66e9a3d953663f)(`Invalid unicode character "${chars}"`, i);
    }
}
function $c5edb56365253722$var$atEndOfBlockComment(text, i) {
    return text[i] === '*' && text[i + 1] === '/';
}


// eslint-disable-next-line no-restricted-imports




var $1oCLl = parcelRequire("1oCLl");

const $c7c8da7d85ce457a$var$adfStreamStartingWrappers = [
    '```json',
    '<adf_input>'
];
const $c7c8da7d85ce457a$var$adfStreamEndingWrappers = [
    '```',
    '</adf_input>'
];
function $c7c8da7d85ce457a$export$9239af86fecd5c3b(content) {
    $c7c8da7d85ce457a$var$adfStreamStartingWrappers.forEach((wrapper)=>{
        if (content.startsWith(wrapper)) content = content.replace(wrapper, '');
    });
    $c7c8da7d85ce457a$var$adfStreamEndingWrappers.forEach((wrapper)=>{
        if (content.endsWith(wrapper)) content = content.replace(wrapper, '');
    });
    if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
        /**
		 * Special case: if the pattern is at the end (dangling /), we need to escape both quote and slash
		 * "Hello"/ -> "Hello\"\/ (this keeps both chars in the string and keeps string open for jsonrepair)
		 * Pattern: (^|[^\\])"\/"$ captures start or non-backslash char before "/" and at the end of the string
		 * This handles malformed JSON like "Hello"/ -> "Hello\"\/
		 */ // eslint-disable-next-line require-unicode-regexp
        content = content.replace(/(^|[^\\])"\/$/g, '$1\\"\\/');
        /**
		 * For all other cases (not at the end)
		 * Escape unescaped double quotes followed by a forward slash
		 * Pattern: (^|[^\\])"\//g captures start or non-backslash char before "/"
		 * This handles malformed JSON like "Hello"/world" -> "Hello\"/world"
		 * It also ensures we don't capture JSON key/value pairs
		 */ if ((0, $1oCLl.expValEquals)('platform_editor_ai_fix_streaming_json_escape', 'isEnabled', true)) // eslint-disable-next-line require-unicode-regexp
        content = content.replace(/(^|[^\\:])"\//g, '$1\\"/');
        else // eslint-disable-next-line require-unicode-regexp
        content = content.replace(/(^|[^\\])"\//g, '$1\\"/');
    }
    return content;
}


class $81d0c9debb3582da$export$c1ee0a0b09546958 {
    append(chunk) {
        this.buffer += chunk;
    }
    /**
   * parse will actually repair the json string stored in buffer.
   * It will throw error if it fails to repair the json string.
   * It will return the repaired json string if it succeeds and
   * 	also indicate if the json string has changed.
   */ parse() {
        const sanitizedBuffer = (0, $c7c8da7d85ce457a$export$9239af86fecd5c3b)(this.buffer);
        const repairedJsonString = (0, $c5edb56365253722$export$b7f9abe9df7056b9)(sanitizedBuffer);
        if (repairedJsonString?.length) try {
            const repairedJson = JSON.parse(repairedJsonString);
            const size = repairedJsonString.length;
            const hasChanged = size !== this.prevSize;
            this.prevSize = size;
            return {
                hasChanged: hasChanged,
                repairedJson: repairedJson
            };
        } catch (error) {
            /**
         * If it comes here, it means JSON.parse failed.
         * Ideally, it should not happen, but if there is a bug in the jsonrepair function,
         * 	then it can return invalid json string.
         * We want to capture that, so throwing specific error here.
         */ throw new Error('failed to parse repaired json string returned by jsonrepair.');
        }
        else throw new Error('jsonrepair returned undefined or empty string.');
    }
    reset() {
        this.buffer = '';
        this.prevSize = 0;
    }
    constructor(){
        this.buffer = '';
        this.prevSize = 0;
    }
}


function $9d1bc519e8c763c2$export$fc7f14f8b3a9c1d7(attrRule, attrName, markOrNodeType) {
    if (attrRule.type === 'enum' && attrRule.values && attrRule.values.length > 0) return attrRule.values[0];
    if (attrRule.type === 'number') return attrRule.minimum ?? 0;
    if (attrRule.type === 'string') {
        // If validatorFn is defined, can't provide default
        if (attrRule.validatorFn) return null; // Signal that we can't provide default
        // If pattern is defined, try to match it
        if (attrRule.pattern) {
            // Handle common hex color patterns
            if (attrRule.pattern === '^#[0-9a-fA-F]{6}$') {
                // Using white gray as default color for text
                if (markOrNodeType === 'textColor') return '#172B4D';
                // Using light gray as default color for background
                if (markOrNodeType === 'backgroundColor') return '#DCDFE4';
                // Using black as default color
                return '#000000';
            }
            // Only border has below regex pattern
            if (attrRule.pattern === '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$') // Using subtle gray as default border color
            return '#091E4224';
            if (attrName === 'timestamp') return new Date().getTime().toString();
            else if (attrName === 'shortName') return ':smile:';
            /**
			 * For other patterns, return empty string
			 * Better solution is to use https://github.com/wimpyprogrammer/regex-to-strings
			 * 	and generate one string that matches the pattern
			 */ return null;
        }
        // If minLength is defined, generate string of minimum length
        if (attrRule.minLength && attrRule.minLength > 0) return 'a'.repeat(attrRule.minLength);
        return null;
    }
    if (attrRule.type === 'boolean') return false;
    if (attrRule.type === 'array') {
        if (attrRule.minItems && attrRule.minItems > 0) /**
			 * Generating default value which is useful is not possible
			 * 	based on current validation rules.
			 * So just returning null.
			 */ return null;
        return [];
    }
    return null;
}
function $9d1bc519e8c763c2$export$22eef2421c3aeb33(attrName, value, rule, markOrNodeType) {
    if (rule.type === 'string') {
        if (rule.pattern) {
            const regex = new RegExp(rule.pattern, 'u');
            if (!regex.test(value) && !rule.optional) {
                const defaultedValue = $9d1bc519e8c763c2$export$fc7f14f8b3a9c1d7(rule, attrName, markOrNodeType);
                if (defaultedValue === null) return {
                    isValid: false,
                    error: `Attribute '${attrName}' does not match required pattern`
                };
                return {
                    isValid: true,
                    repairedValue: defaultedValue
                };
            }
            return {
                isValid: true,
                repairedValue: value
            };
        }
        // Only number value is allowed to be converted to string
        const stringValue = typeof value === 'string' || typeof value === 'number' ? value.toString() : undefined;
        if (stringValue && (rule.minLength ? stringValue.length > rule.minLength : true)) return {
            isValid: true,
            repairedValue: stringValue
        };
        else if (!rule.optional) {
            /**
			 * Right now default value is only generated for string type having pattern.
			 * Still calling generateDefaultValueForAttribute, so that in future we can generate default value
			 * 	for other cases, it will be supported automatically.
			 */ const defaultedValue = $9d1bc519e8c763c2$export$fc7f14f8b3a9c1d7(rule, attrName, markOrNodeType);
            if (defaultedValue !== null) return {
                isValid: true,
                repairedValue: defaultedValue
            };
        }
        return {
            isValid: false,
            error: `Attribute '${attrName}' has invalid value and can't be repaired`
        };
    }
    if (rule.type === 'number') {
        const repairedValue = typeof value === 'number' ? value : parseInt(value);
        /**
		 * if mininum or maximum is defined, and repaired value is not number,
		 * 	then set repaired value to minimum or maximum
		 * 	or if repaired value is number and out of range, then set repaired value to minimum or maximum
		 */ if (rule.minimum !== undefined && (isNaN(repairedValue) || repairedValue < rule.minimum)) return {
            isValid: true,
            repairedValue: rule.minimum
        };
        else if (rule.maximum !== undefined && (isNaN(repairedValue) || repairedValue > rule.maximum)) return {
            isValid: true,
            repairedValue: rule.maximum
        };
        else if (!isNaN(repairedValue)) return {
            isValid: true,
            repairedValue: repairedValue
        };
        /**
		 * For layoutColumn width, set default value to 20 in case of invalid value.
		 * Choose 20 as default value because it's the default width for 5 column layout,
		 * 	which is minium width for layoutColumn.
		 *
		 */ if (markOrNodeType === 'layoutColumn' && attrName === 'width') return {
            isValid: true,
            repairedValue: 20
        };
        return {
            isValid: false,
            error: `Failed to repair attribute '${attrName}'`
        };
    }
    if (rule.type === 'boolean') {
        if (typeof value === 'boolean') return {
            isValid: true,
            repairedValue: value
        };
        else if (typeof value === 'string') {
            if ('true'.includes(value)) return {
                isValid: true,
                repairedValue: true
            };
            if ('false'.includes(value)) return {
                isValid: true,
                repairedValue: false
            };
        }
        return {
            isValid: false,
            error: `Attribute '${attrName}' has invalid boolean value '${value}'`
        };
    }
    if (rule.type === 'enum' && rule.values) {
        const enumValue = value;
        if (rule.values.includes(enumValue)) return {
            isValid: true,
            repairedValue: value
        };
        else {
            /**
			 * During streaming enum value may be incomplete, so try to find partial match
			 */ const partialMatches = rule.values.filter((allowedValue)=>allowedValue.startsWith(enumValue));
            if (partialMatches.length > 0) return {
                isValid: true,
                repairedValue: partialMatches[0]
            };
            /**
			 * If no partial match found, then set first value as default
			 */ const defaultEnumValue = rule.values.includes('default') ? 'default' : rule.values[0];
            return {
                isValid: true,
                repairedValue: defaultEnumValue
            };
        }
    }
    if (rule.type === 'array') {
        if (!Array.isArray(value)) return {
            isValid: false,
            error: `Attribute '${attrName}' must be an array`
        };
        const arrayItemType = rule.items?.[0]?.type;
        const invalidItemType = value.some((item)=>typeof item !== arrayItemType);
        if (invalidItemType) return {
            isValid: false,
            error: `Attribute '${attrName}' must have items of type ${arrayItemType}`
        };
        if (rule.minItems !== undefined && value.length < rule.minItems) return {
            isValid: false,
            error: `Attribute '${attrName}' must have at least ${rule.minItems} items`
        };
    }
    if (rule.type === 'object' && typeof value !== 'object') return {
        isValid: false,
        error: `Attribute '${attrName}' must be an object`
    };
    return {
        isValid: true,
        repairedValue: value
    };
}



var $4rpi6 = parcelRequire("4rpi6");

const $b6d99a6b8e9d4a93$var$blockCardTyped = (0, $4rpi6.blockCard);
const $b6d99a6b8e9d4a93$var$inlineCardTyped = (0, $4rpi6.inlineCard);
const $b6d99a6b8e9d4a93$var$mediaTyped = (0, $4rpi6.media);
const $b6d99a6b8e9d4a93$export$70a4306b43ad6238 = {
    alignment: $4rpi6.alignment,
    annotation: $4rpi6.annotation,
    backgroundColor: $4rpi6.backgroundColor,
    blockCard: $b6d99a6b8e9d4a93$var$blockCardTyped,
    block_content: $4rpi6.block_content,
    blockRootOnly: $4rpi6.blockRootOnly,
    blockquote: $4rpi6.blockquote,
    blockTaskItem: $4rpi6.blockTaskItem,
    bodiedExtension: $4rpi6.bodiedExtension,
    bodiedExtension_with_marks: $4rpi6.bodiedExtension_with_marks,
    border: $4rpi6.border,
    breakout: $4rpi6.breakout,
    bulletList: $4rpi6.bulletList,
    caption: $4rpi6.caption,
    code: $4rpi6.code,
    codeBlock: $4rpi6.codeBlock,
    codeBlock_root_only: $4rpi6.codeBlock_root_only,
    text_with_no_marks: $4rpi6.text_with_no_marks,
    confluenceInlineComment: $4rpi6.confluenceInlineComment,
    dataConsumer: $4rpi6.dataConsumer,
    date: $4rpi6.date,
    decisionItem: $4rpi6.decisionItem,
    decisionList: $4rpi6.decisionList,
    doc: $4rpi6.doc,
    em: $4rpi6.em,
    embedCard: $4rpi6.embedCard,
    emoji: $4rpi6.emoji,
    expand: $4rpi6.expand,
    expand_root_only: $4rpi6.expand_root_only,
    extension: $4rpi6.extension,
    extensionFrame: $4rpi6.extensionFrame,
    extension_with_marks: $4rpi6.extension_with_marks,
    fragment: $4rpi6.fragment,
    hardBreak: $4rpi6.hardBreak,
    heading: $4rpi6.heading,
    heading_with_alignment: $4rpi6.heading_with_alignment,
    heading_with_indentation: $4rpi6.heading_with_indentation,
    heading_with_no_marks: $4rpi6.heading_with_no_marks,
    indentation: $4rpi6.indentation,
    inlineCard: $b6d99a6b8e9d4a93$var$inlineCardTyped,
    inlineExtension: $4rpi6.inlineExtension,
    inlineExtension_with_marks: $4rpi6.inlineExtension_with_marks,
    inline_content: $4rpi6.inline_content,
    layoutColumn: $4rpi6.layoutColumn,
    layoutSection: $4rpi6.layoutSection,
    layoutSection_full: $4rpi6.layoutSection_full,
    layoutSection_with_single_column: $4rpi6.layoutSection_with_single_column,
    link: $4rpi6.link,
    listItem: $4rpi6.listItem,
    media: $b6d99a6b8e9d4a93$var$mediaTyped,
    mediaGroup: $4rpi6.mediaGroup,
    mediaInline: $4rpi6.mediaInline,
    mediaSingle: $4rpi6.mediaSingle,
    mediaSingle_caption: $4rpi6.mediaSingle_caption,
    mediaSingle_full: $4rpi6.mediaSingle_full,
    mention: $4rpi6.mention,
    multiBodiedExtension: $4rpi6.multiBodiedExtension,
    nestedExpand: $4rpi6.nestedExpand,
    nestedExpand_with_no_marks: $4rpi6.nestedExpand_with_no_marks,
    non_nestable_block_content: $4rpi6.non_nestable_block_content,
    orderedList: $4rpi6.orderedList,
    panel: $4rpi6.panel,
    paragraph: $4rpi6.paragraph,
    paragraph_with_alignment: $4rpi6.paragraph_with_alignment,
    paragraph_with_indentation: $4rpi6.paragraph_with_indentation,
    paragraph_with_no_marks: $4rpi6.paragraph_with_no_marks,
    placeholder: $4rpi6.placeholder,
    rule: $4rpi6.rule,
    status: $4rpi6.status,
    strike: $4rpi6.strike,
    strong: $4rpi6.strong,
    subsup: $4rpi6.subsup,
    table: $4rpi6.table,
    tableCell: $4rpi6.tableCell,
    tableHeader: $4rpi6.tableHeader,
    tableRow: $4rpi6.tableRow,
    taskItem: $4rpi6.taskItem,
    taskList: $4rpi6.taskList,
    text: $4rpi6.text,
    textColor: $4rpi6.textColor,
    text_code_inline: $4rpi6.text_code_inline,
    text_formatted: $4rpi6.text_formatted,
    text_link_inline: $4rpi6.text_link_inline,
    underline: $4rpi6.underline
};


function $1aa0486454fc21f2$export$5a70a9db9005e6b(nodeType) {
    const allowedMarks = new Set();
    // First try to get the main node rule
    const mainNodeRule = (0, $b6d99a6b8e9d4a93$export$70a4306b43ad6238)[nodeType];
    const additionalRules = [];
    const specKeys = Object.keys((0, $b6d99a6b8e9d4a93$export$70a4306b43ad6238));
    specKeys.forEach((specKey)=>{
        if (specKey.startsWith(nodeType) && Array.isArray((0, $b6d99a6b8e9d4a93$export$70a4306b43ad6238)[specKey]) && (0, $b6d99a6b8e9d4a93$export$70a4306b43ad6238)[specKey][0] === nodeType) additionalRules.push((0, $b6d99a6b8e9d4a93$export$70a4306b43ad6238)[specKey]);
    });
    // Extract allowed marks from the node rule
    function extractMarksFromRule(rule) {
        if (!rule) return;
        if ('props' in rule && 'marks' in rule.props && rule.props.marks) extractMarksFromItems(rule.props.marks.items);
        else if (Array.isArray(rule) && rule.length >= 2) {
            // Handle array format [nodeType, { props: { marks: ... } }]
            const additionalSpec = rule[1];
            if (additionalSpec?.props?.marks?.items) extractMarksFromItems(additionalSpec.props.marks.items);
        }
    }
    function extractMarksFromItems(items) {
        if (Array.isArray(items)) items.forEach((item)=>{
            if (typeof item === 'string') allowedMarks.add(item);
            else if (Array.isArray(item)) item.forEach((subItem)=>{
                if (typeof subItem === 'string') allowedMarks.add(subItem);
            });
        });
    }
    extractMarksFromRule(mainNodeRule);
    additionalRules.forEach((rule)=>extractMarksFromRule(rule));
    return Array.from(allowedMarks);
}
/**
 * Infer mark type from attrs if type is missing
 */ function $1aa0486454fc21f2$var$inferMarkTypeFromAttrs(attrs) {
    if (!attrs || typeof attrs !== 'object') return undefined;
    // Check for specific attribute patterns that indicate mark types
    if (attrs.align) return 'alignment';
    if (attrs.annotationType) return 'annotation';
    if (attrs.size) return 'border';
    if (attrs.color) return 'backgroundColor';
    if (attrs.mode) return 'breakout';
    if (attrs.sources) return 'dataConsumer';
    if (attrs.localId && attrs.name !== undefined) return 'fragment';
    if (attrs.level) return 'indentation';
    if (attrs.href || attrs.title || attrs.collection || attrs.occurrenceKey) return 'link';
    if (attrs.type && (attrs.type === 'sub' || attrs.type === 'sup')) return 'subsup';
}
function $1aa0486454fc21f2$var$inferMarkType(markType, allowedMarkTypes, attrs) {
    // Step 1: Try to infer type from attrs
    if (!markType) // Try to infer type from attrs
    markType = $1aa0486454fc21f2$var$inferMarkTypeFromAttrs(attrs);
    // Step 2: Try to infer, assuming type string is incomplete
    if (typeof markType === 'string' && !allowedMarkTypes.includes(markType)) {
        // Try partial matching - find marks that start with the given type
        const partialMatches = allowedMarkTypes.filter((allowedType)=>allowedType.startsWith(markType));
        if (partialMatches.length > 0) markType = partialMatches[0];
    }
    return markType;
}
/**
 * Validate and repair a single mark's attributes
 */ function $1aa0486454fc21f2$var$repairMarkAttrs(markType, attrs) {
    const markRule = (0, $b6d99a6b8e9d4a93$export$70a4306b43ad6238)[markType];
    if (!markRule) return {
        isValid: false,
        error: `Unknown mark type: ${markType}`
    };
    const attrsRule = markRule.props.attrs;
    if (!attrsRule) // Mark doesn't require attributes, not need to repair or validate attrs
    return {
        isValid: true
    };
    // If no attrs provided, try to generate defaults for required attributes
    if (!attrs) {
        const defaultAttrs = {};
        const errors = [];
        for (const [attrName, attrRule] of Object.entries(attrsRule.props))if (!attrRule.optional) {
            const defaultValue = (0, $9d1bc519e8c763c2$export$fc7f14f8b3a9c1d7)(attrRule, attrName, markType);
            if (defaultValue === null) errors.push(`Mark ${markType}: Required attribute '${attrName}' cannot have default value`);
            else defaultAttrs[attrName] = defaultValue;
        }
        if (errors.length > 0) return {
            isValid: false,
            error: errors.join('; ')
        };
        return {
            isValid: true,
            repairedAttrs: defaultAttrs
        };
    }
    const repairedAttrs = {
        ...attrs
    };
    const errors = [];
    // Check all defined attributes in the rule
    for (const [attrName, attrRule] of Object.entries(attrsRule.props)){
        const attrValue = attrs[attrName];
        // Validate and potentially repair attribute value
        const validation = (0, $9d1bc519e8c763c2$export$22eef2421c3aeb33)(attrName, attrValue, attrRule, markType);
        if (validation.isValid) repairedAttrs[attrName] = validation.repairedValue;
        else if (!attrRule.optional) errors.push(validation.error || `Invalid value for attribute '${attrName}'`);
    }
    if (errors.length > 0) return {
        isValid: false,
        error: errors.join('; ')
    };
    return {
        isValid: true,
        repairedAttrs: repairedAttrs
    };
}
/**
 * Validate and repair a single mark
 */ function $1aa0486454fc21f2$var$repairMark(mark, allowedMarkTypes) {
    if (!mark || typeof mark !== 'object') return {
        isValid: false,
        error: 'Mark must be an object'
    };
    let markType = mark.type;
    /**
	 * Step 1: If mark type is undefined or is not allowed,
	 * 	then it may be incomplete, so try to infer type from attrs
	 */ if (!markType || !allowedMarkTypes.includes(markType)) // Try to infer type from attrs
    markType = $1aa0486454fc21f2$var$inferMarkType(markType, allowedMarkTypes, mark.attrs);
    if (!markType) return {
        isValid: false,
        error: `Mark type '${markType}' is invalid and could not be inferred`
    };
    // Step 2: Validate and repairmark attributes
    const attrValidationResult = $1aa0486454fc21f2$var$repairMarkAttrs(markType, mark.attrs);
    if (!attrValidationResult.isValid) return {
        isValid: false,
        error: attrValidationResult.error
    };
    const repairedMark = {
        type: markType
    };
    // Only add attrs if they exist and are not empty
    if (attrValidationResult.repairedAttrs && Object.keys(attrValidationResult.repairedAttrs).length > 0) repairedMark.attrs = attrValidationResult.repairedAttrs;
    return {
        isValid: true,
        repairedMark: repairedMark
    };
}
function $1aa0486454fc21f2$export$fb8ba848cbd161c6(nodeType, marks) {
    /**
	 * Currently makrs are always optional, so if marks are not provided,
	 * 	then simply consider it as valid.
	 */ if (!marks || !Array.isArray(marks)) return {
        repairedMarks: []
    };
    const allowedMarkTypes = $1aa0486454fc21f2$export$5a70a9db9005e6b(nodeType);
    const repairedMarks = [];
    const errors = [];
    for(let i = 0; i < marks.length; i++){
        const mark = marks[i];
        const result = $1aa0486454fc21f2$var$repairMark(mark, allowedMarkTypes);
        if (result.isValid && result.repairedMark) repairedMarks.push(result.repairedMark);
        else errors.push(result.error || `Can' repair mark ${mark.type} for node ${nodeType}`);
    }
    return {
        repairedMarks: repairedMarks,
        errors: errors
    };
}







/**
 * Resolve the actual node spec from a nodeType, handling secondary specs
 */ function $e0378dbdee4e269d$var$resolveNodeSpec(nodeType) {
    const mainSpec = (0, $b6d99a6b8e9d4a93$export$70a4306b43ad6238)[nodeType];
    if (!mainSpec) return null;
    const nodeSpec = mainSpec;
    // If main spec has attrs, use it directly
    if (nodeSpec.props.attrs) return nodeSpec;
    // If main spec doesn't have attrs, look for secondary specs that extend this nodeType
    for (const [, secondarySpec] of Object.entries((0, $b6d99a6b8e9d4a93$export$70a4306b43ad6238)))if (Array.isArray(secondarySpec)) {
        const [baseNodeType, extendedSpec] = secondarySpec;
        if (baseNodeType === nodeType && extendedSpec.props.attrs) // Found a secondary spec that extends this nodeType and has attrs
        return {
            ...nodeSpec,
            props: {
                ...nodeSpec.props,
                ...extendedSpec.props
            },
            required: extendedSpec.required || nodeSpec.required
        };
    }
    // Return main spec even if it doesn't have attrs
    return nodeSpec;
}
/**
 * Validate attributes against a single attribute group spec
 */ function $e0378dbdee4e269d$var$validateAttrsAgainstGroup(attrs, attrsGroup, nodeType) {
    // If no attrs provided, try to generate defaults for required attributes
    if (!attrs) {
        const defaultAttrs = {};
        const errors = [];
        for (const [attrName, attrRule] of Object.entries(attrsGroup.props))if (!attrRule.optional) {
            const defaultValue = (0, $9d1bc519e8c763c2$export$fc7f14f8b3a9c1d7)(attrRule, attrName, nodeType);
            if (defaultValue === null) errors.push(`Required attribute '${attrName}' cannot have default value (has validatorFn)`);
            else defaultAttrs[attrName] = defaultValue;
        }
        if (errors.length > 0) return {
            isValid: false,
            error: errors.join('; ')
        };
        return {
            isValid: true,
            repairedAttrs: defaultAttrs
        };
    }
    const repairedAttrs = {
        ...attrs
    };
    const errors = [];
    // Check all defined attributes in the rule
    for (const [attrName, attrRule] of Object.entries(attrsGroup.props)){
        const attrValue = attrs[attrName];
        // Validate and potentially repair attribute value
        const validation = (0, $9d1bc519e8c763c2$export$22eef2421c3aeb33)(attrName, attrValue, attrRule, nodeType);
        if (validation.isValid) repairedAttrs[attrName] = validation.repairedValue;
        else if (!attrRule.optional) errors.push(validation.error || `Invalid value for attribute '${attrName}'`);
    }
    if (errors.length > 0) return {
        isValid: false,
        error: errors.join('; ')
    };
    return {
        isValid: true,
        repairedAttrs: repairedAttrs
    };
}
function $e0378dbdee4e269d$export$fde9f26eb5c83773(nodeType, attrs) {
    const spec = (0, $b6d99a6b8e9d4a93$export$70a4306b43ad6238)[nodeType];
    if (!spec) return {
        isValid: false,
        error: `Unknown node type: ${nodeType}`
    };
    // Use resolveNodeSpec for main specs to handle attrs resolution
    const resolvedSpec = $e0378dbdee4e269d$var$resolveNodeSpec(nodeType);
    if (!resolvedSpec) return {
        isValid: false,
        error: `Unable to resolve spec for node type: ${nodeType}`
    };
    const nodeSpec = resolvedSpec;
    const attrsRule = nodeSpec.props.attrs;
    if (!attrsRule) // Node doesn't require attributes
    return {
        isValid: true,
        repairedAttrs: attrs || {}
    };
    // Handle array of attribute groups (multiple possible schemas)
    if (Array.isArray(attrsRule)) {
        const errors = [];
        // Try each attribute group until one succeeds
        for(let i = 0; i < attrsRule.length; i++){
            const attrsGroup = attrsRule[i];
            const result = $e0378dbdee4e269d$var$validateAttrsAgainstGroup(attrs, attrsGroup, nodeType);
            /**
			 * If validateAttrsAgainstGroup has repaired attrs, then don't return.
			 * Check against next attrsGroup. If last group, then return.
			 */ if (result.isValid && (i === attrsRule.length - 1 || (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(result.repairedAttrs, attrs))) return result;
            else errors.push(result.error || 'Unknown validation error');
        }
        // If none of the attribute groups worked, return combined errors
        return {
            isValid: false,
            error: `Node '${nodeType}' attrs don't match any valid schema: ${errors.join(' | ')}`
        };
    }
    // Handle single attribute group
    return $e0378dbdee4e269d$var$validateAttrsAgainstGroup(attrs, attrsRule, nodeType);
}


const $f28f9cd61441a099$var$fixTimestamp = (timestamp)=>{
    const currentTime = new Date().getTime().toString();
    if (!timestamp) return currentTime;
    if (typeof timestamp !== 'string') return timestamp;
    if (timestamp.includes('-')) {
        const time = new Date(timestamp).getTime();
        return isNaN(time) ? currentTime : time.toString();
    }
    // eslint-disable-next-line require-unicode-regexp
    if (!timestamp.match(/^\d+$/)) return currentTime;
    return timestamp;
};
const $f28f9cd61441a099$export$9c486687c39453a7 = ({ attrs: attrs = {}, ...rest })=>({
        ...rest,
        attrs: {
            ...attrs,
            timestamp: $f28f9cd61441a099$var$fixTimestamp(attrs.timestamp)
        }
    });


// eslint-disable-next-line no-restricted-imports



const $88b6ce66bc0ee8e9$export$258397c3ff887c2b = (partialNodeJson)=>{
    if (partialNodeJson.attrs?.panelType === 'tip' && (0, $dh538.fg)('platform_editor_convert_tip_to_info')) return {
        ...partialNodeJson,
        attrs: {
            ...partialNodeJson.attrs,
            panelType: 'info'
        }
    };
    return partialNodeJson;
};


const $5b99a4b27f90f818$var$nodeTransformers = {
    date: (0, $f28f9cd61441a099$export$9c486687c39453a7),
    panel: (0, $88b6ce66bc0ee8e9$export$258397c3ff887c2b)
};
const $5b99a4b27f90f818$export$dd6751dd7e5e8e9a = (type, partialNodeJson)=>{
    const nodeTransformer = $5b99a4b27f90f818$var$nodeTransformers[type];
    return nodeTransformer ? nodeTransformer(partialNodeJson) : partialNodeJson;
};


const $c660dc6389f481da$var$isTextblock = (schema, typeName)=>!!typeName && !!schema.nodes[typeName]?.isTextblock;
function $c660dc6389f481da$var$isTextLink(node) {
    const isText = node.type === 'text';
    if (!isText) return false;
    const mark = node.marks?.find((mark)=>mark.type === 'link');
    return !!mark;
}
// these block nodes should be treated as leaf nodes which should be omitted
// because they have src or url attrs that can be null after repair
// We handle tables differently so we also add it to the list
const $c660dc6389f481da$var$leafLikeNodeTypes = [
    'blockCard',
    'embedCard',
    'unsupportedBlock',
    'tableRow'
];
function $c660dc6389f481da$var$countIncompleteRows(node) {
    if (node.type !== 'table') return 0;
    const rows = node.content;
    if (!rows) return 0;
    //
    if (rows.length === 1) return 1;
    // Always ignore the final row if this is the end of the stream
    const rowsWithoutLast = rows.slice(0, rows.length - 1);
    let lastCompleteIndex = -1;
    let incompleteRowCount = 1;
    rowsWithoutLast.forEach((row, index)=>{
        const maxMergedRows = (row.content || []).reduce((max, cell)=>{
            return Math.max(max, typeof cell.attrs?.rowspan === 'number' ? cell.attrs.rowspan : 1);
        }, 1);
        incompleteRowCount = Math.max(incompleteRowCount, maxMergedRows);
        incompleteRowCount--;
        if (incompleteRowCount === 0) lastCompleteIndex = index;
    });
    /**
   * If lastCompleteIndex is -1, it means that no complete row has been found even after
   * trimming the last row.
   *
   * rowsWithoutLast.length - (-1) means that none of the rows are valid, so we actually
   * return the full row length here by doing double negation.
   */ return rowsWithoutLast.length - lastCompleteIndex;
}
function $c660dc6389f481da$var$isLeafLikeBlockNode(node) {
    return node.type.startsWith('media') || node.type.startsWith('extension') || node.type.endsWith('Extension') || /**
   * We want to treat tableRow as a leaf-like node so that we know cells are fully formed.
   * This will avoid any insertion issues while table is being streamed.
   */ $c660dc6389f481da$var$leafLikeNodeTypes.includes(node.type);
}
function $c660dc6389f481da$var$findLastLeafNode(doc) {
    let parent = doc;
    let leaf = doc.content && doc.content[doc.content.length - 1];
    while(leaf && !!leaf.content){
        if ($c660dc6389f481da$var$isLeafLikeBlockNode(leaf)) break;
        parent = leaf;
        leaf = leaf.content[leaf.content.length - 1];
    }
    return {
        parent: parent,
        leaf: leaf
    };
}
/**
 * Generic function to mark a process as failed
 * @param analyticsEventsSessionData - The analytics session data
 * @param processStatus - The specific process status object to update
 * @param error - The error message to record
 */ function $c660dc6389f481da$var$markProcessFailed({ analyticsEventsSessionData: analyticsEventsSessionData, processStatus: processStatus, error: error, stack: stack, validationError: validationError }) {
    processStatus.failed = true;
    processStatus.error = error;
    processStatus.recovered = false;
    processStatus.stack = stack;
    processStatus.validationError = validationError;
    /**
   * If multiple times process fails, only first and last failure will be recorded.
   * If need arise in future, then we can record all failures.
   */ processStatus.lastFailedAtChunk = analyticsEventsSessionData.chunksCount;
    if (processStatus.firstFailedAtChunk === 0) processStatus.firstFailedAtChunk = analyticsEventsSessionData.chunksCount;
}
/**
 * Generic function to mark a process as recovered
 * @param analyticsEventsSessionData - The analytics session data
 * @param processStatus - The specific process status object to update
 */ function $c660dc6389f481da$var$markProcessRecovered({ analyticsEventsSessionData: analyticsEventsSessionData, processStatus: processStatus }) {
    /**
   * If failed and not recovered then only mark it as recovered.
   * If already recovered, then don't mark it as recovered again, otherwise recoveredAtChunk will have wrong value.
   */ if (processStatus.failed && !processStatus.recovered) {
        processStatus.recovered = true;
        processStatus.lastRecoveredAtChunk = analyticsEventsSessionData.chunksCount;
        if (processStatus.firstRecoveredAtChunk === 0) processStatus.firstRecoveredAtChunk = analyticsEventsSessionData.chunksCount;
    }
}
function $c660dc6389f481da$var$markJsonRepairFailed(analyticsEventsSessionData, error) {
    $c660dc6389f481da$var$markProcessFailed({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.json.repairJson,
        error: error
    });
}
function $c660dc6389f481da$var$markJsonRepairRecovered(analyticsEventsSessionData) {
    $c660dc6389f481da$var$markProcessRecovered({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.json.repairJson
    });
}
function $c660dc6389f481da$var$markFailedToRepairADF(analyticsEventsSessionData, error, stack) {
    $c660dc6389f481da$var$markProcessFailed({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.failedToRepairADF,
        error: error,
        stack: stack
    });
}
function $c660dc6389f481da$var$markFailedToRepairADFRecovered(analyticsEventsSessionData) {
    $c660dc6389f481da$var$markProcessRecovered({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.failedToRepairADF
    });
}
function $c660dc6389f481da$var$markTopNodeFailed(analyticsEventsSessionData, error) {
    $c660dc6389f481da$var$markProcessFailed({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.topNode,
        error: error
    });
}
function $c660dc6389f481da$var$markTopNodeRecovered(analyticsEventsSessionData) {
    $c660dc6389f481da$var$markProcessRecovered({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.topNode
    });
}
function $c660dc6389f481da$var$markTopNodeValidationFailed(analyticsEventsSessionData, error, validationError) {
    $c660dc6389f481da$var$markProcessFailed({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.topNodeValidation,
        error: error,
        validationError: validationError
    });
}
function $c660dc6389f481da$var$markTopNodeValidationRecovered(analyticsEventsSessionData) {
    $c660dc6389f481da$var$markProcessRecovered({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.topNodeValidation
    });
}
const $c660dc6389f481da$var$processStatusDefault = {
    failed: false,
    error: '',
    recovered: false,
    firstFailedAtChunk: 0,
    firstRecoveredAtChunk: 0,
    lastFailedAtChunk: 0,
    lastRecoveredAtChunk: 0
};
const $c660dc6389f481da$var$createDefaultAnalyticsEventsSessionData = ()=>({
        chunksCount: 0,
        json: {
            repairJson: Object.assign({}, $c660dc6389f481da$var$processStatusDefault)
        },
        adf: {
            topNode: Object.assign({}, $c660dc6389f481da$var$processStatusDefault),
            repairInvalidContent: {
                wrappingNodesFoundEvents: [],
                nodeMovedToEndOfPreviousNodeEvents: [],
                invalidWrappingNodesEvents: [],
                wrappingNodesNotFoundEvents: []
            },
            failedToRepairADF: Object.assign({}, $c660dc6389f481da$var$processStatusDefault),
            topNodeValidation: Object.assign({}, $c660dc6389f481da$var$processStatusDefault)
        }
    });
function $c660dc6389f481da$var$isEventForRepairInvalidContentExists(eventsRegistry, eventType, event) {
    return eventsRegistry[eventType].some((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(e, event));
}
class $c660dc6389f481da$export$7e740171e70a13ac {
    setAnalyticsEventMetaData(analyticsEventMetaData) {
        this.analyticsEventMetaData = analyticsEventMetaData;
    }
    fireAnalyticEvent(event) {
        event.data = {
            ...event.data,
            ...this.analyticsEventMetaData
        };
        this.fireAnalyticEventCallback?.(event);
    }
    setInputDocumentTree(slice) {
        if (!slice || slice.size === 0) return;
        const empty = this.schema.topNodeType.createAndFill();
        if (!empty) return;
        try {
            const tr = new (0, $aXG5V.Transform)(empty).replaceRange(0, empty.content.size, slice);
            const json = tr.doc.toJSON();
            const tree = this.getPartialNodeTypeTree(json);
            this.inputDocumentTree = tree;
        } catch  {}
    }
    reset() {
        this.jsonRepair.reset();
        this.lastDoc = this.createDefaultDoc();
        this.analyticsEventMetaData = undefined;
        this.analyticsEventsSessionData = $c660dc6389f481da$var$createDefaultAnalyticsEventsSessionData();
    }
    isInErrorState() {
        const isRepairJsonFailed = this.analyticsEventsSessionData.json.repairJson.failed && !this.analyticsEventsSessionData.json.repairJson.recovered;
        const isFailedToRepairADF = this.analyticsEventsSessionData.adf.failedToRepairADF.failed && !this.analyticsEventsSessionData.adf.failedToRepairADF.recovered;
        const isInvalidTopNode = this.analyticsEventsSessionData.adf.topNode.failed && !this.analyticsEventsSessionData.adf.topNode.recovered;
        const isTopNodeValidationFailed = this.analyticsEventsSessionData.adf.topNodeValidation.failed && !this.analyticsEventsSessionData.adf.topNodeValidation.recovered;
        let emptyLastDoc = false;
        if ((0, $dh538.fg)('platform_editor_ai_adf_streamer_top_node_empty')) {
            const result = this.isEmptyLastDoc();
            emptyLastDoc = result.isEmpty || !!result.deserializationError;
            if (result.deserializationError) this.fireAnalyticEvent({
                type: 'error',
                message: 'Deserializing last doc to node failed in isInErrorState',
                data: {
                    error: result.deserializationError
                }
            });
        } else emptyLastDoc = this.isEmptyLastDocOld();
        return isRepairJsonFailed || isFailedToRepairADF || isInvalidTopNode || isTopNodeValidationFailed || emptyLastDoc;
    }
    createDefaultDoc() {
        const defaultDoc = this.schema.topNodeType.createAndFill()?.toJSON();
        return {
            ...defaultDoc,
            version: 1
        };
    }
    /**
   * This method is used to append a chunk to the streamer.
   * It will not process the chunk, you need to call {@link ADFStreamer.processChunk} to process the chunk.
   *
   * This is usefull when you just want to append a chunk to the streamer without processing it.
   *
   * @param chunk - The chunk to append.
   */ appendChunk(chunk) {
        this.jsonRepair.append(chunk);
    }
    /**
   * This method is used to append and process a chunk.
   * @param chunk - The chunk to append and process.
   * @returns The streamer itself.
   */ processChunk(chunk) {
        this.analyticsEventsSessionData.chunksCount++;
        this.jsonRepair.append(chunk);
        try {
            const { hasChanged: hasChanged, repairedJson: repairedJson } = this.jsonRepair.parse();
            if (hasChanged) this.repairADFJson(repairedJson);
            $c660dc6389f481da$var$markJsonRepairRecovered(this.analyticsEventsSessionData);
        } catch (jsonRepairError) {
            $c660dc6389f481da$var$markJsonRepairFailed(this.analyticsEventsSessionData, jsonRepairError instanceof Error ? jsonRepairError.message : 'Unknown error');
        }
        return this;
    }
    /**
   * This method is used to get the last document without the last leaf node.
   * Because the last leaf node may not be complete yet and it will be repaired in the next stream.
   * You still need to call {@link ADFStreamer.getLastDoc} to get the last document after processing the last stream.
   *
   * @example
   *
   * // for loading
   * streamer.processChunk(stream);
   * streamer.getLastDocWithoutLastLeafNode();
   *
   * // for preview
   * streamer.getLastDoc();
   *
   * @returns The last document without the last leaf node.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getLastDocWithoutLastLeafNode() {
        const doc = this.createCopyOfDoc(this.lastDoc);
        const { parent: parent, leaf: leaf } = $c660dc6389f481da$var$findLastLeafNode(doc);
        // bailout if empty content
        if (!leaf) return this.createCopyOfDoc(doc);
        // only keep text leaf node if it is not a link
        const keepTextLeaf = leaf && !!leaf.text && !$c660dc6389f481da$var$isTextLink(leaf);
        if (// empty Paragraph
        $c660dc6389f481da$var$isTextblock(this.schema, leaf.type) || keepTextLeaf) return this.createCopyOfDoc(doc);
        if (parent.type === 'table' && leaf.type === 'tableRow') {
            /**
       * For tables, we want to analyse whether or not the rows are actually complete.
       * This includes checking rows with merged cells.
       * We trim any incomplete rows at the end of the table to maintain structural integrity when streaming.
       */ const incompleteRows = $c660dc6389f481da$var$countIncompleteRows(parent);
            if (!!parent.content) parent.content = parent.content.slice(0, parent.content.length - incompleteRows);
        } else {
            // being cautious here, because it may break the ADF if arbitrarily remove the last leaf node from any parent node
            // - remove last leaf node from paragraph-like parent node
            // - remove block node if its a leaf-like node
            const shouldRemoveLastLeaf = $c660dc6389f481da$var$isLeafLikeBlockNode(leaf) || $c660dc6389f481da$var$isTextblock(this.schema, parent.type);
            if (!!parent.content && parent.content.length > 0 && shouldRemoveLastLeaf) parent.content = parent.content.slice(0, parent.content.length - 1);
        }
        return this.createCopyOfDoc(doc);
    }
    getLastDoc() {
        return this.createCopyOfDoc(this.lastDoc);
    }
    createCopyOfDoc(doc) {
        /**
     * Some older browsers like chrome 97 doesn't support structuredClone.
     * So using JSON.parse(JSON.stringify()) as a fallback.
     */ if (typeof window !== 'undefined' && typeof window.structuredClone === 'function') return structuredClone(doc);
        else return JSON.parse(JSON.stringify(doc));
    }
    repairADFJson(partialJson) {
        /**
     * No need to wait till we get "type: doc" in the JSON.
     * First node type will always be schema.topNodeType, and can start repairing
     * 	the JSON as soon as there is content in it.
     */ const sanitizedTopNodeResult = this.sanitizeTopNode(partialJson);
        if (sanitizedTopNodeResult.failed) {
            $c660dc6389f481da$var$markTopNodeFailed(this.analyticsEventsSessionData, sanitizedTopNodeResult.error);
            return this.lastDoc;
        }
        if (this.analyticsEventsSessionData.adf.topNode.failed) $c660dc6389f481da$var$markTopNodeRecovered(this.analyticsEventsSessionData);
        const sanitizedTopNode = sanitizedTopNodeResult.sanitizedTopNode;
        try {
            const docRepairResult = this.repairNode({
                partialNodeJson: sanitizedTopNode,
                isTopNode: true
            });
            /**
       * repairNode will be undefined if the node cannot be repaired
       * We only update lastDoc if node is repaired successfully
       */ if (docRepairResult && docRepairResult.node) {
                const currentDoc = docRepairResult.node;
                const { result: result, error: error } = this.validateNodeUsingValidator(currentDoc);
                if (result) {
                    this.lastDoc = currentDoc.toJSON();
                    $c660dc6389f481da$var$markTopNodeValidationRecovered(this.analyticsEventsSessionData);
                } else $c660dc6389f481da$var$markTopNodeValidationFailed(this.analyticsEventsSessionData, error?.errorMessage || 'Invalid top node', error?.validationError);
                $c660dc6389f481da$var$markFailedToRepairADFRecovered(this.analyticsEventsSessionData);
            }
        } catch (e) {
            $c660dc6389f481da$var$markFailedToRepairADF(this.analyticsEventsSessionData, e instanceof Error ? e.message : 'Unknown error', e instanceof Error ? e.stack : undefined);
        }
        return this.lastDoc;
    }
    sanitizeTopNode(partialNodeJson) {
        let sanitizedTopNode = partialNodeJson;
        if (Array.isArray(partialNodeJson)) {
            /**
       * We have observed that LLM sometimes returns invalid adf json
       * 	or sometimes returns top partial node as an array.
       * For example, LLM forgets put curly bracket to close node,
       * 	and when jsonrepair repairs it, it will change top node to be an array.
       * And doc node becomes part of an array along with other nodes.
       *
       * So if we find top partialNodeJson as an array and found topNode (doc)
       * 	in array then move other nodes to topNode and return topNode.
       */ sanitizedTopNode = partialNodeJson.find((node)=>node.type === this.schema.topNodeType.name);
            if (sanitizedTopNode) {
                const otherNodes = partialNodeJson.filter((node)=>node.type !== this.schema.topNodeType.name);
                sanitizedTopNode.content = [
                    ...sanitizedTopNode.content || [],
                    ...otherNodes
                ];
            } else return {
                failed: true,
                error: 'Valid top node not found in array.'
            };
        } else if (typeof partialNodeJson !== 'object' || partialNodeJson === null) return {
            failed: true,
            error: 'Invalid top node.'
        };
        return {
            failed: false,
            sanitizedTopNode: sanitizedTopNode
        };
    }
    repairNode(...args) {
        return (0, $dh538.fg)('platform_editor_ai_refactor_repair_method') ? this.repairNodeNew(...args) : this.repairNodeOld(...args);
    }
    repairNodeOld({ partialNodeJson: partialNodeJson, parentNodeType: parentNodeType, isTopNode: isTopNode }) {
        const type = this.inferNodeType({
            partialNodeJson: partialNodeJson,
            parentNodeType: parentNodeType,
            isTopNode: isTopNode
        });
        if (!type) {
            // If type can't be inferred, then we can't repair the node, so skipping it.
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Failed to infer node type.',
                data: {
                    nodeType: partialNodeJson.type ?? 'type is undefined'
                }
            });
            return;
        }
        let marksToUse = partialNodeJson.marks;
        if ((0, $dh538.fg)('platform_editor_ai_repair_using_validatorspec')) {
            const repairedMarksResult = (0, $1aa0486454fc21f2$export$fb8ba848cbd161c6)(type.name, marksToUse);
            if (repairedMarksResult.repairedMarks && repairedMarksResult.repairedMarks.length > 0) marksToUse = repairedMarksResult.repairedMarks;
            repairedMarksResult.errors && repairedMarksResult.errors.length;
        }
        const maybeMarks = marksToUse ? marksToUse.map((mark)=>this.createMark(mark))// Type guard isn't necessary in newer versions of TypeScript
        .filter((mark)=>mark !== null) : [];
        if (type.name === 'text') /**
       * Empty text node is not allowed in prosemirror.
       * Checkout: https://prosemirror.net/docs/ref/#model.Schema.text
       * That's why when text is not available, we are using space as default.
       */ return {
            node: this.schema.text(partialNodeJson.text ? partialNodeJson.text : ' ', maybeMarks),
            invalidNodes: []
        };
        if (type.name === 'date') {
            const today = new Date().getTime().toString();
            partialNodeJson.attrs = partialNodeJson.attrs || {};
            if (partialNodeJson.attrs.timestamp) {
                if (typeof partialNodeJson.attrs.timestamp === 'string') {
                    if (partialNodeJson.attrs.timestamp.includes('-')) {
                        const d = new Date(partialNodeJson.attrs.timestamp);
                        partialNodeJson.attrs.timestamp = isNaN(d.getTime()) ? today : d.getTime().toString();
                    // eslint-disable-next-line require-unicode-regexp
                    } else if (!String(partialNodeJson.attrs.timestamp).match(/^\d+$/)) partialNodeJson.attrs.timestamp = today;
                }
            } else partialNodeJson.attrs.timestamp = today;
        }
        if (type.name === 'panel' && partialNodeJson.attrs?.panelType === 'tip' && (0, $dh538.fg)('platform_editor_convert_tip_to_info')) partialNodeJson.attrs.panelType = 'info';
        const maybeContent = partialNodeJson.content ? this.repairContent({
            newContent: partialNodeJson.content,
            parentNodeType: type
        }).filter((node)=>!!node).map((node)=>this.schema.nodeFromJSON(node)) : undefined;
        let attrsToUse = partialNodeJson.attrs;
        if ((0, $dh538.fg)('platform_editor_ai_repair_attrs_with_validatorspec')) {
            // EDITOR-2316 Send analytic event when repairing of mark happens.
            const repairedAttrsResult = (0, $e0378dbdee4e269d$export$fde9f26eb5c83773)(type.name, attrsToUse);
            if (repairedAttrsResult.isValid) attrsToUse = repairedAttrsResult.repairedAttrs;
        }
        let node = type.createAndFill(attrsToUse, maybeContent, maybeMarks);
        let invalidNodes = [];
        /**
     * If node is null, then it means content is invalid and fitting wrapping node is not found.
     * We need to repair the content and try again.
     */ if (!node && maybeContent) {
            const { repairedContent: repairedContent, invalidNodes: invalidNodesFromRepairInvalidContent } = this.repairInvalidContent({
                parentNodeType: type,
                maybeContent: maybeContent
            });
            invalidNodes = invalidNodesFromRepairInvalidContent;
            node = type.createAndFill(attrsToUse, repairedContent, maybeMarks);
            if (!node) {
                /**
         * Tried to repair content, but still failed. So need to skip this node.
         */ this.fireAnalyticEvent({
                    type: 'info',
                    message: 'Tried to repair content of node, but failed.',
                    data: {
                        nodeType: type.name ?? 'type is undefined',
                        repairedContentNodeTypeTree: repairedContent.map((node)=>this.getNodeTypeTree(node)),
                        originalNodeTypeTree: this.getPartialNodeTypeTree(partialNodeJson)
                    }
                });
                return;
            }
        }
        return {
            node: node,
            invalidNodes: invalidNodes
        };
    }
    repairNodeNew({ partialNodeJson: partialNodeJson, parentNodeType: parentNodeType, isTopNode: isTopNode }) {
        const type = this.inferNodeType({
            partialNodeJson: partialNodeJson,
            parentNodeType: parentNodeType,
            isTopNode: isTopNode
        });
        if (!type) {
            // If type can't be inferred, then we can't repair the node, so skipping it.
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Failed to infer node type.',
                data: {
                    nodeType: partialNodeJson.type ?? 'type is undefined'
                }
            });
            return;
        }
        let marksToUse = partialNodeJson.marks;
        if ((0, $dh538.fg)('platform_editor_ai_repair_using_validatorspec')) {
            const repairedMarksResult = (0, $1aa0486454fc21f2$export$fb8ba848cbd161c6)(type.name, marksToUse);
            if (repairedMarksResult.repairedMarks && repairedMarksResult.repairedMarks.length > 0) marksToUse = repairedMarksResult.repairedMarks;
            repairedMarksResult.errors && repairedMarksResult.errors.length;
        }
        const maybeMarks = marksToUse ? marksToUse.map((mark)=>this.createMark(mark))// Type guard isn't necessary in newer versions of TypeScript
        .filter((mark)=>mark !== null) : [];
        if (type.name === 'text') /**
       * Empty text node is not allowed in prosemirror.
       * Checkout: https://prosemirror.net/docs/ref/#model.Schema.text
       * That's why when text is not available, we are using space as default.
       */ return {
            node: this.schema.text(partialNodeJson.text ? partialNodeJson.text : ' ', maybeMarks),
            invalidNodes: []
        };
        const maybeContent = partialNodeJson.content ? this.repairContent({
            newContent: partialNodeJson.content,
            parentNodeType: type
        }).filter((node)=>!!node).map((node)=>this.schema.nodeFromJSON(node)) : undefined;
        let validAttrs = partialNodeJson.attrs;
        if ((0, $dh538.fg)('platform_editor_ai_repair_attrs_with_validatorspec')) {
            // EDITOR-2316 Send analytic event when repairing of mark happens.
            const repairedAttrsResult = (0, $e0378dbdee4e269d$export$fde9f26eb5c83773)(type.name, validAttrs);
            if (repairedAttrsResult.isValid) validAttrs = repairedAttrsResult.repairedAttrs;
        }
        const validNode = {
            ...partialNodeJson,
            attrs: validAttrs
        };
        const supportedNode = (0, $5b99a4b27f90f818$export$dd6751dd7e5e8e9a)(type.name, validNode);
        let node = type.createAndFill(supportedNode.attrs, maybeContent, maybeMarks);
        let invalidNodes = [];
        /**
     * If node is null, then it means content is invalid and fitting wrapping node is not found.
     * We need to repair the content and try again.
     */ if (!node && maybeContent) {
            const { repairedContent: repairedContent, invalidNodes: invalidNodesFromRepairInvalidContent } = this.repairInvalidContent({
                parentNodeType: type,
                maybeContent: maybeContent
            });
            invalidNodes = invalidNodesFromRepairInvalidContent;
            node = type.createAndFill(supportedNode.attrs, repairedContent, maybeMarks);
            if (!node) {
                /**
         * Tried to repair content, but still failed. So need to skip this node.
         */ this.fireAnalyticEvent({
                    type: 'info',
                    message: 'Tried to repair content of node, but failed.',
                    data: {
                        nodeType: type.name ?? 'type is undefined',
                        repairedContentNodeTypeTree: repairedContent.map((node)=>this.getNodeTypeTree(node)),
                        originalNodeTypeTree: this.getPartialNodeTypeTree(supportedNode)
                    }
                });
                return;
            }
        }
        return {
            node: node,
            invalidNodes: invalidNodes
        };
    }
    repairInvalidContent({ parentNodeType: parentNodeType, maybeContent: maybeContent }) {
        let currentContentMatch = parentNodeType.contentMatch;
        const invalidNodes = [];
        const repairedContent = [];
        maybeContent.forEach((node, index)=>{
            const nextContentMatch = currentContentMatch.matchType(node.type);
            if (nextContentMatch) {
                /**
         * this node is allowed in the parent node.
         * so continue to the next node.
         */ currentContentMatch = nextContentMatch;
                repairedContent.push(node);
            } else {
                const { taskItem: taskItem, paragraph: paragraph } = this.schema.nodes;
                /**
         * The LLM has been observed to occasionally wrap taskItem content inside a paragraph.
         * Task items support the same content as paragraph so we unwrap the pargaraph into the taskItem..
         */ if (parentNodeType === taskItem && node.type === paragraph) {
                    repairedContent.push(...node.content.content);
                    return;
                }
                /**
         * We've noticed that the LLM occasionally omits closing } or ] brackets,
         * 	causing the node to be incorrectly moved from its parent and placed as a sibling.
         *
         * If node is not valid at this position, then check if it is valid child
         * 	at end in previous node. If it is, then move it to the end of previous node.
         *
         * Use repairedContent instead of maybeContent to avoid duplicate nodes.
         */ if (index > 0 && repairedContent.length > 0) {
                    const previousNode = repairedContent[repairedContent.length - 1];
                    const previousNodeChildCount = previousNode.childCount;
                    if (previousNode.canReplaceWith(previousNodeChildCount, previousNodeChildCount, node.type)) {
                        const previousNodeContent = previousNode.content;
                        const newPreviousNodeContent = previousNodeContent.addToEnd(node);
                        const newPreviousNode = previousNode.copy(newPreviousNodeContent);
                        repairedContent[repairedContent.length - 1] = newPreviousNode;
                        /**
             * During streaming, invalid content will be repaired on processing every chunk.
             * Without checking if event already exists, it will fire multiple events for same node.
             * With duplicate events, analyzing the data will be difficult.
             */ const event = {
                            parentNodeType: parentNodeType.name,
                            previousNodeType: previousNode.type.name,
                            movedNodeType: node.type.name,
                            oldChildIndex: index,
                            childIndexInPreviousNode: previousNodeContent.childCount
                        };
                        if (!$c660dc6389f481da$var$isEventForRepairInvalidContentExists(this.analyticsEventsSessionData.adf.repairInvalidContent, 'nodeMovedToEndOfPreviousNodeEvents', event)) this.analyticsEventsSessionData.adf.repairInvalidContent.nodeMovedToEndOfPreviousNodeEvents.push(event);
                        return;
                    }
                }
                /**
         * this node is not allwed directly in parent node.
         * so let's check if we wrap this node with other nodes, it can be allowed or not.
         */ const wrappingNodeTypes = currentContentMatch.findWrapping(node.type);
                let currentChildNode = node;
                if (wrappingNodeTypes) {
                    for(let i = wrappingNodeTypes?.length - 1; i >= 0; i--){
                        const wrappingNodeType = wrappingNodeTypes[i];
                        const nextChildNode = wrappingNodeType.createAndFill(null, [
                            currentChildNode
                        ]);
                        if (nextChildNode) currentChildNode = nextChildNode;
                        else {
                            /**
               * This should not happen as prosemirror should never give us such a wrappingNodes
               * so that createAndFill fails.
               * Buf it this happens, we need to fire analytic event, so that we diagnose the issue.
               */ const event = {
                                childNodeType: node.type.name,
                                childIndex: index,
                                wrappingNodeType: wrappingNodeType.name,
                                currentChildNode: currentChildNode.type.name
                            };
                            if (!$c660dc6389f481da$var$isEventForRepairInvalidContentExists(this.analyticsEventsSessionData.adf.repairInvalidContent, 'invalidWrappingNodesEvents', event)) this.analyticsEventsSessionData.adf.repairInvalidContent.invalidWrappingNodesEvents.push(event);
                            return;
                        }
                    }
                    const event = {
                        childNodeType: node.type.name,
                        childIndex: index,
                        wrappingNodeTypes: wrappingNodeTypes.map((nodeType)=>nodeType.name),
                        parentNodeType: parentNodeType.name
                    };
                    if (!$c660dc6389f481da$var$isEventForRepairInvalidContentExists(this.analyticsEventsSessionData.adf.repairInvalidContent, 'wrappingNodesFoundEvents', event)) this.analyticsEventsSessionData.adf.repairInvalidContent.wrappingNodesFoundEvents.push(event);
                    repairedContent.push(currentChildNode);
                } else {
                    /**
           * this node is not allowed in the parent node as child at any level.
           * For example, a table node can't be a child of a bulletList node at any level.
           *
           * This can happen because sometimes LLM gives us a node that is not allowed in the parent node.
           * Or LLM gives us invalid json, and jsonrepair repairs it in such a way that
           * 	node is shifted and placed in a place where it's not allowed in the parent node.
           *
           * So we need to discard this node.
           */ const event = {
                        childNodeType: node.type.name,
                        parentNodeType: parentNodeType.name,
                        childIndex: index
                    };
                    if (!$c660dc6389f481da$var$isEventForRepairInvalidContentExists(this.analyticsEventsSessionData.adf.repairInvalidContent, 'wrappingNodesNotFoundEvents', event)) this.analyticsEventsSessionData.adf.repairInvalidContent.wrappingNodesNotFoundEvents.push(event);
                    invalidNodes.push(node);
                }
            }
        });
        return {
            repairedContent: repairedContent.filter((node)=>!!node),
            invalidNodes: invalidNodes
        };
    }
    inferNodeType({ partialNodeJson: partialNodeJson, parentNodeType: parentNodeType, isTopNode: isTopNode }) {
        /**
     * If type is still not available, and, node has been previously repaired,
     * then just use type of the repaired node.
     * And if node hasn't been repaired, then use default type based on parent node type.
     */ let type = null;
        if (partialNodeJson.type) type = this.schema.nodes[partialNodeJson.type];
        if (!type) {
            if (isTopNode) type = this.schema.topNodeType;
            else if ($c660dc6389f481da$var$isTextblock(this.schema, parentNodeType?.name) || /**
       * codeBlock nodeType returns "unsupportedInline" as defaultType.
       * Because prosemirror never returns text node as defaultType.
       * So overriding "text" as defaultType for codeBlock.
       */ parentNodeType?.name === 'codeBlock' || /**
       * If node has text as child, then use text as defaultType.
       */ typeof partialNodeJson === 'object' && 'text' in partialNodeJson) type = this.schema.nodes.text;
        }
        return type || parentNodeType?.contentMatch.defaultType;
    }
    repairContent({ newContent: newContent, parentNodeType: parentNodeType }) {
        const repairedContent = [];
        newContent.forEach((node, index)=>{
            /**
       * If repairing node fails, then instead of failing processing whole document,
       * 	just skip the node and continue with the next node.
       */ try {
                const nodeRepairResult = this.repairNode({
                    partialNodeJson: node,
                    parentNodeType: parentNodeType
                });
                if (nodeRepairResult?.node) repairedContent.push(nodeRepairResult.node.toJSON());
                if (nodeRepairResult?.invalidNodes && nodeRepairResult?.invalidNodes.length > 0) repairedContent.push(...nodeRepairResult.invalidNodes.map((node)=>node.toJSON()));
            } catch (e) {
                this.fireAnalyticEvent({
                    type: 'info',
                    message: 'Failed to repair node',
                    data: {
                        error: e instanceof Error ? e.message : 'Unknown error',
                        stack: e instanceof Error ? e.stack : undefined,
                        nodeType: node.type ?? 'type is undefined',
                        parentNodeType: parentNodeType.name,
                        childIndex: index
                    }
                });
            }
        });
        return repairedContent;
    }
    validateNodeUsingValidator(node, parentNodeType) {
        const nodes = Object.keys(this.schema.nodes);
        const marks = Object.keys(this.schema.marks);
        const validate = (0, $jqXx5.validator)(nodes, marks, {
            allowPrivateAttributes: true,
            mode: 'strict'
        });
        try {
            const isNestedTable = node.type.name === 'table' && (parentNodeType?.name === 'tableCell' || parentNodeType?.name === 'tableHeader');
            if (isNestedTable) return {
                result: true
            };
            let error;
            const errorCallback = (entity, validationError)=>{
                error = {
                    nodeType: entity.type ?? 'type is undefined',
                    validationError: validationError
                };
                return undefined;
            };
            const validation = validate({
                ...node?.toJSON(),
                /**
         * In the ProseMirror model the doc version is a number, but
         * ADF validator expects a string. We override this manually here as the
         * version number is trivial to doc formation.
         */ ...node.type.name === 'doc' ? {
                    version: '1'
                } : {}
            }, errorCallback);
            if (validation.valid) return {
                result: true,
                entity: validation.entity,
                error: error
            };
            return {
                result: false,
                error: error
            };
        } catch (e) {
            return {
                result: false,
                error: {
                    nodeType: node.type.name,
                    errorMessage: e instanceof Error ? e.message : 'Unknown error'
                }
            };
        }
    }
    createMark(json) {
        if (json.type) {
            const type = this.schema.marks[json.type];
            if (!type) {
                this.fireAnalyticEvent({
                    type: 'info',
                    message: 'Failed to repair mark, type not found',
                    data: {
                        markType: json.type
                    }
                });
                return null;
            }
            return type.create(json.attrs);
        }
        return null;
    }
    getPartialNodeTypeTree(node) {
        const children = node.content;
        return {
            type: node.type,
            content: Array.isArray(children) ? children.map((child)=>this.getPartialNodeTypeTree(child)) : []
        };
    }
    getNodeTypeTree(node) {
        const children = node.content;
        return {
            type: node.type.name,
            content: Array.isArray(children) ? children.map((child)=>this.getNodeTypeTree(child)) : []
        };
    }
    isEmptyLastDocOld() {
        /* eslint-disable @typescript-eslint/no-unused-vars */ try {
            const docNode = this.schema.nodeFromJSON(this.lastDoc);
            const textContent = docNode.textContent;
            return textContent.length === 0;
        } catch (_e) {
            /**
       * If can't convert last doc to node, then consider it as empty.
       * If many empty docs events are received then
       * 	will start fire another error event to track this error.
       */ return true;
        }
    /* eslint-enable @typescript-eslint/no-unused-vars */ }
    isEmptyLastDoc() {
        try {
            const docNode = this.schema.nodeFromJSON(this.lastDoc);
            return {
                isEmpty: // If doc has no child then it is empty.
                docNode.childCount <= 1 && // By default, lastDoc has empty paragraph as child of doc node.
                docNode.firstChild?.type.name === 'paragraph' && docNode.firstChild?.childCount === 0,
                deserializationError: undefined
            };
        } catch (error) {
            return {
                isEmpty: false,
                deserializationError: error instanceof Error ? error.message : 'Unknown error'
            };
        }
    }
    endStreamingSession({ hasProcessedFinalResponse: hasProcessedFinalResponse } = {}) {
        this.fireAnalyticEvent({
            type: 'info',
            message: 'Number of chunks processed',
            data: {
                chunksCount: this.analyticsEventsSessionData.chunksCount,
                inputDocumentTree: this.inputDocumentTree
            }
        });
        /**
     * When input to LLM is very small, like couple of words,
     * then few stream events are sent which has empty doc,
     * and final response completes doc with transformed couple of words.
     *
     * So firing empty doc event only when final response is processed.
     */ if ((0, $dh538.fg)('platform_editor_ai_adf_streamer_top_node_empty')) {
            if (hasProcessedFinalResponse) {
                const result = this.isEmptyLastDoc();
                if (result.isEmpty) this.fireAnalyticEvent({
                    type: 'error',
                    message: 'Top node is empty',
                    data: {
                        inputDocumentTree: this.inputDocumentTree
                    }
                });
                if (result.deserializationError) this.fireAnalyticEvent({
                    type: 'error',
                    message: 'Deserializing last doc to node failed',
                    data: {
                        error: result.deserializationError
                    }
                });
            }
        } else if (this.isEmptyLastDocOld() && hasProcessedFinalResponse) this.fireAnalyticEvent({
            type: 'error',
            message: 'Top node is empty',
            data: {
                inputDocumentTree: this.inputDocumentTree
            }
        });
        if (this.analyticsEventsSessionData.json.repairJson.failed) {
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Failed to repair partial JSON using jsonrepair',
                data: {
                    error: this.analyticsEventsSessionData.json.repairJson.error,
                    firstFailedAtChunk: this.analyticsEventsSessionData.json.repairJson.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.json.repairJson.lastFailedAtChunk,
                    recovered: this.analyticsEventsSessionData.json.repairJson.recovered,
                    firstRecoveredAtChunk: this.analyticsEventsSessionData.json.repairJson.firstRecoveredAtChunk,
                    lastRecoveredAtChunk: this.analyticsEventsSessionData.json.repairJson.lastRecoveredAtChunk
                }
            });
            if (!this.analyticsEventsSessionData.json.repairJson.recovered) this.fireAnalyticEvent({
                type: 'error',
                message: 'Received invalid json',
                data: {
                    error: this.analyticsEventsSessionData.json.repairJson.error,
                    firstFailedAtChunk: this.analyticsEventsSessionData.json.repairJson.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.json.repairJson.lastFailedAtChunk
                }
            });
        }
        if (this.analyticsEventsSessionData.adf.failedToRepairADF.failed) {
            if (this.analyticsEventsSessionData.adf.failedToRepairADF.recovered) this.fireAnalyticEvent({
                type: 'info',
                message: 'Failed to repair ADF json during streaming, but recovered',
                data: {
                    error: this.analyticsEventsSessionData.adf.failedToRepairADF.error,
                    stack: this.analyticsEventsSessionData.adf.failedToRepairADF.stack,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.lastFailedAtChunk,
                    recovered: this.analyticsEventsSessionData.adf.failedToRepairADF.recovered,
                    firstRecoveredAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.firstRecoveredAtChunk,
                    lastRecoveredAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.lastRecoveredAtChunk
                }
            });
            else this.fireAnalyticEvent({
                type: 'error',
                message: 'Failed to repair ADF Json',
                data: {
                    error: this.analyticsEventsSessionData.adf.failedToRepairADF.error,
                    stack: this.analyticsEventsSessionData.adf.failedToRepairADF.stack,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.lastFailedAtChunk
                }
            });
        }
        if (this.analyticsEventsSessionData.adf.topNode.failed) {
            if (this.analyticsEventsSessionData.adf.topNode.recovered) this.fireAnalyticEvent({
                type: 'info',
                message: 'Got invalid top not, but recovered',
                data: {
                    error: this.analyticsEventsSessionData.adf.topNode.error,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.topNode.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.topNode.lastFailedAtChunk,
                    firstRecoveredAtChunk: this.analyticsEventsSessionData.adf.topNode.firstRecoveredAtChunk,
                    lastRecoveredAtChunk: this.analyticsEventsSessionData.adf.topNode.lastRecoveredAtChunk
                }
            });
            else this.fireAnalyticEvent({
                type: 'error',
                message: 'Invalid top node',
                data: {
                    error: this.analyticsEventsSessionData.adf.topNode.error,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.topNode.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.topNode.lastFailedAtChunk
                }
            });
        }
        if (this.analyticsEventsSessionData.adf.topNodeValidation.failed) {
            if (this.analyticsEventsSessionData.adf.topNodeValidation.recovered) this.fireAnalyticEvent({
                type: 'info',
                message: 'Top node validation failed, but recovered',
                data: {
                    error: this.analyticsEventsSessionData.adf.topNodeValidation.error,
                    validationError: this.analyticsEventsSessionData.adf.topNodeValidation.validationError,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.lastFailedAtChunk,
                    firstRecoveredAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.firstRecoveredAtChunk,
                    lastRecoveredAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.lastRecoveredAtChunk
                }
            });
            else this.fireAnalyticEvent({
                type: 'error',
                message: 'Top node validation failed',
                data: {
                    error: this.analyticsEventsSessionData.adf.topNodeValidation.error,
                    validationError: this.analyticsEventsSessionData.adf.topNodeValidation.validationError,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.lastFailedAtChunk
                }
            });
        }
        this.analyticsEventsSessionData.adf.repairInvalidContent.wrappingNodesFoundEvents.forEach((event)=>{
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Wrapping nodes found',
                data: {
                    ...event
                }
            });
        });
        this.analyticsEventsSessionData.adf.repairInvalidContent.nodeMovedToEndOfPreviousNodeEvents.forEach((event)=>{
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Node moved to the end of previous node',
                data: {
                    ...event
                }
            });
        });
        this.analyticsEventsSessionData.adf.repairInvalidContent.invalidWrappingNodesEvents.forEach((event)=>{
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Invalid wrapping nodes found for node.',
                data: {
                    ...event
                }
            });
        });
        this.analyticsEventsSessionData.adf.repairInvalidContent.wrappingNodesNotFoundEvents.forEach((event)=>{
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Wrapping nodes not found.',
                data: {
                    ...event
                }
            });
        });
    }
    constructor(schema, fireAnalyticEvent){
        this.jsonRepair = void 0;
        this.schema = void 0;
        this.lastDoc = void 0;
        this.fireAnalyticEventCallback = void 0;
        this.analyticsEventMetaData = void 0;
        this.inputDocumentTree = void 0;
        this.analyticsEventsSessionData = $c660dc6389f481da$var$createDefaultAnalyticsEventsSessionData();
        this.jsonRepair = new (0, $81d0c9debb3582da$export$c1ee0a0b09546958)();
        this.schema = schema;
        this.fireAnalyticEventCallback = fireAnalyticEvent;
        this.lastDoc = this.createDefaultDoc();
        this.inputDocumentTree = undefined;
    }
}
module.exports["ADFStreamer"] = $c660dc6389f481da$export$7e740171e70a13ac;

});

parcelRegister("4DEL1", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $ftzrq = parcelRequire("ftzrq");


var $bqMS3 = parcelRequire("bqMS3");


var $6mYMS = parcelRequire("6mYMS");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $6eZqW = parcelRequire("6eZqW");


var $1xicG = parcelRequire("1xicG");


var $h9yJL = parcelRequire("h9yJL");








var $5oqzu = parcelRequire("5oqzu");


var $5SuLc = parcelRequire("5SuLc");


var $kqrrC = parcelRequire("kqrrC");

const $2b0668eaf60a5292$export$e49a2031d0d2ff07 = ({ invokedFrom: invokedFrom, aiOptIn: aiOptIn, configItem: configItem, editorView: editorView, triggeredFor: triggeredFor, isExternal: isExternal = false, withAcceptReject: withAcceptReject = true, withStreamingHighlight: withStreamingHighlight = true, hideLoadingScreen: hideLoadingScreen = false, traceId: traceId, isCreate: isCreate })=>{
    if (!editorView) return;
    const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
        state: editorView.state,
        configItem: configItem,
        lastTriggeredFrom: invokedFrom,
        aiGlobalOptIn: aiOptIn,
        triggeredFor: triggeredFor,
        isExternal: isExternal,
        withAcceptReject: withAcceptReject,
        withStreamingHighlight: withStreamingHighlight,
        hideLoadingScreen: hideLoadingScreen,
        traceId: traceId,
        isCreate: isCreate
    });
    openAIModalCommand(editorView.state, editorView.dispatch);
};
const $2b0668eaf60a5292$export$eb7c7403500d1c40 = ({ editorView: editorView })=>{
    if (!editorView) return;
    const endAIExperienceCommand = (0, $5SuLc.createEndAIExperienceCommand)();
    endAIExperienceCommand(editorView.state, editorView.dispatch);
};
const $2b0668eaf60a5292$export$254dcf4812f17c19 = ({ editorView: editorView, sessionId: sessionId, traceId: traceId })=>{
    if (!editorView) return;
    return (0, $5SuLc.createStartAISessionCommand)(sessionId, (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceId : undefined)(editorView.state, editorView.dispatch);
};
const $2b0668eaf60a5292$export$3a08ee9ddec0cdee = ({ editorView: editorView, sessionId: sessionId })=>{
    if (!editorView) return;
    const endSessionCommand = (0, $kqrrC.createCommand)((state)=>{
        const aiDecorationExperiencePluginState = (0, $kqrrC.getPluginState)(state);
        const nextSessionId = aiDecorationExperiencePluginState.nextSessionId;
        // If a sessions which is not the next session is trying to be ended then we should abort trying to end the session.
        if (sessionId !== nextSessionId) return false;
        return {
            type: 'END_SESSION',
            data: {
                sessionId: undefined
            }
        };
    }, (tr)=>{
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) tr.setMeta((0, $5oqzu.aiSessionContextPluginKey), {
            type: 'RESET'
        });
        return tr;
    });
    return endSessionCommand(editorView.state, editorView.dispatch);
};
const $2b0668eaf60a5292$export$955fdaa156e3249e = ({ editorView: editorView, targetId: targetId })=>{
    if (!editorView) return;
    return (0, $5SuLc.createUpdateTargetIdCommand)(targetId)(editorView.state, editorView.dispatch);
};
const $2b0668eaf60a5292$export$159ce495a6d11302 = ({ selection: selection, maxSize: maxSize = 10000 })=>{
    if (!selection) return undefined;
    const { $from: $from, $to: $to } = selection;
    const doc = $from.doc;
    /**
	 * Check the from and to positions of the lowest depth level (doc level).
	 * If the size is over the threshold, increase the depth.
	 */ let depth = 0;
    while(// Check until max depth is reached from the resolved positions
    !isNaN($from.start(depth)) && !isNaN($to.end(depth))){
        const from = $from.start(depth);
        const to = $to.end(depth);
        if (to - from < maxSize) break;
        depth++;
    }
    if (depth === 0) return doc;
    // find a depth that fits and then start looking at siblings n - 1 and n + 1 and so on
    const parentDepth = depth - 1;
    const index = $from.index(parentDepth);
    let from = $from.start(depth);
    let to = $to.end(depth);
    let increment = 1;
    const maxIndex = $from.node(parentDepth).childCount;
    while(// Loop until both ends of the bounds have been reached
    index - increment >= 0 || index + increment <= maxIndex){
        const newFrom = $from.posAtIndex(Math.max(index - increment, 0), parentDepth);
        // We look ahead at the next index as posAtIndex yields the starting position of the node
        const newTo = $to.posAtIndex(Math.min(index + increment + 1, maxIndex), parentDepth);
        let isPositionUpdated = false;
        if (to - newFrom < maxSize) {
            from = newFrom;
            isPositionUpdated = true;
        }
        if (newTo - from < maxSize) {
            to = newTo;
            isPositionUpdated = true;
        }
        if (!isPositionUpdated) break;
        increment++;
    }
    return doc.cut(from, to);
};
const $2b0668eaf60a5292$export$cb4bd847e3d154fe = (options)=>{
    const transformer = new (0, $h9yJL.JSONTransformer)();
    const doc = $2b0668eaf60a5292$export$159ce495a6d11302(options);
    if (doc) return transformer.encode(doc);
};
const $2b0668eaf60a5292$export$3e64d26c171d92fc = (options)=>{
    const doc = $2b0668eaf60a5292$export$159ce495a6d11302(options);
    if (doc) return (0, $6eZqW.convertProsemirrorNodeToMarkdown)({
        node: doc
    })?.markdown ?? '';
};
const $2b0668eaf60a5292$export$99447d9e0d76b7ef = (tr, options)=>{
    if (options?.isFinal && (0, $dh538.fg)('platform_editor_ai_instrumentation_updates')) return tr.setMeta('isAIFinalStreamingTransformation', true);
    return tr.setMeta('isAIStreamingTransformation', true);
};






var $bYZ53 = parcelRequire("bYZ53");


var $9OCYt = parcelRequire("9OCYt");


var $3tFte = parcelRequire("3tFte");

const $59f25d3bacd6bee4$var$initialState = {
    isWatching: false,
    watchFrom: undefined,
    watchTo: undefined,
    startingAnnotationIds: undefined
};
const $59f25d3bacd6bee4$export$120e869ffea6ac01 = (options)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $3tFte.aiAnnotationWatchmenPluginKey),
        state: {
            init: ()=>$59f25d3bacd6bee4$var$initialState,
            apply: (tr, pluginState, _, ns)=>{
                if (!options.onAnnotationsAdded && !options.onAnnotationsRemoved && !options.onAnnotationsChanged) return pluginState;
                const meta = tr.getMeta((0, $3tFte.aiAnnotationWatchmenPluginKey));
                const { isWatching: isWatching, watchFrom: watchFrom, watchTo: watchTo, startingAnnotationIds: startingAnnotationIds } = pluginState;
                switch(meta?.action){
                    case (0, $9OCYt.ACTIONS).START_WATCHING_REGION:
                        {
                            const { from: from, to: to } = meta;
                            if (from === undefined || to === undefined) return pluginState;
                            const mappedFrom = tr.mapping.map(from, -1);
                            const mappedTo = tr.mapping.map(to, 1);
                            const ids = (0, $bYZ53.getAnnotationIdsFromRange)({
                                from: mappedFrom,
                                to: mappedTo
                            }, tr.doc, ns.schema);
                            return {
                                isWatching: true,
                                watchFrom: mappedFrom,
                                watchTo: mappedTo,
                                startingAnnotationIds: ids
                            };
                        }
                    case (0, $9OCYt.ACTIONS).END_WATCHING_REGION:
                        {
                            if (watchFrom === undefined || watchTo === undefined) return pluginState;
                            const ids = (0, $bYZ53.getAnnotationIdsFromRange)({
                                from: tr.mapping.map(watchFrom, -1),
                                to: tr.mapping.map(watchTo, 1)
                            }, tr.doc, ns.schema);
                            const removedIds = startingAnnotationIds?.filter((id)=>!ids.includes(id)) ?? [];
                            const addedIds = ids.filter((id)=>!startingAnnotationIds?.includes(id)) ?? [];
                            if (!!options.onAnnotationsRemoved && removedIds?.length) options.onAnnotationsRemoved(removedIds);
                            if (!!options.onAnnotationsAdded && addedIds?.length) options.onAnnotationsAdded(addedIds);
                            if (!!options.onAnnotationsChanged && (removedIds?.length || addedIds?.length)) {
                                const changes = removedIds.map((id)=>({
                                        annotationId: id,
                                        type: 'REMOVED'
                                    })).concat(addedIds.map((id)=>({
                                        annotationId: id,
                                        type: 'ADDED'
                                    })));
                                options.onAnnotationsChanged(changes);
                            }
                            return {
                                isWatching: false,
                                watchFrom: undefined,
                                watchTo: undefined,
                                startingAnnotationIds: undefined
                            };
                        }
                }
                return {
                    isWatching: isWatching,
                    startingAnnotationIds: startingAnnotationIds,
                    watchFrom: watchFrom !== undefined ? tr.mapping.map(watchFrom, -1) : undefined,
                    watchTo: watchTo !== undefined ? tr.mapping.map(watchTo, 1) : undefined
                };
            }
        }
    });
};






var $lkJUe = parcelRequire("lkJUe");


var $ks2lK = parcelRequire("ks2lK");

const $273a0a7ac26cc1de$export$d41d542343dd0571 = new (0, $ks2lK.PluginKey)('aiAuditLogs');


const $ca9327f3325910e0$export$a339266ad71b2447 = 2000;
const $ca9327f3325910e0$export$85b84234e02688c1 = 2;


function $5baf73694b79cf27$export$1650419e431d3ba3(pluginState, action) {
    switch(action.type){
        case 'UPDATE_PLUGIN_STATE':
            return {
                ...pluginState,
                'ai-generated-content-inserted': {
                    ...pluginState['ai-generated-content-inserted'],
                    ...action.data['ai-generated-content-inserted']
                },
                'aup-violation': {
                    ...pluginState['aup-violation'],
                    ...action.data['aup-violation']
                }
            };
        default:
            return pluginState;
    }
}


function $0d430026b24034e8$var$onDocChanged(tr, pluginState) {
    const eventState = pluginState['ai-generated-content-inserted'];
    if (eventState.eventStatus === 'not-sent' && tr.getMeta('isAiContentTransformation')) return {
        ...pluginState,
        'ai-generated-content-inserted': {
            ...eventState,
            eventStatus: 'send-event'
        }
    };
    return pluginState;
}
const $0d430026b24034e8$export$de5e90bd767c5d82 = (eventData)=>(_state)=>{
        return {
            'ai-generated-content-inserted': {
                eventStatus: 'not-sent',
                retries: 0
            },
            'aup-violation': {
                eventStatus: 'not-sent',
                retries: 0
            },
            maxRetries: (0, $ca9327f3325910e0$export$85b84234e02688c1),
            retryDelay: (0, $ca9327f3325910e0$export$a339266ad71b2447),
            eventData: eventData
        };
    };
const { createPluginState: $0d430026b24034e8$export$656c7661095efe2e, createCommand: $0d430026b24034e8$export$8d4021544bdece00, getPluginState: $0d430026b24034e8$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $273a0a7ac26cc1de$export$d41d542343dd0571), (0, $5baf73694b79cf27$export$1650419e431d3ba3), {
    onDocChanged: $0d430026b24034e8$var$onDocChanged
});




var $klIiV = parcelRequire("klIiV");


async function $e36c6f447980a314$export$da4c3508f56b63bc(event, view) {
    /**
	 * Always get pluginState from view.state as view.state is always latest state
	 * 	as sendAuditLogEvent is called in recursion and depend on pluginState
	 * 	updated by previous call.
	 */ const pluginState = (0, $0d430026b24034e8$export$f05434c51e3762e)(view.state);
    const { eventData: eventData, retryDelay: retryDelay } = pluginState;
    const eventState = pluginState[event];
    const entityId = eventData.type === 'page' ? eventData.pageId : eventData.issueId;
    $e36c6f447980a314$export$c16f4f0c4f1ae3d4({
        [event]: {
            retries: eventState.retries + 1
        }
    })(view.state, view.dispatch);
    function retrySendingEvent() {
        if (eventState.retries < pluginState.maxRetries) setTimeout(()=>{
            $e36c6f447980a314$export$da4c3508f56b63bc(event, view);
        }, retryDelay);
    }
    try {
        // API spec is not finalised yet.
        // We may have one or two separate APIs, don't know yet.
        // So below section will be changed once spec is finalised.
        const response = await fetch((0, $klIiV.convoAIAuditLogApiURL), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                event: event,
                ai_feature_input: {
                    entityId: entityId
                }
            })
        });
        if (response.ok) $e36c6f447980a314$export$c16f4f0c4f1ae3d4({
            [event]: {
                eventStatus: 'event-sent'
            }
        })(view.state, view.dispatch);
        else retrySendingEvent();
    } catch (e) {
        retrySendingEvent();
    }
}
const $e36c6f447980a314$export$c16f4f0c4f1ae3d4 = (pluginState)=>(0, $0d430026b24034e8$export$8d4021544bdece00)((state)=>{
        return {
            type: 'UPDATE_PLUGIN_STATE',
            data: pluginState
        };
    }, (tr)=>tr.setMeta('addToHistory', false));


const $f4a9abb9aa850d5c$export$5c0f6fec45bb2e7b = [
    'ai-generated-content-inserted',
    'aup-violation'
];


const $46038edb0783e562$export$b07b9a8a474c46fb = (options)=>{
    const { dispatch: dispatch, eventData: eventData } = options;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $273a0a7ac26cc1de$export$d41d542343dd0571),
        state: (0, $0d430026b24034e8$export$656c7661095efe2e)(dispatch, (0, $0d430026b24034e8$export$de5e90bd767c5d82)(eventData)),
        view (_view) {
            return {
                update: (view)=>{
                    const pluginState = (0, $0d430026b24034e8$export$f05434c51e3762e)(view.state);
                    (0, $f4a9abb9aa850d5c$export$5c0f6fec45bb2e7b).forEach((event)=>{
                        const eventState = pluginState[event];
                        if (eventState.eventStatus === 'send-event') {
                            (0, $e36c6f447980a314$export$c16f4f0c4f1ae3d4)({
                                [event]: {
                                    eventStatus: 'event-in-progress'
                                }
                            })(view.state, view.dispatch);
                            (0, $e36c6f447980a314$export$da4c3508f56b63bc)(event, view);
                        }
                    });
                }
            };
        }
    });
};









var $8m4tT = parcelRequire("8m4tT");


var $jdR93 = parcelRequire("jdR93");




const $97a626d9dbcaa4c0$export$521879fd431ff390 = new (0, $ks2lK.PluginKey)('aiExperienceAIButton');


const $a84cc97c8c45c622$export$e65c99dea6a50353 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $97a626d9dbcaa4c0$export$521879fd431ff390),
        state: {
            init: (_, state)=>({
                    isSelectionValidForAIExperience: true
                }),
            // eslint-disable-next-line @typescript-eslint/max-params
            apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                if (tr.selectionSet) {
                    const selection = tr.selection;
                    const { $from: $from } = selection;
                    const parent = $from.parent;
                    const { codeBlock: codeBlock, tableHeader: tableHeader, tableCell: tableCell, tabeRow: tabeRow, table: table } = newEditorState.schema.nodes;
                    const isNodeSelection = selection instanceof (0, $ks2lK.NodeSelection);
                    const isSelectionInCodeBlock = parent.type === codeBlock;
                    const isCellSelection = [
                        tableHeader,
                        tableCell,
                        tabeRow,
                        table
                    ].includes(parent.type);
                    // AI button is always disabled for Node selection.
                    // AI button is always disabled for Cell selection.
                    // AI button is always disabled for selection in code block.
                    // For all other selection and empty selections AI button is enabled.
                    let isSelectionValidForAIExperience = true;
                    if (isSelectionInCodeBlock || isNodeSelection || isCellSelection) isSelectionValidForAIExperience = false;
                    let newPluginState = {
                        isSelectionValidForAIExperience: isSelectionValidForAIExperience
                    };
                    const getParentSupportedForAIButton = ()=>{
                        const supportedNodesForAI = (0, $jdR93.getSupportedNodesForAIModal)(newEditorState);
                        if (isNodeSelection) return supportedNodesForAI.has(selection.node.type) ? selection.node : undefined;
                        else {
                            const parentNodeFindResult = (0, $8m4tT.findParentNode)((node)=>supportedNodesForAI.has(node.type))(selection);
                            return parentNodeFindResult?.node;
                        }
                    };
                    const parentSupportedForAIButton = getParentSupportedForAIButton();
                    const { from: from, to: to } = selection;
                    if ((from === to || isNodeSelection || isCellSelection) && parentSupportedForAIButton) {
                        const isTextSelection = selection instanceof (0, $ks2lK.TextSelection);
                        const isSelectionValidForAIExperience = !isSelectionInCodeBlock && (isTextSelection || !!parentSupportedForAIButton);
                        const triggeredFor = parentSupportedForAIButton?.type;
                        newPluginState = {
                            isSelectionValidForAIExperience: isSelectionValidForAIExperience,
                            triggeredFor: triggeredFor
                        };
                    }
                    return newPluginState;
                }
                return _pluginState;
            }
        }
    });
};















const $898294d85774604e$export$e54fe7f659b58e64 = new (0, $ks2lK.PluginKey)('aiEventHub');



var $jOIil = parcelRequire("jOIil");

const $9c92f80e4cca6045$var$EventHubEvent = {
    StartPrompt: 'start prompt',
    ReplaceConfluenceTitle: 'replace title in confluence'
};
const $9c92f80e4cca6045$var$LINK_SOURCE_TYPE = {
    CONFLUENCE: 'CONFLUENCE_LINK',
    LOOM: 'LOOM_LINK',
    GOOGLE_DOC: 'GOOGLE_DOC_LINK'
};
const $9c92f80e4cca6045$export$4cefcfab1f987be5 = {
    SuggestTitleConfluenceTitleToolbar: 'suggest title in confluence title toolbar',
    SuggestTitle: 'suggest title',
    DraftReply: 'draft reply',
    GenerateEscalationNotes: 'generate escalation notes',
    IncidentSmartComments: 'incident smart comments',
    CustomPrompt: 'custom prompt',
    IssueReformatter: 'issue reformatter',
    DescriptionCompleter: 'description completer',
    Summarize: 'summarize',
    ImproveWriting: 'improve writing',
    MakeShorter: 'make shorter',
    FixSpellingGrammar: 'fix spelling and grammar',
    ChangeToneToProfessional: 'change tone to professional',
    ChangeToneToNeutral: 'change tone to neutral',
    ChangeToneToEmpathetic: 'change tone to empathetic',
    ChangeToneToCasual: 'change tone to casual',
    ChangeToneToEducational: 'change tone to educational',
    DraftReplyPill: 'draft reply pill'
};






var $bwpRs = parcelRequire("bwpRs");


var $4SGh1 = parcelRequire("4SGh1");

const $a87d8904564d2f13$export$3ddc9d41f6af5056 = ({ editorView: editorView, dispatch: dispatch, prompt: prompt, adjustSelection: adjustSelection, promptText: promptText })=>{
    const errorEventTr = (0, $4SGh1.addAnalytics)({
        editorState: editorView.state,
        tr: editorView.state.tr,
        payload: {
            action: 'error',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'eventHubPlugin',
            attributes: {
                errorType: 'promptConfigItemNotFound',
                prompt: prompt,
                promptText: promptText,
                adjustSelection: adjustSelection
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        }
    });
    dispatch(errorEventTr);
};
function $a87d8904564d2f13$var$fireSuggestedTitleAnalyticsEvent({ api: api, analyticSourceId: analyticSourceId, additionalAttributes: additionalAttributes }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'streamingCompleted',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'eventHubPlugin',
        attributes: {
            promptType: (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE,
            modalHidden: true,
            analyticSourceId: analyticSourceId,
            ...additionalAttributes
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    });
}
const $a87d8904564d2f13$export$268e0492b4645ae4 = ({ api: api, analyticSourceId: analyticSourceId, isDateTimeFormat: isDateTimeFormat })=>{
    $a87d8904564d2f13$var$fireSuggestedTitleAnalyticsEvent({
        api: api,
        analyticSourceId: analyticSourceId,
        additionalAttributes: {
            fallbackSuggestedTitleReturned: true,
            isDateTimeFormat: isDateTimeFormat
        }
    });
};
async function $a87d8904564d2f13$var$hashString(input) {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}
const $a87d8904564d2f13$export$8e68345bacf55b30 = (configItem)=>configItem.key === (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE;
const $a87d8904564d2f13$export$544cb5cc4b426cad = async ({ api: api, analyticSourceId: analyticSourceId, suggestedTitle: suggestedTitle })=>{
    const suggestedTitleFingerprint = await $a87d8904564d2f13$var$hashString(suggestedTitle);
    $a87d8904564d2f13$var$fireSuggestedTitleAnalyticsEvent({
        api: api,
        analyticSourceId: analyticSourceId,
        additionalAttributes: {
            fallbackSuggestedTitleReturned: false,
            suggestedTitleFingerprint: suggestedTitleFingerprint
        }
    });
};








function $c2200b5407d4af9f$export$2c6858d7c847006(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value) {
    return 'selection' in value && typeof value.selection === 'string';
}
function $c2200b5407d4af9f$export$77a7a46521e984a3(item) {
    return !!item;
}
function $c2200b5407d4af9f$export$475f2e7e3b5c59c4({ editorView: editorView, positions: positions, isEmpty: isEmpty, item: item }) {
    const { triggers: triggers } = item;
    const doc = editorView.state.doc;
    // Size of the doc with a single empty paragraph is 4
    const docSize = doc.nodeSize - 4;
    const selectionSize = positions[1] - positions[0];
    if (triggers.canShow && !triggers.canShow({
        editorView: editorView,
        docSize: docSize,
        selectionSize: selectionSize
    })) return false;
    const emptyOptions = triggers.empty;
    const emptyEnabled = emptyOptions.enabled;
    const docMinSize = emptyOptions.docMinSize ?? 0;
    const docMaxSize = emptyOptions.docMaxSize ?? Number.MAX_SAFE_INTEGER;
    const selectionOptions = triggers.selection;
    const selectionEnabled = selectionOptions.enabled;
    const selectionMinSize = selectionOptions.selectionMinSize ?? 1;
    const selectionMaxSize = selectionOptions.selectionMaxSize ?? Number.MAX_SAFE_INTEGER;
    if (isEmpty) {
        if (!emptyEnabled || docSize < docMinSize || docSize > docMaxSize) return false;
    } else {
        if (!selectionEnabled || selectionSize < selectionMinSize || selectionSize > selectionMaxSize) return false;
    }
    return true;
}
function $c2200b5407d4af9f$export$a64e27216c5d7416({ isEmpty: isEmpty, configItem: configItem }) {
    if (!configItem) return [];
    const actions = (isEmpty ? configItem.actions.empty : configItem.actions.selection) ?? [];
    return actions;
}
function $c2200b5407d4af9f$export$2dd2807afbd4a532({ configItemWithOptions: configItemWithOptions, editorView: editorView, positions: positions, isEmpty: isEmpty }) {
    const arr = [];
    configItemWithOptions.forEach((item)=>{
        if (!item) return;
        if ($c2200b5407d4af9f$export$475f2e7e3b5c59c4({
            editorView: editorView,
            positions: positions,
            isEmpty: isEmpty,
            item: item
        })) arr.push(item.config);
    });
    return arr;
}
function $c2200b5407d4af9f$export$2527a005bbcba079({ configItemWithOptions: configItemWithOptions }) {
    const arr = [];
    configItemWithOptions.forEach((item)=>{
        if (!item) return;
        arr.push(item.config);
    });
    return arr;
}
function $c2200b5407d4af9f$export$d97f37f32ae9d000(configItem, formatMessage) {
    // for agents return the saved agent name in the same language as it was saved
    if (configItem.agent) {
        const presetTitle = `@${configItem.agent.name}`;
        return presetTitle || formatMessage(configItem.title);
    }
    // adding beta label for the translation prompts
    if (configItem.key.startsWith('Translate to')) return formatMessage(configItem.title);
    // for all other items return the i18n-ed title
    return formatMessage(configItem.title);
}
function $c2200b5407d4af9f$export$4539b8c6808af330(configItem, formatMessage) {
    /**
   * When the config item is silently using agent behind the scenes for prompt
   * then don't show the prompt label
   */ if (!configItem.silentAgentPrompt && configItem.agent) // for agents return the saved agent name in the same language as it was saved
    return `@${configItem.agent.name}`;
    // intentionally fall back to undefined as this value is checked to verify if we need to show the prompt input
    return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
}



var $70Lwl = parcelRequire("70Lwl");


const $eabfb7a856f4f7ef$var$getConfigFromProvider = (editorPluginAIProvider, configType, key)=>{
    if (key === (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE) return editorPluginAIProvider.baseGenerate;
    else {
        const configItem = (0, $c2200b5407d4af9f$export$2527a005bbcba079)({
            configItemWithOptions: editorPluginAIProvider.configItemWithOptions
        }).find((suggestion)=>suggestion.key === key);
        return configItem;
    }
};
const $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection = (adjustSelection)=>{
    switch(adjustSelection){
        case 'fullDocument':
            return 'rangeConfig';
        case 'keepCurrent':
            return 'rangeConfig';
        default:
            return 'emptyConfig';
    }
};
const $eabfb7a856f4f7ef$export$bd5d7e8cfaa78c6f = (prompt, editorPluginAIProvider, adjustSelection, additionalPayloadData)=>{
    switch(prompt){
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).SuggestTitleConfluenceTitleToolbar:
            return (0, $70Lwl.suggestTitleForConfluenceTitleToolbar)();
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).SuggestTitle:
            {
                const suggestTitle = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE);
                return suggestTitle;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).DraftReply:
            {
                const draftReply = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_RESPONSE);
                return draftReply;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).GenerateEscalationNotes:
            {
                const generateEscalationNotes = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).GENERATE_ESCALATION_NOTES);
                return generateEscalationNotes;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).IncidentSmartComments:
            {
                const incidentSmartComments = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).INCIDENT_SMART_COMMENTS);
                return $eabfb7a856f4f7ef$export$4708d9c8128efb7e(incidentSmartComments, additionalPayloadData);
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).CustomPrompt:
            {
                const freeGenerate = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE);
                return freeGenerate;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).IssueReformatter:
            {
                const issueReformatter = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, 'rangeConfig', (0, $bwpRs.CONFIG_ITEM_KEYS).ADD_STRUCTURE);
                return $eabfb7a856f4f7ef$export$4ca9d7e8b67397d6(issueReformatter, additionalPayloadData);
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).DescriptionCompleter:
            {
                const descriptionCompleter = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, 'rangeConfig', (0, $bwpRs.CONFIG_ITEM_KEYS).ADD_STRUCTURE);
                return $eabfb7a856f4f7ef$export$c479c0f686f70979(descriptionCompleter, additionalPayloadData);
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).DraftReplyPill:
            {
                const draftReplyPill = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, 'rangeConfig', (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_RESPONSE);
                return $eabfb7a856f4f7ef$export$e6213a58f2a1160d(draftReplyPill, additionalPayloadData);
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).Summarize:
            {
                const summarize = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).SUMMARISE_WRITING);
                return summarize;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).ImproveWriting:
            {
                const improveWriting = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).IMPROVE_WRITING);
                return improveWriting;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).MakeShorter:
            {
                const makeShorter = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).MAKE_SHORTER);
                return makeShorter;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).FixSpellingGrammar:
            {
                const fixSpellingGrammar = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).FIX_SPELLING_AND_GRAMMAR);
                return fixSpellingGrammar;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).ChangeToneToProfessional:
            {
                const professionalTone = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_PROFESSIONAL);
                return professionalTone;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).ChangeToneToNeutral:
            {
                const neutralTone = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_NEUTRAL);
                return neutralTone;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).ChangeToneToEmpathetic:
            {
                const empatheticTone = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EMPATHETIC);
                return empatheticTone;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).ChangeToneToCasual:
            {
                const empatheticTone = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_CASUAL);
                return empatheticTone;
            }
        case (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).ChangeToneToEducational:
            {
                const empatheticTone = $eabfb7a856f4f7ef$var$getConfigFromProvider(editorPluginAIProvider, $eabfb7a856f4f7ef$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EDUCATIONAL);
                return empatheticTone;
            }
        default:
            return undefined;
    }
};
const $eabfb7a856f4f7ef$export$8aaa839b34c07044 = (configItem, currentEditorView)=>{
    return configItem?.key === (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE && currentEditorView.state.doc.textContent.trim() === '';
};
const $eabfb7a856f4f7ef$export$4ca9d7e8b67397d6 = (configItem, additionalPayload)=>{
    if (configItem?.getRequestPayload && additionalPayload?.feature === 'proactive-improve-description') {
        const modifiedConfigItem = {
            ...configItem,
            experienceId: 'jira-work-completer',
            getRequestPayload: (...params)=>{
                const requestPayload = configItem.getRequestPayload?.(...params) || {};
                if (requestPayload.agent_input_context) {
                    // Add additional payload from description completer to agent_input_context
                    const agent_input_context = {
                        ...requestPayload?.agent_input_context,
                        ...additionalPayload
                    };
                    return {
                        ...requestPayload,
                        agent_input_context: agent_input_context
                    };
                }
                return requestPayload;
            }
        };
        return modifiedConfigItem;
    }
    if (configItem?.getRequestPayload && additionalPayload?.feature === 'issue-reformatter' && (0, $dh538.fg)('jira-work-sync-desc-comment-summary-ga')) return {
        ...configItem,
        getRequestPayload: (...params)=>{
            const requestPayload = configItem.getRequestPayload?.(...params) || {};
            const aiFeatureInput = requestPayload?.ai_feature_input;
            const existingContext = aiFeatureInput?.context;
            const payload = {
                ai_feature_input: {
                    ...aiFeatureInput,
                    context: {
                        ...existingContext,
                        description: additionalPayload?.additionalInfo
                    }
                }
            };
            return payload;
        }
    };
    return configItem;
};
const $eabfb7a856f4f7ef$export$c479c0f686f70979 = (configItem, additionalPayload)=>{
    if (configItem?.getRequestPayload) {
        const { source: source } = additionalPayload || {};
        // Use different experienceId for Google Docs
        const experienceId = source === 'GOOGLE_DOC_LINK' ? 'ai-issue-create-google-doc-single' : 'jira-work-completer';
        const modifiedConfigItem = {
            ...configItem,
            endpoint: '/gateway/api/assist/ai/v2/ai-feature/jira/issue/source-type/link/suggestions/stream',
            experienceId: experienceId,
            getRequestPayload: (params)=>{
                const { context: contextFromPayload, source: source } = additionalPayload || {};
                const { ai_feature_input: input } = configItem.getRequestPayload?.(params) ?? {};
                const { context: context, ...additionalProps } = input ?? {};
                const { summary: summary, description: description } = context;
                // Construct input for AI Work Create API
                const ai_feature_input = {
                    ...additionalProps,
                    source: source,
                    context: {
                        ...contextFromPayload,
                        additional_context: {
                            issue_summary: summary,
                            issue_description: description
                        }
                    }
                };
                return {
                    ai_feature_input: ai_feature_input
                };
            }
        };
        return modifiedConfigItem;
    }
};
const $eabfb7a856f4f7ef$export$e6213a58f2a1160d = (configItem, additionalPayload)=>{
    if (configItem?.getRequestPayload) {
        const modifiedConfigItem = {
            ...configItem,
            featureId: 'brainstorm',
            endpoint: '/gateway/api/firebolt/1/agent-response/generate',
            getRequestPayload: (params)=>{
                const payload = additionalPayload || {};
                const { userText: userText } = configItem.getRequestPayload?.(params) ?? {
                    userText: params?.selection || params?.doc
                };
                return {
                    ...payload,
                    ...additionalPayload?.category === 'ENHANCE_REPLY' ? {
                        userText: userText
                    } : {}
                };
            }
        };
        return modifiedConfigItem;
    }
};
const $eabfb7a856f4f7ef$export$4708d9c8128efb7e = (configItem, additionalPayload)=>{
    if (configItem?.getRequestPayload) {
        const modifiedConfigItem = {
            ...configItem,
            getRequestPayload: (params)=>{
                const originalPayload = configItem.getRequestPayload?.(params) || {};
                // Override intent with the runtime value from the pill
                return {
                    ...originalPayload,
                    intent: additionalPayload?.replyIntent || 'REQUEST_MORE_INFO',
                    isExternal: additionalPayload?.isExternal
                };
            }
        };
        return modifiedConfigItem;
    }
    return configItem;
};



var $2e7rb = parcelRequire("2e7rb");


var $dWCFT = parcelRequire("dWCFT");


var $cUcZ5 = parcelRequire("cUcZ5");


var $7ShCl = parcelRequire("7ShCl");




const $087baae06cf8cdc5$export$922d75f514df28b7 = async ({ node: node, getMentionNameDetails: getMentionNameDetails })=>{
    const mentionMapping = {};
    const findMentions = async (node)=>{
        if (node.type.name === 'mention') {
            const mentionNameDetails = await getMentionNameDetails(node.attrs.id);
            if (mentionNameDetails) mentionMapping[node.attrs.id] = mentionNameDetails?.name;
        }
        if (node.content) {
            const promises = [];
            node.content.forEach((child)=>{
                promises.push(findMentions(child));
            });
            await Promise.all(promises);
        }
    };
    await findMentions(node);
    return mentionMapping;
};









var $8nxxM = parcelRequire("8nxxM");











var $2QlXt = parcelRequire("2QlXt");


var $jSnXV = parcelRequire("jSnXV");







let $88fbc814d2ba3955$var$mergedNonErrorFallbackState = {};
const $88fbc814d2ba3955$export$34fee48925e19a88 = (newState)=>{
    for (const [key, value] of Object.entries(newState))if ($88fbc814d2ba3955$var$mergedNonErrorFallbackState[key] === undefined) $88fbc814d2ba3955$var$mergedNonErrorFallbackState[key] = value;
    else $88fbc814d2ba3955$var$mergedNonErrorFallbackState[key] = Math.max($88fbc814d2ba3955$var$mergedNonErrorFallbackState[key], value);
};
const $88fbc814d2ba3955$export$d9a76334704d46ad = (editorView, aiSessionId)=>{
    const tr = (0, $4SGh1.addAnalytics)({
        editorState: editorView.state,
        tr: editorView.state.tr,
        payload: {
            action: 'nonErrorFallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'markdownSerializer',
            attributes: {
                aiSessionId: aiSessionId,
                nonErrorFallbackState: $88fbc814d2ba3955$var$mergedNonErrorFallbackState
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        }
    });
    tr.setMeta('addToHistory', false);
    editorView.dispatch(tr);
    // Reset the merged state
    $88fbc814d2ba3955$var$mergedNonErrorFallbackState = {};
};
const $88fbc814d2ba3955$export$2dc9d8571b4d0979 = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))($88fbc814d2ba3955$export$d9a76334704d46ad, 500);





const $1bf4b6b5f80356cf$export$19bde12812d70545 = ({ editorView: editorView, slice: slice, node: node })=>{
    const hasContent = node ? (node.content?.size || 0) > 2 : slice ? slice.size >= 1 : false;
    if (hasContent) {
        if (slice?.content?.eq?.(editorView.state.doc.content) || node?.eq?.(editorView.state.doc)) return 'fullDocument';
        else return 'partialSelection';
    }
    return 'none';
};


function $a53dd72cd1e76da5$export$ae9f8b78c9fe6ae0({ slice: slice, node: node, editorView: editorView, convertTo: convertTo, existingIdMap: existingIdMap, updateIdMap: updateIdMap, mentionMap: mentionMap, aiSessionId: aiSessionId }) {
    const fragment = (slice || node).content;
    try {
        // we track whether the context is a whole document or a partial selection
        const contextSelectionScope = (0, $1bf4b6b5f80356cf$export$19bde12812d70545)({
            editorView: editorView,
            slice: slice,
            node: node
        });
        if (convertTo === 'markdown-plus') {
            const { markdown: markdown, idMap: idMap, contentStatistics: contentStatistics, fallbackState: fallbackState, nonErrorFallbackState: nonErrorFallbackState } = (0, $6eZqW.convertProsemirrorToMarkdown)({
                editorView: editorView,
                fragment: fragment,
                featureToggles: {
                    markdownPlus: true,
                    markdownPlusExtensions: true,
                    markdownPlusPanels: true,
                    markdownPlusDecisions: true,
                    markdownPlusAttributeTest: (0, $dh538.fg)('platform_editor_ai_markdown_plus_attr_test'),
                    markdownPlusMentions: (0, $dh538.fg)('platform_editor_ai_draft_reply_mentions'),
                    markdownPlusAddComplexNodes: (0, $dh538.fg)('platform_editor_ai_markdown_plus_add_complex_nodes'),
                    markdownPlusUseNextMediaPlugin: (0, $dh538.fg)('platform_editor_ai_next_media_plugin'),
                    allowAttributesMatchDefault: true
                },
                mentionMap: mentionMap,
                idMap: existingIdMap
            });
            if (!!Object.keys(nonErrorFallbackState).length && aiSessionId) {
                (0, $88fbc814d2ba3955$export$34fee48925e19a88)(nonErrorFallbackState);
                (0, $88fbc814d2ba3955$export$2dc9d8571b4d0979)(editorView, aiSessionId);
            }
            if (!!Object.keys(fallbackState).length) {
                const tr = (0, $4SGh1.addAnalytics)({
                    editorState: editorView.state,
                    tr: editorView.state.tr,
                    payload: {
                        action: 'fallback',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'markdownSerializer',
                        attributes: {
                            fallbackState: fallbackState
                        },
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                    }
                });
                tr.setMeta('addToHistory', false);
                editorView.dispatch(tr);
            }
            // This ID map is used to map the markdown back to the original ProseMirror
            // when we receive transformed content back from the llm.
            updateIdMap({
                idMap: idMap
            });
            return {
                idMap: idMap,
                markdown: markdown,
                contentStatistics: {
                    ...contentStatistics,
                    contextSelectionScope: contextSelectionScope
                }
            };
        }
        const { markdown: markdown, idMap: idMap, contentStatistics: contentStatistics } = (0, $6eZqW.convertProsemirrorToMarkdown)({
            editorView: editorView,
            fragment: fragment,
            featureToggles: {},
            mentionMap: mentionMap,
            idMap: existingIdMap
        });
        return {
            idMap: idMap,
            markdown: markdown,
            contentStatistics: {
                ...contentStatistics,
                contextSelectionScope: contextSelectionScope
            }
        };
    } catch (e) {
        const tr = (0, $4SGh1.addAnalytics)({
            editorState: editorView.state,
            tr: editorView.state.tr,
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'markdownSerializer',
                attributes: {
                    errorType: 'markdownSerializer',
                    errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(e)
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            }
        });
        editorView.dispatch(tr);
        return {
            idMap: {},
            markdown: '',
            contentStatistics: undefined
        };
    }
}





/**
 * BE supported markdowns are defined in https://bitbucket.org/atlassian/cc-smarts/src/master/src/main/java/io/atlassian/micros/smarts/model/Markdown.java
 * BE support is based on https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3632267938/Mapping+node+and+mark+names+to+markdown+features
 */ const $82475a2274af6840$var$backEndSupportedMarkdown = {
    blockquote: 'BLOCKQUOTES',
    paragraph: 'PARAGRAPH',
    rule: 'HORIZONTAL_RULE',
    heading: 'HEADING',
    hardbreak: 'HARD_LINE_BREAK',
    codeBlock: 'CODEBLOCKS',
    bulletList: 'BULLET_LISTS',
    orderedList: 'NUMBERED_LISTS',
    media: 'IMAGES',
    table: 'TABLE',
    taskList: 'TASK_LIST',
    code: 'CODE_SPAN',
    em: 'ITALICS',
    strong: 'BOLD',
    link: 'LINK',
    strike: 'STRIKETHROUGH'
};
const $82475a2274af6840$export$64c88b3c322e3de4 = (schema)=>{
    if (!schema?.nodes && !schema?.marks) return [];
    const schemaNodesAndMarks = [
        ...Object.keys(schema.nodes),
        ...Object.keys(schema.marks)
    ];
    return schemaNodesAndMarks.map((nodeOrMark)=>$82475a2274af6840$var$backEndSupportedMarkdown[nodeOrMark]).filter(Boolean);
};


const $a564dbf0a969018b$var$buildContentAri = ({ product: product, objectId: objectId, cloudId: cloudId })=>{
    return `ari:cloud:${product.toLowerCase()}:${cloudId}:content/${objectId}`;
};
const $a564dbf0a969018b$export$13b228d724f1e48f = ({ context: context, configItem: configItem, mentionMap: mentionMap, updateIdMap: updateIdMap, callback: callback })=>{
    const { aiProvider: aiProvider, userInput: userInput, editorView: editorView, positions: positions, intl: intl, latestPromptResponse: latestPromptResponse } = context;
    const editorSchema = editorView.state.schema;
    const { product: product, objectId: objectId, getChannelVariables: getChannelVariables } = aiProvider;
    const cloudId = getChannelVariables?.('rovo-agent')?.cloudId;
    let contentAri;
    // Currently CC and Jira pass in the objectID. According to the BE implementation this content ari is required.
    // for CC, Jira and Trello. This will make this property optional from FE perspective and if the BE reqruies this
    // then they can return an error when needed. This will unblock all product from adopting this.
    if (objectId !== undefined && cloudId !== undefined) contentAri = $a564dbf0a969018b$var$buildContentAri({
        product: product,
        objectId: objectId,
        cloudId: cloudId
    });
    const featureId = configItem.featureId;
    if (!featureId) return {
        error: `Unknown feature id: ${configItem.intentSchemaId}`,
        endpoint: configItem.endpoint || (0, $klIiV.convoAIApiUrl)
    };
    const { experienceId: experienceId, endpoint: endpoint } = configItem;
    const aiSessionId = context.analyticsContext?.aiSessionId;
    const idMap = {};
    // if there is no selection, we want to pass only the doc
    // if there is selection, we want to pass only the selection (if we pass doc and selection, the doc will be ignored by BE)
    let needDoc = context.isEmpty;
    let needSelection = !context.isEmpty;
    if (configItem.alwaysNoDocAndSelection) {
        // for Brainstorm, Jira Draft reply, don't send document (we have history feedback that LLM was using the document too much)
        needDoc = false;
        needSelection = false;
    } else if (configItem.alwaysNeedDoc) {
        // for Jira Improve description
        needDoc = true;
        needSelection = false;
    } else if (configItem.canTogglePageKnowledge) // for Free generate and interrogation
    // For range selection and usePageKnowledge, we're sending both doc and selection
    needDoc = context.usePageKnowledge;
    // Check for experiment first to fire exposure event, otherwise there will be imbalance.
    const isADFPrompt = configItem.adfPrompt && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    let docContent;
    let selectionContent;
    let contentStatistics;
    if (isADFPrompt) {
        const serializer = new (0, $h9yJL.JSONTransformer)(editorSchema, mentionMap);
        docContent = needDoc ? JSON.stringify(serializer.encode(editorView.state.doc, {
            keepNestedTables: true
        })) : undefined;
        let contextSelectionScope = 'fullDocument';
        let selectionDoc = null;
        if (needSelection) {
            const docNodeType = editorSchema.nodes.doc;
            const doc = editorView.state.doc;
            const selectionSlice = doc.slice(positions[0], positions[1]);
            const sliceContent = selectionSlice.content;
            callback({
                type: 'update selectionMetaData',
                context: {
                    selectionMetaData: {
                        sliceOpenStart: selectionSlice.openStart,
                        sliceOpenEnd: selectionSlice.openEnd
                    }
                }
            });
            if (docNodeType.validContent(sliceContent)) {
                selectionDoc = docNodeType.createAndFill(null, selectionSlice.content);
                selectionContent = selectionDoc ? JSON.stringify(serializer.encode(selectionDoc, {
                    keepNestedTables: true
                })) : undefined;
            } else {
                const startPos = doc.resolve(positions[0]);
                const endPos = doc.resolve(positions[1]);
                const adfResponseNodeWrappers = [];
                /**
				 * When prosemirror creates slice, it will have node
				 * 	starting from (shared depth + 1) level of start and end position.
				 * So finding parent node that can set as doc content should be
				 * 	start at shared depth level.
				 */ const sameParentDepth = startPos.sharedDepth(endPos.pos);
                let currentDepth = sameParentDepth;
                let docContentNode = selectionSlice.content;
                while(currentDepth > 0){
                    const parentNode = startPos.node(currentDepth);
                    const parentNodeType = parentNode.type;
                    docContentNode = parentNodeType.createAndFill(null, docContentNode);
                    if (docContentNode) {
                        adfResponseNodeWrappers.push(parentNodeType.name);
                        selectionDoc = docNodeType.createAndFill(null, docContentNode);
                        if (selectionDoc) {
                            selectionContent = JSON.stringify(serializer.encode(selectionDoc, {
                                keepNestedTables: true
                            }));
                            break;
                        } else currentDepth--;
                    } else break;
                }
                contextSelectionScope = 'partialSelection';
                callback({
                    type: 'update adfResponseNodeWrappers',
                    context: {
                        adfResponseNodeWrappers: adfResponseNodeWrappers
                    }
                });
            }
        }
        const nodeForStats = needDoc ? editorView.state.doc : selectionDoc;
        if (nodeForStats) {
            const pmStats = new (0, $8nxxM.ProseMirrorContentStatistics)(nodeForStats);
            contentStatistics = pmStats.collectStatistics();
            contentStatistics = {
                ...contentStatistics,
                contextSelectionScope: contextSelectionScope
            };
        }
    } else {
        const doc = needDoc ? (0, $a53dd72cd1e76da5$export$ae9f8b78c9fe6ae0)({
            node: editorView.state.doc,
            editorView: editorView,
            convertTo: 'markdown-plus',
            existingIdMap: idMap,
            updateIdMap: updateIdMap,
            mentionMap: mentionMap,
            aiSessionId: aiSessionId
        }) : undefined;
        docContent = doc?.markdown;
        const selection = needSelection ? (0, $a53dd72cd1e76da5$export$ae9f8b78c9fe6ae0)({
            slice: editorView.state.doc.slice(positions[0], positions[1]),
            editorView: editorView,
            convertTo: 'markdown-plus',
            existingIdMap: doc?.idMap,
            updateIdMap: updateIdMap,
            mentionMap: mentionMap,
            aiSessionId: aiSessionId
        }) : undefined;
        docContent = doc?.markdown;
        selectionContent = selection?.markdown;
        contentStatistics = doc?.contentStatistics || selection?.contentStatistics;
    }
    const additionalProps = aiProvider.getAdditionalProps && aiProvider.getAdditionalProps?.();
    /**
	 * Whenever configItem has a getRequestPayload, it should be used to build the payload.
	 * Currently it is defined for Jira Improve description, Generate Escalation Notes,
	 * 	Draft reply and Incident Smart Comments.
	 */ const payload = configItem.getRequestPayload?.({
        aiSessionId: aiSessionId,
        locale: intl.locale,
        isEmpty: context.isEmpty,
        doc: docContent,
        selection: selectionContent
    });
    return {
        doc: docContent,
        selection: selectionContent,
        contentStatistics: contentStatistics,
        isConvoAI: true,
        experienceId: experienceId || 'editor',
        endpoint: endpoint || (0, $klIiV.convoAIApiUrl),
        payload: JSON.stringify(payload || {
            ai_feature_input: {
                feature_args: {
                    // NOTE: we want to ensure we use undefined instead of null. This is because the JSON Serializer will remove props
                    // that are undefined, but will not remove props that are null.
                    user_input: userInput || undefined,
                    // Previously Assistance service sent a `document_title` prop which was used only by jira for situations where nothing was selected
                    // during free generate. This will ensure that the BE has some context about the issue
                    document_title: additionalProps?.issue_summary,
                    selected_context: latestPromptResponse || selectionContent || undefined,
                    document_context: docContent || undefined,
                    supported_markdown_nodes: (0, $82475a2274af6840$export$64c88b3c322e3de4)(editorSchema),
                    output_mime_type: isADFPrompt ? 'text/adf' : 'text/markdown',
                    // for translate
                    transformation_subtype: configItem.lang
                },
                feature: featureId,
                /**
					 * We can still get a response from the server if the contentAri is not valid
					 * but we will get 500, internal server error if the contentAri is undefined.
					 * It is not required for a prompt like improve writing so we can ignore it.
					 * But we should still log an analytics event to track when this occurs.
					 */ content_ari: contentAri,
                ai_session_id: aiSessionId,
                locale: intl.locale
            }
        })
    };
};



var $caRYB = parcelRequire("caRYB");

var $2FFuS = parcelRequire("2FFuS");





function $85b577a3914af3c7$var$makeAdf({ userInput: userInput = '', userADFInput: userADFInput }) {
    return userADFInput || (0, $caRYB.doc)((0, $2FFuS.paragraph)(userInput));
}
const $85b577a3914af3c7$export$65177b80f2db004b = ({ context: context, configItem: configItem, mentionMap: mentionMap, updateIdMap: updateIdMap })=>{
    const { editorView: editorView, positions: positions, userInput: userInput, userADFInput: userADFInput } = context;
    const { agent: agent } = configItem;
    const idMap = {};
    const needDoc = context.usePageKnowledge;
    const needSelection = true;
    const doc = needDoc ? (0, $a53dd72cd1e76da5$export$ae9f8b78c9fe6ae0)({
        node: editorView.state.doc,
        editorView: editorView,
        convertTo: 'markdown-plus',
        existingIdMap: idMap,
        updateIdMap: updateIdMap,
        mentionMap: mentionMap
    }) : undefined;
    const selection = needSelection ? (0, $a53dd72cd1e76da5$export$ae9f8b78c9fe6ae0)({
        slice: editorView.state.doc.slice(positions[0], positions[1]),
        editorView: editorView,
        convertTo: 'markdown-plus',
        existingIdMap: doc?.idMap,
        updateIdMap: updateIdMap,
        mentionMap: mentionMap
    }) : undefined;
    return {
        doc: doc?.markdown,
        selection: selection?.markdown,
        contentStatistics: doc?.contentStatistics || selection?.contentStatistics,
        isConvoAI: true,
        experienceId: 'ai-mate',
        endpoint: (0, $klIiV.convoAIRovoApiURL),
        // For payload spec, see https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3783312372/Actions+Contract+for+Confluence+Content+Suggestion
        payload: JSON.stringify({
            agent_id: agent?.namedId,
            internal_data_sharing_opt_in: true,
            mimeType: 'text/adf',
            content: $85b577a3914af3c7$var$makeAdf({
                userInput: userInput,
                userADFInput: userADFInput
            }),
            context: {
                // Just the main URL, remove the extra stuff like hashes/query params
                browser_url: window.location.origin + window.location.pathname,
                editor: {
                    document: {
                        type: 'text/markdown',
                        content: doc?.markdown || ''
                    },
                    selection: {
                        type: 'text/markdown',
                        content: selection?.markdown || ''
                    }
                }
            }
        })
    };
};


function $658af4922a7dab16$export$65964063bcedf059({ callback: callback, context: context, configItem: configItem, mentionMap: mentionMap }) {
    // elevate free generate is disabled and returns the pre-configured response immediately
    if (configItem.response) return {
        response: configItem.response
    };
    const updateIdMap = ({ idMap: idMap })=>{
        callback({
            type: 'update idMap',
            context: {
                idMap: idMap
            }
        });
    };
    let requestOptions;
    if (configItem.agent) requestOptions = (0, $85b577a3914af3c7$export$65177b80f2db004b)({
        context: context,
        configItem: configItem,
        mentionMap: mentionMap,
        updateIdMap: updateIdMap
    });
    else requestOptions = (0, $a564dbf0a969018b$export$13b228d724f1e48f)({
        context: context,
        configItem: configItem,
        mentionMap: mentionMap,
        updateIdMap: updateIdMap,
        callback: callback
    });
    if ('contentStatistics' in requestOptions && requestOptions.contentStatistics) callback({
        type: 'storeContextStatistics',
        contextStatistics: {
            inputDocument: requestOptions.contentStatistics
        }
    });
    return requestOptions;
}


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $b4emg = parcelRequire("b4emg");





var $8klLr = parcelRequire("8klLr");

function $56d53639f779f5c2$export$46d5228a079b1d3(product) {
    return {
        'X-Product': (0, $8klLr.mapToAssistanceServiceProduct)(product)
    };
}
function $56d53639f779f5c2$export$b3f5e033c954a1b0(experienceId) {
    switch(experienceId){
        case 'ai-mate':
            return {
                'X-Channel-Id': 'editor'
            };
        case 'issue-reformatter':
            return {
                'X-Channel-Id': 'issue-reformatter'
            };
        default:
            return {};
    }
}






var $6jPem = parcelRequire("6jPem");

const $2f2616de49edd3d8$var$punctuationCharacters = [
    '.',
    '!',
    '?'
];
const $2f2616de49edd3d8$var$estimateTextContentLength = (doc, maxLength)=>{
    let totalLength = 0;
    try {
        (0, $6jPem.traverse)(doc, {
            text: (node)=>{
                totalLength += (node.text || '').length;
                // Early termination if we exceed the threshold
                if (totalLength > maxLength) throw new Error('SIZE_EXCEEDED');
            },
            hardBreak: ()=>{
                totalLength += 1; // Count newlines
                if (totalLength > maxLength) throw new Error('SIZE_EXCEEDED');
            }
        });
    } catch (error) {
        if (error instanceof Error && error.message === 'SIZE_EXCEEDED') return totalLength; // Return the length that exceeded threshold
        // If traversal fails for other reasons, return a conservative estimate
        return maxLength + 1;
    }
    return totalLength;
};
/**
 * Extract plain text from ADF document
 */ const $2f2616de49edd3d8$var$extractTextFromADF = (doc)=>{
    const result = [];
    (0, $6jPem.traverse)(doc, {
        text: (node)=>{
            result.push(node.text || '');
        },
        hardBreak: ()=>{
            result.push('\n');
        }
    });
    return result.join('');
};
/**
 * Check if selection starts at a position where capitalization is appropriate
 * (beginning of document, after sentence-ending punctuation, or start of paragraph)
 */ const $2f2616de49edd3d8$var$startsWithSentence = (fullText, selectionStart)=>{
    // Start of document
    if (selectionStart === 0) return true;
    // Look at the text before the selection
    const beforeSelection = fullText.slice(0, selectionStart);
    // Start of paragraph (preceded only by whitespace/newlines)
    if (beforeSelection.trim().length === 0) return true;
    // Check for paragraph break (newline followed by optional whitespace)
    // eslint-disable-next-line require-unicode-regexp
    if (/\n\s*$/.test(beforeSelection)) return true;
    // Check for sentence-ending punctuation followed by optional whitespace
    // eslint-disable-next-line require-unicode-regexp
    if (/[.!?]\s*$/.test(beforeSelection)) return true;
    return false;
};
/**
 * Check if text ends at a sentence boundary
 */ const $2f2616de49edd3d8$var$endsAtSentence = (fullText, selectionEnd)=>{
    const afterSelection = fullText.slice(selectionEnd).trim();
    return afterSelection.length === 0;
};
/**
 * Determine if we need to revert inappropriate API capitalization/punctuation changes
 */ const $2f2616de49edd3d8$var$shouldCorrectCapitalization = (originalText, responseText, fullDocumentText, selectionStart, selectionEnd)=>{
    if (selectionStart === selectionEnd) return {
        shouldCorrectFirst: false,
        shouldCorrectLast: false
    };
    const originalTrimmed = originalText.trim();
    const responseTrimmed = responseText.trim();
    if (!originalTrimmed || !responseTrimmed || originalTrimmed === responseTrimmed) return {
        shouldCorrectFirst: false,
        shouldCorrectLast: false
    };
    const originalFirstChar = originalTrimmed.length > 0 ? $2f2616de49edd3d8$var$getFirstCharacter(originalTrimmed) : '';
    const responseFirstChar = responseTrimmed.length > 0 ? $2f2616de49edd3d8$var$getFirstCharacter(responseTrimmed) : '';
    const originalLastChar = originalTrimmed.length > 0 ? $2f2616de49edd3d8$var$getLastCharacter(originalTrimmed) : '';
    const responseLastChar = responseTrimmed.length > 0 ? $2f2616de49edd3d8$var$getLastCharacter(responseTrimmed) : '';
    // Check if LLM inappropriately capitalized first character (revert to lowercase)
    const shouldCorrectFirst = Boolean(originalFirstChar && responseFirstChar && originalFirstChar === originalFirstChar.toLowerCase() && // Original was lowercase
    responseFirstChar === responseFirstChar.toUpperCase() && // LLM made it uppercase
    !$2f2616de49edd3d8$var$startsWithSentence(fullDocumentText, selectionStart));
    // Check if LLM inappropriately added punctuation (remove it)
    const shouldCorrectLast = Boolean(responseLastChar && $2f2616de49edd3d8$var$punctuationCharacters.includes(responseLastChar) && (!originalLastChar || !$2f2616de49edd3d8$var$punctuationCharacters.includes(originalLastChar)) && !$2f2616de49edd3d8$var$endsAtSentence(fullDocumentText, selectionEnd));
    return {
        shouldCorrectFirst: shouldCorrectFirst,
        shouldCorrectLast: shouldCorrectLast
    };
};
/**
 * Get the first character from a string, handling Unicode properly
 */ const $2f2616de49edd3d8$var$getFirstCharacter = (text)=>{
    const chars = Array.from(text);
    return chars.length > 0 ? chars[0] : '';
};
/**
 * Get the last character from a string, handling Unicode properly
 */ const $2f2616de49edd3d8$var$getLastCharacter = (text)=>{
    const chars = Array.from(text);
    return chars.length > 0 ? chars[chars.length - 1] : '';
};
/**
 * Replace the first character in a string, handling Unicode properly
 */ const $2f2616de49edd3d8$var$replaceFirstCharacter = (text, newChar)=>{
    const chars = Array.from(text);
    if (chars.length > 0) {
        chars[0] = newChar;
        return chars.join('');
    }
    return text;
};
/**
 * Check if this is the last text node by comparing the extracted text
 */ const $2f2616de49edd3d8$var$isLastMeaningfulTextNode = (doc, currentText)=>{
    const fullText = $2f2616de49edd3d8$var$extractTextFromADF(doc);
    const trimmedFullText = fullText.trimEnd();
    const trimmedCurrentText = currentText.trimEnd();
    // If this node's text appears at the end of the full document text, it's likely the last one
    return trimmedCurrentText.length > 0 && trimmedFullText.endsWith(trimmedCurrentText);
};
/**
 * Revert inappropriate API capitalization and punctuation changes in ADF document
 */ const $2f2616de49edd3d8$var$applyADFCorrections = (doc, shouldCorrectFirst, shouldCorrectLast)=>{
    let firstTextNodeFound = false;
    let correctedDoc = doc;
    correctedDoc = (0, $6jPem.traverse)(correctedDoc, {
        text: (node)=>{
            if (!node.text) return node;
            let correctedText = node.text;
            // Revert inappropriate capitalization of first character if this is the first text node
            if (!firstTextNodeFound && shouldCorrectFirst && correctedText.trim().length > 0) {
                // Find the first non-whitespace character and its position
                // eslint-disable-next-line require-unicode-regexp
                const firstNonWhitespaceIndex = correctedText.search(/\S/);
                if (firstNonWhitespaceIndex !== -1) {
                    const beforeChar = correctedText.slice(0, firstNonWhitespaceIndex);
                    const restOfText = correctedText.slice(firstNonWhitespaceIndex);
                    // Use Unicode-safe character extraction
                    const firstChar = $2f2616de49edd3d8$var$getFirstCharacter(restOfText);
                    if (firstChar && firstChar.toUpperCase() !== firstChar.toLowerCase()) {
                        const correctedFirstChar = firstChar.toLowerCase();
                        const remainingText = $2f2616de49edd3d8$var$replaceFirstCharacter(restOfText, correctedFirstChar);
                        correctedText = beforeChar + remainingText;
                    }
                }
                firstTextNodeFound = true;
            }
            // Remove inappropriate punctuation only from the last meaningful text node
            if (shouldCorrectLast && $2f2616de49edd3d8$var$isLastMeaningfulTextNode(doc, node.text)) {
                const trimmedText = correctedText.trimEnd();
                if (trimmedText.length > 0) {
                    const lastChar = $2f2616de49edd3d8$var$getLastCharacter(trimmedText);
                    if ($2f2616de49edd3d8$var$punctuationCharacters.includes(lastChar)) {
                        // Use Unicode-safe character removal - remove last character
                        const chars = Array.from(trimmedText);
                        const textWithoutLastChar = chars.slice(0, -1).join('');
                        // Preserve trailing whitespace if any
                        const trailingWhitespace = correctedText.slice(trimmedText.length);
                        const resultText = textWithoutLastChar + trailingWhitespace;
                        correctedText = resultText;
                    }
                }
            }
            // Delete the text node if it becomes empty after corrections
            if (correctedText.trim().length === 0) return false;
            return correctedText !== node.text ? {
                ...node,
                text: correctedText
            } : node;
        }
    });
    return correctedDoc;
};
const $2f2616de49edd3d8$export$895f42d4e9947fc3 = (adfResponse, selectionContext)=>{
    try {
        // Performance guard: skip processing for documents with large text content
        const MAX_TEXT_LENGTH = 100000; // ~100KB of text
        const estimatedTextLength = $2f2616de49edd3d8$var$estimateTextContentLength(adfResponse, MAX_TEXT_LENGTH);
        if (estimatedTextLength > MAX_TEXT_LENGTH) return adfResponse;
        // Extract response text from ADF
        const responseText = $2f2616de49edd3d8$var$extractTextFromADF(adfResponse);
        // Use pre-captured selection context
        const { originalText: originalText, fullDocumentText: fullDocumentText, selectionStart: selectionStart, selectionEnd: selectionEnd } = selectionContext;
        // Determine what corrections are needed
        const { shouldCorrectFirst: shouldCorrectFirst, shouldCorrectLast: shouldCorrectLast } = $2f2616de49edd3d8$var$shouldCorrectCapitalization(originalText, responseText, fullDocumentText, selectionStart, selectionEnd);
        if (shouldCorrectFirst || shouldCorrectLast) return $2f2616de49edd3d8$var$applyADFCorrections(adfResponse, shouldCorrectFirst, shouldCorrectLast);
        return adfResponse;
    } catch (error) {
        return adfResponse;
    }
};


var $a70d178538e2ee9c$export$ab58f948d2b5b95c = /*#__PURE__*/ function(FAILURE_REASON) {
    FAILURE_REASON["API_FAIL"] = "api fail";
    FAILURE_REASON["AUP_VIOLATION"] = "aup violation detected";
    FAILURE_REASON["UNKNOWN"] = "unknown fail";
    FAILURE_REASON["TOKEN_LIMIT"] = "token limit fail";
    FAILURE_REASON["INSERT_FAILURE"] = "insert failure";
    FAILURE_REASON["INPUT_TOO_SHORT"] = "input too short fail";
    FAILURE_REASON["HIPAA_CONTENT"] = "hipaa content fail";
    FAILURE_REASON["RATE_LIMITED"] = "rate limited";
    FAILURE_REASON["INTERNAL_SERVER_ERROR"] = "internal server error";
    FAILURE_REASON["ELEVATE_DISABLED_GENERATE"] = "elevate disabled generate";
    FAILURE_REASON["ADF_STREAMING_ERROR"] = "adf streaming error";
    FAILURE_REASON["NO_TEXTUAL_CONTENT"] = "no textual content";
    FAILURE_REASON["INVALID_JSON"] = "invalid json";
    return FAILURE_REASON;
}({});



var $3FxV8 = parcelRequire("3FxV8");


var $l6okE = parcelRequire("l6okE");




var $d7640ba9fbf99af2$export$917a2c609d734ce2 = /*#__PURE__*/ function(SELECTION_CATEGORY) {
    SELECTION_CATEGORY["EMPTY"] = "empty";
    SELECTION_CATEGORY["FULL_DOCUMENT"] = "fullDocument";
    SELECTION_CATEGORY["FULL_SINGLE_BLOCK"] = "fullSingleBlock";
    SELECTION_CATEGORY["PARTIAL_SINGLE_BLOCK"] = "partialSingleBlock";
    SELECTION_CATEGORY["FULL_MULTIPLE_BLOCKS"] = "fullMultipleBlocks";
    SELECTION_CATEGORY["PARTIAL_MULTIPLE_BLOCKS"] = "partialMultipleBlocks";
    return SELECTION_CATEGORY;
}({});


function $d465bdc6207b3d88$var$findFirstDeco(decorationSet, key) {
    const found = decorationSet.find(undefined, undefined, (spec)=>spec.key === key);
    return found.length > 0 ? found[0] : undefined;
}
function $d465bdc6207b3d88$export$8e313fd1eaf35cec({ modalDecorationSet: modalDecorationSet }) {
    if (!modalDecorationSet) return undefined;
    const inlineDecoration = $d465bdc6207b3d88$var$findFirstDeco(modalDecorationSet, 'inlineDecoration');
    if (inlineDecoration) return [
        inlineDecoration.from,
        inlineDecoration.to
    ];
    const startWidget = $d465bdc6207b3d88$var$findFirstDeco(modalDecorationSet, 'generatedStartWidget');
    const endWidget = $d465bdc6207b3d88$var$findFirstDeco(modalDecorationSet, 'generatedEndWidget');
    if (startWidget && endWidget) return [
        startWidget.from,
        endWidget.to
    ];
    return undefined;
}
function $d465bdc6207b3d88$export$385434a4b24ab280(editorView, positions) {
    const { state: state } = editorView;
    return $d465bdc6207b3d88$export$c96ebd9bae9a4b95(state, positions);
}
function $d465bdc6207b3d88$export$c96ebd9bae9a4b95(state, positions) {
    const [start, end] = positions;
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $kqrrC.getPluginState)(state);
    const isEmptySelection = start === end;
    // For in-document streaming, somehow during streaming, the position can be larger than the document size
    // So we clamp the position to the document size to quickly bypass the issue
    // In the future, when we refactor the decoration plugin, we should revisit this if needed
    const $start = isInDocumentStreamingEnabled ? state.doc.resolve((0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(start, 1, state.doc.content.size)) : state.doc.resolve(start);
    const $end = isInDocumentStreamingEnabled ? state.doc.resolve((0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(end, 1, state.doc.content.size)) : state.doc.resolve(end);
    const isSameParent = $start.sameParent($end);
    const isBeginningOfDoc = $start.pos === $start.depth;
    const isEndOfDoc = state.doc.nodeSize - $end.pos - 2 === $end.depth;
    const isStartOfParentNode = (0, $l6okE.isSelectionAtStartOfNode)($start, $start.parent);
    const isEndOfParentNode = (0, $l6okE.isSelectionAtEndOfNode)($end, $end.parent);
    if (isEmptySelection) return (0, $d7640ba9fbf99af2$export$917a2c609d734ce2).EMPTY;
    if (isBeginningOfDoc && isEndOfDoc) return (0, $d7640ba9fbf99af2$export$917a2c609d734ce2).FULL_DOCUMENT;
    if (isSameParent) {
        if (isStartOfParentNode && isEndOfParentNode) return (0, $d7640ba9fbf99af2$export$917a2c609d734ce2).FULL_SINGLE_BLOCK;
        return (0, $d7640ba9fbf99af2$export$917a2c609d734ce2).PARTIAL_SINGLE_BLOCK;
    }
    if (isStartOfParentNode && isEndOfParentNode) return (0, $d7640ba9fbf99af2$export$917a2c609d734ce2).FULL_MULTIPLE_BLOCKS;
    return (0, $d7640ba9fbf99af2$export$917a2c609d734ce2).PARTIAL_MULTIPLE_BLOCKS;
}
function $d465bdc6207b3d88$export$13724218f8b1273e(state, positions) {
    const [start, end] = positions;
    const text = state.doc.textBetween(start, end);
    return text.trim().length > 0;
}
function $d465bdc6207b3d88$export$208ac2488b55bf9d(state, positions) {
    const [start, end] = positions;
    const nodeCounts = {};
    // Walk through the document between the start and end positions
    state.doc.nodesBetween(start, end, (node)=>{
        // Count the node type
        nodeCounts[node.type.name] = (nodeCounts[node.type.name] ?? 0) + 1;
        // Count each mark on the node
        node.marks.forEach((mark)=>{
            nodeCounts[mark.type.name] = (nodeCounts[mark.type.name] ?? 0) + 1;
        });
    });
    return nodeCounts;
}









var $4pSml = parcelRequire("4pSml");

const $2366813efecaf494$var$createFireADFStreamingAnalyticsEvent = ({ fireAIAnalyticsEvent: fireAIAnalyticsEvent, experienceName: experienceName, featureId: featureId, aiSessionId: aiSessionId, aiInteractionID: aiInteractionID, selectionType: selectionType, selectionCategory: selectionCategory, contentStatistics: contentStatistics, streamId: streamId, retryAttemptNumber: retryAttemptNumber, traceId: traceId })=>(event)=>{
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) {
            const commonAttributes = {
                experienceName: experienceName,
                featureId: featureId,
                aiSessionId: aiSessionId,
                aiInteractionID: aiInteractionID,
                selectionType: selectionType,
                selectionCategory: selectionCategory,
                contentStatistics: contentStatistics,
                streamId: streamId,
                retryAttemptNumber: retryAttemptNumber,
                traceId: traceId,
                source: {
                    type: 'plugin'
                }
            };
            if (event.type === 'error') fireAIAnalyticsEvent({
                payload: {
                    action: 'error',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'adfStreaming',
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        ...commonAttributes,
                        errorMessage: event.message,
                        errorData: event.data
                    }
                }
            });
            else fireAIAnalyticsEvent({
                payload: {
                    action: 'info',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'adfStreaming',
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        ...commonAttributes,
                        message: event.message,
                        data: event.data
                    }
                }
            });
        } else if (event.type === 'error') fireAIAnalyticsEvent({
            payload: {
                action: 'error',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'adfStreaming',
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: event.message,
                    errorData: event.data,
                    experienceName: experienceName,
                    featureId: featureId,
                    aiSessionId: aiSessionId,
                    aiInteractionID: aiInteractionID,
                    selectionType: selectionType,
                    selectionCategory: selectionCategory,
                    contentStatistics: contentStatistics,
                    streamId: streamId,
                    retryAttemptNumber: retryAttemptNumber,
                    source: {
                        type: 'plugin'
                    }
                }
            }
        });
        else fireAIAnalyticsEvent({
            payload: {
                action: 'info',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'adfStreaming',
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    message: event.message,
                    data: event.data,
                    experienceName: experienceName,
                    featureId: featureId,
                    aiSessionId: aiSessionId,
                    aiInteractionID: aiInteractionID,
                    selectionType: selectionType,
                    selectionCategory: selectionCategory,
                    contentStatistics: contentStatistics,
                    streamId: streamId,
                    retryAttemptNumber: retryAttemptNumber,
                    source: {
                        type: 'plugin'
                    }
                }
            }
        });
    };
function $2366813efecaf494$export$313ea9e31b82ddc(options) {
    return new (0, $4pSml.ADFStreamer)(options.state.schema, $2366813efecaf494$var$createFireADFStreamingAnalyticsEvent({
        fireAIAnalyticsEvent: options.fireAIAnalyticsEvent,
        experienceName: options.experienceName,
        featureId: options.featureId,
        aiSessionId: options.aiSessionId,
        aiInteractionID: options.aiInteractionID,
        selectionType: options.selectionType,
        contentStatistics: options.contentStatistics,
        selectionCategory: options.selectionCategory,
        streamId: options.streamId,
        retryAttemptNumber: options.retryAttemptNumber,
        traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? options.traceId : undefined
    }));
}



var $5SAOw = parcelRequire("5SAOw");




const $8ec52e19962cb30c$export$76f60e834c48b8d9 = (adf, schema)=>{
    const prosemirrorNode = (0, $5SAOw.Node).fromJSON(schema, adf);
    return (0, $6eZqW.convertProsemirrorNodeToMarkdown)({
        node: prosemirrorNode
    }).markdown;
};


const $e04ad68663ab9071$var$DEFAULT_MAX_RETRY_CHECKS = 10;
class $e04ad68663ab9071$export$f748a1b030d3429f {
    /**
   * Starts a timer to check for errors after the specified delay.
   * When the timer expires, it will attempt a retry if an error is detected.
   *
   * @private
   */ startErrorCheckTimer() {
        this.clearErrorCheckTimer();
        this.errorCheckTimerId = setTimeout(()=>{
            this.attemptRetry();
        }, this.options.delayMs);
    }
    /**
   * Attempts to retry the request if the maximum number of retries hasn't been reached.
   *
   * Checks for errors using the errorChecker function. If an error is detected:
   * - Aborts the current request
   * - Calls the beforeRetryCallback
   * - Starts a new request with retry logic
   * - Increments the retry counter
   *
   * If no error is detected, schedules another error check after the delay period.
   *
   * @private
   */ attemptRetry() {
        if (this.retries < this.options.maxRetries) {
            const hasErrored = this.options.errorChecker();
            /**
       * If errored then abort current request and start a new request.
       */ if (hasErrored) {
                this.callBeforeRetryCallback();
                this.startFetchingWithRetry();
            } else {
                if (this.currentRetryCheck < this.maxRetryChecks) // If not errored then check again after delay.
                this.startErrorCheckTimer();
                this.currentRetryCheck++;
            }
        }
    }
    callBeforeRetryCallback() {
        this.abortController?.abort();
        /**
     * In beforeRetryCallback, retryAttemptCount can be used for various purposes,
     * 	like creating new ADFStreamer instance having retryAttemptCount as a parameter
     * 	to send to analytics.
     * So must update retries before calling beforeRetryCallback.
     */ this.retries++;
        this.options.beforeRetryCallback();
    }
    /**
   * Manually triggers a retry when streaming has ended.
   * This is useful when streaming ends before first check for errors
   * 	or if ADFStreamer is in error state when streaming ends.
   *
   * It will only retry if ADFStreamer is in error state and
   *  the maximum number of retries hasn't been reached.
   *
   * Steps performed:
   * 1. Clears the error checking timer
   * 2. Calls the beforeRetryCallback to prepare for retry
   * 3. Initiates the new request using the fetcher function
   * 4. Increments the retry counter
   *
   * @public
   */ retryOnStreamingEnd() {
        this.clearErrorCheckTimer();
        const hasErrored = this.options.errorChecker();
        if (hasErrored && !this.hasMaxRetryReached()) {
            this.callBeforeRetryCallback();
            this.fetch();
        }
    }
    /**
   * Returns the current number of retry attempts made.
   *
   * @public
   */ getRetryCount() {
        return this.retries;
    }
    /**
   * Checks if the maximum number of retries has been reached.
   *
   * @public
   */ hasMaxRetryReached() {
        return this.retries >= this.options.maxRetries;
    }
    /**
   * Creates a new AbortController, initiates the fetch using the fetcher function.
   *
   * @private
   */ fetch() {
        this.abortController = new AbortController();
        this.options.fetcher(this.abortController, this);
    }
    /**
   * Starts a new fetch operation with retry monitoring enabled.
   *
   * Creates a new AbortController, initiates the fetch using the fetcher function,
   * and starts the error checking timer to monitor for issues during the request.
   */ startFetchingWithRetry() {
        this.currentRetryCheck = 0;
        this.fetch();
        this.startErrorCheckTimer();
    }
    /**
   * Clears the active error checking timer if one exists.
   *
   * This stops any pending error checks and resets the timer ID to null.
   * Used during cleanup or when resetting the retry manager state.
   *
   * @private
   */ clearErrorCheckTimer() {
        if (this.errorCheckTimerId) {
            clearTimeout(this.errorCheckTimerId);
            this.errorCheckTimerId = null;
        }
    }
    /**
   * Resets the retry manager to its initial state.
   *
   * Clears any active error checking timers and resets the retry counter to zero.
   * This allows the retry manager to be reused for new streaming operations.
   *
   * @public
   */ reset() {
        this.clearErrorCheckTimer();
        this.retries = 0;
    }
    /**
   * Creates a new ADFStreamingRetryManager instance.
   *
   * @param options - Configuration options for the retry manager
   * @param options.maxRetries - Maximum number of retry attempts allowed
   * @param options.delayMs - Delay in milliseconds between error checks and retries
   * @param options.beforeRetryCallback - Callback executed before each retry attempt.
   *   Must not throw errors or the fetcher will not be called.
   * @param options.fetcher - Function that initiates the streaming request.
   *   Must not throw errors or subsequent retries won't be triggered.
   *   Receives an AbortController to allow request cancellation.
   * @param options.errorChecker - Function that checks if an error has occurred.
   *   Must not throw errors or the previous request won't be aborted and retry won't be attempted.
   *   Should return true if an error is detected, false otherwise.
   */ constructor(options){
        this.options = options;
        /** Timer ID for the error checking interval, null when no timer is active */ this.errorCheckTimerId = null;
        /** Current number of retry attempts made */ this.retries = 0;
        /** AbortController for the current request, used to cancel ongoing operations */ this.abortController = null;
        /**
     * Maximum number of retry checks after fetching started.
     * This is to prevent infinite loop of checking for errors.
     */ this.maxRetryChecks = $e04ad68663ab9071$var$DEFAULT_MAX_RETRY_CHECKS;
        this.currentRetryCheck = 0;
        this.maxRetryChecks = options.maxRetryChecks ?? $e04ad68663ab9071$var$DEFAULT_MAX_RETRY_CHECKS;
    }
}


const $10da779a4259130a$var$ADF_STREAMING_PROCESS_INTERVAL = 250; // 4 re-renders per second
const $10da779a4259130a$var$ADF_STREAMING_PROCESS_INITIAL_CHARS_PER_TICK = 5000;
const $10da779a4259130a$var$ADF_STREAMING_PROCESS_MAX_CHARS_PER_TICK = 10000;
const $10da779a4259130a$var$ADF_STREAMING_RETRY_MAX_RETRIES = 1;
const $10da779a4259130a$var$ADF_STREAMING_RETRY_DELAY_MS = 10000;
let $10da779a4259130a$var$canProcessADFStreaming = false;
let $10da779a4259130a$var$adfStreamingProcessTimer = null;
function $10da779a4259130a$var$startADFStreamingProcessTimer() {
    $10da779a4259130a$var$stopADFStreamingProcessTimer();
    $10da779a4259130a$var$adfStreamingProcessTimer = setInterval(()=>{
        $10da779a4259130a$var$canProcessADFStreaming = true;
    }, $10da779a4259130a$var$ADF_STREAMING_PROCESS_INTERVAL);
}
function $10da779a4259130a$var$stopADFStreamingProcessTimer() {
    if ($10da779a4259130a$var$adfStreamingProcessTimer) {
        clearInterval($10da779a4259130a$var$adfStreamingProcessTimer);
        $10da779a4259130a$var$adfStreamingProcessTimer = null;
    }
}
function $10da779a4259130a$var$getInputSlice(context) {
    const { editorView: editorView, positions: positions } = context;
    if (!positions || positions.length < 2) return undefined;
    const from = Number(positions[0]);
    const to = Number(positions[1]);
    if (!Number.isFinite(from) || !Number.isFinite(to)) return undefined;
    try {
        return editorView.state.doc.slice(from, to);
    } catch  {
        return undefined;
    }
}
function $10da779a4259130a$var$parsedHasExpectedKey(key, parsed) {
    if (typeof parsed !== 'object' || parsed === null || !(key in parsed)) return false;
    return true;
}
function $10da779a4259130a$var$sanitizeErrorContent(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return error.message;
    return `Unknown error: ${error === null ? 'null' : error?.toString()}`;
}
function $10da779a4259130a$var$handleRequestError(error, endpoint) {
    const isErrorUnknown = $10da779a4259130a$var$parsedHasExpectedKey('name', error) && error.name === 'AbortError' || $10da779a4259130a$var$parsedHasExpectedKey('cause', error) && error.cause === 'ConvoAIChannelCreationError';
    // This can be due to code crashes too, but falls back to network errors
    if (!isErrorUnknown) // eslint-disable-next-line no-console
    console.error('Editor AI: startStreamingResponse()', error);
    return {
        type: 'error',
        errorInfo: {
            apiName: (0, $klIiV.getAPIName)(endpoint),
            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL,
            statusCode: $10da779a4259130a$var$parsedHasExpectedKey('status', error) ? Number(error.status) : 9000,
            errorContent: $10da779a4259130a$var$sanitizeErrorContent(error)
        }
    };
}
// For non 200 status codes
// See details https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs#Error-codes
async function $10da779a4259130a$var$handleResponseNotOK({ requestOptions: requestOptions, cacheKey: cacheKey, response: response }) {
    if (response.status === 400) try {
        // Errors with special handling
        // We have soft alignment with the BE that for inputs that are not suitable
        // for prompts -- we want to rely on openai providing a suitable message for
        // the user. And not have manually maintained guards/user feedback messages.
        // https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3573548013/Introducing+AI+Dev+Documentation+TODO+AIFOLLOWUP+audit
        const knownErrors = [
            'INPUT_TOO_SHORT_TO_SUMMARIZE',
            'INPUT_TOO_SHORT_TO_PROCESS',
            'INPUT_EXCEEDS_TOKEN_LIMIT'
        ];
        const { error: error } = await response.json();
        if (error) {
            if (typeof error === 'object' && 'key' in error && knownErrors.includes(error.key)) {
                if (error.key === 'INPUT_EXCEEDS_TOKEN_LIMIT') return {
                    type: 'error',
                    errorInfo: {
                        apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
                        failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).TOKEN_LIMIT,
                        statusCode: response.status,
                        errorKey: error.key
                    }
                };
                if (error.key === 'INPUT_TOO_SHORT_TO_SUMMARIZE' || error.key === 'INPUT_TOO_SHORT_TO_PROCESS') return {
                    type: 'error',
                    errorInfo: {
                        apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
                        failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INPUT_TOO_SHORT,
                        statusCode: response.status,
                        errorKey: error.key
                    }
                };
            }
            return {
                type: 'error',
                errorInfo: {
                    apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
                    failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL,
                    statusCode: response.status,
                    errorContent: 'Unhandled error response received'
                }
            };
        }
    } catch (backendError) {
        return {
            type: 'error',
            errorInfo: {
                apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
                failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL,
                statusCode: response.status,
                errorContent: $10da779a4259130a$var$sanitizeErrorContent(backendError)
            }
        };
    }
    // The BE are unable to add the header due to constraints with the service proxy
    // There is a ticket to add this via feature request
    // https://hello.jira.atlassian.cloud/browse/SPSVC-28
    // For now we are just hard coding the value
    if (response.status === 429) {
        const retryAfter = response.headers.get('Retry-After') || '60';
        return {
            type: 'error',
            retryAfter: Number(retryAfter),
            errorInfo: {
                apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
                failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED,
                statusCode: response.status
            }
        };
    }
    // This status code is being used to indicate that the request was unable to be handled
    // due to the content not meeting the Acceptable Use Policy.
    if (response.status === 451) return {
        type: 'error',
        cacheKey: cacheKey,
        modelInput: {
            selection: requestOptions.selection,
            doc: requestOptions.doc
        },
        errorInfo: {
            apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION,
            statusCode: 451
        }
    };
    if (response.status === 9001) return {
        type: 'error',
        errorInfo: {
            apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).ELEVATE_DISABLED_GENERATE,
            statusCode: 9001
        }
    };
    return {
        type: 'error',
        errorInfo: {
            apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL,
            statusCode: response.status,
            errorContent: `unexpected response status: ${response.status}`
        }
    };
}
function $10da779a4259130a$var$handleNoResponseBody({ response: response, requestOptions: requestOptions }) {
    return {
        type: 'error',
        errorInfo: {
            apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL,
            statusCode: response.status,
            errorContent: 'response.body missing'
        }
    };
}
function $10da779a4259130a$var$handleLineNoGeneratedContent({ requestOptions: requestOptions, cacheKey: cacheKey, data: data }) {
    const { selection: selection, doc: doc } = requestOptions;
    if (data.error?.statusCode === 429) return {
        type: 'error',
        retryAfter: 60,
        errorInfo: {
            apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED,
            statusCode: 429
        }
    };
    if (data.error?.key === 'RESPONSE_TOO_SIMILAR') {
        const inputOutputDiffRatio = $10da779a4259130a$var$parsedHasExpectedKey('meta', data) && $10da779a4259130a$var$parsedHasExpectedKey('inputOutputDiffRatio', data.meta) ? data['meta']['inputOutputDiffRatio'] : '';
        return {
            type: 'response too similar',
            cacheKey: cacheKey,
            modelInput: {
                selection: selection,
                doc: doc
            },
            inputOutputDiffRatio: inputOutputDiffRatio
        };
    }
    return {
        type: 'error',
        errorInfo: {
            apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL,
            statusCode: data.error?.statusCode ?? 9002
        }
    };
}
function $10da779a4259130a$var$handleLineGeneratedContent({ streamContentProcessor: streamContentProcessor, partial: partial, data: data }) {
    partial.content += data['generatedContent'];
    if ($10da779a4259130a$var$parsedHasExpectedKey('meta', data) && $10da779a4259130a$var$parsedHasExpectedKey('inputOutputDiffRatio', data.meta)) partial.meta = {
        inputOutputDiffRatio: data['meta']['inputOutputDiffRatio'],
        loadingStatus: ''
    };
    return {
        type: 'stream',
        loadingStatus: partial.meta.loadingStatus,
        markdown: partial.content,
        ...streamContentProcessor?.(partial.content)
    };
}
function $10da779a4259130a$var$handleLineConvoAITrace({ partial: partial, data: data }) {
    const loadingStatus = $10da779a4259130a$var$parsedHasExpectedKey('message', data) && $10da779a4259130a$var$parsedHasExpectedKey('message_template', data.message) ? data.message.message_template : '';
    partial.meta = {
        inputOutputDiffRatio: '',
        loadingStatus: loadingStatus
    };
}
function $10da779a4259130a$var$handleLineConvoAIAnswerPart({ partial: partial, data: data, adfStreamer: adfStreamer }) {
    if (adfStreamer && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products')) {
        if ($10da779a4259130a$var$canProcessADFStreaming) {
            adfStreamer.processChunk(data.message.content);
            $10da779a4259130a$var$canProcessADFStreaming = false;
        } else adfStreamer.appendChunk(data.message.content);
        partial.adfResponse = adfStreamer.getLastDocWithoutLastLeafNode();
        // When adf streaming is enabled, don't need to keep the content in markdown
        partial.content = '';
        partial.meta = {
            inputOutputDiffRatio: '',
            loadingStatus: ''
        };
    } else {
        partial.content += data.message.content;
        partial.meta = {
            inputOutputDiffRatio: '',
            loadingStatus: ''
        };
    }
}
function $10da779a4259130a$var$processADFStreamingFinalResponse({ content: content, adfStreamer: adfStreamer, partial: partial, context: context }) {
    // Reset the adfStreamer to ensure it starts fresh for the final response to avoid any potential issues
    adfStreamer.reset();
    adfStreamer.setAnalyticsEventMetaData({
        isFinalResponse: true
    });
    const rawAdfResponse = adfStreamer.processChunk(content).getLastDoc();
    partial.adfResponse = partial.initialSelectionContext && (0, $dh538.fg)('platform_editor_ai_iw_capitalisation_fix') ? (0, $2f2616de49edd3d8$export$895f42d4e9947fc3)(rawAdfResponse, partial.initialSelectionContext) : rawAdfResponse;
    const inputSlice = $10da779a4259130a$var$getInputSlice(context);
    adfStreamer.setInputDocumentTree(inputSlice);
    // To fire analytics event for final response, need to end the streaming session
    adfStreamer.endStreamingSession({
        hasProcessedFinalResponse: true
    });
    // When adf streaming is enabled, don't need to keep the content in markdown
    partial.content = '';
}
function $10da779a4259130a$var$handleLineConvoAIFinalResponse({ requestOptions: requestOptions, cacheKey: cacheKey, data: data, partial: partial, adfStreamer: adfStreamer, context: context }) {
    const { message: message } = data;
    const { selection: selection, doc: doc } = requestOptions;
    const adfStreamingEnabled = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    function handleResponseTooSimilar(inputOutputDiffRatio) {
        if (adfStreamer && adfStreamingEnabled) $10da779a4259130a$var$processADFStreamingFinalResponse({
            content: message.content,
            adfStreamer: adfStreamer,
            partial: partial,
            context: context
        });
        return {
            type: 'response too similar',
            cacheKey: cacheKey,
            modelInput: {
                selection: selection,
                doc: doc
            },
            inputOutputDiffRatio: inputOutputDiffRatio,
            adfResponse: partial.adfResponse
        };
    }
    // if response too similar, early break/return
    if ($10da779a4259130a$var$parsedHasExpectedKey('message_metadata', message.message) && $10da779a4259130a$var$parsedHasExpectedKey('response_too_similar', message.message.message_metadata) && message.message.message_metadata.response_too_similar) return handleResponseTooSimilar(message.message?.message_metadata?.diff_ratio || '');
    else if ($10da779a4259130a$var$parsedHasExpectedKey('response_too_similar', data) && data.response_too_similar) // Convo AI has a different structure compared to the Assistance Service
    // If 'response_too_similar' is a direct property of 'data', it indicates a Convo AI response
    return handleResponseTooSimilar($10da779a4259130a$var$parsedHasExpectedKey('similarity_ratio', data) ? `${data.similarity_ratio}` : '');
    if ($10da779a4259130a$var$parsedHasExpectedKey('content', message)) {
        if (adfStreamer && adfStreamingEnabled) $10da779a4259130a$var$processADFStreamingFinalResponse({
            content: message.content,
            adfStreamer: adfStreamer,
            partial: partial,
            context: context
        });
        else // Handle New Convo AI response structure
        partial.content = message.content;
        if ($10da779a4259130a$var$parsedHasExpectedKey('actions', message) && Array.isArray(message.actions)) partial.rovoActions = message.actions || [];
        partial.meta = {
            inputOutputDiffRatio: $10da779a4259130a$var$parsedHasExpectedKey('similarity_ratio', data) ? `${data.similarity_ratio}` : '',
            loadingStatus: ''
        };
        return;
    }
    // Else handle Assistance Service response structure
    if (adfStreamer && adfStreamingEnabled) $10da779a4259130a$var$processADFStreamingFinalResponse({
        content: message.content,
        adfStreamer: adfStreamer,
        partial: partial,
        context: context
    });
    else partial.content = message.message.content;
    partial.rovoActions = message.message.actions || [];
    partial.meta = {
        inputOutputDiffRatio: message.message?.message_metadata?.diff_ratio || '',
        loadingStatus: ''
    };
}
function $10da779a4259130a$var$handleLineConvoAIError({ requestOptions: requestOptions, cacheKey: cacheKey, data: data }) {
    let statusCode;
    let guard = 'UNHANDLED_ERROR';
    let error;
    let retryAfter;
    if ($10da779a4259130a$var$parsedHasExpectedKey('message', data)) {
        // Get status code
        if ($10da779a4259130a$var$parsedHasExpectedKey('status_code', data.message) && typeof data.message.status_code === 'number') statusCode = data.message.status_code;
        // Get reason
        if ($10da779a4259130a$var$parsedHasExpectedKey('message_template', data.message)) guard = data.message.message_template;
        // Get error
        if ($10da779a4259130a$var$parsedHasExpectedKey('content', data.message)) error = data.message.content;
        // Get retryAfter
        if ($10da779a4259130a$var$parsedHasExpectedKey('headers', data) && $10da779a4259130a$var$parsedHasExpectedKey('Retry-After', data.headers)) retryAfter = Number(data.headers['Retry-After']);
    }
    let failureReason = (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL;
    if ([
        'RATE_LIMIT',
        'OPENAI_RATE_LIMIT_USER_ABUSE'
    ].includes(guard) && retryAfter) failureReason = (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED;
    else retryAfter = undefined;
    if (guard === 'HIPAA_CONTENT_DETECTED') failureReason = (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).HIPAA_CONTENT;
    if (guard === 'EXCEEDING_CONTEXT_LENGTH_ERROR') failureReason = (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).TOKEN_LIMIT;
    const apiName = (0, $klIiV.getAPIName)(requestOptions.endpoint);
    if (guard === 'ACCEPTABLE_USE_VIOLATIONS') return {
        type: 'error',
        cacheKey: cacheKey,
        modelInput: {
            selection: requestOptions.selection,
            doc: requestOptions.doc
        },
        errorInfo: {
            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION,
            statusCode: statusCode,
            errorKey: guard,
            apiName: apiName,
            errorContent: $10da779a4259130a$var$sanitizeErrorContent(error)
        }
    };
    if (retryAfter) return {
        type: 'error',
        retryAfter: retryAfter,
        errorInfo: {
            apiName: apiName,
            failureReason: failureReason,
            statusCode: statusCode,
            errorKey: guard,
            errorContent: $10da779a4259130a$var$sanitizeErrorContent(error)
        }
    };
    return {
        type: 'error',
        errorInfo: {
            apiName: apiName,
            failureReason: failureReason,
            statusCode: statusCode,
            errorKey: guard,
            errorContent: $10da779a4259130a$var$sanitizeErrorContent(error)
        }
    };
}
function $10da779a4259130a$var$handleLineConvoAI(props) {
    const { data: data, adfStreamer: adfStreamer, partial: partial } = props;
    if ($10da779a4259130a$var$parsedHasExpectedKey('type', data)) switch(data.type){
        case 'TRACE':
            $10da779a4259130a$var$handleLineConvoAITrace(props);
            break;
        case 'ANSWER_PART':
            $10da779a4259130a$var$handleLineConvoAIAnswerPart(props);
            break;
        case 'FINAL_RESPONSE':
            /**
				 * When final response is received, all chunks received so far are processed.
				 * So, we need to end the streaming session to fire analytics events.
				 *
				 * Final response has all chunks combined, so adfStreamer is reset before
				 * 	processing final response.
				 * After processing final response, we can end the streaming session with
				 * 	isFinalResponse set to true in analytics event meta data.
				 * And will call endStreamingSession() to fire analytics events.
				 */ $10da779a4259130a$var$stopADFStreamingProcessTimer();
            const inputSlice = $10da779a4259130a$var$getInputSlice(props.context);
            adfStreamer?.setInputDocumentTree(inputSlice);
            adfStreamer?.endStreamingSession();
            const error = $10da779a4259130a$var$handleLineConvoAIFinalResponse(props);
            if (error) return error;
            break;
        case 'ERROR':
            $10da779a4259130a$var$stopADFStreamingProcessTimer();
            return $10da779a4259130a$var$handleLineConvoAIError(props);
    }
    // If there are any unexpected loading responses, we should return the current data
    return adfStreamer && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? {
        type: 'stream',
        loadingStatus: partial.meta.loadingStatus,
        markdown: partial.content,
        adfResponse: partial.adfResponse
    } : {
        type: 'stream',
        loadingStatus: partial.meta.loadingStatus,
        markdown: partial.content
    };
}
function $10da779a4259130a$var$handleLine(props) {
    if ($10da779a4259130a$var$parsedHasExpectedKey('generatedContent', props.data)) return $10da779a4259130a$var$handleLineGeneratedContent(props);
    else if (props.requestOptions.isConvoAI) return $10da779a4259130a$var$handleLineConvoAI(props);
    else // if not expected response from the API the we have an error
    return {
        type: 'error',
        errorInfo: {
            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL,
            apiName: (0, $klIiV.getAPIName)(props.requestOptions.endpoint),
            statusCode: 9003
        }
    };
}
function $10da779a4259130a$var$handleLoaded({ requestOptions: requestOptions, cacheKey: cacheKey, selectionType: selectionType, streamContentProcessor: streamContentProcessor, isComplete: isComplete, partial: partial, schema: schema, isAdfPrompt: isAdfPrompt }) {
    const rovoActions = partial.rovoActions || [];
    let markdown;
    let adfResponse;
    if (isAdfPrompt && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products')) {
        markdown = (0, $8ec52e19962cb30c$export$76f60e834c48b8d9)(partial.adfResponse || {
            type: 'doc',
            version: 1,
            content: []
        }, schema);
        adfResponse = partial.adfResponse;
    } else markdown = partial.content;
    let processedResponse = {
        markdown: markdown
    };
    if (rovoActions.length > 0) {
        const idealSuggestion = selectionType === 'range' ? 'replace' : 'insert';
        const action = rovoActions.find((x)=>x.data.suggestion === idealSuggestion) ?? rovoActions[0];
        // There is a scenario where we are in selectionType === 'empty'
        // but AI returns replace. In this case, we override the replace
        // suggestion with insert.
        if (selectionType === 'empty' && action.data.suggestion === 'replace') // This should also update the value by reference in rovoActions
        action.data.suggestion = 'insert';
        else if (selectionType === 'range' && action.data.suggestion === 'insert') // This should also update the value by reference in rovoActions
        action.data.suggestion = 'replace';
        markdown += `\n\n---\n\n${action.data.content}`;
    } else if (streamContentProcessor) processedResponse = streamContentProcessor(partial.content);
    if (isComplete) {
        const isCompleted = isComplete();
        if (!isCompleted) return {
            type: 'stream',
            ...processedResponse,
            loadingStatus: partial.meta?.loadingStatus
        };
    }
    return {
        type: 'complete',
        ...processedResponse,
        ...adfResponse && {
            adfResponse: adfResponse
        },
        cacheKey: cacheKey,
        modelInput: {
            selection: requestOptions.selection,
            doc: requestOptions.doc
        },
        inputOutputDiffRatio: partial.meta?.inputOutputDiffRatio,
        rovoActions: rovoActions
    };
}
/**
 * Extracts initial selection context for capitalization correction
 */ function $10da779a4259130a$var$getInitialSelectionContext(context) {
    const doc = context.editorView.state.doc;
    const positionToTextIndex = (proseMirrorPos)=>{
        return doc.textBetween(0, Math.min(proseMirrorPos, doc.content.size), '\n', ' ').length;
    };
    const fullDocumentText = doc.textBetween(0, doc.content.size, '\n', ' ');
    const originalText = doc.textBetween(Math.max(0, context.positions[0]), Math.min(context.positions[1], doc.content.size), '\n', ' ');
    const selectionStart = positionToTextIndex(context.positions[0]);
    const selectionEnd = positionToTextIndex(context.positions[1]);
    return {
        fullDocumentText: fullDocumentText,
        originalText: originalText,
        selectionEnd: selectionEnd,
        selectionStart: selectionStart
    };
}
async function* $10da779a4259130a$var$streamingBody({ requestOptions: requestOptions, cacheKey: cacheKey, context: context, selectionType: selectionType, streamContentProcessor: streamContentProcessor, isComplete: isComplete, response: response, body: body, adfStreamer: adfStreamer, abortController: abortController }) {
    try {
        const reader = body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        const adfPrompt = context?.configItem?.adfPrompt && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
        const initialSelectionContext = adfPrompt && (0, $dh538.fg)('platform_editor_ai_iw_capitalisation_fix') ? $10da779a4259130a$var$getInitialSelectionContext(context) : undefined;
        const partial = {
            type: 'markdown',
            content: '',
            meta: {
                inputOutputDiffRatio: ''
            },
            rovoActions: [],
            initialSelectionContext: initialSelectionContext
        };
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            done = doneReading;
            const chunkValue = decoder.decode(value);
            buffer = buffer + chunkValue;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const line = lines.shift();
                let data;
                try {
                    data = JSON.parse(line);
                } catch (jsonError) {
                    // Handle invalid JSON - revert content and show error with retry option
                    return yield {
                        type: 'error',
                        errorInfo: {
                            apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
                            failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INVALID_JSON,
                            statusCode: response.status,
                            errorContent: `Received invalid json: ${jsonError instanceof Error ? jsonError.message : String(jsonError)}`
                        }
                    };
                }
                if (data.generatedContent === null) return yield $10da779a4259130a$var$handleLineNoGeneratedContent({
                    requestOptions: requestOptions,
                    cacheKey: cacheKey,
                    context: context,
                    streamContentProcessor: streamContentProcessor,
                    partial: partial,
                    data: data,
                    adfStreamer: adfStreamer,
                    selectionType: selectionType,
                    schema: context.editorView?.state?.schema,
                    isAdfPrompt: !!adfPrompt
                });
                yield $10da779a4259130a$var$handleLine({
                    requestOptions: requestOptions,
                    cacheKey: cacheKey,
                    context: context,
                    streamContentProcessor: streamContentProcessor,
                    partial: partial,
                    data: data,
                    adfStreamer: adfStreamer,
                    selectionType: selectionType,
                    schema: context.editorView?.state?.schema,
                    isAdfPrompt: !!adfPrompt
                });
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return yield $10da779a4259130a$var$handleLoaded({
            requestOptions: requestOptions,
            cacheKey: cacheKey,
            context: context,
            selectionType: selectionType,
            streamContentProcessor: streamContentProcessor,
            isComplete: isComplete,
            partial: partial,
            schema: context.editorView?.state?.schema,
            isAdfPrompt: !!adfPrompt
        });
    } catch (parsingError) {
        /**
		 * Retry Manager will abort request if there are ADF parsing is failing
		 * 	for specified duration and retry attempt has not reached max retries.
		 *
		 * It will abort previous request which will throw AbortError.
		 *
		 * isThisAutomaticRetry will be true if this is retry attempt.
		 */ if (!(abortController.signal.aborted && parsingError instanceof Error && parsingError.name === 'AbortError')) return yield {
            type: 'error',
            errorInfo: {
                apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
                failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL,
                statusCode: response.status,
                errorContent: $10da779a4259130a$var$sanitizeErrorContent(parsingError)
            }
        };
    }
}
function $10da779a4259130a$var$makeEndpoint({ endpoint: endpoint, channelId: channelId }) {
    let actualEndpoint = endpoint;
    // Using a stateful endpoint
    if (channelId) actualEndpoint = `${endpoint}/${channelId}/message/stream`;
    return actualEndpoint;
}
function $10da779a4259130a$var$makeHeaders({ product: product, experienceId: experienceId }) {
    return {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Experience-Id': experienceId,
        ...(0, $56d53639f779f5c2$export$b3f5e033c954a1b0)(experienceId),
        ...(0, $56d53639f779f5c2$export$46d5228a079b1d3)(product)
    };
}
async function $10da779a4259130a$export$209cb5bffda2d239(options) {
    const { abortController: abortController, cacheKey: cacheKey, selectionType: selectionType, product: product, getFetchCustomHeaders: getFetchCustomHeaders, channelId: channelId, callback: callback, streamFlowPacer: streamFlowPacer, streamContentProcessor: streamContentProcessor, isComplete: isComplete, requestOptions: requestOptions, context: context, fireAIAnalyticsEvent: fireAIAnalyticsEvent, aiInteractionID: aiInteractionID } = options;
    if ('response' in requestOptions) {
        callback(requestOptions.response);
        return;
    }
    if ('error' in requestOptions) {
        // eslint-disable-next-line no-console
        console.error('Editor AI: startStreamingResponse()', requestOptions.error);
        callback({
            type: 'error',
            errorInfo: {
                apiName: (0, $klIiV.getAPIName)(requestOptions.endpoint),
                failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL,
                statusCode: 400,
                errorContent: requestOptions.error
            }
        });
        return;
    }
    const { experienceId: experienceId, endpoint: endpoint, payload: payload } = requestOptions;
    // After early return checks above, requestOptions must be the payload-containing variant
    const typedRequestOptions = requestOptions;
    let streamCallback = callback;
    let adfStreamingRetryManager = null;
    function createNewADFStreamer() {
        return (0, $2366813efecaf494$export$313ea9e31b82ddc)({
            state: context.editorView.state,
            /*
			 * Remove use of null coalescing operator when last
			 *  experiment for adf streaming is removed.
			 */ fireAIAnalyticsEvent: fireAIAnalyticsEvent ?? (()=>{}),
            experienceName: context.configItem.key,
            featureId: context.configItem.featureId,
            aiSessionId: context.analyticsContext.aiSessionId,
            aiInteractionID: aiInteractionID,
            selectionType: selectionType,
            contentStatistics: typedRequestOptions.contentStatistics,
            selectionCategory: (0, $d465bdc6207b3d88$export$385434a4b24ab280)(context.editorView, context.positions),
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            streamId: (0, $dQl1W.v4)(),
            retryAttemptNumber: adfStreamingRetryManager?.getRetryCount() ?? 0,
            traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? context.traceIds?.[0] ?? undefined : undefined
        });
    }
    const isAdfPrompt = context?.configItem?.adfPrompt && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    let adfStreamer = isAdfPrompt ? createNewADFStreamer() : undefined;
    async function fetcher(abortController, retryManager) {
        try {
            if (streamFlowPacer && (isAdfPrompt || context.aiProvider.isInDocumentStreamingEnabled)) {
                // when we retry after an error, we need to reset
                streamFlowPacer.reset();
                streamFlowPacer.setEmit(callback);
                /**
				 * If AIFC is disabled, then AI response will be shown in LoadingScreen.
				 * GPT models returns very very small chunks (often times 2-3 chars).
				 * This causes too many re-renders of Renderer component in LoadingScreen,
				 * 	which affects performance.
				 *
				 * So using streamFlowPacer to throttle the stream and process chunks in batches.
				 * Currently, it re-render LoadingScreen 4 times per second.
				 */ if (isAdfPrompt && !context.aiProvider.isInDocumentStreamingEnabled) {
                    streamFlowPacer.setTickMs($10da779a4259130a$var$ADF_STREAMING_PROCESS_INTERVAL);
                    streamFlowPacer.setCharsPerTick($10da779a4259130a$var$ADF_STREAMING_PROCESS_INITIAL_CHARS_PER_TICK);
                    streamFlowPacer.setMaxCharsPerTick($10da779a4259130a$var$ADF_STREAMING_PROCESS_MAX_CHARS_PER_TICK);
                }
                streamFlowPacer.start();
                streamCallback = streamFlowPacer.push;
            }
            if (isAdfPrompt) $10da779a4259130a$var$startADFStreamingProcessTimer();
            const actualEndpoint = $10da779a4259130a$var$makeEndpoint({
                endpoint: endpoint,
                channelId: channelId
            });
            const fetchInit = {
                method: 'POST',
                headers: $10da779a4259130a$var$makeHeaders({
                    product: product,
                    experienceId: experienceId
                }),
                body: payload,
                credentials: 'include',
                signal: abortController.signal,
                mode: 'cors'
            };
            const fetchCustomHeaders = getFetchCustomHeaders?.(endpoint, fetchInit) || {};
            const response = await fetch(actualEndpoint, {
                ...fetchInit,
                headers: {
                    ...fetchInit.headers,
                    ...fetchCustomHeaders
                }
            });
            const traceId = response.headers.get('X-Trace-Id') || response.headers.get('Atl-Traceid');
            if (traceId) callback({
                type: 'update traceIds',
                context: {
                    traceIds: [
                        traceId
                    ]
                }
            });
            if (!response.ok) return callback(await $10da779a4259130a$var$handleResponseNotOK({
                requestOptions: typedRequestOptions,
                cacheKey: cacheKey,
                response: response
            }));
            if (!response.body) {
                callback($10da779a4259130a$var$handleNoResponseBody({
                    requestOptions: typedRequestOptions,
                    response: response
                }));
                return;
            }
            if (context?.configItem?.handleFetchResponse) {
                const data = await response.json();
                context.configItem.handleFetchResponse(data, requestOptions, callback, cacheKey);
                return;
            }
            const streaming = $10da779a4259130a$var$streamingBody({
                requestOptions: typedRequestOptions,
                cacheKey: cacheKey,
                selectionType: selectionType,
                streamContentProcessor: streamContentProcessor,
                isComplete: isComplete,
                response: response,
                body: response.body,
                context: context,
                adfStreamer: adfStreamer,
                abortController: abortController
            });
            for await (const item of streaming){
                streamCallback(item);
                // If we have a response other than stream (which means there is an error), we should stop the streaming
                if (item.type !== 'stream') {
                    /**
					 * When streaming ends, check if ADFStreamer is in error state.
					 * Retry if possible if in error state.
					 */ if (retryManager) {
                        if (adfStreamer?.isInErrorState()) {
                            if (retryManager.hasMaxRetryReached()) callback({
                                type: 'error',
                                errorInfo: {
                                    apiName: (0, $klIiV.getAPIName)(endpoint),
                                    failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).ADF_STREAMING_ERROR
                                }
                            });
                            else retryManager.retryOnStreamingEnd();
                        } else retryManager.reset();
                    }
                    return;
                }
            }
        } catch (error) {
            adfStreamingRetryManager?.reset();
            $10da779a4259130a$var$stopADFStreamingProcessTimer();
            streamCallback($10da779a4259130a$var$handleRequestError(error, endpoint));
        }
    }
    /**
	 * When AIFC is enabled, it will stream directly into document.
	 * Currently, automatic retry will only happen when in document streaming is disabled.
	 */ if (isAdfPrompt && !context.aiProvider.isInDocumentStreamingEnabled) {
        adfStreamingRetryManager = new (0, $e04ad68663ab9071$export$f748a1b030d3429f)({
            maxRetries: $10da779a4259130a$var$ADF_STREAMING_RETRY_MAX_RETRIES,
            delayMs: $10da779a4259130a$var$ADF_STREAMING_RETRY_DELAY_MS,
            beforeRetryCallback: ()=>{
                callback({
                    type: 'retry on adf stream errors',
                    adfResponse: (0, $b4emg.getEmptyADF)()
                });
                adfStreamer?.endStreamingSession();
                adfStreamer?.reset();
                adfStreamer = createNewADFStreamer();
            },
            fetcher: fetcher,
            errorChecker: ()=>{
                return adfStreamer?.isInErrorState() ?? false;
            }
        });
        adfStreamingRetryManager?.startFetchingWithRetry();
    } else await fetcher(abortController);
}


/**
 * Vary prompt request triggered - if latest response exists, we are interrogating,
 * and do not want to use the original config item (i.e. may possibly be summarise/transform)
 *
 * If it is a generate with tag, the response will be captured within
 * the latest "latest response, prompt", flow.
 *
 * REVISIT THIS: analytics is based on the config item, however
 * interrogation analytics uses base generate instead to complete;
 */ function $03deff61eb2c4e8b$var$getConfigItem({ context: context }) {
    return context.configItem.withContextMutation?.(context.configItem, context) ?? context.configItem;
}
/**
 * Get mention map for the current document
 * We can no longer use the node attrs to get the mention name
 * So we now need to get all the mentions and create a mapping that can be used by the
 * markdown serializer
 */ async function $03deff61eb2c4e8b$var$_getMentionMap({ context: context }) {
    let mentionMap = {};
    if (context.getMentionNameDetails) mentionMap = await (0, $087baae06cf8cdc5$export$922d75f514df28b7)({
        node: context.editorView.state.doc,
        getMentionNameDetails: context.getMentionNameDetails
    });
    return mentionMap;
}
function $03deff61eb2c4e8b$var$hitCache({ context: context, cacheKey: cacheKey }) {
    const { entries: entries } = context.responseHistory;
    const lastHistoryItem = entries[entries.length - 1];
    return lastHistoryItem && cacheKey === lastHistoryItem.cacheKey && context.promptTrigger !== 'interrogate';
}
function $03deff61eb2c4e8b$export$ad256dcfbe275ed5({ fireAIAnalyticsEvent: fireAIAnalyticsEvent, aiInteractionID: aiInteractionID, streamFlowPacer: streamFlowPacer }) {
    return async function streamingHandler(context, callback) {
        const abortController = new AbortController();
        const { userInput: userInput, configItem: { agent: agent } } = context;
        const configItem = $03deff61eb2c4e8b$var$getConfigItem({
            context: context
        });
        const mentionMap = await $03deff61eb2c4e8b$var$_getMentionMap({
            context: context
        });
        const requestOptions = (0, $658af4922a7dab16$export$65964063bcedf059)({
            callback: callback,
            context: context,
            configItem: configItem,
            mentionMap: mentionMap
        });
        const cacheKey = JSON.stringify({
            userInput: userInput,
            agent: agent,
            requestOptions: requestOptions
        });
        if ($03deff61eb2c4e8b$var$hitCache({
            context: context,
            cacheKey: cacheKey
        })) {
            callback({
                type: 'same cache key'
            });
            return;
        }
        const getFetchCustomHeaders = configItem.getCustomHeaders ? configItem.getCustomHeaders : context.aiProvider.getFetchCustomHeaders;
        await (0, $10da779a4259130a$export$209cb5bffda2d239)({
            abortController: abortController,
            cacheKey: cacheKey,
            selectionType: context.selectionType,
            product: context.aiProvider.product,
            getFetchCustomHeaders: getFetchCustomHeaders,
            channelId: context.channelId,
            callback: callback,
            requestOptions: requestOptions,
            context: context,
            fireAIAnalyticsEvent: fireAIAnalyticsEvent,
            aiInteractionID: aiInteractionID,
            streamFlowPacer: streamFlowPacer
        });
        // Cleanup function
        return ()=>{
            abortController.abort();
        };
    };
}




const $1796eb624ddc2d9b$var$handleFallbackSuggestedTitle = (streamingCallback, api, analyticSourceId, fallbackSuggestedTitle, isDateTimeFormat)=>{
    streamingCallback({
        type: 'complete',
        result: fallbackSuggestedTitle
    });
    (0, $a87d8904564d2f13$export$268e0492b4645ae4)({
        api: api,
        analyticSourceId: analyticSourceId,
        isDateTimeFormat: isDateTimeFormat
    });
};
const $1796eb624ddc2d9b$export$20a4431e680ea8af = ({ getIntl: getIntl, editorPluginAIProvider: editorPluginAIProvider, currentEditorView: currentEditorView, configItem: configItem, streamingCallback: streamingCallback, api: api, analyticSourceId: analyticSourceId })=>{
    const intl = getIntl();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const uid = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
    const context = {
        aiProvider: editorPluginAIProvider,
        editorView: currentEditorView,
        configItem: configItem,
        intl: intl,
        positions: [
            0,
            0
        ],
        isEmpty: true,
        selectionType: 'empty',
        usePageKnowledge: true,
        analyticsContext: {
            aiSessionId: uid,
            aiGroupId: uid
        },
        responseHistory: {
            positionFromEnd: 0,
            entries: [],
            totalSize: 0,
            traversals: 0
        }
    };
    streamingCallback({
        type: 'initialising'
    });
    // For proactive title generation project: We carve out a specific scenario when to
    // return a 'fallback title' if no context will be sent with the suggest a title prompt
    // (which would otherwise generate training data gibberish)
    if ((0, $eabfb7a856f4f7ef$export$8aaa839b34c07044)(configItem, currentEditorView)) {
        let fallbackSuggestedTitle = intl.formatMessage((0, $7ShCl.aiMessages).eventHubfallbackSuggestedTitle);
        let isDateTimeFormat;
        if ((0, $dh538.fg)('platform_editor_ai_date_time_format_title_fallback')) {
            isDateTimeFormat = true;
            const fallbackTitleMessage = intl.formatMessage((0, $7ShCl.aiMessages).eventHubfallbackSuggestedTitlePrefix);
            const now = new Date();
            const dateTimeString = (0, $dWCFT.default)(now, 'yyyy-MM-dd HH:mm');
            fallbackSuggestedTitle = `${fallbackTitleMessage} ${dateTimeString}`;
        }
        $1796eb624ddc2d9b$var$handleFallbackSuggestedTitle(streamingCallback, api, analyticSourceId, fallbackSuggestedTitle, isDateTimeFormat);
        return;
    }
    const callbackHandler = (0, $03deff61eb2c4e8b$export$ad256dcfbe275ed5)({
        fireAIAnalyticsEvent: ()=>{},
        streamFlowPacer: null
    });
    callbackHandler(context, (streamData)=>{
        if (streamData) // @ts-ignore callbackHandler's type expectation is too wide, need to narrow down
        switch(streamData.type){
            case 'stream':
                if (streamData.loadingStatus === 'ANALYSING_QUERY') streamingCallback({
                    type: 'analysingQuery'
                });
                else streamingCallback({
                    type: 'streaming',
                    result: streamData.markdown
                });
                break;
            case 'complete':
                streamingCallback({
                    type: 'complete',
                    result: streamData.markdown
                });
                if ((0, $a87d8904564d2f13$export$8e68345bacf55b30)(configItem)) (0, $a87d8904564d2f13$export$544cb5cc4b426cad)({
                    api: api,
                    analyticSourceId: analyticSourceId,
                    suggestedTitle: streamData.markdown
                });
                break;
            case 'error':
                streamingCallback({
                    type: streamData.type,
                    errorInfo: streamData.errorInfo
                });
                break;
            case 'response too similar':
                streamingCallback({
                    type: streamData.type
                });
                break;
            default:
                break;
        }
    });
};


const $bd3d20f153868f6f$export$c83eff15443f700 = (options)=>{
    const { aiGlobalOptIn: aiGlobalOptIn } = options;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $898294d85774604e$export$e54fe7f659b58e64),
        view: (editorView)=>{
            let currentEditorView = editorView;
            const { unsubscribe: unsubscribe } = (0, $jOIil.eventHub).subscribe({
                event: 'start prompt',
                callback: (data)=>{
                    const editorId = (0, $2e7rb.findEditorIdFromView)(currentEditorView);
                    if (editorId === data.targetEditorId) {
                        const { state: state, dispatch: dispatch } = currentEditorView;
                        let payloadData;
                        if (data.prompt === (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).IssueReformatter) payloadData = data.additionalPayloadDataIssueReformatter;
                        else if (data.prompt === (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).DraftReplyPill && (0, $dh538.fg)('draft_reply_contextual_pills_gate')) payloadData = data.additionalPayloadData;
                        else if (data.prompt === (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).DescriptionCompleter) payloadData = data.additionalPayloadData;
                        else if (data.prompt === (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).IncidentSmartComments) payloadData = data.additionalPayloadData;
                        const configItem = (0, $eabfb7a856f4f7ef$export$bd5d7e8cfaa78c6f)(data.prompt, options.editorPluginAIProvider, data.adjustSelection, payloadData);
                        if (!configItem) {
                            (0, $a87d8904564d2f13$export$3ddc9d41f6af5056)({
                                dispatch: dispatch,
                                editorView: currentEditorView,
                                prompt: data.prompt,
                                promptText: data.prompt === (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).CustomPrompt ? data.promptText : undefined,
                                adjustSelection: data.adjustSelection
                            });
                            return;
                        }
                        const params = {
                            state: state,
                            configItem: configItem,
                            lastTriggeredFrom: data.analyticSourceId,
                            aiGlobalOptIn: aiGlobalOptIn,
                            adjustSelection: data.adjustSelection,
                            initialPrompt: data.prompt === (0, $9c92f80e4cca6045$export$4cefcfab1f987be5).CustomPrompt ? data.promptText : undefined,
                            locale: options.getIntl().locale
                        };
                        if (data.hideModal) (0, $1796eb624ddc2d9b$export$20a4431e680ea8af)({
                            getIntl: options.getIntl,
                            currentEditorView: currentEditorView,
                            editorPluginAIProvider: options.editorPluginAIProvider,
                            configItem: configItem,
                            streamingCallback: data.streamingCallback,
                            api: options.api,
                            analyticSourceId: data.analyticSourceId
                        });
                        else {
                            const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)(params);
                            openAIModalCommand(state, dispatch);
                        }
                    }
                }
            });
            return {
                update: (newEditorView)=>{
                    currentEditorView = newEditorView;
                },
                destroy: ()=>{
                    unsubscribe();
                }
            };
        }
    });
};



var $5qzNs = parcelRequire("5qzNs");














var $ilIeg = parcelRequire("ilIeg");


var $6gJll = parcelRequire("6gJll");





var $3yUTv = parcelRequire("3yUTv");




const $4aaaca4c5ac35fca$export$ade9b71e7e80f74e = new (0, $ks2lK.PluginKey)('aiMonitorWatchmen');





const $5cf9c79654e9fa24$export$67337c564456c5bb = (payload, delayedAt)=>{
    return {
        action: 'delayedAction',
        actionSubject: 'aiDelayedResult',
        actionSubjectId: 'editorPluginAI',
        eventType: 'track',
        attributes: {
            aiExperienceName: payload.attributes?.aiExperienceName,
            aiGroupId: payload.action === (0, $d925B.ACTION).ACTIONED ? payload.attributes?.aiGroupId : undefined,
            traceIds: payload.attributes?.traceIds,
            delayedAtMs: delayedAt
        }
    };
};



var $aXG5V = parcelRequire("aXG5V");

const $bc20842f08ebabaa$export$4876cc3130d3f820 = (ranges)=>{
    if (!ranges.length) return ranges;
    const sorted = [
        ...ranges
    ].sort((a, b)=>a.from - b.from);
    const out = [];
    let cur = {
        ...sorted[0]
    };
    for(let i = 1; i < sorted.length; i++){
        const r = sorted[i];
        if (r.from <= cur.to) cur.to = Math.max(cur.to, r.to);
        else {
            out.push(cur);
            cur = {
                ...r
            };
        }
    }
    out.push(cur);
    return out;
};
const $bc20842f08ebabaa$var$TEXT_BETWEEN_BLOCK = ' ';
const $bc20842f08ebabaa$var$TEXT_BETWEEN_LEAF = ' ';
const $bc20842f08ebabaa$export$8a4da2d583115a0d = (doc, from, to)=>{
    return doc.textBetween(from, to, $bc20842f08ebabaa$var$TEXT_BETWEEN_BLOCK, $bc20842f08ebabaa$var$TEXT_BETWEEN_LEAF);
};
const $bc20842f08ebabaa$var$wordSegmenter = typeof Intl !== 'undefined' && Intl.Segmenter ? new Intl.Segmenter(undefined, {
    granularity: 'word'
}) : null;
const $bc20842f08ebabaa$export$5e9f9da5213092bc = (text)=>{
    const t = text.trim();
    if (!t) return 0;
    try {
        if ($bc20842f08ebabaa$var$wordSegmenter) {
            let c = 0;
            for (const { isWordLike: isWordLike } of $bc20842f08ebabaa$var$wordSegmenter.segment(t))if (isWordLike) c++;
            return c;
        }
    } catch  {}
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return t.split(/\s+/u).filter(Boolean).length;
};
const $bc20842f08ebabaa$export$eed38d084e27127a = (doc, ranges)=>{
    let chars = 0;
    let words = 0;
    for (const r of ranges){
        const s = $bc20842f08ebabaa$export$8a4da2d583115a0d(doc, r.from, r.to);
        chars += s.length;
        words += $bc20842f08ebabaa$export$5e9f9da5213092bc(s);
    }
    return {
        chars: chars,
        words: words
    };
};
const $bc20842f08ebabaa$export$5185129806b81f0a = (maps)=>{
    const out = [];
    for (const m of maps)m.forEach((oldStart, oldEnd, newStart, newEnd)=>{
        if (oldStart !== oldEnd || newStart !== newEnd) out.push({
            oldStart: oldStart,
            oldEnd: oldEnd,
            newStart: newStart,
            newEnd: newEnd
        });
    });
    return out;
};
const $bc20842f08ebabaa$export$97c088e92f2198d4 = (maps, sessionRanges)=>{
    if (!sessionRanges.length) return false;
    const key = (a, b, c, d)=>`${a}:${b}:${c}:${d}`;
    const need = new Set(sessionRanges.map((r)=>key(r.newStart, r.newEnd, r.oldStart, r.oldEnd)));
    for (const m of maps)m.forEach((os, oe, ns, ne)=>need.delete(key(os, oe, ns, ne)));
    return need.size === 0;
};
const $bc20842f08ebabaa$export$476c745650a7176c = (maps, undoneRanges)=>{
    if (!undoneRanges.length) return false;
    // A redo is the inverse of an undo, so we check if the transaction
    // restores the exact content that was undone
    const key = (a, b, c, d)=>`${a}:${b}:${c}:${d}`;
    const need = new Set(undoneRanges.map((r)=>key(r.oldStart, r.oldEnd, r.newStart, r.newEnd)));
    for (const m of maps)m.forEach((os, oe, ns, ne)=>need.delete(key(os, oe, ns, ne)));
    return need.size === 0;
};
const $bc20842f08ebabaa$export$e852621173d4215b = (steps, stepMaps, baselineDoc, sessionRangesAfterAI)=>{
    let localDoc = baselineDoc;
    let currentRanges = sessionRangesAfterAI.map((r)=>({
            ...r
        }));
    let deletedChars = 0;
    let deletedWords = 0;
    const touchedIdx = new Set();
    for(let i = 0; i < steps.length; i++){
        const step = steps[i];
        let delFrom = null;
        let delTo = null;
        if (step instanceof (0, $aXG5V.ReplaceStep)) {
            if (typeof step.from === 'number' && typeof step.to === 'number' && step.from < step.to) {
                delFrom = step.from;
                delTo = step.to;
            }
        } else if (step instanceof (0, $aXG5V.ReplaceAroundStep)) {
            const ra = step;
            const deletedSpans = [
                {
                    from: ra.from,
                    to: ra.gapFrom
                },
                {
                    from: ra.gapTo,
                    to: ra.to
                }
            ].filter((s)=>s.from < s.to);
            for (const span of deletedSpans)for(let idx = 0; idx < currentRanges.length; idx++){
                const r = currentRanges[idx];
                const start = Math.max(r.from, span.from);
                const end = Math.min(r.to, span.to);
                if (start < end) {
                    touchedIdx.add(idx);
                    const removed = $bc20842f08ebabaa$export$8a4da2d583115a0d(localDoc, start, end);
                    deletedChars += removed.length;
                    deletedWords += $bc20842f08ebabaa$export$5e9f9da5213092bc(removed);
                }
            }
        }
        if (delFrom != null && delTo != null) for(let idx = 0; idx < currentRanges.length; idx++){
            const r = currentRanges[idx];
            const start = Math.max(r.from, delFrom);
            const end = Math.min(r.to, delTo);
            if (start < end) {
                touchedIdx.add(idx);
                const removed = $bc20842f08ebabaa$export$8a4da2d583115a0d(localDoc, start, end);
                deletedChars += removed.length;
                deletedWords += $bc20842f08ebabaa$export$5e9f9da5213092bc(removed);
            }
        }
        const result = step.apply(localDoc);
        if (result.doc) localDoc = result.doc;
        const map = stepMaps[i];
        if (map) currentRanges = currentRanges.map(({ from: from, to: to })=>({
                from: map.map(from, -1),
                to: map.map(to, 1)
            }));
    }
    return {
        deletedChars: deletedChars,
        deletedWords: deletedWords,
        touched: touchedIdx.size
    };
};
const $bc20842f08ebabaa$export$bfa42147068ddd92 = (state, s, type, counts = {})=>{
    const now = performance.now();
    const { removedChars: removedChars, removedWords: removedWords, touched: touched } = counts;
    return {
        ...state,
        currentSession: null,
        pendingAnalytics: {
            aiSessionId: s.id,
            nextActionType: type,
            aiOutputChars: s.aiOutputChars,
            aiOutputWords: s.aiOutputWords,
            nextActionRemovedAiChars: removedChars,
            nextActionRemovedAiWords: removedWords,
            nextActionTouchedAiRanges: touched,
            nextActionLatencyMs: Math.round(Math.max(0, now - s.startedAt)),
            aiGroupId: s.aiGroupId,
            experienceName: s.experienceName
        }
    };
};
const $bc20842f08ebabaa$export$f5fff894cf1d5ab = (maps, aiRanges)=>{
    const changed = $bc20842f08ebabaa$export$5185129806b81f0a(maps);
    for(let i = 0; i < changed.length; i++){
        const c = changed[i];
        for(let j = 0; j < aiRanges.length; j++){
            const r = aiRanges[j];
            if (c.oldEnd > r.from && c.oldStart < r.to) return true;
        }
    }
    return false;
};


const $290ed39dc9fde36a$var$META_FLUSH_ANALYTICS = 'AIMonitorWatchmenFlushAnalytics';
const $290ed39dc9fde36a$var$META_DEFERRED_ANALYTICS = 'AIMonitorWatchmenDeferredAnalytics';
const $290ed39dc9fde36a$export$249b63272434dfc7 = 'AIMonitorWatchmenCommonAttributes';
const $290ed39dc9fde36a$var$initialState = {
    currentSession: null,
    pendingAnalytics: null,
    lastUndoneSession: null,
    deferredAnalytics: {
        deferred: {},
        sessionState: 'notStarted'
    },
    commonAttributes: {}
};
const $290ed39dc9fde36a$export$d5f2dba636afec41 = (api, autoApplyAIChangesEnabled)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $4aaaca4c5ac35fca$export$ade9b71e7e80f74e),
        state: {
            init: ()=>$290ed39dc9fde36a$var$initialState,
            apply: (tr, pluginState, _old, newState)=>{
                let sessionStarted = false;
                const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(newState);
                if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                    sessionStarted = decorationPluginState?.sessionStarted ?? false;
                    const { deferredAnalytics: deferredAnalytics } = pluginState;
                    if (sessionStarted && deferredAnalytics.sessionState !== 'inProgress') return {
                        ...pluginState,
                        deferredAnalytics: {
                            ...deferredAnalytics,
                            sessionState: 'inProgress'
                        }
                    };
                    const sessionEnded = decorationPluginState?.sessionEnded ?? false;
                    if (sessionEnded && deferredAnalytics.sessionState === 'inProgress') return {
                        ...pluginState,
                        deferredAnalytics: {
                            ...deferredAnalytics,
                            sessionState: 'justEnded'
                        }
                    };
                    const deferredAnalyticsFromMeta = tr.getMeta($290ed39dc9fde36a$var$META_DEFERRED_ANALYTICS);
                    if (deferredAnalyticsFromMeta) return {
                        ...pluginState,
                        deferredAnalytics: deferredAnalyticsFromMeta
                    };
                    const updatedCommonAttributes = tr.getMeta($290ed39dc9fde36a$export$249b63272434dfc7);
                    if (updatedCommonAttributes) return {
                        ...pluginState,
                        commonAttributes: updatedCommonAttributes
                    };
                }
                if (tr.getMeta($290ed39dc9fde36a$var$META_FLUSH_ANALYTICS)) return {
                    ...pluginState,
                    pendingAnalytics: null
                };
                const isCollab = Boolean(tr.getMeta('isRemote'));
                const isFinalAI = Boolean(tr.getMeta('isAIFinalStreamingTransformation'));
                const appendedTr = tr.getMeta('appendedTransaction');
                const isIntermediateAI = Boolean(tr.getMeta('isAIStreamingTransformation') || appendedTr && appendedTr.getMeta('isAIStreamingTransformation') && !isFinalAI);
                let invokedFrom;
                let experienceName;
                if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                    const aiDecorationExperiencePluginState = api?.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState;
                    const configItemKey = aiDecorationExperiencePluginState?.configItem?.key || '';
                    invokedFrom = aiDecorationExperiencePluginState?.lastTriggeredFrom;
                    experienceName = (0, $6gJll.convertExperienceName)(configItemKey, invokedFrom);
                }
                // ignore txns that don’t change the doc
                if (!tr.docChanged || tr.getMeta('metricsPlugin$')) return pluginState;
                // start a new analytic session when a stream finalizes
                if (isFinalAI) {
                    const changed = (0, $bc20842f08ebabaa$export$5185129806b81f0a)(tr.mapping.maps);
                    const mergedNewRanges = (0, $bc20842f08ebabaa$export$4876cc3130d3f820)(changed.map((r)=>({
                            from: r.newStart,
                            to: r.newEnd
                        })).filter((r)=>r.from < r.to));
                    const { chars: chars, words: words } = (0, $bc20842f08ebabaa$export$eed38d084e27127a)(newState.doc, mergedNewRanges);
                    const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(newState);
                    const session = {
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                        startedAt: Math.round(performance.now()),
                        ranges: changed,
                        mergedNewRanges: mergedNewRanges,
                        baselineDoc: newState.doc,
                        aiOutputChars: chars,
                        aiOutputWords: words,
                        awaitingNextAction: true,
                        aiGroupId: decorationPluginState?.nextSessionId,
                        experienceName: experienceName
                    };
                    let updatedDeferredAnalytics = pluginState.deferredAnalytics;
                    if (autoApplyAIChangesEnabled() && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                        /**
             * If traceId is present in decoration plugin state, use it, otherwise use traceIds from common attributes.
             * Currently, traceId is set in decoration plugin state only for freegen.
             * For other prompts, it should be in common attributes.
             */ const traceIds = decorationPluginState?.traceId ? [
                            decorationPluginState.traceId
                        ] : pluginState.commonAttributes.traceIds;
                        const actionedPayload = (0, $ilIeg.createUnifiedAnalyticsPayload)({
                            ...pluginState.commonAttributes,
                            action: (0, $d925B.ACTION).ACTIONED,
                            attributes: {
                                aiResultAction: 'accepted',
                                aiActionedType: 'automaticallyInserted'
                            },
                            interactionID: session.id,
                            experienceName: experienceName,
                            invokedFrom: invokedFrom,
                            aiGroupId: decorationPluginState?.nextSessionId,
                            isPayloadCreate: decorationPluginState?.isCreate,
                            ...(0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') && {
                                traceIds: traceIds
                            }
                        });
                        updatedDeferredAnalytics = {
                            ...pluginState.deferredAnalytics,
                            toDefer: {
                                aiSessionId: session.id,
                                payload: actionedPayload,
                                waitForSessionEnd: pluginState.deferredAnalytics.sessionState === 'inProgress'
                            }
                        };
                    }
                    return {
                        ...pluginState,
                        currentSession: session,
                        pendingAnalytics: null,
                        deferredAnalytics: updatedDeferredAnalytics
                    };
                }
                // observe and classify the very next local user action
                if (pluginState.currentSession && pluginState.currentSession.awaitingNextAction && !isCollab && tr.docChanged) {
                    const s = pluginState.currentSession;
                    const isRegen = isIntermediateAI;
                    if (isRegen) return (0, $bc20842f08ebabaa$export$bfa42147068ddd92)(pluginState, s, 'regen');
                    const isUndo = (0, $bc20842f08ebabaa$export$97c088e92f2198d4)(tr.mapping.maps, s.ranges);
                    if (isUndo) {
                        // Store the undone session for potential redo detection
                        const undoneSession = {
                            aiSessionId: s.id,
                            undoneRanges: s.ranges,
                            aiOutputChars: s.aiOutputChars,
                            aiOutputWords: s.aiOutputWords,
                            aiGroupId: s.aiGroupId,
                            experienceName: s.experienceName,
                            undoneAt: Math.round(performance.now())
                        };
                        let updatedDeferredAnalytics = pluginState.deferredAnalytics;
                        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) updatedDeferredAnalytics = {
                            ...pluginState.deferredAnalytics,
                            toCancel: s.id
                        };
                        return {
                            ...(0, $bc20842f08ebabaa$export$bfa42147068ddd92)(pluginState, s, 'undo', {
                                removedChars: s.aiOutputChars,
                                removedWords: s.aiOutputWords,
                                touched: s.mergedNewRanges.length
                            }),
                            deferredAnalytics: updatedDeferredAnalytics,
                            lastUndoneSession: undoneSession
                        };
                    }
                    if (!(0, $bc20842f08ebabaa$export$f5fff894cf1d5ab)(tr.mapping.maps, s.mergedNewRanges)) return (0, $bc20842f08ebabaa$export$bfa42147068ddd92)(pluginState, s, 'other');
                    const { deletedChars: deletedChars, deletedWords: deletedWords, touched: touched } = (0, $bc20842f08ebabaa$export$e852621173d4215b)(tr.steps, tr.mapping.maps, s.baselineDoc, s.mergedNewRanges);
                    const isDelete = deletedChars > 0 || deletedWords > 0;
                    const overHalfDeleted = deletedChars >= s.aiOutputChars / 2;
                    let updatedDeferredAnalytics = pluginState.deferredAnalytics;
                    if (overHalfDeleted && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) updatedDeferredAnalytics = {
                        ...pluginState.deferredAnalytics,
                        toCancel: s.id
                    };
                    return {
                        ...(0, $bc20842f08ebabaa$export$bfa42147068ddd92)(pluginState, s, isDelete ? 'delete' : 'other', {
                            removedChars: deletedChars,
                            removedWords: deletedWords,
                            touched: touched
                        }),
                        deferredAnalytics: updatedDeferredAnalytics
                    };
                }
                // Check for redo of previously undone AI content
                if (pluginState.lastUndoneSession && !isCollab && tr.docChanged && !isIntermediateAI) {
                    const undoneSession = pluginState.lastUndoneSession;
                    const now = Math.round(performance.now());
                    const timeSinceUndo = now - undoneSession.undoneAt;
                    // Check if this is a redo within a reasonable time window (2000ms like undo)
                    if (timeSinceUndo <= 2000) {
                        const isRedo = (0, $bc20842f08ebabaa$export$476c745650a7176c)(tr.mapping.maps, undoneSession.undoneRanges);
                        if (isRedo) {
                            // Create a mock session for analytics purposes
                            const mockSession = {
                                id: undoneSession.aiSessionId,
                                startedAt: undoneSession.undoneAt,
                                ranges: undoneSession.undoneRanges,
                                mergedNewRanges: undoneSession.undoneRanges.map((r)=>({
                                        from: r.newStart,
                                        to: r.newEnd
                                    })),
                                baselineDoc: newState.doc,
                                aiOutputChars: undoneSession.aiOutputChars,
                                aiOutputWords: undoneSession.aiOutputWords,
                                awaitingNextAction: false,
                                aiGroupId: undoneSession.aiGroupId,
                                experienceName: undoneSession.experienceName
                            };
                            let updatedDeferredAnalytics = pluginState.deferredAnalytics;
                            if (autoApplyAIChangesEnabled() && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                                /**
                 * If traceId is present in decoration plugin state, use it, otherwise use traceIds from common attributes.
                 * Currently, traceId is set in decoration plugin state only for freegen.
                 * For other prompts, it should be in common attributes.
                 */ const traceIds = decorationPluginState?.traceId ? [
                                    decorationPluginState.traceId
                                ] : pluginState.commonAttributes.traceIds;
                                const actionedPayload = (0, $ilIeg.createUnifiedAnalyticsPayload)({
                                    ...pluginState.commonAttributes,
                                    action: (0, $d925B.ACTION).ACTIONED,
                                    attributes: {
                                        aiResultAction: 'accepted',
                                        aiActionedType: 'automaticallyInserted',
                                        wasRedone: true
                                    },
                                    interactionID: undoneSession.aiSessionId,
                                    experienceName: undoneSession.experienceName,
                                    invokedFrom: invokedFrom,
                                    aiGroupId: undoneSession.aiGroupId,
                                    ...(0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') && {
                                        traceIds: traceIds
                                    }
                                });
                                updatedDeferredAnalytics = {
                                    ...pluginState.deferredAnalytics,
                                    toDefer: {
                                        aiSessionId: undoneSession.aiSessionId,
                                        payload: actionedPayload,
                                        waitForSessionEnd: pluginState.deferredAnalytics.sessionState === 'inProgress'
                                    }
                                };
                            }
                            return {
                                ...(0, $bc20842f08ebabaa$export$bfa42147068ddd92)(pluginState, mockSession, 'redo', {
                                    removedChars: undoneSession.aiOutputChars,
                                    removedWords: undoneSession.aiOutputWords,
                                    touched: undoneSession.undoneRanges.length
                                }),
                                lastUndoneSession: null,
                                // Clear after redo
                                deferredAnalytics: updatedDeferredAnalytics
                            };
                        }
                    } else // Clear expired undone session
                    return {
                        ...pluginState,
                        lastUndoneSession: null
                    };
                }
                return pluginState;
            }
        },
        appendTransaction: (_transactions, _oldState, newState)=>{
            const ps = (0, $4aaaca4c5ac35fca$export$ade9b71e7e80f74e).getState(newState);
            const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(newState);
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                const deferredAnalytics = ps?.deferredAnalytics || $290ed39dc9fde36a$var$initialState.deferredAnalytics;
                const { toDefer: toDefer, toCancel: toCancel, sessionState: sessionState } = deferredAnalytics;
                const waitForSessionEnd = toDefer?.waitForSessionEnd;
                const readyToDefer = !waitForSessionEnd || sessionState === 'justEnded';
                if (toDefer && readyToDefer) {
                    const timeoutId = setTimeout(()=>api?.analytics?.actions.fireAnalyticsEvent(toDefer.payload), 10000);
                    if ((0, $dh538.fg)('platform_editor_ai_instrumentation_updates')) {
                        // Fire delayed analytics events at 20s and 30s
                        const delayedAt20s = setTimeout(()=>{
                            const delayedPayload = (0, $5cf9c79654e9fa24$export$67337c564456c5bb)(toDefer.payload, 20000);
                            api?.analytics?.actions.fireAnalyticsEvent(delayedPayload);
                        }, 20000);
                        const delayedAt30s = setTimeout(()=>{
                            const delayedPayload = (0, $5cf9c79654e9fa24$export$67337c564456c5bb)(toDefer.payload, 30000);
                            api?.analytics?.actions.fireAnalyticsEvent(delayedPayload);
                        }, 30000);
                        const updatedDeferredAnalytics = {
                            ...deferredAnalytics,
                            deferred: {
                                ...deferredAnalytics?.deferred,
                                [toDefer.aiSessionId]: timeoutId,
                                [`${toDefer.aiSessionId}-20s`]: delayedAt20s,
                                [`${toDefer.aiSessionId}-30s`]: delayedAt30s
                            },
                            toDefer: undefined,
                            sessionState: 'notStarted'
                        };
                        return newState.tr.setMeta($290ed39dc9fde36a$var$META_DEFERRED_ANALYTICS, updatedDeferredAnalytics);
                    }
                    const updatedDeferredAnalytics = {
                        ...deferredAnalytics,
                        deferred: {
                            ...deferredAnalytics?.deferred,
                            [toDefer.aiSessionId]: timeoutId
                        },
                        toDefer: undefined,
                        sessionState: 'notStarted'
                    };
                    return newState.tr.setMeta($290ed39dc9fde36a$var$META_DEFERRED_ANALYTICS, updatedDeferredAnalytics);
                }
                if (toCancel) {
                    if ((0, $dh538.fg)('platform_editor_ai_instrumentation_updates')) {
                        // Clear the main timeout and the delayed timeouts at 20s and 30s
                        window.clearTimeout(deferredAnalytics.deferred[toCancel]);
                        window.clearTimeout(deferredAnalytics.deferred[`${toCancel}-20s`]);
                        window.clearTimeout(deferredAnalytics.deferred[`${toCancel}-30s`]);
                        const updatedDeferredAnalytics = {
                            ...deferredAnalytics,
                            pending: (0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(deferredAnalytics.deferred, [
                                toCancel,
                                `${toCancel}-20s`,
                                `${toCancel}-30s`
                            ]),
                            toCancel: undefined
                        };
                        return newState.tr.setMeta($290ed39dc9fde36a$var$META_DEFERRED_ANALYTICS, updatedDeferredAnalytics);
                    }
                    window.clearTimeout(deferredAnalytics.deferred[toCancel]);
                    const updatedDeferredAnalytics = {
                        ...deferredAnalytics,
                        pending: (0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(deferredAnalytics.deferred, [
                            toCancel
                        ]),
                        toCancel: undefined
                    };
                    return newState.tr.setMeta($290ed39dc9fde36a$var$META_DEFERRED_ANALYTICS, updatedDeferredAnalytics);
                }
            }
            if (!ps?.pendingAnalytics) return null;
            const { aiSessionId: aiSessionId, nextActionType: nextActionType, aiOutputChars: aiOutputChars, aiOutputWords: aiOutputWords, nextActionRemovedAiChars: nextActionRemovedAiChars, nextActionRemovedAiWords: nextActionRemovedAiWords, nextActionTouchedAiRanges: nextActionTouchedAiRanges, nextActionLatencyMs: nextActionLatencyMs, aiGroupId: aiGroupId, experienceName: experienceName } = ps.pendingAnalytics;
            const tr = newState.tr.setMeta($290ed39dc9fde36a$var$META_FLUSH_ANALYTICS, true);
            return (0, $4SGh1.addAnalytics)({
                editorState: newState,
                tr: tr,
                payload: {
                    action: 'updated',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'aiImmediateReaction',
                    attributes: {
                        aiSessionId: aiSessionId,
                        aiGroupId: aiGroupId,
                        nextActionType: nextActionType,
                        aiOutputChars: aiOutputChars,
                        aiOutputWords: aiOutputWords,
                        nextActionRemovedAiChars: nextActionRemovedAiChars,
                        nextActionRemovedAiWords: nextActionRemovedAiWords,
                        nextActionTouchedAiRanges: nextActionTouchedAiRanges,
                        nextActionLatencyMs: nextActionLatencyMs,
                        traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? decorationPluginState?.traceId : undefined,
                        experienceName: experienceName
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                },
                addToHistory: false
            });
        }
    });
};



var $d7ZU3 = parcelRequire("d7ZU3");





var $1oCLl = parcelRequire("1oCLl");







const $ad2c121df062ec6f$export$725555b5a77b69ce = new (0, $ks2lK.PluginKey)('aiQucikstartCommand');


const $aee682b977e525bb$export$75dff2601176292f = (options)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $ad2c121df062ec6f$export$725555b5a77b69ce),
        state: {
            init: (_, state)=>({}),
            apply: ()=>{}
        },
        props: {
            handleDOMEvents: {
                keydown (view, event) {
                    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
                    const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
                    if (metaKey && event.key === "'") {
                        const { editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn } = options;
                        const { state: state, dispatch: dispatch } = view;
                        const configItem = editorPluginAIProvider.baseGenerate;
                        const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
                            state: state,
                            configItem: configItem,
                            lastTriggeredFrom: 'shortcut',
                            triggerMethod: 'shortcut',
                            aiGlobalOptIn: aiGlobalOptIn,
                            locale: options.getIntl().locale
                        });
                        openAIModalCommand(state, dispatch);
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};









function $6ff5c0402a3519d4$export$1650419e431d3ba3({ state: state, action: action }) {
    switch(action.type){
        case 'RESET':
            return 0, $278237b840ae0e27$export$d4c72bab9d6cc13a;
        case 'START_SESSION':
            return {
                ...state,
                sessionId: action.sessionId,
                status: 'streaming'
            };
        case 'PROMPT':
            return {
                ...state,
                status: 'prompt'
            };
        case 'STREAM':
            // Prevent streaming if the session is in an error state
            if (state.status === 'error') return {
                ...state
            };
            // if the previous state was complete it means we are starting a new stream
            const responseVersion = state.status === 'complete' ? 0 : state.responseVersion + 1;
            return {
                ...state,
                adfResponse: action.adfResponse,
                status: 'streaming',
                responseVersion: responseVersion
            };
        case 'COMPLETE':
            // Prevent completing the session if it is in an error state
            if (state.status === 'error') return {
                ...state
            };
            return {
                ...state,
                adfResponse: action.adfResponse,
                status: 'complete'
            };
        case 'ERROR':
            return {
                ...state,
                errorInfo: action.errorInfo,
                status: 'error'
            };
        default:
            return state;
    }
}


const $278237b840ae0e27$export$d4c72bab9d6cc13a = {
    adfResponse: undefined,
    status: 'idle',
    responseVersion: 0
};
const $278237b840ae0e27$export$3332615281a18d68 = (options)=>{
    const { dispatch: dispatch } = options;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $5oqzu.aiSessionContextPluginKey),
        state: {
            init: ()=>$278237b840ae0e27$export$d4c72bab9d6cc13a,
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $5oqzu.aiSessionContextPluginKey));
                if (meta) {
                    const newState = (0, $6ff5c0402a3519d4$export$1650419e431d3ba3)({
                        state: pluginState,
                        action: meta
                    });
                    if (newState !== pluginState) dispatch((0, $5oqzu.aiSessionContextPluginKey), newState);
                    return newState;
                }
                return pluginState;
            }
        }
    });
};
const $278237b840ae0e27$export$cfaa4734e6c82b = (state)=>{
    return (0, $5oqzu.aiSessionContextPluginKey).getState(state);
};
const $278237b840ae0e27$export$8d4021544bdece00 = (action)=>{
    return ({ tr: tr })=>{
        return tr.setMeta((0, $5oqzu.aiSessionContextPluginKey), action);
    };
};






const $7d27e28955fa0757$export$ea01a78091d2ff77 = ()=>(0, $278237b840ae0e27$export$8d4021544bdece00)({
        type: 'RESET'
    });
const $7d27e28955fa0757$export$7f430c6835f5abe7 = ({ adfResponse: adfResponse })=>(0, $278237b840ae0e27$export$8d4021544bdece00)({
        type: 'STREAM',
        adfResponse: adfResponse
    });
const $7d27e28955fa0757$export$55e78bff62ceea68 = ({ adfResponse: adfResponse })=>(0, $278237b840ae0e27$export$8d4021544bdece00)({
        type: 'COMPLETE',
        adfResponse: adfResponse
    });
const $7d27e28955fa0757$export$e40a87860316fbc4 = ({ errorInfo: errorInfo })=>(0, $278237b840ae0e27$export$8d4021544bdece00)({
        type: 'ERROR',
        errorInfo: errorInfo
    });
const $7d27e28955fa0757$export$6725e2cbda5e459c = (event)=>{
    switch(event.type){
        case 'stream':
            return $7d27e28955fa0757$export$7f430c6835f5abe7(event);
        case 'complete':
            return $7d27e28955fa0757$export$55e78bff62ceea68(event);
        case 'error':
            return $7d27e28955fa0757$export$e40a87860316fbc4(event);
        default:
            $7d27e28955fa0757$var$assertUnreachable(event);
            return undefined;
    }
};
function $7d27e28955fa0757$var$assertUnreachable(_x) {}









var $2pjJ5 = parcelRequire("2pjJ5");




const $88e4cdc4e27bab7a$export$6183e81dd2ece439 = new (0, $ks2lK.PluginKey)('aiSmartButtonAPI');






const $6750a93626028bcf$export$1650419e431d3ba3 = (pluginState)=>{
    return pluginState;
};


const $8815223fdb2de3a5$export$de5e90bd767c5d82 = ()=>{
    return {};
};
const { createPluginState: $8815223fdb2de3a5$export$656c7661095efe2e, createCommand: $8815223fdb2de3a5$export$8d4021544bdece00, getPluginState: $8815223fdb2de3a5$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $88e4cdc4e27bab7a$export$6183e81dd2ece439), (0, $6750a93626028bcf$export$1650419e431d3ba3), {});






var $3Mg7y = parcelRequire("3Mg7y");


var $6Htct = parcelRequire("6Htct");




function $47c0a7afb7a888d4$var$convertConfigItemToAction({ config: config, aiGlobalOptIn: aiGlobalOptIn, intl: intl, view: view, isChild: isChild }) {
    return {
        id: config.key.toString(),
        title: intl.formatMessage(config.title),
        description: intl.formatMessage(config.description),
        icon: ()=>config.icon?.({
                formatMessage: intl.formatMessage
            }) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                label: "",
                spacing: "spacious"
            }),
        onClick: ()=>{
            view.focus();
            (0, $5SuLc.createOpenAIModalCommand)({
                state: view.state,
                configItem: config,
                lastTriggeredFrom: 'rovoButton',
                aiGlobalOptIn: aiGlobalOptIn,
                locale: intl.locale
            })(view.state, view.dispatch);
        },
        closePanelOnSelection: true,
        handleType: (0, $6Htct.HandleActionType).Base,
        type: 'ai-action',
        isChild: isChild
    };
}
const $47c0a7afb7a888d4$export$57ef315382487c5f = ({ intl: intl, dynamicSurfaceConfigItems: dynamicSurfaceConfigItems, aiGlobalOptIn: aiGlobalOptIn })=>(view)=>{
        const parentConfigItems = dynamicSurfaceConfigItems.reduce((accumulator, configItem)=>{
            const nestingConfig = configItem.config.nestingConfig;
            if (nestingConfig) {
                if (!accumulator[nestingConfig.id]) accumulator[nestingConfig.id] = [];
                accumulator[nestingConfig.id].push(configItem);
            }
            return accumulator;
        }, {});
        const processedParentConfigItem = [];
        const actions = [];
        dynamicSurfaceConfigItems.forEach(({ config: config })=>{
            if (config.nestingConfig) {
                if (!processedParentConfigItem.includes(config.nestingConfig.id)) {
                    processedParentConfigItem.push(config.nestingConfig.id);
                    const childrenConfigItems = parentConfigItems[config.nestingConfig.id];
                    const childrenActions = childrenConfigItems.map((configItem)=>$47c0a7afb7a888d4$var$convertConfigItemToAction({
                            config: configItem.config,
                            aiGlobalOptIn: aiGlobalOptIn,
                            intl: intl,
                            view: view,
                            isChild: true
                        }));
                    actions.push({
                        id: config.nestingConfig.id,
                        title: intl.formatMessage(config.nestingConfig.parentTitle),
                        description: intl.formatMessage(config.nestingConfig.parentTitle),
                        icon: ()=>config.nestingConfig?.icon?.({
                                formatMessage: intl.formatMessage
                            }) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                                label: "",
                                spacing: "spacious"
                            }),
                        actionHeading: intl.formatMessage(config.nestingConfig.parentTitle),
                        children: childrenActions,
                        handleType: (0, $6Htct.HandleActionType).Nested,
                        type: 'ai-action'
                    });
                }
            } else actions.push($47c0a7afb7a888d4$var$convertConfigItemToAction({
                config: config,
                aiGlobalOptIn: aiGlobalOptIn,
                intl: intl,
                view: view
            }));
        });
        return actions;
    };
function $47c0a7afb7a888d4$export$7ffd1e30b4d91091(dynamicSurfaceConfigItems) {
    /**
   * Empty document config items are for prompts:
   * - which can run when document is empty. Currently we have only one empty prompt - Brainstorm.
   */ const emptyDocConfigItems = dynamicSurfaceConfigItems.filter((configWithOptions)=>{
        const emptyTrigger = configWithOptions.triggers.empty;
        return emptyTrigger && emptyTrigger.enabled && emptyTrigger.docMinSize === 0;
    });
    /**
   * Non empty document, but selection without content config items are for prompts:
   * - which can run only on non-empty documents (e.g improve writing, change tone etc)
   */ const nonEmptyDocConfigItems = dynamicSurfaceConfigItems.filter((configWithOptions)=>{
        const emptyTrigger = configWithOptions.triggers.empty;
        return emptyTrigger.enabled && (!emptyTrigger.docMinSize || emptyTrigger.docMinSize >= 0);
    });
    /**
   * Selection with content config items are for prompts:
   * - which can run only on selection (e.g Convert to table, convert to bullet list etc)
   */ const selectionConfigItems = dynamicSurfaceConfigItems.filter((configWithOptions)=>{
        const selectionTrigger = configWithOptions.triggers.selection;
        return selectionTrigger.enabled && (!selectionTrigger.selectionMinSize || selectionTrigger.selectionMinSize >= 0);
    });
    return {
        emptyDocConfigItems: emptyDocConfigItems,
        nonEmptyDocConfigItems: nonEmptyDocConfigItems,
        selectionConfigItems: selectionConfigItems
    };
}
function $47c0a7afb7a888d4$export$6dd4d7c2a3a49de7({ intl: intl, dynamicSurfaceConfigItems: dynamicSurfaceConfigItems, aiGlobalOptIn: aiGlobalOptIn, view: view }) {
    const { emptyDocConfigItems: emptyDocConfigItems, nonEmptyDocConfigItems: nonEmptyDocConfigItems, selectionConfigItems: selectionConfigItems } = $47c0a7afb7a888d4$export$7ffd1e30b4d91091(dynamicSurfaceConfigItems);
    const emptyDocActions = $47c0a7afb7a888d4$export$57ef315382487c5f({
        aiGlobalOptIn: aiGlobalOptIn,
        dynamicSurfaceConfigItems: emptyDocConfigItems,
        intl: intl
    })(view);
    const nonEmptyDocActions = $47c0a7afb7a888d4$export$57ef315382487c5f({
        aiGlobalOptIn: aiGlobalOptIn,
        dynamicSurfaceConfigItems: nonEmptyDocConfigItems,
        intl: intl
    })(view);
    const selectionActions = $47c0a7afb7a888d4$export$57ef315382487c5f({
        aiGlobalOptIn: aiGlobalOptIn,
        dynamicSurfaceConfigItems: selectionConfigItems,
        intl: intl
    })(view);
    return {
        emptyDocActions: emptyDocActions,
        nonEmptyDocActions: nonEmptyDocActions,
        selectionActions: selectionActions
    };
}
function $47c0a7afb7a888d4$export$3bfcc298ac0016df({ isEmptyDoc: isEmptyDoc, isEmptySelection: isEmptySelection }, { emptyDocActions: emptyDocActions, nonEmptyDocActions: nonEmptyDocActions, selectionActions: selectionActions }) {
    if (isEmptyDoc) return emptyDocActions;
    else if (isEmptySelection) return nonEmptyDocActions;
    else return selectionActions;
}


const $aad534496f5c8757$export$b43aba46e2a0894 = ({ aiGlobalOptIn: aiGlobalOptIn, aiSmartButtonOptions: aiSmartButtonOptions, dispatch: dispatch, dynamicSurfaceConfigItems: dynamicSurfaceConfigItems, getIntl: getIntl, api: // Optional options
api })=>{
    const intl = getIntl();
    const { removeActions: removeActions, removeContext: removeContext, setActions: setActions, setContext: setContext } = aiSmartButtonOptions.actions;
    function isInEditMode() {
        const editorViewModeState = api?.editorViewMode?.sharedState.currentState();
        const mode = editorViewModeState?.mode;
        const isInEditMode = !!(mode && mode === 'edit');
        return isInEditMode;
    }
    return new (0, $1S4f7.SafePlugin)({
        state: (0, $8815223fdb2de3a5$export$656c7661095efe2e)(dispatch, (0, $8815223fdb2de3a5$export$de5e90bd767c5d82)()),
        key: (0, $88e4cdc4e27bab7a$export$6183e81dd2ece439),
        view: (editorView)=>{
            const { emptyDocActions: emptyDocActions, nonEmptyDocActions: nonEmptyDocActions, selectionActions: selectionActions } = (0, $47c0a7afb7a888d4$export$6dd4d7c2a3a49de7)({
                aiGlobalOptIn: aiGlobalOptIn,
                dynamicSurfaceConfigItems: dynamicSurfaceConfigItems,
                intl: intl,
                view: editorView
            });
            // Track the edit mode state
            let wasInEditMode = isInEditMode();
            // Track the doc state and selection state to avoid resetting actions unnecessarily
            let wasDocumentEmpty = (0, $2pjJ5.isEmptyDocument)(editorView.state.doc);
            let wasSelectionEmpty = editorView.state.selection.empty;
            let wasCleanedUp = false;
            // Register editor actions only in edit page or edit mode of live page.
            if (wasInEditMode) setActions((0, $47c0a7afb7a888d4$export$3bfcc298ac0016df)({
                isEmptyDoc: (0, $2pjJ5.isEmptyDocument)(editorView.state.doc),
                isEmptySelection: editorView.state.selection.empty
            }, {
                emptyDocActions: emptyDocActions,
                nonEmptyDocActions: nonEmptyDocActions,
                selectionActions: selectionActions
            }));
            const reference = intl.formatMessage((0, $7ShCl.aiMessages).aiSmartButtonDynamicSurfaceSelectedContent);
            /**
			 * On removing reference, focus the editor.
			 */ const onRemoveReference = ()=>{
                editorView.focus();
            };
            function cleanup() {
                removeActions();
                removeContext();
                wasCleanedUp = true;
            }
            return {
                update: (editorView, prevState)=>{
                    const currentEditorState = editorView.state;
                    const currentlyInEditMode = isInEditMode();
                    const switchedFromViewToEdit = !wasInEditMode && currentlyInEditMode;
                    /**
					 * Switching from edit to view mode, we need to remove
					 * 	all actions, context and nudges.
					 */ if (wasInEditMode && !currentlyInEditMode) cleanup();
                    wasInEditMode = currentlyInEditMode;
                    if (!currentlyInEditMode) return;
                    /**
					 * Switching from view mode to edit mode, editor state doesn't change.
					 * But editing actions must be added again as it had been removed
					 * 	when transitioning to edito -> view mode.
					 */ if (currentEditorState.doc.eq(prevState.doc) && currentEditorState.selection.empty === prevState.selection.empty && !switchedFromViewToEdit) return;
                    /**
					 * Update;
					 * - registry of editor actions
					 * - context on selection change
					 * - nudges related stuff
					 * only in edit page or edit mode of live page.
					 */ const isCurrentSelectionEmpty = currentEditorState.selection.empty;
                    const isCurrentDocEmpty = (0, $2pjJ5.isEmptyDocument)(currentEditorState.doc);
                    // only reset actions if the selection or document state has changed
                    // this avoids unnecessary re-renders for editor
                    if (wasCleanedUp || isCurrentSelectionEmpty !== wasSelectionEmpty || isCurrentDocEmpty !== wasDocumentEmpty) {
                        setActions((0, $47c0a7afb7a888d4$export$3bfcc298ac0016df)({
                            isEmptyDoc: isCurrentDocEmpty,
                            isEmptySelection: isCurrentSelectionEmpty
                        }, {
                            emptyDocActions: emptyDocActions,
                            nonEmptyDocActions: nonEmptyDocActions,
                            selectionActions: selectionActions
                        }));
                        wasSelectionEmpty = isCurrentSelectionEmpty;
                        wasDocumentEmpty = isCurrentDocEmpty;
                        wasCleanedUp = false;
                    }
                    /**
					 * Check for dynamic surface context change on every selection change.
					 * Not using onSelectionChanged in pluginFactory because
					 * it will be called only when selection changes by current user.
					 */ if (!currentEditorState.selection.empty) setContext({
                        reference: reference,
                        onRemove: onRemoveReference,
                        sourceId: 'editor'
                    });
                    else removeContext();
                },
                destroy: ()=>{
                    cleanup();
                }
            };
        }
    });
};



var $hgeg8 = parcelRequire("hgeg8");


var $l9G9n = parcelRequire("l9G9n");




var $dus6D = parcelRequire("dus6D");







function $3eb5e2a10123a78c$export$1f64fead470ce6a8(options) {
    return (0, $dus6D.keymap)({
        [`${(0, $hgeg8.space).common}`]: (state, dispatch, view)=>{
            if (!view) return false;
            const { from: from, to: to, $to: $to } = state.selection;
            if (options.editorPluginAIProvider.isInDocumentStreamingEnabled ? from === to && (0, $l9G9n.isEmptyParagraph)($to.parent) && (0, $l9G9n.hasDocAsParent)($to) : (0, $2pjJ5.isEmptyDocument)(state.doc)) {
                const { editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn } = options;
                const configItem = editorPluginAIProvider.baseGenerate;
                const { ignoredSpaceTriggerSelection: ignoredSpaceTriggerSelection } = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {};
                if (ignoredSpaceTriggerSelection) try {
                    if (state.selection.eq(ignoredSpaceTriggerSelection)) // If there's an ignored selection set for the space trigger, then we want to avoid opening the AI modal
                    // if it's trying to be opened at the same selection again. This is to stop situations where a users
                    // opens by space and immediately presses Esc or space again. We want to allow them to use the editor as normal.
                    return false;
                } catch  {
                // Default to opening the modal as usual.
                }
                const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
                    state: state,
                    configItem: configItem,
                    lastTriggeredFrom: 'spaceShortcut',
                    triggerMethod: 'shortcut',
                    aiGlobalOptIn: aiGlobalOptIn,
                    locale: options.getIntl().locale
                });
                // We must delay calling this command so that the experiences is mounted in a new stack, otherwise the keybindings
                // in the react modal will pickup this keypress and cause headaches for key tracking.
                setTimeout(()=>openAIModalCommand(state, dispatch), 0);
                return true;
            }
            return false;
        }
    });
}


















var $56Rej = parcelRequire("56Rej");

const $707c63b45c7f9a45$export$f5369c92191ba6f = (view, event)=>{
    const pluginState = (0, $kqrrC.getPluginState)(view.state);
    if ((0, $56Rej.hasGeneratedContentDecorations)(pluginState)) {
        const endAIExperienceCommand = (0, $5SuLc.createEndAIExperienceCommand)();
        endAIExperienceCommand(view.state, view.dispatch);
        return true;
    }
    return false;
};





const $bdef30dffe49f479$export$6181eb45d9edf6d3 = (getPluginState, api)=>()=>{
        // If the plugin doesn't exist let's avoid running this code.
        if (!api?.selectionMarker) return {};
        let releaseSelectionMarker;
        return {
            update: (editorView)=>{
                const pluginState = getPluginState(editorView.state);
                const modalIsOpen = pluginState.modalDecorationSet !== (0, $ftzrq.DecorationSet).empty;
                if (modalIsOpen && !releaseSelectionMarker) releaseSelectionMarker = api?.selectionMarker?.actions.hideDecoration();
                else if (!modalIsOpen && releaseSelectionMarker) {
                    releaseSelectionMarker();
                    releaseSelectionMarker = undefined;
                }
            },
            destroy: ()=>{
                releaseSelectionMarker?.();
            }
        };
    };


const $93128a3776147250$export$f99722d744184238 = (options)=>{
    const { dispatch: dispatch, api: api, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = options;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $3yUTv.aiExperienceDecorationPluginKey),
        state: (0, $kqrrC.createPluginState)(dispatch, (0, $kqrrC.createInitialState)(dispatchAnalyticsEvent, isInDocumentStreamingEnabled)),
        props: {
            handleDOMEvents: {
                click: (0, $707c63b45c7f9a45$export$f5369c92191ba6f)
            },
            decorations: (editorState)=>{
                const pluginState = (0, $kqrrC.getPluginState)(editorState);
                return pluginState.modalDecorationSet;
            }
        },
        view: (0, $bdef30dffe49f479$export$6181eb45d9edf6d3)((0, $kqrrC.getPluginState), api)
    });
};














const $6d81f3f6e54d61c8$export$59c835e23d1ad13 = new (0, $ks2lK.PluginKey)('ai-document-content-state');
const $6d81f3f6e54d61c8$export$ea83d625c73fdf28 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $6d81f3f6e54d61c8$export$59c835e23d1ad13,
        state: {
            init (_, state) {
                return {
                    hasVisibleContent: (0, $2pjJ5.hasVisibleContent)(state.doc)
                };
            },
            apply (tr, pluginState, _, newState) {
                if (!tr.docChanged) return pluginState;
                const newHasVisibleContent = (0, $2pjJ5.hasVisibleContent)(newState.doc);
                if (pluginState.hasVisibleContent !== newHasVisibleContent) return {
                    hasVisibleContent: newHasVisibleContent
                };
                return pluginState;
            }
        }
    });
};








const $d48c0a9f3bd8a0ec$export$519cafec2c63c5bb = new (0, $ks2lK.PluginKey)('aiExperienceGetEditorView');


const $327f80136292b9fb$export$3de1ac9a9cd13933 = ({ setEditorView: setEditorView })=>new (0, $1S4f7.SafePlugin)({
        key: (0, $d48c0a9f3bd8a0ec$export$519cafec2c63c5bb),
        view (editorView) {
            setEditorView(editorView);
            return {};
        }
    });


















var $9F9dO = parcelRequire("9F9dO");




const $f40d45a6cce8f6b7$export$b3d3cfdedcf26988 = (label)=>{
    const telepointerElement = document.createElement('span');
    telepointerElement.setAttribute('data-testid', `ai-in-editor-telepointer-widget`);
    telepointerElement.className = `ai-in-editor-telepointer`;
    const telepointerLabel = document.createElement('span');
    telepointerLabel.setAttribute('data-testid', `ai-in-editor-telepointer-widget-label`);
    telepointerLabel.className = `ai-in-editor-telepointer-label`;
    telepointerLabel.append(label);
    telepointerElement.appendChild(telepointerLabel);
    return telepointerElement;
};
const $f40d45a6cce8f6b7$export$3f4dbbc6f36d65d4 = (position, element)=>{
    return (0, $ftzrq.Decoration).widget(position, element, {
        side: 0,
        key: 'inEditorAIContentDecoration'
    });
};












var $adayn = parcelRequire("adayn");


var $hWRJP = parcelRequire("hWRJP");


var $7YjFd = parcelRequire("7YjFd");











var $LmqWp = parcelRequire("LmqWp");





var $ke2AI = parcelRequire("ke2AI");













function $8f1d8f3ab95a28bc$export$acd864b9a56191f6({ editorView: editorView, pmFragment: pmFragment }) {
    const fragmentToInsert = pmFragment;
    let textContent = '';
    fragmentToInsert.forEach((node)=>{
        textContent += node.textContent;
    });
    const confluenceTitle = document.querySelector('textarea[data-ai-suggest-title-target="true"]');
    if (confluenceTitle) {
        const sourceEditorId = (0, $2e7rb.findEditorIdFromView)(editorView);
        if (sourceEditorId) {
            (0, $jOIil.eventHub).publishFromEditor({
                event: 'replace title in confluence',
                data: {
                    analyticSourceId: 'confluenceTitleToolbar',
                    sourceEditorId: sourceEditorId,
                    title: textContent
                }
            });
            confluenceTitle.scrollIntoView({
                block: 'nearest'
            });
        }
    }
}



var $hX9je = parcelRequire("hX9je");










function $3adf5d183dded6a4$export$b26e0d212ef01829({ invokeAttributes: invokeAttributes, canInlineStreamChanges: canInlineStreamChanges, onCommonAttributesUpdated: onCommonAttributesUpdated, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled }) {
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const analyticsFlowRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    if (!analyticsFlowRef.current) analyticsFlowRef.current = (0, $6gJll.createAnalyticsFlow)({
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        invokeAttributes: invokeAttributes,
        canInlineStreamChanges: canInlineStreamChanges,
        onCommonAttributesUpdated: onCommonAttributesUpdated,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    });
    return analyticsFlowRef.current;
}
const $3adf5d183dded6a4$var$AnalyticsFlowContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $3adf5d183dded6a4$export$b8f39b5859612546 = $3adf5d183dded6a4$var$AnalyticsFlowContext.Provider;
const $3adf5d183dded6a4$export$8af1809310de64fa = ()=>{
    const analyticsFlowInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($3adf5d183dded6a4$var$AnalyticsFlowContext);
    if (!analyticsFlowInstance) throw new Error('No analyticsFlowInstance available in the context, make sure to have container wrapped with AnalyticsFlowContextProvider');
    return analyticsFlowInstance;
};
function $3adf5d183dded6a4$export$f06fb39743945e19({ stepName: stepName, attributes: attributes, needUpdatedArgs: needUpdatedArgs }) {
    const analyticsFlow = $3adf5d183dded6a4$export$8af1809310de64fa();
    const argsRef = (0, $42omo.useRef)({
        stepName: undefined,
        attributes: undefined
    });
    (0, $42omo.useEffect)(()=>{
        argsRef.current = {
            stepName: stepName,
            attributes: attributes
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        analyticsFlow.fireQueuedStep(stepName);
        return ()=>{
            if (needUpdatedArgs && argsRef.current.stepName) analyticsFlow.enqueueStep({
                stepName: argsRef.current.stepName,
                attributes: argsRef.current.attributes
            });
            else analyticsFlow.enqueueStep({
                stepName: stepName,
                attributes: attributes
            });
        };
    // expecting to enqueue step only once on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return analyticsFlow;
}



var $kTCUV = parcelRequire("kTCUV");








var $5vNOi = parcelRequire("5vNOi");


var $eyHC2 = parcelRequire("eyHC2");

const $d27932f4c96239ca$export$68178086d03445ca = ({ nodeType: nodeType, schema: schema })=>{
    const { table: table, tableRow: tableRow, tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    return [
        table,
        tableRow,
        tableHeader,
        tableCell
    ].includes(nodeType);
};



var $cVxBN = parcelRequire("cVxBN");

const $3a34bf48b420323e$export$f9c4337e36118c2b = (element, scrollContainer)=>{
    let offset = 0;
    let currentElement = element;
    /**
	 * If we've reached the scroll container or the element is null (scrollContainer not found after traversal)
	 * we return the accumulated offset.
	 * This is to avoid calling getBoundingClientRect which can be more expensive.
	 */ while(currentElement && currentElement !== scrollContainer){
        offset += currentElement.offsetTop;
        currentElement = currentElement.offsetParent;
    }
    return offset;
};


const $bc1b0aa0b4af6d11$var$SCROLL_MARGIN = 32;
function $bc1b0aa0b4af6d11$export$8c11be8ccd39ce0b({ pos: pos, tr: tr }) {
    let mappedPos = tr.mapping.map(pos, -1);
    // if it's AI in-document streaming, the startPos shouldn't change
    // however, when generating table, somehow the mappedPos could be smaller than pos
    // - we insert at the beginning of the doc, pos 1 somehow maps to 0
    // - which we should allow
    if (tr.getMeta('isAIStreamingTransformation')) {
        if (mappedPos > pos) {
            const adjustedPos = tr.mapping.map(pos - 1, -1) + 1;
            if (adjustedPos === pos) mappedPos = pos;
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(mappedPos, 0, tr.doc.content.size);
}
function $bc1b0aa0b4af6d11$export$3dcc2c094c7e6748({ pos: pos, tr: tr }) {
    let mappedPos = tr.mapping.map(pos, 1);
    // if it's AI in-document streaming, the endPos should change
    if (tr.getMeta('isAIStreamingTransformation')) {
        if (mappedPos === pos) {
            const adjustedPos = tr.mapping.map(pos + 1, 1) - 1;
            if (adjustedPos !== pos) mappedPos = adjustedPos;
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(mappedPos, 0, tr.doc.content.size);
}
function $bc1b0aa0b4af6d11$var$getStartOfTableRow({ schema: schema, resolvedPos: resolvedPos }) {
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        const node = resolvedPos.node(depth);
        if (node.type === schema.nodes.tableRow) return resolvedPos.start(depth);
    }
}
function $bc1b0aa0b4af6d11$var$getEndOfTableRow({ schema: schema, resolvedPos: resolvedPos }) {
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        const node = resolvedPos.node(depth);
        if (node.type === schema.nodes.tableRow) {
            const tableNode = resolvedPos.node(depth - 1);
            const tablePos = resolvedPos.start(depth - 1);
            const map = (0, $LmqWp.TableMap).get(tableNode);
            const { mapByRow: mapByRow } = map;
            const rowIndexContainingCell = mapByRow.findIndex((r)=>r.includes(resolvedPos.start(depth) - tablePos));
            if (rowIndexContainingCell === -1) /**
				 * In the case that we can't find a row containing the cell (this should not occur) we early exit
				 */ return;
            /**
			 * If we've reached the last row, then just return the end of that row
			 * since it won't have further vertically merged cells.
			 */ if (rowIndexContainingCell + 1 === map.height) {
                const $cellPos = resolvedPos.doc.resolve(tablePos + mapByRow[rowIndexContainingCell][0]);
                return $cellPos.end($cellPos.depth);
            }
            for(let i = rowIndexContainingCell + 1; i < map.height; i++){
                // We keep checking the next row to see if there are any duplicate positions
                // If there are, it means that there are vertically merged cells and we want to extend the position
                const rowA = mapByRow[i - 1];
                const rowB = mapByRow[i];
                if (rowA.every((val, idx)=>val !== rowB[idx])) {
                    const $cellPos = resolvedPos.doc.resolve(tablePos + rowA[0]);
                    return $cellPos.end($cellPos.depth);
                }
                /***
				 * If we've reached the end and still encountering merged cells,
				 * we return the last row's end position
				 */ if (i === map.height - 1) {
                    const $cellPos = resolvedPos.doc.resolve(tablePos + rowB[0]);
                    return $cellPos.end($cellPos.depth);
                }
            }
        }
    }
}
/**
 * We want to adjust the streaming position so that we don't break table rows.
 * Here, we extend the position to the end of a table row if the current position is inside a table cell.
 * We only do this if the replacement range spans over more than a cell!
 */ function $bc1b0aa0b4af6d11$var$adjustStartToPosForTable({ view: view, startPos: startPos, toPos: toPos, userContentEndPos: userContentEndPos }) {
    const $startPos = view.state.doc.resolve(startPos);
    const $toPos = view.state.doc.resolve(toPos);
    const isSameCell = (0, $cVxBN.isWithinSameCell)({
        $from: $startPos,
        $to: $toPos,
        schema: view.state.schema
    });
    const adjustStartPosIfTableRow = !isSameCell ? $bc1b0aa0b4af6d11$var$getStartOfTableRow({
        schema: view.state.schema,
        resolvedPos: $startPos
    }) : undefined;
    const adjustToPosIfTableRow = !isSameCell ? $bc1b0aa0b4af6d11$var$getEndOfTableRow({
        schema: view.state.schema,
        resolvedPos: $toPos
    }) : undefined;
    if (adjustStartPosIfTableRow !== undefined) startPos = adjustStartPosIfTableRow;
    if (adjustToPosIfTableRow !== undefined) toPos = Math.min(adjustToPosIfTableRow, userContentEndPos);
    return {
        startPos: startPos,
        toPos: toPos
    };
}
/**
 * Ensure the fragment is valid, otherwise indicate we received the fragment, but make
 * no updates.
 *
 * @param fragment
 * @returns boolean - true if fragment is healthy (valid), false otherwise
 */ const $bc1b0aa0b4af6d11$var$fragmentIsHealthy = (fragment)=>{
    let isHealthy = true;
    fragment.forEach((node)=>{
        if (!isHealthy) return;
        try {
            node.check();
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
            isHealthy = false;
        }
    });
    return isHealthy;
};
// if we insert a heading at the beginning of a list item
// we want to insert the heading at the pos right before the list
// if we insert a heading at the end of a list item
// we want to insert the heading at the pos right after the list
function $bc1b0aa0b4af6d11$var$adjustStartEndPosForEmptySelection({ view: view, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } = view.state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos
    };
    const $start = view.state.doc.resolve(startPos);
    const startParent = $start.parent;
    // we only need to adjust the pos if the parent is list item (orderedList or bulletList), decisionItem, or taskItem
    const inList = startParent.type === paragraph && $start.node($start.depth - 1)?.type === listItem;
    const inTaskItem = startParent.type === taskItem;
    const inDecisionItem = startParent.type === decisionItem;
    const shouldAdjust = inList || inTaskItem || inDecisionItem;
    if (!shouldAdjust) return bailout;
    const $end = view.state.doc.resolve(userContentEndPos);
    const endParent = $end.parent;
    const newNode = fragment.firstChild;
    const oneBlock = fragment.childCount === 1 && newNode && newNode.isBlock;
    const newStartBlock = oneBlock && newNode.type.name !== startParent.type.name;
    const newEndBlock = oneBlock && newNode.type.name !== endParent.type.name;
    let startPosAdjusted = startPos;
    let endPosAdjusted = userContentEndPos;
    if (newStartBlock) // find a potential pos at the beginning of the block
    for(let depth = $start.depth, diff = 1; depth > 0; depth--, diff++, startPosAdjusted--){
        const ancestor = $start.node(depth);
        if (ancestor.type.contentMatch.matchType(newNode.type)) break;
        const before = $start.before(depth);
        if (before + diff !== startPos) break;
    }
    if (newEndBlock) // find a potential pos at the end of the block
    for(let depth = $end.depth, diff = 1; depth > 0; depth--, diff++, endPosAdjusted++){
        const ancestor = $end.node(depth);
        if (ancestor.type.contentMatch.matchType(newNode.type)) break;
        const after = $end.after(depth);
        if (after - diff !== userContentEndPos) break;
    }
    if (startPosAdjusted !== bailout.startPos || endPosAdjusted !== bailout.userContentEndPos) {
        // prefer the end if there is a tie/draw
        // or else if there will be extra list item if insert heading at the beginning of the doc
        const pos = endPosAdjusted - userContentEndPos >= startPos - startPosAdjusted ? endPosAdjusted : startPosAdjusted;
        view.dispatch((0, $eyHC2.adjustInitPositions)({
            start: pos,
            end: pos
        })(view.state.tr));
        return {
            startPos: pos,
            userContentEndPos: pos
        };
    }
    return bailout;
}
// if we are at the beginning of a block visually
// we want to move the start pos to the pos right before the block
// for example, if we run Improve Writing with two nodes: expand+paragraph
// we want to move the start pos to the pos right before the expand
// otherwise, there will be an extra empty expand node inserted
function $bc1b0aa0b4af6d11$var$adjustStartEndPosForRangeSelection({ view: view, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { paragraph: paragraph } = view.state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos
    };
    let $start = view.state.doc.resolve(startPos);
    // if the start pos is not at the beginning of its parent, bailout
    // sometimes startPos is 0, in this case $start.depth is 0 and
    // $start.before() will throw an error `There is no position before the top-level node`
    if ($start.depth > 0 && $start.before() !== startPos - 1) return bailout;
    // find the types of the ancestor nodes in the fragment in reverse order
    const types = [];
    let node = fragment.firstChild;
    while(node && node.firstChild){
        types.push(node.type);
        node = node.firstChild;
    }
    types.reverse();
    if (types.length === 1 && types[0] === paragraph) return bailout;
    // go to the innermost ancestor node in the doc
    let startPosAdjusted = startPos;
    node = $start.parent.firstChild;
    while(node && node.firstChild){
        startPosAdjusted++;
        node = node.firstChild;
    }
    // compare every ancestor node outwards
    $start = view.state.doc.resolve(startPosAdjusted);
    for(let i = 0, depth = $start.depth; depth > 0; i++, depth--, startPosAdjusted--){
        const ancestor = $start.node(depth);
        if (ancestor.type !== types[i]) break;
        const before = $start.before(depth);
        if (before + 1 !== startPosAdjusted) break;
    }
    // if we found a pos that is before startPos, we need to adjust startPos
    if (startPosAdjusted < bailout.startPos) {
        view.dispatch((0, $eyHC2.adjustInitPositions)({
            start: startPosAdjusted,
            end: bailout.userContentEndPos
        })(view.state.tr));
        return {
            startPos: startPosAdjusted,
            userContentEndPos: bailout.userContentEndPos
        };
    }
    return bailout;
}
/**
 * Adjusts start and end positions when streaming block nodes (e.g., tables, panels) that replace content within list items.
 *
 * When AI streams a block-level node to replace selected content inside list items, we need to adjust
 * the replacement range to prevent empty list items from appearing before and after the inserted block.
 * This function expands the start and end positions to include the surrounding list item structure.
 *
 * @example
 * // Before adjustment: Replacing content inside a list item paragraph
 * // - List item 1
 * // - [Selected content in list item 2]
 * // - List item 2
 * // After streaming a table, without adjustment, would create:
 * // - List item 1
 * // -           <-- empty list item
 * // [Table]
 * // -           <-- empty list item
 * // - List item 2
 *
 * // With adjustment, positions are expanded to replace the entire list item:
 * // - List item 1
 * // [Table]
 * // - List item 2
 *
 * @param params - The adjustment parameters
 * @param params.fragment - The ProseMirror fragment being streamed (contains the AI-generated content)
 * @param params.startPos - The current start position of the replacement range
 * @param params.userContentEndPos - The current end position of the replacement range (original user content)
 * @param params.view - The editor view instance
 * @returns Object containing the adjusted start and end positions
 * @returns returns.startPos - The adjusted start position, moved earlier if at start of list item paragraph
 * @returns returns.userContentEndPos - The adjusted end position, moved later if at end of list item paragraph
 */ function $bc1b0aa0b4af6d11$var$adjustStartAndUserContentEndPosForList({ fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos, view: view }) {
    const state = view.state;
    const schema = state.schema;
    const doc = state.doc;
    let startPosAdjusted = startPos;
    let userContentEndPosAdjusted = userContentEndPos;
    /**
	 * If the first node in the fragment is a block node,
	 * we need to adjust the start and userContentEndPos
	 * to avoid having empty list items before and after the block node.
	 */ const fragmentFirstNode = fragment.firstChild;
    const firstNodeIsBlock = fragmentFirstNode && fragmentFirstNode.isBlock;
    if (firstNodeIsBlock) {
        const $start = doc.resolve(startPos);
        const { listItem: listItem, paragraph: paragraph } = schema.nodes;
        /**
		 * Adjusting startPos is only necessary when startPos is at the beginning of a paragraph in list item.
		 */ let curParent = $start.node($start.depth);
        let curParentParent = $start.node($start.depth - 1);
        if (curParent.type === paragraph && $start.parentOffset === 0 && curParentParent?.type === listItem) startPosAdjusted -= 2;
        else if (curParent.type === listItem) startPosAdjusted -= 1;
        /**
		 * Adjusting userContentEndPos is only necessary when userContentEndPos is at the end of a paragraph in list item.
		 */ const $userContentEnd = doc.resolve(userContentEndPos);
        curParent = $userContentEnd.node($userContentEnd.depth);
        curParentParent = $userContentEnd.node($userContentEnd.depth - 1);
        if (curParent.type === paragraph && $userContentEnd.parentOffset === curParent.content.size && curParentParent?.type === listItem) userContentEndPosAdjusted += 2;
        else if (curParent.type === listItem) userContentEndPosAdjusted += 1;
    }
    return {
        startPos: startPosAdjusted,
        userContentEndPos: userContentEndPosAdjusted
    };
}
function $bc1b0aa0b4af6d11$var$adjustSliceOpenStartEnd({ slice: slice, startPos: startPos, toPos: toPos, view: view }) {
    const fragment = slice.content;
    // if the first node in fragment is different from the existing first node,
    // we need to adjust the slice open start to 0,
    // to avoid merging the first node in fragment with the existing first node,
    // for example, if the first node in fragment is a panel node, we'll lose the panel wrapper
    // (only the panel content is inserted into the doc)
    // but we don't need to do this if both nodes are table nodes
    const firstNode = fragment.firstChild;
    if (firstNode) {
        const firstNodeIsTableNode = (0, $d27932f4c96239ca$export$68178086d03445ca)({
            nodeType: firstNode.type,
            schema: view.state.schema
        });
        const startPosTableDepth = (0, $cVxBN.getPositionNodeTypeDepth)({
            resolvedPos: view.state.doc.resolve(startPos),
            nodeType: view.state.schema.nodes.table
        });
        const bothTableNodes = firstNodeIsTableNode && !!startPosTableDepth;
        if (!bothTableNodes) {
            const existingFirstNode = view.state.doc.resolve(startPos).node(1);
            if (!existingFirstNode || firstNode.type !== existingFirstNode.type) slice = new (0, $5SAOw.Slice)(fragment, 0, slice.openEnd);
        }
    }
    // if the last node in fragment is different from the existing last node,
    // we need to adjust the slice open end to 0,
    // to avoid merging the last node in fragment with the existing last node,
    // for example, we've seen during streaming, heading and paragraph are merged together
    // (leading to a very long heading containing the paragraph content)
    // but we don't need to do this if both nodes are table nodes
    const lastNode = fragment.lastChild;
    if (lastNode) {
        const lastNodeIsTableNode = (0, $d27932f4c96239ca$export$68178086d03445ca)({
            nodeType: lastNode.type,
            schema: view.state.schema
        });
        const toPosTableDepth = (0, $cVxBN.getPositionNodeTypeDepth)({
            resolvedPos: view.state.doc.resolve(toPos),
            nodeType: view.state.schema.nodes.table
        });
        const bothTableNodes = lastNodeIsTableNode && !!toPosTableDepth;
        if (!bothTableNodes) {
            const existingLastNode = view.state.doc.resolve(toPos).node(1);
            if (!existingLastNode || lastNode.type !== existingLastNode.type) slice = new (0, $5SAOw.Slice)(fragment, slice.openStart, 0);
        }
    }
    return slice;
}
const $bc1b0aa0b4af6d11$export$bab543e64bfa5b68 = ({ api: api, configItem: configItem, isProgrammaticScroll: isProgrammaticScroll, view: view, positions: positions, modalRef: modalRef, aiSessionId: aiSessionId })=>{
    const isSuggestTitle = (0, $hX9je.isSuggestTitleForConfluence)(configItem);
    const showTelepointer = !isSuggestTitle;
    const [isPaused, setIsPaused] = (0, $42omo.useState)(true);
    const [_start, setStart] = (0, $42omo.useState)();
    const scrollParentRef = (0, $42omo.useRef)(null);
    const originalUserContentSlice = (0, $42omo.useRef)();
    /**
	 * The AI content slice is used to store the AI content that has been streamed
	 */ const aiContentSlice = (0, $42omo.useRef)();
    const hasFinalStreamRef = (0, $42omo.useRef)(false);
    // NOTE: This is not pretty but we still need data from the userflow, so we've decoupled the firing of unified events
    // for AIFC however we still need more data, so we can do this for now until xstate ios removed.
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    const commonUnifiedAnalyticsData = analyticsFlow.getUnifiedEventData();
    (0, $42omo.useEffect)(()=>{
        const dom = view.dom;
        const scrollParent = (0, $7YjFd.findOverflowScrollParent)(dom);
        if (scrollParent) scrollParentRef.current = scrollParent;
    }, [
        view
    ]);
    (0, $42omo.useEffect)(()=>{
        if (_start !== undefined && scrollParentRef.current) {
            const startCoords = view.coordsAtPos(_start);
            const offsetTop = view.coordsAtPos(0).top;
            const modalHeight = modalRef?.current?.offsetHeight || 0;
            const offsetTopFromScrollContainer = (0, $3a34bf48b420323e$export$f9c4337e36118c2b)(view.dom, scrollParentRef.current);
            /**
			 * If the start position is above viewport,
			 * we set the scroll so that the start is at the top of viewport (+ margin)
			 * If the start position is below the viewport,
			 * we set the scroll so that the start is at the bottom of viewport (+ margin)
			 */ const topScrollTop = // offset of view dom from scroll parent
            offsetTopFromScrollContainer + // top - 0.top is height of content
            startCoords.top - offsetTop - // extra margin so text isn't at the very very top
            $bc1b0aa0b4af6d11$var$SCROLL_MARGIN;
            const bottomScrollTop = // offset of view dom from scroll parent
            offsetTopFromScrollContainer + // bottom - 0.top is height of content
            startCoords.bottom - offsetTop + // extra margin so modal isn't in the way
            modalHeight + // extra margin so text isn't at the very very bottom
            $bc1b0aa0b4af6d11$var$SCROLL_MARGIN - // subtracting offsetHeight keeps content at the bottom so
            // auto-scrolling is more incremental
            scrollParentRef.current.offsetHeight;
            isProgrammaticScroll.current = true;
            if (scrollParentRef.current.scrollTop > topScrollTop) scrollParentRef.current.scroll({
                top: topScrollTop,
                behavior: 'instant'
            });
            else if (scrollParentRef.current.scrollTop < bottomScrollTop) scrollParentRef.current.scroll({
                top: bottomScrollTop,
                behavior: 'instant'
            });
        }
    }, [
        view,
        _start,
        modalRef,
        isProgrammaticScroll
    ]);
    const isEmptySelection = positions[0] === positions[1];
    const initialStartPos = positions[0];
    const shouldReplaceDoc = isEmptySelection && !configItem.insertOnEmptySelection;
    const [start, end] = shouldReplaceDoc ? [
        1,
        view.state.doc.content.size - 1
    ] : positions;
    /**
	 * we should show highlight when:
	 * - always (yayyyyyyyyy)
	 *
	 * we should not show highlight when:
	 * - suggest title
	 */ const showHighlight = !isSuggestTitle;
    // we don't want to show AI content highlight when we do full page streaming which replaces the whole document
    const showAIContentHighlight = !shouldReplaceDoc;
    (0, $42omo.useEffect)(()=>{
        if (// we don't need to show loading highlight when we're inserting into the current position such as free generate
        isEmptySelection && configItem.insertOnEmptySelection || !showHighlight) return;
        const min = 80, max = 240;
        const prestreamLoading = setInterval(()=>{
            if (isPaused) return;
            if (((0, $5vNOi.inEditorDirectStreamingPluginKey).getState(view.state) || {}).aiContentEndPos !== undefined) clearInterval(prestreamLoading);
            else view.dispatch((0, $eyHC2.updateLoadingPositions)(view.state.tr));
        }, Math.random() * (max - min) + min);
        return ()=>{
            clearInterval(prestreamLoading);
        };
    }, [
        view,
        isPaused,
        configItem.insertOnEmptySelection,
        isEmptySelection,
        showHighlight
    ]);
    const mountDecorations = (0, $42omo.useCallback)(()=>{
        const pluginState = (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(view.state) || {
            chunkNumber: 0
        };
        if (pluginState.startPos === undefined) {
            // turn diff off when starting streaming
            if (api?.trackChanges?.sharedState.currentState()?.isDisplayingChanges) api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
            (0, $5SuLc.clearSelectionDecorations)(view.state)(view.state, view.dispatch);
            setIsPaused(false);
            /**
			 * Store the original user content slice so that we can restore it
			 * and use it to manipulate the history plugin.
			 */ originalUserContentSlice.current = view.state.doc.slice(start, end);
            const $start = view.state.doc.resolve(start);
            let telepointerPos = $start.pos;
            /**
			 * We position the telepointer to be the beginning of a leaf node so that
			 * it displays inline.
			 */ let node = $start.node()?.firstChild;
            while(node && node.firstChild && !node.isLeaf){
                telepointerPos += 1;
                node = node.firstChild;
            }
            const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(view.state);
            view.dispatch((0, $ke2AI.closeHistory)((0, $eyHC2.initPositions)({
                start: start,
                end: end,
                showHighlight: showHighlight && decorationPluginState?.withStreamingHighlight !== false,
                showAIContentHighlight: showAIContentHighlight,
                showTelepointer: showTelepointer,
                telepointerPos: telepointerPos
            })((0, $kTCUV.startWatchingAnnotationChanges)({
                from: start,
                to: end
            })(view.state.tr))));
            setStart(start);
            return ()=>{
                setIsPaused(true);
            };
        }
    }, [
        api,
        view,
        start,
        end,
        showHighlight,
        showAIContentHighlight,
        showTelepointer
    ]);
    /**
	 * Caller should dispatch an extra transaction to reset the document back to original state
	 * so that the history plugin can correctly track the difference between the
	 * original document and the final document after streaming.
	 */ const restoreOriginalUserContent = (0, $42omo.useCallback)((tr)=>{
        const pluginState = (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(view.state);
        const { startPos: startPos, userContentEndPos: userContentEndPos, streamTimeStamp: streamTimeStamp } = pluginState || {};
        if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice.current) return tr;
        // To review - size should never be -1 but it is sometimes
        if (originalUserContentSlice.current.size === -1) {
            // if the original user content is empty, we need to delete the inserted content
            tr = tr.delete(startPos, userContentEndPos);
            tr = (0, $eyHC2.metaTransaction)({
                tr: tr,
                isFinalStream: false,
                stackTime: streamTimeStamp
            });
        } else {
            tr = tr.replaceRange(startPos, userContentEndPos, originalUserContentSlice.current);
            tr = (0, $eyHC2.metaTransaction)({
                tr: tr,
                isFinalStream: false,
                stackTime: streamTimeStamp
            });
        }
        return tr;
    }, [
        view
    ]);
    const commitFinalResponse = (0, $42omo.useCallback)(({ tr: tr, slice: slice })=>{
        const pluginState = (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(view.state);
        let { startPos: startPos, userContentEndPos: userContentEndPos } = pluginState || {};
        const streamTimeStamp = pluginState?.streamTimeStamp;
        if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice.current) return tr;
        if ((0, $dh538.fg)('platform_editor_ai_convert_list_to_table_bugfix')) ({ startPos: startPos, userContentEndPos: userContentEndPos } = $bc1b0aa0b4af6d11$var$adjustStartAndUserContentEndPosForList({
            view: view,
            fragment: slice.content,
            startPos: startPos,
            userContentEndPos: userContentEndPos
        }));
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
            const { paragraph: paragraph } = tr.doc.type.schema.nodes;
            // If we have a lone paragraph - replaceRange will not replace with a paragraph
            // This can cause issues as we will not be using the same localId as provided
            if (slice.content.firstChild === slice.content.lastChild && slice.content.firstChild?.type === paragraph && tr.selection.$from === tr.selection.$to && (0, $l9G9n.isEmptyParagraph)(tr.selection.$from.parent)) tr = tr.replaceRangeWith(startPos, // End pos should never be smaller than start pos - for now just clamp it to start (to be reviewed)
            userContentEndPos < startPos ? startPos : userContentEndPos, slice.content.firstChild);
            else tr = tr.replaceRange(startPos, // End pos should never be smaller than start pos - for now just clamp it to start (to be reviewed)
            userContentEndPos < startPos ? startPos : userContentEndPos, slice);
        } else tr = tr.replaceRange(startPos, // End pos should never be smaller than start pos - for now just clamp it to start (to be reviewed)
        userContentEndPos < startPos ? startPos : userContentEndPos, slice);
        tr = (0, $eyHC2.metaTransaction)({
            tr: tr,
            isFinalStream: true,
            stackTime: streamTimeStamp
        });
        tr = tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, Math.min(tr.selection.to, tr.doc.content.size)));
        // the passed-in slice structure may be different from originalUserContentSlice
        // for a paragraph, the passed-in slice may contain only a text node
        // that's why we cut a new slice here
        const newSlice = tr.doc.slice($bc1b0aa0b4af6d11$export$8c11be8ccd39ce0b({
            pos: startPos,
            tr: tr
        }), $bc1b0aa0b4af6d11$export$3dcc2c094c7e6748({
            pos: userContentEndPos,
            tr: tr
        }));
        const isSame = newSlice.eq(originalUserContentSlice.current);
        if (isSame) tr = tr.setMeta('addToHistory', false);
        return tr;
    }, [
        view
    ]);
    const posAdjusted = (0, $42omo.useRef)(false);
    /**
	 * We only add the final transaction to history so user can undo it all at once
	 */ const updateStream = (0, $42omo.useCallback)(({ fragment: fragment, isFinalStream: isFinalStream = false, hasUserScrolled: // Prevent scroll-jacking by default to be safe
    hasUserScrolled = true })=>{
        try {
            if (isFinalStream) {
                if (hasFinalStreamRef.current) return;
                hasFinalStreamRef.current = true;
            }
            const scrollTop = scrollParentRef.current?.scrollTop;
            if (isSuggestTitle) {
                (0, $8f1d8f3ab95a28bc$export$acd864b9a56191f6)({
                    editorView: view,
                    pmFragment: fragment
                });
                if (isFinalStream && originalUserContentSlice.current && // We need to ensure we're not doubling up unified events. The streaming api (ie rovo chat) will also be firing
                // its own unified events. So we basically nuke all unified events from the streaming api.
                commonUnifiedAnalyticsData.invokedFrom !== 'streamingApi' && commonUnifiedAnalyticsData.invokedFrom !== 'confluenceTitleGenOnPaste') // We fire the unified viewed event on the final stream because this is when all the AI content is known to be visible
                // to the user.
                // The view event previously fired in the preview modal. This will no longer occur in AIFC.
                api?.analytics?.actions.fireAnalyticsEvent((0, $ilIeg.createUnifiedAnalyticsPayload)({
                    action: (0, $d925B.ACTION).VIEWED,
                    ...commonUnifiedAnalyticsData,
                    interactionID: aiSessionId
                }));
                return;
            }
            const pluginState = (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(view.state);
            let { startPos: startPos, userContentEndPos: userContentEndPos } = pluginState || {};
            const { aiContentEndPos: aiContentEndPos, streamTimeStamp: streamTimeStamp } = pluginState || {};
            if (startPos === undefined || userContentEndPos === undefined) return;
            const { expand: expand, nestedExpand: nestedExpand } = view.state.schema.nodes;
            let slice = (0, $5SAOw.Slice).maxOpen(fragment);
            /**
				 * Occasionally we receive a response with empty content which causes the fragment -> slice
				 * to have a negative size, which causes the experience to break.
				 * Since there's nothing to update, we early exit here if it's not the final stream.
				 *
				 * We also want to early exit if the slice is inherently empty - for non empty selections we use maxOpen
				 * which means even if the fragment has an empty paragraph, the slice will have size 0 since the contents are empty.
				 */ if (slice.size <= 0 && !isFinalStream) return;
            // https://atlassian-2y.sentry.io/issues/6886259844/?project=4505129224110080&query=tags%5Blocation%5D%3Aeditor-ai-streaming-update-stream&referrer=issue-stream
            // we're getting error `Cannot read properties of null (reading 'content')`
            // but we're using Slice.maxOpen(fragment)
            // maybe this will fix the issue
            if (!slice.content.firstChild) slice = (0, $5SAOw.Slice).empty;
            // If fragment isn't healthy indicate we received the chunk, but do not update positions as we haven't
            // streamed any changes
            if (!$bc1b0aa0b4af6d11$var$fragmentIsHealthy(fragment)) view.dispatch((0, $eyHC2.updateStreamPositions)({
                aiContentEndPos: pluginState?.aiContentEndPos,
                telepointerPos: pluginState?.telepointerPos,
                isFinalStream: isFinalStream
            })(view.state.tr));
            // we only need to adjust the pos once
            if (!posAdjusted.current) {
                posAdjusted.current = true;
                if (isEmptySelection) ({ startPos: startPos, userContentEndPos: userContentEndPos } = $bc1b0aa0b4af6d11$var$adjustStartEndPosForEmptySelection({
                    view: view,
                    fragment: fragment,
                    startPos: startPos,
                    userContentEndPos: userContentEndPos
                }));
                else {
                    ({ startPos: startPos } = $bc1b0aa0b4af6d11$var$adjustStartEndPosForRangeSelection({
                        view: view,
                        fragment: fragment,
                        startPos: startPos,
                        userContentEndPos: userContentEndPos
                    }));
                    if ((0, $dh538.fg)('platform_editor_ai_convert_list_to_table_bugfix')) ({ startPos: startPos, userContentEndPos: userContentEndPos } = $bc1b0aa0b4af6d11$var$adjustStartAndUserContentEndPosForList({
                        view: view,
                        fragment: fragment,
                        startPos: startPos,
                        userContentEndPos: userContentEndPos
                    }));
                }
            }
            let toPos = isFinalStream ? userContentEndPos : Math.min(Math.max(aiContentEndPos || 0, startPos + slice.size + 1), userContentEndPos);
            ({ startPos: startPos, toPos: toPos } = $bc1b0aa0b4af6d11$var$adjustStartToPosForTable({
                view: view,
                fragment: fragment,
                startPos: startPos,
                toPos: toPos,
                userContentEndPos: userContentEndPos
            }));
            slice = $bc1b0aa0b4af6d11$var$adjustSliceOpenStartEnd({
                slice: slice,
                startPos: startPos,
                toPos: toPos,
                view: view
            });
            aiContentSlice.current = slice;
            // we don't want to add every streaming step to history
            let tr = view.state.tr;
            if (isFinalStream && originalUserContentSlice.current) {
                // we still need this restoration because it will allow
                // Prosemirror to drop fully covered parent nodes of the replaced region
                // if in the future we decide to remove this
                // we may need to revisit the logic to drop fully covered parent nodes
                // otherwise there will be empty parent nodes left in the doc
                view.dispatch(restoreOriginalUserContent(view.state.tr));
                // re-get pos after dispatch
                const _pluginState = (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(view.state);
                startPos = _pluginState?.startPos || startPos;
                toPos = _pluginState?.userContentEndPos || toPos;
                // Now we replace it with the AI response
                tr = commitFinalResponse({
                    tr: view.state.tr,
                    slice: slice
                });
                if (// We need to ensure we're not doubling up unified events. The streaming api (ie rovo chat) will also be firing
                // its own unified events. So we basically nuke all unified events from the streaming api.
                commonUnifiedAnalyticsData.invokedFrom !== 'streamingApi') // We fire the unified viewed event on the final stream because this is when all the AI content is known to be visible
                // to the user.
                // The view event previously fired in the preview modal. This will no longer occur in AIFC.
                api?.analytics?.actions.fireAnalyticsEvent((0, $ilIeg.createUnifiedAnalyticsPayload)({
                    action: (0, $d925B.ACTION).VIEWED,
                    ...commonUnifiedAnalyticsData,
                    interactionID: aiSessionId
                }));
            } else {
                tr = view.state.tr// End pos should never be smaller than start pos - for now just clamp it to start (to be reviewed)
                .replaceRange(startPos, toPos < startPos ? startPos : toPos, slice)// Local id updates break streaming as we may be trying
                // to replace a node that's already streamed in with
                // an empty local id -> causing the node to be destroyed and recreated
                // on the final stream we clean it up
                .setMeta('ignoreLocalIdUpdate', true);
                tr = (0, $eyHC2.metaTransaction)({
                    tr: tr,
                    isFinalStream: isFinalStream,
                    stackTime: streamTimeStamp
                });
            }
            const mappedStartPos = $bc1b0aa0b4af6d11$export$8c11be8ccd39ce0b({
                pos: startPos,
                tr: tr
            });
            let mappedToPos = $bc1b0aa0b4af6d11$export$3dcc2c094c7e6748({
                pos: toPos,
                tr: tr
            });
            let telepointerPos = mappedToPos;
            tr.doc.nodesBetween(mappedStartPos, mappedToPos, (node, pos)=>{
                if (node.isLeaf) telepointerPos = pos + node.nodeSize;
            });
            telepointerPos = Math.min(telepointerPos, mappedToPos);
            view.dispatch((0, $eyHC2.updateStreamPositions)({
                aiContentEndPos: toPos,
                telepointerPos: telepointerPos,
                isFinalStream: isFinalStream
            })(tr));
            // Expand all expand and nestedExpand nodes in the actual document after dispatching
            // Set expandedState after dispatch: only view.state.doc has the real nodes, not tr.doc.
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) api?.core.actions.execute(api?.expand?.commands.toggleExpandRange(mappedStartPos, Math.min(mappedToPos, view.state.doc.content.size)));
            else view.state.doc.nodesBetween(mappedStartPos, Math.min(mappedToPos, view.state.doc.content.size), (node)=>{
                if ([
                    expand,
                    nestedExpand
                ].includes(node.type)) (0, $adayn.expandedState).set(node, true);
            });
            isProgrammaticScroll.current = true;
            if (!hasUserScrolled && scrollParentRef.current) {
                const modalHeight = modalRef?.current?.offsetHeight || 0;
                // somehow we're getting pos out of range error here
                mappedToPos = (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(mappedToPos, 0, view.state.doc.content.size);
                let toPosBottom = view.coordsAtPos(mappedToPos).bottom;
                // somehow this coords could be all 0 when the mappedToPos is the last position of the doc
                if (toPosBottom === 0) toPosBottom = view.coordsAtPos(mappedToPos - 1).bottom;
                const bottomScrollTop = // offset of view dom from scroll parent
                (0, $3a34bf48b420323e$export$f9c4337e36118c2b)(view.dom, scrollParentRef.current) + // mappedToPos.bottom - 0.top is height of content
                view.coordsAtPos(mappedToPos).bottom - view.coordsAtPos(0).top + // extra margin so modal isn't in the way
                modalHeight + // extra margin so text isn't at the very very bottom
                $bc1b0aa0b4af6d11$var$SCROLL_MARGIN - // subtracting offsetHeight keeps content at the bottom so
                // auto-scrolling is more incremental
                scrollParentRef.current.offsetHeight;
                // when isFinalStream is true, scrollParentRef.current.scrollTop is 0,
                // maybe it's because we reset the doc content before committing the final response,
                // but it doesn't affect the result if we adjust the scrollTop
                if (scrollParentRef.current.scrollTop < bottomScrollTop) scrollParentRef.current?.scroll({
                    top: bottomScrollTop,
                    behavior: 'instant'
                });
            } else if (scrollParentRef.current && scrollParentRef.current.scrollTop !== scrollTop) scrollParentRef.current.scroll({
                top: scrollTop,
                behavior: 'instant'
            });
        } catch (error) {
            const errorMessage = (0, $2QlXt.ErrorUtils).extractErrorMessage(error);
            let errorStack = '';
            if (error instanceof Error) {
                errorStack = error.stack || '';
                (0, $hWRJP.logException)(error, {
                    location: 'editor-ai-streaming-update-stream',
                    isFinalStream: isFinalStream,
                    docSize: view.state.doc.content.size,
                    fragmentSize: fragment.size
                });
            }
            // https://atlassian-2y.sentry.io/issues/errors-outages/?project=4505129224110080&query=tags%5Blocation%5D%3Aeditor-ai-streaming-update-stream&referrer=issue-list&statsPeriod=14d
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).UPDATE_STREAM,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: errorMessage,
                    errorStack: errorStack,
                    isFinalStream: isFinalStream,
                    docSize: view.state.doc.content.size,
                    fragmentSize: fragment.size
                }
            });
            if (isFinalStream) throw error;
        }
    }, [
        api,
        view,
        modalRef,
        isSuggestTitle,
        restoreOriginalUserContent,
        commitFinalResponse,
        isEmptySelection,
        isProgrammaticScroll,
        commonUnifiedAnalyticsData,
        aiSessionId
    ]);
    const discardStream = (0, $42omo.useCallback)(({ restoreSelection: restoreSelection = true } = {})=>{
        const pluginState = (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(view.state);
        let { startPos: startPos, userContentEndPos: userContentEndPos } = pluginState || {};
        if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice.current) return;
        try {
            // undo only if we already have streamed AI content
            // which means non need to undo if there is no network response yet or we haven't streamed anything yet
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? !!aiContentSlice.current : true) {
                (0, $ke2AI.undo)(view.state, view.dispatch);
                // re-get pos after dispatch
                const _pluginState = (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(view.state);
                startPos = _pluginState?.startPos || startPos;
                userContentEndPos = _pluginState?.userContentEndPos || userContentEndPos;
            }
            let tr = view.state.tr;
            // We close the current history here.
            // We have a new history event when we do the discard, but when we close history we lock in the "mid-stream"
            // rather than an empty undo.
            (0, $ke2AI.closeHistory)(tr);
            const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(view.state);
            // If there was a session, don't restore the selection
            // because there might be multiple streaming updates, so we can't restore the selection
            if (restoreSelection && !decorationPluginState?.sessionEnded) {
                // restore user selection
                let anchor = 1;
                let head = 1;
                if (isEmptySelection) {
                    anchor = initialStartPos;
                    head = anchor;
                } else {
                    anchor = $bc1b0aa0b4af6d11$export$8c11be8ccd39ce0b({
                        pos: startPos,
                        tr: tr
                    });
                    head = $bc1b0aa0b4af6d11$export$3dcc2c094c7e6748({
                        pos: userContentEndPos,
                        tr: tr
                    });
                    if (decorationPluginState && decorationPluginState.initialSelection && decorationPluginState.initialSelection.head < decorationPluginState.initialSelection.anchor) [anchor, head] = [
                        head,
                        anchor
                    ];
                }
                tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, anchor, head));
            }
            // hide the highlight immediately after the stream is discarded
            // this is needed if we need to discard when the response is too similar
            tr = (0, $eyHC2.endStream)(tr);
            view.dispatch(tr);
        } catch (error) {
            const errorMessage = (0, $2QlXt.ErrorUtils).extractErrorMessage(error);
            let errorStack = '';
            if (error instanceof Error) {
                errorStack = error.stack || '';
                (0, $hWRJP.logException)(error, {
                    location: 'editor-ai-streaming-discard-stream'
                });
            }
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DISCARD_STREAM,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: errorMessage,
                    errorStack: errorStack
                }
            });
        } finally{
            // reset the stream state so that we can't discard again
            originalUserContentSlice.current = undefined;
            aiContentSlice.current = undefined;
        }
    }, [
        api,
        view,
        isEmptySelection,
        initialStartPos
    ]);
    return {
        mountDecorations: mountDecorations,
        updateStream: updateStream,
        discardStream: discardStream,
        /**
		 * @private
		 * @deprecated	This method was only added for testing purposes within unified-analytics.tsx
		 * 				and should be removed as soon as we have a better way to emulate multiple
		 * 				"mini-streams" within a session (e.g. during free-gen)
		 */ resetHasFinalStreamRef: ()=>hasFinalStreamRef.current = false
    };
};





const $ef407fc59b6ca435$var$initialState = {
    showHighlight: false,
    showAIContentHighlight: false,
    showTelepointer: false,
    isStreaming: false,
    isStreamingFinished: false,
    startPos: undefined,
    loadingPos: undefined,
    userContentEndPos: undefined,
    aiContentEndPos: undefined,
    telepointerPos: undefined,
    isFinalStream: false,
    chunkNumber: 0,
    streamTimeStamp: undefined
};
const $ef407fc59b6ca435$export$465eeb0611517dc = (options)=>{
    // Create the telepointer element
    const telepointerElement = (0, $f40d45a6cce8f6b7$export$b3d3cfdedcf26988)(options.getIntl().formatMessage((0, $7ShCl.aiMessages).aiRovoTelepointer));
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $5vNOi.inEditorDirectStreamingPluginKey),
        state: {
            init: ()=>{
                return $ef407fc59b6ca435$var$initialState;
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $5vNOi.inEditorDirectStreamingPluginKey));
                let newPluginState = pluginState;
                if (meta?.action) switch(meta.action){
                    case (0, $9F9dO.ACTIONS).INIT_POSITIONS:
                        {
                            const { positions: positions, showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer } = meta;
                            const { startPos: startPos, userContentEndPos: userContentEndPos, telepointerPos: telepointerPos } = positions;
                            newPluginState = {
                                ...newPluginState,
                                showHighlight: showHighlight,
                                showAIContentHighlight: showAIContentHighlight,
                                showTelepointer: showTelepointer,
                                isStreaming: true,
                                isStreamingFinished: false,
                                startPos: startPos,
                                loadingPos: startPos,
                                userContentEndPos: userContentEndPos,
                                telepointerPos: telepointerPos,
                                aiContentEndPos: undefined,
                                streamTimeStamp: Date.now()
                            };
                            break;
                        }
                    case (0, $9F9dO.ACTIONS).ADJUST_INIT_POSITIONS:
                        {
                            const { positions: positions } = meta;
                            const { startPos: startPos, userContentEndPos: userContentEndPos } = positions;
                            newPluginState = {
                                ...newPluginState,
                                startPos: startPos,
                                userContentEndPos: userContentEndPos
                            };
                            break;
                        }
                    case (0, $9F9dO.ACTIONS).UPDATE_LOADING_POSITIONS:
                        {
                            const { startPos: startPos, userContentEndPos: userContentEndPos, loadingPos: loadingPos } = pluginState;
                            if (startPos === undefined || userContentEndPos === undefined) break;
                            const max = userContentEndPos;
                            const min = loadingPos || startPos;
                            const eighth = (max - min) / 8;
                            const low = Math.floor(min + eighth);
                            const high = Math.ceil(min + 3 * eighth);
                            const newLoadingPos = Math.ceil(Math.random() * (high - low) + low);
                            newPluginState = {
                                ...newPluginState,
                                loadingPos: tr.mapping.map(newLoadingPos, -1)
                            };
                            break;
                        }
                    case (0, $9F9dO.ACTIONS).UPDATE_STREAM_POSITIONS:
                        {
                            const { positions: positions, isFinalStream: isFinalStream } = meta;
                            const { aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos } = positions;
                            newPluginState = {
                                ...newPluginState,
                                // when final stream, hide highlight for accept reject screen
                                ...isFinalStream ? {
                                    showHighlight: false,
                                    showAIContentHighlight: false,
                                    showTelepointer: false
                                } : {},
                                loadingPos: undefined,
                                aiContentEndPos: aiContentEndPos,
                                telepointerPos: telepointerPos,
                                isFinalStream: isFinalStream,
                                // when auto accept AI changes is off, isStreaming should be false once we have the final stream
                                // otherwise, ai orchestrator endExperiencePromise will timeout
                                isStreaming: !isFinalStream,
                                isStreamingFinished: isFinalStream,
                                chunkNumber: newPluginState.chunkNumber + 1,
                                // Ensure the streaming timestamp is updated so it's > previous value (for history plugin)
                                streamTimeStamp: newPluginState.streamTimeStamp ? newPluginState.streamTimeStamp + 1 : undefined
                            };
                            break;
                        }
                    case (0, $9F9dO.ACTIONS).END_STREAM:
                        return {
                            ...$ef407fc59b6ca435$var$initialState,
                            // the telepointer position should be reset on init, however we want to remember the last position until then.
                            telepointerPos: newPluginState.telepointerPos
                        };
                }
                else // These positions will be mapped by the plugin's transaction
                // So we map them only when the transaction is not related to the plugin
                newPluginState = {
                    ...newPluginState,
                    ...newPluginState.loadingPos !== undefined && {
                        loadingPos: tr.mapping.map(newPluginState.loadingPos, -1)
                    },
                    ...newPluginState.telepointerPos !== undefined && {
                        telepointerPos: tr.mapping.map(newPluginState.telepointerPos, -1)
                    }
                };
                newPluginState = {
                    ...newPluginState,
                    ...newPluginState.startPos !== undefined && {
                        startPos: (0, $bc1b0aa0b4af6d11$export$8c11be8ccd39ce0b)({
                            pos: newPluginState.startPos,
                            tr: tr
                        })
                    },
                    ...newPluginState.userContentEndPos !== undefined && {
                        userContentEndPos: (0, $bc1b0aa0b4af6d11$export$3dcc2c094c7e6748)({
                            pos: newPluginState.userContentEndPos,
                            tr: tr
                        })
                    },
                    ...newPluginState.aiContentEndPos !== undefined && {
                        aiContentEndPos: (0, $bc1b0aa0b4af6d11$export$3dcc2c094c7e6748)({
                            pos: newPluginState.aiContentEndPos,
                            tr: tr
                        })
                    }
                };
                return newPluginState;
            }
        },
        props: {
            decorations: (state)=>{
                const pluginState = (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(state);
                const { showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, startPos: startPos, userContentEndPos: userContentEndPos, aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, loadingPos: loadingPos, isFinalStream: isFinalStream, isStreaming: isStreaming } = pluginState || {};
                const decorations = [];
                if (!isStreaming || startPos === undefined) {
                    // If streaming stops and theres still and active session, then we need to ensure that the telepointer remains
                    // visible on the page up until the ai session is ended.
                    const { nextSessionId: nextSessionId } = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) || {};
                    if (!!nextSessionId && telepointerPos !== undefined) return (0, $ftzrq.DecorationSet).create(state.doc, [
                        (0, $f40d45a6cce8f6b7$export$3f4dbbc6f36d65d4)(telepointerPos, telepointerElement)
                    ]);
                    return (0, $ftzrq.DecorationSet).empty;
                }
                if (showHighlight) {
                    if (loadingPos !== undefined) decorations.push((0, $ftzrq.Decoration).inline(startPos, loadingPos, {
                        class: 'ai-in-editor-user-content',
                        'data-testid': 'ai-in-editor-user-content'
                    }));
                    else if (userContentEndPos !== undefined) decorations.push((0, $ftzrq.Decoration).inline(aiContentEndPos || startPos, userContentEndPos, {
                        class: 'ai-in-editor-user-content',
                        'data-testid': 'ai-in-editor-user-content'
                    }));
                    if (showAIContentHighlight && aiContentEndPos !== undefined) decorations.push((0, $ftzrq.Decoration).inline(startPos, aiContentEndPos, {
                        class: 'ai-in-editor-ai-content',
                        'data-testid': 'ai-in-editor-ai-content'
                    }));
                }
                /**
         * We show the telepointer only when isFinalStream is false.
         * On the final stream, plugin state is reset so isFinalStream will be undefined.
         */ if (isFinalStream === false && showTelepointer) decorations.push((0, $f40d45a6cce8f6b7$export$3f4dbbc6f36d65d4)(telepointerPos || aiContentEndPos || startPos, telepointerElement));
                else {
                    // If the telepointer is not being shown, and there is a next session id set, then we can renderer a temporary
                    // telepointer ad the current selection position
                    const { nextSessionId: nextSessionId } = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) || {};
                    if (!!nextSessionId && telepointerPos !== undefined) decorations.push((0, $f40d45a6cce8f6b7$export$3f4dbbc6f36d65d4)(telepointerPos, telepointerElement));
                }
                if (decorations.length) return (0, $ftzrq.DecorationSet).create(state.doc, decorations);
                return (0, $ftzrq.DecorationSet).empty;
            }
        },
        view () {
            let hasReset = false;
            let wasPreviouslyStreaming = false;
            let cursorHiddenState = false;
            let originalTabIndex;
            let originalOutlineColor;
            let originalOutline;
            return {
                update (view) {
                    const { currentSessionId: currentSessionId } = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(view.state) || {};
                    const pluginState = (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(view.state);
                    const { isStreaming: isStreaming = false, isStreamingFinished: isStreamingFinished = false } = pluginState || {};
                    const isActive = !!currentSessionId || isStreaming || isStreamingFinished;
                    const editorContentArea = view?.dom.closest('.ak-editor-content-area');
                    if (originalTabIndex === undefined && editorContentArea) {
                        originalTabIndex = editorContentArea.tabIndex;
                        originalOutlineColor = editorContentArea.style.outlineColor;
                        originalOutline = editorContentArea.style.outline;
                    }
                    // Handle cursor visibility
                    if (isActive !== wasPreviouslyStreaming) {
                        if (isActive && !cursorHiddenState) {
                            cursorHiddenState = true;
                            options.api?.core.actions.execute(options.api?.selection?.commands.hideCursor(true));
                        } else if (!isActive && cursorHiddenState) {
                            cursorHiddenState = false;
                            options.api?.core.actions.execute(options.api?.selection?.commands.hideCursor(false));
                        }
                    }
                    // At the start of streaming reset
                    if (isActive && !hasReset) {
                        hasReset = true;
                        options.api?.core?.actions.execute(({ tr: tr })=>{
                            options.api?.trackChanges?.commands.resetBaseline({
                                tr: tr
                            });
                            options.api?.userIntent?.commands.setCurrentUserIntent('aiStreaming')({
                                tr: tr
                            });
                            options.api?.editorDisabled?.commands.toggleDisabled(true)({
                                tr: tr
                            });
                            return tr;
                        });
                        // when we disable editor while streaming, document.body will be focused
                        // we need to focus editor to make pressing esc to work
                        if (editorContentArea) {
                            editorContentArea.tabIndex = -1;
                            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) editorContentArea.style.outline = 'none';
                            else editorContentArea.style.outlineColor = 'transparent';
                            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                                if (editorContentArea && !editorContentArea.contains(document.activeElement)) editorContentArea.focus();
                            } else editorContentArea.focus();
                        }
                    }
                    // When streaming concludes allow for
                    if (!isActive && hasReset) {
                        hasReset = false;
                        options.api?.core?.actions.execute(({ tr: tr })=>{
                            options.api?.userIntent?.commands.setCurrentUserIntent('default')({
                                tr: tr
                            });
                            options.api?.editorDisabled?.commands.toggleDisabled(false)({
                                tr: tr
                            });
                            return tr;
                        });
                        if (editorContentArea) {
                            if (originalTabIndex !== undefined) {
                                if (originalTabIndex === -1) editorContentArea.removeAttribute('tabindex');
                                else editorContentArea.tabIndex = originalTabIndex;
                            }
                            if (originalOutlineColor !== undefined) {
                                editorContentArea.style.outlineColor = originalOutlineColor;
                                if (editorContentArea.getAttribute('style') === '') editorContentArea.removeAttribute('style');
                            }
                            if (originalOutline !== undefined) {
                                editorContentArea.style.outline = originalOutline;
                                if (editorContentArea.getAttribute('style') === '') editorContentArea.removeAttribute('style');
                            }
                        }
                    }
                    wasPreviouslyStreaming = isActive;
                }
            };
        }
    });
};





var $3ebfa284e46a7bd4$export$ae8cf7712eb9509e = /*#__PURE__*/ function(AI_SUGGESTION_TRIGGERED_FROM) {
    AI_SUGGESTION_TRIGGERED_FROM["ENTER_BUTTON"] = "enterKeydown";
    AI_SUGGESTION_TRIGGERED_FROM["TAB_BUTTON"] = "tabKeydown";
    AI_SUGGESTION_TRIGGERED_FROM["ESCAPE_BUTTON"] = "escapeKeydown";
    AI_SUGGESTION_TRIGGERED_FROM["TOOLBAR"] = "toolbar";
    return AI_SUGGESTION_TRIGGERED_FROM;
}({});




















const $3b5f4e0ab92501a6$export$75940366de9545d9 = new (0, $ks2lK.PluginKey)('aiInlineSuggestion');


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead






var $77ebba5aaa328fa7$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["CLEAR_INLINE_SUGGESTION"] = "CLEAR_INLINE_SUGGESTION";
    ACTIONS["UPDATE_INLINE_SUGGESTION"] = "UPDATE_INLINE_SUGGESTION";
    ACTIONS["UPDATE_LOCALE"] = "UPDATE_LOCALE";
    return ACTIONS;
}({});


const $0d11a1b930ae92a0$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case (0, $77ebba5aaa328fa7$export$92a1a3b7554e9387).CLEAR_INLINE_SUGGESTION:
            return {
                ...pluginState,
                inlineSuggestion: null,
                decorationSet: (0, $ftzrq.DecorationSet).empty,
                inlineSuggestionSessionId: null
            };
        case (0, $77ebba5aaa328fa7$export$92a1a3b7554e9387).UPDATE_INLINE_SUGGESTION:
            {
                let sessionID = null;
                if (action.payload.inlineSuggestion) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                sessionID = pluginState.inlineSuggestion ? pluginState.inlineSuggestionSessionId : (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
                return {
                    ...pluginState,
                    inlineSuggestion: action.payload.inlineSuggestion,
                    decorationSet: action.payload.decorationSet,
                    inlineSuggestionSessionId: sessionID
                };
            }
        case (0, $77ebba5aaa328fa7$export$92a1a3b7554e9387).UPDATE_LOCALE:
            return {
                ...pluginState,
                locale: action.payload.locale
            };
        default:
            return pluginState;
    }
};


function $f60ba1d011d7390b$var$isSelectionNotInSuggestion({ selectionFrom: selectionFrom, selectionTo: selectionTo, suggestionFrom: suggestionFrom, suggestionTo: suggestionTo }) {
    return selectionTo < suggestionFrom || selectionFrom > suggestionTo;
}
function $f60ba1d011d7390b$var$onSelectionChanged(tr, pluginState) {
    const { inlineSuggestion: inlineSuggestion } = pluginState;
    if (!inlineSuggestion) return pluginState;
    const { from: from, to: to } = inlineSuggestion;
    const { from: selectionFrom, to: selectionTo } = tr.selection;
    if ($f60ba1d011d7390b$var$isSelectionNotInSuggestion({
        selectionFrom: selectionFrom,
        selectionTo: selectionTo,
        suggestionFrom: from,
        suggestionTo: to
    })) return {
        ...pluginState,
        inlineSuggestion: null,
        decorationSet: (0, $ftzrq.DecorationSet).empty,
        inlineSuggestionSessionId: null
    };
    return pluginState;
}
function $f60ba1d011d7390b$var$mapSuggestionPositions(tr, pluginState, _editorState) {
    const { inlineSuggestion: inlineSuggestion } = pluginState;
    if (!inlineSuggestion) return pluginState;
    return {
        ...pluginState,
        inlineSuggestion: {
            ...inlineSuggestion,
            from: tr.mapping.map(inlineSuggestion.from),
            to: tr.mapping.map(inlineSuggestion.to)
        },
        decorationSet: pluginState.decorationSet.map(tr.mapping, tr.doc)
    };
}
const $f60ba1d011d7390b$export$de5e90bd767c5d82 = ({ locale: locale })=>{
    return {
        inlineSuggestion: null,
        locale: locale,
        decorationSet: (0, $ftzrq.DecorationSet).empty,
        inlineSuggestionSessionId: null
    };
};
const { createPluginState: $f60ba1d011d7390b$export$656c7661095efe2e, createCommand: $f60ba1d011d7390b$export$8d4021544bdece00, getPluginState: $f60ba1d011d7390b$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $3b5f4e0ab92501a6$export$75940366de9545d9), (0, $0d11a1b930ae92a0$export$1650419e431d3ba3), {
    onSelectionChanged: $f60ba1d011d7390b$var$onSelectionChanged,
    mapping: $f60ba1d011d7390b$var$mapSuggestionPositions
});



function $9f1a7e01d4004520$export$351bd6e47d1cc1d0() {
    return (0, $f60ba1d011d7390b$export$8d4021544bdece00)(()=>({
            type: (0, $77ebba5aaa328fa7$export$92a1a3b7554e9387).CLEAR_INLINE_SUGGESTION
        }), (tr, state)=>{
        const { inlineSuggestion: inlineSuggestion } = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(state);
        if (!inlineSuggestion) return tr;
        tr.replaceWith(inlineSuggestion.from, inlineSuggestion.to, inlineSuggestion.suggestedNode);
        tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(inlineSuggestion.from + inlineSuggestion.suggestedNode.nodeSize)));
        return tr;
    });
}
function $9f1a7e01d4004520$export$8cf80a50b9a4edd8() {
    return (0, $f60ba1d011d7390b$export$8d4021544bdece00)(()=>({
            type: (0, $77ebba5aaa328fa7$export$92a1a3b7554e9387).CLEAR_INLINE_SUGGESTION
        }));
}
function $9f1a7e01d4004520$export$c0b81cca6dd83656(inlineSuggestion, decorationSet) {
    return (0, $f60ba1d011d7390b$export$8d4021544bdece00)(()=>({
            type: (0, $77ebba5aaa328fa7$export$92a1a3b7554e9387).UPDATE_INLINE_SUGGESTION,
            payload: {
                inlineSuggestion: inlineSuggestion,
                decorationSet: decorationSet
            }
        }));
}
function $9f1a7e01d4004520$export$c1428fdaca6ad73f(locale) {
    return (0, $f60ba1d011d7390b$export$8d4021544bdece00)(()=>({
            type: (0, $77ebba5aaa328fa7$export$92a1a3b7554e9387).UPDATE_LOCALE,
            payload: {
                locale: locale
            }
        }));
}



var $8Yfbq = parcelRequire("8Yfbq");






// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead




var $2wblJ = parcelRequire("2wblJ");

var $cFEpk = parcelRequire("cFEpk");

var $bJbIe = parcelRequire("bJbIe");





class $517812094daeefb0$export$68c21ead5a95ee64 {
    static getTextPhrasesAroundCursor(state) {
        const { selection: selection } = state;
        if (!selection || selection.from !== selection.to) return [];
        const { $from: $from } = selection;
        const parent = $from.parent;
        const parentStart = $from.start($from.depth);
        const parentOffset = $from.parentOffset;
        const segments = this.extractPlainTextSegments(parent);
        const segment = this.findSegmentForCursor(segments, parentOffset);
        if (!segment) return [];
        const offsetInSegment = parentOffset - segment.from;
        const words = this.extractWordsFromSegment(segment);
        if (!words.length) return [];
        if (!this.isCursorTouchingWord(words, offsetInSegment)) return [];
        const centralWordIndex = this.findCentralWordIndex(words, offsetInSegment);
        const { nearbyWords: nearbyWords, centralWordPos: centralWordPos } = this.extractNearbyWords(words, centralWordIndex, parentStart, segment.from);
        return this.generateTextPhrases(nearbyWords, centralWordPos);
    }
    static extractPlainTextSegments(parent) {
        const segments = [];
        let currentSegment = null;
        const flushSegment = ()=>{
            if (currentSegment) {
                segments.push(currentSegment);
                currentSegment = null;
            }
        };
        const isPlainText = (child)=>child.isText && !child.marks?.some((mark)=>mark.type.name === 'link');
        parent.forEach((child, offset)=>{
            if (isPlainText(child)) {
                const text = child.text || '';
                if (currentSegment && offset === currentSegment.to) {
                    currentSegment.text += text;
                    currentSegment.to += text.length;
                } else {
                    flushSegment();
                    currentSegment = {
                        text: text,
                        from: offset,
                        to: offset + text.length
                    };
                }
            } else flushSegment();
        });
        flushSegment();
        return segments;
    }
    static findSegmentForCursor(segments, parentOffset) {
        return segments.find((seg)=>parentOffset >= seg.from && parentOffset <= seg.to) || null;
    }
    static isCursorTouchingWord(words, relativeOffset) {
        return words.some((word)=>relativeOffset >= word.start && relativeOffset <= word.end);
    }
    static extractWordsFromSegment(segment) {
        const words = [];
        for (const match of segment.text.matchAll(this.WORD_REGEX))words.push({
            text: match[0],
            start: match.index,
            end: match.index + match[0].length
        });
        return words;
    }
    static findCentralWordIndex(words, cursorOffset) {
        if (words.length === 0) return 0;
        const lastIndex = words.length - 1;
        if (cursorOffset > words[lastIndex].end) return lastIndex;
        let idx = words.findIndex((w)=>w.start <= cursorOffset && w.end >= cursorOffset);
        if (idx === -1) idx = words.findIndex((w)=>w.end === cursorOffset);
        return idx === -1 ? lastIndex : idx;
    }
    static extractNearbyWords(words, centralIndex, basePos, segmentFrom) {
        const adjustWord = (w)=>({
                word: w.text,
                from: basePos + segmentFrom + w.start,
                to: basePos + segmentFrom + w.end
            });
        const startIndex = Math.max(0, centralIndex - this.WORDS_BEFORE_CENTRAL);
        const leftWords = words.slice(startIndex, centralIndex + 1).map(adjustWord);
        const rightWords = words.slice(centralIndex + 1, centralIndex + 1 + this.WORDS_AFTER_CENTRAL).map(adjustWord);
        return {
            nearbyWords: leftWords.concat(rightWords),
            centralWordPos: leftWords.length - 1
        };
    }
    static generateTextPhrases(nearbyWords, centralIndex) {
        const phrases = [];
        for(let start = 0; start <= centralIndex; start++)for(let end = centralIndex; end < nearbyWords.length; end++){
            const phrase = nearbyWords.slice(start, end + 1).map((w)=>w.word).join(' ');
            phrases.push({
                phrase: phrase,
                from: nearbyWords[start].from,
                to: nearbyWords[end].to
            });
        }
        return phrases;
    }
}
// Matches any non-whitespace character
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
$517812094daeefb0$export$68c21ead5a95ee64.WORD_REGEX = /\S+/gu;
$517812094daeefb0$export$68c21ead5a95ee64.WORDS_BEFORE_CENTRAL = 4;
$517812094daeefb0$export$68c21ead5a95ee64.WORDS_AFTER_CENTRAL = 2;
class $517812094daeefb0$export$94affb487e701bf2 {
    get(key, compute) {
        if (this.store.has(key)) {
            const value = this.store.get(key);
            if (value) return value;
        }
        const value = compute();
        if (value) this.set(key, value);
        return value;
    }
    set(key, value) {
        if (this.store.size >= this.maxSize) {
            const oldestKey = this.store.keys().next().value;
            if (oldestKey) this.store.delete(oldestKey);
        }
        this.store.set(key, value);
    }
    constructor(maxSize = 10000){
        this.maxSize = maxSize;
        this.store = new Map();
        this.maxSize = maxSize;
    }
}


/* eslint-disable @atlaskit/editor/no-re-export */ 
var $e6KrE = parcelRequire("e6KrE");

var $9gbhg = parcelRequire("9gbhg");

const $c9453c526aca8e3c$export$94d2d72df36bbb16 = [
    'en-US',
    'en-GB'
];
const $c9453c526aca8e3c$export$17a6a815985c8621 = (locale)=>$c9453c526aca8e3c$export$94d2d72df36bbb16.includes(locale);
// Numeric Date Formats for en-US
const $c9453c526aca8e3c$var$NUMERIC_FORMATS_EN_US = [
    // ====================================================
    // Numeric Date Formats
    // ====================================================
    // Full Dates (4-digit year)
    'M/d/yyyy',
    'M-d-yyyy',
    'yyyy-MM-dd',
    'yyyy/MM/dd',
    // Partial Dates (Numeric, no year – defaults to current year)
    'M/d'
];
// Numeric Date Formats for en-GB
const $c9453c526aca8e3c$var$NUMERIC_FORMATS_EN_GB = [
    // ====================================================
    // Numeric Date Formats
    // ====================================================
    // Full Dates (4-digit year)
    'd/M/yyyy',
    'd-M-yyyy',
    'yyyy-MM-dd',
    'yyyy/MM/dd',
    // Partial Dates (Numeric, no year – defaults to current year)
    'd/M'
];
// Shared Month Name Formats (used by both en-US and en-GB)
const $c9453c526aca8e3c$var$SHARED_MONTH_NAME_FORMATS = [
    // ====================================================
    // Month Name Date Formats
    // ====================================================
    // Full Dates (4-digit year)
    'd MMM yyyy',
    'd MMMM yyyy',
    "MMMM d', 'yyyy",
    'MMMM d yyyy',
    "MMM d', 'yyyy",
    'MMM d yyyy',
    // Full Dates (Month Name and ordinals, year)
    "do 'of' MMMM yyyy",
    // Partial Dates (Month Name, no year – defaults to current year)
    'd MMMM',
    'd MMM',
    'MMMM d',
    'MMM d',
    'do MMMM',
    'do MMM',
    'MMMM do',
    'MMM do',
    "do 'of' MMMM",
    "do 'of' MMM"
];
const $c9453c526aca8e3c$export$45f7fd8a58803cb5 = {
    'en-US': [
        ...$c9453c526aca8e3c$var$NUMERIC_FORMATS_EN_US,
        ...$c9453c526aca8e3c$var$SHARED_MONTH_NAME_FORMATS
    ],
    'en-GB': [
        ...$c9453c526aca8e3c$var$NUMERIC_FORMATS_EN_GB,
        ...$c9453c526aca8e3c$var$SHARED_MONTH_NAME_FORMATS
    ]
};
const $c9453c526aca8e3c$export$1ff91fc1b670f83b = {
    'en-US': (0, $9gbhg.default),
    'en-GB': (0, $e6KrE.default)
};


class $15cece9afc52d932$export$9a5c40674650b7fa {
    static getSelectedLocale(state) {
        const pluginState = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(state);
        return pluginState?.locale || 'en-US';
    }
}
$15cece9afc52d932$export$9a5c40674650b7fa.LOCALES = (0, $c9453c526aca8e3c$export$1ff91fc1b670f83b);
class $15cece9afc52d932$export$e8d4b28a20981dd2 {
    static isPotentialDateString(input) {
        return this.REGEXES.DIGITS.test(input) && input.length >= this.MIN_DATE_LENGTH && input.length <= this.MAX_DATE_LENGTH;
    }
    static containsAmbiguousMonth(input) {
        const matches = input.match(this.REGEXES.ALL_ALPHABET_CHARS);
        if (!matches) return false;
        const longestTokenLength = matches.reduce((max, token)=>Math.max(max, token.length), 0);
        return longestTokenLength <= 2;
    }
    static containsYear(format) {
        return format.includes('y');
    }
    static isEnteredDateAfterToday(date) {
        const today = new Date();
        const todayDate = today.getDate();
        const todayMonth = today.getMonth() + 1;
        // If it's the same month and day as today, consider it as "after or equal to" today
        if (todayMonth === date.getMonth() + 1 && todayDate === date.getDate()) return true;
        // Check if today's date is before the entered date (comparing month and day only)
        // Case 1: Today's month is earlier than the entered month
        // Case 2: Same month, but today's day is earlier than the entered day
        return todayMonth < date.getMonth() + 1 || todayMonth === date.getMonth() + 1 && todayDate < date.getDate();
    }
    static normaliseYear(date, format) {
        const year = date.getFullYear();
        const isEnteredDateAfterToday = this.isEnteredDateAfterToday(date);
        if (year < 100) date = (0, $2wblJ.default)(date, year < this.SHORT_YEAR_CUTOFF ? 2000 : 1900);
        else if (year < 1000) date = (0, $2wblJ.default)(date, 2000);
        else if (!this.containsYear(format) && (0, $1oCLl.expValEquals)('platform_editor_ai_exp_inline_date_year_refresh', 'isEnabled', true)) // This only applies for partial numeric formats.
        // If the entered date is after today, add 0 years. Otherwise, add 1 year
        // If it's equal to today, add 0 years.
        date = (0, $2wblJ.default)(date, isEnteredDateAfterToday ? 0 : 1);
        return date;
    }
    static analyzeDelimiters(input) {
        const delimiterMatches = input.match((0, $1oCLl.expValEquals)('platform_editor_ai_exp_suggestion_date_comma_delim', 'isEnabled', true) ? this.REGEXES.ALL_DATE_DELIMITERS_COMMA : this.REGEXES.ALL_DATE_DELIMITERS) || [];
        const uniqueDelims = new Set(delimiterMatches);
        const hasMixedDelimiters = uniqueDelims.size > 1;
        const trailingCharMatch = input.match((0, $1oCLl.expValEquals)('platform_editor_ai_exp_suggestion_date_comma_delim', 'isEnabled', true) ? this.REGEXES.TRAILING_DATE_DELIMITER_COMMA : this.REGEXES.TRAILING_DATE_DELIMITER);
        let trailingDelimiter = null;
        let strippedInput = input;
        if (trailingCharMatch) {
            trailingDelimiter = trailingCharMatch[0];
            strippedInput = input.slice(0, -1);
        }
        return {
            hasMixedDelimiters: hasMixedDelimiters,
            trailingDelimiter: trailingDelimiter,
            strippedInput: strippedInput
        };
    }
    static tryAllFormats(strippedInput, trailingDelimiter, locale) {
        if (!(0, $c9453c526aca8e3c$export$17a6a815985c8621)(locale)) return null;
        const dateFnsLocale = $15cece9afc52d932$export$9a5c40674650b7fa.LOCALES[locale];
        const formats = this.DATE_FORMATS_BY_LOCALE[locale];
        for (const format of formats){
            const parsed = (0, $bJbIe.default)(strippedInput, format, new Date(), {
                locale: dateFnsLocale
            });
            if ((0, $cFEpk.default)(parsed)) return {
                date: this.normaliseYear(parsed, format),
                matchedFormat: format,
                trailingDelimiter: trailingDelimiter
            };
        }
        return null;
    }
    static parse(input, locale) {
        if (!this.isPotentialDateString(input) || this.containsAmbiguousMonth(input)) return null;
        const { hasMixedDelimiters: hasMixedDelimiters, trailingDelimiter: trailingDelimiter, strippedInput: strippedInput } = this.analyzeDelimiters(input);
        if (hasMixedDelimiters) return null;
        return this.cache.get(`${locale}:${input}`, ()=>{
            return this.tryAllFormats(strippedInput, trailingDelimiter, locale);
        });
    }
    static extractDelimiterFromFormat(matchedFormat) {
        return matchedFormat.match(this.REGEXES.NON_ALPHABET_CHARS)?.[0] ?? ' ';
    }
}
$15cece9afc52d932$export$e8d4b28a20981dd2.MIN_DATE_LENGTH = 3;
$15cece9afc52d932$export$e8d4b28a20981dd2.MAX_DATE_LENGTH = 20;
$15cece9afc52d932$export$e8d4b28a20981dd2.SHORT_YEAR_CUTOFF = 60;
$15cece9afc52d932$export$e8d4b28a20981dd2.DATE_FORMATS_BY_LOCALE = (0, $c9453c526aca8e3c$export$45f7fd8a58803cb5);
$15cece9afc52d932$export$e8d4b28a20981dd2.REGEXES = {
    // Reference to make sure to clean up this when cleaning up platform_editor_ai_exp_suggestion_date_comma_delim
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    TRAILING_DATE_DELIMITER_COMMA: /[-/.,]$/u,
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    ALL_DATE_DELIMITERS_COMMA: /[-/.,]/gu,
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    TRAILING_DATE_DELIMITER: /[-/.]$/u,
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    ALL_DATE_DELIMITERS: /[-/.]/gu,
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    NON_ALPHABET_CHARS: /[^A-Za-z]/u,
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    ALL_ALPHABET_CHARS: /[A-Za-z]+/gu,
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    DIGITS: /\d/u
};
$15cece9afc52d932$export$e8d4b28a20981dd2.cache = new (0, $517812094daeefb0$export$94affb487e701bf2)();
class $15cece9afc52d932$export$3e048df13f4eb60b {
    static getDateOnlyUtcTimestamp(date) {
        return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    }
    static canInsertDateNode(state, pos) {
        const dateType = state?.schema?.nodes?.date;
        if (!dateType) return false;
        const $pos = state.doc.resolve(pos);
        return $pos.parent.canReplaceWith($pos.index(), $pos.index(), dateType);
    }
}
class $15cece9afc52d932$export$cc88dec3a6065079 {
    static sortByDescendingRangeLength(phrases) {
        return phrases.slice().sort((a, b)=>{
            const aLength = a.to - a.from;
            const bLength = b.to - b.from;
            return bLength - aLength;
        });
    }
    static findFirstValidDatePhrase(phrases, locale) {
        for (const phrase of phrases){
            const result = $15cece9afc52d932$export$e8d4b28a20981dd2.parse(phrase.phrase, locale);
            if (result) return {
                phrase: phrase,
                result: result
            };
        }
        return null;
    }
}


const $7926a8fbf7089314$export$d69b88be852b7d7f = {
    type: 'date',
    detect (state, cursorPhrases) {
        const locale = (0, $15cece9afc52d932$export$9a5c40674650b7fa).getSelectedLocale(state);
        const sortedPhrases = (0, $15cece9afc52d932$export$cc88dec3a6065079).sortByDescendingRangeLength(cursorPhrases);
        const match = (0, $15cece9afc52d932$export$cc88dec3a6065079).findFirstValidDatePhrase(sortedPhrases, locale);
        if (!match || !(0, $15cece9afc52d932$export$3e048df13f4eb60b).canInsertDateNode(state, match.phrase.from)) return null;
        return {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            id: (0, $dQl1W.v4)(),
            type: 'date',
            from: match.phrase.from,
            to: match.phrase.to,
            metadata: {
                date: match.result.date,
                matchedFormat: match.result.matchedFormat,
                trailingDelimiter: match.result.trailingDelimiter
            },
            isPartial: !match.result.matchedFormat.includes('y')
        };
    },
    createMarkers (suggestion) {
        const { from: from, to: to } = suggestion;
        return [
            {
                style: 'highlight',
                from: from,
                to: to
            },
            {
                style: 'underline',
                from: from,
                to: to
            }
        ];
    },
    createCompletionHint (suggestion) {
        if (!suggestion.isPartial) return null;
        const { date: date, matchedFormat: matchedFormat, trailingDelimiter: trailingDelimiter } = suggestion.metadata;
        const formatDelimiter = (0, $15cece9afc52d932$export$e8d4b28a20981dd2).extractDelimiterFromFormat(matchedFormat);
        if (trailingDelimiter && trailingDelimiter === formatDelimiter) return {
            hintText: `${date.getFullYear()}`
        };
        else return {
            hintText: `${formatDelimiter}${date.getFullYear()}`
        };
    },
    createReplacement (suggestion, schema) {
        const { date: date } = suggestion.metadata;
        const timestamp = (0, $15cece9afc52d932$export$3e048df13f4eb60b).getDateOnlyUtcTimestamp(date);
        return schema.nodes.date.create({
            timestamp: String(timestamp)
        });
    }
};



class $49ae62cb4df29db1$export$3582487b0804e1f6 {
    detectFirstSuggestion(state, cursorPhrases) {
        for (const handler of this.handlers){
            const match = handler.detect(state, cursorPhrases);
            if (match) {
                const node = handler.createReplacement(match, state.schema);
                return {
                    ...match,
                    suggestedNode: node
                };
            }
        }
        return null;
    }
    scheduleScanForSuggestions(view) {
        this.throttledDetection(view);
    }
    cancelSuggestionScans() {
        this.throttledDetection.cancel();
    }
    createMarkerDecoration(marker) {
        const addClass = $49ae62cb4df29db1$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES[marker.style];
        const decoClass = [
            marker.cssClass,
            addClass
        ].filter(Boolean).join(' ');
        return (0, $ftzrq.Decoration).inline(marker.from, marker.to, {
            class: decoClass.trim()
        });
    }
    /**
   * Creates an inline decoration whose DOM element serves as a positioning
   * anchor for the Suggestion popup (i.e. the floating toolbar).
   */ createToolbarDecoration(from, to) {
        return (0, $ftzrq.Decoration).inline(from, to, {
            class: $49ae62cb4df29db1$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES.toolbarAnchor
        });
    }
    createCompletionHintDecorations(suggestion, state) {
        const handler = this.handlers.find((handler)=>handler.type === suggestion.type);
        if (handler && handler.createCompletionHint) {
            const hint = handler.createCompletionHint(suggestion, state);
            if (hint) return [
                (0, $ftzrq.Decoration).widget(suggestion.to, ()=>{
                    const container = document.createElement('span');
                    container.className = [
                        $49ae62cb4df29db1$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES.completionHint,
                        $49ae62cb4df29db1$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES.underline,
                        $49ae62cb4df29db1$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES.highlight
                    ].join(' ');
                    const textSpan = document.createElement('span');
                    textSpan.textContent = hint.hintText;
                    container.appendChild(textSpan);
                    return container;
                }, {
                    side: 1,
                    type: $49ae62cb4df29db1$export$3582487b0804e1f6.DECORATION_TYPES.completionHint
                })
            ];
        }
        return [];
    }
    rebuildSuggestionDecorations(suggestion, state, prevDecoSet) {
        if (!suggestion) return (0, $ftzrq.DecorationSet).empty;
        const regionDecos = prevDecoSet.find(suggestion.from, suggestion.to);
        const cleanSet = prevDecoSet.remove(regionDecos);
        const handler = this.handlers.find((handler)=>handler.type === suggestion.type);
        if (!handler) return cleanSet;
        const markers = handler.createMarkers(suggestion, state);
        const markerDecos = markers.map((marker)=>this.createMarkerDecoration(marker));
        const toolbarDeco = this.createToolbarDecoration(suggestion.from, suggestion.to);
        const newDecos = [
            ...markerDecos,
            toolbarDeco
        ];
        const hintDecos = this.createCompletionHintDecorations(suggestion, state);
        newDecos.push(...hintDecos);
        return cleanSet.add(state.doc, newDecos);
    }
    constructor(){
        this.THROTTLE_MS = 100;
        this.handlers = [
            (0, $7926a8fbf7089314$export$d69b88be852b7d7f)
        ];
        this.throttledDetection = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))((view)=>{
            try {
                const { state: state, dispatch: dispatch } = view;
                const pluginState = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(state);
                const prevSug = pluginState.inlineSuggestion;
                const prevDecos = pluginState.decorationSet;
                const cursorPhrases = (0, $517812094daeefb0$export$68c21ead5a95ee64).getTextPhrasesAroundCursor(state);
                const currSug = this.detectFirstSuggestion(state, cursorPhrases);
                const isNoSuggestionChange = prevSug === null && currSug === null;
                if (isNoSuggestionChange) return;
                const updatedDecos = this.rebuildSuggestionDecorations(currSug, state, prevDecos);
                (0, $9f1a7e01d4004520$export$c0b81cca6dd83656)(currSug, updatedDecos)(state, dispatch);
            } catch (err) {
            // HOT-118204: swallow uncaught errors for now to prevent collab catchup failures
            }
        }, this.THROTTLE_MS, {
            leading: false,
            trailing: true
        });
    }
}
$49ae62cb4df29db1$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES = {
    underline: 'proactive-ai-inline-suggestion-underline',
    highlight: 'proactive-ai-inline-suggestion-highlight',
    toolbarAnchor: 'proactive-ai-inline-suggestion-floating-toolbar-anchor',
    completionHint: 'proactive-ai-inline-suggestion-completion-hint'
};
$49ae62cb4df29db1$export$3582487b0804e1f6.DECORATION_TYPES = {
    completionHint: 'completionHint'
};
const $49ae62cb4df29db1$export$fd041caf0943d29 = new $49ae62cb4df29db1$export$3582487b0804e1f6();








var $dAtrv = parcelRequire("dAtrv");



const $2356c0ded658404c$var$getInlineSuggestionDetails = (state)=>{
    const pluginState = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(state);
    const { inlineSuggestion: inlineSuggestion, locale: locale, inlineSuggestionSessionId: inlineSuggestionSessionId } = pluginState;
    return {
        matchedFormat: inlineSuggestion?.type === 'date' ? inlineSuggestion?.metadata.matchedFormat : undefined,
        suggestionType: inlineSuggestion?.type,
        locale: locale,
        inlineSuggestionSessionId: inlineSuggestionSessionId
    };
};
const $2356c0ded658404c$var$getInlineSuggestionInsertPayload = ({ state: state, triggeredFrom: triggeredFrom })=>{
    const { matchedFormat: matchedFormat, suggestionType: suggestionType, locale: locale, inlineSuggestionSessionId: inlineSuggestionSessionId } = $2356c0ded658404c$var$getInlineSuggestionDetails(state);
    return {
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        action: (0, $d925B.ACTION).SUGGESTION_INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_AI,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_INLINE_SUGGESTION,
        attributes: {
            locale: locale,
            suggestionType: suggestionType,
            triggeredFrom: triggeredFrom,
            matchedFormat: matchedFormat,
            inlineSuggestionSessionId: inlineSuggestionSessionId
        }
    };
};
const $2356c0ded658404c$export$d09baef8b6358b47 = (analyticsApi)=>(triggeredFrom)=>{
        /* This is a "curry" function to fire 2 events
		 * The reason we fire 2 so that we can track the suggestion inserted event
		 * and also the document event (wider editor analytics) for the date suggestion
		 */ const insertInlineSuggestionWithAnalyticsCommand = (0, $dAtrv.withAnalytics)(analyticsApi, (state)=>{
            return $2356c0ded658404c$var$getInlineSuggestionInsertPayload({
                state: state,
                triggeredFrom: triggeredFrom
            });
        })((0, $9f1a7e01d4004520$export$351bd6e47d1cc1d0)());
        return (0, $dAtrv.withAnalytics)(analyticsApi, ()=>{
            return {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DATE,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).INLINE_SUGGESTION_FLOATING_TB
                }
            };
        })(insertInlineSuggestionWithAnalyticsCommand);
    };
const $2356c0ded658404c$export$be54d64153cbf00c = (analyticsApi)=>(triggeredFrom)=>(0, $dAtrv.withAnalytics)(analyticsApi, (state)=>{
            const { matchedFormat: matchedFormat, suggestionType: suggestionType, locale: locale, inlineSuggestionSessionId: inlineSuggestionSessionId } = $2356c0ded658404c$var$getInlineSuggestionDetails(state);
            return {
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                action: (0, $d925B.ACTION).SUGGESTION_DISMISSED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_AI,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_INLINE_SUGGESTION,
                attributes: {
                    locale: locale,
                    suggestionType: suggestionType,
                    triggeredFrom: triggeredFrom,
                    matchedFormat: matchedFormat,
                    inlineSuggestionSessionId: inlineSuggestionSessionId
                }
            };
        })((0, $9f1a7e01d4004520$export$8cf80a50b9a4edd8)());
const $2356c0ded658404c$var$getNewSuggestionAnalytics = ()=>{
    return ({ analyticsApi: analyticsApi, state: state })=>{
        const { matchedFormat: matchedFormat, suggestionType: suggestionType, locale: locale, inlineSuggestionSessionId: inlineSuggestionSessionId } = $2356c0ded658404c$var$getInlineSuggestionDetails(state);
        analyticsApi?.fireAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).SUGGESTION_VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_AI,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_INLINE_SUGGESTION,
            attributes: {
                matchedFormat: matchedFormat,
                suggestionType: suggestionType,
                locale: locale,
                inlineSuggestionSessionId: inlineSuggestionSessionId
            }
        });
    };
};
const $2356c0ded658404c$export$5029d42449df706e = $2356c0ded658404c$var$getNewSuggestionAnalytics();




function $d3a7115c9c289752$export$9bc8c22bfed8132b(prevState, newState) {
    return !prevState.doc.eq(newState.doc);
}
function $d3a7115c9c289752$export$7c8b2b990474e5ed(state, currentLocale) {
    return (0, $f60ba1d011d7390b$export$f05434c51e3762e)(state).locale !== currentLocale;
}
var $d3a7115c9c289752$export$2aad89d71b868151 = /*#__PURE__*/ function(KeydownActionType) {
    KeydownActionType["INSERT"] = "INSERT";
    KeydownActionType["DISMISS"] = "DISMISS";
    return KeydownActionType;
}({});
const $d3a7115c9c289752$export$5f35e2fc4ff3b9a2 = (actionType, triggeredFrom, api)=>{
    return (state, dispatch)=>{
        if ((0, $f60ba1d011d7390b$export$f05434c51e3762e)(state).inlineSuggestion) {
            if (actionType === "INSERT") {
                (0, $2356c0ded658404c$export$d09baef8b6358b47)(api?.analytics?.actions)(triggeredFrom)(state, dispatch);
                return true;
            }
            if (actionType === "DISMISS") {
                (0, $2356c0ded658404c$export$be54d64153cbf00c)(api?.analytics?.actions)(triggeredFrom)(state, dispatch);
                return true;
            }
        }
        return false;
    };
};
const $d3a7115c9c289752$export$c5cb2015ae945fc1 = (oldState, newState, api)=>{
    const { inlineSuggestion: oldInlineSuggestions } = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(oldState);
    const { inlineSuggestion: newInlineSuggestions } = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(newState);
    if (oldInlineSuggestions?.metadata !== newInlineSuggestions?.metadata && newInlineSuggestions !== null) (0, $2356c0ded658404c$export$5029d42449df706e)({
        analyticsApi: api?.analytics?.actions,
        state: newState
    });
    return null;
};
function $d3a7115c9c289752$export$f67302dde054579d(event) {
    const relatedTarget = event.relatedTarget || document.activeElement;
    return relatedTarget instanceof Element && Boolean(relatedTarget.closest('[data-editor-popup="true"]'));
}
function $d3a7115c9c289752$export$eca9821f54e86f43(state) {
    const { inlineSuggestion: inlineSuggestion } = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(state);
    return Boolean(inlineSuggestion);
}
function $d3a7115c9c289752$var$isSelectionAtEndOfDocument(state) {
    return state.selection.from === state.doc.nodeSize - 3;
}
function $d3a7115c9c289752$var$hasActiveCompletionHintDecoration(decorationSet) {
    return decorationSet.find().some((deco)=>deco?.spec?.type === (0, $49ae62cb4df29db1$export$3582487b0804e1f6).DECORATION_TYPES.completionHint);
}
function $d3a7115c9c289752$var$isAtCompletionHintBoundary(selection, inlineSuggestion) {
    return selection.from === inlineSuggestion?.to;
}
function $d3a7115c9c289752$export$4245db1db7843682(state) {
    const { selection: selection } = state;
    if (!selection.empty || !$d3a7115c9c289752$var$isSelectionAtEndOfDocument(state)) return false;
    const { inlineSuggestion: inlineSuggestion, decorationSet: decorationSet } = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(state);
    const hintActive = $d3a7115c9c289752$var$hasActiveCompletionHintDecoration(decorationSet);
    return hintActive && $d3a7115c9c289752$var$isAtCompletionHintBoundary(selection, inlineSuggestion);
}


const $de4b3e800a5062e7$export$21cd6432d1e2d949 = (options)=>{
    const { dispatch: dispatch, getIntl: getIntl, api: api } = options;
    const { locale: locale } = getIntl();
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $3b5f4e0ab92501a6$export$75940366de9545d9),
        state: (0, $f60ba1d011d7390b$export$656c7661095efe2e)(dispatch, (0, $f60ba1d011d7390b$export$de5e90bd767c5d82)({
            locale: locale
        })),
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(state);
                return decorationSet;
            },
            handleKeyDown: (0, $dus6D.keydownHandler)({
                Enter: (0, $d3a7115c9c289752$export$5f35e2fc4ff3b9a2)((0, $d3a7115c9c289752$export$2aad89d71b868151).INSERT, (0, $3ebfa284e46a7bd4$export$ae8cf7712eb9509e).ENTER_BUTTON, api),
                Tab: (0, $d3a7115c9c289752$export$5f35e2fc4ff3b9a2)((0, $d3a7115c9c289752$export$2aad89d71b868151).INSERT, (0, $3ebfa284e46a7bd4$export$ae8cf7712eb9509e).TAB_BUTTON, api),
                Escape: (0, $d3a7115c9c289752$export$5f35e2fc4ff3b9a2)((0, $d3a7115c9c289752$export$2aad89d71b868151).DISMISS, (0, $3ebfa284e46a7bd4$export$ae8cf7712eb9509e).ESCAPE_BUTTON, api),
                ArrowRight: (0, $d3a7115c9c289752$export$4245db1db7843682)
            }),
            handleDOMEvents: {
                blur: (view, event)=>{
                    if ((0, $d3a7115c9c289752$export$eca9821f54e86f43)(view.state) && !(0, $d3a7115c9c289752$export$f67302dde054579d)(event)) {
                        (0, $9f1a7e01d4004520$export$8cf80a50b9a4edd8)()(view.state, view.dispatch);
                        return false;
                    }
                }
            }
        },
        view: ()=>{
            return {
                update: (view, prevState)=>{
                    try {
                        const currentState = view.state;
                        if ((0, $d3a7115c9c289752$export$9bc8c22bfed8132b)(prevState, currentState)) (0, $49ae62cb4df29db1$export$fd041caf0943d29).scheduleScanForSuggestions(view);
                        const currentLocale = getIntl().locale;
                        if ((0, $d3a7115c9c289752$export$7c8b2b990474e5ed)(currentState, currentLocale)) (0, $9f1a7e01d4004520$export$c1428fdaca6ad73f)(currentLocale)(currentState, view.dispatch);
                    } catch (err) {
                    // HOT-118204: swallow uncaught errors for now to prevent collab catchup failures
                    }
                },
                destroy: ()=>{
                    (0, $49ae62cb4df29db1$export$fd041caf0943d29).cancelSuggestionScans();
                }
            };
        },
        appendTransaction: (_transactions, oldState, newState)=>{
            return (0, $d3a7115c9c289752$export$c5cb2015ae945fc1)(oldState, newState, api);
        }
    });
};











const $97bd9a9bc8d6fe47$export$1d8514938d526e53 = (options)=>{
    const { api: api } = options;
    return new (0, $1S4f7.SafePlugin)({
        view () {
            let previousIsRunning = false;
            return {
                update (view) {
                    if (!api?.placeholder || !api?.core) return;
                    const state = view.state;
                    const aiDecorationState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state);
                    const currentIsRunning = aiDecorationState?.isRunning ?? false;
                    if (currentIsRunning !== previousIsRunning) {
                        previousIsRunning = currentIsRunning;
                        if (options.editorPluginAIProvider.isInDocumentStreamingEnabled) api.core.actions.execute(api.placeholder.commands.setPlaceholderHidden(currentIsRunning));
                        else if ((0, $2pjJ5.isEmptyDocument)(state.doc)) api.core.actions.execute(api.placeholder.commands.setPlaceholderHidden(currentIsRunning));
                    }
                }
            };
        }
    });
};















function $caaba1b8815755f9$export$de5e90bd767c5d82() {
    return {
        // Original fields
        showHighlight: false,
        showAIContentHighlight: false,
        showTelepointer: false,
        isStreaming: false,
        isStreamingFinished: false,
        startPos: undefined,
        loadingPos: undefined,
        userContentEndPos: undefined,
        aiContentEndPos: undefined,
        telepointerPos: undefined,
        isFinalStream: false,
        chunkNumber: 0,
        streamTimeStamp: undefined,
        // New fields
        streamPhase: 'idle',
        // Use -1 so that responseVersion 0 > -1 triggers the first update
        // This is important for subsequent streams in the same session where
        // responseVersion resets to 0
        lastProcessedVersion: -1,
        posAdjusted: false,
        hasFinalStream: false,
        originalUserContentSlice: undefined,
        aiContentSlice: undefined,
        scrollTargetPos: undefined,
        isPaused: true,
        streamStartPos: undefined,
        currentSessionId: undefined
    };
}


function $e2b6da12acd69cbd$export$8c11be8ccd39ce0b({ pos: pos, tr: tr }) {
    let mappedPos = tr.mapping.map(pos, -1);
    // Special handling for AI streaming transformation
    if (tr.getMeta('isAIStreamingTransformation')) {
        if (mappedPos > pos) {
            const adjustedPos = tr.mapping.map(pos - 1, -1) + 1;
            if (adjustedPos === pos) mappedPos = pos;
        }
    }
    return mappedPos;
}
function $e2b6da12acd69cbd$export$3dcc2c094c7e6748({ pos: pos, tr: tr }) {
    let mappedPos = tr.mapping.map(pos, 1);
    // Special handling for AI streaming transformation
    if (tr.getMeta('isAIStreamingTransformation')) {
        if (mappedPos === pos) {
            const adjustedPos = tr.mapping.map(pos + 1, 1) - 1;
            if (adjustedPos !== pos) mappedPos = adjustedPos;
        }
    }
    return mappedPos;
}



var $1DOVk = parcelRequire("1DOVk");

function $71d83711c24eb8b1$export$158e6dc925f36647(state, startPos, endPos) {
    const errors = [];
    const docSize = state.doc.content.size;
    let safeStart = startPos ?? 0;
    let safeEnd = endPos ?? docSize;
    // Validate startPos
    if (startPos === undefined) errors.push('startPos is undefined');
    else {
        if (startPos < 0) {
            errors.push(`startPos ${startPos} is negative`);
            safeStart = 0;
        }
        if (startPos > docSize) {
            errors.push(`startPos ${startPos} exceeds docSize ${docSize}`);
            safeStart = docSize;
        }
    }
    // Validate endPos
    if (endPos === undefined) errors.push('endPos is undefined');
    else {
        if (endPos < 0) {
            errors.push(`endPos ${endPos} is negative`);
            safeEnd = 0;
        }
        if (endPos > docSize) {
            errors.push(`endPos ${endPos} exceeds docSize ${docSize}`);
            safeEnd = docSize;
        }
    }
    // Validate relationship
    if (safeEnd < safeStart) {
        errors.push(`endPos ${safeEnd} is less than startPos ${safeStart}`);
        safeEnd = safeStart;
    }
    return {
        valid: errors.length === 0,
        errors: errors,
        sanitized: {
            startPos: safeStart,
            endPos: safeEnd
        }
    };
}
function $71d83711c24eb8b1$export$4af2bdeb9a1268d4(pos, docSize) {
    return Math.max(0, Math.min(pos, docSize));
}
function $71d83711c24eb8b1$export$e6dc95dc82e623ff(from, to, docSize) {
    if (from === undefined || to === undefined) return null;
    const safeFrom = $71d83711c24eb8b1$export$4af2bdeb9a1268d4(from, docSize);
    const safeTo = $71d83711c24eb8b1$export$4af2bdeb9a1268d4(to, docSize);
    if (safeFrom > safeTo) return null;
    return {
        from: safeFrom,
        to: safeTo
    };
}


function $bf81f44e31217796$export$1056d35c08b77b41(meta, pluginState) {
    switch(meta?.action){
        case (0, $1DOVk.ACTIONS).INIT_POSITIONS:
            {
                const { start: start, end: end, showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, telepointerPos: telepointerPos, originalUserContentSlice: originalUserContentSlice, streamStartPos: streamStartPos, sessionId: sessionId } = meta;
                return {
                    ...(0, $caaba1b8815755f9$export$de5e90bd767c5d82)(),
                    startPos: start,
                    userContentEndPos: end,
                    loadingPos: start,
                    showHighlight: showHighlight,
                    showAIContentHighlight: showAIContentHighlight,
                    showTelepointer: showTelepointer,
                    telepointerPos: telepointerPos,
                    isStreaming: true,
                    chunkNumber: 0,
                    streamTimeStamp: Date.now(),
                    streamPhase: 'mounting',
                    isPaused: false,
                    posAdjusted: false,
                    hasFinalStream: false,
                    currentSessionId: sessionId,
                    ...originalUserContentSlice !== undefined && {
                        originalUserContentSlice: originalUserContentSlice
                    },
                    ...streamStartPos !== undefined && {
                        streamStartPos: streamStartPos
                    }
                };
            }
        case (0, $1DOVk.ACTIONS).ADJUST_INIT_POSITIONS:
            const { start: start, end: end } = meta;
            return {
                ...pluginState,
                startPos: start,
                userContentEndPos: end
            };
        case (0, $1DOVk.ACTIONS).UPDATE_LOADING_POSITIONS:
            {
                const { startPos: startPos, userContentEndPos: userContentEndPos, loadingPos: loadingPos } = pluginState;
                if (startPos === undefined || userContentEndPos === undefined) return pluginState;
                const max = userContentEndPos;
                const min = loadingPos ?? startPos;
                if (max <= min) return pluginState;
                // Randomize loading position within 1/8th to 3/8ths of range
                const eighth = (max - min) / 8;
                const low = Math.floor(min + eighth);
                const high = Math.ceil(min + 3 * eighth);
                const newLoadingPos = Math.ceil(Math.random() * (high - low) + low);
                return {
                    ...pluginState,
                    loadingPos: newLoadingPos
                };
            }
        case (0, $1DOVk.ACTIONS).UPDATE_STREAM_POSITIONS:
            {
                const { aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, isFinalStream: isFinalStream, lastProcessedVersion: lastProcessedVersion, aiContentSlice: aiContentSlice, scrollTargetPos: scrollTargetPos, posAdjusted: posAdjusted, startPos: startPos, userContentEndPos: userContentEndPos } = meta.positions;
                const nextPhase = isFinalStream ? 'finalizing' : 'streaming';
                let newState = {
                    ...pluginState,
                    aiContentEndPos: aiContentEndPos,
                    telepointerPos: telepointerPos,
                    chunkNumber: pluginState.chunkNumber + 1,
                    streamTimeStamp: Date.now(),
                    loadingPos: undefined,
                    streamPhase: nextPhase,
                    // New fields (if provided)
                    ...lastProcessedVersion !== undefined && {
                        lastProcessedVersion: lastProcessedVersion
                    },
                    ...aiContentSlice !== undefined && {
                        aiContentSlice: aiContentSlice
                    },
                    ...scrollTargetPos !== undefined && {
                        scrollTargetPos: scrollTargetPos
                    },
                    ...posAdjusted !== undefined && {
                        posAdjusted: posAdjusted
                    },
                    ...startPos !== undefined && {
                        startPos: startPos
                    },
                    ...userContentEndPos !== undefined && {
                        userContentEndPos: userContentEndPos
                    }
                };
                if (isFinalStream) newState = {
                    ...newState,
                    isFinalStream: true,
                    showHighlight: false,
                    showAIContentHighlight: false,
                    showTelepointer: false,
                    isStreaming: false,
                    isStreamingFinished: true,
                    hasFinalStream: true,
                    scrollTargetPos: undefined
                };
                return newState;
            }
        case (0, $1DOVk.ACTIONS).END_STREAM:
            return {
                ...(0, $caaba1b8815755f9$export$de5e90bd767c5d82)(),
                telepointerPos: pluginState.telepointerPos
            };
        default:
            return pluginState;
    }
}
function $bf81f44e31217796$export$38844252556f39ef(tr, pluginState) {
    const docSize = tr.doc.content.size;
    return {
        ...pluginState,
        ...pluginState.startPos !== undefined && {
            startPos: (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$8c11be8ccd39ce0b)({
                pos: pluginState.startPos,
                tr: tr
            }), docSize)
        },
        ...pluginState.userContentEndPos !== undefined && {
            userContentEndPos: (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$3dcc2c094c7e6748)({
                pos: pluginState.userContentEndPos,
                tr: tr
            }), docSize)
        },
        ...pluginState.aiContentEndPos !== undefined && {
            aiContentEndPos: (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$3dcc2c094c7e6748)({
                pos: pluginState.aiContentEndPos,
                tr: tr
            }), docSize)
        },
        ...pluginState.loadingPos !== undefined && {
            loadingPos: (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)(tr.mapping.map(pluginState.loadingPos, -1), docSize)
        },
        ...pluginState.telepointerPos !== undefined && {
            telepointerPos: (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)(tr.mapping.map(pluginState.telepointerPos, -1), docSize)
        },
        ...pluginState.streamStartPos !== undefined && {
            streamStartPos: (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$8c11be8ccd39ce0b)({
                pos: pluginState.streamStartPos,
                tr: tr
            }), docSize)
        },
        ...pluginState.scrollTargetPos !== undefined && {
            scrollTargetPos: (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$3dcc2c094c7e6748)({
                pos: pluginState.scrollTargetPos,
                tr: tr
            }), docSize)
        }
    };
}










var $ly5a2 = parcelRequire("ly5a2");

function $e0c73d166056a088$export$6e70fb48265e25fd(state, telepointerElement) {
    const pluginState = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state);
    if (!pluginState) return (0, $ftzrq.DecorationSet).empty;
    const { showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, startPos: startPos, userContentEndPos: userContentEndPos, aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, loadingPos: loadingPos, isFinalStream: isFinalStream, isStreaming: isStreaming } = pluginState;
    const decorations = [];
    // When not actively streaming, show telepointer if there's an active session with positions set
    if (!isStreaming || startPos === undefined) {
        const decorationState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state);
        const { nextSessionId: nextSessionId, positions: positions } = decorationState || {};
        if (nextSessionId && positions) return (0, $ftzrq.DecorationSet).create(state.doc, [
            (0, $f40d45a6cce8f6b7$export$3f4dbbc6f36d65d4)(positions[0], telepointerElement)
        ]);
        return (0, $ftzrq.DecorationSet).empty;
    }
    // User content highlight (loading state)
    if (showHighlight) {
        if (loadingPos !== undefined) decorations.push((0, $ftzrq.Decoration).inline(startPos, loadingPos, {
            class: 'ai-in-editor-user-content',
            'data-testid': 'ai-in-editor-user-content'
        }));
        else if (userContentEndPos !== undefined) decorations.push((0, $ftzrq.Decoration).inline(aiContentEndPos || startPos, userContentEndPos, {
            class: 'ai-in-editor-user-content',
            'data-testid': 'ai-in-editor-user-content'
        }));
        // AI content highlight (streaming state)
        if (showAIContentHighlight && aiContentEndPos !== undefined) decorations.push((0, $ftzrq.Decoration).inline(startPos, aiContentEndPos, {
            class: 'ai-in-editor-ai-content',
            'data-testid': 'ai-in-editor-ai-content'
        }));
    }
    /**
   * We show the telepointer only when isFinalStream is false.
   * On the final stream, plugin state is reset so isFinalStream will be undefined.
   */ if (isFinalStream === false && showTelepointer) decorations.push((0, $f40d45a6cce8f6b7$export$3f4dbbc6f36d65d4)(telepointerPos || aiContentEndPos || startPos, telepointerElement));
    else {
        // Between streams: show telepointer if session is active
        const { nextSessionId: nextSessionId } = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) || {};
        if (nextSessionId && telepointerPos !== undefined) decorations.push((0, $f40d45a6cce8f6b7$export$3f4dbbc6f36d65d4)(telepointerPos, telepointerElement));
    }
    if (decorations.length) return (0, $ftzrq.DecorationSet).create(state.doc, decorations);
    return (0, $ftzrq.DecorationSet).empty;
}






















function $2781a13e391742e0$export$5cba160ccca2cd8c(state) {
    const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state);
    const { positions: positions, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom } = decorationPluginState ?? {};
    if (!positions || !configItem) return null;
    // Defer mounting for orchestrator flows until streaming API sets correct positions
    // (e.g., end of document for appendNodeToEnd)
    if (lastTriggeredFrom && lastTriggeredFrom !== 'streamingApi') return null;
    const [from, to] = positions;
    const validation = (0, $71d83711c24eb8b1$export$158e6dc925f36647)(state, from, to);
    const docSize = state.doc.content.size;
    const isEmptySelection = from === to;
    const shouldReplaceDoc = isEmptySelection && !configItem?.insertOnEmptySelection;
    const [start, end] = shouldReplaceDoc ? [
        1,
        Math.max(1, docSize - 1)
    ] : [
        validation.sanitized.startPos,
        validation.sanitized.endPos
    ];
    const isSuggestTitle = $2781a13e391742e0$var$isSuggestTitleForConfluence(configItem);
    const showTelepointer = !isSuggestTitle;
    const showHighlight = !isSuggestTitle;
    const showAIContentHighlight = !shouldReplaceDoc;
    let originalUserContentSlice;
    try {
        originalUserContentSlice = state.doc.slice(start, end);
    } catch  {
        return null;
    }
    let telepointerPos = start;
    try {
        const $start = state.doc.resolve(start);
        telepointerPos = $start.pos;
        let node = $start.node()?.firstChild;
        while(node && node.firstChild && !node.isLeaf){
            telepointerPos += 1;
            node = node.firstChild;
        }
    } catch  {
        telepointerPos = start;
    }
    let tr = state.tr;
    tr = (0, $ke2AI.closeHistory)(tr);
    tr = (0, $kTCUV.startWatchingAnnotationChanges)({
        from: start,
        to: end
    })(tr);
    tr = (0, $1DOVk.initPositions)({
        start: start,
        end: end,
        showHighlight: showHighlight && decorationPluginState?.withStreamingHighlight !== false,
        showAIContentHighlight: showAIContentHighlight,
        showTelepointer: showTelepointer,
        telepointerPos: telepointerPos,
        originalUserContentSlice: originalUserContentSlice,
        streamStartPos: start,
        sessionId: decorationPluginState?.currentSessionId
    })(tr);
    return tr;
}
function $2781a13e391742e0$var$isSuggestTitleForConfluence(configItem) {
    if (!configItem) return false;
    return configItem.key === (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE;
}


/* eslint-disable no-console */ 











/* eslint-disable no-console */ 





const $5c0ab2c2b5c994a4$var$isRootNode = (schema, node)=>node.type === schema.nodes.doc;
const $5c0ab2c2b5c994a4$export$d53ec95625564c92 = ({ schema: schema, adfResponse: adfResponse, adfResponseNodeWrappers: adfResponseNodeWrappers })=>{
    const initialNode = (0, $5SAOw.Node).fromJSON(schema, adfResponse);
    // If we're not in the root node make the current node a fragment, otherwise
    // we may lose information about the container while streaming.
    let fragment = !$5c0ab2c2b5c994a4$var$isRootNode(schema, initialNode) && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? (0, $5SAOw.Fragment).from(initialNode) : initialNode.content;
    const wrappers = adfResponseNodeWrappers ? [
        ...adfResponseNodeWrappers
    ] : [];
    while(wrappers.length > 0){
        const wrapperName = wrappers.pop();
        if (wrapperName && fragment.content.length === 1 && fragment.content[0].type.name === wrapperName) fragment = fragment.content[0].content;
        else break;
    }
    return fragment;
};


function $a18790a6197d27f1$export$f61de149b3c1af13(schema, adfResponse) {
    if (!adfResponse) return null;
    try {
        const pmNode = (0, $5c0ab2c2b5c994a4$export$d53ec95625564c92)({
            schema: schema,
            adfResponse: adfResponse
        });
        return pmNode;
    } catch  {
        return null;
    }
}
function $a18790a6197d27f1$export$34f795fdad5abc80(fragment) {
    let isHealthy = true;
    fragment.forEach((node)=>{
        if (!isHealthy) return;
        try {
            node.check();
        } catch  {
            isHealthy = false;
        }
    });
    return isHealthy;
}


function $eba16d073b59ce1c$export$dc6f106b7f3aca98(configItem) {
    if (!configItem) return false;
    return configItem.key === (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE;
}
function $eba16d073b59ce1c$export$95ec53ef5cde2054(state, isFinalStream) {
    const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state);
    if (!decorationPluginState) return null;
    const { configItem: configItem } = decorationPluginState;
    const sessionState = (0, $5oqzu.aiSessionContextPluginKey).getState(state);
    if (!sessionState) return null;
    const { adfResponse: adfResponse, responseVersion: responseVersion } = sessionState;
    if (!configItem || !adfResponse || !responseVersion) return null;
    if (!$eba16d073b59ce1c$export$dc6f106b7f3aca98(configItem)) return null;
    const fragment = (0, $a18790a6197d27f1$export$f61de149b3c1af13)(state.schema, adfResponse);
    if (!fragment) return null;
    const tr = $eba16d073b59ce1c$var$replaceConfluenceTitle(state, fragment);
    if (!tr) return null;
    return (0, $1DOVk.updateStreamPositions)({
        aiContentEndPos: 0,
        telepointerPos: 0,
        isFinalStream: isFinalStream,
        lastProcessedVersion: responseVersion
    })(tr);
}
function $eba16d073b59ce1c$var$replaceConfluenceTitle(state, fragment) {
    const { doc: doc, schema: schema } = state;
    let titleText = '';
    fragment.forEach((node)=>{
        titleText += node.textContent;
    });
    // Look for title node type
    const titleType = schema.nodes.title;
    if (titleType) {
        let titlePos = null;
        let titleNode = null;
        doc.descendants((node, pos)=>{
            if (node.type === titleType && titlePos === null) {
                titlePos = pos;
                titleNode = node;
                return false;
            }
            return true;
        });
        if (titlePos !== null && titleNode) {
            const tr = state.tr;
            const titleStart = titlePos + 1;
            const titleEnd = titlePos + (titleNode.nodeSize - 1);
            try {
                if (titleText) tr.insertText(titleText, titleStart, titleEnd);
                else tr.delete(titleStart, titleEnd);
                return tr;
            } catch  {
            // Title replacement failed - try fallback
            }
        }
    }
    // Fallback: first heading
    const { heading: heading } = schema.nodes;
    if (heading) {
        let headingPos = null;
        let headingNode = null;
        doc.descendants((node, pos)=>{
            if (node.type === heading && headingPos === null) {
                headingPos = pos;
                headingNode = node;
                return false;
            }
            return true;
        });
        if (headingPos !== null && headingNode) {
            const tr = state.tr;
            const headingStart = headingPos + 1;
            const headingEnd = headingPos + (headingNode.nodeSize - 1);
            try {
                if (titleText) tr.insertText(titleText, headingStart, headingEnd);
                else tr.delete(headingStart, headingEnd);
                return tr;
            } catch  {
            // Heading replacement failed
            }
        }
    }
    return null;
}






















function $ecf3bcf501846ef2$export$bbf65721f248cea({ state: state, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } = state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos,
        adjusted: false
    };
    // Validate positions
    if (startPos < 0 || startPos > state.doc.content.size) return bailout;
    const $start = state.doc.resolve(startPos);
    const startParent = $start.parent;
    const inList = startParent.type === paragraph && $start.depth > 1 && $start.node($start.depth - 1)?.type === listItem;
    const inTaskItem = taskItem && startParent.type === taskItem;
    const inDecisionItem = decisionItem && startParent.type === decisionItem;
    if (!inList && !inTaskItem && !inDecisionItem) return bailout;
    const $end = state.doc.resolve(userContentEndPos);
    const endParent = $end.parent;
    const newNode = fragment.firstChild;
    const oneBlock = fragment.childCount === 1 && newNode && newNode.isBlock;
    const newStartBlock = oneBlock && newNode.type.name !== startParent.type.name;
    const newEndBlock = oneBlock && newNode.type.name !== endParent.type.name;
    let startPosAdjusted = startPos;
    let endPosAdjusted = userContentEndPos;
    if (newStartBlock) for(let depth = $start.depth, diff = 1; depth > 0; depth--, diff++, startPosAdjusted--){
        const ancestor = $start.node(depth);
        if (ancestor.type.contentMatch.matchType(newNode.type)) break;
        const before = $start.before(depth);
        if (before + diff !== startPos) break;
    }
    if (newEndBlock) for(let depth = $end.depth, diff = 1; depth > 0; depth--, diff++, endPosAdjusted++){
        const ancestor = $end.node(depth);
        if (ancestor.type.contentMatch.matchType(newNode.type)) break;
        const after = $end.after(depth);
        if (after - diff !== userContentEndPos) break;
    }
    if (startPosAdjusted !== bailout.startPos || endPosAdjusted !== bailout.userContentEndPos) {
        const pos = endPosAdjusted - userContentEndPos >= startPos - startPosAdjusted ? endPosAdjusted : startPosAdjusted;
        return {
            startPos: pos,
            userContentEndPos: pos,
            adjusted: true
        };
    }
    return bailout;
}
function $ecf3bcf501846ef2$export$30fe2235297e05d0({ state: state, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { paragraph: paragraph } = state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos,
        adjusted: false
    };
    // Validate positions
    if (startPos < 0 || startPos > state.doc.content.size) return bailout;
    let $start = state.doc.resolve(startPos);
    if ($start.depth > 0 && $start.before() !== startPos - 1) return bailout;
    const types = [];
    let node = fragment.firstChild;
    while(node && node.firstChild){
        types.push(node.type);
        node = node.firstChild;
    }
    types.reverse();
    if (types.length === 1 && types[0] === paragraph) return bailout;
    let startPosAdjusted = startPos;
    node = $start.parent.firstChild;
    while(node && node.firstChild){
        startPosAdjusted++;
        node = node.firstChild;
    }
    $start = state.doc.resolve(startPosAdjusted);
    for(let i = 0, depth = $start.depth; depth > 0; i++, depth--, startPosAdjusted--){
        const ancestor = $start.node(depth);
        if (ancestor.type !== types[i]) break;
        const before = $start.before(depth);
        if (before + 1 !== startPosAdjusted) break;
    }
    if (startPosAdjusted < bailout.startPos) return {
        startPos: startPosAdjusted,
        userContentEndPos: bailout.userContentEndPos,
        adjusted: true
    };
    return bailout;
}
function $ecf3bcf501846ef2$export$b235a800374c03c3({ state: state, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { listItem: listItem, paragraph: paragraph } = state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos,
        adjusted: false
    };
    if (!listItem) return bailout;
    const doc = state.doc;
    const docSize = doc.content.size;
    // Validate positions
    if (startPos < 0 || startPos > docSize || userContentEndPos < 0 || userContentEndPos > docSize) return bailout;
    let startPosAdjusted = startPos;
    let userContentEndPosAdjusted = userContentEndPos;
    const fragmentFirstNode = fragment.firstChild;
    if (!fragmentFirstNode || !fragmentFirstNode.isBlock) return bailout;
    const $start = doc.resolve(startPos);
    let curParent = $start.node($start.depth);
    let curParentParent = $start.depth > 1 ? $start.node($start.depth - 1) : null;
    if (curParent.type === paragraph && $start.parentOffset === 0 && curParentParent?.type === listItem) startPosAdjusted -= 2;
    else if (curParent.type === listItem) startPosAdjusted -= 1;
    const $userContentEnd = doc.resolve(userContentEndPos);
    curParent = $userContentEnd.node($userContentEnd.depth);
    curParentParent = $userContentEnd.depth > 1 ? $userContentEnd.node($userContentEnd.depth - 1) : null;
    if (curParent.type === paragraph && $userContentEnd.parentOffset === curParent.content.size && curParentParent?.type === listItem) userContentEndPosAdjusted += 2;
    else if (curParent.type === listItem) userContentEndPosAdjusted += 1;
    // Clamp to valid range
    startPosAdjusted = Math.max(0, startPosAdjusted);
    userContentEndPosAdjusted = Math.min(docSize, userContentEndPosAdjusted);
    const adjusted = startPosAdjusted !== startPos || userContentEndPosAdjusted !== userContentEndPos;
    return {
        startPos: startPosAdjusted,
        userContentEndPos: userContentEndPosAdjusted,
        adjusted: adjusted
    };
}



/* eslint-disable no-console */ 


function $31b5d0fe0a837af1$export$a0cec308ca83a1dc({ state: state, fragment: fragment, startPos: startPos, toPos: toPos, userContentEndPos: userContentEndPos }) {
    const doc = state.doc;
    const schema = state.schema;
    const docSize = doc.content.size;
    const bailout = {
        startPos: startPos,
        toPos: toPos,
        adjusted: false
    };
    if (startPos < 0 || startPos > docSize || toPos < 0 || toPos > docSize) return bailout;
    try {
        const $startPos = doc.resolve(startPos);
        const $toPos = doc.resolve(toPos);
        if ($31b5d0fe0a837af1$var$isWithinSameCell($startPos, $toPos, schema)) return bailout;
        const adjustedStartPos = $31b5d0fe0a837af1$var$getStartOfTableRow(schema, $startPos);
        const adjustedToPos = $31b5d0fe0a837af1$var$getEndOfTableRow(schema, $toPos);
        let newStartPos = startPos;
        let newToPos = toPos;
        let adjusted = false;
        if (adjustedStartPos !== undefined) {
            newStartPos = adjustedStartPos;
            adjusted = true;
        }
        if (adjustedToPos !== undefined) {
            newToPos = Math.min(adjustedToPos, userContentEndPos);
            adjusted = true;
        }
        return {
            startPos: newStartPos,
            toPos: newToPos,
            adjusted: adjusted
        };
    } catch  {
        return bailout;
    }
}
function $31b5d0fe0a837af1$var$isWithinSameCell($from, $to, schema) {
    const tableCell = schema.nodes.tableCell;
    const tableHeader = schema.nodes.tableHeader;
    if (!tableCell && !tableHeader) return false;
    let fromCellDepth = -1;
    for(let d = $from.depth; d > 0; d--){
        const node = $from.node(d);
        if (tableCell && node.type === tableCell || tableHeader && node.type === tableHeader) {
            fromCellDepth = d;
            break;
        }
    }
    if (fromCellDepth === -1) return false;
    let toCellDepth = -1;
    for(let d = $to.depth; d > 0; d--){
        const node = $to.node(d);
        if (tableCell && node.type === tableCell || tableHeader && node.type === tableHeader) {
            toCellDepth = d;
            break;
        }
    }
    if (toCellDepth === -1) return false;
    return $from.start(fromCellDepth) === $to.start(toCellDepth);
}
function $31b5d0fe0a837af1$var$getStartOfTableRow(schema, resolvedPos) {
    const tableRow = schema.nodes.tableRow;
    if (!tableRow) return undefined;
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        if (resolvedPos.node(depth).type === tableRow) return resolvedPos.start(depth);
    }
    return undefined;
}
function $31b5d0fe0a837af1$var$getEndOfTableRow(schema, resolvedPos) {
    const tableRow = schema.nodes.tableRow;
    if (!tableRow) return undefined;
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        if (resolvedPos.node(depth).type === tableRow) return resolvedPos.end(depth);
    }
    return undefined;
}
function $31b5d0fe0a837af1$export$f7df414f524c21dc({ state: state, slice: slice, startPos: startPos, toPos: toPos }) {
    const doc = state.doc;
    const schema = state.schema;
    const fragment = slice.content;
    const docSize = doc.content.size;
    // If the first node in fragment is different from the existing first node,
    // we need to adjust the slice open start to 0,
    // to avoid merging the first node in fragment with the existing first node,
    // for example, if the first node in fragment is a panel node, we'll lose the panel wrapper
    // (only the panel content is inserted into the doc)
    // but we don't need to do this if both nodes are table nodes
    const firstNode = fragment.firstChild;
    if (firstNode && startPos >= 0 && startPos <= docSize) try {
        const firstNodeIsTable = $31b5d0fe0a837af1$var$isTableNode(firstNode.type, schema);
        const $startPos = doc.resolve(startPos);
        const startPosInTable = $31b5d0fe0a837af1$var$getNodeTypeDepth($startPos, schema.nodes.table) !== null;
        const bothTableNodes = firstNodeIsTable && startPosInTable;
        if (!bothTableNodes) {
            const existingFirstNode = $startPos.depth >= 1 ? $startPos.node(1) : null;
            if (!existingFirstNode || firstNode.type !== existingFirstNode.type) slice = new (0, $5SAOw.Slice)(fragment, 0, slice.openEnd);
        }
    } catch (e) {
    // On error, don't adjust
    }
    // If the last node in fragment is different from the existing last node,
    // we need to adjust the slice open end to 0,
    // to avoid merging the last node in fragment with the existing last node,
    // for example, we've seen during streaming, heading and paragraph are merged together
    // (leading to a very long heading containing the paragraph content)
    // but we don't need to do this if both nodes are table nodes
    const lastNode = fragment.lastChild;
    if (lastNode && toPos >= 0 && toPos <= docSize) try {
        const lastNodeIsTable = $31b5d0fe0a837af1$var$isTableNode(lastNode.type, schema);
        const $toPos = doc.resolve(toPos);
        const toPosInTable = $31b5d0fe0a837af1$var$getNodeTypeDepth($toPos, schema.nodes.table) !== null;
        const bothTableNodes = lastNodeIsTable && toPosInTable;
        if (!bothTableNodes) {
            const existingLastNode = $toPos.depth >= 1 ? $toPos.node(1) : null;
            if (!existingLastNode || lastNode.type !== existingLastNode.type) slice = new (0, $5SAOw.Slice)(fragment, slice.openStart, 0);
        }
    } catch (e) {
    // On error, don't adjust
    }
    return slice;
}
function $31b5d0fe0a837af1$var$isTableNode(nodeType, schema) {
    return schema.nodes.table !== undefined && nodeType === schema.nodes.table;
}
function $31b5d0fe0a837af1$var$getNodeTypeDepth(resolvedPos, nodeType) {
    if (!nodeType) return null;
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        if (resolvedPos.node(depth).type === nodeType) return depth;
    }
    return null;
}


function $35e4450f9b1d2d92$export$13c76c9a18264386(state) {
    const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state);
    const { positions: positions } = decorationPluginState ?? {};
    const sessionState = (0, $5oqzu.aiSessionContextPluginKey).getState(state);
    if (!sessionState) return null;
    const { adfResponse: adfResponse, responseVersion: responseVersion } = sessionState;
    const streamingState = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state);
    if (!positions || !streamingState) return null;
    const { startPos: startPos, userContentEndPos: userContentEndPos, aiContentEndPos: aiContentEndPos, posAdjusted: posAdjusted, streamTimeStamp: streamTimeStamp } = streamingState;
    if (startPos === undefined || userContentEndPos === undefined) return $35e4450f9b1d2d92$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    const fragment = (0, $a18790a6197d27f1$export$f61de149b3c1af13)(state.schema, adfResponse);
    if (!fragment) return $35e4450f9b1d2d92$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    let slice = (0, $5SAOw.Slice).maxOpen(fragment);
    if (!slice.content.firstChild) slice = (0, $5SAOw.Slice).empty;
    if (slice.size <= 0) return $35e4450f9b1d2d92$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    if (!(0, $a18790a6197d27f1$export$34f795fdad5abc80)(fragment)) return $35e4450f9b1d2d92$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    const docSize = state.doc.content.size;
    let workingStartPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)(startPos, docSize);
    let workingUserContentEndPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)(userContentEndPos, docSize);
    let workingPosAdjusted = posAdjusted;
    // Position adjustments (once per stream)
    if (!posAdjusted) {
        const isEmptySelection = positions[0] === positions[1];
        if (isEmptySelection) {
            const adjustment = (0, $ecf3bcf501846ef2$export$bbf65721f248cea)({
                state: state,
                fragment: fragment,
                startPos: workingStartPos,
                userContentEndPos: workingUserContentEndPos
            });
            if (adjustment.adjusted) {
                workingStartPos = adjustment.startPos;
                workingUserContentEndPos = adjustment.userContentEndPos;
            }
        } else {
            const adjustment = (0, $ecf3bcf501846ef2$export$30fe2235297e05d0)({
                state: state,
                fragment: fragment,
                startPos: workingStartPos,
                userContentEndPos: workingUserContentEndPos
            });
            if (adjustment.adjusted) workingStartPos = adjustment.startPos;
        }
        if ((0, $dh538.fg)('platform_editor_ai_convert_list_to_table_bugfix')) {
            const listAdjustment = (0, $ecf3bcf501846ef2$export$b235a800374c03c3)({
                state: state,
                fragment: fragment,
                startPos: workingStartPos,
                userContentEndPos: workingUserContentEndPos
            });
            if (listAdjustment.adjusted) {
                workingStartPos = listAdjustment.startPos;
                workingUserContentEndPos = listAdjustment.userContentEndPos;
            }
        }
        workingPosAdjusted = true;
    }
    // Calculate toPos
    let toPos = Math.min(Math.max(aiContentEndPos ?? 0, workingStartPos + slice.size + 1), workingUserContentEndPos);
    // Table adjustment
    const tableAdjustment = (0, $31b5d0fe0a837af1$export$a0cec308ca83a1dc)({
        state: state,
        fragment: fragment,
        startPos: workingStartPos,
        toPos: toPos,
        userContentEndPos: workingUserContentEndPos
    });
    if (tableAdjustment.adjusted) {
        workingStartPos = tableAdjustment.startPos;
        toPos = tableAdjustment.toPos;
    }
    // Slice adjustment
    slice = (0, $31b5d0fe0a837af1$export$f7df414f524c21dc)({
        state: state,
        slice: slice,
        startPos: workingStartPos,
        toPos: toPos
    });
    // Build transaction
    let tr = state.tr;
    const safeToPos = Math.max(workingStartPos, Math.min(toPos, tr.doc.content.size));
    try {
        tr = tr.replaceRange(workingStartPos, safeToPos, slice);
    } catch  {
        return $35e4450f9b1d2d92$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    }
    tr = tr.setMeta('ignoreLocalIdUpdate', true);
    tr = (0, $1DOVk.metaTransaction)({
        tr: tr,
        isFinalStream: false,
        stackTime: streamTimeStamp
    });
    // Map positions AFTER document changes
    const newDocSize = tr.doc.content.size;
    const mappedStartPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$8c11be8ccd39ce0b)({
        pos: workingStartPos,
        tr: tr
    }), newDocSize);
    const mappedUserContentEndPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$3dcc2c094c7e6748)({
        pos: workingUserContentEndPos,
        tr: tr
    }), newDocSize);
    const mappedAiContentEndPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$3dcc2c094c7e6748)({
        pos: toPos,
        tr: tr
    }), newDocSize);
    // Calculate telepointer
    let telepointerPos = mappedAiContentEndPos;
    try {
        tr.doc.nodesBetween(mappedStartPos, mappedAiContentEndPos, (node, pos)=>{
            if (node.isLeaf) telepointerPos = pos + node.nodeSize;
        });
        telepointerPos = Math.min(telepointerPos, mappedAiContentEndPos);
    } catch  {
        telepointerPos = mappedAiContentEndPos;
    }
    // Use original transform with extended payload
    tr = (0, $1DOVk.updateStreamPositions)({
        aiContentEndPos: mappedAiContentEndPos,
        telepointerPos: telepointerPos,
        isFinalStream: false,
        lastProcessedVersion: responseVersion,
        aiContentSlice: slice,
        scrollTargetPos: mappedAiContentEndPos,
        posAdjusted: workingPosAdjusted,
        startPos: mappedStartPos,
        userContentEndPos: mappedUserContentEndPos
    })(tr);
    return tr;
}
function $35e4450f9b1d2d92$var$buildPositionOnlyUpdate(state, streamingState, responseVersion) {
    const { aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, startPos: startPos, aiContentSlice: aiContentSlice } = streamingState;
    let tr = state.tr;
    tr = (0, $1DOVk.updateStreamPositions)({
        aiContentEndPos: aiContentEndPos ?? startPos ?? 0,
        telepointerPos: telepointerPos ?? startPos ?? 0,
        isFinalStream: false,
        lastProcessedVersion: responseVersion,
        aiContentSlice: aiContentSlice
    })(tr);
    return tr;
}





function $56b5f1a09d39ac02$export$3174bd35cfffd429(sessionState, prevSessionState, streamingState, autoAcceptAIChanges) {
    if (!sessionState) return null;
    // === DERIVE SESSION TRANSITION INFO ===
    const session = {
        id: sessionState.sessionId,
        status: sessionState.status,
        responseVersion: sessionState.responseVersion,
        changed: sessionState.sessionId !== prevSessionState?.sessionId,
        cleared: !sessionState.sessionId && !!prevSessionState?.sessionId,
        justCompleted: sessionState.status === 'complete' && prevSessionState?.status === 'streaming',
        isStreaming: sessionState.status === 'streaming'
    };
    // === DERIVE STREAMING STATE INFO ===
    const streaming = {
        phase: streamingState.streamPhase,
        isIdle: streamingState.streamPhase === 'idle',
        isActive: streamingState.streamPhase !== 'idle',
        isProcessing: streamingState.streamPhase === 'mounting' || streamingState.streamPhase === 'streaming',
        canFinalize: streamingState.isStreaming && !streamingState.hasFinalStream && streamingState.streamPhase === 'streaming',
        hasNewContent: sessionState.responseVersion > streamingState.lastProcessedVersion
    };
    // === DECISION TREE (in priority order) ===
    // 1. CLEANUP: Session changed while we were actively streaming
    //    → Need to reset before handling the new session
    if (session.changed && streaming.isActive && autoAcceptAIChanges) return 'cleanup';
    // 2. SESSION CLEARED: No active session anymore
    //    → Nothing to do
    if (session.cleared) return null;
    // 3. FINALIZE: Stream just completed and we're ready to finalize
    //    → Commit the final content
    if (session.justCompleted && streaming.canFinalize) return 'finalize';
    // 4. MOUNT: Session is streaming but we haven't started yet
    //    → Initialize streaming decorations
    //    Note: Also handles "deferred mount" when orchestrator updates positions
    if (session.isStreaming && (streaming.isIdle || streamingState.streamPhase === 'finalizing')) return 'mount';
    // 5. UPDATE: We're actively processing and have new content
    //    → Stream the new content into the document
    if (session.isStreaming && streaming.isProcessing && streaming.hasNewContent) return 'update';
    // No action needed
    return null;
}
function $56b5f1a09d39ac02$export$218c70edcbbc64e5(streamingState, sessionState) {
    const isIdle = streamingState.streamPhase === 'idle';
    const noActiveSession = !sessionState?.sessionId;
    const sessionIsIdle = !sessionState || sessionState.status === 'idle';
    // Skip if completely idle with no active session
    if (isIdle && sessionIsIdle && noActiveSession) return true;
    // Skip if stream finalized and session has ended
    const streamFinalized = streamingState.hasFinalStream;
    const sessionComplete = sessionState?.status === 'complete';
    if (streamFinalized && sessionComplete && noActiveSession) return true;
    return false;
}






















function $35b43fbab041936a$export$c4d4122316c86846(view, restoreSelection = true) {
    const streamingState = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(view.state);
    if (!streamingState) return false;
    let { startPos: startPos, userContentEndPos: userContentEndPos } = streamingState;
    const { originalUserContentSlice: originalUserContentSlice, streamStartPos: streamStartPos } = streamingState;
    const isEmptySelection = startPos === userContentEndPos;
    // Validate we have required state
    if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice) {
        view.dispatch((0, $1DOVk.endStream)(view.state.tr));
        return false;
    }
    // Step 1: Undo streamed changes
    (0, $ke2AI.undo)(view.state, view.dispatch);
    // Re-get positions after undo - they may have changed
    const updatedState = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(view.state);
    startPos = updatedState?.startPos ?? startPos;
    userContentEndPos = updatedState?.userContentEndPos ?? userContentEndPos;
    // Step 2: Build cleanup transaction
    let tr = (0, $ke2AI.closeHistory)(view.state.tr);
    // Step 3: Restore selection if requested
    const decorationState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(view.state);
    if (restoreSelection && !decorationState?.sessionEnded) {
        const docSize = tr.doc.content.size;
        let anchor;
        let head;
        if (isEmptySelection) {
            anchor = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)(streamStartPos ?? startPos, docSize);
            head = anchor;
        } else {
            anchor = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$8c11be8ccd39ce0b)({
                pos: startPos,
                tr: tr
            }), docSize);
            head = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$3dcc2c094c7e6748)({
                pos: userContentEndPos,
                tr: tr
            }), docSize);
        }
        // Handle reversed selection
        if (decorationState?.initialSelection && decorationState.initialSelection.head < decorationState.initialSelection.anchor) [anchor, head] = [
            head,
            anchor
        ];
        // TextSelection.create can throw with invalid positions
        try {
            tr = tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, anchor, head));
        } catch  {
        // Positions invalid - keep default selection
        }
    }
    // Step 4: End stream and dispatch
    view.dispatch((0, $1DOVk.endStream)(tr));
    return true;
}


function $4d5430ab557dbfa1$export$b4e7ecb7c76b6f00() {
    return {
        isDiscardInProgress: false,
        lastSeenSessionId: undefined
    };
}
function $4d5430ab557dbfa1$export$e4f8a57678205f7d(view, state, discardState) {
    // Guard: Don't re-enter while we're discarding
    if (discardState.isDiscardInProgress) return;
    const sessionState = (0, $5oqzu.aiSessionContextPluginKey).getState(view.state);
    const currentSessionId = sessionState?.sessionId;
    // Detect if session was cleared while we were actively streaming
    const wasStreaming = state.streamPhase !== 'idle' && state.isStreaming;
    const sessionCleared = discardState.lastSeenSessionId && !currentSessionId;
    // Update tracking before processing
    discardState.lastSeenSessionId = currentSessionId;
    if (wasStreaming && sessionCleared) {
        discardState.isDiscardInProgress = true;
        try {
            (0, $35b43fbab041936a$export$c4d4122316c86846)(view, true);
        } catch  {
        // Discard failed - continue
        } finally{
            discardState.isDiscardInProgress = false;
        }
    }
}



var $hTKp4 = parcelRequire("hTKp4");

function $e5b850d2eca2666d$export$25dfe1561be19c6b(view, isActive, api, viewState) {
    const editorContentArea = view?.dom.closest('.ak-editor-content-area');
    if (viewState.originalTabIndex === undefined && editorContentArea) {
        viewState.originalTabIndex = editorContentArea.tabIndex;
        viewState.originalOutlineColor = editorContentArea.style.outlineColor;
        viewState.originalOutline = editorContentArea.style.outline;
    }
    // === STREAMING STARTED ===
    if (isActive && !viewState.hasActivatedStreaming) {
        viewState.hasActivatedStreaming = true;
        // Hide cursor and set up streaming state
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.selection?.commands.hideCursor?.(true)({
                tr: tr
            });
            api?.trackChanges?.commands.resetBaseline?.({
                tr: tr
            });
            api?.userIntent?.commands.setCurrentUserIntent?.('aiStreaming')({
                tr: tr
            });
            api?.editorDisabled?.commands.toggleDisabled?.(true)({
                tr: tr
            });
            return tr;
        });
        // Focus editor content area to enable keyboard shortcuts (e.g., Esc to cancel)
        if (editorContentArea) {
            editorContentArea.tabIndex = -1;
            editorContentArea.style.outline = 'none';
            const doc = (0, $hTKp4.getDocument)();
            if (doc && !editorContentArea.contains(doc.activeElement)) editorContentArea.focus();
        }
    }
    // === STREAMING ENDED ===
    if (!isActive && viewState.hasActivatedStreaming) {
        viewState.hasActivatedStreaming = false;
        // Show cursor and restore editor state
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.selection?.commands.hideCursor?.(false)({
                tr: tr
            });
            api?.userIntent?.commands.setCurrentUserIntent?.('default')({
                tr: tr
            });
            api?.editorDisabled?.commands.toggleDisabled?.(false)({
                tr: tr
            });
            return tr;
        });
        // Restore original editor content area state
        if (editorContentArea) $e5b850d2eca2666d$export$50f5de8099342b42(editorContentArea, viewState.originalTabIndex, viewState.originalOutlineColor, viewState.originalOutline);
    }
}
function $e5b850d2eca2666d$export$50f5de8099342b42(editorContentArea, originalTabIndex, originalOutlineColor, originalOutline) {
    if (originalTabIndex !== undefined) {
        if (originalTabIndex === -1) editorContentArea.removeAttribute('tabindex');
        else editorContentArea.tabIndex = originalTabIndex;
    }
    if (originalOutlineColor !== undefined) {
        editorContentArea.style.outlineColor = originalOutlineColor;
        if (editorContentArea.getAttribute('style') === '') editorContentArea.removeAttribute('style');
    }
    if (originalOutline !== undefined) {
        editorContentArea.style.outline = originalOutline;
        if (editorContentArea.getAttribute('style') === '') editorContentArea.removeAttribute('style');
    }
}
function $e5b850d2eca2666d$export$d459380d3cf60a30(view, viewState) {
    const editorContentArea = view.dom.closest('.ak-editor-content-area');
    if (editorContentArea) $e5b850d2eca2666d$export$50f5de8099342b42(editorContentArea, viewState.originalTabIndex, viewState.originalOutlineColor, viewState.originalOutline);
    viewState.originalTabIndex = undefined;
    viewState.originalOutlineColor = undefined;
    viewState.originalOutline = undefined;
}


function $26ee645154e56af9$export$ed6bcbf8c4a7024f(view, state, prevState, api) {
    if (!state.aiContentEndPos || state.aiContentEndPos === prevState?.aiContentEndPos || state.startPos === undefined) return;
    const { expand: expand, nestedExpand: nestedExpand } = view.state.schema.nodes;
    if (!expand && !nestedExpand) return;
    const startPos = state.startPos;
    const endPos = Math.min(state.aiContentEndPos, view.state.doc.content.size);
    if (startPos >= endPos) return;
    api?.expand?.commands.toggleExpandRange(startPos, endPos);
}






























function $fba14755b906eaef$export$1695ca555427e313(state) {
    const sessionState = (0, $5oqzu.aiSessionContextPluginKey).getState(state);
    if (!sessionState) return null;
    const { adfResponse: adfResponse, responseVersion: responseVersion } = sessionState;
    const streamingState = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state);
    const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state);
    const { positions: positions } = decorationPluginState ?? {};
    if (!streamingState || !positions) return null;
    // After restore, the document is back to original state
    // Use the positions from streaming state (which were mapped through restore)
    const { startPos: startPos, userContentEndPos: userContentEndPos, originalUserContentSlice: originalUserContentSlice, aiContentSlice: aiContentSlice } = streamingState;
    if (startPos === undefined || userContentEndPos === undefined) return $fba14755b906eaef$var$buildCommitStateOnly(state, streamingState, responseVersion);
    // IMPORTANT: Reuse the aiContentSlice that was already adjusted during the update phase.
    // This matches how the original hook works - it adjusts the slice ONCE before restore,
    // then reuses the same adjusted slice for commit. If we create a new slice here and
    // adjust it against the restored document state, we get different (incorrect) results
    // for edge cases like inserting a heading at the start of a paragraph.
    let slice = aiContentSlice;
    // Fallback: create new slice if aiContentSlice not available
    if (!slice) {
        const fragment = (0, $a18790a6197d27f1$export$f61de149b3c1af13)(state.schema, adfResponse);
        if (!fragment || !(0, $a18790a6197d27f1$export$34f795fdad5abc80)(fragment)) return $fba14755b906eaef$var$buildCommitStateOnly(state, streamingState, responseVersion);
        slice = (0, $5SAOw.Slice).maxOpen(fragment);
        if (!slice.content.firstChild) slice = (0, $5SAOw.Slice).empty;
    }
    if (slice.size <= 0) return $fba14755b906eaef$var$buildCommitStateOnly(state, streamingState, responseVersion);
    // Use positions from streaming state
    const docSize = state.doc.content.size;
    let workingStartPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)(startPos, docSize);
    let workingUserContentEndPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)(userContentEndPos, docSize);
    // List adjustment (matching original)
    if ((0, $dh538.fg)('platform_editor_ai_convert_list_to_table_bugfix')) {
        const listAdjustment = (0, $ecf3bcf501846ef2$export$b235a800374c03c3)({
            state: state,
            fragment: slice.content,
            startPos: workingStartPos,
            userContentEndPos: workingUserContentEndPos
        });
        if (listAdjustment.adjusted) {
            workingStartPos = listAdjustment.startPos;
            workingUserContentEndPos = listAdjustment.userContentEndPos;
        }
    }
    let tr = state.tr;
    const streamTimeStamp = streamingState.streamTimeStamp;
    const safeEndPos = Math.max(workingStartPos, Math.min(workingUserContentEndPos, docSize));
    // Apply final content - matching original commitFinalResponse logic
    try {
        const { paragraph: paragraph } = tr.doc.type.schema.nodes;
        // If we have a lone paragraph - replaceRange will not replace with a paragraph
        const isSingleParagraph = slice.content.firstChild === slice.content.lastChild && slice.content.firstChild?.type === paragraph;
        if (isSingleParagraph && workingStartPos < docSize) {
            const $from = tr.doc.resolve(workingStartPos);
            const isEmptyParagraph = $from.parent.type === paragraph && $from.parent.content.size === 0;
            if (isEmptyParagraph && slice.content.firstChild) tr = tr.replaceRangeWith(workingStartPos, safeEndPos, slice.content.firstChild);
            else tr = tr.replaceRange(workingStartPos, safeEndPos, slice);
        } else tr = tr.replaceRange(workingStartPos, safeEndPos, slice);
        tr = (0, $1DOVk.metaTransaction)({
            tr: tr,
            isFinalStream: true,
            stackTime: streamTimeStamp
        });
    } catch  {
        return $fba14755b906eaef$var$buildCommitStateOnly(state, streamingState, responseVersion);
    }
    // Set selection at end of inserted content
    try {
        tr = tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, Math.min(tr.selection.to, tr.doc.content.size)));
    } catch  {
    // Invalid position - keep default selection
    }
    // Skip history if content unchanged
    if (originalUserContentSlice) try {
        const newDocSize = tr.doc.content.size;
        const finalStartPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$8c11be8ccd39ce0b)({
            pos: startPos,
            tr: tr
        }), newDocSize);
        const finalEndPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$3dcc2c094c7e6748)({
            pos: userContentEndPos,
            tr: tr
        }), newDocSize);
        const newSlice = tr.doc.slice(finalStartPos, finalEndPos);
        if (newSlice.eq(originalUserContentSlice)) tr = tr.setMeta('addToHistory', false);
    } catch  {
    // Position mapping failed - add to history as normal
    }
    // Map final positions for telepointer
    const finalDocSize = tr.doc.content.size;
    const mappedStartPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$8c11be8ccd39ce0b)({
        pos: startPos,
        tr: tr
    }), finalDocSize);
    const mappedToPos = (0, $71d83711c24eb8b1$export$4af2bdeb9a1268d4)((0, $e2b6da12acd69cbd$export$3dcc2c094c7e6748)({
        pos: userContentEndPos,
        tr: tr
    }), finalDocSize);
    let telepointerPos = mappedToPos;
    try {
        tr.doc.nodesBetween(mappedStartPos, mappedToPos, (node, pos)=>{
            if (node.isLeaf) telepointerPos = pos + node.nodeSize;
        });
        telepointerPos = Math.min(telepointerPos, mappedToPos);
    } catch  {
    // Position out of bounds - use mapped end position
    }
    tr = (0, $1DOVk.updateStreamPositions)({
        aiContentEndPos: mappedToPos,
        telepointerPos: telepointerPos,
        isFinalStream: true,
        lastProcessedVersion: responseVersion
    })(tr);
    return tr;
}
function $fba14755b906eaef$var$buildCommitStateOnly(state, streamingState, responseVersion) {
    let tr = state.tr;
    tr = (0, $1DOVk.updateStreamPositions)({
        aiContentEndPos: streamingState.aiContentEndPos ?? streamingState.startPos ?? 0,
        telepointerPos: streamingState.telepointerPos ?? streamingState.startPos ?? 0,
        isFinalStream: true,
        lastProcessedVersion: responseVersion
    })(tr);
    return tr;
}











function $9df365bb20a14e22$export$a3c1603642e03c34(state) {
    const streamingState = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state);
    if (!streamingState) return null;
    const { startPos: startPos, userContentEndPos: userContentEndPos, originalUserContentSlice: originalUserContentSlice } = streamingState;
    if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice) return null;
    const streamTimeStamp = Date.now();
    let tr = state.tr;
    try {
        if (originalUserContentSlice.content.size > 0) tr = tr.replaceRange(startPos, userContentEndPos, originalUserContentSlice);
        else // If original was empty, we need to delete the AI content.
        // IMPORTANT: Use replaceRange with Slice.empty instead of delete()
        // because replaceRange properly handles block boundaries.
        // When a block node (e.g., heading) was inserted with openStart=0,
        // positions track content boundaries (inside the block), not node
        // boundaries. Using delete() would merge the block with adjacent content.
        // replaceRange with Slice.empty will delete the appropriate range
        // while preserving the structure of surrounding nodes.
        tr = tr.replaceRange(startPos, userContentEndPos, (0, $5SAOw.Slice).empty);
        tr = (0, $1DOVk.metaTransaction)({
            tr: tr,
            isFinalStream: false,
            stackTime: streamTimeStamp
        });
        // Mark as restore transaction so track-changes knows this is part of finalize
        tr = tr.setMeta('isAIRestoreTransaction', true);
        // Don't add to history - the commit transaction will be the undo point
        tr = tr.setMeta('addToHistory', false);
    } catch  {
        return null;
    }
    return tr;
}


function $7b5e313e31eb97f3$export$a3923527de5abc80() {
    return {
        isFinalizingInProgress: false
    };
}
function $7b5e313e31eb97f3$export$21750d5b9a51a4dd(view, state, finalizeState) {
    // Guard: Don't re-enter while we're dispatching restore/commit
    if (finalizeState.isFinalizingInProgress) return;
    const sessionState = (0, $5oqzu.aiSessionContextPluginKey).getState(view.state);
    if (!sessionState) return;
    // Check if finalize is needed:
    // - Session status is 'complete'
    // - Streaming state is in 'streaming' phase and actively streaming
    // - Final stream hasn't been applied yet
    const needsFinalize = sessionState.status === 'complete' && state.streamPhase === 'streaming' && state.isStreaming && !state.hasFinalStream;
    if (!needsFinalize) return;
    // Set flag to prevent re-entry during dispatches
    finalizeState.isFinalizingInProgress = true;
    try {
        // DISPATCH 1: Restore original content (streaming → original)
        const restoreTr = (0, $9df365bb20a14e22$export$a3c1603642e03c34)(view.state);
        if (restoreTr) view.dispatch(restoreTr);
        // DISPATCH 2: Commit final content (original → final)
        const commitTr = (0, $fba14755b906eaef$export$1695ca555427e313)(view.state);
        if (commitTr) view.dispatch(commitTr);
    } catch  {
    // Finalize failed - continue
    } finally{
        finalizeState.isFinalizingInProgress = false;
    }
}








const $de815ab9b96b6c55$var$LOADING_INTERVAL_MIN = 80;
const $de815ab9b96b6c55$var$LOADING_INTERVAL_MAX = 240;
function $de815ab9b96b6c55$export$46bad72eede9c7b(view, state, viewState) {
    const shouldAnimate = (state.streamPhase === 'mounting' || state.streamPhase === 'streaming') && !state.isPaused && state.aiContentEndPos === undefined;
    if (shouldAnimate && !viewState.loadingTimeout) $de815ab9b96b6c55$export$cd27e59e5909a810(view, viewState);
    if (!shouldAnimate && viewState.loadingTimeout) $de815ab9b96b6c55$export$b25251fc60891db7(viewState);
}
function $de815ab9b96b6c55$export$cd27e59e5909a810(view, viewState) {
    const interval = Math.random() * ($de815ab9b96b6c55$var$LOADING_INTERVAL_MAX - $de815ab9b96b6c55$var$LOADING_INTERVAL_MIN) + $de815ab9b96b6c55$var$LOADING_INTERVAL_MIN;
    viewState.loadingTimeout = window.setTimeout(()=>{
        const state = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(view.state);
        if (!state || state.isPaused || state.aiContentEndPos !== undefined || state.streamPhase === 'idle') {
            viewState.loadingTimeout = undefined;
            return;
        }
        try {
            view.dispatch((0, $1DOVk.updateLoadingPositions)(view.state.tr));
        } catch  {
        // Loading position update failed - continue
        }
        // Schedule next tick with NEW random interval
        $de815ab9b96b6c55$export$cd27e59e5909a810(view, viewState);
    }, interval);
}
function $de815ab9b96b6c55$export$b25251fc60891db7(viewState) {
    if (viewState.loadingTimeout) {
        clearTimeout(viewState.loadingTimeout);
        viewState.loadingTimeout = undefined;
    }
}


/**
 * Mutable state container for view-related streaming state.
 * Passed by reference to allow functions to update closure variables.
 */ function $8605ff1934edfea1$export$25cb56651fa39437() {
    return {
        loadingTimeout: undefined,
        originalTabIndex: undefined,
        originalOutlineColor: undefined,
        originalOutline: undefined,
        hasActivatedStreaming: false
    };
}


const $4df545aa292d26a2$export$465eeb0611517dc = (options)=>{
    const { api: api, canAutoAcceptAIChanges: canAutoAcceptAIChanges } = options;
    // Create the telepointer element
    const telepointerElement = (0, $f40d45a6cce8f6b7$export$b3d3cfdedcf26988)(options.getIntl().formatMessage((0, $7ShCl.aiMessages).aiRovoTelepointer));
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $ly5a2.purePmInEditorDirectStreamingPluginKey),
        state: {
            init: (0, $caaba1b8815755f9$export$de5e90bd767c5d82),
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $ly5a2.purePmInEditorDirectStreamingPluginKey));
                // Handle action-based state transformations
                // IMPORTANT: Return early when an action is handled because the positions
                // in the action payload are already mapped (e.g., in buildUpdateTransaction).
                // If we also run mapPositions, we'd double-map and get incorrect results.
                if (meta?.action) {
                    const newState = (0, $bf81f44e31217796$export$1056d35c08b77b41)(meta, pluginState);
                    if (newState !== undefined) return newState;
                }
                // Apply position mapping for transactions that don't have a streaming action
                // but do change the document
                if (tr.docChanged && pluginState.isStreaming) return (0, $bf81f44e31217796$export$38844252556f39ef)(tr, pluginState);
                return pluginState;
            }
        },
        appendTransaction (transactions, oldState, newState) {
            const streamingState = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(newState);
            const sessionState = (0, $5oqzu.aiSessionContextPluginKey).getState(newState);
            const prevSessionState = (0, $5oqzu.aiSessionContextPluginKey).getState(oldState);
            const decorationState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(newState);
            if (!streamingState || !sessionState) return null;
            // Quick bail-out checks
            if ((0, $56b5f1a09d39ac02$export$218c70edcbbc64e5)(streamingState, sessionState)) return null;
            // Determine what action is needed
            const action = (0, $56b5f1a09d39ac02$export$3174bd35cfffd429)(sessionState, prevSessionState, streamingState, false);
            if (!action) return null;
            // Handle suggest title separately as it uses a different transaction builder
            const isSuggestTitle = decorationState?.configItem && (0, $eba16d073b59ce1c$export$dc6f106b7f3aca98)(decorationState.configItem);
            if (isSuggestTitle && (action === 'update' || action === 'finalize')) return (0, $eba16d073b59ce1c$export$95ec53ef5cde2054)(newState, action === 'finalize');
            switch(action){
                case 'mount':
                    return (0, $2781a13e391742e0$export$5cba160ccca2cd8c)(newState);
                case 'update':
                    return (0, $35e4450f9b1d2d92$export$13c76c9a18264386)(newState);
                case 'cleanup':
                    // Reset streaming state when session changes mid-stream
                    return (0, $1DOVk.endStream)(newState.tr);
                // Finalize & Discard are handled in view.update()
                case 'finalize':
                case 'discard':
                default:
                    return null;
            }
        },
        props: {
            decorations (state) {
                return (0, $e0c73d166056a088$export$6e70fb48265e25fd)(state, telepointerElement);
            }
        },
        view: (editorView)=>{
            // Mutable state containers for view closure variables
            const viewState = (0, $8605ff1934edfea1$export$25cb56651fa39437)();
            const discardState = (0, $4d5430ab557dbfa1$export$b4e7ecb7c76b6f00)();
            const finalizeState = (0, $7b5e313e31eb97f3$export$a3923527de5abc80)();
            return {
                update (view, previousState) {
                    const state = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(view.state);
                    const prevState = (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(previousState);
                    if (!state) return;
                    // Handle discard when session is cleared while streaming
                    (0, $4d5430ab557dbfa1$export$e4f8a57678205f7d)(view, state, discardState);
                    // Handle finalize with TWO separate dispatches (matching original implementation)
                    // This is critical for track-changes to work correctly
                    (0, $7b5e313e31eb97f3$export$21750d5b9a51a4dd)(view, state, finalizeState);
                    // Detect finalised just completed, and auto accept AI changes is enabled, then we can auto accept the changes
                    const justFinalised = state.hasFinalStream && !prevState?.hasFinalStream;
                    if (justFinalised && canAutoAcceptAIChanges) {
                        api?.aiExperience?.actions.endAIExperience();
                        // Note: endAIExperience dispatches a transaction, which will trigger another update() call
                        // In that subsequent call, currentSessionId will be cleared and isActive will be false
                        return;
                    }
                    const { currentSessionId: currentSessionId } = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(view.state) || {};
                    const isActive = !!currentSessionId || state.isStreaming || state.isStreamingFinished;
                    if (!api) return;
                    (0, $de815ab9b96b6c55$export$46bad72eede9c7b)(view, state, viewState);
                    (0, $26ee645154e56af9$export$ed6bcbf8c4a7024f)(view, state, prevState, api);
                    (0, $e5b850d2eca2666d$export$25dfe1561be19c6b)(view, isActive, api, viewState);
                },
                destroy () {
                    (0, $de815ab9b96b6c55$export$b25251fc60891db7)(viewState);
                    (0, $e5b850d2eca2666d$export$d459380d3cf60a30)(editorView, viewState);
                }
            };
        }
    });
};






var $47Psn = parcelRequire("47Psn");





var $6bKwm = parcelRequire("6bKwm");




function $e9052fc7b27acce4$export$c72f28d9e4137cea(options) {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $47Psn.rovoAgentsPluginKey),
        state: (0, $6bKwm.createPluginState)(options.dispatch, // Initial state
        {
            agents: [],
            enabled: false,
            publish: ()=>{},
            isBrowseModalOpen: false,
            positions: undefined,
            initialised: false
        })
    });
}

















const $573094f376184d73$export$382457814c88610e = new (0, $ks2lK.PluginKey)('aiExperienceSelectionPreview');


const $904968b6cb52c4fa$export$6b0a857b1a5189ef = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $573094f376184d73$export$382457814c88610e),
        state: {
            init: (_, state)=>({
                    selectionPreview: false
                }),
            apply: (tr, _pluginState, _oldEditorState)=>{
                if (tr.getMeta('showSelectionPreview')) return {
                    selectionPreview: true
                };
                if (tr.getMeta('hideSelectionPreview')) return {
                    selectionPreview: false
                };
                return _pluginState;
            }
        },
        props: {
            decorations: (editorState)=>{
                const pluginState = (0, $573094f376184d73$export$382457814c88610e).getState(editorState);
                if (pluginState.selectionPreview) {
                    const { modalDecorationSet: modalDecorationSet } = (0, $kqrrC.getPluginState)(editorState);
                    const modalDecorations = modalDecorationSet.find(0, editorState.doc.content.size);
                    const existingHighlightDecoration = modalDecorations.filter((x)=>x?.spec?.key === 'inlineDecoration')[0];
                    const nodeDecoration = modalDecorations.filter((x)=>x?.spec?.key === 'ai-nodeDecoration')[0];
                    if (!nodeDecoration && !existingHighlightDecoration) {
                        const highlightDecoration = (0, $5SuLc.createInlineDecoration)(0, editorState.doc.content.size);
                        return (0, $ftzrq.DecorationSet).create(editorState.doc, [
                            highlightDecoration
                        ]);
                    }
                }
                return (0, $ftzrq.DecorationSet).empty;
            }
        }
    });
};









var $fXyZM = parcelRequire("fXyZM");





function $18bd41d0ea419926$export$be187c3e65ffcc8e(oldState, newState) {
    const oldDecoSet = (0, $kqrrC.getPluginState)(oldState)?.modalDecorationSet;
    const newDecoSet = (0, $kqrrC.getPluginState)(newState)?.modalDecorationSet;
    const oldPositions = oldDecoSet ? (0, $d465bdc6207b3d88$export$8e313fd1eaf35cec)({
        modalDecorationSet: oldDecoSet
    }) : undefined;
    const newPositions = newDecoSet ? (0, $d465bdc6207b3d88$export$8e313fd1eaf35cec)({
        modalDecorationSet: newDecoSet
    }) : undefined;
    if (oldPositions && !newPositions || !oldPositions && newPositions) return true;
    if (oldPositions && newPositions) return oldPositions[0] !== newPositions[0] || oldPositions[1] !== newPositions[1];
    return false;
}


/**
 * Clear the selection context when the next user action interaction occurs
 */ const $344063b249c0a0e4$var$clearPendingSelectionContext = (view)=>{
    const isPending = (0, $fXyZM.selectionPluginKey).getState(view.state)?.isPendingSelectionContextClear;
    if (isPending) {
        const { dispatch: dispatch, state: state } = view;
        dispatch(state.tr.setMeta((0, $fXyZM.selectionPluginKey), {
            action: 'clearPendingSelectionContext'
        }));
    }
};
const $344063b249c0a0e4$export$adbe0f8e0f3704d5 = ({ api: api, editorPluginAIProvider: editorPluginAIProvider })=>{
    let isMouseDown = false;
    let selectionChangedDuringDrag = false;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $fXyZM.selectionPluginKey),
        state: {
            init: ()=>({
                    nonCursorSelectionChangeCount: 0,
                    lastSelectionContext: undefined,
                    isPendingSelectionContextClear: false
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $fXyZM.selectionPluginKey));
                if (meta?.action === 'incrementNonCursorSelectionChangeCount') return {
                    ...pluginState,
                    nonCursorSelectionChangeCount: pluginState.nonCursorSelectionChangeCount + 1
                };
                else if (meta?.action === 'lastSelectionContextPending') return {
                    ...pluginState,
                    isPendingSelectionContextClear: true
                };
                else if (meta?.action === 'lastSelectionContext') {
                    const selection = meta.selection;
                    return {
                        ...pluginState,
                        isPendingSelectionContextClear: false,
                        lastSelectionContext: selection ? {
                            selectionFragment: api?.selection?.actions?.getSelectionFragment({
                                selection: selection
                            }) ?? null,
                            localIds: api?.selection?.actions?.getSelectionLocalIds({
                                selection: selection
                            }) ?? null,
                            selectionMarkdown: (0, $6eZqW.convertProsemirrorNodeToMarkdown)({
                                node: selection.content().content
                            }).markdown ?? null
                        } : undefined
                    };
                } else if (pluginState?.isPendingSelectionContextClear && meta?.action === 'clearPendingSelectionContext') return {
                    ...pluginState,
                    lastSelectionContext: undefined,
                    isPendingSelectionContextClear: false
                };
                return pluginState;
            }
        },
        appendTransaction: (_transactions, oldState, newState)=>{
            const oldSel = oldState.selection;
            const newSel = newState.selection;
            const pseudoSelectionChanged = (0, $18bd41d0ea419926$export$be187c3e65ffcc8e)(oldState, newState);
            // Check for pseudo-selection changes first
            if (pseudoSelectionChanged) {
                // If pseudo-selection changed, always count as meaningful
                // unless we are dragging with mouse
                if (isMouseDown) {
                    selectionChangedDuringDrag = true;
                    return null;
                }
                return newState.tr.setMeta((0, $fXyZM.selectionPluginKey), {
                    action: 'incrementNonCursorSelectionChangeCount'
                });
            }
            // If no pseudo-selection change, check actual selection differences
            if (oldSel.eq(newSel)) return null;
            // If both are empty and no pseudo-change
            if (oldSel.empty && newSel.empty) return null;
            // If the mouse is currently down (e.g., during a drag), record that a change occurred
            // but do not increment the counter yet. The increment will happen when the mouse is released.
            if (isMouseDown) {
                selectionChangedDuringDrag = true;
                return null;
            }
            // If the mouse is not down, this change is considered final and should increment
            // the selection change count immediately.
            return newState.tr.setMeta((0, $fXyZM.selectionPluginKey), {
                action: 'incrementNonCursorSelectionChangeCount'
            });
        },
        props: {
            handleDOMEvents: {
                paste: editorPluginAIProvider.isInDocumentStreamingEnabled ? (view)=>{
                    $344063b249c0a0e4$var$clearPendingSelectionContext(view);
                    return false;
                } : undefined,
                compositionstart: editorPluginAIProvider.isInDocumentStreamingEnabled ? (view)=>{
                    $344063b249c0a0e4$var$clearPendingSelectionContext(view);
                    return false;
                } : undefined,
                keydown: editorPluginAIProvider.isInDocumentStreamingEnabled ? (view)=>{
                    $344063b249c0a0e4$var$clearPendingSelectionContext(view);
                    return false;
                } : undefined,
                mousedown: (view)=>{
                    if (editorPluginAIProvider.isInDocumentStreamingEnabled) $344063b249c0a0e4$var$clearPendingSelectionContext(view);
                    // When the mouse goes down, we start "dragging" mode.
                    isMouseDown = true;
                    selectionChangedDuringDrag = false;
                    return false; // Returning false to allow other handlers
                },
                mouseup: (view)=>{
                    // When the mouse is released, if a selection change happened during dragging,
                    // we increment the counter once.
                    isMouseDown = false;
                    if (selectionChangedDuringDrag) {
                        const { state: state, dispatch: dispatch } = view;
                        dispatch(state.tr.setMeta((0, $fXyZM.selectionPluginKey), {
                            action: 'incrementNonCursorSelectionChangeCount'
                        }));
                        selectionChangedDuringDrag = false;
                    }
                    return false; // Returning false to allow other handlers
                }
            }
        }
    });
};





/* ContentComponentWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $eiA8Z = parcelRequire("eiA8Z");
















const $3a58a391c8755141$var$ContentComponentContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $3a58a391c8755141$export$9bdba9f1d1439b59 = $3a58a391c8755141$var$ContentComponentContext.Provider;
const $3a58a391c8755141$export$c8b5a1f09cc4bb85 = ()=>{
    const context = (0, $42omo.useContext)($3a58a391c8755141$var$ContentComponentContext);
    if (!context) throw new Error('No Editor view or API available in the context, make sure to have container wrapped with ContentComponentContextProvider');
    return context;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 



var $9K4OG = parcelRequire("9K4OG");


var $ieXGd = parcelRequire("ieXGd");

var $b38UX = parcelRequire("b38UX");





var $6fnsQ = parcelRequire("6fnsQ");




/* floating-toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ 




var $fVUfS = parcelRequire("fVUfS");




/* utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $8C5kA = parcelRequire("8C5kA");


var $b4zhJ = parcelRequire("b4zhJ");


var $dIxHZ = parcelRequire("dIxHZ");

const $359f9bb0bb5c3eba$var$nodeRenderers = {
    date: (node, intl)=>{
        const displayString = (0, $dIxHZ.timestampToString)(node.attrs.timestamp, intl);
        return /*#__PURE__*/ $42omo.createElement((0, $b4zhJ.Date), {
            value: node.attrs.timestamp
        }, displayString);
    }
};
const $359f9bb0bb5c3eba$export$fcbd2f181368d6ad = ({ node: node })=>{
    const intl = (0, $8C5kA.default)();
    const render = $359f9bb0bb5c3eba$var$nodeRenderers[node.type.name];
    return render ? render(node, intl) : /*#__PURE__*/ $42omo.createElement("span", null, node.type.name);
};


function $d4d1598b7faaa41b$var$_defineProperty(e, r, t) {
    return (r = $d4d1598b7faaa41b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d4d1598b7faaa41b$var$_toPropertyKey(t) {
    var i = $d4d1598b7faaa41b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d4d1598b7faaa41b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $d4d1598b7faaa41b$var$styles = {
    pressable: "_bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
};
class $d4d1598b7faaa41b$export$e510567c2b33e62 {
    static shouldShow(suggestion, selection) {
        return suggestion.from <= selection.from && suggestion.to >= selection.to;
    }
    static createToolbarItem(inlineSuggestion, api) {
        return {
            type: 'custom',
            render: (view)=>{
                if (!view || !inlineSuggestion.suggestedNode) return null;
                return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
                    xcss: $d4d1598b7faaa41b$var$styles.pressable,
                    onClick: ()=>{
                        (0, $2356c0ded658404c$export$d09baef8b6358b47)(api?.analytics?.actions)((0, $3ebfa284e46a7bd4$export$ae8cf7712eb9509e).TOOLBAR)(view.state, view.dispatch);
                        view.focus();
                    }
                }, /*#__PURE__*/ $42omo.createElement((0, $359f9bb0bb5c3eba$export$fcbd2f181368d6ad), {
                    node: inlineSuggestion.suggestedNode
                }));
            },
            fallback: []
        };
    }
    static buildToolbarConfig(inlineSuggestion, state, api) {
        const { paragraph: paragraph, heading: heading, taskItem: taskItem, decisionItem: decisionItem, caption: caption } = state.schema.nodes;
        return {
            title: 'Inline suggestions',
            getDomRef: ()=>{
                const anchor = document.querySelector(`.${(0, $49ae62cb4df29db1$export$3582487b0804e1f6).INLINE_SUGGESTION_DECORATION_CLASSES.toolbarAnchor}`);
                return anchor instanceof HTMLElement ? anchor : undefined;
            },
            nodeType: [
                paragraph,
                heading,
                taskItem,
                decisionItem,
                caption
            ].filter((nodeType)=>!!nodeType),
            items: [
                this.createToolbarItem(inlineSuggestion, api)
            ],
            align: 'left',
            className: this.INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS
        };
    }
    static maybeBuild(state, api) {
        const { inlineSuggestion: inlineSuggestion } = (0, $f60ba1d011d7390b$export$f05434c51e3762e)(state);
        if (!inlineSuggestion) return undefined;
        if (this.shouldShow(inlineSuggestion, state.selection)) return this.buildToolbarConfig(inlineSuggestion, state, api);
        return undefined;
    }
}
$d4d1598b7faaa41b$var$_defineProperty($d4d1598b7faaa41b$export$e510567c2b33e62, "INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS", 'proactive-ai-inline-suggestion-floating-toolbar');



function $5e1f6449d50a03b0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5e1f6449d50a03b0$var$highlightStyles = {
    name: "1hbjkx0",
    styles: "background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);border-bottom:var(--ds-border-width-selected, 2px) solid var(--ds-background-accent-blue-subtler, #cce0ff)"
};
const $5e1f6449d50a03b0$var$nodeHighlightStyles = {
    name: "mcqy92",
    styles: "border:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #579DFF);box-shadow:0 0 2px 1px var(--ds-background-accent-blue-subtler, #cce0ff)"
};
const $5e1f6449d50a03b0$var$cellHighlightStyles = /*#__PURE__*/ (0, $9K4OG.css)($5e1f6449d50a03b0$var$nodeHighlightStyles, " ::after{border-left:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #579DFF);border-bottom:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #579DFF);}");
// override standard dropdown max-height 90vh to accomodate for long list of translation languages
const $5e1f6449d50a03b0$var$translationsFloatingToolbarDropdownStyles = {
    name: "735ejv",
    styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{max-height:400px;overflow-x:hidden;[data-testid^='ak-editor-ai-selection-toolbar-translate-button'] [data-item-elem-before]>span{padding:0;}}[data-testid='ak-editor-ai-selection-toolbar-ai-dropdown']>span>span{margin:0;}}"
};
const $5e1f6449d50a03b0$var$dropdownHeadingStyles = /*#__PURE__*/ (0, $9K4OG.css)("[aria-label='Selection toolbar']{[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']{cursor:default;>span{gap:initial;}[data-item-elem-before]>span{padding:0;}[data-item-title]{text-transform:uppercase;font-size:0.75rem;font-weight:var(--ds-font-weight-bold, 653);color:", `var(--ds-text, ${(0, $6fnsQ.N200)})`, ";}}[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']:hover{color:", `var(--ds-text, ${(0, $6fnsQ.N700)})`, ";}}");
const $5e1f6449d50a03b0$var$rovoAgentsFloatingToolbarDropdownStyles = {
    name: "aisf00",
    styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{[data-testid='ak-editor-ai-selection-toolbar-dropdown-view-all-agents']:not(:only-child){border-block-start:var(--ds-border-width-selected, 2px) solid var(--ds-menu-seperator-color, var(--ds-border, #e1e3e7));>span{gap:4px;}}button[data-testid^='ak-editor-ai-selection-toolbar-dropdown-agent'] [data-item-title='true']>span{white-space:normal;}}}"
};
var $5e1f6449d50a03b0$var$_ref = {
    name: "1pr32me",
    styles: "button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus,button[data-testid='ak-editor-annotation-toolbar-create-button'],button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,button[data-testid='ak-editor-annotation-toolbar-create-button']:focus{padding:0px var(--ds-space-100, 8px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button'] svg{padding-right:var(--ds-space-050, 4px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button']>span:only-child{svg{padding:0px var(--ds-space-100, 8px);}}"
};
var $5e1f6449d50a03b0$var$_ref2 = {
    name: "2wdbgh",
    styles: "button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus{padding:0px var(--ds-space-075, 6px);}button[data-testid='ak-editor-annotation-toolbar-create-button'],button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,button[data-testid='ak-editor-annotation-toolbar-create-button']:focus{padding:0px var(--ds-space-075, 6px);span:first-child{margin:0;}span[role='img'],svg{padding:0;}}"
};
const $5e1f6449d50a03b0$var$aiSelectionToolbarButtonStyles = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return $5e1f6449d50a03b0$var$_ref2;
    else return $5e1f6449d50a03b0$var$_ref;
};
const $5e1f6449d50a03b0$var$inlineSuggestionsStyles = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".ak-editor-content-area .", (0, $d4d1598b7faaa41b$export$e510567c2b33e62).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS, "{padding:var(--ds-space-100, 8px);border-radius:var(--ds-space-075, 6px);[class$='-DateLozenge']{margin:0;}}.", (0, $49ae62cb4df29db1$export$3582487b0804e1f6).INLINE_SUGGESTION_DECORATION_CLASSES.underline, "{text-decoration-line:underline;text-decoration-style:dashed;text-decoration-color:var(--ds-border-accent-blue, #1D7AFC);}.", (0, $49ae62cb4df29db1$export$3582487b0804e1f6).INLINE_SUGGESTION_DECORATION_CLASSES.highlight, "{background-color:var(--ds-background-selected, #E9F2FF);}.", (0, $49ae62cb4df29db1$export$3582487b0804e1f6).INLINE_SUGGESTION_DECORATION_CLASSES.completionHint, "{color:", `var(--ds-text, ${(0, $6fnsQ.N800)})`, ";opacity:var(--ds-opacity-disabled, 0.5);pointer-events:none;user-select:none;}");
};
const $5e1f6449d50a03b0$var$userHighlightBackgroundColor = {
    name: "2h87e8",
    styles: ".akEditor div.ProseMirror{.ai-pre-stream-range-selection{background-color:Highlight;&.ak-editor-annotation-draft, &.ak-editor-annotation-focus, &.ak-editor-annotation-blur{all:unset;background-color:Highlight;}}.annotationView-content-wrap{.ak-editor-annotation-draft, .ak-editor-annotation-focus, .ak-editor-annotation-blur{&:has(.ai-pre-stream-selection-highlight){all:unset;background-color:Highlight;}}}}"
};
const $5e1f6449d50a03b0$var$inEditorStreamingStyles = {
    name: "vdmq5y",
    styles: ".akEditor div.ProseMirror{.ai-modal-mount-point-widget{bottom:0;}tr>.ai-modal-mount-point-widget{display:table-cell;}.ai-pre-stream-empty-selection-caret{content:'';position:relative;border-left:var(--ds-border-width, 1px) solid var(--ds-text, #292A2E);margin-left:-1px;left:0.5px;}.ai-inline-streaming-hidden{display:none;}.ai-in-editor-user-content{opacity:0.2;}.ai-in-editor-ai-content:not(\n\t\t\t.ak-editor-annotation-draft,\n\t\t\t.ak-editor-annotation-focus,\n\t\t\t.ak-editor-annotation-blur\n\t\t){background-color:var(--ds-background-accent-purple-subtlest, #F8EEFE);border-bottom:var(--ds-border-width, 1px) dashed var(--ds-border-accent-purple, #AF59E1);}.ai-in-editor-telepointer{position:relative;z-index:1;&>.ai-in-editor-telepointer-label{position:absolute;box-sizing:border-box;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:var(--ds-space-025, 2px);gap:var(--ds-space-075, 6px);height:16px;top:var(--ds-space-0, 0px);left:var(--ds-space-0, 0px);border-radius:0px var(--ds-space-050, 4px) var(--ds-space-050, 4px) 0px;border:solid var(--ds-border-width, 1px) transparent;background:linear-gradient(var(--ds-text, #292A2E), var(--ds-text, #292A2E)) padding-box,conic-gradient(\n\t\t\t\t\t\t\tfrom 270deg at 50% 50%,\n\t\t\t\t\t\t\t#1868db 0deg,\n\t\t\t\t\t\t\t#1868db 115deg,\n\t\t\t\t\t\t\t#fca700 115deg,\n\t\t\t\t\t\t\t#fca700 180deg,\n\t\t\t\t\t\t\t#bf63f3 180deg,\n\t\t\t\t\t\t\t#bf63f3 310deg,\n\t\t\t\t\t\t\t#82b536 310deg,\n\t\t\t\t\t\t\t#82b536 359.96deg,\n\t\t\t\t\t\t\t#1868db 360deg\n\t\t\t\t\t\t) border-box;font-family:var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);font-size:10px;line-height:9px;text-align:center;white-space:pre;color:var(--ds-text-inverse, #FFFFFF);}&::after{content:'';position:absolute;width:1px;height:24px;top:var(--ds-space-0, 0px);left:var(--ds-space-0, 0px);background:var(--ds-border-brand, #1868DB);}}}"
};
/**
 * We position it as a table row to ensure it doesn't affect the table layout.
 */ const $5e1f6449d50a03b0$var$modalMountPointTableFix = {
    name: "pxemtm",
    styles: ".akEditor div.ProseMirror{tbody>.ai-modal-mount-point-widget{height:0;display:table-row;border-top-style:solid;border-top-width:var(--ds-border-width, 1px);}}"
};
const $5e1f6449d50a03b0$var$globalStyles = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".akEditor div.ProseMirror{.ai-modal-start-widget,.ai-modal-end-widget{position:relative;&::before{content:'';background-image:url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxSDBMMSAxLjg1NzE0VjE4LjE0MzNMMCAxOS4wMDA0SDNMMiAxOC4xNDMzVjEuODU3MTRMMyAxSDJIMVoiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3QgeT0iMTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iMSIgZmlsbD0iIzU3OURGRiIvPgo8L3N2Zz4K');z-index:1;display:block;position:absolute;top:0;bottom:var(--ds-space-negative-025, -2px);background-repeat:no-repeat;background-position-x:center;background-position-y:center;background-size:contain;aspect-ratio:3/20;}}.ai-modal-start-widget::before{left:0px;margin-left:-0.1em;}.ai-modal-end-widget::before{right:0px;margin-right:-0.1em;}.ai-generated-content-highlight{", $5e1f6449d50a03b0$var$highlightStyles, ";}.ai-selection-highlight{", $5e1f6449d50a03b0$var$highlightStyles, "&.ak-editor-annotation-draft,&.ak-editor-annotation-focus,&.ak-editor-annotation-blur{all:unset;", $5e1f6449d50a03b0$var$highlightStyles, ";}}.ai-selection-node .pm-table-wrapper{table tr td,table tr th{", (0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Border,
        (0, $b38UX.SelectionStyle).Blanket
    ]), ";}}.ai-generated-node-highlight .pm-table-wrapper{table tr td,table tr th{", $5e1f6449d50a03b0$var$cellHighlightStyles, ";}}.annotationView-content-wrap{.ak-editor-annotation-draft,.ak-editor-annotation-focus,.ak-editor-annotation-blur{&:has(.ai-selection-highlight){all:unset;", $5e1f6449d50a03b0$var$highlightStyles, ";}}}}");
};
const $5e1f6449d50a03b0$var$nestedEditorStyles = {
    name: "1w40d4h",
    styles: ".ak-editor-plugin-ai-modal .ak-editor-content-area .ProseMirror{min-height:auto;> p:last-of-type{margin-bottom:0;}}"
};
const $5e1f6449d50a03b0$export$214e018fc3e147ea = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: [
            $5e1f6449d50a03b0$var$translationsFloatingToolbarDropdownStyles,
            $5e1f6449d50a03b0$var$rovoAgentsFloatingToolbarDropdownStyles,
            $5e1f6449d50a03b0$var$inlineSuggestionsStyles(),
            $5e1f6449d50a03b0$var$dropdownHeadingStyles,
            $5e1f6449d50a03b0$var$globalStyles(),
            $5e1f6449d50a03b0$var$inEditorStreamingStyles,
            $5e1f6449d50a03b0$var$userHighlightBackgroundColor,
            $5e1f6449d50a03b0$var$aiSelectionToolbarButtonStyles(),
            (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') && $5e1f6449d50a03b0$var$nestedEditorStyles,
            (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') && $5e1f6449d50a03b0$var$modalMountPointTableFix
        ]
    }), children);
};


/* SessionUIComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 









const $0f4ccde48208a2ab$export$4783d4d69ea114f3 = ({ dispatch: dispatch, state: state })=>({
        syncCommonAttributes: (attributes)=>dispatch(state.tr.setMeta((0, $290ed39dc9fde36a$export$249b63272434dfc7), attributes))
    });



















/* AcceptReject.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $808tb = parcelRequire("808tb");


var $fi2El = parcelRequire("fi2El");





var $1s5hv = parcelRequire("1s5hv");

/* FeedbackForm.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 



var $gMc0m = parcelRequire("gMc0m");











var $9zIwY = parcelRequire("9zIwY");


var $9FnLD = parcelRequire("9FnLD");


var $gdv5Z = parcelRequire("gdv5Z");


var $6F6hl = parcelRequire("6F6hl");


var $cgtv4 = parcelRequire("cgtv4");

var $723d60dd8af8a494$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    goodResponse: {
        id: "fabric.editor.ai.components.feedbackForm.goodResponse",
        defaultMessage: "Good response"
    },
    badResponse: {
        id: "fabric.editor.ai.components.feedbackForm.badResponse",
        defaultMessage: "Bad response"
    },
    feedbackSent: {
        id: "fabric.editor.ai.components.feedbackForm.feedbackSent",
        defaultMessage: "Feedback sent"
    }
});


const $475e1faaefe5731f$var$iconWrapperStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $475e1faaefe5731f$var$hideBackgroundStyles = null;
const $475e1faaefe5731f$var$Announcer = ({ message: message, shouldAnnounce: shouldAnnounce })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            "aria-atomic": "true",
            "aria-live": "polite",
            children: shouldAnnounce && message
        })
    });
};
const $475e1faaefe5731f$var$FeedbackButton = ({ type: type, onClick: onClick, isPressed: isPressed, isDisabled: isDisabled, flexIconWrapper: flexIconWrapper, largeIconButton: largeIconButton })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const responseLabel = type === 'good' ? formatMessage((0, $723d60dd8af8a494$export$2e2bcd8739ae039).goodResponse) : formatMessage((0, $723d60dd8af8a494$export$2e2bcd8739ae039).badResponse);
    const color = isPressed ? "var(--ds-link-pressed, #1558BC)" : 'currentColor';
    const Icon = ()=>type === 'good' ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
            label: responseLabel,
            color: color
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
            label: responseLabel,
            color: color
        });
    const tooltipOptions = {
        position: 'top',
        content: responseLabel
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            flexIconWrapper && "_1e0c1txw _4cvr1h6o _1bah1h6o",
            (isPressed || isDisabled) && "_7dirsm61"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            testId: `${type}-response-feedback-button`,
            type: "button",
            isDisabled: isDisabled,
            onClick: onClick,
            icon: Icon,
            label: responseLabel,
            appearance: "subtle",
            spacing: largeIconButton ? undefined : 'compact',
            isTooltipDisabled: false,
            tooltip: tooltipOptions
        })
    });
};
const $475e1faaefe5731f$export$ce859c56062f484c = ({ onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, isPressed: isPressed, isDisabled: isDisabled, flexIconWrapper: flexIconWrapper, largeIconButton: largeIconButton })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const feedbackWasSentLabel = formatMessage((0, $723d60dd8af8a494$export$2e2bcd8739ae039).feedbackSent);
    const [feedbackSelected, setFeedbackSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((onClick, feedback)=>()=>{
            onClick();
            setFeedbackSelected(feedback);
        }, [
        setFeedbackSelected
    ]);
    const disableButton = !!isPressed || isDisabled || !!feedbackSelected;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($475e1faaefe5731f$var$Announcer, {
                message: feedbackWasSentLabel,
                shouldAnnounce: Boolean(feedbackSelected)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($475e1faaefe5731f$var$FeedbackButton, {
                type: "good",
                isPressed: isPressed === 'good',
                isDisabled: disableButton,
                flexIconWrapper: flexIconWrapper,
                largeIconButton: largeIconButton,
                onClick: handleOnClick(onGoodResponseButtonClick, 'good')
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($475e1faaefe5731f$var$FeedbackButton, {
                type: "bad",
                isPressed: isPressed === 'bad',
                isDisabled: disableButton,
                flexIconWrapper: flexIconWrapper,
                largeIconButton: largeIconButton,
                onClick: handleOnClick(onBadResponseButtonClick, 'bad')
            })
        ]
    });
};



var $40sdH = parcelRequire("40sdH");




var $13afa04c82162ebf$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    acceptLabel: {
        id: "fabric.editor.ai.screens.acceptReject.acceptLabel",
        defaultMessage: "Accept"
    },
    rejectLabel: {
        id: "fabric.editor.ai.screens.acceptReject.rejectLabel",
        defaultMessage: "Discard"
    }
});


const $04da2381767ad981$var$styles = {
    container: "_ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi"
};
const $04da2381767ad981$var$stylesUnbounded = {
    toggleChangesButtonWrapper: "_12o5glyw"
};
const $04da2381767ad981$export$87eca91cbe06d0c8 = ({ onAccept: onAccept, onReject: onReject, onBadResponseButtonClick: onBadResponseButtonClick, onGoodResponseButtonClick: onGoodResponseButtonClick, isDisplayingChanges: isDisplayingChanges, onToggleChanges: onToggleChanges })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40sdH.FloatingContainer), {
        "data-testid": "accept-reject-screen",
        rainbowBorderAnimation: false,
        rainbowBorder: false,
        disablePadding: true,
        enableMaxWidth: true,
        isAIFC: true,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $04da2381767ad981$var$styles.container,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    gap: "space.050",
                    children: [
                        (0, $dh538.fg)('platform_editor_ai_aifc_no_default_diff') && /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            alignItems: "center",
                            justifyContent: "center",
                            xcss: $04da2381767ad981$var$stylesUnbounded.toggleChangesButtonWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                testId: "toggle-changes-button",
                                type: "button",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($fi2El))),
                                label: formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel),
                                appearance: "subtle",
                                isTooltipDisabled: false,
                                tooltip: {
                                    position: 'top',
                                    content: formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel)
                                },
                                isSelected: isDisplayingChanges,
                                onClick: onToggleChanges
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $475e1faaefe5731f$export$ce859c56062f484c), {
                            onBadResponseButtonClick: onBadResponseButtonClick,
                            onGoodResponseButtonClick: onGoodResponseButtonClick,
                            flexIconWrapper: (0, $dh538.fg)('platform_editor_ai_aifc_no_default_diff'),
                            largeIconButton: (0, $dh538.fg)('platform_editor_ai_aifc_no_default_diff')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    gap: (0, $dh538.fg)('platform_editor_ai_aifc_no_default_diff') ? 'space.050' : 'space.100',
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            onClick: onReject,
                            children: formatMessage((0, $13afa04c82162ebf$export$2e2bcd8739ae039).rejectLabel)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "primary",
                            onClick: onAccept,
                            autoFocus: true,
                            children: formatMessage((0, $13afa04c82162ebf$export$2e2bcd8739ae039).acceptLabel)
                        })
                    ]
                })
            ]
        })
    });
};











/* Container.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $e340c4e479241554$var$slideFadeIn = null;
const $e340c4e479241554$var$loadingStyles = null;
const $e340c4e479241554$export$42a852a2b6b56249 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_2lx21bp4 _kqsw1n9t _94n5pxbi _18u0mgjw _2hwxmgjw _19pkpxbi _1pby1nn1 _1bsb1ht8 _j7hq1w10 _5sagfnf5 _1pgl6ui8 _1o51q7pw _ta6yglyw"
        ])
    }, children);
});


const $ef7b093638b9e335$export$fe4c8e5bea1e02f4 = ({ api: api, dispatch: dispatch, appearance: appearance })=>{
    const { isDisplayingChanges: isDisplayingChanges, endExperience: endExperience, editorPluginAIProvider: editorPluginAIProvider, editorView: editorView } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const { configItem: configItem, lastTriggeredFrom: lastTriggeredFrom } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>({
            configItem: state.aiExperienceState?.aiDecorationExperiencePluginState?.configItem,
            lastTriggeredFrom: state.aiExperienceState?.aiDecorationExperiencePluginState?.lastTriggeredFrom
        }));
    const product = editorPluginAIProvider.product;
    // preset prompt or base generate / interrogation
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    const aiExperienceMetadata = (0, $42omo.useMemo)(()=>{
        return {
            configItemTitle: configItem?.agent?.name || (0, $6gJll.convertExperienceName)(configItem?.key?.toString() ?? ''),
            ...configItem?.experienceId && (0, $dh538.fg)('thor_support_google_docs_in_description_improver') ? {
                experienceId: configItem?.experienceId
            } : {},
            lastTriggeredFrom: lastTriggeredFrom
        };
    }, [
        configItem,
        lastTriggeredFrom
    ]);
    const onToggleChanges = (0, $42omo.useCallback)(()=>{
        // toggle diff, diff will also be turned off when unmount ExperienceApplication
        const toggleCmd = api?.trackChanges?.commands?.toggleChanges;
        if (toggleCmd) api?.core.actions.execute(toggleCmd);
    }, [
        api
    ]);
    const onAccept = (0, $42omo.useCallback)(()=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_CHANGES_ACCEPT_BUTTON,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                appearance: appearance,
                configItemTitle: configItem?.agent?.name || configItem?.key,
                lastTriggeredFrom: lastTriggeredFrom,
                product: product
            }
        });
        api?.analytics?.actions?.fireAnalyticsEvent((0, $ilIeg.createUnifiedAnalyticsPayload)({
            action: (0, $d925B.ACTION).ACTIONED,
            interactionID: analyticsFlow.getLastAiInteractionId(),
            experienceName: (0, $6gJll.convertExperienceName)(configItem?.key?.toString() ?? ''),
            isProactive: false,
            attributes: {
                ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                    init: false
                }),
                aiResultAction: 'accepted',
                aiActionedType: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? 'manuallyAccepted' : undefined
            },
            invokedFrom: lastTriggeredFrom
        }));
        endExperience();
        dispatch({
            type: 'reset'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        api,
        appearance,
        configItem,
        lastTriggeredFrom,
        product,
        endExperience,
        analyticsFlow,
        dispatch
    ]);
    const onReject = (0, $42omo.useCallback)(()=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_CHANGES_REJECT_BUTTON,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                appearance: appearance,
                configItemTitle: configItem?.agent?.name || configItem?.key,
                lastTriggeredFrom: lastTriggeredFrom,
                product: product
            }
        });
        api?.analytics?.actions?.fireAnalyticsEvent((0, $ilIeg.createUnifiedAnalyticsPayload)({
            action: (0, $d925B.ACTION).DISMISSED,
            interactionID: analyticsFlow.getLastAiInteractionId(),
            experienceName: (0, $6gJll.convertExperienceName)(configItem?.key?.toString() ?? ''),
            isProactive: false,
            attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                init: false
            }),
            invokedFrom: lastTriggeredFrom
        }));
        // api?.core.actions.execute(rejectCommand(editorView?.state));
        // discardStream({ view: editorView, restoreSelection: true });
        (0, $35b43fbab041936a$export$c4d4122316c86846)(editorView, true);
        dispatch({
            type: 'reset'
        });
        endExperience();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        api,
        appearance,
        configItem,
        lastTriggeredFrom,
        product,
        analyticsFlow,
        dispatch,
        endExperience
    ]);
    const fireResponseFeedbackEvent = (0, $42omo.useCallback)((sentiment, productSuccessState)=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'responseFeedbackButton',
                attributes: {
                    sentiment: sentiment,
                    appearance: appearance,
                    product: product,
                    configItemTitle: configItem?.agent?.name || configItem?.key,
                    lastTriggeredFrom: lastTriggeredFrom,
                    productSuccessStatus: productSuccessState,
                    aiInteractionID: analyticsFlow.getLastAiInteractionId()
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
        fireAIAnalyticsEvent({
            payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                action: (0, $d925B.ACTION).SUBMITTED,
                interactionID: analyticsFlow.getLastAiInteractionId(),
                experienceName: (0, $6gJll.convertExperienceName)(configItem?.key?.toString() ?? '', lastTriggeredFrom),
                isProactive: false,
                invokedFrom: lastTriggeredFrom,
                attributes: {
                    aiFeedbackResult: sentiment === 'good' ? 'up' : 'down',
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    })
                }
            })
        });
    }, [
        configItem,
        fireAIAnalyticsEvent,
        analyticsFlow,
        lastTriggeredFrom,
        appearance,
        product
    ]);
    const handleFiringFeedbackEvent = (0, $42omo.useCallback)(async (feedbackMetadata)=>{
        analyticsFlow.addAttributes({
            userFeedbackSentiment: feedbackMetadata.sentiment
        });
        // // we need to update the state machine to reflect the user feedback
        // sendToAIExperienceMachine({
        // 	type: 'feedback submitted',
        // 	sentiment: feedbackMetadata.sentiment as 'good' | 'bad',
        // });
        // handleFeedbackSubmission is intended to be implemented
        // by all products -- there will be a period where products won't have
        // it implemented (and will be relying on THUMBS_UP/THUMBS_DOWN)
        // in these cases -- we don't know the product response status
        if (!editorPluginAIProvider.handleFeedbackSubmission) {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'unknown');
            return;
        } else try {
            const productResponse = await editorPluginAIProvider.handleFeedbackSubmission(feedbackMetadata);
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, productResponse.status);
        } catch  {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'failed');
        }
    }, [
        fireResponseFeedbackEvent,
        editorPluginAIProvider,
        analyticsFlow
    ]);
    const getAIExperience = (0, $42omo.useCallback)(()=>({
            ...aiExperienceMetadata
        }), [
        aiExperienceMetadata
    ]);
    const onBadResponseButtonClick = (0, $42omo.useCallback)(()=>{
        const feedbackMetadata = {
            sentiment: 'bad',
            getAIExperience: getAIExperience,
            editorAttributes: {
                appearance: appearance,
                product: product
            }
        };
        // Now deprecated - migrate to handleFeedbackSubmission
        editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_DOWN();
        handleFiringFeedbackEvent(feedbackMetadata);
    }, [
        getAIExperience,
        editorPluginAIProvider.onExperienceEvent,
        handleFiringFeedbackEvent,
        appearance,
        product
    ]);
    const onGoodResponseButtonClick = (0, $42omo.useCallback)(()=>{
        const feedbackMetadata = {
            sentiment: 'good',
            getAIExperience: getAIExperience,
            editorAttributes: {
                appearance: appearance,
                product: product
            }
        };
        // Now deprecated - migrate to handleFeedbackSubmission
        editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_UP();
        handleFiringFeedbackEvent(feedbackMetadata);
    }, [
        getAIExperience,
        editorPluginAIProvider.onExperienceEvent,
        handleFiringFeedbackEvent,
        appearance,
        product
    ]);
    const acceptRejectScreenRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e340c4e479241554$export$42a852a2b6b56249), {
        ref: acceptRejectScreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04da2381767ad981$export$87eca91cbe06d0c8), {
        onAccept: onAccept,
        onReject: onReject,
        onBadResponseButtonClick: onBadResponseButtonClick,
        onGoodResponseButtonClick: onGoodResponseButtonClick,
        isDisplayingChanges: isDisplayingChanges,
        onToggleChanges: onToggleChanges
    }));
};








// eslint-disable-next-line no-restricted-imports



const $453a2c54e5f1c7c7$export$c73af7ca4a2501ab = (0, $cgtv4.defineMessages)({
    dialogAriaLabel: {
        id: "fabric.editor.ai.experience.dialogAriaLabel",
        defaultMessage: "Atlassian Intelligence Dialog"
    },
    responseTooSimilarMessage: {
        id: "fabric.editor.ai.experience.responseTooSimilarMessage",
        defaultMessage: "Atlassian Intelligence has no suggestions at this time. Feel free to try a different prompt or content."
    },
    generatingAiResponse: {
        id: "fabric.editor.ai.experience.generatingAiResponse",
        defaultMessage: "Generating"
    },
    discardMessagePrompt: {
        id: "fabric.editor.ai.experience.discardMessagePrompt",
        defaultMessage: "Do you want to discard your prompt?"
    },
    discardMessageResponse: {
        id: "fabric.editor.ai.experience.discardMessageResponse",
        defaultMessage: "Do you want to discard your response?"
    },
    discardStreamingInDocumennt: {
        id: "fabric.editor.ai.experience.discardStreamingInDocumennt",
        defaultMessage: "Cancel request and discard response?"
    },
    loadingTitle: {
        id: "fabric.editor.ai.experience.loadingTitle",
        defaultMessage: "Generating"
    },
    messageTemplateAnalysingQuery: {
        id: "fabric.editor.ai.experience.messageTemplateAnalysingQuery",
        defaultMessage: "Analyzing: Reviewing your question."
    },
    messageTemplateContentSearch: {
        id: "fabric.editor.ai.experience.messageTemplateContentSearch",
        defaultMessage: "Searching: One moment while we search for information."
    },
    messageTemplatePageHydration: {
        id: "fabric.editor.ai.experience.messageTemplatePageHydration",
        defaultMessage: "Searching: One moment while we search the page."
    },
    messageTemplateNextBestTask: {
        id: "fabric.editor.ai.experience.messageTemplateNextBestTask",
        defaultMessage: "Searching: One moment while we search Jira."
    },
    convoAIBeta: {
        id: "fabric.editor.ai.screens.preview.convoAIBeta",
        defaultMessage: "Content generation requests that reference URLs is in beta."
    },
    useRovoOrganisationKnowledgeRightText: {
        id: "fabric.editor.ai.experience.labelRight.rovo",
        defaultMessage: "Rovo"
    },
    useGeneralAiKnowledgeRightText: {
        id: "fabric.editor.ai.experience.labelRight.atlassianIntelligence",
        defaultMessage: "Atlassian Intelligence"
    },
    actionsGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.actions",
        defaultMessage: "Actions"
    },
    atlassianIntelligenceGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence",
        defaultMessage: "Atlassian intelligence"
    },
    knowledgeSourceGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource",
        defaultMessage: "Knowledge source"
    },
    agentsSuggestionGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.agents",
        defaultMessage: "Agents"
    },
    rovoAgentsCountSuggestionGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount",
        defaultMessage: "Rovo agents ({numberOfAgents})"
    },
    useRovoAgentsCountSuggestionGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount",
        defaultMessage: "Use a Rovo agent ({numberOfAgents})"
    },
    rovoAgentsSuggestionGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents",
        defaultMessage: "Rovo agents"
    },
    useGeneralAiKnowledgeLabel: {
        id: "fabric.editor.ai.experience.useGeneralAiKnowledgeLabel",
        defaultMessage: "Use general knowledge"
    },
    useRovoOrganisationKnowledgeLabel: {
        id: "fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel",
        defaultMessage: "Use knowledge from your organization"
    },
    agentsFooterRightText: {
        id: "fabric.editor.ai.experience.footerRightText.agents",
        defaultMessage: "Powered by Rovo"
    },
    agentsBrowseMore: {
        id: "fabric.editor.ai.experience.browseMore.agents",
        defaultMessage: "Browse Agents"
    },
    showMoreButton: {
        id: "fabric.editor.ai.experience.showMoreButton",
        defaultMessage: "Show more"
    },
    noResultsSuggestion: {
        id: "fabric.editor.ai.experience.noResultsSuggestion",
        defaultMessage: "No results"
    },
    engagementBannerLinksText: {
        id: "fabric.editor.ai.experience.engagementBannerLinksText",
        defaultMessage: "\uD83D\uDE80 You can now paste links \uD83D\uDD17 to Jira and Confluence content in your prompts."
    }
});














/* Discard.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 















var $ebrpi = parcelRequire("ebrpi");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");





var $kuYGt = parcelRequire("kuYGt");





var $imfiV = parcelRequire("imfiV");




var $08cc7e16d5f5f71b$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    cancelLabel: {
        id: "fabric.editor.ai.screens.discard.cancelLabel",
        defaultMessage: "Back"
    },
    discardLabel: {
        id: "fabric.editor.ai.screens.discard.discardLabel",
        defaultMessage: "Discard"
    },
    warningIconLabel: {
        id: "fabric.editor.ai.screens.discard.warningIconLabel",
        defaultMessage: "Warning"
    },
    yesLabel: {
        id: "fabric.editor.ai.screens.discard.yesLabel",
        defaultMessage: "Yes"
    },
    noLabel: {
        id: "fabric.editor.ai.screens.discard.noLabel",
        defaultMessage: "No"
    }
});


const $01efd7a6722fa820$var$buttonContainerStyles = null;
const $01efd7a6722fa820$var$contentContainerStyles = null;
const $01efd7a6722fa820$var$contentContainerStylesSmall = null;
const $01efd7a6722fa820$var$contentIconStyles = null;
const $01efd7a6722fa820$var$contentInStreamingIconStyles = null;
const $01efd7a6722fa820$var$contentInStreamingIconStylesSmall = null;
const $01efd7a6722fa820$var$discardFloatingContainerStyle = null;
const $01efd7a6722fa820$var$discardFloatingContainerStyleFitContent = null;
const $01efd7a6722fa820$var$smallDiscardFloatingContainerStyle = null;
const $01efd7a6722fa820$var$styles = {
    buttonContainer: "_zulp1b66 _1e0c1txw _1n261g80 _2lx2vrvc _1bahesu3 _4cvr1h6o _zs121b66 _d4lfzwfg _10gv1ex1 _xlob1h6o"
};
const $01efd7a6722fa820$var$DiscardButtonsContainer = ({ children: children, isAIFC: isAIFC })=>isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: $01efd7a6722fa820$var$styles.buttonContainer,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _1n261g80 _2lx2vrvc _1bahesu3 _4cvr1h6o"
        ]),
        children: children
    });
const $01efd7a6722fa820$export$453c0e2ebf820c66 = ({ onCancel: onCancel, onDiscard: onDiscard, text: text, appearance: appearance, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [containerElement, setContainerElement] = (0, $42omo.useState)(null);
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $imfiV.useElementBreakpoints)();
    const setRootContainer = (element)=>{
        setContainerElement(element);
        setBreakpointsElement(element);
    }; // Scroll the discard screen into view if it's not fully visible
    (0, $42omo.useEffect)(()=>{
        if (containerElement) containerElement.scrollIntoView({
            block: 'nearest'
        });
    }, [
        containerElement
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $40sdH.FloatingContainer), {
        ref: setRootContainer,
        "data-testid": "discard-screen",
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _2lx2vrvc _j4orxy5q",
            breakpoint <= (0, $imfiV.Breakpoint).Small && "_zulppxbi _2lx21bp4",
            isAIFC && "_10fp1h6o _1bsb1ns9",
            `discard-screen ${(0, $kuYGt.AI_MODAL_SCREEN_CLASS)}`
        ]),
        paddingAdjustments: isAIFC ? {
            right: 4,
            left: 4
        } : {
            top: 1,
            bottom: 1
        },
        rainbowBorder: false,
        appearance: appearance,
        isAIFC: isAIFC,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $08cc7e16d5f5f71b$export$2e2bcd8739ae039).warningIconLabel)
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulpu2gc _1e0c1txw _2lx2vrvc _1bah1y6m _4cvr1h6o",
                    breakpoint <= (0, $imfiV.Breakpoint).Small && !isAIFC && "_4cvr1y6m"
                ]),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        className: (0, $gMc0m.default)([
                            "_2hwxv77o _1e0c116y _4cvr1h6o _1bah1h6o _kqswh2mm _1o9zidpf",
                            isAIFC && "_19bv1b66 _u5f31b66 _n3td1b66 _ca0q1b66",
                            breakpoint <= (0, $imfiV.Breakpoint).Small && !isAIFC && "_154i1i6y"
                        ]),
                        children: isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                            label: formatMessage((0, $08cc7e16d5f5f71b$export$2e2bcd8739ae039).warningIconLabel),
                            color: "var(--ds-icon-warning, #E06C00)"
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                            label: formatMessage((0, $08cc7e16d5f5f71b$export$2e2bcd8739ae039).warningIconLabel),
                            color: "var(--ds-icon-warning, #E06C00)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        as: "p",
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)($01efd7a6722fa820$var$DiscardButtonsContainer, {
                isAIFC: isAIFC,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        testId: "cancel-button",
                        spacing: "compact",
                        onClick: onCancel,
                        type: "button",
                        appearance: "subtle",
                        children: formatMessage(isAIFC ? (0, $08cc7e16d5f5f71b$export$2e2bcd8739ae039).noLabel : (0, $08cc7e16d5f5f71b$export$2e2bcd8739ae039).cancelLabel)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        autoFocus: true,
                        testId: "discard-button",
                        spacing: "compact",
                        onClick: onDiscard,
                        type: "button",
                        appearance: "warning",
                        children: formatMessage(isAIFC ? (0, $08cc7e16d5f5f71b$export$2e2bcd8739ae039).yesLabel : (0, $08cc7e16d5f5f71b$export$2e2bcd8739ae039).discardLabel)
                    })
                ]
            })
        ]
    });
};







var $fFa3V = parcelRequire("fFa3V");







const $dce5a479357f9352$var$SCROLL_MARGIN = 32;
/**
 * Calculate the offset from the editor DOM to the scroll container.
 * Walks up the DOM tree accumulating offsetTop values until reaching the scroll container.
 */ function $dce5a479357f9352$var$calculateOffsetTopFromScrollContainer(editorDom, scrollContainer) {
    let offset = 0;
    let el = editorDom;
    while(el && el !== scrollContainer){
        if (el instanceof HTMLElement) {
            offset += el.offsetTop;
            el = el.offsetParent;
        } else break;
    }
    return offset;
}
const $dce5a479357f9352$export$d605968e18f8ea5 = ({ api: api, view: view, modalRef: modalRef })=>{
    const scrollParentRef = (0, $42omo.useRef)(null);
    const hasUserScrolledRef = (0, $42omo.useRef)(false);
    const isProgrammaticScrollRef = (0, $42omo.useRef)(false);
    // Read streaming positions from plugin state
    const { streamStartPos: streamStartPos, scrollTargetPos: scrollTargetPos, isStreaming: isStreaming } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>({
            streamStartPos: state.aiExperienceState?.streamingState?.streamStartPos,
            scrollTargetPos: state.aiExperienceState?.streamingState?.scrollTargetPos,
            isStreaming: state.aiExperienceState?.isStreaming ?? false
        }));
    // Find and cache the scroll parent
    (0, $42omo.useEffect)(()=>{
        if (!view?.dom) return;
        const scrollParent = (0, $7YjFd.findOverflowScrollParent)(view.dom);
        if (scrollParent) scrollParentRef.current = scrollParent;
        return ()=>{
            scrollParentRef.current = null;
        };
    }, [
        view?.dom
    ]);
    // Set up scroll listener to detect user scrolls
    (0, $42omo.useEffect)(()=>{
        const scrollParent = scrollParentRef.current;
        if (!scrollParent) return;
        const handleScroll = ()=>{
            if (isProgrammaticScrollRef.current) {
                isProgrammaticScrollRef.current = false;
                return;
            }
            // User manually scrolled - disable auto-scroll
            hasUserScrolledRef.current = true;
        };
        const unbind = (0, $fFa3V.bind)(scrollParent, {
            type: 'scroll',
            listener: handleScroll,
            options: {
                passive: true
            }
        });
        return unbind;
    }, [
        view?.dom
    ]);
    // Perform scroll when streaming positions change
    (0, $42omo.useEffect)(()=>{
        const scrollParent = scrollParentRef.current;
        // Reset user scroll flag when streaming starts
        if (isStreaming) hasUserScrolledRef.current = false;
        // Don't auto-scroll if user has manually scrolled
        if (hasUserScrolledRef.current || !scrollParent || !view) return;
        // Skip if no start position to scroll to
        if (streamStartPos === undefined) return;
        try {
            const startCoords = view.coordsAtPos(streamStartPos);
            const offsetTop = view.coordsAtPos(0).top;
            const modalHeight = modalRef?.current?.offsetHeight || 0;
            const offsetTopFromScrollContainer = $dce5a479357f9352$var$calculateOffsetTopFromScrollContainer(view.dom, scrollParent);
            /**
			 * Calculate scroll to show start at top of viewport.
			 * If the start position is above viewport, scroll up.
			 * If below viewport, scroll down.
			 */ const topScrollTop = offsetTopFromScrollContainer + startCoords.top - offsetTop - $dce5a479357f9352$var$SCROLL_MARGIN;
            isProgrammaticScrollRef.current = true;
            // If no target position, just scroll to show the start position
            if (scrollTargetPos === undefined) {
                if (scrollParent.scrollTop > topScrollTop) scrollParent.scroll({
                    top: topScrollTop,
                    behavior: 'instant'
                });
                return;
            }
            // Calculate scroll to show target at bottom of viewport (above modal)
            // Handle edge case where coords could be 0 when at the last position of doc
            let targetBottom = view.coordsAtPos(scrollTargetPos).bottom;
            if (targetBottom === 0 && scrollTargetPos > 0) targetBottom = view.coordsAtPos(scrollTargetPos - 1).bottom;
            const bottomScrollTop = offsetTopFromScrollContainer + targetBottom - offsetTop + modalHeight + $dce5a479357f9352$var$SCROLL_MARGIN - scrollParent.offsetHeight;
            if (scrollParent.scrollTop > topScrollTop) // Start scrolled past - scroll up to show start
            scrollParent.scroll({
                top: topScrollTop,
                behavior: 'instant'
            });
            else if (scrollParent.scrollTop < bottomScrollTop) // Target below viewport - scroll down to show it
            scrollParent.scroll({
                top: bottomScrollTop,
                behavior: 'instant'
            });
        } catch  {
        // Ignore scroll errors - positions may be invalid during transitions
        }
    }, [
        streamStartPos,
        scrollTargetPos,
        isStreaming,
        view,
        modalRef
    ]);
};




var $hHa70 = parcelRequire("hHa70");


var $4a3y9 = parcelRequire("4a3y9");


var $cDDqH = parcelRequire("cDDqH");


var $9XexZ = parcelRequire("9XexZ");

const $eae81ca554f80ec0$export$5ddafe3fa55c1ac5 = ()=>{
    const { send: send } = (0, $9XexZ.useRovoContentBridgeAPI)((0, $4a3y9.ROVO_INLINE_INPUT_BOX_CLIENT_ID));
    return {
        abort: ()=>{
            send((0, $cDDqH.InlineInputBoxAbortMessageCommand), {
                receiverId: (0, $hHa70.ROVO_CHAT_CLIENT_ID)
            });
        }
    };
};









function $3af6f886d5308b08$export$31f5c3fa05bebb33({ api: api, appearance: appearance, dispatch: dispatch }) {
    const { abort: abort } = (0, $eae81ca554f80ec0$export$5ddafe3fa55c1ac5)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, editorView: editorView } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const aiDecorationExperiencePluginState = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState);
    const onCancel = (0, $42omo.useCallback)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) api?.aiExperience.actions.getAiExperienceActor()?.send({
            type: 'disable discard'
        });
        dispatch({
            type: 'cancel'
        });
    }, [
        api,
        dispatch
    ]);
    const onDiscard = (0, $42omo.useCallback)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) {
            const context = api?.aiExperience.actions.getAiExperienceActor().getSnapshot().context;
            const traceIds = aiDecorationExperiencePluginState?.traceId ? [
                aiDecorationExperiencePluginState.traceId
            ] : context?.traceIds;
            /**
       * Introduced in EDF-1443 to track discard event confirmations
       * separately to normal discard events
       */ fireAIAnalyticsEvent({
                // Simplified context from streamingApi to avoid issues
                // To follow-up
                payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                    action: (0, $d925B.ACTION).DISMISSED,
                    interactionID: context?.channelId,
                    experienceName: (0, $6gJll.convertExperienceName)(context?.configItem.key.toString() ?? ''),
                    isProactive: false,
                    invokedFrom: 'streamingApi',
                    traceIds: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceIds : undefined
                })
            });
        }
        // Abort any ongoing Rovo requests - this will end the session
        abort();
        // Clear the AI session context to trigger handleDiscard in the streaming plugin
        // This must be done before endAIExperience so the streaming plugin can detect
        // the session was cleared while streaming was in progress
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) api?.core?.actions.execute((0, $7d27e28955fa0757$export$ea01a78091d2ff77)());
        api?.aiExperience.actions.endAIExperience();
        dispatch({
            type: 'terminate'
        });
    }, [
        api,
        dispatch,
        abort,
        fireAIAnalyticsEvent,
        aiDecorationExperiencePluginState?.traceId
    ]);
    const discardScreenRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    (0, $dce5a479357f9352$export$d605968e18f8ea5)({
        api: api,
        view: editorView,
        modalRef: discardScreenRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e340c4e479241554$export$42a852a2b6b56249), {
        ref: discardScreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $01efd7a6722fa820$export$453c0e2ebf820c66), {
        onCancel: onCancel,
        onDiscard: onDiscard,
        text: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).discardStreamingInDocumennt),
        appearance: appearance,
        isAIFC: isInDocumentStreamingEnabled
    }));
}









var $cSGOW = parcelRequire("cSGOW");





var $gtD4K = parcelRequire("gtD4K");




var $ls2Fy = parcelRequire("ls2Fy");






const $a4a9843496093656$var$knownErrorMessages = {
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).UNKNOWN]: (0, $ls2Fy.aiFailedStateMessages).documentInsertError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).TOKEN_LIMIT]: (0, $ls2Fy.aiFailedStateMessages).tokenLimitExceeded,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INSERT_FAILURE]: (0, $ls2Fy.aiFailedStateMessages).documentInsertError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INPUT_TOO_SHORT]: (0, $ls2Fy.aiFailedStateMessages).inputTooShortError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).HIPAA_CONTENT]: (0, $ls2Fy.aiFailedStateMessages).hipaaContentError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED]: (0, $ls2Fy.aiFailedStateMessages).rateLimitEnforced,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION]: (0, $ls2Fy.aiFailedStateMessages).aupViolationMessage,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).ELEVATE_DISABLED_GENERATE]: (0, $ls2Fy.aiFailedStateMessages).elevateDisabledGenerateError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INTERNAL_SERVER_ERROR]: (0, $ls2Fy.aiFailedStateMessages).internalServerError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL]: (0, $ls2Fy.aiFailedStateMessages).apiError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).ADF_STREAMING_ERROR]: (0, $ls2Fy.aiFailedStateMessages).adfStreamingError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).NO_TEXTUAL_CONTENT]: (0, $ls2Fy.aiFailedStateMessages).noTextualContentError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INVALID_JSON]: (0, $ls2Fy.aiFailedStateMessages).apiError
};
const $a4a9843496093656$var$aifcKnownErrorMessages = {
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).UNKNOWN]: (0, $ls2Fy.aiFailedStateMessages).documentInsertError,
    // no longer used in aifc
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).TOKEN_LIMIT]: (0, $ls2Fy.aiFailedStateMessages).aifcTokenLimitExceeded,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INSERT_FAILURE]: (0, $ls2Fy.aiFailedStateMessages).documentInsertError,
    // no longer used in aifc
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INPUT_TOO_SHORT]: (0, $ls2Fy.aiFailedStateMessages).aifcInputTooShortError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).HIPAA_CONTENT]: (0, $ls2Fy.aiFailedStateMessages).aifcHipaaContentError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED]: (0, $ls2Fy.aiFailedStateMessages).aifcRateLimitEnforced,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION]: (0, $ls2Fy.aiFailedStateMessages).aifcAupViolationMessage,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).ELEVATE_DISABLED_GENERATE]: (0, $ls2Fy.aiFailedStateMessages).elevateDisabledGenerateError,
    // not relevant to aifc
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INTERNAL_SERVER_ERROR]: (0, $ls2Fy.aiFailedStateMessages).aifcInternalServerError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL]: (0, $ls2Fy.aiFailedStateMessages).aifcApiErrorRetry,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).ADF_STREAMING_ERROR]: (0, $ls2Fy.aiFailedStateMessages).aifcAdfStreamingError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).NO_TEXTUAL_CONTENT]: (0, $ls2Fy.aiFailedStateMessages).noTextualContentError,
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INVALID_JSON]: (0, $ls2Fy.aiFailedStateMessages).aifcApiErrorRetry
};
const $a4a9843496093656$export$5efe5b9065b71976 = {
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INTERNAL_SERVER_ERROR]: 'https://status.atlassian.com/',
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION]: 'https://www.atlassian.com/legal/acceptable-use-policy',
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED]: 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/'
};
const $a4a9843496093656$export$71ce55872f13f1f1 = {
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INTERNAL_SERVER_ERROR]: 'https://rovo.status.atlassian.com/',
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION]: 'https://www.atlassian.com/legal/acceptable-use-policy',
    // no change
    [(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED]: 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/' // no change
};
const $a4a9843496093656$var$getErrorMessage = (error, isInDocumentStreamingEnabled)=>{
    if (isInDocumentStreamingEnabled) return $a4a9843496093656$var$aifcKnownErrorMessages[error];
    return $a4a9843496093656$var$knownErrorMessages[error];
};
// Use of links in messages is based on guidance at https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
const $a4a9843496093656$var$LinkedMessage = ({ error: error, documentationUrl: documentationUrl })=>{
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const errorMessage = $a4a9843496093656$var$getErrorMessage(error, isInDocumentStreamingEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...errorMessage,
        values: {
            link: (message)=>// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                    href: documentationUrl,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, message)
        }
    });
};
// 500 status codes should not be retryable
const $a4a9843496093656$var$is5xxErrorRange = (statusCode)=>statusCode >= 500 && statusCode < 600;
const $a4a9843496093656$export$27eceeaa1726619e = ({ failureReason: failureReason, statusCode: statusCode = 500 })=>failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).ADF_STREAMING_ERROR || failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INVALID_JSON || failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL && !$a4a9843496093656$var$is5xxErrorRange(statusCode);
const $a4a9843496093656$export$accc136c77ec5dfa = ({ apiName: apiName, failureReason: failureReason })=>{
    return apiName === 'assistance-service' || failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION || failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).API_FAIL ? 'apiError' : 'failed';
};
const $a4a9843496093656$export$915e9e7bd4f0f96d = ({ errorKey: errorKey, failureReason: failureReason, statusCode: statusCode })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const isConvoAIServerError = [
        'FEATURE_DISABLED',
        'FEATURE_DISABLED_ON_SITE',
        'NO_AGENT'
    ].includes(errorKey || '');
    // 9001 is a special case for elevate where we disable generate until Q3
    if (statusCode === 9001) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($a4a9843496093656$var$knownErrorMessages['elevate disabled generate']));
    if (statusCode && $a4a9843496093656$var$is5xxErrorRange(statusCode) || isConvoAIServerError || failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INTERNAL_SERVER_ERROR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4a9843496093656$var$LinkedMessage, {
        error: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INTERNAL_SERVER_ERROR,
        documentationUrl: (isInDocumentStreamingEnabled ? $a4a9843496093656$export$71ce55872f13f1f1 : $a4a9843496093656$export$5efe5b9065b71976)[(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).INTERNAL_SERVER_ERROR]
    });
    if (!failureReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($a4a9843496093656$var$knownErrorMessages['unknown fail']));
    if (failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4a9843496093656$var$LinkedMessage, {
        error: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION,
        documentationUrl: (isInDocumentStreamingEnabled ? $a4a9843496093656$export$71ce55872f13f1f1 : $a4a9843496093656$export$5efe5b9065b71976)[(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION]
    });
    if (failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4a9843496093656$var$LinkedMessage, {
        error: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED,
        documentationUrl: (isInDocumentStreamingEnabled ? $a4a9843496093656$export$71ce55872f13f1f1 : $a4a9843496093656$export$5efe5b9065b71976)[(0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).RATE_LIMITED]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($a4a9843496093656$var$getErrorMessage(failureReason, isInDocumentStreamingEnabled)));
};



function $d30f9447f9199f71$export$d5b86f1573c0ea10({ api: api, appearance: appearance, dispatch: dispatch }) {
    const errorScreenRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const { errorInfo: errorInfo, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, nextSessionId: nextSessionId } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>{
        return {
            errorInfo: aiExperienceState?.aiSessionPluginState?.errorInfo || {},
            isInDocumentStreamingEnabled: aiExperienceState?.aiDecorationExperiencePluginState.isInDocumentStreamingEnabled,
            nextSessionId: aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId
        };
    });
    const onCancel = (0, $42omo.useCallback)(()=>{
        api?.aiExperience.actions.endSession(nextSessionId || '');
        api?.aiExperience.actions.endAIExperience();
        dispatch({
            type: 'terminate'
        });
    }, [
        api,
        dispatch,
        nextSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e340c4e479241554$export$42a852a2b6b56249), {
        ref: errorScreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSGOW.ErrorScreen), {
        text: (0, $a4a9843496093656$export$915e9e7bd4f0f96d)(errorInfo),
        onCancel: onCancel,
        onRetry: ()=>{},
        showRetryButton: false,
        appearance: appearance,
        isAIFC: isInDocumentStreamingEnabled
    }));
}
















var $5gEqE = parcelRequire("5gEqE");


var $7JKll = parcelRequire("7JKll");














const $4961f0dd6244924e$export$27da6e66e88e9ac7 = ({ ref: ref, onDiscard: onDiscard })=>{
    const handleEscapeKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        onDiscard?.();
    }, [
        onDiscard
    ]);
    const handleEscapeKeyUp = (0, $42omo.useCallback)((event)=>{
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
    }, []);
    const handleClickOutside = (0, $42omo.useCallback)((event)=>{
        if (ref.current?.contains(event.target)) return;
        onDiscard?.();
    }, [
        ref,
        onDiscard
    ]);
    (0, $42omo.useEffect)(()=>{
        const contentArea = document.querySelector('.ak-editor-content-area');
        if (!contentArea) return;
        // Ensure we focus the content area to capture keyboard events
        contentArea.focus({
            preventScroll: true
        });
        return (0, $fFa3V.bindAll)(contentArea, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            },
            {
                type: 'click',
                listener: handleClickOutside
            }
        ]);
    }, [
        ref,
        handleEscapeKeyDown,
        handleEscapeKeyUp,
        handleClickOutside
    ]);
};


function $9392ff680475ade8$export$6ad5d8e31817f39c({ api: api, providerFactory: providerFactory, appearance: appearance, dispatch: dispatch }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { mounted: isRovoMounted, streaming: isRovoStreaming } = (0, $5gEqE.useUIStore)();
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, endExperience: endExperience, canInlineStreamChanges: canInlineStreamChanges, editorView: editorView } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const hideLoadingScreen = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>state.aiExperienceState?.aiDecorationExperiencePluginState.hideLoadingScreen);
    const loadingScreenRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const schema = (0, $42omo.useMemo)(()=>api?.core.sharedState.currentState()?.schema, [
        api
    ]);
    const onDiscard = (0, $42omo.useCallback)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) api?.aiExperience.actions.getAiExperienceActor()?.send({
            type: 'enable discard'
        });
        else api?.core?.actions.execute((0, $7d27e28955fa0757$export$ea01a78091d2ff77)());
        dispatch({
            type: 'discard'
        });
    }, [
        api,
        dispatch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) return;
        // turn off diff when loading screen is shown on first render
        if (api?.trackChanges?.sharedState.currentState()?.isDisplayingChanges) api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        // clear selection decorations on first render
        (0, $5SuLc.clearSelectionDecorations)(editorView.state)(editorView.state, editorView.dispatch);
        return ()=>{
            if (!(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) return;
            if (!canInlineStreamChanges()) dispatch({
                type: 'show-accept-reject'
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        api,
        canInlineStreamChanges,
        dispatch,
        endExperience
    ]);
    (0, $4961f0dd6244924e$export$27da6e66e88e9ac7)({
        onDiscard: onDiscard,
        ref: loadingScreenRef
    });
    (0, $dce5a479357f9352$export$d605968e18f8ea5)({
        api: api,
        view: editorView,
        modalRef: loadingScreenRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e340c4e479241554$export$42a852a2b6b56249), {
        ref: loadingScreenRef
    }, schema && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7JKll.MemoLoadingScreen), {
        onCancel: onDiscard,
        preview: undefined,
        title: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).loadingTitle),
        providerFactory: providerFactory,
        schema: schema,
        isStreaming: true,
        canInlineStreamChanges: true,
        hideLoadingScreen: isRovoMounted && isRovoStreaming || hideLoadingScreen,
        appearance: appearance,
        isAIFC: isInDocumentStreamingEnabled
    }));
}


/* Prompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















var $c6GJD = parcelRequire("c6GJD");


var $dpPtd = parcelRequire("dpPtd");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $fBMbo = parcelRequire("fBMbo");


var $1Whri = parcelRequire("1Whri");

















var $i25hX = parcelRequire("i25hX");














var $bnT2y = parcelRequire("bnT2y");


var $lfmg5 = parcelRequire("lfmg5");


var $aUQK5 = parcelRequire("aUQK5");


var $22Wz8 = parcelRequire("22Wz8");




const $46ea5adc37ee5a6a$var$initialState = {
    mode: 'editing',
    latestTrace: null,
    isCancelling: false,
    error: null,
    agent: null
};
const $46ea5adc37ee5a6a$var$reducer = (state, action)=>{
    switch(action.type){
        case 'submit':
            return {
                ...state,
                mode: 'thinking',
                latestTrace: null,
                error: null
            };
        case 'trace':
            return {
                ...state,
                latestTrace: action.latestTrace
            };
        case 'cancel':
            return {
                ...state,
                isCancelling: true
            };
        case 'keep':
            return {
                ...state,
                isCancelling: false
            };
        case 'abort':
            return {
                ...state,
                mode: 'editing',
                isCancelling: false,
                latestTrace: null,
                error: null
            };
        case 'complete':
            return {
                ...state,
                mode: 'editing',
                latestTrace: null,
                error: null
            };
        case 'error':
            return {
                ...state,
                mode: 'error',
                latestTrace: null,
                error: action.error
            };
        case 'success':
            return {
                ...state,
                mode: 'success',
                latestTrace: null,
                error: null
            };
        case 'set-agent':
            return {
                ...state,
                agent: action.agent
            };
    }
};
const $46ea5adc37ee5a6a$export$e924b3ae6248b17a = ({ source: source, productKey: productKey, onAbort: onAbort, onSubmit: onSubmit, onComplete: onComplete, onCancel: onCancel, autoClose: autoClose, objectId: objectId, onBeforeComplete: onBeforeComplete })=>{
    (0, $fBMbo.di)((0, $i25hX.usePublish), (0, $9XexZ.useRovoContentBridgeAPI));
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const [{ mode: mode, isCancelling: isCancelling, latestTrace: latestTrace, error: error, agent: agent }, dispatch] = (0, $42omo.useReducer)($46ea5adc37ee5a6a$var$reducer, $46ea5adc37ee5a6a$var$initialState);
    const { mounted: isChatMounted } = (0, $5gEqE.useUIStore)();
    const { ready: ready, send: send } = (0, $9XexZ.useRovoContentBridgeAPI)((0, $4a3y9.ROVO_INLINE_INPUT_BOX_CLIENT_ID), (on)=>{
        on((0, $22Wz8.InlineInputBoxTraceMessageCommand), (latestTrace)=>{
            dispatch({
                type: 'trace',
                latestTrace: latestTrace
            });
        });
        on((0, $lfmg5.InlineInputBoxFinalResponseMessageCommand), ()=>{
            const complete = ()=>{
                dispatch({
                    type: 'complete'
                });
                onComplete();
            };
            if (onBeforeComplete) onBeforeComplete(complete);
            else complete();
        });
        on((0, $bnT2y.InlineInputBoxErrorMessageCommand), ({ error: error })=>{
            dispatch({
                type: 'error',
                error: error.message
            });
        });
    });
    const lastSubmittedInput = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ready();
    }, [
        ready
    ]);
    const abort = (0, $42omo.useCallback)((endStream = false)=>{
        if (endStream && mode === 'thinking') send((0, $cDDqH.InlineInputBoxAbortMessageCommand), {
            receiverId: (0, $hHa70.ROVO_CHAT_CLIENT_ID)
        });
        dispatch({
            type: 'abort'
        });
        onAbort({
            streamEnded: endStream
        });
    }, [
        mode,
        send,
        onAbort
    ]);
    // Exit the inline prompt if the chat opens
    (0, $42omo.useEffect)(()=>{
        if (isChatMounted && mode !== 'editing' && (0, $dh538.fg)('platform_inline_rovo_auto_close')) abort();
    }, [
        isChatMounted,
        mode,
        abort
    ]);
    const submit = (params)=>{
        if (agent?.id) {
            // Always start a new conversation and open the chat when submitting with an agent
            publish({
                type: 'chat-new',
                source: 'ai-mate',
                data: {
                    dialogues: [],
                    prompt: params.prompt,
                    agentId: agent.id
                }
            });
            // Immediately exit the inline prompt as the sidebar chat should take over
            abort();
            return;
        }
        const input = {
            ...params,
            prompt: params.prompt,
            productKey: productKey,
            source: source,
            receiverId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
            contentId: objectId,
            agentId: agent?.id
        };
        lastSubmittedInput.current = input;
        send((0, $aUQK5.InlineInputBoxSendMessageCommand), input);
        if (isChatMounted && (0, $dh538.fg)('platform_inline_rovo_auto_close')) // If the side nav is already open, let the chat take over and close the inline prompt
        abort();
        else {
            // Keep the inline prompt open if the side nav isn't open yet
            dispatch({
                type: 'submit'
            });
            onSubmit?.(()=>{
                // Pass skipWarning since this callback is used by global escape handlers during thinking state
                cancelRef.current((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? {
                    skipWarning: true
                } : undefined);
            });
        }
    };
    const resubmit = ()=>{
        if (lastSubmittedInput.current) {
            send((0, $aUQK5.InlineInputBoxSendMessageCommand), lastSubmittedInput.current);
            dispatch({
                type: 'submit'
            });
        }
    };
    const keep = (0, $42omo.useCallback)(()=>{
        dispatch({
            type: 'keep'
        });
    }, []);
    const cancel = (0, $42omo.useCallback)((options)=>{
        if (!onCancel || mode === 'editing') abort(true);
        else if (isCancelling && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) keep();
        else if (options?.skipWarning && mode === 'thinking' && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) // When skipWarning is true and in thinking mode, abort immediately without showing warning
        abort(true);
        else {
            dispatch({
                type: 'cancel'
            });
            onCancel();
        }
    }, [
        onCancel,
        mode,
        isCancelling,
        abort,
        keep
    ]);
    const cancelRef = (0, $42omo.useRef)(cancel);
    (0, $42omo.useEffect)(()=>{
        cancelRef.current = cancel;
    }, [
        cancel
    ]);
    const setAgent = (agent)=>{
        dispatch({
            type: 'set-agent',
            agent: agent
        });
    };
    return {
        mode: mode,
        isCancelling: isCancelling,
        latestTrace: latestTrace,
        error: error,
        submit: submit,
        resubmit: resubmit,
        cancel: cancel,
        keep: keep,
        abort: abort,
        autoClose: autoClose ?? true,
        agent: agent,
        setAgent: setAgent
    };
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











var $hmuev = parcelRequire("hmuev");





var $kPjga = parcelRequire("kPjga");




var $98018e11d3abac78$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    removeAgentLabel: {
        id: "ai-mate.inline-chat-input.remove-agent",
        defaultMessage: "Remove agent"
    }
});


const $80d7e5b2eb9a35f8$var$styles = {
    agentHeader: "_11c81qyo _18zrpxbi _1rjcu2gc _1bsb1osq _kqswstnw _154iidpf _1ltvidpf _4t3ickbl _bfhkysee _13li1tm3 _qrwq1tm3",
    compact: "_18zrutpp"
};
const $80d7e5b2eb9a35f8$export$24238a3d65fa333 = ({ agent: agent, removeAgent: removeAgent, compact: compact })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($80d7e5b2eb9a35f8$var$styles.agentHeader, compact && $80d7e5b2eb9a35f8$var$styles.compact),
        spread: "space-between",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kPjga.PromptAgentAvatar), {
                        agent: agent
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        children: agent.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                label: formatMessage((0, $98018e11d3abac78$export$2e2bcd8739ae039).removeAgentLabel),
                appearance: "subtle",
                onClick: removeAgent
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $a3fRD = parcelRequire("a3fRD");


var $auNCB = parcelRequire("auNCB");






var $5bd44c99dd57f62b$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    closeButtonLabel: {
        id: "ai-mate.inline-chat-input.error-view.close-button.label",
        defaultMessage: "Close"
    },
    retryButtonLabel: {
        id: "ai-mate.inline-chat-input.error-view.retry-button.label",
        defaultMessage: "Try again"
    },
    rateLimited: {
        id: "ai-mate.inline-chat-input.error-view.message.rate-limited",
        defaultMessage: "You\u2019ve reached the maximum number of requests. Try again later. <a>Excessive use of AI</a>."
    },
    aupViolation: {
        id: "ai-mate.inline-chat-input.error-view.message.aup-violation",
        defaultMessage: "Content does not comply with our <a>Acceptable Use Policy</a>."
    },
    tokenLimitExceeded: {
        id: "ai-mate.inline-chat-input.error-view.message.token-limit-exceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    unknownError: {
        id: "ai-mate.inline-chat-input.error-view.message.unknown-error",
        defaultMessage: "An unknown error occurred."
    }
});


const $e0a2b0c08103f485$var$styles = {
    message: "_syazi7uo"
};
const $e0a2b0c08103f485$export$8c68b6013ae44ca6 = ({ error: error, onClose: onClose, onTryAgain: onTryAgain })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const renderErrorMessage = ()=>{
        switch(error?.message_template){
            case 'RATE_LIMIT':
                return formatMessage((0, $5bd44c99dd57f62b$export$2e2bcd8739ae039).rateLimited, {
                    a: (chunks)=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                            href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                            target: "_blank",
                            children: chunks
                        });
                    }
                });
            case 'ACCEPTABLE_USE_VIOLATIONS':
                return formatMessage((0, $5bd44c99dd57f62b$export$2e2bcd8739ae039).aupViolation, {
                    a: (chunks)=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                            href: "https://www.atlassian.com/legal/acceptable-use-policy",
                            target: "_blank",
                            children: chunks
                        });
                    }
                });
            case 'TOKEN_LIMIT_EXCEEDED':
                return formatMessage((0, $5bd44c99dd57f62b$export$2e2bcd8739ae039).tokenLimitExceeded);
        }
        return formatMessage((0, $5bd44c99dd57f62b$export$2e2bcd8739ae039).unknownError);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center",
                xcss: $e0a2b0c08103f485$var$styles.message,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        spacing: "spacious",
                        size: "medium",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        children: renderErrorMessage()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "subtle",
                        onClick: onClose,
                        children: formatMessage((0, $5bd44c99dd57f62b$export$2e2bcd8739ae039).closeButtonLabel)
                    }),
                    $e0a2b0c08103f485$var$canRetry(error) && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "default",
                        onClick: onTryAgain,
                        children: formatMessage((0, $5bd44c99dd57f62b$export$2e2bcd8739ae039).retryButtonLabel)
                    })
                ]
            })
        ]
    });
};
const $e0a2b0c08103f485$var$canRetry = (error)=>{
    return error?.message_template !== 'RATE_LIMIT' && error?.message_template !== 'ACCEPTABLE_USE_VIOLATIONS';
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $lAJUP = parcelRequire("lAJUP");

















var $5AtW0 = parcelRequire("5AtW0");


var $e6Iiv = parcelRequire("e6Iiv");


var $auTg8 = parcelRequire("auTg8");





var $euUgw = parcelRequire("euUgw");









var $eyWa4 = parcelRequire("eyWa4");


var $i4C2H = parcelRequire("i4C2H");


var $gALmy = parcelRequire("gALmy");

var $bEPY6 = parcelRequire("bEPY6");

var $6VMxF = parcelRequire("6VMxF");


var $euw6P = parcelRequire("euw6P");


var $5fzJo = parcelRequire("5fzJo");


var $16lEl = parcelRequire("16lEl");


var $1yaYZ = parcelRequire("1yaYZ");


var $805F8 = parcelRequire("805F8");


var $2e6ow = parcelRequire("2e6ow");


var $gjr93 = parcelRequire("gjr93");


var $gWF6I = parcelRequire("gWF6I");


var $aY6zh = parcelRequire("aY6zh");


var $6Y7nw = parcelRequire("6Y7nw");


var $fbZF8 = parcelRequire("fbZF8");


var $eRTWv = parcelRequire("eRTWv");


var $ZsUvD = parcelRequire("ZsUvD");


var $hnap0 = parcelRequire("hnap0");


var $4zqRX = parcelRequire("4zqRX");


var $V9Rzh = parcelRequire("V9Rzh");

/* labs-lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 



















var $cOrQJ = parcelRequire("cOrQJ");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");




parcelRequire("42omo");

const $03145eb8c9f8bcdb$export$36be37b392de5213 = ({ darkMode: darkMode = false })=>{
    return darkMode ? /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "confluence-labs-icon-dark",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1466_13761)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1466_13761",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "confluence-labs-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1352_45568)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "#1E1F21"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1352_45568",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    });
};


const $9d8f4e2acb755628$var$i18n = (0, $cgtv4.defineMessages)({
    tooltip: {
        id: "ai-common.confluence-labs-lozenge.tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $9d8f4e2acb755628$var$lozengeStyles = {
    lozenge: "_2rko12b0 _18zr1b66 _1e0c1txw _4cvr1h6o _1bah1h6o",
    tooltip: "_2rko12b0 _11c8wadc _vchhusvi _p12f7l9q _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
};
const $9d8f4e2acb755628$var$gradientWaveKeyframes = null;
const $9d8f4e2acb755628$var$lozengeAnimatedBorder = null;
const $9d8f4e2acb755628$var$textContainerStyles = null; // Using a custom tooltip is a workaround to avoid odd spacing due to default styles,
// primarily for the English locale
const $9d8f4e2acb755628$var$CustomTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            $9d8f4e2acb755628$var$lozengeStyles.tooltip
        ]),
        children: children
    });
});
const $9d8f4e2acb755628$export$8c4514d5420b4a89 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)(); // We don't want to i18n the term 'Confluence Labs' because it is the branding name
    // and should be the same across all languages
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        component: $9d8f4e2acb755628$var$CustomTooltip,
        content: formatMessage($9d8f4e2acb755628$var$i18n.tooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "labs-lozenge",
            className: (0, $gMc0m.default)([
                $9d8f4e2acb755628$var$lozengeStyles.lozenge,
                "_2rko12b0 _18zr1b66 _kqswh2mm _bfhksm61 _1e0c1txw _4cvr1h6o _1bah1h6o _1pbyidpf _1tesidpf _rfx312b0 _1414t94y _p7f0t94y _7gpxt94y _syayt94y _1s6kyrfl _16qq1ajn _1kt9b3bt _1cs8stnw _1ankm4tz _12a1epuu _x5brkvto _13sb1p67 _dsq4glyw _1g0v1mrw"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                grow: "hug",
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $03145eb8c9f8bcdb$export$36be37b392de5213), {
                        darkMode: colorMode === 'dark'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_vwz4f6fq _1p1dangw"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            weight: "semibold",
                            color: "color.text",
                            children: "Labs"
                        })
                    })
                ]
            })
        })
    });
};





var $b340a9e5e1414569$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    sendButtonLabel: {
        id: "ai-mate.inline-chat-input.send-button.label",
        defaultMessage: "Submit"
    },
    chatInputAssistiveLabel: {
        id: "ai-mate.inline-chat-input.chat-input-assistive-label",
        defaultMessage: "Describe what you want to do..."
    }
});


const $91234e0d34981cdc$var$STORE_KEY = 'inline_prompt_view';
const $91234e0d34981cdc$var$styles = {
    stack: "_1bsb1osq _otyrxmi2",
    stackWithoutContexts: "_1e0c1bgi",
    editorWrapper: "_p12f1osq _1e0c1txw _4cvr1h6o _ca0q1b66 _otyrr5cr _16jlhac1",
    actions: "_zulpu2gc _1bahh9n0 _16jlkb7n",
    labsLozenge: "_1wpz1h6o"
};
const $91234e0d34981cdc$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $91234e0d34981cdc$var$PromptViewInternal = ({ productKey: productKey, siteId: siteId, orgId: orgId, source: source, onSubmit: onSubmit, actions: actions, onAgentSelect: onAgentSelect, isBrowseAgentsModalOpen: isBrowseAgentsModalOpen, setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen, enableAgents: enableAgents = false, showLabsLozenge: showLabsLozenge = false, agent: agent, popupsMountPoint: popupsMountPoint })=>{
    (0, $fBMbo.di)((0, $e6Iiv.ComposableEditor), (0, $aY6zh.default), (0, $2e6ow.useEditorPlaceholder), (0, $euw6P.useEditorPreset), (0, $V9Rzh.useChatModeStoreActions), (0, $gWF6I.AtlassianRelayEnvironmentProvider));
    const saveRef = (0, $42omo.useRef)();
    const [inputValue, setInputValue] = (0, $42omo.useState)('');
    const [hasMentionOrInlineCard, setHasMentionOrInlineCard] = (0, $42omo.useState)(false);
    const submitButtonRef = (0, $42omo.useRef)(null);
    const { value: mentionResourceOverride } = (0, $5fzJo.useRovoMentionProvider)();
    const { placeholder: placeholder, clearPlaceholder: clearPlaceholder } = (0, $2e6ow.useEditorPlaceholder)();
    const { highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder, clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder } = (0, $gjr93.useHighlightActionsEditorPlaceholder)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const assistanceServiceParams = {
        siteId: siteId,
        experienceId: 'ai-mate',
        product: productKey,
        touchpointSource: source
    };
    const { files: files, clearAttachments: clearAttachments, anyFilesUploading: anyFilesUploading } = (0, $6Y7nw.useConversationFiles)({
        assistanceServiceParams: assistanceServiceParams,
        key: $91234e0d34981cdc$var$STORE_KEY
    });
    const { handleTranscriptUpdate: handleTranscriptUpdate, rejectTranscriptedText: rejectTranscriptedText, disposeTranscriptedText: disposeTranscriptedText } = (0, $gALmy.useTranscriptionToEditorText)();
    const { getChatMode: getChatMode, resetReasoningMode: resetReasoningMode, setWebSearchEnabled: setWebSearchEnabled } = (0, $V9Rzh.useChatModeStoreActions)();
    const mentionResource = (0, $42omo.useMemo)(()=>Promise.resolve(mentionResourceOverride || new (0, $aY6zh.default)({
            productKey: productKey,
            siteId: siteId,
            includeTeams: true,
            includeUsers: true,
            orgId: orgId,
            searchQueryFilter: $91234e0d34981cdc$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER // TODO: searchQueryFilter: fg('rovo_chat_filter_bot_users_mention_resource')
        })), [
        productKey,
        siteId,
        orgId,
        mentionResourceOverride
    ]);
    const inputExceedsMaxLimit = inputValue.length > (0, $euw6P.MAX_CHARACTERS_INPUT);
    const isEmpty = inputValue.trim().length === 0;
    const isSendDisabled = inputExceedsMaxLimit || anyFilesUploading || isEmpty && !hasMentionOrInlineCard;
    const handleSubmit = (0, $42omo.useCallback)(async ()=>{
        const value = await actions.getValue();
        if (isSendDisabled) return;
        const { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, webSearchEnabled: webSearchEnabled, appFilters: appFilters } = getChatMode($91234e0d34981cdc$var$STORE_KEY);
        const validFiles = files.filter((file)=>!file.error);
        onSubmit({
            prompt: value,
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            webSearchEnabled: webSearchEnabled,
            appFilters: appFilters,
            files: validFiles,
            addCurrentPageAsContextUserPreference: true
        }); // Clean up
        actions.clear();
        clearAttachments($91234e0d34981cdc$var$STORE_KEY);
        resetReasoningMode($91234e0d34981cdc$var$STORE_KEY);
        setWebSearchEnabled($91234e0d34981cdc$var$STORE_KEY, false);
    }, [
        actions,
        clearAttachments,
        files,
        getChatMode,
        isSendDisabled,
        onSubmit,
        resetReasoningMode,
        setWebSearchEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // Reset attachments on unmount
            clearAttachments($91234e0d34981cdc$var$STORE_KEY);
        };
    }, [
        clearAttachments
    ]);
    saveRef.current = handleSubmit;
    const { editorApi: editorApi, preset: preset } = (0, $euw6P.useEditorPreset)({
        onSave: ()=>saveRef.current?.(),
        arrowKeyPluginConfig: {
            userMessages: []
        },
        productKey: productKey,
        siteId: siteId
    });
    const onVoiceDictationUpdate = (0, $42omo.useCallback)((result)=>{
        switch(result.state){
            case (0, $6VMxF.VoiceDictationState).Recording:
                if (!editorApi?.core?.actions?.execute) return;
                editorApi.core.actions.execute(({ tr: tr })=>handleTranscriptUpdate(result.transcription, tr));
                break;
            case (0, $6VMxF.VoiceDictationState).Stopped:
                if (result.stopReason === (0, $6VMxF.VoiceDictationStopReason).TimeoutAccepted) disposeTranscriptedText();
                break;
            default:
                break;
        }
    }, [
        handleTranscriptUpdate,
        editorApi,
        disposeTranscriptedText
    ]);
    const [voiceDictationResult, { startRecording: startRecording, stopRecording: stopRecording }] = (0, $bEPY6.useVoiceDictation)(onVoiceDictationUpdate, siteId);
    const onStartRecording = (0, $42omo.useCallback)(()=>{
        // TODO: Set recording placeholder
        startRecording();
    }, [
        startRecording
    ]);
    const onAcceptRecording = (0, $42omo.useCallback)(()=>{
        disposeTranscriptedText();
        stopRecording((0, $6VMxF.VoiceDictationStopReason).StoppedAccepted);
    }, [
        stopRecording,
        disposeTranscriptedText
    ]);
    const onRejectRecording = (0, $42omo.useCallback)(()=>{
        stopRecording((0, $6VMxF.VoiceDictationStopReason).StoppedRejected);
        editorApi?.core.actions.execute(({ tr: tr })=>rejectTranscriptedText(tr));
    }, [
        stopRecording,
        editorApi?.core.actions,
        rejectTranscriptedText
    ]);
    const closeTypeAhead = (0, $42omo.useCallback)(()=>{
        editorApi?.typeAhead?.actions.close({
            insertCurrentQueryAsRawText: false
        });
    }, [
        editorApi?.typeAhead?.actions
    ]);
    const openMentionTypeAhead = (0, $42omo.useCallback)(()=>{
        closeTypeAhead(); // Small delay to ensure the editor regains focus after closing the dropdown menu
        // This prevents the typeahead from immediately closing in Safari
        // Original root cause research: https://product-fabric.atlassian.net/browse/AFC-550
        requestAnimationFrame(()=>{
            editorApi?.core.actions.focus();
            editorApi?.mention?.actions.openTypeAhead((0, $d925B.INPUT_METHOD).QUICK_INSERT);
        });
    }, [
        closeTypeAhead,
        editorApi?.core.actions,
        editorApi?.mention?.actions
    ]);
    const openLinkTypeAhead = (0, $42omo.useCallback)(()=>{
        closeTypeAhead();
        const command = editorApi?.hyperlink?.commands.showLinkToolbar((0, $d925B.INPUT_METHOD).QUICK_INSERT);
        editorApi?.core.actions.execute(command);
    }, [
        closeTypeAhead,
        editorApi?.core.actions,
        editorApi?.hyperlink?.commands
    ]);
    const openAddTypeAhead = (0, $42omo.useCallback)(()=>{
        closeTypeAhead(); // Small delay to ensure the editor regains focus after closing the dropdown menu
        // This prevents the typeahead from immediately closing in Safari
        // Original root cause research: https://product-fabric.atlassian.net/browse/AFC-550
        requestAnimationFrame(()=>{
            editorApi?.core.actions.focus();
            editorApi?.quickInsert?.actions.openTypeAhead((0, $d925B.INPUT_METHOD).QUICK_INSERT);
        });
    }, [
        closeTypeAhead,
        editorApi?.core.actions,
        editorApi?.quickInsert?.actions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!!placeholder && !!editorApi) {
            actions.clear();
            actions.focus();
            closeTypeAhead();
            actions.appendText(placeholder.prompt);
            editorApi?.core.actions.execute(({ tr: tr })=>{
                const transaction = tr.setSelection((0, $ks2lK.TextSelection).between(tr.doc.resolve(placeholder.selectionStartIndex), tr.doc.resolve(placeholder.selectionEndIndex)));
                return transaction;
            });
            switch(placeholder.type){
                case 'person':
                    openMentionTypeAhead();
                    break;
                case 'link':
                    openLinkTypeAhead();
                    break;
            }
            clearPlaceholder();
        }
    }, [
        editorApi,
        actions,
        clearPlaceholder,
        closeTypeAhead,
        editorApi?.core.actions,
        openLinkTypeAhead,
        openMentionTypeAhead,
        placeholder
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!!highlightActionsEditorPlaceholder && !!editorApi) {
            actions.clear();
            actions.focus();
            closeTypeAhead();
            editorApi.core.actions.replaceDocument(highlightActionsEditorPlaceholder);
            editorApi?.core.actions.execute(({ tr: tr })=>{
                const lastNode = tr.doc.lastChild;
                if (lastNode) {
                    const lastNodePos = tr.doc.resolve(tr.doc.content.size - lastNode.nodeSize);
                    const endPos = tr.doc.resolve(tr.doc.content.size);
                    const transaction = tr.setSelection((0, $ks2lK.TextSelection).between(lastNodePos, endPos));
                    return transaction;
                }
                return null;
            }); // This is a workaround to avoid the focus being lost in Jira
            if (productKey === 'jira') requestAnimationFrame(()=>{
                setTimeout(()=>{
                    actions.focus();
                }, 1500);
            });
            clearHighlightActionsEditorPlaceholder();
        }
    }, [
        editorApi,
        actions,
        clearHighlightActionsEditorPlaceholder,
        closeTypeAhead,
        highlightActionsEditorPlaceholder,
        productKey
    ]);
    const isConversationAgentic = enableAgents && !!agent && (0, $dh538.fg)('platform_inline_rovo_agents');
    const editorProps = (0, $42omo.useMemo)(()=>{
        return {
            assistiveLabel: formatMessage((0, $b340a9e5e1414569$export$2e2bcd8739ae039).chatInputAssistiveLabel),
            minHeight: 20,
            shouldFocus: true,
            preset: preset,
            mentionProvider: mentionResource,
            maxHeight: 200,
            appearance: 'chromeless',
            onSave: ()=>saveRef.current?.(),
            popupsMountPoint: popupsMountPoint ?? undefined,
            onChange: (ev, meta)=>{
                if (!meta.isDirtyChange) {
                    let hasMentionOrCard = false;
                    ev.state.doc.descendants((node)=>{
                        if (node.type.name === 'mention' || node.type.name === 'inlineCard') {
                            hasMentionOrCard = true;
                            return false;
                        }
                        return true;
                    });
                    setHasMentionOrInlineCard(hasMentionOrCard);
                }
                setInputValue(ev.state.doc.textContent);
            }
        };
    }, [
        formatMessage,
        mentionResource,
        preset,
        popupsMountPoint,
        setHasMentionOrInlineCard,
        setInputValue
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                xcss: (0, $1Whri.cx)($91234e0d34981cdc$var$styles.stack, files.length === 0 && $91234e0d34981cdc$var$styles.stackWithoutContexts),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $91234e0d34981cdc$var$styles.editorWrapper,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $lAJUP.ErrorBoundary), {
                            fallbackRender: ({ error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $805F8.ExperienceFailure), {
                                            error: error,
                                            name: (0, $16lEl.ExperienceName).LOAD_INLINE_EDITOR
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $e6Iiv.ComposableEditor), {
                                            ...editorProps
                                        })
                                    ]
                                }),
                            onError: (error)=>{
                                (0, $1yaYZ.logException)({
                                    exception: error,
                                    name: (0, $16lEl.ExperienceName).LOAD_INLINE_EDITOR,
                                    tags: {
                                        siteId: siteId
                                    }
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $805F8.ExperienceStart), {
                                    name: (0, $16lEl.ExperienceName).LOAD_INLINE_EDITOR
                                }),
                                (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1') || (0, $dh538.fg)('rovo_chat_skills_fe_agg_cutover') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.AtlassianRelayEnvironmentProvider), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $i4C2H.default), {
                                        interactionName: "inline-chat-prompt-input-skills-load",
                                        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $e6Iiv.ComposableEditor), {
                                            ...editorProps
                                        }),
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eRTWv.ComposableEditorWithSkills), {
                                            isConversationAgentic: isConversationAgentic,
                                            promptHasSkill: false,
                                            enableSkills: true,
                                            siteId: siteId,
                                            ...editorProps
                                        })
                                    })
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $e6Iiv.ComposableEditor), {
                                    ...editorProps
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $805F8.ExperienceSuccess), {
                                    name: (0, $16lEl.ExperienceName).LOAD_INLINE_EDITOR
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ZsUvD.InputContextListDisplay), {
                        attachtmentsStoreKey: $91234e0d34981cdc$var$STORE_KEY
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $91234e0d34981cdc$var$styles.actions,
                children: [
                    showLabsLozenge && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        xcss: $91234e0d34981cdc$var$styles.labsLozenge,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9d8f4e2acb755628$export$8c4514d5420b4a89), {})
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.050",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4zqRX.VoiceRecordingPanel), {
                            state: voiceDictationResult.state,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fbZF8.ChatInputActionButtons), {
                                siteId: siteId,
                                attachmentsAndCurrentPageAsContextStoreKey: $91234e0d34981cdc$var$STORE_KEY,
                                isDisabled: false,
                                useCurrentPageContext: false,
                                onLinkTypeAheadClick: openLinkTypeAhead,
                                onMentionTypeAheadClick: openMentionTypeAhead,
                                onAddTypeAheadClick: openAddTypeAhead,
                                assistanceServiceParams: assistanceServiceParams,
                                placement: "bottom-end",
                                onMenuOpen: closeTypeAhead,
                                onAgentSelect: enableAgents && (0, $dh538.fg)('platform_inline_rovo_agents') ? onAgentSelect : undefined,
                                isBrowseAgentsModalOpen: isBrowseAgentsModalOpen,
                                setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $hnap0.VoiceActionsPanel), {
                        state: voiceDictationResult.state,
                        onStartRecording: onStartRecording,
                        onRejectRecording: onRejectRecording,
                        onAcceptRecording: onAcceptRecording,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            isTooltipDisabled: false,
                            appearance: "primary",
                            shape: "circle",
                            ref: submitButtonRef,
                            onClick: ()=>saveRef.current?.(),
                            type: "submit",
                            isDisabled: isSendDisabled,
                            interactionName: "ai-mate.send-message-button",
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
                                    ...iconProps,
                                    label: ''
                                }),
                            label: formatMessage((0, $b340a9e5e1414569$export$2e2bcd8739ae039).sendButtonLabel)
                        })
                    })
                ]
            })
        ]
    });
};
const $91234e0d34981cdc$export$5f6ebec06531be50 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auTg8.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5AtW0.default), {
            render: (actions)=>/*#__PURE__*/ (0, $l998X.jsx)($91234e0d34981cdc$var$PromptViewInternal, {
                    ...props,
                    actions: actions
                })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $3sFtD = parcelRequire("3sFtD");









var $15dd9d2f477bafc1$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    successMessage: {
        id: "ai-mate.inline-chat-input.success-view.message",
        defaultMessage: "No improvements, nice work."
    }
});


const $01a2199d411e8ba2$var$styles = {
    additionalSpacing: "_1rjc1b66",
    message: "_syazi7uo"
};
const $01a2199d411e8ba2$export$be5117c66bf44cb9 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $01a2199d411e8ba2$var$styles.additionalSpacing,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center",
            xcss: $01a2199d411e8ba2$var$styles.message,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                    color: "var(--ds-icon-success, #6A9A23)",
                    spacing: "spacious",
                    size: "medium",
                    label: ""
                }),
                formatMessage((0, $15dd9d2f477bafc1$export$2e2bcd8739ae039).successMessage)
            ]
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













var $5lVpa = parcelRequire("5lVpa");










var $6jnYQ = parcelRequire("6jnYQ");


var $PRMv4 = parcelRequire("PRMv4");




var $739cedc672548c9a$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    followAiMateButton: {
        id: "ai-mate.inline-chat-input.follow-button.label",
        defaultMessage: "Follow"
    },
    stopGeneratingButtonLabel: {
        id: "ai-mate.inline-chat-input.stop-generating-button.label",
        defaultMessage: "Stop generating"
    },
    thinkingText: {
        id: "ai-mate.inline-chat-input.thinking",
        defaultMessage: "Rovo is analyzing"
    },
    editingText: {
        id: "ai-mate.inline-chat-input.editing",
        defaultMessage: "Rovo is editing"
    },
    escapeKeyHint: {
        id: "ai-mate.inline-chat-input.escape-key-hint",
        defaultMessage: "Esc"
    }
});


const $dbef95e45b7bded4$var$styles = {
    escape: "_2rko12b0 _11c8wadc _18zr1b66 _1rjcv77o _bfhkysee _syaz1rpy",
    thinkingContainer: "_zulpu2gc _4t3i1tcg _1e0c1txw _4cvr1h6o",
    thinkingText: "_syazazsu"
};
const $dbef95e45b7bded4$export$4d87d729d663f77d = ({ latestTrace: latestTrace, onCancel: onCancel, onFollow: onFollow })=>{
    (0, $fBMbo.di)((0, $PRMv4.usePageContextType));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const pageContextType = (0, $PRMv4.usePageContextType)();
    const isNotWhiteboardContext = pageContextType !== (0, $PRMv4.PageContextType).CONFLUENCE_WHITEBOARD;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $dbef95e45b7bded4$var$styles.thinkingContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6jnYQ.RovoThinkingIndicator), {
                    title: formatMessage($dbef95e45b7bded4$var$latestTraceToI18n(latestTrace))
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                testId: "inline-chat__thinking-view",
                alignBlock: "center",
                space: "space.100",
                children: [
                    onFollow && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "subtle",
                        onClick: onFollow,
                        children: formatMessage((0, $739cedc672548c9a$export$2e2bcd8739ae039).followAiMateButton)
                    }),
                    isNotWhiteboardContext && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $dbef95e45b7bded4$var$styles.escape,
                        children: formatMessage((0, $739cedc672548c9a$export$2e2bcd8739ae039).escapeKeyHint)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        isTooltipDisabled: false,
                        shape: "circle",
                        onClick: ()=>onCancel((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? {
                                skipWarning: true
                            } : undefined),
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lVpa))), {
                                ...iconProps,
                                color: "var(--ds-icon-danger, #C9372C)",
                                label: ''
                            }),
                        label: formatMessage((0, $739cedc672548c9a$export$2e2bcd8739ae039).stopGeneratingButtonLabel)
                    })
                ]
            })
        ]
    });
};
const $dbef95e45b7bded4$var$latestTraceToI18n = (latestTrace)=>{
    if (latestTrace?.message_template === 'ACTION_CLASSIFICATION' && (latestTrace?.action_key === 'aifc-adf-update' || latestTrace?.action_key === 'aifc-confluence-whiteboard-update')) return (0, $739cedc672548c9a$export$2e2bcd8739ae039).editingText;
    return (0, $739cedc672548c9a$export$2e2bcd8739ae039).thinkingText;
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



















var $7b366b8e063b1841$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    discardMessage: {
        id: "ai-mate.inline-chat-input.warning-view.discard.message",
        defaultMessage: "Cancel request and discard response?"
    },
    deleteMessage: {
        id: "ai-mate.inline-chat-input.warning-view.message",
        defaultMessage: "Delete response?"
    },
    deleteButtonLabel: {
        id: "ai-mate.inline-chat-input.warning-view.delete-button.label",
        defaultMessage: "Delete"
    },
    keepButtonLabel: {
        id: "ai-mate.inline-chat-input.warning-view.keep-button.label",
        defaultMessage: "Keep"
    },
    stopMessage: {
        id: "ai-mate.inline-chat-input.warning-view.stop-message",
        defaultMessage: "Stop request?"
    },
    yesButtonLabel: {
        id: "ai-mate.inline-chat-input.warning-view.yes-button.label",
        defaultMessage: "Yes"
    },
    noButtonLabel: {
        id: "ai-mate.inline-chat-input.warning-view.no-button.label",
        defaultMessage: "No"
    }
});


const $d1627b3a2fc6f894$var$styles = {
    wrapper: "_2rko1tm3 _18zrutpp _1rjcu2gc _1bsb1ssb _kqswh2mm _bfhk1j9a _16qs130s",
    message: "_syazi7uo"
};
const $d1627b3a2fc6f894$export$1688d93d64f5e437 = ({ onKeep: onKeep, onDelete: onDelete, willDeleteAfterAbort: willDeleteAfterAbort })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        testId: "inline-chat__warning-view",
        spread: "space-between",
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center",
                xcss: $d1627b3a2fc6f894$var$styles.message,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                        color: "var(--ds-icon-warning, #E06C00)",
                        spacing: "spacious",
                        size: "medium",
                        label: ""
                    }),
                    formatMessage(willDeleteAfterAbort ? (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? (0, $7b366b8e063b1841$export$2e2bcd8739ae039).discardMessage : (0, $7b366b8e063b1841$export$2e2bcd8739ae039).deleteMessage : (0, $7b366b8e063b1841$export$2e2bcd8739ae039).stopMessage)
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        autoFocus: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers'),
                        appearance: "subtle",
                        onClick: onKeep,
                        children: formatMessage(willDeleteAfterAbort ? (0, $7b366b8e063b1841$export$2e2bcd8739ae039).keepButtonLabel : (0, $7b366b8e063b1841$export$2e2bcd8739ae039).noButtonLabel)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: willDeleteAfterAbort ? 'warning' : 'default',
                        onClick: onDelete,
                        children: formatMessage(willDeleteAfterAbort ? (0, $7b366b8e063b1841$export$2e2bcd8739ae039).deleteButtonLabel : (0, $7b366b8e063b1841$export$2e2bcd8739ae039).yesButtonLabel)
                    })
                ]
            })
        ]
    });
};


const $13ebdd826904c6da$var$slideFadeIn = null;
const $13ebdd826904c6da$var$styles = {
    wrapper: "_2rko1tm3 _18zrpxbi _1rjcutpp _1bsb1ns9 _bfhk1j9a _16qs130s _kqswh2mm _1e0c1txw _2lx21bp4",
    fadeIn: "_j7hq1w10 _5sagfnf5 _1pgl6ui8 _1o51q7pw _1bumglyw _sedtglyw",
    wrapperFlex: "_zulpu2gc _1bsb1osq _1e0c1txw _1n261g80 _1bah1yb4 _4cvr1h6o",
    agentHeaderSpacer: "_19pk1a70 _n3tdv77o",
    compact: "_18zrutpp _1rjcu2gc",
    fullWidth: "_1bsb1osq",
    thinking: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1ssb",
    thinkingIsCancelling: "_19pkidpf _2hwx1wug _otyridpf _18u01wug"
};
const $13ebdd826904c6da$export$b817d651a700fd8c = (props)=>{
    (0, $fBMbo.di)((0, $46ea5adc37ee5a6a$export$e924b3ae6248b17a));
    const { mode: mode, isCancelling: isCancelling, latestTrace: latestTrace, error: error, submit: submit, resubmit: resubmit, cancel: cancel, keep: keep, abort: abort, autoClose: autoClose, agent: agent, setAgent: setAgent } = (0, $46ea5adc37ee5a6a$export$e924b3ae6248b17a)(props);
    const dialogRef = (0, $42omo.useRef)(null);
    const [isBrowseAgentsModalOpen, setIsBrowseAgentsModalOpen] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const onMouseDown = (e)=>{
            const isClickInsideDialog = dialogRef.current?.contains(e.target);
            const isClickInsidePopupMount = (0, $dh538.fg)('platform_editor_fix_inline_rendering') && props.popupsMountPoint?.contains(e.target);
            if (!isClickInsideDialog && !isClickInsidePopupMount && !isBrowseAgentsModalOpen) {
                if (autoClose) cancel();
            }
        };
        return (0, $fFa3V.bind)(document, {
            type: 'mousedown',
            listener: onMouseDown
        });
    }, [
        mode,
        cancel,
        autoClose,
        isBrowseAgentsModalOpen,
        props.popupsMountPoint
    ]);
    const onKeyDown = (e)=>{
        if (e.key === 'Escape') cancel((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? {
            skipWarning: true
        } : undefined);
    };
    const willDeleteAfterAbort = props.willDeleteAfterAbort ?? true;
    const renderView = ()=>{
        if (isCancelling) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d1627b3a2fc6f894$export$1688d93d64f5e437), {
            onKeep: keep,
            onDelete: ()=>abort(true),
            willDeleteAfterAbort: willDeleteAfterAbort
        });
        switch(mode){
            case 'thinking':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $dbef95e45b7bded4$export$4d87d729d663f77d), {
                    latestTrace: latestTrace,
                    onCancel: cancel,
                    onFollow: props.onFollow
                });
            case 'editing':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $91234e0d34981cdc$export$5f6ebec06531be50), {
                    ...props,
                    showLabsLozenge: props._showLabsLozenge,
                    onSubmit: submit,
                    onAgentSelect: (a)=>setAgent(a),
                    isBrowseAgentsModalOpen: isBrowseAgentsModalOpen,
                    setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen,
                    agent: agent
                });
            case 'error':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $e0a2b0c08103f485$export$8c68b6013ae44ca6), {
                    error: error,
                    onClose: abort,
                    onTryAgain: resubmit
                });
            case 'success':
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $01a2199d411e8ba2$export$be5117c66bf44cb9), {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        role: "dialog",
        ref: dialogRef,
        onKeyDown: onKeyDown,
        xcss: (0, $1Whri.cx)($13ebdd826904c6da$var$styles.wrapper, props.compact && $13ebdd826904c6da$var$styles.compact, mode === 'editing' && $13ebdd826904c6da$var$styles.fullWidth, mode === 'thinking' && !isCancelling && $13ebdd826904c6da$var$styles.thinking, mode === 'thinking' && $13ebdd826904c6da$var$styles.thinkingIsCancelling, mode === 'thinking' && $13ebdd826904c6da$var$styles.fadeIn),
        children: [
            agent && /*#__PURE__*/ (0, $l998X.jsx)((0, $80d7e5b2eb9a35f8$export$24238a3d65fa333), {
                agent: agent,
                removeAgent: ()=>setAgent(null),
                compact: props.compact
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($13ebdd826904c6da$var$styles.wrapperFlex, agent && $13ebdd826904c6da$var$styles.agentHeaderSpacer),
                children: renderView()
            })
        ]
    });
};







const $52854ee2a6ade060$var$providerProductToProuductKey = (product)=>{
    switch(product){
        case 'CONFLUENCE':
            return 'confluence';
        case 'JSW':
        case 'JSM':
        case 'JWM':
        case 'JPD':
            return 'jira';
        case 'ATLAS':
        case 'TOWNSQUARE':
            return 'atlas';
        case 'BITBUCKET':
            return 'bitbucket';
        default:
            return 'unknown';
    }
};
const $52854ee2a6ade060$var$backupChannelVariables = {
    cloudId: '',
    orgId: undefined
};
function $52854ee2a6ade060$export$d0c09a27ab507630({ cancel: cancel }) {
    const { setIsRovoLoading: setIsRovoLoading, api: api, targetId: targetId, editorPluginAIProvider: editorPluginAIProvider, appearance: appearance, setCancelRovoPrompt: setCancelRovoPrompt, popupsMountPoint: popupsMountPoint } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const { cloudId: cloudId, orgId: orgId } = (0, $42omo.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent') || $52854ee2a6ade060$var$backupChannelVariables, [
        editorPluginAIProvider
    ]);
    const product = editorPluginAIProvider.product;
    const productKey = $52854ee2a6ade060$var$providerProductToProuductKey(product);
    const isPageEditor = appearance === 'full-page' || appearance === 'full-width' || appearance === 'max';
    const source = productKey === 'confluence' && isPageEditor ? 'CONFLUENCE_INLINE_EDITOR' : 'INLINE_EDITOR';
    const nextSessionId = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId);
    const showLabsLozenge = (0, $42omo.useMemo)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) return true;
        if (productKey === 'confluence') {
            if (!(0, $dh538.fg)('aifc_onboarding_ga_enabled')) return true;
            // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
            if (!(0, $c6GJD.default).getExperimentValue('cc-aifc-databases-experiment', 'isEnabled', false)) return true;
        }
        return false;
    }, [
        productKey
    ]);
    (0, $42omo.useEffect)(()=>{
        setCancelRovoPrompt?.(undefined);
        return ()=>{
            setIsRovoLoading(false);
        };
    }, [
        setCancelRovoPrompt,
        setIsRovoLoading
    ]);
    const handleAbort = (0, $42omo.useCallback)(({ streamEnded: streamEnded })=>{
        cancel({
            shouldClearSelectionContext: streamEnded
        });
        setIsRovoLoading(false);
        api?.core?.actions?.execute((0, $7d27e28955fa0757$export$ea01a78091d2ff77)());
    }, [
        cancel,
        setIsRovoLoading,
        api?.core?.actions
    ]);
    // useEffect(() => {
    // 	console.log('RovoPromptScreenWithLogic mounted');
    // 	return () => {
    // 		console.log('RovoPromptScreenWithLogic unmounted');
    // 	};
    // }, []);
    const onSubmit = (0, $42omo.useCallback)((cancel)=>{
        editorPluginAIProvider.onSubmit?.();
        setIsRovoLoading(true);
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) // Fire prompt event for AIFC. We don't have access to the request id as it's not generated
        // at this point of time and nothing else is available at this stage.
        // For now this will just give us an indication of prompt volume.
        api?.analytics?.actions.fireAnalyticsEvent({
            action: 'prompt',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'userFlow',
            attributes: {
                aiGroupId: nextSessionId,
                experienceName: (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC,
                actionTaken: '',
                editCount: 0,
                aiSessionId: '',
                inlineStreamingAvailable: true
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
        const cancelRovoPrompt = ()=>{
            cancel();
        };
        // give DOM time to update the screen
        setTimeout(()=>{
            setCancelRovoPrompt?.(()=>cancelRovoPrompt);
        }, 100);
    }, [
        api,
        nextSessionId,
        editorPluginAIProvider,
        setCancelRovoPrompt,
        setIsRovoLoading
    ]);
    // If a session is active - we'll show the loading screen elsewhere and we can hide this
    if (nextSessionId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13ebdd826904c6da$export$b817d651a700fd8c), {
        source: (0, $dh538.fg)('platform_editor_aifc_in_page_comment') ? source : productKey === 'confluence' ? 'CONFLUENCE_INLINE_EDITOR' : 'INLINE_EDITOR',
        productKey: productKey,
        siteId: cloudId,
        orgId: orgId,
        objectId: targetId,
        onAbort: handleAbort,
        onCancel: ()=>{
        /* noop - this is to allow the rovo inline chat to manage cancel behaviour.
					 * We shouldn't end the AI experience directly. */ },
        popupsMountPoint: (0, $dh538.fg)('platform_editor_fix_inline_rendering') ? popupsMountPoint : undefined,
        // The following nops usages are like this because we want to ensure that only the AI plugin or the Orchestrator
        // are controlling the xstate. We do not want this to end the ai experience directly. Instead the rovo bridge
        // will call the orchestrator which will then end the experience, on both complete and abort.
        // IMPORTANT!! Do not end the AI experience on the complete callback. This can cause problems because the
        // rovo bridge may still have events to stream in the queue, and it's possible that this could result in
        // the experience being ended immediately on mount, which would then unmount the prompt. This is because the rovo bridge
        // can have a final response in its queue which has never fluushed previously, because something else unmounted this
        // component before the final response was flushed.
        onComplete: ()=>{
            setIsRovoLoading(false);
        },
        onSubmit: onSubmit,
        enableAgents: editorPluginAIProvider.isRovoEnabled && (0, $dh538.fg)('platform_inline_rovo_agents'),
        _showLabsLozenge: showLabsLozenge
    }));
}


/* eslint-disable @repo/internal/react/no-class-components */ /* There is no good way to replace ErrorBoundary class components with a
 * functional component; currently no functional hook that can replace
 * 'componentDidCatch'.
 * Source: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 *
 * But I needed to get 'createAnalyticsEvent' via a hook hence
 * the wrapped class component.
 */ 




















/* UnhandledError.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $7sObp = parcelRequire("7sObp");





var $aFUXX = parcelRequire("aFUXX");








var $BPkYg = parcelRequire("BPkYg");


var $4pXOZ = parcelRequire("4pXOZ");

// Where do we get this magic number 500?
// - The lowest product z-index we need to be below is 500 from the Feedback Collector.
// As well as the Editor toolbar popup menu, which is also 500.
// This allows us to be above the floating toolbar, but below the feedback collector.
// +2 because tables floating toolbar is +1.
const $d6a38d051faab504$var$MAX_Z_INDEX = 500; // Where do we get this magic number 402?
// - The highest product z-index we need to be above is 401 from the floating toolbar*.
// *in Confluence and Bitbucket. It is 600px in Atlas & 511 in Jira, however that is a more niche case than the Feedback Collector,
// so this is a known trade-off until we have a better solution.
const $d6a38d051faab504$var$MIN_Z_INDEX = 402; // Sets the z-index so it is not greater than the maximum, and less than the minimum.
const $d6a38d051faab504$var$akAiModalRegionZIndex = Math.min($d6a38d051faab504$var$MAX_Z_INDEX, Math.max($d6a38d051faab504$var$MIN_Z_INDEX, (0, $aFUXX.akEditorFloatingPanelZIndex) + 2));
const $d6a38d051faab504$var$errorScreenCSS = null;
const $d6a38d051faab504$var$errorScreenCSSUnbounded = null;
const $d6a38d051faab504$export$40729e8ab35829ea = ({ onCancel: onCancel, text: text, inContentComponent: inContentComponent, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $imfiV.useElementBreakpoints)();
    const [width, setWidth] = (0, $42omo.useState)(undefined); // when this is rendered in the content component, we have to calc it's width
    const onDivRef = (0, $42omo.useCallback)((node)=>{
        if (inContentComponent && !width && node && node.parentNode instanceof HTMLElement && isAIFC) setWidth(node.parentNode.clientWidth);
    }, [
        inContentComponent,
        width,
        isAIFC
    ]);
    const cnt = /*#__PURE__*/ (0, $l998X.jsxs)((0, $BPkYg.ErrorFloatingContainer), {
        ref: setBreakpointsElement,
        breakpoint: breakpoint,
        isAIFC: isAIFC,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $4pXOZ.default).ariaErrorTitle)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $BPkYg.ErrorMessage), {
                breakpoint: breakpoint,
                isAIFC: isAIFC,
                children: text
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $BPkYg.ErrorButtonContainer), {
                isAIFC: isAIFC,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $BPkYg.ErrorButton), {
                    autoFocus: true,
                    testId: 'cancel',
                    onClick: onCancel,
                    appearance: "primary",
                    isAIFC: isAIFC,
                    children: formatMessage(isAIFC ? (0, $4pXOZ.default).closeLabel : (0, $4pXOZ.default).cancelLabel)
                })
            })
        ]
    }); // when this is rendered in the content component, we have to add a wrapper div to apply some styles like position and zIndex
    // for z-index
    // - this will ensure it's applied properly because passing is via css to ErrorFloatingContainer won't work
    // - the z-index will be compiled to a css custom property, but the css custom property is undefined
    // - normally, the css custom property will be defined on the same dom element
    return inContentComponent && isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: onDivRef,
        className: (0, $gMc0m.default)([
            "_kqswstnw",
            "_1pby1kbs"
        ]),
        style: {
            width: width,
            "--_1dsp0pi": (0, $7sObp.default)($d6a38d051faab504$var$akAiModalRegionZIndex)
        },
        children: cnt
    }) : cnt;
};


const $5b1c9f286ba7f166$export$8a78f5c7307b478b = 'MarkdownConversionError';
class $5b1c9f286ba7f166$export$6c16da0c287c00c extends Error {
    constructor({ message: message, type: type }){
        super(message);
        this.type = void 0;
        this.name = $5b1c9f286ba7f166$export$8a78f5c7307b478b;
        this.type = type;
    }
}





const $510ce0322de9e3d3$var$getErrorMessage = (error)=>{
    if (error.name === (0, $5b1c9f286ba7f166$export$8a78f5c7307b478b)) return (0, $7ShCl.aiMessages).markdownErrorMessage;
    return (0, $7ShCl.aiMessages).cmdPaletteUnhandledErrorMessage;
};
const $510ce0322de9e3d3$export$61f6bd9fac8ed53 = (props)=>{
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    // when there is an error, after we resetErrorBoundary the component tree will render again and trigger the error again
    // use this to not render children to prevent the error from being triggered again
    // when we start AI again, parent should use key to reset this component or its ancestor to render children again
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const onError = (error, info)=>{
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-ai-error-boundary'
        });
        if (error.name === (0, $5b1c9f286ba7f166$export$8a78f5c7307b478b)) {
            const errorHasTypeProperty = 'type' in error;
            const errorSubType = errorHasTypeProperty ? error.type : undefined;
            fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        componentStack: info.componentStack || '',
                        errorType: 'markdownToProseMirrorError',
                        errorSubType: errorSubType,
                        errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                }
            });
        } else fireAIAnalyticsEvent({
            payload: {
                action: 'unhandledErrorCaught',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'experienceApplication',
                attributes: {
                    componentStack: info.componentStack || '',
                    errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        onError: onError,
        fallbackRender: ({ error: error, resetErrorBoundary: resetErrorBoundary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d6a38d051faab504$export$40729e8ab35829ea), {
                inContentComponent: props.inContentComponent,
                text: formatMessage($510ce0322de9e3d3$var$getErrorMessage(error)),
                onCancel: ()=>{
                    props.onCloseFallback();
                    resetErrorBoundary();
                    setHasError(true);
                },
                isAIFC: true
            })
    }, hasError ? null : props.children);
};


/* ModalRegion.tsx generated by @compiled/babel-plugin v0.36.1 */ 




























const $64b8432229a36001$export$91249d6c9b15807 = 'ai-height-div';
function $64b8432229a36001$export$a5441b49687f80f6({ modalElement: modalElement, editorViewElement: editorViewElement, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled }) {
    const heightDivRef = (0, $42omo.useRef)(null);
    // listen to changes to modal size
    (0, $42omo.useEffect)(()=>{
        if (!modalElement) return;
        const resizeObserver = new ResizeObserver((entries)=>{
            if (!heightDivRef.current || !modalElement) return;
            const modalEntry = entries.find((e)=>e.target === modalElement);
            // entry should always exist for modaRef as we're observing on it, this check makes ts happy
            if (!modalEntry) return;
            const modalBottom = // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            modalEntry.target.offsetTop + modalEntry.contentRect.height;
            const editorBottom = editorViewElement.offsetTop + editorViewElement.offsetHeight;
            // The height of the extra div should be expanded to reach
            // the bottom of the modal -- so that no modal content is outside
            // the editor
            const heightToSet = Math.max(modalBottom - editorBottom, 0);
            heightDivRef.current.style.height = `${heightToSet}px`;
        });
        resizeObserver.observe(modalElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        modalElement,
        editorViewElement
    ]);
    // Create an element for adjusting height of editor when modal is visible
    (0, $42omo.useEffect)(()=>{
        if (heightDivRef.current) // In future react will fire useEffect twice in dev mode
        // this early exit avoids issues with this
        return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const newDiv = doc.createElement('div');
        newDiv.className = $64b8432229a36001$export$91249d6c9b15807;
        newDiv.style.height = `0px`;
        if (isInDocumentStreamingEnabled) {
            if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) // Position directly after the editor element to avoid
            // selector ambiguity in nested editor scenarios.
            editorViewElement.after(newDiv);
            else {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const parent = editorViewElement.parentNode;
                // Find the editor textarea element by ID
                const targetChild = parent.querySelector('#ak-editor-textarea');
                if (targetChild) targetChild.after(newDiv);
                else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                editorViewElement.parentNode.appendChild(newDiv);
            }
        } else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorViewElement.parentNode.appendChild(newDiv);
        heightDivRef.current = newDiv;
        return ()=>{
            if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) newDiv.parentNode?.removeChild(newDiv);
            else editorViewElement.parentNode?.removeChild(newDiv);
        };
    }, [
        editorViewElement,
        isInDocumentStreamingEnabled
    ]);
}



var $1zav4 = parcelRequire("1zav4");




function $17eb146d0c8e17ac$var$getOffsetParent(element) {
    const offsetParent = element.offsetParent;
    if (offsetParent) return offsetParent;
    // If offsetParent is null, we need to find the nearest ancestor element that has a position value other than static
    let tempOffsetParent = element.parentElement;
    while(tempOffsetParent){
        const position = getComputedStyle(tempOffsetParent).position;
        if (position !== 'static') return tempOffsetParent;
        tempOffsetParent = tempOffsetParent.parentElement;
    }
    return document.body;
}
// Calculate offset for modal positioning
function $17eb146d0c8e17ac$var$getModalOffset({ from: from, modalElement: modalElement, direction: direction }) {
    const property = direction === 'top' ? 'offsetTop' : 'offsetLeft';
    let offset = from[property];
    let tempOffsetParent = from.offsetParent;
    const modalOffsetParent = $17eb146d0c8e17ac$var$getOffsetParent(modalElement);
    while(tempOffsetParent && tempOffsetParent instanceof HTMLElement && tempOffsetParent !== modalOffsetParent){
        offset += tempOffsetParent[property];
        tempOffsetParent = tempOffsetParent.offsetParent;
    }
    return offset;
}
function $17eb146d0c8e17ac$export$f695eeeda1b3ceee({ relativePositionElement: relativePositionElement, modalElement: modalElement }) {
    return $17eb146d0c8e17ac$var$getModalOffset({
        from: relativePositionElement,
        modalElement: modalElement,
        direction: 'left'
    });
}
// Calculate offset top for decorationBottom positioning
function $17eb146d0c8e17ac$var$getDecorationBottom({ modalDecorationElement: modalDecorationElement, modalElement: modalElement }) {
    const offset = $17eb146d0c8e17ac$var$getModalOffset({
        from: modalDecorationElement,
        modalElement: modalElement,
        direction: 'top'
    });
    return offset + modalDecorationElement.offsetHeight;
}
function $17eb146d0c8e17ac$export$6fabade9f8472f78({ appearance: appearance, modalElement: modalElement, editorRelativeWrapper: editorRelativeWrapper, modalDecorationElement: modalDecorationElement, lastTriggeredFrom: lastTriggeredFrom, editorView: editorView }) {
    const isSuggestTitleQuickAction = lastTriggeredFrom === 'confluenceTitleToolbar';
    if (isSuggestTitleQuickAction) return editorRelativeWrapper?.querySelector('.ProseMirror')?.offsetTop || 0;
    const calculatedTop = $17eb146d0c8e17ac$var$getDecorationBottom({
        modalDecorationElement: modalDecorationElement,
        modalElement: modalElement
    });
    // Clamp AI modal bottom within editor content area in chromeless mode
    // Calculates the bottom limit relative to the modal's offset parent
    if (appearance === 'chromeless') {
        const editorContentArea = editorView?.dom.closest('.ak-editor-content-area');
        if (editorContentArea) {
            const modalOffsetParent = $17eb146d0c8e17ac$var$getOffsetParent(modalElement);
            const contentAreaRect = editorContentArea.getBoundingClientRect();
            const modalOffsetParentRect = modalOffsetParent.getBoundingClientRect();
            const contentAreaBottom = contentAreaRect.bottom - modalOffsetParentRect.top;
            if (calculatedTop > contentAreaBottom) return contentAreaBottom;
        }
    }
    return calculatedTop;
}
function $17eb146d0c8e17ac$export$9e4eede810cdf154(editorView, position) {
    // For in-document streaming, the mount decoration is placed at the end of the document
    // But somehow during streaming, the position can be larger than the document size
    // So we need to clamp the position to the document size
    const resolvedPos = editorView.state.doc.resolve(Math.min(position, editorView.state.doc.content.size));
    const { nodes: nodes, marks: marks } = editorView.state.schema;
    const domAtPos = editorView.domAtPos.bind(editorView);
    /**
   * At the moment, the table node is the only resizable node
   * which can trigger the AI modal.
   */ const resizableNode = (0, $8m4tT.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>currentNode.type === nodes.table);
    if (resizableNode) {
        const resizableDomNode = (0, $8m4tT.findDomRefAtPos)(resizableNode.start, domAtPos);
        if (resizableDomNode instanceof HTMLElement) {
            /**
       * At the moment this only resizable tables need to be handled
       * hence why we use the table resizer class name specifically.
       */ const resizableWrapper = resizableDomNode.closest(`.${(0, $1zav4.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`);
            if (resizableWrapper instanceof HTMLElement) return resizableWrapper;
        }
    }
    const nodeWithBreakout = (0, $8m4tT.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>{
        return currentNode.type === nodes.table && currentNode.attrs.layout !== 'default' || currentNode.marks.some((mark)=>mark.type === marks.breakout);
    });
    if (!nodeWithBreakout) return;
    const domNodeWithBreakout = (0, $8m4tT.findDomRefAtPos)(nodeWithBreakout.start, domAtPos);
    if (!(domNodeWithBreakout instanceof HTMLElement)) return;
    if (!domNodeWithBreakout) return;
    if ([
        nodes.layoutSection,
        nodes.expand
    ].includes(nodeWithBreakout.node.type)) return domNodeWithBreakout.parentElement || undefined;
    if (nodeWithBreakout.node.type === nodes.table) {
        const closest = domNodeWithBreakout.closest(`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`);
        return closest instanceof HTMLElement ? closest : undefined;
    }
}


// Where do we get this magic number 500?
// - The lowest product z-index we need to be below is 500 from the Feedback Collector.
// As well as the Editor toolbar popup menu, which is also 500.
// This allows us to be above the floating toolbar, but below the feedback collector.
// +2 because tables floating toolbar is +1.
const $c33a4c9b26ac5d24$var$MAX_Z_INDEX = 500; // Where do we get this magic number 402?
// - The highest product z-index we need to be above is 401 from the floating toolbar*.
// *in Confluence and Bitbucket. It is 600px in Atlas & 511 in Jira, however that is a more niche case than the Feedback Collector,
// so this is a known trade-off until we have a better solution.
const $c33a4c9b26ac5d24$var$MIN_Z_INDEX = 402; // Sets the z-index so it is not greater than the maximum, and less than the minimum.
const $c33a4c9b26ac5d24$var$akAiModalRegionZIndex = Math.min($c33a4c9b26ac5d24$var$MAX_Z_INDEX, Math.max($c33a4c9b26ac5d24$var$MIN_Z_INDEX, (0, $aFUXX.akEditorFloatingPanelZIndex) + 2));
var $c33a4c9b26ac5d24$var$MODAL_PINNING = /*#__PURE__*/ function(MODAL_PINNING) {
    MODAL_PINNING[MODAL_PINNING["TOP"] = 1] = "TOP";
    MODAL_PINNING[MODAL_PINNING["NONE"] = 0] = "NONE";
    MODAL_PINNING[MODAL_PINNING["BOTTOM"] = -1] = "BOTTOM";
    return MODAL_PINNING;
}($c33a4c9b26ac5d24$var$MODAL_PINNING || {});
const $c33a4c9b26ac5d24$var$slideFadeIn = null;
const $c33a4c9b26ac5d24$var$modalStyles = null;
const $c33a4c9b26ac5d24$var$pinnedTopStyles = null;
const $c33a4c9b26ac5d24$var$pinnedBottomStyles = null;
const $c33a4c9b26ac5d24$var$getModalDecorationElement = (editorView)=>{
    return editorView?.dom.querySelector('.ai-modal-mount-point-widget') || editorView?.dom.querySelector('.ai-selection-node');
};
const $c33a4c9b26ac5d24$export$bd71f7a11db32a15 = ({ isDirectionalPinningEnabled: isDirectionalPinningEnabled, children: children, decoration: decoration, editorView: editorView, editorRelativeWrapper: editorRelativeWrapper, appearance: appearance, endExperience: endExperience, lastTriggeredFrom: lastTriggeredFrom, decorationSet: decorationSet })=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorViewElement = editorView.dom;
    const modalRef = (0, $42omo.useRef)(null);
    const [modalLeft, setModalLeft] = (0, $42omo.useState)(0);
    const [modalTop, setModalTop] = (0, $42omo.useState)(0);
    const [modalWidth, setModalWidth] = (0, $42omo.useState)(0);
    const [transition, setTransition] = (0, $42omo.useState)('');
    const scrollParentRef = (0, $42omo.useRef)(null);
    const [isPinned, setIsPinned] = (0, $42omo.useState)(0);
    const [modalHeight, setModalHeight] = (0, $42omo.useState)(0); // get nearest resizable wrapper or breakout container looking up from the ai decoration position
    const resizableOrBreakoutWrapper = (0, $42omo.useMemo)(()=>(0, $17eb146d0c8e17ac$export$9e4eede810cdf154)(editorView, decoration.to), [
        editorView,
        decoration
    ]);
    const modalDecorationElement = $c33a4c9b26ac5d24$var$getModalDecorationElement(editorView); // We only want modal pinning in full page experiences.
    const isModalPinningEnabled = [
        'full-page',
        'full-width'
    ].includes(appearance); // EDF-161: https://product-fabric.atlassian.net/browse/EDF-161
    // If the editor has a max-height set, we need to set position relative for .ak-editor-content-area
    (0, $42omo.useEffect)(()=>{
        if (appearance === 'comment') {
            // editorRelativeWrapper is the closest but can be null
            // fallback to modalDecorationElement if editorRelativeWrapper is null
            let editorContentArea = null;
            if (editorRelativeWrapper) editorContentArea = editorRelativeWrapper.querySelector('.ak-editor-content-area');
            else if (modalDecorationElement) editorContentArea = modalDecorationElement.closest('.ak-editor-content-area');
            if (editorContentArea) {
                const computedStyle = getComputedStyle(editorContentArea);
                const editorHasMaxHeight = computedStyle.maxHeight !== 'none';
                const originalPosition = computedStyle.position;
                if (editorHasMaxHeight) editorContentArea.style.position = 'relative';
                return ()=>{
                    if (editorHasMaxHeight && editorContentArea) editorContentArea.style.position = originalPosition;
                };
            }
        }
    }, [
        modalDecorationElement,
        appearance,
        editorRelativeWrapper
    ]); // listen for editor resize and update modal size and position
    (0, $42omo.useEffect)(()=>{
        const setModalPosition = ()=>{
            if (!modalRef.current || !modalDecorationElement || !modalDecorationElement.offsetParent) // The modalDecorationElement.offsetParent is used when calculating the modal top postion. If it is null
            // the modal will flikcer from top to bottom, because the top position resets to 0.
            return;
            const relativePositionElement = editorViewElement;
            const top = (0, $17eb146d0c8e17ac$export$6fabade9f8472f78)({
                appearance: appearance,
                modalElement: modalRef.current,
                editorRelativeWrapper: editorRelativeWrapper,
                modalDecorationElement: modalDecorationElement,
                lastTriggeredFrom: lastTriggeredFrom,
                editorView: editorView
            });
            const left = (0, $17eb146d0c8e17ac$export$f695eeeda1b3ceee)({
                relativePositionElement: relativePositionElement,
                modalElement: modalRef.current
            });
            setModalLeft(left);
            setModalTop(top);
            setModalWidth(relativePositionElement.offsetWidth); //setting width to be animated here to make animation happen only after first positioning
            if (!transition) setTransition('left 0.1s ease-in, left 0.1s ease-in');
        };
        setModalPosition();
        const setModalPositionDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setModalPosition();
        }, 20);
        const resizeObserver = new ResizeObserver(setModalPositionDebounced);
        resizeObserver.observe(editorViewElement); // editorViewOffsetParent can be undefined when editor is set to display: none
        // (when Confluence switches to Preview mode)
        const editorViewOffsetParent = editorViewElement.offsetParent;
        if (editorViewOffsetParent) // This resize observer is intended to fix the position of the modal region
        // when the config panel (for extensions or templates) is opened/closed
        resizeObserver.observe(editorViewOffsetParent);
        return ()=>{
            resizeObserver.disconnect(); //clearing any potentially running debounced reposition
            setModalPositionDebounced.cancel();
        }; // no need to rerun due to transition change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorViewElement,
        modalDecorationElement,
        editorRelativeWrapper,
        resizableOrBreakoutWrapper
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!modalRef.current) return;
        if (!scrollParentRef.current) {
            const scrollParentEl = (0, $7YjFd.findOverflowScrollParent)(modalRef.current) || null;
            if (!scrollParentEl) return;
            scrollParentRef.current = scrollParentEl;
        }
        const modalHeightObserver = new ResizeObserver(()=>{
            if (!modalRef.current) return;
            setModalHeight(modalRef.current.offsetHeight);
        });
        modalHeightObserver.observe(modalRef.current);
        return ()=>{
            modalHeightObserver.disconnect();
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (modalHeight && scrollParentRef.current && modalDecorationElement && isModalPinningEnabled && isDirectionalPinningEnabled) {
            const scrollParent = scrollParentRef.current;
            const observer = new IntersectionObserver((entries)=>{
                for (const entry of entries)if (entry.isIntersecting) setIsPinned(0);
                else {
                    // We could be reacting to an element which is no longer in the DOM because prosemirror has removed it,
                    // so we need to check that the target is still the current target.
                    // This is not ideal and can be costly, however it's only a performance issue during the inline streaming
                    // experience, and should have little affect the overall editor experience.
                    const currentTarget = $c33a4c9b26ac5d24$var$getModalDecorationElement(editorView);
                    if (entry.target !== currentTarget) // It's possible for the interaction observer callback to be called early as soon as the prosemirror
                    // widget decoration has been removed. This means the react vdom update lags behind and doesn't disconnect
                    // until a bit latter.
                    return;
                     // somehow, during streaming, the rootBounds and other fields in entry will have all 0, which is really weird!
                    if (!entry.rootBounds || entry.rootBounds.height === 0) {
                        const rect = modalDecorationElement.getBoundingClientRect();
                        const scrollRect = scrollParent.getBoundingClientRect();
                        setIsPinned(rect.bottom < scrollRect.top ? 1 : -1);
                    } else setIsPinned(entry.boundingClientRect.bottom < entry.rootBounds.top ? 1 : -1);
                }
            }, {
                root: scrollParentRef.current,
                /**
         * We set the bottom root margin to account for the modal height (so that the modal does not block content),
         * the top margin and bottom margin of the modal (16px each).
         * We also use the modal decoration's height to figure out the location of the bottom of the mount point widget.
         */ rootMargin: `0px 0px -${modalHeight + 16 + 16 + modalDecorationElement.getBoundingClientRect().height}px 0px`,
                threshold: 0
            });
            observer.observe(modalDecorationElement);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        modalHeight,
        editorView,
        modalDecorationElement,
        isModalPinningEnabled,
        isDirectionalPinningEnabled
    ]); // sync modal height with editor content area height
    (0, $64b8432229a36001$export$a5441b49687f80f6)({
        modalElement: modalRef.current,
        editorViewElement: editorViewElement,
        isInDocumentStreamingEnabled: true
    }); // Check for the modal decoration which is used for positioning
    // If there is none the modal should be removed from the DOM & return early
    // This is intended to make the code more resilient to bugs caused by the
    // editor AI plugin not being reinstantiated correctly when the editor is closed/opened
    // See https://product-fabric.atlassian.net/browse/EDITOR-52
    if (decorationSet === (0, $ftzrq.DecorationSet).empty) {
        endExperience();
        return null;
    }
    const style = {
        ...(!isModalPinningEnabled || isDirectionalPinningEnabled && isPinned === 0) && {
            top: modalTop,
            transition: transition
        },
        left: modalLeft,
        '--content-width': `${modalWidth}px`,
        display: modalWidth ? 'block' : 'none'
    };
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_19pkpxbi _kqswstnw _1pby1kbs _2hwxmgjw _18u0mgjw _1bsbxj84 _j7hq1w10 _5sagfnf5 _1pgl6ui8 _1o51q7pw _ta6yglyw",
            isModalPinningEnabled && isDirectionalPinningEnabled && isPinned === 1 && "_kqsw1n9t _154iidpf",
            isModalPinningEnabled && (isDirectionalPinningEnabled && isPinned === -1 || !isDirectionalPinningEnabled) && "_kqsw1n9t _94n57vkz _154in7od",
            "ak-editor-plugin-ai-modal"
        ]),
        "data-testid": "ai-plugin-modal",
        ref: modalRef,
        // Otherwise, content selection will be prevented in packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
        "data-editor-popup": true,
        style: {
            ...style,
            "--_1dsp0pi": (0, $7sObp.default)($c33a4c9b26ac5d24$var$akAiModalRegionZIndex)
        }
    }, children);
};



const $0a0d682dcc9d762a$var$promptScreenCSS = null;
function $0a0d682dcc9d762a$var$findModalDecoration(modalDecorationSet) {
    if (!modalDecorationSet) return undefined;
    return modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'modalMountPointDecoration' || spec.key === 'modalMountPointRangeDecoration').shift() || modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration').shift();
}
function $0a0d682dcc9d762a$export$eee2c979f2d34827({ api: api, dispatch: dispatch, appearance: appearance }) {
    const { editorView: editorView, wrapperElement: wrapperElement, isRovoLoading: isRovoLoading, endExperience: endExperience } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const { lastTriggeredFrom: lastTriggeredFrom, modalMountedTimeStamp: modalMountedTimeStamp, modalDecorationSet: modalDecorationSet, nextSessionId: nextSessionId } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>({
            lastTriggeredFrom: aiExperienceState?.aiDecorationExperiencePluginState.lastTriggeredFrom,
            modalMountedTimeStamp: aiExperienceState?.aiDecorationExperiencePluginState.modalMountedTimeStamp,
            modalDecorationSet: aiExperienceState?.aiDecorationExperiencePluginState.modalDecorationSet,
            nextSessionId: aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId
        }));
    const isDirectionalPinningEnabled = (0, $42omo.useMemo)(()=>{
        return !isRovoLoading;
    }, [
        isRovoLoading
    ]);
    const promptScreenRef = (0, $42omo.useRef)(null);
    const cancel = (0, $42omo.useCallback)((options)=>{
        endExperience({
            shouldClearSelectionContext: options?.shouldClearSelectionContext
        });
        api?.core?.actions.execute((0, $7d27e28955fa0757$export$ea01a78091d2ff77)());
        dispatch({
            type: 'terminate'
        });
    }, [
        endExperience,
        api?.core?.actions,
        dispatch
    ]);
    (0, $4961f0dd6244924e$export$27da6e66e88e9ac7)({
        ref: promptScreenRef,
        onDiscard: cancel
    }); // Get decoration for modal positioning
    const decoration = $0a0d682dcc9d762a$var$findModalDecoration(modalDecorationSet);
    if (!decoration || !modalDecorationSet) return null;
     // RovoInlineChatPrompt has its own internal logic with a loading screen
    // if a session is active, we'll show our own screen to prevent delay between
    // prompt submission and the rovo loading screen appearing
    if (nextSessionId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: promptScreenRef,
        "data-testid": "rovo-prompt-session-screen",
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $510ce0322de9e3d3$export$61f6bd9fac8ed53), {
        inContentComponent: true,
        onCloseFallback: endExperience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33a4c9b26ac5d24$export$bd71f7a11db32a15), {
        isDirectionalPinningEnabled: isDirectionalPinningEnabled,
        lastTriggeredFrom: lastTriggeredFrom,
        key: modalMountedTimeStamp,
        decoration: decoration,
        editorView: editorView,
        editorRelativeWrapper: wrapperElement?.offsetParent,
        endExperience: endExperience,
        appearance: appearance,
        decorationSet: modalDecorationSet
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52854ee2a6ade060$export$d0c09a27ab507630), {
        cancel: cancel
    }))));
}











const $1846b76781c5e54d$var$initialState = {
    discard: false,
    terminated: false,
    showAcceptReject: false
};
function $1846b76781c5e54d$var$reducer(state, action) {
    switch(action.type){
        case 'discard':
            return {
                ...state,
                discard: true
            };
        case 'cancel':
            return {
                ...state,
                discard: false
            };
        case 'terminate':
            return {
                ...state,
                terminated: true
            };
        case 'reset':
            return {
                discard: false,
                terminated: false,
                showAcceptReject: false
            };
        case 'show-accept-reject':
            return {
                ...state,
                showAcceptReject: true
            };
        default:
            return state;
    }
}
const $1846b76781c5e54d$export$fe5c3dd398c32c18 = (api)=>{
    const [localUI, dispatch] = (0, $42omo.useReducer)($1846b76781c5e54d$var$reducer, $1846b76781c5e54d$var$initialState);
    const pluginState = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>({
            nextSessionId: state.aiExperienceState?.aiDecorationExperiencePluginState?.nextSessionId,
            status: state.aiExperienceState?.aiSessionPluginState?.status
        }));
    const { nextSessionId: nextSessionId, status: status } = pluginState || {};
    (0, $42omo.useEffect)(()=>{
        if (localUI.terminated || !nextSessionId && !(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) dispatch({
            type: 'reset'
        });
    }, [
        nextSessionId,
        status,
        localUI.terminated,
        localUI.showAcceptReject
    ]);
    if (localUI.discard) return [
        'discard',
        dispatch
    ];
    if (!(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) return nextSessionId ? [
        'loading',
        dispatch
    ] : [
        'idle',
        dispatch
    ];
    // MIGRATED MODE
    // Ensure the loading screen stays visible throughout the session lifecycle.
    if (nextSessionId && status !== 'error') return [
        'loading',
        dispatch
    ];
    if (localUI.showAcceptReject && !nextSessionId) return [
        'acceptReject',
        dispatch
    ];
    switch(status){
        case 'prompt':
            return [
                'prompt',
                dispatch
            ];
        case 'streaming':
        case 'complete':
            return [
                'loading',
                dispatch
            ];
        case 'error':
            return [
                'error',
                dispatch
            ];
        case 'idle':
        default:
            return [
                'idle',
                dispatch
            ];
    }
};


/**
 * RenderScreen is a separate component to prevent unnecessary unmount/remount cycles.
 * Defined outside SessionUIComponent to maintain a stable component reference.
 */ function $9ec9029f4dc339f8$var$RenderScreen({ api: api, appearance: appearance, dispatch: dispatch, providerFactory: providerFactory, uiState: uiState }) {
    switch(uiState){
        case 'discard':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3af6f886d5308b08$export$31f5c3fa05bebb33), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'loading':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9392ff680475ade8$export$6ad5d8e31817f39c), {
                api: api,
                appearance: appearance,
                dispatch: dispatch,
                providerFactory: providerFactory
            });
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d30f9447f9199f71$export$d5b86f1573c0ea10), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'prompt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0a0d682dcc9d762a$export$eee2c979f2d34827), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'acceptReject':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ef7b093638b9e335$export$fe4c8e5bea1e02f4), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'idle':
            return null;
    }
}
function $9ec9029f4dc339f8$export$83a775c8cee50de8({ api: api, appearance: appearance, providerFactory: providerFactory }) {
    const [uiState, dispatch] = (0, $1846b76781c5e54d$export$fe5c3dd398c32c18)(api);
    const { canInlineStreamChanges: canInlineStreamChanges, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, editorView: editorView } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const { pluginState: pluginState } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>{
        const decorationState = state.aiExperienceState?.aiDecorationExperiencePluginState;
        return {
            pluginState: decorationState
        };
    });
    const monitorWatchmenCommands = (0, $42omo.useMemo)(()=>(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? (0, $0f4ccde48208a2ab$export$4783d4d69ea114f3)(editorView) : undefined, [
        editorView
    ]);
    const invokeAttributes = (0, $42omo.useMemo)(()=>({
            invokedFrom: pluginState?.lastTriggeredFrom,
            invokedFor: pluginState?.triggeredFor?.name ?? 'text',
            triggerMethod: pluginState?.triggerMethod,
            experienceName: pluginState?.configItem?.key,
            featureId: pluginState?.configItem?.featureId,
            aiGroupId: pluginState?.currentSessionId,
            aiSessionId: pluginState?.interactionSessionId ?? ''
        }), [
        pluginState
    ]);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$b26e0d212ef01829)({
        invokeAttributes: invokeAttributes,
        canInlineStreamChanges: canInlineStreamChanges,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled,
        onCommonAttributesUpdated: monitorWatchmenCommands?.syncCommonAttributes
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3adf5d183dded6a4$export$b8f39b5859612546), {
        value: analyticsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ec9029f4dc339f8$var$RenderScreen, {
        api: api,
        appearance: appearance,
        dispatch: dispatch,
        providerFactory: providerFactory,
        uiState: uiState
    }));
}


/* SessionUIComponentLegacy.tsx generated by @compiled/babel-plugin v0.36.1 */ 





function $89ba6b7b6ab5436d$export$83a775c8cee50de8({ api: api, providerFactory: providerFactory, appearance: appearance }) {
    const [state, dispatch] = (0, $1846b76781c5e54d$export$fe5c3dd398c32c18)(api);
    switch(state){
        case 'discard':
            return /*#__PURE__*/ $42omo.createElement((0, $3af6f886d5308b08$export$31f5c3fa05bebb33), {
                api: api,
                dispatch: dispatch,
                appearance: appearance
            });
        case 'loading':
            return /*#__PURE__*/ $42omo.createElement((0, $9392ff680475ade8$export$6ad5d8e31817f39c), {
                api: api,
                providerFactory: providerFactory,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'idle':
        default:
            return null;
    }
}


/* ContentComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $b3YrF = parcelRequire("b3YrF");


























var $i0iqW = parcelRequire("i0iqW");




var $3Ev1M = parcelRequire("3Ev1M");


var $d0N4G = parcelRequire("d0N4G");


var $cPMXw = parcelRequire("cPMXw");

parcelRequire("2gWl9");

/**
 * Asserts that the given event object is of the specified type or types. Throws
 * an error if the event object is not of the specified types.
 *
 * @example
 *
 * ```ts
 * // ...
 * entry: ({ event }) => {
 *   assertEvent(event, 'doNothing');
 *   // event is { type: 'doNothing' }
 * },
 * // ...
 * exit: ({ event }) => {
 *   assertEvent(event, 'greet');
 *   // event is { type: 'greet'; message: string }
 *
 *   assertEvent(event, ['greet', 'notify']);
 *   // event is { type: 'greet'; message: string }
 *   // or { type: 'notify'; message: string; level: 'info' | 'error' }
 * },
 * ```
 */ function $1466f8e1fdbfbe2b$export$b3e112bfd3a4f448(event, type) {
    const types = (0, $d0N4G.t)(type);
    if (!types.includes(event.type)) {
        const typesText = types.length === 1 ? `type "${types[0]}"` : `one of types "${types.join('", "')}"`;
        throw new Error(`Expected event ${JSON.stringify(event)} to have ${typesText}`);
    }
}
const $1466f8e1fdbfbe2b$var$cache = new WeakMap();
function $1466f8e1fdbfbe2b$var$memo(object, key, fn) {
    let memoizedData = $1466f8e1fdbfbe2b$var$cache.get(object);
    if (!memoizedData) {
        memoizedData = {
            [key]: fn()
        };
        $1466f8e1fdbfbe2b$var$cache.set(object, memoizedData);
    } else if (!(key in memoizedData)) memoizedData[key] = fn();
    return memoizedData[key];
}
const $1466f8e1fdbfbe2b$var$EMPTY_OBJECT = {};
const $1466f8e1fdbfbe2b$var$toSerializableAction = (action)=>{
    if (typeof action === 'string') return {
        type: action
    };
    if (typeof action === 'function') {
        if ('resolve' in action) return {
            type: action.type
        };
        return {
            type: action.name
        };
    }
    return action;
};
class $1466f8e1fdbfbe2b$export$342f24f5edd47b1 {
    /** @internal */ _initialize() {
        this.transitions = (0, $d0N4G.f)(this);
        if (this.config.always) this.always = (0, $d0N4G.a)(this.config.always).map((t)=>(0, $d0N4G.b)(this, (0, $d0N4G.N), t));
        Object.keys(this.states).forEach((key)=>{
            this.states[key]._initialize();
        });
    }
    /** The well-structured state node definition. */ get definition() {
        return {
            id: this.id,
            key: this.key,
            version: this.machine.version,
            type: this.type,
            initial: this.initial ? {
                target: this.initial.target,
                source: this,
                actions: this.initial.actions.map($1466f8e1fdbfbe2b$var$toSerializableAction),
                eventType: null,
                reenter: false,
                toJSON: ()=>({
                        target: this.initial.target.map((t)=>`#${t.id}`),
                        source: `#${this.id}`,
                        actions: this.initial.actions.map($1466f8e1fdbfbe2b$var$toSerializableAction),
                        eventType: null
                    })
            } : undefined,
            history: this.history,
            states: (0, $d0N4G.m)(this.states, (state)=>{
                return state.definition;
            }),
            on: this.on,
            transitions: [
                ...this.transitions.values()
            ].flat().map((t)=>({
                    ...t,
                    actions: t.actions.map($1466f8e1fdbfbe2b$var$toSerializableAction)
                })),
            entry: this.entry.map($1466f8e1fdbfbe2b$var$toSerializableAction),
            exit: this.exit.map($1466f8e1fdbfbe2b$var$toSerializableAction),
            meta: this.meta,
            order: this.order || -1,
            output: this.output,
            invoke: this.invoke,
            description: this.description,
            tags: this.tags
        };
    }
    /** @internal */ toJSON() {
        return this.definition;
    }
    /** The logic invoked as actors by this state node. */ get invoke() {
        return $1466f8e1fdbfbe2b$var$memo(this, 'invoke', ()=>(0, $d0N4G.t)(this.config.invoke).map((invokeConfig, i)=>{
                const { src: src, systemId: systemId } = invokeConfig;
                const resolvedId = invokeConfig.id ?? (0, $d0N4G.c)(this.id, i);
                const sourceName = typeof src === 'string' ? src : `xstate.invoke.${(0, $d0N4G.c)(this.id, i)}`;
                return {
                    ...invokeConfig,
                    src: sourceName,
                    id: resolvedId,
                    systemId: systemId,
                    toJSON () {
                        const { onDone: onDone, onError: onError, ...invokeDefValues } = invokeConfig;
                        return {
                            ...invokeDefValues,
                            type: 'xstate.invoke',
                            src: sourceName,
                            id: resolvedId
                        };
                    }
                };
            }));
    }
    /** The mapping of events to transitions. */ get on() {
        return $1466f8e1fdbfbe2b$var$memo(this, 'on', ()=>{
            const transitions = this.transitions;
            return [
                ...transitions
            ].flatMap(([descriptor, t])=>t.map((t)=>[
                        descriptor,
                        t
                    ])).reduce((map, [descriptor, transition])=>{
                map[descriptor] = map[descriptor] || [];
                map[descriptor].push(transition);
                return map;
            }, {});
        });
    }
    get after() {
        return $1466f8e1fdbfbe2b$var$memo(this, 'delayedTransitions', ()=>(0, $d0N4G.g)(this));
    }
    get initial() {
        return $1466f8e1fdbfbe2b$var$memo(this, 'initial', ()=>(0, $d0N4G.d)(this, this.config.initial));
    }
    /** @internal */ next(snapshot, event) {
        const eventType = event.type;
        const actions = [];
        let selectedTransition;
        const candidates = $1466f8e1fdbfbe2b$var$memo(this, `candidates-${eventType}`, ()=>(0, $d0N4G.h)(this, eventType));
        for (const candidate of candidates){
            const { guard: guard } = candidate;
            const resolvedContext = snapshot.context;
            let guardPassed = false;
            try {
                guardPassed = !guard || (0, $d0N4G.e)(guard, resolvedContext, event, snapshot);
            } catch (err) {
                const guardType = typeof guard === 'string' ? guard : typeof guard === 'object' ? guard.type : undefined;
                throw new Error(`Unable to evaluate guard ${guardType ? `'${guardType}' ` : ''}in transition for event '${eventType}' in state node '${this.id}':\n${err.message}`);
            }
            if (guardPassed) {
                actions.push(...candidate.actions);
                selectedTransition = candidate;
                break;
            }
        }
        return selectedTransition ? [
            selectedTransition
        ] : undefined;
    }
    /** All the event types accepted by this state node and its descendants. */ get events() {
        return $1466f8e1fdbfbe2b$var$memo(this, 'events', ()=>{
            const { states: states } = this;
            const events = new Set(this.ownEvents);
            if (states) for (const stateId of Object.keys(states)){
                const state = states[stateId];
                if (state.states) for (const event of state.events)events.add(`${event}`);
            }
            return Array.from(events);
        });
    }
    /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */ get ownEvents() {
        const events = new Set([
            ...this.transitions.keys()
        ].filter((descriptor)=>{
            return this.transitions.get(descriptor).some((transition)=>!(!transition.target && !transition.actions.length && !transition.reenter));
        }));
        return Array.from(events);
    }
    constructor(/** The raw config used to create the machine. */ config, options){
        this.config = config;
        /**
     * The relative key of the state node, which represents its location in the
     * overall state value.
     */ this.key = void 0;
        /** The unique ID of the state node. */ this.id = void 0;
        /**
     * The type of this state node:
     *
     * - `'atomic'` - no child state nodes
     * - `'compound'` - nested child state nodes (XOR)
     * - `'parallel'` - orthogonal nested child state nodes (AND)
     * - `'history'` - history state node
     * - `'final'` - final state node
     */ this.type = void 0;
        /** The string path from the root machine node to this node. */ this.path = void 0;
        /** The child state nodes. */ this.states = void 0;
        /**
     * The type of history on this state node. Can be:
     *
     * - `'shallow'` - recalls only top-level historical state value
     * - `'deep'` - recalls historical state value at all levels
     */ this.history = void 0;
        /** The action(s) to be executed upon entering the state node. */ this.entry = void 0;
        /** The action(s) to be executed upon exiting the state node. */ this.exit = void 0;
        /** The parent state node. */ this.parent = void 0;
        /** The root machine node. */ this.machine = void 0;
        /**
     * The meta data associated with this state node, which will be returned in
     * State instances.
     */ this.meta = void 0;
        /**
     * The output data sent with the "xstate.done.state._id_" event if this is a
     * final state node.
     */ this.output = void 0;
        /**
     * The order this state node appears. Corresponds to the implicit document
     * order.
     */ this.order = -1;
        this.description = void 0;
        this.tags = [];
        this.transitions = void 0;
        this.always = void 0;
        this.parent = options._parent;
        this.key = options._key;
        this.machine = options._machine;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.id = this.config.id || [
            this.machine.id,
            ...this.path
        ].join((0, $d0N4G.S));
        this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.description = this.config.description;
        this.order = this.machine.idMap.size;
        this.machine.idMap.set(this.id, this);
        this.states = this.config.states ? (0, $d0N4G.m)(this.config.states, (stateConfig, key)=>{
            const stateNode = new $1466f8e1fdbfbe2b$export$342f24f5edd47b1(stateConfig, {
                _parent: this,
                _key: key,
                _machine: this.machine
            });
            return stateNode;
        }) : $1466f8e1fdbfbe2b$var$EMPTY_OBJECT;
        if (this.type === 'compound' && !this.config.initial) throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
        // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this.entry = (0, $d0N4G.t)(this.config.entry).slice();
        this.exit = (0, $d0N4G.t)(this.config.exit).slice();
        this.meta = this.config.meta;
        this.output = this.type === 'final' || !this.parent ? this.config.output : undefined;
        this.tags = (0, $d0N4G.t)(config.tags).slice();
    }
}
const $1466f8e1fdbfbe2b$var$STATE_IDENTIFIER = '#';
class $1466f8e1fdbfbe2b$export$cbf2d83d1eab018a {
    /**
   * Clones this state machine with the provided implementations and merges the
   * `context` (if provided).
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`,
   *   `context`) to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */ provide(implementations) {
        const { actions: actions, guards: guards, actors: actors, delays: delays } = this.implementations;
        return new $1466f8e1fdbfbe2b$export$cbf2d83d1eab018a(this.config, {
            actions: {
                ...actions,
                ...implementations.actions
            },
            guards: {
                ...guards,
                ...implementations.guards
            },
            actors: {
                ...actors,
                ...implementations.actors
            },
            delays: {
                ...delays,
                ...implementations.delays
            }
        });
    }
    resolveState(config) {
        const resolvedStateValue = (0, $d0N4G.r)(this.root, config.value);
        const nodeSet = (0, $d0N4G.i)((0, $d0N4G.j)(this.root, resolvedStateValue));
        return (0, $d0N4G.k)({
            _nodes: [
                ...nodeSet
            ],
            context: config.context || {},
            children: {},
            status: (0, $d0N4G.l)(nodeSet, this.root) ? 'done' : config.status || 'active',
            output: config.output,
            error: config.error,
            historyValue: config.historyValue
        }, this);
    }
    /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */ transition(snapshot, event, actorScope) {
        return (0, $d0N4G.n)(snapshot, event, actorScope, []).snapshot;
    }
    /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */ microstep(snapshot, event, actorScope) {
        return (0, $d0N4G.n)(snapshot, event, actorScope, []).microstates;
    }
    getTransitionData(snapshot, event) {
        return (0, $d0N4G.o)(this.root, snapshot.value, snapshot, event) || [];
    }
    /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */ getPreInitialState(actorScope, initEvent, internalQueue) {
        const { context: context } = this.config;
        const preInitial = (0, $d0N4G.k)({
            context: typeof context !== 'function' && context ? context : {},
            _nodes: [
                this.root
            ],
            children: {},
            status: 'active'
        }, this);
        if (typeof context === 'function') {
            const assignment = ({ spawn: spawn, event: event, self: self })=>context({
                    spawn: spawn,
                    input: event.input,
                    self: self
                });
            return (0, $d0N4G.p)(preInitial, initEvent, actorScope, [
                (0, $cPMXw.a)(assignment)
            ], internalQueue, undefined);
        }
        return preInitial;
    }
    /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */ getInitialSnapshot(actorScope, input) {
        const initEvent = (0, $d0N4G.q)(input); // TODO: fix;
        const internalQueue = [];
        const preInitialState = this.getPreInitialState(actorScope, initEvent, internalQueue);
        const nextState = (0, $d0N4G.s)([
            {
                target: [
                    ...(0, $d0N4G.u)(this.root)
                ],
                source: this.root,
                reenter: true,
                actions: [],
                eventType: null,
                toJSON: null // TODO: fix
            }
        ], preInitialState, actorScope, initEvent, true, internalQueue);
        const { snapshot: macroState } = (0, $d0N4G.n)(nextState, initEvent, actorScope, internalQueue);
        return macroState;
    }
    start(snapshot) {
        Object.values(snapshot.children).forEach((child)=>{
            if (child.getSnapshot().status === 'active') child.start();
        });
    }
    getStateNodeById(stateId) {
        const fullPath = (0, $d0N4G.v)(stateId);
        const relativePath = fullPath.slice(1);
        const resolvedStateId = (0, $d0N4G.w)(fullPath[0]) ? fullPath[0].slice($1466f8e1fdbfbe2b$var$STATE_IDENTIFIER.length) : fullPath[0];
        const stateNode = this.idMap.get(resolvedStateId);
        if (!stateNode) throw new Error(`Child state node '#${resolvedStateId}' does not exist on machine '${this.id}'`);
        return (0, $d0N4G.x)(stateNode, relativePath);
    }
    get definition() {
        return this.root.definition;
    }
    toJSON() {
        return this.definition;
    }
    getPersistedSnapshot(snapshot, options) {
        return (0, $d0N4G.y)(snapshot, options);
    }
    restoreSnapshot(snapshot, _actorScope) {
        const children = {};
        const snapshotChildren = snapshot.children;
        Object.keys(snapshotChildren).forEach((actorId)=>{
            const actorData = snapshotChildren[actorId];
            const childState = actorData.snapshot;
            const src = actorData.src;
            const logic = typeof src === 'string' ? (0, $d0N4G.z)(this, src) : src;
            if (!logic) return;
            const actorRef = (0, $d0N4G.A)(logic, {
                id: actorId,
                parent: _actorScope.self,
                syncSnapshot: actorData.syncSnapshot,
                snapshot: childState,
                src: src,
                systemId: actorData.systemId
            });
            children[actorId] = actorRef;
        });
        const restoredSnapshot = (0, $d0N4G.k)({
            ...snapshot,
            children: children,
            _nodes: Array.from((0, $d0N4G.i)((0, $d0N4G.j)(this.root, snapshot.value)))
        }, this);
        const seen = new Set();
        function reviveContext(contextPart, children) {
            if (seen.has(contextPart)) return;
            seen.add(contextPart);
            for(const key in contextPart){
                const value = contextPart[key];
                if (value && typeof value === 'object') {
                    if ('xstate$$type' in value && value.xstate$$type === (0, $d0N4G.$)) {
                        contextPart[key] = children[value.id];
                        continue;
                    }
                    reviveContext(value, children);
                }
            }
        }
        reviveContext(restoredSnapshot.context, children);
        return restoredSnapshot;
    }
    constructor(/** The raw config used to create the machine. */ config, implementations){
        this.config = config;
        /** The machine's own version. */ this.version = void 0;
        this.schemas = void 0;
        this.implementations = void 0;
        /** @internal */ this.__xstatenode = true;
        /** @internal */ this.idMap = new Map();
        this.root = void 0;
        this.id = void 0;
        this.states = void 0;
        this.events = void 0;
        this.id = config.id || '(machine)';
        this.implementations = {
            actors: implementations?.actors ?? {},
            actions: implementations?.actions ?? {},
            delays: implementations?.delays ?? {},
            guards: implementations?.guards ?? {}
        };
        this.version = this.config.version;
        this.schemas = this.config.schemas;
        this.transition = this.transition.bind(this);
        this.getInitialSnapshot = this.getInitialSnapshot.bind(this);
        this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this);
        this.restoreSnapshot = this.restoreSnapshot.bind(this);
        this.start = this.start.bind(this);
        this.root = new $1466f8e1fdbfbe2b$export$342f24f5edd47b1(config, {
            _key: this.id,
            _machine: this
        });
        this.root._initialize();
        this.states = this.root.states; // TODO: remove!
        this.events = this.root.events;
    }
}
/**
 * Creates a state machine (statechart) with the given configuration.
 *
 * The state machine represents the pure logic of a state machine actor.
 *
 * @example
 *
 * ```ts
 * import { createMachine } from 'xstate';
 *
 * const lightMachine = createMachine({
 *   id: 'light',
 *   initial: 'green',
 *   states: {
 *     green: {
 *       on: {
 *         TIMER: { target: 'yellow' }
 *       }
 *     },
 *     yellow: {
 *       on: {
 *         TIMER: { target: 'red' }
 *       }
 *     },
 *     red: {
 *       on: {
 *         TIMER: { target: 'green' }
 *       }
 *     }
 *   }
 * });
 *
 * const lightActor = createActor(lightMachine);
 * lightActor.start();
 *
 * lightActor.send({ type: 'TIMER' });
 * ```
 *
 * @param config The state machine configuration.
 * @param options DEPRECATED: use `setup({ ... })` or `machine.provide({ ... })`
 *   to provide machine implementations instead.
 */ function $1466f8e1fdbfbe2b$export$aaa7fa18f8e9b2e8(config, implementations) {
    return new $1466f8e1fdbfbe2b$export$cbf2d83d1eab018a(config, implementations);
}
/** @internal */ function $1466f8e1fdbfbe2b$var$createInertActorScope(actorLogic) {
    const self = (0, $d0N4G.A)(actorLogic);
    const inertActorScope = {
        self: self,
        defer: ()=>{},
        id: '',
        logger: ()=>{},
        sessionId: '',
        stopChild: ()=>{},
        system: self.system,
        emit: ()=>{},
        actionExecutor: ()=>{}
    };
    return inertActorScope;
}
/** @deprecated Use `initialTransition(…)` instead. */ function $1466f8e1fdbfbe2b$export$e1c3f9a97f5088ae(actorLogic, ...[input]) {
    const actorScope = $1466f8e1fdbfbe2b$var$createInertActorScope(actorLogic);
    return actorLogic.getInitialSnapshot(actorScope, input);
}
/**
 * Determines the next snapshot for the given `actorLogic` based on the given
 * `snapshot` and `event`.
 *
 * If the `snapshot` is `undefined`, the initial snapshot of the `actorLogic` is
 * used.
 *
 * @deprecated Use `transition(…)` instead.
 * @example
 *
 * ```ts
 * import { getNextSnapshot } from 'xstate';
 * import { trafficLightMachine } from './trafficLightMachine.ts';
 *
 * const nextSnapshot = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   undefined, // snapshot (or initial state if undefined)
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot.value);
 * // => 'yellow'
 *
 * const nextSnapshot2 = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   nextSnapshot, // snapshot
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot2.value);
 * // =>'red'
 * ```
 */ function $1466f8e1fdbfbe2b$export$3629c64713e6dfd7(actorLogic, snapshot, event) {
    const inertActorScope = $1466f8e1fdbfbe2b$var$createInertActorScope(actorLogic);
    inertActorScope.self._snapshot = snapshot;
    return actorLogic.transition(snapshot, event, inertActorScope);
}
// at the moment we allow extra actors - ones that are not specified by `children`
// this could be reconsidered in the future
function $1466f8e1fdbfbe2b$export$de27182ff8187d6c({ schemas: schemas, actors: actors, actions: actions, guards: guards, delays: delays }) {
    return {
        createMachine: (config)=>$1466f8e1fdbfbe2b$export$aaa7fa18f8e9b2e8({
                ...config,
                schemas: schemas
            }, {
                actors: actors,
                actions: actions,
                guards: guards,
                delays: delays
            })
    };
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class $1466f8e1fdbfbe2b$export$7413adad607e2cdf {
    now() {
        return this._now;
    }
    getId() {
        return this._id++;
    }
    setTimeout(fn, timeout) {
        this._flushingInvalidated = this._flushing;
        const id = this.getId();
        this.timeouts.set(id, {
            start: this.now(),
            timeout: timeout,
            fn: fn
        });
        return id;
    }
    clearTimeout(id) {
        this._flushingInvalidated = this._flushing;
        this.timeouts.delete(id);
    }
    set(time) {
        if (this._now > time) throw new Error('Unable to travel back in time');
        this._now = time;
        this.flushTimeouts();
    }
    flushTimeouts() {
        if (this._flushing) {
            this._flushingInvalidated = true;
            return;
        }
        this._flushing = true;
        const sorted = [
            ...this.timeouts
        ].sort(([_idA, timeoutA], [_idB, timeoutB])=>{
            const endA = timeoutA.start + timeoutA.timeout;
            const endB = timeoutB.start + timeoutB.timeout;
            return endB > endA ? -1 : 1;
        });
        for (const [id, timeout] of sorted){
            if (this._flushingInvalidated) {
                this._flushingInvalidated = false;
                this._flushing = false;
                this.flushTimeouts();
                return;
            }
            if (this.now() - timeout.start >= timeout.timeout) {
                this.timeouts.delete(id);
                timeout.fn.call(null);
            }
        }
        this._flushing = false;
    }
    increment(ms) {
        this._now += ms;
        this.flushTimeouts();
    }
    constructor(){
        this.timeouts = new Map();
        this._now = 0;
        this._id = 0;
        this._flushing = false;
        this._flushingInvalidated = false;
    }
}
/**
 * Returns a promise that resolves to the `output` of the actor when it is done.
 *
 * @example
 *
 * ```ts
 * const machine = createMachine({
 *   // ...
 *   output: {
 *     count: 42
 *   }
 * });
 *
 * const actor = createActor(machine);
 *
 * actor.start();
 *
 * const output = await toPromise(actor);
 *
 * console.log(output);
 * // logs { count: 42 }
 * ```
 */ function $1466f8e1fdbfbe2b$export$4dbaaf6c79705e6c(actor) {
    return new Promise((resolve, reject)=>{
        actor.subscribe({
            complete: ()=>{
                resolve(actor.getSnapshot().output);
            },
            error: reject
        });
    });
}
/**
 * Given actor `logic`, a `snapshot`, and an `event`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute.
 *
 * This is a pure function that does not execute `actions`.
 */ function $1466f8e1fdbfbe2b$export$66bb15e2994e6a26(logic, snapshot, event) {
    const executableActions = [];
    const actorScope = $1466f8e1fdbfbe2b$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.transition(snapshot, event, actorScope);
    return [
        nextSnapshot,
        executableActions
    ];
}
/**
 * Given actor `logic` and optional `input`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute from the initial transition (no
 * previous state).
 *
 * This is a pure function that does not execute `actions`.
 */ function $1466f8e1fdbfbe2b$export$5f4d25c77127242(logic, ...[input]) {
    const executableActions = [];
    const actorScope = $1466f8e1fdbfbe2b$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.getInitialSnapshot(actorScope, input);
    return [
        nextSnapshot,
        executableActions
    ];
}
const $1466f8e1fdbfbe2b$var$defaultWaitForOptions = {
    timeout: Infinity // much more than 10 seconds
};
/**
 * Subscribes to an actor ref and waits for its emitted value to satisfy a
 * predicate, and then resolves with that value. Will throw if the desired state
 * is not reached after an optional timeout. (defaults to Infinity).
 *
 * @example
 *
 * ```js
 * const state = await waitFor(someService, (state) => {
 *   return state.hasTag('loaded');
 * });
 *
 * state.hasTag('loaded'); // true
 * ```
 *
 * @param actorRef The actor ref to subscribe to
 * @param predicate Determines if a value matches the condition to wait for
 * @param options
 * @returns A promise that eventually resolves to the emitted value that matches
 *   the condition
 */ function $1466f8e1fdbfbe2b$export$9bbfceb27f687c1b(actorRef, predicate, options) {
    const resolvedOptions = {
        ...$1466f8e1fdbfbe2b$var$defaultWaitForOptions,
        ...options
    };
    return new Promise((res, rej)=>{
        const { signal: signal } = resolvedOptions;
        if (signal?.aborted) {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            rej(signal.reason);
            return;
        }
        let done = false;
        const handle = resolvedOptions.timeout === Infinity ? undefined : setTimeout(()=>{
            dispose();
            rej(new Error(`Timeout of ${resolvedOptions.timeout} ms exceeded`));
        }, resolvedOptions.timeout);
        const dispose = ()=>{
            clearTimeout(handle);
            done = true;
            sub?.unsubscribe();
            if (abortListener) signal.removeEventListener('abort', abortListener);
        };
        function checkEmitted(emitted) {
            if (predicate(emitted)) {
                dispose();
                res(emitted);
            }
        }
        /**
     * If the `signal` option is provided, this will be the listener for its
     * `abort` event
     */ let abortListener;
        // eslint-disable-next-line prefer-const
        let sub; // avoid TDZ when disposing synchronously
        // See if the current snapshot already matches the predicate
        checkEmitted(actorRef.getSnapshot());
        if (done) return;
        // only define the `abortListener` if the `signal` option is provided
        if (signal) {
            abortListener = ()=>{
                dispose();
                // XState does not "own" the signal, so we should reject with its reason (if any)
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(signal.reason);
            };
            signal.addEventListener('abort', abortListener);
        }
        sub = actorRef.subscribe({
            next: checkEmitted,
            error: (err)=>{
                dispose();
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(err);
            },
            complete: ()=>{
                dispose();
                rej(new Error(`Actor terminated without satisfying predicate`));
            }
        });
        if (done) sub.unsubscribe();
    });
}





var $hpRUx = parcelRequire("hpRUx");


var $hxT4C = parcelRequire("hxT4C");

const $389f150a524de0cc$var$forEachActor = (actorRef, callback)=>{
    callback(actorRef);
    const children = actorRef.getSnapshot().children;
    if (children) Object.values(children).forEach((child)=>{
        $389f150a524de0cc$var$forEachActor(child, callback);
    });
};
function $389f150a524de0cc$var$stopRootWithRehydration(actorRef) {
    // persist snapshot here in a custom way allows us to persist inline actors and to preserve actor references
    // we do it to avoid setState in useEffect when the effect gets "reconnected"
    // this currently only happens in Strict Effects but it simulates the Offscreen aka Activity API
    // it also just allows us to end up with a somewhat more predictable behavior for the users
    const persistedSnapshots = [];
    $389f150a524de0cc$var$forEachActor(actorRef, (ref)=>{
        persistedSnapshots.push([
            ref,
            ref.getSnapshot()
        ]);
        // muting observers allow us to avoid `useSelector` from being notified about the stopped snapshot
        // React reconnects its subscribers (from the useSyncExternalStore) on its own
        // and userland subscibers should basically always do the same anyway
        // as each subscription should have its own cleanup logic and that should be called each such reconnect
        ref.observers = new Set();
    });
    const systemSnapshot = actorRef.system.getSnapshot?.();
    actorRef.stop();
    actorRef.system._snapshot = systemSnapshot;
    persistedSnapshots.forEach(([ref, snapshot])=>{
        ref._processingStatus = 0;
        ref._snapshot = snapshot;
    });
}
function $389f150a524de0cc$var$useIdleActorRef(logic, ...[options]) {
    let [[currentConfig, actorRef], setCurrent] = (0, $42omo.useState)(()=>{
        const actorRef = (0, $d0N4G.A)(logic, options);
        return [
            logic.config,
            actorRef
        ];
    });
    if (logic.config !== currentConfig) {
        const newActorRef = (0, $d0N4G.A)(logic, {
            ...options,
            snapshot: actorRef.getPersistedSnapshot({
                __unsafeAllowInlineActors: true
            })
        });
        setCurrent([
            logic.config,
            newActorRef
        ]);
        actorRef = newActorRef;
    }
    // TODO: consider using `useAsapEffect` that would do this in `useInsertionEffect` is that's available
    (0, $i0iqW.default)(()=>{
        actorRef.logic.implementations = logic.implementations;
    });
    return actorRef;
}
function $389f150a524de0cc$export$e92bd910f9c89ff6(machine, ...[options, observerOrListener]) {
    const actorRef = $389f150a524de0cc$var$useIdleActorRef(machine, options);
    (0, $42omo.useEffect)(()=>{
        if (!observerOrListener) return;
        const sub = actorRef.subscribe((0, $d0N4G.L)(observerOrListener));
        return ()=>{
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $42omo.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $389f150a524de0cc$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return actorRef;
}
function $389f150a524de0cc$var$defaultCompare(a, b) {
    return a === b;
}
function $389f150a524de0cc$export$2105062e25df4afe(actor, selector, compare = $389f150a524de0cc$var$defaultCompare) {
    const subscribe = (0, $42omo.useCallback)((handleStoreChange)=>{
        if (!actor) return ()=>{};
        const { unsubscribe: unsubscribe } = actor.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actor
    ]);
    const boundGetSnapshot = (0, $42omo.useCallback)(()=>actor?.getSnapshot(), [
        actor
    ]);
    const selectedSnapshot = (0, $hpRUx.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}
function $389f150a524de0cc$export$72ba36f8308928ab(actorLogic, actorOptions) {
    const ReactContext = /*#__PURE__*/ $42omo.createContext(null);
    const OriginalProvider = ReactContext.Provider;
    function Provider({ children: children, logic: providedLogic = actorLogic, machine: machine, options: providedOptions }) {
        if (machine) throw new Error(`The "machine" prop has been deprecated. Please use "logic" instead.`);
        const actor = $389f150a524de0cc$export$e92bd910f9c89ff6(providedLogic, {
            ...actorOptions,
            ...providedOptions
        });
        return /*#__PURE__*/ $42omo.createElement(OriginalProvider, {
            value: actor,
            children: children
        });
    }
    // TODO: add properties to actor ref to make more descriptive
    Provider.displayName = `ActorProvider`;
    function useContext() {
        const actor = $42omo.useContext(ReactContext);
        if (!actor) throw new Error(`You used a hook from "${Provider.displayName}" but it's not inside a <${Provider.displayName}> component.`);
        return actor;
    }
    function useSelector$1(selector, compare) {
        const actor = useContext();
        return $389f150a524de0cc$export$2105062e25df4afe(actor, selector, compare);
    }
    return {
        Provider: Provider,
        useActorRef: useContext,
        useSelector: useSelector$1
    };
}
// From https://github.com/reduxjs/react-redux/blob/720f0ba79236cdc3e1115f4ef9a7760a21784b48/src/utils/shallowEqual.ts
function $389f150a524de0cc$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $389f150a524de0cc$export$d36bdfa510afb180(objA, objB) {
    if ($389f150a524de0cc$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$389f150a524de0cc$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $389f150a524de0cc$export$25c4ab29592aabd9(logic, ...[options]) {
    const actorRef = $389f150a524de0cc$var$useIdleActorRef(logic, options);
    const getSnapshot = (0, $42omo.useCallback)(()=>{
        return actorRef.getSnapshot();
    }, [
        actorRef
    ]);
    const subscribe = (0, $42omo.useCallback)((handleStoreChange)=>{
        const { unsubscribe: unsubscribe } = actorRef.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actorRef
    ]);
    const actorSnapshot = (0, $hxT4C.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $42omo.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $389f150a524de0cc$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return [
        actorSnapshot,
        actorRef.send,
        actorRef
    ];
}
/** @alias useActor */ function $389f150a524de0cc$export$e0338c4153421160(machine, ...[options]) {
    return $389f150a524de0cc$export$25c4ab29592aabd9(machine, options);
}















// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead



const $a967555a2593cb3a$export$4d16f4ec9dad8b6b = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};




class $ad147db5e816cb37$export$645455f759ffd2a2 extends WeakMap {
    getActor(editorView) {
        if (this.has(editorView)) return this.get(editorView);
        return null;
    }
    setActor(editorView, actorRef) {
        this.set(editorView, actorRef);
    }
}


const $fb64f67e895c15d9$export$a6342417f9492df1 = new (0, $ad147db5e816cb37$export$645455f759ffd2a2)();
// Resets to clean context - all optional properties are ensured to reset via typescript
// Remaining required properties will be reset via `initialise context`.
const $fb64f67e895c15d9$var$initialContext = {
    analyticsContext: {
        aiSessionId: '',
        aiGroupId: ''
    },
    positions: [
        0,
        0
    ],
    isEmpty: true,
    selectionType: 'empty',
    markdown: '',
    adfResponse: undefined,
    latestPromptResponse: undefined,
    editCount: 0,
    refinementCount: 0,
    retryPromptCount: 0,
    latestPromptRetried: false,
    userInput: '',
    apiErrorInfo: {},
    responseHistory: {
        positionFromEnd: 0,
        entries: [],
        totalSize: 0,
        traversals: 0
    },
    channelId: undefined,
    usePageKnowledge: true,
    baseGenerate: undefined,
    userADFInput: undefined,
    parentPresetPromptLabel: undefined,
    latestPrompt: undefined,
    promptTrigger: undefined,
    idMap: undefined,
    contextStatistics: undefined,
    loadingStatus: undefined,
    rovoActions: undefined,
    previousAgentId: undefined,
    getMentionNameDetails: undefined,
    onceDiscard: undefined,
    triggeredFor: undefined,
    aiLifeCycleDynamicAttributesGetter: undefined,
    feedbackSubmitted: undefined,
    streamingHandler: undefined,
    traceIds: undefined,
    selectionMetaData: undefined,
    adfResponseNodeWrappers: undefined
};
function $fb64f67e895c15d9$export$d89ac572d9ca416a(options) {
    const machine = (0, $1466f8e1fdbfbe2b$export$aaa7fa18f8e9b2e8)({
        /** @xstate-layout N4IgpgJg5mDOIC5QEECSACAogDwA5gCcBLMAOwGMx0BZAQ3IAsjSwBiAV1wloBcrcA9rCI8iA0rADaABgC6iUIOGjxCkNkQBGAMwA2ABwA6abukB2TZv37tAVgBMmgCwAaEAE8t2w-oCcm+207bXtA-199AF9ItzQsPEISCio6RmYwQ1geWgI+CHQs3jYAayJyYvQBADMqmXkkECURMVI1DQRNM0cfWxsQ7U1bXVsBt08EEOljMzNbX10nW1mh+ydo2IwcfGIyShp6JhZM7NzIAuy+VlLyyprJTXrFIWbVBvbLeyn7Je1pc1NpJYxohJsZ9E5fNJwU5Zk5dNp1iA4ltErsUgd0oYALYCbgAG3Q9FEADcqIVLnByLR8HU1E0VK03oh7L4LIZnGYbPpHE4WfYzMCEL1fIZTCM5mYQty4YjkQkdsl9mkjjj8YTyCSyRc2FkBAQwABhcR8bA8ADKFyIWTKUjkdOeDLaIPsunshhCFjMul8TmkoRmgpdIrhei6phZcN8ss28qSe1ShwyqtoBKJRFJ5yKHC4RUJMFIPFtj0aDpaToQLMB7K9cOk2iccICge9hhD3u0kIc+jmaxiSJj2zj6OVSdxKfVmszfEMYFjaMMeIEtAgzCgU7Y5AEWNweLAfFpDXpZaZHV0XXdzgbZ6G4N82kFASh7pm-P0XQCQQRfblg7RSsT2JjqmGrplqRQznOyQLkuK6kGu5JsOwpDFKQAgAO6kOgVS0EQeIHk8yjHqA7SrMMhhepCThvjCLq2A+vy2D4DYRJ8VFeqs0bxL+ioJpiybAZOCEQdxlDQcuq7rqwsC0FiVBUowVDFGA7j4SWhGvMRXh2KKzjXiYHp6IKb6aIYthONokpnto3JhpxKIKvGGIqkBE6geuwmolBi7iXB7nebBUBSTw+oyapR4aeoWjgt4LoQqEQzer4-JGb4IpWAYUrUb6X4bFxnmOSOgFqmmGZCbOIkZP5ElCVVcHZtwfDoIwtCkCweKoBAYWlhF7zzCKUL6Jo5i2FYfqSoKVnkfW5hvt60hDDl-Z5Q5w4AfxrmldqHkrWJAV+TBq71bmRAQHQuBdepjKaRWYQ+AN9jgn6gKckZZhOMYDjSD6VhJSNi0-vlq18S5JVgdO5WA7t1VbbVgXUkQWE4XhdqHt1V2RRWQSMYNb6Qh2SV3g+UImboBiQgTrodnZkEFWtIMgZt4EQztsP7T5gUELmeJEFiIiQBdLzoyRTiaLohguvouiWBZwzsSlRhDPMnwmA2MK6NTFX-sDxUM2DGTM0OUO+TVB11TwAhKZh3O8zwiO4QLjonqEVYi-yb2SssvgPqRrZnpYPqct8ksa4DWvOTrglbQb86syb7OsMwuDsLb5sCAUDB6rb2H2yjBGC+Wnz+KKrrmZKA1wg+vJi+Tvgjd8IyDCHK1h6OEduWVNOVab8Ew93rBMLgtC0E1xpkFnSMO0RGNhGLb4mMTwwNvYD6aJChj+H4X0spTUbfgOoe8eH46g+50ded3bMBawyAAKoAAroMSYh4rwLToBAe5gBq-O52p+cnqvKid1vSdF5CGRYK9zyDG7INWw5hPhmCbkOFuRVj661Pp3I2PdwKw1YPqWAggJBUFTgUHmuEciTx6lFZw4teS-Asg4RYy8PBeBbPNKWiwQGb3sEgv8h9W5oMjkzTBsctrwztrufICFWDiP1MFFSv9wpC2ZJ9VsgcFidFASYImQRRSzF+tyEYoR-r72bvw1BAl25RxERfISnNGrWxEBtNg2AhK0CqHwAgAAKAASpgAAKj4gAmgAfWQAAGXCQAeQAOqYAACIAEpr6mOQeY9aJ8O4VSwe5exVBHG21BpQ5RFZXRTFdLCBYI0FjmCMqYdeZ4vrsVZBEXeuV7JpKcgIyxjNwY2PZrkrmZDbbMFBjI3ACM5EEAUcWJRBcvqMXmhZMwfoDDemYeMN6wYAgskls4Pwg1eE8S6RY5xGDsn6ifmANCklmCeIIAIKARRinlg5EYQEtd4Si1sL0UYLCOh1m8A4EIqVFhfX8Ec2m2tBFWOERcsAVybnSKQihdCmFs7I1mWjAucJ3oL1+SNPwugHwjCMIEfQX0IS9Elo4SFQMj49L1ttQ2lySBIu1Hgvc0z0C4AeduHgLynZUTdJ8VeKsqILIfG9MW3xpB0PMsMQY6s97LU6YVDJ6CsmQ1ZdcySkAnG8q3LgAVijsUnhGiZbsKyYSpTMr8L2-yEo+ApWeB6NEAi2DpSgjVQi+nwsRe5XlCK2VBRyLbfUVR0iyQLIK66Sq3T2tAaTOYHqHykzdCs1pP0-htKWh0vhJyfWwr9dq4Nuq7FgEjSwaNPBWCUmpGAWNGMlUimlJyeEb16yaAfMZd0DZrBK1CL6T1Kr83HPVfTX1+tME6vZeBCNUax6sCpMkAkC7q1jybe8H5jEQGsmcF9VZUrfjkW9MKeEvpRaINHZ3b1k7i3Tv9Wy3JlbF0FiOo1dgsBCDoETsnLdUUIhMTfBSn5MwDBprmOvP6z0paryiDezW6T729MfaWgNFaq1gBrR+qgX6f1-sKRAWoprLrzJFsXT5kohidDelKgwpkIwui9P7BD7Tb3Ibbqh5l85NxYixC1fIg9dw8EatI64xRqhVHQGhEQDAR78cEzylMe5GqEYAx0LGaiOwHLMKyCD-zErsh+R2GYNgQyaC9ZxmF3Gz6iT4wJ0gQmVOib1rhkeBZZwmqxWRk88IRX+09IS0w95-ktNFPNMBFL5gQjY3mjjhaUNMrsxkBzSnhOqbcyuygmL7S+bjQNRjnJ-C9F5KsImNDuykoiKNIIuaAZmMS1x5LmC0tOeUyJsTHLstgDwg8PL-8406EYj8nQo0-R3gcIGJpopHAfBFnoUIVmms2aZSuWAVICAQEMKM3WdbSC0AAEa7nflaTbnVSODYxiEb4PhHyuwbAlabrJZuWACAt10PDEMHxW4y9y63zuGDGeto7J2Ac5Auz5q77QBjzXZP6QY8xnBJQfHebwUIzyLA7A2AI172NId+2coS4OttA72-Wmkl3HbXQGLoq1OgIgGF9PoabLoLy7LMo4Osu8+yoQ-vABoDW1WJgG9T67Z4ejWr07XcyX0e0mXmHoH5qzaezGW4VQopwpHalF1PEiuzjABFMGUmwQxXD-IGCKWYD1TC+kcJKOLQuC0Tua+uXXVCEAi2xksOV0u7Vy4t9ZcWXbWIPSsDLdXdNXdapWu7kpIZJe+9tbLh14xeSMUlCLIaehggQu+41l3q3zmQ1EUUOPry9OMViklb4pNUrJUdToYPvpbUWUi5H6Ff2Y+G1L9OWG5enbDfZJjmw3yl6CkZ+RPTdZBq+ldNyDvDKifWOyb3jI4iMVnAQgP669cRVUR9FLQOoXxhDW5ORawXYatmRGov7py+4Ul9sVtPJ6ACnOJ39PC9d3vSShr2VifFkUUO8MUEuCwbsO-U5TJFfJ-AZOxIZG2X9A7XWT-EicMVsL6fZZwP6DZRAL0KYCEOKBYW3bsSzfPYXTvB-EtHaWdN3VGfLZtesDPX4VeMpYYaiElc8RYMbKwIOKuSAotWzGdMtOdacINRFVArwO8KaD5Ng3oOjf5ToepWYXSbsGpV1AQpLYvGgkQl9LDGtSQjoaLd0BYXGNQ2jc3U-L0MwcWf0O8CwZNPHeLAnQvLvGAnaTfCAQw1YaQyUayCEQYPTeEOiRQ8ybwbPD1fweBEdfHH7VwqgtDHaNrZzTrPWQwroGw34DKUmefIYAUQzUmZ1PoPwBwM8PTTQ6PLaEnLw+g6HZkWuIwH0PZXSHwoIHtRYUySWZYRYTsSUCoovYnM7CHHbZAzUQwqURZXkO8XHLeUWabVecWdZEYJKOEF0fotw8CaosnMY2osXGHP4auKiODVYiENo-5UVEUIMZHLIuEXoaIaIIAA */ id: 'AI Experience Machine',
        initial: 'started state',
        types: {
            context: {},
            events: {}
        },
        states: {
            'started state': {
                on: {
                    'kick off': [
                        {
                            target: 'modal active state.experience.error state.active',
                            guard: 'no textual content but prompt requires it',
                            actions: [
                                'updateFailureContextForNoTextualContent'
                            ]
                        },
                        {
                            target: 'modal active state.experience.loading state',
                            guard: 'neither base generate nor custom prompt'
                        },
                        '#AI Experience Machine.modal active state.experience.command palette state'
                    ],
                    'initialise context': {
                        actions: [
                            'initialiseContext'
                        ]
                    }
                }
            },
            'modal active state': {
                type: 'parallel',
                initial: 'experience',
                on: {
                    escape: {
                        target: '#AI Experience Machine.modal active state.discard.active'
                    },
                    storeContextStatistics: {
                        actions: 'storeContextStatistics'
                    }
                },
                states: {
                    experience: {
                        initial: 'command palette state',
                        states: {
                            'loading state': {
                                on: {
                                    complete: {
                                        target: 'review state',
                                        actions: [
                                            'pushToHistory',
                                            'updateMarkdown',
                                            'updateADFResponse',
                                            'clearUserInput',
                                            'updateRovoActions'
                                        ]
                                    },
                                    error: {
                                        target: '#error state.active'
                                    },
                                    'same cache key': {
                                        target: 'review state',
                                        actions: [
                                            'restoreResponseFromHistory',
                                            'clearUserInput'
                                        ]
                                    }
                                },
                                states: {
                                    loading: {
                                        invoke: {
                                            src: (0, $3Ev1M.fromCallback)(({ input: context, sendBack: sendBack })=>{
                                                if (context.configItem.key !== (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC && context.streamingHandler) context.streamingHandler(context, sendBack);
                                            }),
                                            input: ({ context: context })=>context
                                        },
                                        on: {
                                            stream: {
                                                target: 'loading',
                                                actions: [
                                                    'updateMarkdown',
                                                    'updateADFResponse',
                                                    'updateLoadingStatus'
                                                ]
                                            },
                                            'update idMap': {
                                                target: 'loading',
                                                actions: 'updateIdMap'
                                            },
                                            'update traceIds': {
                                                target: 'loading',
                                                actions: 'updateTraceIds'
                                            },
                                            error: {
                                                target: '#error state.active'
                                            },
                                            'response too similar': {
                                                target: '#AI Experience Machine.modal active state.experience.review state',
                                                actions: [
                                                    'pushToHistory',
                                                    'clearUserInput',
                                                    'updateADFResponse'
                                                ]
                                            },
                                            'update selectionMetaData': {
                                                target: 'loading',
                                                actions: 'updateSelectionMetaData'
                                            },
                                            'update adfResponseNodeWrappers': {
                                                target: 'loading',
                                                actions: 'updateAdfResponseNodeWrappers'
                                            },
                                            'retry on adf stream errors': {
                                                target: 'loading',
                                                actions: 'retryOnAdfStreamErrors'
                                            }
                                        }
                                    }
                                },
                                initial: 'loading',
                                entry: [
                                    'setLatestPrompt',
                                    'updateChannelId'
                                ],
                                exit: 'clearLoadingStatus'
                            },
                            'review state': {
                                on: {
                                    interrogate: {
                                        target: 'loading state',
                                        actions: [
                                            'clearFromHistory',
                                            'updatePromptContextBasedOnTrigger',
                                            'interrogate'
                                        ]
                                    },
                                    refine: {
                                        target: 'loading state',
                                        actions: [
                                            'clearFromHistory',
                                            'updatePromptContextBasedOnTrigger',
                                            'incrementRefinementCount',
                                            'refine'
                                        ]
                                    },
                                    error: {
                                        target: '#error state.active'
                                    },
                                    'retry prompt': {
                                        target: 'loading state',
                                        actions: [
                                            'updatePromptContextBasedOnTrigger',
                                            'updateUserInput',
                                            'updateUserInputADF',
                                            'clearMarkdown',
                                            'incrementRetryPromptCount',
                                            'clearFromHistory'
                                        ]
                                    },
                                    'edit prompt': {
                                        target: 'command palette state',
                                        actions: [
                                            'editPrompt',
                                            'clearFromHistory'
                                        ]
                                    },
                                    'feedback submitted': {
                                        target: 'review state',
                                        actions: [
                                            'feedbackSubmitted'
                                        ]
                                    }
                                },
                                states: {
                                    preview: {
                                        on: {
                                            'start refinement': 'refinement'
                                        }
                                    },
                                    refinement: {
                                        on: {
                                            'cancel refinement': {
                                                target: '#AI Experience Machine.modal active state.discard.active',
                                                actions: [
                                                    'clearUserInput',
                                                    'clearFocus'
                                                ]
                                            },
                                            'update user input': {
                                                actions: 'updateUserInput'
                                            },
                                            'update user input adf': {
                                                actions: 'updateUserInputADF'
                                            }
                                        }
                                    }
                                },
                                initial: 'preview'
                            },
                            'command palette state': {
                                on: {
                                    'kickoff with command palette input': [
                                        {
                                            target: 'error state.active',
                                            guard: 'no textual content but prompt requires it',
                                            actions: [
                                                'updateFailureContextForNoTextualContent'
                                            ]
                                        },
                                        {
                                            target: 'loading state',
                                            actions: [
                                                'updatePromptContextBasedOnTrigger',
                                                'updateContext',
                                                'resetRefinementCount'
                                            ]
                                        }
                                    ],
                                    'update context': {
                                        target: 'command palette state',
                                        actions: [
                                            'updateContext'
                                        ],
                                        description: `This must be called before 'cancel' transition to make sure the context is updated before the 'if command input is empty' guard is evaluated.`
                                    },
                                    'toggle use page knowledge': {
                                        target: 'command palette state',
                                        actions: 'toggleUsePageKnowledge'
                                    },
                                    'update baseGenerate and configItem': {
                                        target: 'command palette state',
                                        actions: [
                                            'updateBaseGenerateAndConfigItem'
                                        ],
                                        description: `This must be called when agents are loaded and default baseGenerate and configItem needs to be reset`
                                    }
                                },
                                description: `This state creates a nested state machine that handles all the state of the command palette.

  It needs to know the 'userInput', 'baseGenerate' and 'configItem' from the AI Experience State Machine.

  Whenever we exit this state we need to update the AI Experience State Machine's context with the 'updateContext' action.`
                            },
                            //To avoid having to handle errors in every state, all errors are handled here.
                            // All error events are 'error' type with the errorInfo object containing further details.
                            // The experience application will handle the error and display the appropriate error message
                            //based on what has been stored in context on entry to the error state.
                            'error state': {
                                id: 'error state',
                                initial: 'inactive',
                                states: {
                                    inactive: {},
                                    active: {
                                        entry: [
                                            'updateContext',
                                            'storeFailureContext',
                                            'clearLoadingStatus'
                                        ],
                                        exit: [
                                            'clearFailureContext'
                                        ],
                                        on: {
                                            retry: {
                                                target: '#AI Experience Machine.modal active state.experience.loading state.loading'
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    discard: {
                        initial: 'inactive',
                        states: {
                            inactive: {
                                on: {
                                    'enable discard': {
                                        target: 'active',
                                        actions: 'updateContext'
                                    }
                                }
                            },
                            active: {
                                on: {
                                    'disable discard': {
                                        target: 'inactive',
                                        actions: 'updateContext'
                                    },
                                    escape: 'inactive'
                                }
                            }
                        }
                    }
                }
            }
        },
        context: options.context,
        on: {
            'update positions': {
                actions: 'updatePositions'
            },
            reset: {
                target: '.started state',
                actions: 'resetContext'
            }
        }
    }, {
        actions: {
            updatePositions: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'update positions') return {};
                const isEmpty = event.positions[0] === event.positions[1];
                const selectionType = isEmpty ? 'empty' : 'range';
                return {
                    positions: event.positions,
                    isEmpty: isEmpty,
                    selectionType: selectionType
                };
            }),
            resetContext: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'reset') return {};
                // Reset to initial context
                return $fb64f67e895c15d9$var$initialContext;
            }),
            initialiseContext: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'initialise context') return {};
                // Initialise
                return event.context;
            }),
            storeFailureContext: (0, $cPMXw.a)(({ event: event })=>{
                if ([
                    'error'
                ].includes(event.type) && 'errorInfo' in event) return {
                    apiErrorInfo: event.errorInfo
                };
                return {};
            }),
            updateFailureContextForNoTextualContent: (0, $cPMXw.a)(()=>{
                return {
                    apiErrorInfo: {
                        failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).NO_TEXTUAL_CONTENT
                    }
                };
            }),
            clearFailureContext: (0, $cPMXw.a)(()=>{
                return {
                    apiErrorInfo: {}
                };
            }),
            updateMarkdown: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'stream' && event.type !== 'complete') return {};
                return {
                    markdown: event.markdown,
                    feedbackSubmitted: undefined
                };
            }),
            updateADFResponse: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'stream' && event.type !== 'complete' && event.type !== 'response too similar') return {};
                return {
                    adfResponse: event.adfResponse
                };
            }),
            updateLoadingStatus: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'stream') return {};
                // If the loading status is empty, we want to clear it from the context
                if (event.loadingStatus === '') return {
                    loadingStatus: undefined
                };
                return {
                    loadingStatus: event.loadingStatus
                };
            }),
            clearLoadingStatus: (0, $cPMXw.a)(()=>{
                return {
                    loadingStatus: undefined
                };
            }),
            storeContextStatistics: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'storeContextStatistics') return {
                    contextStatistics: event.contextStatistics
                };
                return {};
            }),
            clearMarkdown: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'retry prompt') return {};
                return {
                    markdown: undefined,
                    idMap: undefined,
                    selectionMetaData: undefined,
                    adfResponseNodeWrappers: undefined
                };
            }),
            interrogate: (0, $cPMXw.a)(({ context: context, event: event })=>{
                if (event.type !== 'interrogate') return {};
                /**
         * Need to wipe out markdown as per user story designs where we don't use
         * the prior response in the latest response
         */ return {
                    markdown: '',
                    adfResponse: undefined,
                    configItem: context.configItem.key !== (0, $bwpRs.CONFIG_ITEM_KEYS).ROVO_AGENT ? context.baseGenerate : context.configItem,
                    userInput: event.userInput,
                    userADFInput: event.userADFInput,
                    latestPromptResponse: event.latestPromptResponse
                };
            }),
            refine: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'refine') return {};
                return {
                    markdown: '',
                    configItem: event.configItem,
                    latestPromptResponse: event.latestPromptResponse
                };
            }),
            clearUserInput: (0, $cPMXw.a)(()=>{
                return {
                    userInput: '',
                    userADFInput: undefined
                };
            }),
            updateUserInput: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'update user input' && event.type !== 'retry prompt') return {};
                return {
                    userInput: event.input
                };
            }),
            updateUserInputADF: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'update user input adf' && event.type !== 'retry prompt') return {};
                return {
                    userADFInput: event.adf
                };
            }),
            updateRovoActions: (0, $cPMXw.a)(({ context: context, event: event })=>{
                if (event.type !== 'complete') return {};
                // We don't want to update if there are no rovo actions or
                // an agent hasn't been set
                if (!event.rovoActions?.length || !context.configItem.agent) return {
                    rovoActions: {}
                };
                return {
                    rovoActions: event.rovoActions.reduce((prevValue, currentValue)=>{
                        const key = currentValue.data.suggestion === 'insert' ? 'empty' : 'range';
                        prevValue[key] = currentValue.data;
                        return prevValue;
                    }, {})
                };
            }),
            feedbackSubmitted: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'feedback submitted') return {};
                return {
                    feedbackSubmitted: event.sentiment
                };
            }),
            pushToHistory: (0, $cPMXw.a)(({ context: context, event: event })=>{
                if (event.type !== 'complete' && event.type !== 'response too similar') return {};
                const { cacheKey: cacheKey } = event;
                // Check if the most recent entry is the same as the new event to prevent duplicates
                const entries = context.responseHistory.entries;
                if (entries.length > 0 && entries[entries.length - 1].cacheKey === cacheKey) return {};
                let historyEvent;
                if (event.type === 'complete') historyEvent = {
                    userInput: context.userInput || '',
                    userADFInput: context.userADFInput,
                    configItem: context.configItem,
                    markdown: event.markdown,
                    cacheKey: cacheKey,
                    modelInput: event.modelInput,
                    inputOutputDiffRatio: event.inputOutputDiffRatio,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    latestPrompt: context.latestPrompt
                };
                if (event.type === 'response too similar') historyEvent = {
                    userInput: context.userInput || '',
                    userADFInput: context.userADFInput,
                    configItem: context.configItem,
                    markdown: '',
                    responseTooSimilar: true,
                    cacheKey: cacheKey,
                    modelInput: event.modelInput,
                    inputOutputDiffRatio: event.inputOutputDiffRatio,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    latestPrompt: context.latestPrompt
                };
                if (!historyEvent) return {};
                // Calculate the size of the historyEvent object for analytics
                const historyEventSize = new Blob([
                    JSON.stringify(historyEvent)
                ]).size;
                const totalSize = context.responseHistory.totalSize + historyEventSize;
                // Add the new event to the end of the entries array
                const updatedEntries = [
                    ...entries,
                    historyEvent
                ];
                // Ensure the entries array does not exceed 5 items to limit memory usage
                if (updatedEntries.length > 5) updatedEntries.shift();
                return {
                    responseHistory: {
                        entries: updatedEntries,
                        positionFromEnd: 0,
                        totalSize: // Reset the position
                        totalSize,
                        traversals: context.responseHistory.traversals
                    }
                };
            }),
            restoreResponseFromHistory: (0, $cPMXw.a)(({ context: context, event: event })=>{
                if (event.type !== 'same cache key') return {};
                const { entries: entries } = context.responseHistory;
                const historyEvent = entries[entries.length - 1];
                if (!historyEvent) return {};
                return {
                    userInput: historyEvent.userInput,
                    userADFInput: historyEvent.userADFInput,
                    markdown: historyEvent.markdown,
                    configItem: historyEvent.configItem,
                    latestPromptResponse: historyEvent.markdown
                };
            }),
            clearFromHistory: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type !== 'retry prompt') return {};
                return {
                    responseHistory: {
                        entries: [],
                        positionFromEnd: 0,
                        totalSize: 0,
                        traversals: 0
                    }
                };
            }),
            setLatestPrompt: (0, $cPMXw.b)(({ enqueue: enqueue, check: check })=>{
                if (check({
                    type: 'is base generate'
                })) enqueue((0, $cPMXw.a)(({ context: context })=>({
                        latestPrompt: {
                            userInput: context?.userInput || '',
                            userADFInput: context?.userADFInput
                        }
                    })));
                else if (check({
                    type: 'has custom prompt'
                })) enqueue((0, $cPMXw.a)(({ context: context, event: event })=>({
                        latestPrompt: {
                            ...event.type !== 'interrogate' && event.type !== 'refine' && {
                                presetTitle: context.configItem
                            },
                            userInput: context?.userInput || '',
                            userADFInput: context?.userADFInput
                        }
                    })));
                else /**
           * Falls through to options which do not take additional
           * user input and is not base generate, e.g.
           * - Improve writing
           * - Summarize
           * Upon interrogation, there may also be user input.
           * We preference showing user input over the preset title for
           * non-partial presets.
           */ enqueue((0, $cPMXw.a)(({ context: context })=>context?.userInput ? {
                        latestPrompt: {
                            userInput: context?.userInput || '',
                            userADFInput: context?.userADFInput
                        }
                    } : {
                        latestPrompt: {
                            presetTitle: context.configItem
                        }
                    }));
            }),
            clearFocus: ()=>{
                document.activeElement?.blur();
            },
            updateContext: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'kickoff with command palette input' || event.type === 'update context' || event.type === 'enable discard') return {
                    ...event.context
                };
                if (event.type === 'disable discard') return {
                    onceDiscard: undefined
                };
                return {};
            }),
            updateBaseGenerateAndConfigItem: (0, $cPMXw.a)(({ event: event, context: context })=>{
                if (event.type === 'update baseGenerate and configItem') {
                    /**
           * If user has selected any prompt, then don't change configItem.
           */ if (context.configItem.key === (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE) return {
                        baseGenerate: event.baseGenerate,
                        configItem: event.configItem
                    };
                    else return {
                        baseGenerate: event.baseGenerate
                    };
                }
                return {};
            }),
            updateChannelId: (0, $cPMXw.a)(({ context: context })=>{
                const { aiProvider: aiProvider, configItem: configItem } = context;
                if (!aiProvider.getChannelVariables || !configItem.agent) return {
                    channelId: undefined,
                    previousAgentId: undefined
                };
                // if agent did not change, we don't need to update channelId preserving the same conversation history
                // as soon as agent changes, we need to recreate channelId to start a new conversation
                if (configItem.agent.id === context.previousAgentId) return {};
                return {
                    channelId: (0, $a967555a2593cb3a$export$4d16f4ec9dad8b6b)(),
                    previousAgentId: configItem.agent.id
                };
            }),
            updateIdMap: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'update idMap') return {
                    idMap: {
                        ...event.context.idMap
                    }
                };
                return {};
            }),
            updateTraceIds: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'update traceIds') return {
                    traceIds: event.context.traceIds
                };
                return {};
            }),
            updateSelectionMetaData: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'update selectionMetaData') return {
                    selectionMetaData: event.context.selectionMetaData
                };
                return {};
            }),
            updateAdfResponseNodeWrappers: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'update adfResponseNodeWrappers') return {
                    adfResponseNodeWrappers: event.context.adfResponseNodeWrappers
                };
                return {};
            }),
            retryOnAdfStreamErrors: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'retry on adf stream errors') return {
                    adfResponse: event.adfResponse,
                    markdown: ''
                };
                return {};
            }),
            editPrompt: (0, $cPMXw.a)(({ context: context, event: event })=>{
                if (event.type !== 'edit prompt') return {};
                // from 'neither base generate nor custom prompt'
                const isBaseGenerate = context.configItem.title === context.baseGenerate?.title;
                const hasCustomPrompt = context.configItem.promptLabel !== undefined;
                // if it's a preset prompt which doesn't need user input (like `Summarize writing`)
                // - we want to reset configItem
                // - we want to reset the user input
                const isPresetPrompt = !isBaseGenerate && !hasCustomPrompt;
                let configItem = context.configItem;
                // if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
                // - we don't want to reset the configItem
                //   - (keep the configItem) so that we can restore the selected parent later in UserInputCommandPaletteWithLogic
                // - we want to reset the user input
                const isSubmenuSelected = Boolean(context.parentPresetPromptLabel);
                // when we add default agent for knowledge source, it doesn't need additional user input because it's triggered from the user input
                // - we want to reset the configItem
                // - we don't want to reset the user input
                const isDefaultAgent = Boolean(context.configItem.agent?.isDefault);
                const resetConfigItem = (isPresetPrompt || isDefaultAgent) && !isSubmenuSelected;
                const resetUserInput = (isPresetPrompt || isSubmenuSelected) && !isDefaultAgent;
                if (resetConfigItem && context.baseGenerate) // from dismissCustomPrompt
                configItem = context.baseGenerate;
                // If we detect a preset prompt, clear everything
                // otherwise preserve what we can.
                return {
                    markdown: undefined,
                    userInput: resetUserInput ? undefined : event.userInput,
                    userADFInput: resetUserInput ? undefined : event.userADFInput,
                    presetTitle: resetUserInput ? undefined : event.presetTitle,
                    configItem: configItem,
                    latestPromptResponse: undefined,
                    editCount: context.editCount + 1,
                    idMap: undefined,
                    selectionMetaData: undefined,
                    adfResponseNodeWrappers: undefined
                };
            }),
            incrementRetryPromptCount: (0, $cPMXw.a)(({ context: context })=>{
                return {
                    retryPromptCount: context.retryPromptCount + 1
                };
            }),
            incrementRefinementCount: (0, $cPMXw.a)(({ context: context })=>{
                return {
                    refinementCount: context.refinementCount + 1
                };
            }),
            resetRefinementCount: (0, $cPMXw.a)(()=>{
                return {
                    refinementCount: 0
                };
            }),
            updatePromptContextBasedOnTrigger: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'interrogate') return {
                    promptTrigger: 'interrogate',
                    latestPromptRetried: false
                };
                if (event.type === 'refine') return {
                    promptTrigger: 'refinementButton',
                    latestPromptRetried: false
                };
                if (event.type === 'retry prompt') return {
                    latestPromptRetried: true
                };
                if (event.type === 'kickoff with command palette input') return {
                    promptTrigger: 'generate',
                    latestPromptRetried: false
                };
                return {};
            }),
            toggleUsePageKnowledge: (0, $cPMXw.a)(({ context: context, event: event })=>{
                if (event.type !== 'toggle use page knowledge') return {};
                // This is set to true by default
                return {
                    usePageKnowledge: !context.usePageKnowledge
                };
            })
        },
        guards: {
            ['has custom prompt']: ({ context: context })=>{
                // when we add default agent for knowledge source, it doesn't need additional user input because it's triggered from the user input
                const isDefaultAgent = Boolean(context.configItem.agent?.isDefault);
                if (isDefaultAgent) return false;
                return context.configItem.promptLabel !== undefined;
            },
            ['is base generate']: ({ context: context })=>{
                // Doing configItem direct comparision fails in tests where we mutate or create custom
                // items.
                return context.configItem.title === context.baseGenerate?.title;
            },
            ['neither base generate nor custom prompt']: ({ context: context })=>{
                const isBaseGenerate = context.configItem.title === context.baseGenerate?.title;
                const hasCustomPrompt = context.configItem.promptLabel !== undefined;
                return !isBaseGenerate && !hasCustomPrompt;
            },
            ['if command input is empty']: ({ context: context })=>{
                return context.userInput?.trim?.()?.length === 0;
            },
            ['no textual content but prompt requires it']: ({ context: context, event: event })=>{
                if (!(0, $dh538.fg)('platform_editor_ai_handle_invalid_input')) return false;
                let configItem = context.configItem;
                if (event.type === 'kickoff with command palette input') configItem = event.context.configItem;
                const requiresTextualContent = configItem.requiresTextualContent;
                const isBaseGenerate = configItem.title === context.baseGenerate?.title;
                const hasCustomPrompt = configItem.promptLabel !== undefined;
                const doesPromptRequireTextualContent = requiresTextualContent && !isBaseGenerate && !hasCustomPrompt;
                if (doesPromptRequireTextualContent) {
                    const state = context.editorView.state;
                    /**
           * If selection is empty then prompt will trigger on the entire document.
           * So checking if doc has textual content.
           */ return !(0, $d465bdc6207b3d88$export$13724218f8b1273e)(state, context.isEmpty ? [
                        0,
                        state.doc.content.size
                    ] : context.positions);
                }
                return false;
            }
        }
    });
    return machine;
}


function $c802a1f50ee37760$export$519bc24a166a4cfd(options) {
    const machineRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    if (machineRef.current === null) machineRef.current = (0, $fb64f67e895c15d9$export$d89ac572d9ca416a)(options);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const [state, send, actor] = (0, $389f150a524de0cc$export$e0338c4153421160)(machineRef.current);
    (0, $fb64f67e895c15d9$export$a6342417f9492df1).setActor(options.context.editorView, actor);
    return {
        // In a later version of xstate -- the type gen means the machine
        // has good types, so these assertions are not required
        state: state.value,
        context: state.context,
        send: send
    };
}











var $6Vqkv = parcelRequire("6Vqkv");





var $9uNdP = parcelRequire("9uNdP");

var $8zG4S = parcelRequire("8zG4S");


var $eIhC8 = parcelRequire("eIhC8");

const $95421d7f75dc6e97$export$a3d3d8409c46173b = ()=>{
    return false;
};
















function $f655ac6196582f3d$export$ce428e3c22a00062({ editorState: editorState }) {
    const pluginState = (0, $42omo.useMemo)(()=>{
        const rovoAgentsPluginState = (0, $6bKwm.getRovoAgentsPluginState)(editorState);
        return rovoAgentsPluginState;
    }, [
        editorState
    ]);
    return pluginState;
}



// coming soon missing `icon`
const $01f629ab65a6efb7$var$favouriteAgentsQuery = `
	query editorPluginAIFavouriteAgents($cloudId: String!, $first: Int, $input: AgentStudioAgentQueryInput) {
		agentStudio_getAgents(
			cloudId: $cloudId
			first: $first
			input: $input
		) @optIn(to: "AgentStudio") {
			edges {
				node {
					...editorPluginAI_getAgentsFragment
				}
			}
		}
	}

	fragment editorPluginAI_getAgentsFragment on AgentStudioAssistant {
		id
		name
		description
		creator {
			id
		}
		creatorType
		# icon
		conversationStarters
		identityAccountId
		externalConfigReference
	}
`;
const $01f629ab65a6efb7$var$mapFavouriteToAgent = (favourite)=>{
    return {
        named_id: '',
        creator_type: 'SYSTEM',
        available_plugins: {},
        favourite: true,
        actor_type: 'AGENT',
        user_defined_conversation_starters: [],
        deactivated: false,
        is_default: false,
        ...favourite,
        creator: favourite.creator.id
    };
};
const $01f629ab65a6efb7$var$fetchFavouriteAgents = async ({ cloudId: cloudId })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $01f629ab65a6efb7$var$favouriteAgentsQuery,
                variables: {
                    cloudId: cloudId,
                    first: 10,
                    input: {
                        onlyFavouriteAgents: true
                    }
                }
            })
        });
        const responseJson = await response.json();
        if (responseJson.errors) throw new Error(responseJson.errors[0].message);
        const result = responseJson;
        return result.data.agentStudio_getAgents.edges.map((edge)=>$01f629ab65a6efb7$var$mapFavouriteToAgent(edge.node));
    } catch  {
        return [];
    }
};
const $01f629ab65a6efb7$var$fetchRecommendedAgents = async ({ limit: limit })=>{
    try {
        if ((0, $95421d7f75dc6e97$export$a3d3d8409c46173b)()) return Promise.resolve([
            (0, $9uNdP.CommsCrafterAgent),
            (0, $9uNdP.JobWriterAgent),
            (0, $9uNdP.A11yMateAgent)
        ]);
        const response = await fetch(`/gateway/api/assist/rovo/v1/agents/recommend/v2?limit=${limit}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': 'ai-mate'
            }
        });
        const result = await response.json();
        return result.agents;
    } catch  {
        return [];
    }
};
const $01f629ab65a6efb7$export$e37a2e6de6a7fa90 = ({ cloudId: cloudId, editorState: editorState })=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true,
        error: null
    });
    const agents = (0, $f655ac6196582f3d$export$ce428e3c22a00062)({
        editorState: editorState
    });
    const agentsInitialised = (0, $42omo.useRef)(agents?.initialised);
    const editorAgents = (0, $42omo.useRef)(agents?.agents);
    agentsInitialised.current = agents?.initialised;
    editorAgents.current = agents?.agents;
    (0, $42omo.useEffect)(()=>{
        const fetchFavouriteRecommendedAgents = async ()=>{
            if (agentsInitialised.current && editorAgents.current) {
                setState({
                    data: editorAgents.current,
                    loading: false,
                    error: null
                });
                return;
            }
            const favouriteAgents = await $01f629ab65a6efb7$var$fetchFavouriteAgents({
                cloudId: cloudId
            });
            if (favouriteAgents.length >= 3) {
                setState({
                    data: favouriteAgents.map((a)=>(0, $8zG4S.getEditorAgent)(a)),
                    loading: false,
                    error: null
                });
                return;
            }
            const recommendedAgents = await $01f629ab65a6efb7$var$fetchRecommendedAgents({
                limit: 3 - favouriteAgents.length
            });
            setState({
                data: [
                    ...favouriteAgents ?? [],
                    ...recommendedAgents ?? []
                ].map((a)=>(0, $8zG4S.getEditorAgent)(a)),
                loading: false,
                error: null
            });
        };
        fetchFavouriteRecommendedAgents();
    }, [
        cloudId
    ]);
    return state;
};


const $56e9515070459f37$var$AgentFetcherLegacy = (props)=>{
    const { editorPluginAIProvider: editorPluginAIProvider, editorView: editorView } = props;
    const siteId = (0, $42omo.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const agentsFromAssistanceService = (0, $6Vqkv.useAgentsList)({
        filter: 'favourites',
        assistanceServiceParams: {
            product: (0, $8klLr.mapToAssistanceServiceProduct)(editorPluginAIProvider.product),
            experienceId: 'ai-mate',
            touchpointSource: 'editor-agent-favourites-fetcher',
            siteId: siteId
        }
    });
    const allAgentsFromAssistanceService = (0, $6Vqkv.useAgentsList)({
        assistanceServiceParams: {
            product: (0, $8klLr.mapToAssistanceServiceProduct)(editorPluginAIProvider.product),
            experienceId: 'ai-mate',
            touchpointSource: 'editor-agent-all-fetcher',
            siteId: siteId
        }
    });
    const mockAgentData = (0, $95421d7f75dc6e97$export$a3d3d8409c46173b)();
    // Request information about the latest Rovo agents and update the state accordingly
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!editorPluginAIProvider.getChannelVariables) // Flag can be on, but off for this specific editor
        // eg. Confluence only wants it on for full page editors, not comment editors
        return;
        // http://localhost:3100 is Playwright/Gemini
        const agents = mockAgentData ? [
            (0, $9uNdP.CommsCrafterAgent),
            (0, $9uNdP.JobWriterAgent),
            (0, $9uNdP.A11yMateAgent)
        ].map((0, $8zG4S.getEditorAgent)) : agentsFromAssistanceService.map((0, $8zG4S.getEditorAgent));
        function getDefaultAgent() {
            const defaultAgent = mockAgentData ? (0, $8zG4S.getEditorAgent)((0, $9uNdP.ChatAgent)) : allAgentsFromAssistanceService.filter((agent)=>agent.is_default).map((0, $8zG4S.getEditorAgent))[0];
            return defaultAgent;
        }
        // Update the plugin state with the latest agents
        const command = (0, $eIhC8.updateAgents)({
            agents: agents,
            defaultAgent: getDefaultAgent()
        });
        command(editorView.state, editorView.dispatch);
    }, [
        editorPluginAIProvider,
        agentsFromAssistanceService,
        allAgentsFromAssistanceService,
        mockAgentData,
        editorView.state,
        editorView.dispatch
    ]);
    return null;
};
const $56e9515070459f37$var$AgentFetcherNew = (props)=>{
    const { editorPluginAIProvider: editorPluginAIProvider, editorView: editorView } = props;
    const siteId = (0, $42omo.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const agentsRecommended = (0, $01f629ab65a6efb7$export$e37a2e6de6a7fa90)({
        cloudId: siteId,
        editorState: editorView.state
    });
    // Request information about the latest Rovo agents and update the state accordingly
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!editorPluginAIProvider.getChannelVariables) // Flag can be on, but off for this specific editor
        // eg. Confluence only wants it on for full page editors, not comment editors
        return;
        const agents = agentsRecommended?.data;
        // Update the plugin state with the latest agents
        if (agentsRecommended.data && !agentsRecommended.loading) {
            const command = (0, $eIhC8.updateAgents)({
                agents: agents,
                defaultAgent: undefined
            });
            command(editorView.state, editorView.dispatch);
        }
    }, [
        editorPluginAIProvider,
        agentsRecommended,
        editorView.state,
        editorView.dispatch
    ]);
    return null;
};
const $56e9515070459f37$export$22e51ab65638ad05 = ({ editorPluginAIProvider: editorPluginAIProvider, editorView: editorView })=>{
    return (0, $dh538.fg)('platform_editor_ai_remove_agents_list') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($56e9515070459f37$var$AgentFetcherNew, {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($56e9515070459f37$var$AgentFetcherLegacy, {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView
    });
};






var $4wH3g = parcelRequire("4wH3g");


const $b9096bdf9049f901$export$62821c88a7188481 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "ZPhfu",
    name: "LoadableBrowseRovoAgentsModal",
    loader: ()=>(parcelRequire("cmDmV")).then((mod)=>mod.default),
    loading: ()=>null
});
const $b9096bdf9049f901$export$3b4439d273b7f3cc = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        $b9096bdf9049f901$export$62821c88a7188481.preload();
    }, []);
    return null;
};

























var $hnvzE = parcelRequire("hnvzE");















const $ee350c5972abd564$export$cad72db1c520741c = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
null);
const $ee350c5972abd564$export$28c15afa0bc9f86b = ()=>{
    const contextData = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($ee350c5972abd564$export$cad72db1c520741c);
    if (!contextData) throw new Error('Attempted to access AIExperienceCommonDataContext before its value is set');
    return contextData;
};










var $AMCQl = parcelRequire("AMCQl");





var $SFzFl = parcelRequire("SFzFl");


var $jc4DP = parcelRequire("jc4DP");




const $8dbf3e97af770d28$export$dc3b52bb600cbaa7 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE_EDITOR_AGENT,
        title: (0, $SFzFl.default).aiButtonTitle,
        description: (0, $SFzFl.default).aiUniversalLongCallToAction,
        promptHint: (0, $AMCQl.aiConfigItemMessages).freeGeneratePromptHint,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                label: "",
                spacing: "spacious"
            }),
        doNotHighlightDocWhenSelectionIsEmpty: true,
        insertOnEmptySelection: true,
        quickInsertPriority: Number.NEGATIVE_INFINITY,
        canTogglePageKnowledge: false,
        disableInterrogation: ()=>false,
        silentAgentPrompt: true,
        agent: options.agent,
        intentSchemaId: 'DISABLED',
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>'assistance-service'
    });

















var $hAuc5 = parcelRequire("hAuc5");




function $6537ba32a2b947a8$export$a08e8b3dacf7ffcc({ markdown: markdown, schema: schema, source: source, fireAIAnalyticsEvent: fireAIAnalyticsEvent, idMap: idMap }) {
    try {
        const { pmFragment: pmFragment, htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes, htmlConvertedToNodes: htmlConvertedToNodes, unclosedTokens: unclosedTokens, markdownPlusAttributeStatus: markdownPlusAttributeStatus } = (0, $hAuc5.convertMarkdownToProsemirror)({
            schema: schema,
            markdown: markdown,
            idMap: idMap,
            featureToggles: {
                markdownPlus: true,
                markdownPlusExtensions: true,
                markdownPlusPanels: true,
                markdownPlusDecisions: true,
                markdownPlusAttributeTest: (0, $dh538.fg)('platform_editor_ai_markdown_plus_attr_test'),
                markdownPlusMentions: (0, $dh538.fg)('platform_editor_ai_draft_reply_mentions'),
                markdownPlusAddComplexNodes: (0, $dh538.fg)('platform_editor_ai_markdown_plus_add_complex_nodes'),
                markdownPlusRemoveUnclosedTokens: true,
                markdownPlusUseNextMediaPlugin: (0, $dh538.fg)('platform_editor_ai_next_media_plugin'),
                allowAttributesMatchDefault: true
            }
        });
        if (markdownPlusAttributeStatus.length > 0 && (0, $dh538.fg)('platform_editor_ai_markdown_plus_attr_test')) markdownPlusAttributeStatus.forEach((status)=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'validateAttributes',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'markdownPlusAttributes',
                    attributes: {
                        attributesMatch: status[1],
                        nodeType: status[0]
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                }
            });
        });
        return {
            pmFragment: pmFragment,
            unclosedTokens: unclosedTokens,
            htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes,
            htmlConvertedToNodes: htmlConvertedToNodes,
            isTextFallbackUsed: false
        };
    } catch (error) {
        // When convertMarkdownToProsemirror a fragment
        // we log an analytics event to call out that markdown conversion has failed
        fireAIAnalyticsEvent({
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'markdownParser',
                attributes: {
                    source: source,
                    errorType: 'markdownParser',
                    errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            }
        });
        // Instead of erroring, we fallback to rendering as plaintext in a single paragraph.
        const fallbackPMFragment = (0, $5SAOw.Fragment).from(schema.nodes.paragraph.create(null, schema.text(markdown)));
        return {
            pmFragment: fallbackPMFragment,
            unclosedTokens: {},
            htmlConvertedToFallbackNodes: 0,
            htmlConvertedToNodes: 0,
            isTextFallbackUsed: true
        };
    }
}




const $f67061403a6197ff$export$1e9814631e2193d4 = (messageTemplate)=>{
    switch(messageTemplate){
        case 'ANALYSING_QUERY':
            return (0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).messageTemplateAnalysingQuery;
        case 'CONTENT_SEARCH':
            return (0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).messageTemplateContentSearch;
        case 'PAGE_HYDRATION':
            return (0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).messageTemplatePageHydration;
        case 'NEXT_BEST_TASK':
            return (0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).messageTemplateNextBestTask;
        case 'WRITING':
            return (0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).loadingTitle;
        default:
            return (0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).generatingAiResponse;
    }
};
const $f67061403a6197ff$export$e51701552d28cc4e = ({ status: status, formatMessage: formatMessage })=>{
    const messageTemplate = $f67061403a6197ff$export$1e9814631e2193d4(status);
    return formatMessage(messageTemplate);
};









var $e83av = parcelRequire("e83av");

function $8d54db085cc5a603$export$9ea8217d5ec56f82() {
    return new (0, $e83av.StreamFlowPacer)({
        tickMs: 41,
        initialCharsPerTick: 8,
        maxCharsPerTick: 1000,
        backlogRampThreshold: 100,
        ramp: {
            initialDelaySec: 6,
            stepDelaySec: 3,
            flushDelaySec: 0.5,
            growthFactor: 1.5
        }
    });
}
function $8d54db085cc5a603$export$ace1671de29eb5ea(isInDocumentStreamingEnabled) {
    const streamFlowPacerRef = (0, $42omo.useRef)(null);
    if (!streamFlowPacerRef.current && ((0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') || isInDocumentStreamingEnabled)) streamFlowPacerRef.current = $8d54db085cc5a603$export$9ea8217d5ec56f82();
    // destroy the stream flow pacer when unmounted
    (0, $42omo.useEffect)(()=>{
        streamFlowPacerRef.current?.destroy();
    }, []);
    return streamFlowPacerRef;
}









var $fwDOR = parcelRequire("fwDOR");




const $5e6b5cd1785ea351$var$useUfoLoadingStatus = (loadingStatus)=>{
    const previousStatusRef = (0, $42omo.useRef)(null);
    // Track if we've ever had a loading status
    (0, $42omo.useEffect)(()=>{
        if (loadingStatus) previousStatusRef.current = loadingStatus;
    }, [
        loadingStatus
    ]);
    // Simple logic for determining the status
    if (loadingStatus) // If we have a current status, use it directly
    return loadingStatus;
    else if (previousStatusRef.current) // If we had a status before but not anymore, we're rendering
    return 'RENDERING';
    else // If we never had a status, we're pending
    return 'PENDING';
};
var $5e6b5cd1785ea351$export$2e2bcd8739ae039 = $5e6b5cd1785ea351$var$useUfoLoadingStatus;


const $d523c2c58c9df434$export$90b9d761c76d339a = ({ loadingStatus: loadingStatus })=>{
    const extendedLoadingStatus = (0, $5e6b5cd1785ea351$export$2e2bcd8739ae039)(loadingStatus);
    if (extendedLoadingStatus) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: `loadingStatus_${extendedLoadingStatus}`,
        key: `loadingStatus_${extendedLoadingStatus}`
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};











const $08307bd80aa5722b$export$8850f5fc4cad5830 = (markdown)=>{
    markdown = markdown.trim(); // Trim whitespace to ensure quotes at start/end are detected
    const firstChar = markdown.charAt(0);
    const lastChar = markdown.charAt(markdown.length - 1);
    // Check if the first and last characters are matching quotes (either ' or ")
    if (firstChar === '"' && lastChar === '"' || firstChar === "'" && lastChar === "'") // Remove the first and last character
    return markdown.substring(1, markdown.length - 1);
    // Return the original string if no matching outer quotes are found
    return markdown;
};















function $62aff15c20d44eff$export$6399b1de54f080ad(latestPrompt) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $42omo.useMemo)(()=>{
        return latestPrompt?.presetTitle ? {
            presetTitle: (0, $c2200b5407d4af9f$export$d97f37f32ae9d000)(latestPrompt.presetTitle, formatMessage),
            userInput: latestPrompt?.userInput,
            userADFInput: latestPrompt?.userADFInput
        } : {
            userInput: latestPrompt?.userInput || '',
            userADFInput: latestPrompt?.userADFInput
        };
    }, [
        latestPrompt,
        formatMessage
    ]);
}












const $8d247c8f9aa8e8b7$export$6874965a4629d745 = 0.01;
const $8d247c8f9aa8e8b7$export$4ca0a669de074f43 = ({ input: input, output: output })=>{
    // Remove leading and trailing whitespace from both input and output
    input = input.trim();
    output = output.trim();
    // Remove Zero Width Non-Joiner
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    input = input.replace(/\u200C/gu, '');
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    output = output.replace(/\u200C/gu, '');
    // Remove \n from the end of input and output
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    input = input.replace(/\n+$/u, '');
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    output = output.replace(/\n+$/u, '');
    // If both input and output are empty, return 0 (no difference)
    if (input === '' && output === '') return 0;
    // If either input or output is empty, return 1 (completely different)
    if (input === '' || output === '') return 1;
    /**
	 * Bail out early if the input and output length are so different that even
	 * the longest common subsequence cannot produce a diff ratio less than MAX_DIFF_RATIO
	 * MAX_DIFF_RATIO > 1 - (2 * a) / (a + b)
	 * b > (1 + MAX_DIFF_RATIO) / (1 - MAX_DIFF_RATIO) * a
	 */ const longStringLength = Math.max(input.length, output.length);
    const shortStringLength = Math.min(input.length, output.length);
    if (longStringLength > (1 + $8d247c8f9aa8e8b7$export$6874965a4629d745) / (1 - $8d247c8f9aa8e8b7$export$6874965a4629d745) * shortStringLength) return 1;
    // If the string are exactly the same, return 0 (no difference)
    if (input === output) return 0;
    /**
	 * Bail out of calculating the diff ratio if the LCS cannot produce a diff ratio less than MAX_DIFF_RATIO
	 * MAX_DIFF_RATIO > 1 - (2 * lcs) / (a + b)
	 * This is a performance optimization to avoid unnecessary calculations
	 * when the strings are too different.
	 */ const minLcsLength = (1 - $8d247c8f9aa8e8b7$export$6874965a4629d745) / 2 * (input.length + output.length);
    let isMinLcsPossible = true;
    // Calculate the length of the longest common subsequence (LCS)
    const lcsLength = (a, b)=>{
        const dp = Array.from({
            length: a.length + 1
        }, ()=>Array(b.length + 1).fill(0));
        // Remaining maximum possible LCS at any point
        for(let i = 1; i <= a.length; i++){
            let maxRowLcs = 0; // Tracks the maximum LCS in the current row
            for(let j = 1; j <= b.length; j++){
                if (a[i - 1] === b[j - 1]) dp[i][j] = dp[i - 1][j - 1] + 1;
                else dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
                // Update the maximum LCS found in this row
                maxRowLcs = Math.max(maxRowLcs, dp[i][j]);
            }
            // Estimate the maximum possible LCS length from this point
            const remainingLengthA = a.length - i; // Remaining characters in `a`
            const remainingLengthB = b.length; // All characters in `b` might still match
            const maxPossibleLcs = maxRowLcs + Math.min(remainingLengthA, remainingLengthB);
            // If the maximum possible LCS is less than the required threshold
            if (maxPossibleLcs < minLcsLength) {
                // Update the flag to indicate bailout
                isMinLcsPossible = false;
                // No need to continue further, we can return 0
                return 0;
            }
        }
        return dp[a.length][b.length];
    };
    const lcs = lcsLength(input, output);
    if (!isMinLcsPossible) return 1;
    // Calculate the difference ratio
    const diffRatio = 1 - 2 * lcs / (input.length + output.length);
    return Math.max(0, Math.min(1, diffRatio)); // Ensure the ratio is between 0 and 1
};


const $ca5cb652bdb20bde$export$95a358671d66b6a5 = (props)=>{
    const { aiExperienceMachineContext: aiExperienceMachineContext, backendModel: backendModel, discardStream: discardStream } = props;
    const { configItem: configItem, channelId: channelId, responseHistory: history, latestPrompt: latestPrompt, markdown: actualMarkdown, retryPromptCount: retryPromptCount, endExperience: endExperience } = aiExperienceMachineContext;
    const { api: api, isDisplayingChanges: isDisplayingChanges } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const { appearance: appearance, editorPluginAIProvider: editorPluginAIProvider, lastTriggeredFrom: lastTriggeredFrom, sendToAIExperienceMachine: sendToAIExperienceMachine } = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const product = editorPluginAIProvider.product;
    // preset prompt or base generate / interrogation
    const localizedLatestPrompt = (0, $62aff15c20d44eff$export$6399b1de54f080ad)(latestPrompt);
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    const lastHistoryEvent = history.entries[history.positionFromEnd];
    /**
	 * We may remove this diff ratio calculation, when we are sure that the backend
	 * calculation is working. We will need to have converted to the new ConvoAI endpoint.
	 * @see https://hello.jira.atlassian.cloud/browse/AIX-1665
	 * @see https://hello.jira.atlassian.cloud/browse/EDITOR-792
	 */ const diffRatio = (lastHistoryEvent.modelInput.selection || lastHistoryEvent.modelInput.doc) && actualMarkdown && (0, $dh538.fg)('editor_ai_no_improvement_deadend_fix') ? (0, $8d247c8f9aa8e8b7$export$4ca0a669de074f43)({
        input: lastHistoryEvent.modelInput.selection || lastHistoryEvent.modelInput.doc || '',
        output: actualMarkdown
    }) : 1;
    const responseTooSimilar = lastHistoryEvent.responseTooSimilar || diffRatio < (0, $8d247c8f9aa8e8b7$export$6874965a4629d745);
    const inputOutputDiffRatio = lastHistoryEvent.inputOutputDiffRatio;
    const aiExperienceMetadata = (0, $42omo.useMemo)(()=>{
        return {
            configItemTitle: configItem.agent?.name || (0, $6gJll.convertExperienceName)(configItem.key.toString()),
            ...configItem.experienceId && (0, $dh538.fg)('thor_support_google_docs_in_description_improver') ? {
                experienceId: configItem.experienceId
            } : {},
            lastTriggeredFrom: lastTriggeredFrom,
            inputOutputDiffRatio: inputOutputDiffRatio,
            backendModel: backendModel
        };
    }, [
        configItem,
        lastTriggeredFrom,
        inputOutputDiffRatio,
        backendModel
    ]);
    let markdown = actualMarkdown || '';
    if (markdown && (0, $hX9je.isConfluenceTitleToolbarSuggestTitle)({
        configItem: configItem,
        lastTriggeredFrom: lastTriggeredFrom
    })) markdown = (0, $08307bd80aa5722b$export$8850f5fc4cad5830)(markdown);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_aifc_no_default_diff')) // turn diff on, diff will be turned off when unmount ExperienceApplication
        {
            if (!api?.trackChanges?.sharedState.currentState()?.isDisplayingChanges) api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        }
    }, [
        api
    ]);
    const onToggleChanges = (0, $42omo.useCallback)(()=>{
        // toggle diff, diff will also be turned off when unmount ExperienceApplication
        api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
    }, [
        api
    ]);
    const onAccept = (0, $42omo.useCallback)(()=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_CHANGES_ACCEPT_BUTTON,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                appearance: appearance,
                configItemTitle: configItem.agent?.name || configItem.key,
                lastTriggeredFrom: lastTriggeredFrom,
                product: product
            }
        });
        api?.analytics?.actions.fireAnalyticsEvent((0, $ilIeg.createUnifiedAnalyticsPayload)({
            action: (0, $d925B.ACTION).ACTIONED,
            interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
            experienceName: (0, $6gJll.convertExperienceName)(configItem.key.toString()),
            isProactive: false,
            attributes: {
                ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                    init: false
                }),
                aiResultAction: 'accepted',
                aiActionedType: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? 'manuallyAccepted' : undefined
            },
            invokedFrom: lastTriggeredFrom,
            traceIds: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? analyticsFlow.getCommonAttributes().traceIds : undefined
        }));
        endExperience();
    }, [
        api,
        appearance,
        configItem,
        lastTriggeredFrom,
        product,
        endExperience,
        channelId,
        analyticsFlow
    ]);
    const onReject = (0, $42omo.useCallback)(()=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_CHANGES_REJECT_BUTTON,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                appearance: appearance,
                configItemTitle: configItem.agent?.name || configItem.key,
                lastTriggeredFrom: lastTriggeredFrom,
                product: product
            }
        });
        api?.analytics?.actions.fireAnalyticsEvent((0, $ilIeg.createUnifiedAnalyticsPayload)({
            action: (0, $d925B.ACTION).DISMISSED,
            interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
            experienceName: (0, $6gJll.convertExperienceName)(configItem.key.toString()),
            isProactive: false,
            attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                init: false
            }),
            invokedFrom: lastTriggeredFrom,
            traceIds: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? analyticsFlow.getCommonAttributes().traceIds : undefined
        }));
        discardStream?.();
        endExperience();
    }, [
        api,
        appearance,
        configItem,
        lastTriggeredFrom,
        product,
        discardStream,
        endExperience,
        channelId,
        analyticsFlow
    ]);
    const fireResponseFeedbackEvent = (0, $42omo.useCallback)((sentiment, productSuccessState)=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'responseFeedbackButton',
                attributes: {
                    sentiment: sentiment,
                    appearance: appearance,
                    product: product,
                    configItemTitle: configItem.agent?.name || configItem.key,
                    lastTriggeredFrom: lastTriggeredFrom,
                    productSuccessStatus: productSuccessState,
                    inputOutputDiffRatio: inputOutputDiffRatio,
                    retryPromptCount: retryPromptCount,
                    responseTooSimilar: responseTooSimilar,
                    aiInteractionID: analyticsFlow.getLastAiInteractionId()
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
        fireAIAnalyticsEvent({
            payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                action: (0, $d925B.ACTION).SUBMITTED,
                interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                experienceName: (0, $6gJll.convertExperienceName)(configItem.key.toString(), lastTriggeredFrom),
                isProactive: false,
                invokedFrom: lastTriggeredFrom,
                attributes: {
                    aiFeedbackResult: sentiment === 'good' ? 'up' : 'down',
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    })
                },
                traceIds: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? analyticsFlow.getCommonAttributes().traceIds : undefined
            })
        });
    }, [
        configItem,
        fireAIAnalyticsEvent,
        analyticsFlow,
        channelId,
        lastTriggeredFrom,
        inputOutputDiffRatio,
        retryPromptCount,
        responseTooSimilar,
        appearance,
        product
    ]);
    const handleFiringFeedbackEvent = (0, $42omo.useCallback)(async (feedbackMetadata)=>{
        analyticsFlow.addAttributes({
            userFeedbackSentiment: feedbackMetadata.sentiment
        });
        // we need to update the state machine to reflect the user feedback
        sendToAIExperienceMachine({
            type: 'feedback submitted',
            sentiment: feedbackMetadata.sentiment
        });
        // handleFeedbackSubmission is intended to be implemented
        // by all products -- there will be a period where products won't have
        // it implemented (and will be relying on THUMBS_UP/THUMBS_DOWN)
        // in these cases -- we don't know the product response status
        if (!editorPluginAIProvider.handleFeedbackSubmission) {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'unknown');
            return;
        } else try {
            const productResponse = await editorPluginAIProvider.handleFeedbackSubmission(feedbackMetadata);
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, productResponse.status);
        } catch  {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'failed');
        }
    }, [
        fireResponseFeedbackEvent,
        editorPluginAIProvider,
        sendToAIExperienceMachine,
        analyticsFlow
    ]);
    const getAIExperience = (0, $42omo.useCallback)((hasUserConsent)=>({
            ...aiExperienceMetadata,
            ...hasUserConsent && {
                userPrompt: localizedLatestPrompt.userInput,
                markdownResponse: markdown
            }
        }), [
        aiExperienceMetadata,
        localizedLatestPrompt,
        markdown
    ]);
    const onBadResponseButtonClick = (0, $42omo.useCallback)(()=>{
        const feedbackMetadata = {
            sentiment: 'bad',
            getAIExperience: getAIExperience,
            editorAttributes: {
                appearance: appearance,
                product: product
            }
        };
        // Now deprecated - migrate to handleFeedbackSubmission
        editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_DOWN();
        handleFiringFeedbackEvent(feedbackMetadata);
    }, [
        getAIExperience,
        editorPluginAIProvider.onExperienceEvent,
        handleFiringFeedbackEvent,
        appearance,
        product
    ]);
    const onGoodResponseButtonClick = (0, $42omo.useCallback)(()=>{
        const feedbackMetadata = {
            sentiment: 'good',
            getAIExperience: getAIExperience,
            editorAttributes: {
                appearance: appearance,
                product: product
            }
        };
        // Now deprecated - migrate to handleFeedbackSubmission
        editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_UP();
        handleFiringFeedbackEvent(feedbackMetadata);
    }, [
        getAIExperience,
        editorPluginAIProvider.onExperienceEvent,
        handleFiringFeedbackEvent,
        appearance,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04da2381767ad981$export$87eca91cbe06d0c8), {
        onAccept: onAccept,
        onReject: onReject,
        onBadResponseButtonClick: onBadResponseButtonClick,
        onGoodResponseButtonClick: onGoodResponseButtonClick,
        isDisplayingChanges: isDisplayingChanges,
        onToggleChanges: onToggleChanges
    });
};































const $1d7b35d3a553d01e$export$28146c614df26dc4 = ({ formatMessage: formatMessage, experienceState: experienceState })=>{
    const discardPrompt = formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).discardMessagePrompt);
    const discardResponse = formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).discardMessageResponse);
    const discardStreamingInDocumentResponse = formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).discardStreamingInDocumennt);
    if (typeof experienceState === 'object' && 'user input state' in experienceState) return discardPrompt;
    if (experienceState === 'review state' || typeof experienceState === 'object' && 'loading state' in experienceState) return discardStreamingInDocumentResponse;
    return discardResponse;
};
function $1d7b35d3a553d01e$export$643e9e046f871343({ state: state, editCount: editCount, retryPromptCount: retryPromptCount, history: history, onceDiscard: onceDiscard, channelId: channelId, streamFlowPacer: streamFlowPacer, discardStream: discardStream, api: api }) {
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const nextSessionId = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId);
    const { endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, configItem: configItem, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, appearance: appearance } = aiExperienceCommonData;
    const inputOutputDiffRatio = (0, $42omo.useMemo)(()=>{
        const lastHistoryEvent = history.entries[history.positionFromEnd];
        return history.entries.length === 0 ? '' : lastHistoryEvent.inputOutputDiffRatio;
    }, [
        history
    ]);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $3adf5d183dded6a4$export$f06fb39743945e19)({
        stepName: 'discard',
        attributes: {
            editCount: editCount,
            retryPromptCount: retryPromptCount,
            inputOutputDiffRatio: inputOutputDiffRatio,
            includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage
        }
    });
    (0, $42omo.useEffect)(()=>{
        streamFlowPacer?.pause();
        return ()=>{
            streamFlowPacer?.resume();
        };
    }, [
        streamFlowPacer
    ]);
    const { abort: abort } = (0, $eae81ca554f80ec0$export$5ddafe3fa55c1ac5)();
    // If a session is active - we'll show the loading screen elsewhere and we can hide this
    if (nextSessionId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $01efd7a6722fa820$export$453c0e2ebf820c66), {
        text: $1d7b35d3a553d01e$export$28146c614df26dc4({
            formatMessage: formatMessage,
            experienceState: state
        }),
        onCancel: function() {
            sendToAIExperienceMachine({
                type: 'disable discard'
            });
        },
        onDiscard: function() {
            /**
     * Introduced in EDF-1443 to track discard event confirmations
     * separately to normal discard events which get tracked
     * earlier in this file
     */ fireAIAnalyticsEvent({
                payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                    action: (0, $d925B.ACTION).DISMISSED,
                    interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                    experienceName: (0, $6gJll.convertExperienceName)(configItem.key.toString()),
                    isProactive: false,
                    attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    }),
                    invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                    traceIds: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? analyticsFlow.getCommonAttributes().traceIds : undefined
                })
            });
            // Abort any ongoing Rovo inline input box operations when discarding
            // Note if Rovo is not being used this will be a no-op
            abort();
            if (onceDiscard) {
                sendToAIExperienceMachine({
                    type: 'disable discard'
                });
                onceDiscard();
            } else {
                discardStream?.();
                endExperience();
            }
        },
        appearance: appearance,
        isAIFC: true
    });
}




















function $b307a07f626c94fc$export$eec2740903046434({ errorInfo: errorInfo }) {
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, editorView: editorView, appearance: appearance } = aiExperienceCommonData;
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, api: api } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const nextSessionId = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId);
    (0, $3adf5d183dded6a4$export$f06fb39743945e19)({
        stepName: (0, $a4a9843496093656$export$accc136c77ec5dfa)(errorInfo),
        attributes: {
            errorType: errorInfo.failureReason ?? (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).UNKNOWN,
            sawAupViolation: errorInfo.failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION,
            ...errorInfo
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if ((0, $dh538.fg)('platform_editor_ai_audit_logs_events')) {
            if (errorInfo.failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).AUP_VIOLATION) {
                const command = (0, $e36c6f447980a314$export$c16f4f0c4f1ae3d4)({
                    'aup-violation': {
                        eventStatus: 'send-event'
                    }
                });
                command(editorView.state, editorView.dispatch);
            }
        }
    }, [
        errorInfo.failureReason,
        editorView
    ]);
    if (nextSessionId && (0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSGOW.ErrorScreen), {
        text: (0, $a4a9843496093656$export$915e9e7bd4f0f96d)(errorInfo),
        onCancel: ()=>{
            endExperience();
        },
        onRetry: ()=>sendToAIExperienceMachine({
                type: 'retry'
            }),
        showRetryButton: (0, $a4a9843496093656$export$27eceeaa1726619e)(errorInfo),
        appearance: appearance,
        isAIFC: isInDocumentStreamingEnabled
    });
}













function $2c2b39d1df2126a4$export$124856cc35c13bde({ errorInfo: errorInfo, contextStatistics: contextStatistics }) {
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { endExperience: endExperience } = aiExperienceCommonData;
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    (0, $3adf5d183dded6a4$export$f06fb39743945e19)({
        stepName: 'invalidInput',
        attributes: {
            reason: errorInfo.failureReason ?? (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).UNKNOWN,
            modelIO: {
                contextStatistics: contextStatistics
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSGOW.ErrorScreen), {
        text: (0, $a4a9843496093656$export$915e9e7bd4f0f96d)(errorInfo),
        onCancel: ()=>{
            endExperience();
        },
        isAIFC: isInDocumentStreamingEnabled
    });
}


/* LoadingScreenWithLogic.tsx generated by @compiled/babel-plugin v0.36.1 */ 























/**
 * This function checks if a given markdown string ends with an incomplete "custom" tag,
 * ensuring that the tag is not closed by either a full closing tag (</custom>) or a self-closing tag (/>).
 *
 * Examples of matches:
 * - "Something something <"
 * - "Something something <c"
 * - "Something something <cust"
 * - "Something something <custom"
 *
 * It will not match strings where the "custom" tag is completed or closed:
 * - "Something something <custom/>"
 * - "Something something </custom>"
 * - Non-custom tags like:
 *   - "<custard"
 *   - "<status"
 */ const $a0122b81a4611d41$export$bde720e3489117f9 = (markdown)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!markdown.match(/<(c(u(s(t(o(m(?!.*<\/custom>|.*\/>).*?)?)?)?)?)?)?$/g);
};












const $ae9409607dcc8014$export$b38eff301cbfa415 = ({ editorPluginAIProvider: editorPluginAIProvider })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let disclaimer;
    const { aiUsageDisclaimer: aiUsageDisclaimer } = editorPluginAIProvider;
    if (aiUsageDisclaimer) disclaimer = {
        text: formatMessage(aiUsageDisclaimer.text),
        tooltip: formatMessage(aiUsageDisclaimer.tooltip),
        url: aiUsageDisclaimer.url
    };
    return disclaimer;
};












function $b51c49163805cfe9$export$4e4614f0417d7178({ userADFInput: userADFInput }) {
    return (0, $42omo.useMemo)(()=>{
        const jsonTransformer = new (0, $h9yJL.JSONTransformer)();
        const promptStats = userADFInput ? new (0, $8nxxM.ProseMirrorContentStatistics)(jsonTransformer.parse(userADFInput)) : undefined;
        return promptStats?.collectStatistics();
    }, [
        userADFInput
    ]);
}







const $e1bfb729a95c0d28$export$e9b50d8f92ed61d4 = 'use-general-ai-knowledge';
const $e1bfb729a95c0d28$export$f94ca114676d6a3f = 'use-rovo-organisation-knowledge';
const $e1bfb729a95c0d28$export$aed4aa2c04f0ff0a = 'tell-ai';
const $e1bfb729a95c0d28$export$ea35400996401183 = 'tell-agent';
const $e1bfb729a95c0d28$export$3cb19042951e1104 = 'agent:browse-more-agents';
const $e1bfb729a95c0d28$export$95f98990d7202b31 = 'show-more';
const $e1bfb729a95c0d28$export$9a9d72a255528f = 32;









/* PreviewRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $4FxUL = parcelRequire("4FxUL");





var $67O0h = parcelRequire("67O0h");


var $lspPP = parcelRequire("lspPP");




/*
 * This function checks if the current selection is a partial copy of the target element.
 */ function $0e1b477df898eb2c$export$d109786c97a20f08(targetElement) {
    const selection = window.getSelection();
    const selectionText = selection?.toString();
    // If there is no current selection, we don't want to send the event.
    if (!selectionText) return false;
    // Remove new lines and trailing spaces from the text to compare as innerText may have unecessary newlines.
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedPreviewResponseText = targetElement.innerText.replace(/\n/g, '').trim();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedSelectionText = selectionText.replace(/\n/g, '').trim();
    let isSelectionOutsideTargetElement = false;
    let isSelectionWholeAndMore = false;
    if (selection) {
        const { anchorNode: anchorNode, focusNode: focusNode } = selection;
        // Cases where the selection may be outside the node but are considered a whole copy:
        // Starts and ends outside the node.
        // Note: The anchor and focus nodes might be text nodes, not necessarily elements themselves,
        // but the `contains` method works for any node type.
        const selectionStartsOutside = !targetElement.contains(anchorNode);
        const selectionEndsOutside = !targetElement.contains(focusNode);
        isSelectionOutsideTargetElement = selectionStartsOutside && selectionEndsOutside;
        // Starts outside, ends at the end of the node.
        // OR Ends outside, starts at the start of the node.
        // Verify start and end locations.
        const selectionStartsAtStart = selection.anchorOffset === 0;
        const selectionEndsAtEnd = selection.focusOffset === focusNode?.textContent?.length;
        // Verify if the selection is a whole copy and more.
        const startsOutsideAndEndsAtEnd = selectionStartsOutside && selectionEndsAtEnd;
        const startsAtStartAndEndsOutside = selectionEndsOutside && selectionStartsAtStart;
        if (startsOutsideAndEndsAtEnd || startsAtStartAndEndsOutside) isSelectionWholeAndMore = true;
    }
    if (isSelectionOutsideTargetElement || isSelectionWholeAndMore) return false;
    return strippedPreviewResponseText !== strippedSelectionText;
}
function $0e1b477df898eb2c$export$60519e70a23320fb(element) {
    const selection = window.getSelection();
    if (!selection?.rangeCount || !selection.toString()) return false;
    const { anchorNode: anchorNode, focusNode: focusNode } = selection;
    if (!anchorNode || !focusNode) return false;
    // if start or end of the selection is within element no need in further checks
    if ([
        anchorNode,
        focusNode
    ].some((node)=>element.contains(node))) return true;
    // detect start and end node based on the direction of the selection
    const isLTRSelection = anchorNode.compareDocumentPosition(focusNode) & Node.DOCUMENT_POSITION_FOLLOWING;
    const startNode = isLTRSelection ? selection.anchorNode : selection.focusNode;
    const endNode = isLTRSelection ? selection.focusNode : selection.anchorNode;
    if (!startNode || !endNode) return false;
    // Check if the selection starts before and ends after the element
    if (startNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING && endNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING) return true;
    // Check if the selection starts after and ends before the element
    if (startNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING && endNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING) return true;
    return false;
}










const $a7659f8d588b0497$var$rendererOverrides = null;
const $a7659f8d588b0497$var$widthOverrides = null;
const $a7659f8d588b0497$export$8ce5f720dc007208 = ({ jsonDocument: jsonDocument, showTelepointer: showTelepointer, providerFactory: providerFactory, schema: schema })=>{
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const experienceType = (0, $6gJll.convertExperienceName)(aiExperienceCommonData.configItem.key.toString());
    const lastTriggeredFrom = aiExperienceCommonData.lastTriggeredFrom;
    const previewRendererRef = (0, $42omo.useRef)(null);
    const copiedOnceRef = (0, $42omo.useRef)(false); // IMPORTANT: the renderer will call providerFactory.destroy() when it unmounts. This is why we need to duplicate
    // the providerFactory and add a heap of subscribers to it. This is to avoid this duplicate provider gettting out of
    // sync with the original providerFactory.
    const dupedProviderFactory = (0, $42omo.useRef)(new (0, $4FxUL.default)());
    const adfStreamingEnabled = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    (0, $42omo.useEffect)(()=>{
        const mentionHandler = (name, provider)=>{
            dupedProviderFactory.current.setProvider(name, provider);
        };
        const emojiHandler = (name, provider)=>{
            dupedProviderFactory.current.setProvider(name, provider);
        };
        const mediaHandler = (name, provider)=>{
            dupedProviderFactory.current.setProvider(name, provider);
        };
        const extensionHandler = (name, provider)=>{
            dupedProviderFactory.current.setProvider(name, provider);
        };
        providerFactory.subscribe('mentionProvider', mentionHandler);
        providerFactory.subscribe('emojiProvider', emojiHandler);
        providerFactory.subscribe('mediaProvider', mediaHandler);
        if (adfStreamingEnabled) providerFactory.subscribe('extensionProvider', extensionHandler);
        return ()=>{
            providerFactory.unsubscribe('mentionProvider', mentionHandler);
            providerFactory.unsubscribe('emojiProvider', emojiHandler);
            providerFactory.unsubscribe('mediaProvider', mediaHandler);
            if (adfStreamingEnabled) providerFactory.unsubscribe('extensionProvider', extensionHandler);
        };
    }, [
        providerFactory,
        adfStreamingEnabled
    ]); // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const onCopyHandler = (0, $42omo.useCallback)(async ()=>{
        const previewRendererElement = previewRendererRef.current;
        if (!analyticsFlow || !previewRendererElement) return;
        if (!(0, $0e1b477df898eb2c$export$60519e70a23320fb)(previewRendererElement)) return;
        if ((0, $0e1b477df898eb2c$export$d109786c97a20f08)(previewRendererRef.current)) analyticsFlow.addAttributes({
            contentCopiedPartially: true
        });
         // Fire ACTION.ACTIONED event for copy action
        if (fireAIAnalyticsEvent && experienceType) fireAIAnalyticsEvent({
            payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                action: (0, $d925B.ACTION).ACTIONED,
                interactionID: analyticsFlow.getLastAiInteractionId(),
                experienceName: experienceType,
                isProactive: false,
                attributes: {
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    }),
                    aiResultAction: 'copied'
                },
                invokedFrom: lastTriggeredFrom
            })
        });
         // exit if copied already for this preview
        if (copiedOnceRef.current) return;
        analyticsFlow.addAttributes({
            contentCopied: true
        });
        copiedOnceRef.current = true;
    }, [
        analyticsFlow,
        fireAIAnalyticsEvent,
        experienceType,
        lastTriggeredFrom
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(document, {
            type: 'copy',
            listener: onCopyHandler
        });
        return unbind;
    }, [
        onCopyHandler,
        analyticsFlow
    ]);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "preview-renderer",
        ref: previewRendererRef,
        className: (0, $gMc0m.default)([
            "_1gxu4jg8 _1u11i7a9 _1ddwi7uo",
            adfStreamingEnabled && "_r98naq80 _1m04aq80 _17megrf3"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ $42omo.createElement((0, $67O0h.default // EDITOR-1178
    ), {
        // specify the appearance will make the renderer have a max-width of 760px when appearance is full-page
        // but AI modal could be triggered from a resized larger table, which will make the AI modal much wider than 760px
        // we want the renderer be the same wide as the AI modal, so we don't want to limit the renderer width via appearance
        // keep the appearance undefined here for clarity (it's added in EDITOR-1115)
        appearance: undefined,
        document: jsonDocument,
        media: adfStreamingEnabled ? {
            allowLinking: true,
            allowCaptions: true
        } : {
            // We don't currently support images with captions
            allowLinking: false
        },
        // the nodes and marks the markdown transformer can create.
        // see packages/editor/adf-schema/src/schema/default-schema.ts for details.
        useSpecBasedValidator: true,
        addTelepointer: showTelepointer,
        allowCustomPanels: adfStreamingEnabled,
        allowAnnotations: adfStreamingEnabled,
        allowWrapCodeBlock: adfStreamingEnabled,
        schema: adfStreamingEnabled ? schema : undefined,
        dataProviders: dupedProviderFactory.current,
        allowPlaceholderText: true,
        UNSTABLE_allowTableAlignment: adfStreamingEnabled,
        UNSTABLE_allowTableResizing: adfStreamingEnabled
    })));
};


const $e63c465153c397bc$var$jsonTransformer = new (0, $h9yJL.JSONTransformer)();
function $e63c465153c397bc$export$f5e3af6d625de7a({ schema: schema, pmFragment: pmFragment, showTelepointer: showTelepointer, providerFactory: providerFactory }) {
    let jsonDocument;
    const prosemirrorDocument = schema.nodes.doc.createAndFill({}, pmFragment);
    // If a failure has occured creating this, we don't know what's happened
    // and so should trigger the error boundary
    if (!prosemirrorDocument) throw new (0, $5b1c9f286ba7f166$export$6c16da0c287c00c)({
        message: 'Unable to transform markdown into a valid prosemirror document',
        type: 'noProseMirrorDoc'
    });
    if (prosemirrorDocument.content.size === 0) throw new (0, $5b1c9f286ba7f166$export$6c16da0c287c00c)({
        message: 'Transforming markdown returns an empty prosemirror document',
        type: 'emptyProseMirrorDoc'
    });
    try {
        // Warning -- this is asserted due to a mismatch in the editor-json-transformer
        // and renderer types.
        // jsonTransformer.encode returns a "JSONDocNode" which _should_ be runtime
        // compatible with DocNode -- but does not have compatible types.
        // See the following files for more details
        // - packages/editor/editor-json-transformer/src/types.ts
        // - packages/editor/adf-schema/src/schema/nodes/doc.ts
        jsonDocument = $e63c465153c397bc$var$jsonTransformer.encode(prosemirrorDocument);
    } catch  {
        throw new (0, $5b1c9f286ba7f166$export$6c16da0c287c00c)({
            message: 'Unable to transform markdown into a valid prosemirror document',
            type: 'invalidProseMirrorDoc'
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7659f8d588b0497$export$8ce5f720dc007208), {
        jsonDocument: jsonDocument,
        showTelepointer: showTelepointer,
        providerFactory: providerFactory
    });
}
function $e63c465153c397bc$export$5ae44876b720d032({ adfResponse: adfResponse, showTelepointer: showTelepointer, providerFactory: providerFactory, schema: schema }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7659f8d588b0497$export$8ce5f720dc007208), {
        schema: schema,
        jsonDocument: adfResponse,
        showTelepointer: showTelepointer,
        providerFactory: providerFactory
    });
}




// the scroll parent element and scrollable content height
const $8867d6c0228bd6b5$var$AK_EDITOR_CONTENT_AREA_SELECTOR = '.ak-editor-content-area'; /**
                                                                    * Scroll margin is used to ensure that the modal won't be
                                                                    * too close to the top of the editor, which may sometimes
                                                                    * cover the modal slightly.
                                                                    */ 
const $8867d6c0228bd6b5$var$scrollMarginStyles = null;
const $8867d6c0228bd6b5$var$gridStyles = null;
function $8867d6c0228bd6b5$export$9c279fd5d5bced59({ mountDecorations: mountDecorations, updateStream: updateStream, parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, title: title, latestPrompt: latestPrompt, promptTrigger: promptTrigger, refinementCount: refinementCount, latestPromptRetried: latestPromptRetried, markdown: markdown, adfResponse: adfResponse, adfResponseNodeWrappers: adfResponseNodeWrappers, idMap: idMap, contextStatistics: contextStatistics, hideLoadingScreen: hideLoadingScreen, api: api }) {
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { configItem: configItem, editorView: editorView, providerFactory: providerFactory, sendToAIExperienceMachine: sendToAIExperienceMachine, editorPluginAIProvider: editorPluginAIProvider, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, isUserScroll: isUserScroll, isProgrammaticScroll: isProgrammaticScroll, appearance: appearance } = aiExperienceCommonData;
    const schema = editorView.state.schema;
    const nextSessionId = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId);
    (0, $42omo.useEffect)(()=>{
        if (mountDecorations) return mountDecorations();
        return ()=>{};
    }, [
        mountDecorations
    ]);
    const { mounted: isRovoMounted, streaming: isRovoStreaming } = (0, $5gEqE.useUIStore)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const disclaimer = (0, $ae9409607dcc8014$export$b38eff301cbfa415)({
        editorPluginAIProvider: editorPluginAIProvider
    });
    const presetPromptLabel = (0, $c2200b5407d4af9f$export$4539b8c6808af330)(configItem, formatMessage);
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const [preview, setPreview] = (0, $42omo.useState)();
    const [hasPreview, setHasPreview] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)(null); // raf is used for debouncing, if useEffect is called
    // multiple times before raf is run this prevents rendering
    // multiple times if we receive streams very quickly
    const raf = (0, $42omo.useRef)();
    const errorReported = (0, $42omo.useRef)(false); /**
                                                 * scrollParentRef is for
                                                 * storing the scroll parent element once its found
                                                 * to be re-used in calculations
                                                 */ 
    const scrollParentRef = (0, $42omo.useRef)(null);
    const initialScrollTop = (0, $42omo.useRef)(0);
    const modalOffsetTop = (0, $42omo.useRef)(0);
    const isModalAtTop = (0, $42omo.useRef)(false);
    const scrollModalAlignBottom = (0, $42omo.useCallback)((modalEl, scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current + modalEl.scrollHeight - scrollParentEl.offsetHeight,
            behavior: 'instant'
        });
    }, [
        isProgrammaticScroll
    ]);
    const scrollModalToTop = (0, $42omo.useCallback)((scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current - (0, $e1bfb729a95c0d28$export$9a9d72a255528f),
            behavior: 'instant'
        });
    }, [
        isProgrammaticScroll
    ]);
    (0, $42omo.useEffect)(()=>{
        /**
     * Set up ResizeObserver to detect cases where the editor content grows,
     * as it will normally trigger a scroll event due to scrollHeight and scrollTop changes.
     * We set isProgrammaticScroll to true to flag it as a non-user scroll.
     */ const editorContentArea = editorView.dom.closest($8867d6c0228bd6b5$var$AK_EDITOR_CONTENT_AREA_SELECTOR);
        if (!editorContentArea) return;
        const resizeObserver = new ResizeObserver(()=>{
            isProgrammaticScroll.current = true;
        });
        resizeObserver.observe(editorContentArea);
        return ()=>resizeObserver.unobserve(editorContentArea);
    }, [
        editorView,
        isProgrammaticScroll
    ]); /**
                                           * Editor AI can be invoked directly into this Loading screen.
                                           * ExperienceApplication calls scrollIntoView
                                           * (currently only when platform_editor_ai_scroll_into_view_fix is on, when off it is triggered from UserInputCommandPalette)
                                           *
                                           * We need to check whether scrollIntoView is complete to determine when to track user scrolling for the auto-scroll logic
                                           * that prevents scroll-jacking when a user scrolls away.
                                           */ 
    // const [isScrollIntoViewSettled, setIsScrollIntoViewSettled] = useState(false);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_scroll_into_view_fix')) return;
        const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = (0, $7YjFd.findOverflowScrollParent)(modalEl);
        if (!scrollParentEl) return;
        const settleScroll = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            // setIsScrollIntoViewSettled(true);
            /**
       * Once it's settled, we can unbind
       * as we only need to check when it first loads
       *
       * This is to emulate scrollEnd which is not supported
       * across all browsers at the moment.
       *
       * unbind taken from the bind function below
       */ unbind();
        }, 250);
        const unbind = (0, $fFa3V.bind)(scrollParentEl, {
            type: 'scroll',
            listener: settleScroll
        });
    }, []);
    function scrollModalIntoView() {
        /**
     * Early exits:
     * - If user has manually scrolled, stop auto-scrolling
     * - If modal has reached the top of the editor, no more calculations or scrolling needed
     */ if (isUserScroll.current || isModalAtTop.current) return;
        const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = scrollParentRef.current;
        if (!scrollParentEl) return;
         // Check if modal is already fully visible
        const isModalFullyVisible = scrollParentEl.offsetHeight > modalOffsetTop.current + modalEl.scrollHeight; /**
                                                                                                              * Check if modal height exceeds scroll parent's height
                                                                                                              * Scroll margin is used to prevent the modal from being scrolled to the top
                                                                                                              * and should match scroll margin in other modals e.g. from
                                                                                                              * packages/editor/editor-plugin-ai/src/ui/components/FloatingContainer/styles.ts
                                                                                                              */ 
        const isModalFullHeight = scrollParentEl.offsetHeight - (0, $e1bfb729a95c0d28$export$9a9d72a255528f) < modalEl.scrollHeight;
        if (isModalFullyVisible) return;
        if (isModalFullHeight) {
            scrollModalToTop(scrollParentEl);
            isModalAtTop.current = true;
            return;
        }
        scrollModalAlignBottom(modalEl, scrollParentEl);
    }
    const adfResponseRef = (0, $42omo.useRef)(adfResponse);
    adfResponseRef.current = adfResponse;
    const pmFragmentRef = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        /* eslint-disable @atlaskit/platform/no-preconditioning */ if (adfResponseRef.current && updateStream && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') && (0, $dh538.fg)('platform_editor_ai_aifc_background')) {
            const pmFragment = (0, $5c0ab2c2b5c994a4$export$d53ec95625564c92)({
                schema: schema,
                adfResponse: adfResponseRef.current,
                adfResponseNodeWrappers: adfResponseNodeWrappers
            }); // don't update stream if the pmFragment is the same.
            if (!pmFragmentRef.current || !pmFragmentRef.current.eq(pmFragment)) {
                pmFragmentRef.current = pmFragment;
                isProgrammaticScroll.current = true;
                updateStream({
                    fragment: pmFragment,
                    isFinalStream: false,
                    hasUserScrolled: isUserScroll.current
                });
            }
            return;
        } /* eslint-enable @atlaskit/platform/no-preconditioning */ 
        // only run the callback if the raf has not been set, and then
        // reset raf to undefined
        if (raf.current === undefined) raf.current = window.requestAnimationFrame(()=>{
            let _preview;
            raf.current = undefined;
            if (adfResponseRef.current && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products')) {
                if (updateStream) {
                    const pmFragment = (0, $5c0ab2c2b5c994a4$export$d53ec95625564c92)({
                        schema: schema,
                        adfResponse: adfResponseRef.current,
                        adfResponseNodeWrappers: adfResponseNodeWrappers
                    }); // Do not merge below two if conditions. When gate is on, don't want to update stream if the pmFragment is the same.
                    if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                        if (!pmFragmentRef.current || !pmFragmentRef.current.eq(pmFragment)) {
                            pmFragmentRef.current = pmFragment;
                            isProgrammaticScroll.current = true;
                            updateStream({
                                fragment: pmFragment,
                                isFinalStream: false,
                                hasUserScrolled: isUserScroll.current
                            });
                        }
                    } else {
                        isProgrammaticScroll.current = true;
                        updateStream({
                            fragment: pmFragment,
                            isFinalStream: false,
                            hasUserScrolled: isUserScroll.current
                        });
                    }
                } else _preview = (0, $e63c465153c397bc$export$5ae44876b720d032)({
                    adfResponse: adfResponseRef.current,
                    showTelepointer: true,
                    providerFactory: providerFactory
                });
            } else if (!markdown || markdown === '') // When there is no streamed preview content -- set the preview to
            // undefined.
            // This allows a nicer loading screen (rather than showing an empty paragraph).
            _preview = undefined;
            else {
                const { pmFragment: pmFragment } = (0, $6537ba32a2b947a8$export$a08e8b3dacf7ffcc)({
                    markdown: markdown,
                    schema: schema,
                    source: 'loading',
                    fireAIAnalyticsEvent: (event)=>{
                        if (!errorReported.current) {
                            errorReported.current = true;
                            fireAIAnalyticsEvent(event);
                        }
                    },
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    idMap: idMap
                }); /**
               * Hold off on setting the preview if we appear to be receiving
               * a custom tag through our stream. This is to hide raw tags from
               * users until the tags are complete and can be rendered back into nodes.
               */ 
                if ((0, $a0122b81a4611d41$export$bde720e3489117f9)(markdown)) return;
                if (updateStream) {
                    isProgrammaticScroll.current = true;
                    updateStream({
                        fragment: pmFragment,
                        isFinalStream: false,
                        hasUserScrolled: isUserScroll.current
                    });
                } else _preview = (0, $e63c465153c397bc$export$f5e3af6d625de7a)({
                    schema: schema,
                    pmFragment: pmFragment,
                    showTelepointer: true,
                    providerFactory: providerFactory
                });
            }
            if (_preview) {
                setPreview(_preview);
                setHasPreview(true);
                window.requestAnimationFrame(()=>{
                    scrollModalIntoView();
                });
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        markdown,
        updateStream,
        adfResponse
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // if the component is unmounted before the raf callback
            // has run, we cancel it
            if (raf.current) window.cancelAnimationFrame(raf.current);
        };
    }, []); // preset prompt or base generate / interrogation
    const localizedLatestPrompt = (0, $62aff15c20d44eff$export$6399b1de54f080ad)(latestPrompt);
    const promptStatistics = (0, $b51c49163805cfe9$export$4e4614f0417d7178)(localizedLatestPrompt);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$f06fb39743945e19)({
        needUpdatedArgs: true,
        stepName: 'loading',
        attributes: {
            promptType: promptTrigger,
            latestPromptRetried: latestPromptRetried,
            refinementCount: refinementCount,
            modelIO: {
                contextStatistics: contextStatistics,
                userInputCharacterCount: promptStatistics?.totalCharacterCount,
                userInputNodeCounts: promptStatistics?.nodeCounts,
                userInputLinksCount: promptStatistics?.linksCount,
                userInputMentionsCount: promptStatistics?.mentionsCount
            },
            includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage
        }
    });
    const previewBecameAvailable = (0, $42omo.useRef)();
    if (!previewBecameAvailable.current && hasPreview) previewBecameAvailable.current = performance.now();
    (0, $42omo.useEffect)(()=>{
        const noPreviewAvailable = performance.now();
        return ()=>{
            if (!previewBecameAvailable.current) return;
            analyticsFlow.addAttributes({
                durations: {
                    timeSpentWithoutPartialPreview: previewBecameAvailable.current - noPreviewAvailable,
                    timeSpentWithPartialPreview: performance.now() - previewBecameAvailable.current
                }
            });
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onCancel = (0, $42omo.useCallback)(()=>{
        sendToAIExperienceMachine({
            type: 'enable discard'
        });
    }, [
        sendToAIExperienceMachine
    ]);
    const isRovoStreamingActive = isRovoMounted && isRovoStreaming;
    const shouldHideLoadingScreen = isRovoStreamingActive || !!hideLoadingScreen;
    if (nextSessionId) return null;
    return /*#__PURE__*/ $42omo.createElement("div", {
        ref: containerRef,
        className: (0, $gMc0m.default)([
            "_j4orxy5q",
            "_1e0c11p5"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $7JKll.MemoLoadingScreen), {
        parentPresetPromptLabel: parentPresetPromptLabel,
        childShortTitle: childShortTitle,
        presetPromptLabel: presetPromptLabel,
        latestPrompt: localizedLatestPrompt,
        agent: configItem?.agent,
        title: title,
        preview: preview,
        providerFactory: providerFactory,
        disclaimer: disclaimer,
        onCancel: onCancel,
        schema: schema,
        isStreaming: !!adfResponse || !!markdown,
        canInlineStreamChanges: true,
        hideLoadingScreen: shouldHideLoadingScreen,
        appearance: appearance,
        isAIFC: true
    }));
}














/* NoImprovement.tsx generated by @compiled/babel-plugin v0.36.1 */ 


































var $9779640b27fbd79f$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    noImprovementMessage: {
        id: "fabric.editor.ai.screens.noImprovement.noImprovementMessage",
        defaultMessage: "No improvements, nice work."
    },
    successIconLabel: {
        id: "fabric.editor.ai.screens.noImprovement.successIconLabel",
        defaultMessage: "Success"
    }
});


const $7ec4d4d42e83e3c1$var$noImprovementFloatingContainerStyle = null;
const $7ec4d4d42e83e3c1$var$fadeOutStyle = null;
const $7ec4d4d42e83e3c1$var$noImprovementStyles = {
    container: "_zulpu2gc _1e0c1txw _2lx2vrvc _u5f31b66 _19bv1b66",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulpu2gc _1e0c1txw _2lx2vrvc _1bah1y6m _4cvr1h6o _ca0q12x7 _u5f31b66 _n3td12x7 _19bv1b66"
};
const $7ec4d4d42e83e3c1$export$fbc3425fa4d2d058 = ({ isHidden: isHidden, onceFade: onceFade, appearance: appearance })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [containerElement, setContainerElement] = (0, $42omo.useState)(null);
    const setRootContainer = (element)=>{
        setContainerElement(element);
    }; // Scroll the no improvement screen into view if it's not fully visible
    (0, $42omo.useEffect)(()=>{
        if (containerElement) containerElement.scrollIntoView({
            block: 'nearest'
        });
    }, [
        containerElement
    ]); // Handle fade animation completion
    (0, $42omo.useEffect)(()=>{
        if (isHidden && onceFade && containerElement) {
            const handleTransitionEnd = (event)=>{
                if (event.propertyName === 'opacity') onceFade();
            };
            const unbind = (0, $fFa3V.bind)(containerElement, {
                type: 'transitionend',
                listener: handleTransitionEnd
            });
            return unbind;
        }
    }, [
        isHidden,
        onceFade,
        containerElement
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40sdH.FloatingContainer), {
        ref: setRootContainer,
        "data-testid": "no-improvement-screen",
        className: (0, $gMc0m.default)([
            "_v564168n _j4orxy5q _10fp1h6o _1bsb1ns9",
            isHidden && "_tzy4idpf",
            (0, $kuYGt.AI_MODAL_SCREEN_CLASS)
        ]),
        rainbowBorder: false,
        appearance: appearance,
        isAIFC: true,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            xcss: $7ec4d4d42e83e3c1$var$noImprovementStyles.container,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: formatMessage((0, $9779640b27fbd79f$export$2e2bcd8739ae039).successIconLabel)
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    xcss: $7ec4d4d42e83e3c1$var$noImprovementStyles.content,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                                label: formatMessage((0, $9779640b27fbd79f$export$2e2bcd8739ae039).successIconLabel),
                                color: "var(--ds-icon-success, #6A9A23)"
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: formatMessage((0, $9779640b27fbd79f$export$2e2bcd8739ae039).noImprovementMessage)
                        })
                    ]
                })
            ]
        })
    });
};










function $913868fa5814d0bf$export$a283bcbda9880df6({ discardStream: discardStream, aiExperienceMachineContext: aiExperienceMachineContext }) {
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { endExperience: endExperience, editorView: editorView, appearance: appearance, lastTriggeredFrom: lastTriggeredFrom } = aiExperienceCommonData;
    const { channelId: channelId, configItem: configItem } = aiExperienceMachineContext;
    const [isHidden, setIsHidden] = (0, $42omo.useState)(false);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    (0, $42omo.useEffect)(()=>{
        // We must fire a viewed event to ensure the AI interaction is counted toward MAU stats. Even though nothing has changed on
        // screen we still count this as the user having seen the result.
        fireAIAnalyticsEvent({
            payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                action: (0, $d925B.ACTION).VIEWED,
                interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                experienceName: (0, $6gJll.convertExperienceName)(configItem.key.toString()),
                isProactive: false,
                attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                    init: false
                }),
                invokedFrom: lastTriggeredFrom,
                traceIds: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? analyticsFlow.getCommonAttributes().traceIds : undefined
            })
        });
        discardStream?.({
            restoreSelection: false
        });
        const timer = setTimeout(()=>{
            setIsHidden(true);
        }, 1000);
        return ()=>clearTimeout(timer);
    }, [
        editorView,
        discardStream,
        channelId,
        configItem,
        lastTriggeredFrom,
        analyticsFlow,
        fireAIAnalyticsEvent
    ]);
    // TODO: EDITOR-1085 - Add analytics for no improvement screen
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ec4d4d42e83e3c1$export$fbc3425fa4d2d058), {
        isHidden: isHidden,
        onceFade: endExperience,
        appearance: appearance
    });
}


/* PreviewScreenWithLogic.tsx generated by @compiled/babel-plugin v0.36.1 */ 





























var $cMZNY = parcelRequire("cMZNY");




const $419edf111d0cfe8d$var$toDOM = (fragment, schema)=>{
    return (0, $5SAOw.DOMSerializer).fromSchema(schema).serializeFragment(fragment);
};
/**
 * Copied and amended from platform/packages/editor/editor-plugin-paste/src/pm-plugins/clipboard-text-serializer.ts
 */ function $419edf111d0cfe8d$var$clipboardTextSerializer(fragment) {
    let text = '';
    const blockSeparater = '\n\n';
    fragment.nodesBetween(0, fragment.size, (node)=>{
        if (node.type.isBlock) text += blockSeparater;
        if (node.type.name === 'paragraph') return true;
        else if (node.type.name === 'hardBreak') text += '\n';
        else if (node.type.name === 'text') text += node.text;
        else if (node.type.name === 'inlineCard') text += node.attrs.url;
        else if (node.type.name === 'blockCard') text += node.attrs.url;
        else text += node.textBetween(0, node.content.size, '\n\n');
        return false;
    });
    return text.trim();
}
function $419edf111d0cfe8d$export$a707cf6ca97554ae({ editorView: editorView, pmFragment: pmFragment }) {
    const transaction = editorView.state.tr;
    const domNode = $419edf111d0cfe8d$var$toDOM(pmFragment, editorView.state.schema);
    if (domNode) {
        const div = document.createElement('div');
        div.appendChild(domNode);
        // The "0 0" refers to the start and end depth of the slice
        // since we're copying the block node only, it will always be 0 0
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        div.firstChild.setAttribute('data-pm-slice', '0 0 []');
        /**
		 * ED-18062: override the plain text in
		 * copyHTMLToClipboard using clipboardTextSerializer(pmFragment)
		 * because HTML to plain text is formatted without new lines
		 * in certain nodes such as lists
		 */ (0, $cMZNY.copyHTMLToClipboard)(div, $419edf111d0cfe8d$var$clipboardTextSerializer(pmFragment));
    }
    transaction.setMeta('scrollIntoView', false);
    editorView.dispatch(transaction);
}





/* Preview.tsx generated by @compiled/babel-plugin v0.36.1 */ // Entry file
/* eslint-disable @atlaskit/editor/no-re-export */ /** @jsxFrag */ 









var $kB2tR = parcelRequire("kB2tR");



















/* ButtonWithShortcut.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $eEA8O = parcelRequire("eEA8O");







/* Shortcut.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







const $fb6ab6e57de2ff7c$var$styleUnbounded = null;
const $fb6ab6e57de2ff7c$var$style = null;
function $fb6ab6e57de2ff7c$export$59451aa6b6270879({ shortcut: shortcut }) {
    const formattedShortcut = (0, $hgeg8.formatShortcut)(shortcut);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_2rko12b0 _syazazsu _bfhki8nm _k48pi7a9",
            "_ca0q1l7b _u5f31l7b _n3td1l7b _19bv1l7b _18u0i2wt"
        ]),
        children: formattedShortcut
    });
}


/**
 * Checks if a keyboard event matches a given shortcut.
 *
 * @param event - The keyboard event to check.
 * @param shortcut - The shortcut string to match against (e.g., "Ctrl-Shift-A").
 * @returns True if the event matches the shortcut, false otherwise.
 */ function $2ade9a5d68269bab$export$b6ac0c7de16a0eb8(event, shortcut) {
    const parts = shortcut.split('-');
    const key = parts.pop();
    const mods = new Set(parts);
    if (event.key !== key) return false;
    if (mods.has('Mod') !== event.metaKey) return false;
    if (mods.has('Shift') !== event.shiftKey) return false;
    if (mods.has('Alt') !== event.altKey) return false;
    if (mods.has('Ctrl') !== event.ctrlKey) return false;
    return true;
}


const $ab92869aa5ca99ad$var$buttonAutoFocusRingFix = null;
const $ab92869aa5ca99ad$var$forceFocusRingStyles = null;
function $ab92869aa5ca99ad$export$3ca6788437e93171({ shortcut: shortcut, children: children, forceFocusRing: forceFocusRing, buttonAutoFocusRing: buttonAutoFocusRing, onClick: onClick, ...rest }) {
    (0, $42omo.useEffect)(()=>{
        const listener = (event)=>{
            if (shortcut?.common && (0, $2ade9a5d68269bab$export$b6ac0c7de16a0eb8)(event, shortcut.common)) {
                event.preventDefault();
                event.stopPropagation();
                onClick?.();
            }
        };
        return (0, $fFa3V.bind)(document, {
            type: 'keydown',
            listener: listener
        });
    }, [
        onClick,
        shortcut
    ]);
    const content = (0, $42omo.useMemo)(()=>{
        if (!shortcut) return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: children
        });
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "aria-keyshortcuts": browser.mac ? shortcut?.mac : shortcut?.windows,
                    children: children
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb6ab6e57de2ff7c$export$59451aa6b6270879), {
                        shortcut: shortcut
                    })
                })
            ]
        });
    }, [
        shortcut,
        children
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    ), {
        onClick: onClick,
        ...rest,
        className: (0, $gMc0m.default)([
            forceFocusRing && "_7br8dfik _5wkdv77o",
            buttonAutoFocusRing && "_15y8dfik _2en4v77o"
        ]),
        children: content
    });
}


/* CopyIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $2MuFw = parcelRequire("2MuFw");




var $6d869f2d458e30a9$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    copy: {
        id: "fabric.editor.ai.config.item.action.copyResponse",
        defaultMessage: "Copy"
    },
    copied: {
        id: "fabric.editor.ai.config.item.action.responseCopied",
        defaultMessage: "Copied!"
    },
    copiedToClipboard: {
        id: "fabric.editor.ai.config.item.action.responseCopiedToClipboard",
        defaultMessage: "Copied to clipboard"
    }
});


const $f0460d394892f7ed$export$dcd7ef7785e10577 = ({ onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [tooltip, setTooltip] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(formatMessage((0, $6d869f2d458e30a9$export$2e2bcd8739ae039).copy));
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        onClick(event);
        setTooltip(formatMessage((0, $6d869f2d458e30a9$export$2e2bcd8739ae039).copiedToClipboard));
    }, [
        onClick,
        formatMessage
    ]);
    const resetTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>setTooltip(formatMessage((0, $6d869f2d458e30a9$export$2e2bcd8739ae039).copy)), [
        formatMessage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        tooltip
    ]);
    const tooltipOptions = {
        position: 'top',
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltip;
        },
        onHide: resetTooltip
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        testId: "copy-response-button",
        type: "button",
        onClick: handleOnClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
        label: tooltip,
        appearance: appearance,
        spacing: spacing,
        tabIndex: tabIndex,
        isTooltipDisabled: false,
        tooltip: tooltipOptions
    });
};







var $jHWjW = parcelRequire("jHWjW");


var $8PgnR = parcelRequire("8PgnR");

/* PromptForm.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /** @jsxfrag */ 














var $hbEec = parcelRequire("hbEec");








var $9q1Mo = parcelRequire("9q1Mo");

/* PromptEditorWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 











const $2676c5921c742a31$var$promptEditorWrapperStylesUnbounded = null;
const $2676c5921c742a31$var$promptEditorWrapperStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $2676c5921c742a31$var$promptEditorWrapperOverflowStyles = null; // The types PromptEditorType should mirror what is in the editor-ai-injected-editors package
const $2676c5921c742a31$export$b0a649d08575ac09 = ({ type: type, PromptEditor: PromptEditor, defaultValue: defaultValue, autoFocus: autoFocus, focusInputRef: focusInputRef, blurInputRef: blurInputRef, clearInputRef: clearInputRef, placeholder: placeholder, enableLinks: enableLinks, onInputChange: onInputChange, onADFChange: onADFChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, submit: submit, isAIFC: isAIFC })=>{
    const setFocusHandlers = (0, $42omo.useCallback)((blur, focus)=>{
        if (blurInputRef) blurInputRef.current = blur;
        if (focusInputRef) focusInputRef.current = focus;
    }, [
        blurInputRef,
        focusInputRef
    ]);
    const setClearHandler = (0, $42omo.useCallback)((clear)=>{
        if (clearInputRef) clearInputRef.current = clear;
    }, [
        clearInputRef
    ]); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const componentId = (0, $42omo.useMemo)(()=>`${placeholder}-${(0, $dQl1W.v4)()}`, [
        placeholder
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "ai-experience-prompt-input",
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c11p5 _kqswh2mm",
            "_1hxngktf _hmumidpf _12k3idpf _q5yz1wug _dcw6idpf _2ih3idpf",
            "_w79o1m6u _1hxn1tcg"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)(PromptEditor, {
            type: type,
            autoFocus: autoFocus,
            defaultValue: defaultValue,
            placeholder: placeholder,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            setFocusHandlers: setFocusHandlers,
            setClearHandler: setClearHandler,
            enableLinks: enableLinks,
            submit: submit,
            isAIFC: isAIFC
        }, componentId)
    });
};


/* SubmitButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $4fdTR = parcelRequire("4fdTR");







parcelRequire("42omo");

const $b08c7be14e35e8a5$var$Enter = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M4.63477 11.2256C5.12012 11.2256 5.44141 10.8906 5.44141 10.4326C5.44141 10.1729 5.33203 9.98828 5.18164 9.83789L4.18359 8.86719L3.41113 8.24512L4.61426 8.2998H10.9102C12.4688 8.2998 13.1387 7.62988 13.1387 6.07129V2.89258C13.1387 1.33398 12.4688 0.657227 10.9102 0.657227H8.06641C7.58105 0.657227 7.21875 1.0332 7.21875 1.49121C7.21875 1.95605 7.58105 2.33203 8.06641 2.33203H10.835C11.3135 2.33203 11.5049 2.5166 11.5049 3.00195V5.96191C11.5049 6.44043 11.3135 6.63184 10.835 6.63184H4.61426L3.41113 6.68652L4.18359 6.06445L5.18164 5.10059C5.33203 4.94336 5.44141 4.76562 5.44141 4.50586C5.44141 4.04785 5.12012 3.70605 4.63477 3.70605C4.42285 3.70605 4.19727 3.80176 4.0332 3.96582L1.10742 6.85059C0.950195 7.00781 0.861328 7.24023 0.861328 7.46582C0.861328 7.69141 0.950195 7.93066 1.10742 8.08105L4.0332 10.9658C4.19727 11.1367 4.42285 11.2256 4.63477 11.2256Z",
            fill: "currentColor"
        })
    });
var $b08c7be14e35e8a5$export$2e2bcd8739ae039 = $b08c7be14e35e8a5$var$Enter;





var $df1dec83f4c60008$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    submitLabel: {
        id: "fabric.editor.ai.screens.prompt.submitLabel",
        defaultMessage: "Submit"
    },
    submitTooltip: {
        id: "fabric.editor.ai.screens.prompt.submitTooltip",
        defaultMessage: "Send to AI"
    }
});


const $265d55187973d7e1$export$8b7b7cdfb85d78c5 = ({ disabled: disabled, tabIndex: tabIndex, onClick: onClick, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const icon = isAIFC ? (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))) : (0, $b08c7be14e35e8a5$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage((0, $df1dec83f4c60008$export$2e2bcd8739ae039).submitTooltip),
        hideTooltipOnClick: true,
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            label: formatMessage((0, $df1dec83f4c60008$export$2e2bcd8739ae039).submitLabel),
            onClick: onClick,
            testId: "submit-icon-button",
            isDisabled: disabled,
            icon: icon,
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex
        })
    });
};





var $f5a9d679cc9fd470$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    logo: {
        id: "fabric.editor.ai.commandPalette.promptForm.logo",
        defaultMessage: "Atlassian Intelligence Logo"
    }
});


const $964c4428d6c8e6f2$var$commonTextStyles = null;
const $964c4428d6c8e6f2$var$formGapStyles = null; // Make form height equals the height of its parent to prevent the form from growing out of the parent
const $964c4428d6c8e6f2$var$formHeightStyles = null; // Prevent form inner from growing out of form
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $964c4428d6c8e6f2$var$formInnerHeightStyles = null; // input's line-height is 20px, logo/button's height is 24px, need to adjust the height
const $964c4428d6c8e6f2$var$nextToInputStyles = null;
const $964c4428d6c8e6f2$var$selfStartStyles = null;
const $964c4428d6c8e6f2$var$formContainerStyles = null;
const $964c4428d6c8e6f2$var$newPaletteStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $964c4428d6c8e6f2$var$formStyles = null;
const $964c4428d6c8e6f2$var$formPaddingTopStyles = null;
const $964c4428d6c8e6f2$var$formInnerStyles = null;
const $964c4428d6c8e6f2$var$formInnerPaddingTopStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $964c4428d6c8e6f2$var$buttonWrapperStyles = null;
const $964c4428d6c8e6f2$export$416523684d97c4ad = ({ type: type = 'user-input', onFormSubmit: onFormSubmit, value: value = '', showButtons: showButtons = true, tag: tag, autoFocus: autoFocus = true, onInputChange: onInputChange, onADFChange: onADFChange, onInputFocus: onInputFocus, onInputBlur: onInputBlur, placeholder: placeholder, focusInputRef: focusInputRef, clearInputRef: clearInputRef, showLogo: showLogo = true, onInputKeyDown: onInputKeyDown, adfValue: adfValue, enableLinks: enableLinks, PromptEditor: PromptEditor, showBack: showBack, onBack: onBack, onInputKeyUp: onInputKeyUp, fireParentActionButton: fireParentActionButton, focusParentActionButton: focusParentActionButton, refinementTagRef: refinementTagRef, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [setBreakpointElement, { breakpoint: breakpoint }] = (0, $imfiV.useElementBreakpoints)();
    const blurInputRef = (0, $42omo.useRef)(undefined);
    const [isComposing, setIsComposing] = (0, $42omo.useState)(false);
    const [isLozengeSelected, setIsLozengeSelected] = (0, $42omo.useState)(false);
    const lastAdfValue = (0, $42omo.useRef)((0, $b4emg.getEmptyADF)());
    const isPromptInputEmpty = Boolean((0, $hbEec.isEmpty)(lastAdfValue?.current) && adfValue && (0, $hbEec.isEmpty)(adfValue));
    const handleOnCompositionStart = (0, $42omo.useCallback)(()=>{
        setIsComposing(true);
    }, []);
    const handleOnCompositionEnd = (0, $42omo.useCallback)(()=>{
        setIsComposing(false);
    }, []);
    const handleKeyUp = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (isPromptInputEmpty && focusParentActionButton) focusParentActionButton(true);
        onInputKeyUp && onInputKeyUp(event);
    }, [
        focusParentActionButton,
        onInputKeyUp,
        isPromptInputEmpty
    ]);
    const handleInputFocus = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        setIsLozengeSelected(false);
        if (onInputFocus) onInputFocus();
    }, [
        onInputFocus
    ]);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        /**
     * If the key is printable or escape, we should remove the focus ring
     * that is applied to the parent insert or replace button
     */ if ((event.key.length === 1 || event.key === 'Escape') && focusParentActionButton) focusParentActionButton(false);
        if (event.key === 'Backspace' && onBack) {
            // This shortcuts the default functionality by placing focus on the refinement tag
            // instead of removing the tag
            if (!isLozengeSelected && isPromptInputEmpty && refinementTagRef?.current) {
                refinementTagRef.current.getElementsByTagName('button')[0].focus();
                setIsLozengeSelected(true);
                return;
            }
            event.stopPropagation();
            if (isPromptInputEmpty) onBack();
        }
        if (event.key === 'Enter' && [
            event.altKey,
            event.metaKey,
            event.ctrlKey
        ].every((isPressed)=>!isPressed)) {
            event.stopPropagation(); // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            if (isComposing) return;
             // If the prompt input is empty, we should fire the parent action button
            // on Enter, which will either be replace or insert
            if (isPromptInputEmpty && fireParentActionButton) {
                fireParentActionButton();
                return;
            } // Handles a case where the user presses enter if refinement tag's close button or the
            // cancel button is focused
            if ([
                'close-button-refinement-tag',
                'cancel-icon-button',
                'cancel-esc-button',
                'back-icon-button'
            ].includes(target.getAttribute('data-testid') ?? '')) return;
             // Handles every other case that is not a "shift + enter"
            if (!event.shiftKey) {
                event.preventDefault();
                onFormSubmit(value);
            }
        } /**
       * Return focus back to the input if the user is typing
       * and the refinement tag removing button is focused.
       */ 
        if (![
            'Enter',
            'Backspace',
            'Tab'
        ].includes(event.key) && refinementTagRef?.current && refinementTagRef.current.contains(document.activeElement)) document.getElementById('ak-editor-textarea')?.focus();
    }, [
        focusParentActionButton,
        onBack,
        refinementTagRef,
        isLozengeSelected,
        isPromptInputEmpty,
        isComposing,
        fireParentActionButton,
        onFormSubmit,
        value
    ]);
    const onADFChange_ = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((input)=>{
        lastAdfValue.current = adfValue ?? (0, $b4emg.getEmptyADF)();
        if (onADFChange) onADFChange(input);
    }, [
        onADFChange,
        adfValue
    ]);
    const onInputChange_ = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((newValue)=>{
        if (onInputChange) onInputChange(newValue);
    }, [
        onInputChange
    ]);
    const handleSubmitClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        onFormSubmit(value);
    }, [
        onFormSubmit,
        value
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // ED-19496: We avoid propagating enter keypresses
    , {
        // since products like Bitbucket might have parent forms
        // that listen for keydown events to trigger form submission
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: setBreakpointElement,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1y6m _4cvr1y6m"
        ]),
        children: [
            showLogo && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_19pk1i6y _otyr1i6y _1e0c1txw _2lx2vrvc _2hwx1b66 _4cvr1h6o _1wpz1wug",
                    breakpoint <= (0, $imfiV.Breakpoint).Small && "_1wpzynz6"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                    color: "var(--ds-icon, #292A2E)",
                    label: formatMessage((0, $f5a9d679cc9fd470$export$2e2bcd8739ae039).logo),
                    spacing: "spacious"
                })
            }),
            showBack && /*#__PURE__*/ (0, $l998X.jsx)((0, $9q1Mo.BackIconButton), {
                inPromptHeader: true,
                stopPropagation: true,
                onClick: onBack
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: (0, $gMc0m.default)([
                    "_rcujidpf _o81cidpf _1l6uidpf _149midpf _1vhmkb7n _tqf3kb7n _1rnvf1ug _if291txw _2b921bp4",
                    "_zulp1b66",
                    showLogo && "_ca0qv77o",
                    "_4t3i1osq",
                    type === 'interrogate' && isAIFC && "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp",
                    "ai-modal-prompt-form"
                ]),
                "data-testid": "ai-modal-prompt-form",
                children: [
                    tag,
                    /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            "_11c8fhey _1nmz1hna",
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
                            !!tag && "_ca0q1b66",
                            "_1tkeidpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2676c5921c742a31$export$b0a649d08575ac09), {
                                PromptEditor: PromptEditor,
                                type: type,
                                focusInputRef: focusInputRef,
                                blurInputRef: blurInputRef,
                                clearInputRef: clearInputRef,
                                autoFocus: autoFocus,
                                defaultValue: adfValue,
                                onInputChange: onInputChange_,
                                onADFChange: onADFChange_,
                                placeholder: placeholder,
                                onFocus: handleInputFocus,
                                onBlur: onInputBlur,
                                onKeyDown: onInputKeyDown,
                                onCompositionStart: handleOnCompositionStart,
                                onCompositionEnd: handleOnCompositionEnd,
                                enableLinks: enableLinks
                            }),
                            showButtons && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    "_1aaxusic _1e0c1txw _18u01b66"
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $265d55187973d7e1$export$8b7b7cdfb85d78c5), {
                                    disabled: !value,
                                    onClick: handleSubmitClick,
                                    isAIFC: isAIFC
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/* RetryIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $d8ohW = parcelRequire("d8ohW");




var $77fa638be64783b6$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    retryPrompt: {
        id: "fabric.editor.ai.config.item.action.retryPrompt",
        defaultMessage: "Retry"
    }
});


const $054114d4e1c712d8$export$6f66175e87cc7542 = ({ onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const tooltip = formatMessage((0, $77fa638be64783b6$export$2e2bcd8739ae039).retryPrompt);
    const tooltipOptions = {
        position: 'top',
        hideTooltipOnClick: true,
        content: tooltip
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        testId: "retry-prompt-button",
        type: "button",
        onClick: onClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
        label: tooltip,
        appearance: appearance,
        spacing: spacing,
        tabIndex: tabIndex,
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        isDisabled: isDisabled
    });
};


/* ActionButtonsLayout.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 


parcelRequire("42omo");










function $63e451a97e81592b$export$1ca3f17e50a1bf69() {
    const [element, setElement] = (0, $42omo.useState)(null);
    const [result, setResult] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!element) return;
        const updateResult = (entries)=>{
            for (const entry of entries){
                const firstChild = entry.target.firstElementChild;
                if (!(firstChild instanceof HTMLElement)) {
                    setResult(false);
                    return;
                }
                const firstChildTop = firstChild.offsetTop;
                // Check that all elements in the same row, if not, set result to true.
                // We can't check the first and last element because the may have different visual position,
                // because of order CCS property.
                const isInTwoLine = Array.from(entry.target.children).some((child)=>child instanceof HTMLElement && child.offsetTop !== firstChildTop);
                setResult(isInTwoLine);
            }
        };
        const resizeObserver = new ResizeObserver(updateResult);
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        element
    ]);
    return [
        setElement,
        result
    ];
}





var $63aac829604a098b$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    logoAltText: {
        id: "fabric.editor.ai.screens.prompt.logoAltText",
        defaultMessage: "Atlassian Intelligence Logo"
    },
    logoText: {
        id: "fabric.editor.ai.screens.prompt.logoText",
        defaultMessage: "Atlassian Intelligence"
    },
    betaLabel: {
        id: "fabric.editor.ai.screens.preview.betaLabel",
        defaultMessage: "Beta"
    },
    cancelLabel: {
        id: "fabric.editor.ai.screens.preview.cancelLabel",
        defaultMessage: "Cancel"
    },
    discardLabel: {
        id: "fabric.editor.ai.screens.preview.discardLabel",
        defaultMessage: "Discard"
    },
    defaultInputPlaceholder: {
        id: "fabric.editor.ai.screens.preview.defaultAIPlaceholder",
        defaultMessage: "Tell AI what to do next"
    },
    defaultRovoInputPlaceholder: {
        id: "fabric.editor.ai.screens.preview.defaultRovoInputPlaceholder",
        defaultMessage: "Tell Rovo what to do next"
    },
    placeholderWithAgent: {
        id: "fabric.editor.ai.screens.preview.placeholderWithAgent",
        defaultMessage: "Ask {agentName} what to do next"
    },
    disclaimer: {
        id: "fabric.editor.ai.screens.preview.disclaimer",
        defaultMessage: "Information quality may vary."
    },
    disclaimerLink: {
        id: "fabric.editor.ai.screens.preview.disclaimerLink",
        defaultMessage: "Learn why"
    },
    previewScreenLabel: {
        id: "fabric.editor.ai.experience.previewScreenLabel",
        defaultMessage: "Preview"
    },
    refineButton: {
        id: "fabric.editor.ai.screens.preview.refineButton",
        defaultMessage: "Refine"
    },
    highlightDifferencesLabel: {
        id: "fabric.editor.ai.screens.preview.highlightDifferencesLabel.non-final",
        defaultMessage: "Highlight differences"
    },
    highlightDifferencesDisabledTooltip: {
        id: "fabric.editor.ai.screens.preview.highlightDifferencesDisabledTooltip.non-final",
        defaultMessage: "This feature is not available for this AI generated response."
    },
    actionButtonsAccessibleLabel: {
        id: "fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel",
        defaultMessage: "Actions for AI generated content"
    },
    actionButtonsTryAgain: {
        id: "fabric.editor.ai.screens.preview.actionButtonsTryAgain",
        defaultMessage: "Try again"
    },
    actionButtonsAccept: {
        id: "fabric.editor.ai.screens.preview.actionButtonsAccept",
        defaultMessage: "Accept"
    }
});


const $8d7c140c81666045$var$container = null;
const $8d7c140c81666045$var$secondLevelContainer = null;
const $8d7c140c81666045$var$compactSecondaryButtonsContainer = null;
function $8d7c140c81666045$export$6a458a35d6b615d0({ cancelButton: cancelButton, primaryButtons: primaryButtons, secondaryButtons: secondaryButtons }) {
    // The Discard button should be the last when there are two lines of buttons.
    //
    // We can't do it just by CSS (for example, by order prop), because CSS order doesn't
    // affect the tab order.
    // And we can't use tabindex, because tabindex is global and change order of all elements.
    // That's why we need to render the Discard button in different places in the DOM,
    // based on the number of lines. Stupid but works=(
    //
    // Also, we can't determinate the line count based on container width
    // because the amount buttons can be different.
    // That's why we use the useIsFlexElementWrapped hook to determine the line count.
    //
    // See more why CSS order and tabindex don't work: https://tink.uk/flexbox-the-keyboard-navigation-disconnect/
    const [setRootContainerElement, isRootContainerWrapped] = (0, $63e451a97e81592b$export$1ca3f17e50a1bf69)();
    const [setSecondLevelContainerElement, isSecondLevelContainerWrapped] = (0, $63e451a97e81592b$export$1ca3f17e50a1bf69)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ref: setRootContainerElement,
        role: "group",
        "aria-label": formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).actionButtonsAccessibleLabel),
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _1n261g80 _1bahesu3 _ca0qze3t"
        ]),
        children: [
            !isRootContainerWrapped && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1e0c1txw _4cvr1h6o"
                ]),
                children: secondaryButtons
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                ref: setSecondLevelContainerElement,
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1e0c1txw _1n261g80 _1bahesu3 _ca0qze3t",
                    "_18u01wug"
                ]),
                children: [
                    !isSecondLevelContainerWrapped && cancelButton,
                    primaryButtons && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_zulpu2gc _1e0c1txw _1n261g80 _1bahesu3 _ca0qze3t"
                        ]),
                        children: primaryButtons
                    }),
                    isSecondLevelContainerWrapped && cancelButton
                ]
            }),
            isRootContainerWrapped && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1e0c1txw _4cvr1h6o"
                ]),
                children: secondaryButtons
            })
        ]
    });
}


/* RefineDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 









var $52EPl = parcelRequire("52EPl");




var $5cb356ffb6967308$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    refineButton: {
        id: "fabric.editor.ai.screens.preview.refineDropdown.refineButton",
        defaultMessage: "Refine"
    }
});


/* RefineDropdownItems.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 


parcelRequire("42omo");







var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $6R5uz = parcelRequire("6R5uz");

function $a206644f87d5b962$export$99f30ba596e90ddb({ items: items, onItemClick: onItemClick, currentOpenedSubMenu: currentOpenedSubMenu, onSubMenuOpenChanged: onSubMenuOpenChanged }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
        children: items.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)($a206644f87d5b962$var$Item, {
                item: item,
                onItemClick: onItemClick,
                currentOpenedSubMenu: currentOpenedSubMenu,
                onSubMenuOpenChanged: onSubMenuOpenChanged
            }, item.title.id))
    });
}
function $a206644f87d5b962$var$Item({ item: item, onItemClick: onItemClick, currentOpenedSubMenu: currentOpenedSubMenu, onSubMenuOpenChanged: onSubMenuOpenChanged }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if ('children' in item && item.children) {
        const handleOpenChange = ({ isOpen: isOpen })=>{
            onSubMenuOpenChanged?.(item, isOpen);
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            placement: "right-start",
            shouldRenderToParent: true,
            isOpen: currentOpenedSubMenu === item,
            onOpenChange: handleOpenChange,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default // Ignored via go/ees005
                ), {
                    ...triggerProps,
                    ref: triggerRef,
                    elemBefore: item.icon,
                    elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        color: "var(--ds-icon-subtle, #505258)",
                        label: "",
                        size: "small"
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        children: formatMessage(item.title)
                    })
                }),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($a206644f87d5b962$export$99f30ba596e90ddb, {
                    items: item.children,
                    onItemClick: onItemClick
                })
            })
        });
    }
    const handleItemClick = ()=>{
        onItemClick();
        item.onClick?.();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        elemBefore: item.icon,
        onClick: handleItemClick,
        children: formatMessage(item.title)
    });
}


function $8b8a21813f13369d$export$892617147bbb1d94({ items: items, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isOpened, setIsOpened] = (0, $42omo.useState)(false);
    const [currentOpenedSubMenu, setCurrentOpenedSubMenu] = (0, $42omo.useState)(null);
    const handleOpenChange = (0, $42omo.useCallback)(({ isOpen: isOpen })=>{
        isOpen && onClick && onClick();
        setIsOpened(isOpen);
        if (!isOpen) setCurrentOpenedSubMenu(null);
    }, [
        onClick
    ]);
    const handleItemClick = (0, $42omo.useCallback)(()=>{
        setIsOpened(false);
        setCurrentOpenedSubMenu(null);
    }, []);
    const handleSubMenuOpenChanged = (0, $42omo.useCallback)((subMenu, isOpen)=>{
        setCurrentOpenedSubMenu((current)=>{
            // Close the current opened sub menu if it's not the same as the one that was clicked
            if (current === subMenu && !isOpen) return null;
            return subMenu;
        });
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        trigger: formatMessage((0, $5cb356ffb6967308$export$2e2bcd8739ae039).refineButton),
        testId: "refine-dropdown",
        shouldRenderToParent: true,
        isOpen: isOpened,
        onOpenChange: handleOpenChange,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a206644f87d5b962$export$99f30ba596e90ddb), {
            items: items,
            onItemClick: handleItemClick,
            currentOpenedSubMenu: currentOpenedSubMenu,
            onSubMenuOpenChanged: handleSubMenuOpenChanged
        })
    });
}



const $6037e01702f2a193$var$previewContainerPaddingStyles = null;
const $6037e01702f2a193$var$columnLayout = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $6037e01702f2a193$var$interrogationWrapper = null;
const $6037e01702f2a193$var$defaultPaddingStyles = null;
const $6037e01702f2a193$var$previewContainerPaddingCompact = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $6037e01702f2a193$var$previewContainerBorders = null;
const $6037e01702f2a193$var$previewFloatingContainerStyle = null;
const $6037e01702f2a193$var$mapActionAppearanceToButtonAppearance = {
    primary: 'primary',
    secondary: 'default',
    cancel: 'subtle'
};
const $6037e01702f2a193$export$9f3706359963c421 = ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, staticPromptTitle: staticPromptTitle, staticInsertedPrompt: staticInsertedPrompt, latestPrompt: latestPrompt, preview: preview, disableActions: disableActions = false, disableInterrogation: disableInterrogation = false, onSubmit: onSubmit, onCancel: onCancel, onCopy: onCopy, onRetry: onRetry, onInputFocus: onInputFocus, onInputChange: onInputChange, onADFChange: onADFChange, onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, onEditPromptClick: onEditPromptClick, onBack: onBack, onClose: onClose, showBack: showBack = true, applications: applications, isInputActive: isInputActive, inputValue: inputValue, inputADFValue: inputADFValue, PromptEditor: PromptEditor, clearInputRef: clearInputRef, providerFactory: providerFactory, schema: schema, disclaimer: disclaimer, agent: agent, onRefinementClick: onRefinementClick, refineDropdownItems: refineDropdownItems, hideHorizontalRule: hideHorizontalRule = false, showBetaLozenge: showBetaLozenge = false, isClearTitle: isClearTitle = false, canInlineStreamChanges: canInlineStreamChanges, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [forceFocusRing, setForceFocusRing] = (0, $42omo.useState)(true);
    const presetTitleString = staticPromptTitle ?? latestPrompt?.presetTitle;
    const promptString = staticInsertedPrompt ?? latestPrompt?.userInput;
    const firePrimaryApplication = ()=>{
        if (!applications) return;
        setForceFocusRing(false);
        applications[applications.length - 1].onClick();
    };
    const onInterrogateBlur = (0, $42omo.useCallback)(()=>{
        setForceFocusRing(false);
    }, []);
    const handleOnInputFocus = (0, $42omo.useCallback)(()=>{
        setForceFocusRing(true);
        if (onInputFocus) onInputFocus();
    }, [
        onInputFocus
    ]);
    const focusInputRef = (0, $42omo.useRef)(undefined);
    const initialPlaceholder = agent ? formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).placeholderWithAgent, {
        agentName: agent.name
    }) : formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).defaultRovoInputPlaceholder); // This is used to determine when to disable a number of features to prevent
    // the user from performing actions on previous responses
    const isViewingLatestResponse = !disableActions && !disableInterrogation;
    const feedbackForm = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $475e1faaefe5731f$export$ce859c56062f484c), {
            onBadResponseButtonClick: onBadResponseButtonClick,
            onGoodResponseButtonClick: onGoodResponseButtonClick
        });
    }, [
        onBadResponseButtonClick,
        onGoodResponseButtonClick
    ]);
    const actionButtons = (0, $42omo.useMemo)(()=>{
        const secondaryButtons = !disableActions && (isAIFC ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                onCopy && /*#__PURE__*/ (0, $l998X.jsx)((0, $f0460d394892f7ed$export$dcd7ef7785e10577), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onCopy
                }),
                feedbackForm,
                onRetry && /*#__PURE__*/ (0, $l998X.jsx)((0, $054114d4e1c712d8$export$6f66175e87cc7542), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onRetry
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                feedbackForm,
                onRetry && /*#__PURE__*/ (0, $l998X.jsx)((0, $054114d4e1c712d8$export$6f66175e87cc7542), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onRetry
                }),
                onCopy && /*#__PURE__*/ (0, $l998X.jsx)((0, $f0460d394892f7ed$export$dcd7ef7785e10577), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onCopy
                })
            ]
        }));
        const cancelButton = onCancel ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            testId: "discard-button",
            onClick: onCancel,
            type: "button",
            appearance: disableActions ? 'primary' : 'subtle',
            autoFocus: disableActions || applications.length === 0,
            children: formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).discardLabel)
        }) : undefined;
        let primaryButtons = !disableActions && applications.map(({ onClick: onClick, label: label, appearance: appearance, shortcut: shortcut, isDisabled: isDisabled, tooltip: tooltip }, index)=>{
            const button = /*#__PURE__*/ (0, $l998X.jsx)((0, $ab92869aa5ca99ad$export$3ca6788437e93171), {
                onClick: onClick,
                type: "button",
                shortcut: shortcut,
                autoFocus: appearance === 'primary',
                forceFocusRing: index === applications.length - 1 && forceFocusRing,
                buttonAutoFocusRing: index === applications.length - 1 && !forceFocusRing,
                appearance: $6037e01702f2a193$var$mapActionAppearanceToButtonAppearance[appearance],
                isDisabled: isDisabled,
                children: label
            }, label);
            if (tooltip) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: tooltip,
                position: "top",
                children: button
            }, `${label}-tooltip`);
            return button;
        });
        if (primaryButtons && !agent && refineDropdownItems) primaryButtons.unshift(/*#__PURE__*/ (0, $l998X.jsx)((0, $8b8a21813f13369d$export$892617147bbb1d94), {
            items: refineDropdownItems,
            onClick: onRefinementClick
        }, "refine-dropdown"));
        if (isAIFC) {
            // still brittle, assumes only 1 primary
            const primaryAction = applications.find((action)=>action.appearance === 'primary');
            if (primaryAction) {
                const acceptButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $ab92869aa5ca99ad$export$3ca6788437e93171), {
                    onClick: primaryAction?.onClick,
                    type: "button",
                    shortcut: primaryAction?.shortcut,
                    autoFocus: true,
                    appearance: "primary",
                    isDisabled: primaryAction?.isDisabled,
                    children: formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).actionButtonsAccept)
                }, (0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(primaryAction?.label));
                primaryButtons = !disableActions && [
                    acceptButton
                ];
            }
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8d7c140c81666045$export$6a458a35d6b615d0), {
            cancelButton: cancelButton,
            secondaryButtons: secondaryButtons,
            primaryButtons: primaryButtons
        });
    }, [
        disableActions,
        feedbackForm,
        onRetry,
        onCopy,
        onCancel,
        applications,
        formatMessage,
        agent,
        refineDropdownItems,
        isAIFC,
        forceFocusRing,
        onRefinementClick
    ]);
    const generatedContentPreview = /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
            hideHorizontalRule ? "_ca0qze3t" : !isAIFC && "_x3doia51 _n7zlia51"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.200",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        isAIFC && "_ca0q12x7"
                    ]),
                    children: preview
                }),
                actionButtons
            ]
        })
    });
    const promptForm = isViewingLatestResponse && PromptEditor && /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
            "_1tke1x2r _vchhusvi _247hidpf _txhsidpf _zu32idpf _16d6idpf"
        ]),
        children: isViewingLatestResponse && /*#__PURE__*/ (0, $l998X.jsx)((0, $964c4428d6c8e6f2$export$416523684d97c4ad), {
            type: "interrogate",
            showButtons: isInputActive,
            autoFocus: true,
            placeholder: `${initialPlaceholder}${isAIFC ? '...' : ''}`,
            value: inputValue,
            adfValue: inputADFValue,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onFormSubmit: onSubmit,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            onInputFocus: handleOnInputFocus,
            focusInputRef: focusInputRef,
            clearInputRef: clearInputRef,
            PromptEditor: PromptEditor,
            enableLinks: true,
            fireParentActionButton: firePrimaryApplication,
            focusParentActionButton: setForceFocusRing,
            showLogo: false,
            onInputBlur: onInterrogateBlur,
            isAIFC: isAIFC
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ , {
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _2lx21bp4 _4cvr1y6m",
            "preview-screen"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $40sdH.FloatingContainer), {
            disablePadding: true,
            "data-testid": "preview-screen",
            className: (0, $gMc0m.default)([
                "_1e0c1txw _2lx21bp4",
                `preview-screen ${(0, $kuYGt.AI_MODAL_SCREEN_CLASS)}`
            ]),
            rainbowBorder: false,
            isAIFC: isAIFC,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).previewScreenLabel)
                }),
                !isAIFC && /*#__PURE__*/ (0, $l998X.jsx)((0, $8PgnR.LatestPromptHeader), {
                    parentPresetPromptLabel: parentPresetPromptLabel,
                    childShortTitle: childShortTitle,
                    prompt: promptString,
                    promptADF: latestPrompt?.userADFInput,
                    presetTitle: presetTitleString,
                    agent: agent,
                    providerFactory: providerFactory,
                    schema: schema,
                    onEditPromptClick: onEditPromptClick,
                    showBack: showBack,
                    onBack: onBack,
                    onClose: onClose,
                    isClearTitle: isClearTitle
                }),
                generatedContentPreview,
                !isAIFC && promptForm,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $jHWjW.Footer), {
                    brand: agent ? 'rovo' : 'atlassian-intelligence',
                    disclaimer: disclaimer,
                    showDisclaimer: true,
                    showBetaLozenge: showBetaLozenge,
                    showFeedback: isAIFC && canInlineStreamChanges,
                    feedbackForm: feedbackForm,
                    isAIFC: isAIFC
                })
            ]
        })
    });
};










function $6d06a2fc5e272e41$export$2eadb01b889bdc4() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $42omo.useCallback)((history)=>{
        const title = history.entries[0].configItem.title;
        const name = title ? formatMessage(title) : '';
        const dialogues = history.entries.map((entry, index)=>{
            const configItemTitle = formatMessage(entry.configItem.title);
            let humanMessage = entry.userInput;
            // The first message should show the config item title
            if (index === 0) humanMessage = `${configItemTitle}\n\n${humanMessage}`;
            // Use the config item title as fallback if the human message is empty
            humanMessage = humanMessage.trim() || configItemTitle;
            return {
                agent_message: {
                    content: entry.markdown
                },
                human_message: {
                    content: humanMessage
                }
            };
        });
        return {
            name: name,
            dialogues: dialogues
        };
    }, [
        formatMessage
    ]);
}









/**
 * Check if the element has a modal above it.
 *
 * This implementation is dangerous because it relies on the DOM structure of the modal.
 */ function $e236b1c8cd73e2cd$var$isElementHasModalAbove(element) {
    if (!element) return false;
    const elementPortal = element.closest('.atlaskit-portal');
    if (!elementPortal) // If element is not in the modal, we can safely assume that the modal is above
    // if there is a focus guard in the document.
    return !!document.querySelector('[data-focus-guard="true"]');
    // Check all siblings of the element to see if there is a focus guard.
    // If there is a focus guard, it means that the modal is above the current modal.
    let sibling = elementPortal.nextElementSibling;
    while(sibling){
        if (sibling.querySelector('[data-focus-guard="true"]')) return true;
        sibling = sibling.nextElementSibling;
    }
    return false;
}
const $e236b1c8cd73e2cd$export$aa79b0abe3dfeaba = ({ disabled: disabled, userInput: userInput, onCancel: onCancel, onDiscard: onDiscard, modalRef: modalRef })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (disabled) return;
        if (!modalRef) return;
        const handleOutsideClick = (event)=>{
            // It's a really bad idea to check DOM, but we don't have any better way to determinate if
            // the Feedback modal is open or not.
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // FIXME: It should be removed and replaced with solution based on the state of the modal and `disabled` prop.
            if ($e236b1c8cd73e2cd$var$isElementHasModalAbove(modalRef.current)) return;
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                if (!userInput) onCancel();
                else onDiscard();
            }
        };
        return (0, $fFa3V.bind)(document, {
            type: 'mousedown',
            listener: handleOutsideClick
        });
    }, [
        disabled,
        userInput,
        onCancel,
        onDiscard,
        modalRef
    ]);
};
















function $0051c1ce99634d93$export$f332b66be3f378cc(promptTrigger, history) {
    const isPreConfiguredPrompt = promptTrigger !== 'generate'; // like immediate 'improve writing' from toolbar
    const isInitialPrompt = history?.entries?.length === 1;
    return isPreConfiguredPrompt && isInitialPrompt;
}




function $0082397ce8f9ad9a$export$705df12804ca7004({ aiExperienceMachineContext: aiExperienceMachineContext, isInputActive: isInputActive, backendModel: backendModel, rovoAction: rovoAction, rovoPublish: rovoPublish }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isEmpty: isEmpty, parentPresetPromptLabel: parentPresetPromptLabel, latestPrompt: latestPrompt, markdown: actualMarkdown, adfResponse: adfResponse, configItem: configItem, userInput: actualUserInput, userADFInput: actualUserADFInput, editCount: editCount, retryPromptCount: retryPromptCount, refinementCount: refinementCount, idMap: idMap, responseHistory: history, contextStatistics: contextStatistics, promptTrigger: promptTrigger, channelId: channelId, selectionMetaData: selectionMetaData } = aiExperienceMachineContext;
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { appearance: appearance, editorPluginAIProvider: editorPluginAIProvider, editorView: editorView, endExperience: endExperience, positions: positions, providerFactory: providerFactory, sendToAIExperienceMachine: sendToAIExperienceMachine, lastTriggeredFrom: lastTriggeredFrom, modalRef: modalRef, triggeredFor: triggeredFor, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, canInlineStreamChanges: canInlineStreamChanges } = aiExperienceCommonData;
    const disclaimer = (0, $ae9409607dcc8014$export$b38eff301cbfa415)({
        editorPluginAIProvider: editorPluginAIProvider
    }); /**
       * Short title for the submenu if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
       * If the user selects a submenu directly, this will be empty (search and select `Change tone to Neutral`)
       */ 
    const childShortTitle = parentPresetPromptLabel && configItem.nestingConfig ? formatMessage(configItem.nestingConfig.shortTitle) : '';
    const userInput = actualUserInput || '';
    const userADFInput = actualUserADFInput;
    const schema = editorView.state.schema;
    const product = editorPluginAIProvider.product;
    const adfStreamingEnabled = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products'); /**
                                                                                     * Please check with Ethan/PM upon removing onExperienceEvent
                                                                                     * calls, to confirm it is no longer used in any ongoing experiments.
                                                                                     */ 
    (0, $42omo.useEffect)(()=>{
        editorPluginAIProvider.onExperienceEvent?.REVIEW_STATE_ENTERED();
    }, [
        editorPluginAIProvider
    ]);
    const clearInputRef = (0, $42omo.useRef)();
    const lastHistoryEvent = history.entries[history.positionFromEnd]; /**
                                                                      * We may remove this diff ratio calculation, when we are sure that the backend
                                                                      * calculation is working. We will need to have converted to the new ConvoAI endpoint.
                                                                      * @see https://hello.jira.atlassian.cloud/browse/AIX-1665
                                                                      * @see https://hello.jira.atlassian.cloud/browse/EDITOR-792
                                                                      */ 
    const diffRatio = (lastHistoryEvent.modelInput.selection || lastHistoryEvent.modelInput.doc) && actualMarkdown && (0, $dh538.fg)('editor_ai_no_improvement_deadend_fix') ? (0, $8d247c8f9aa8e8b7$export$4ca0a669de074f43)({
        input: lastHistoryEvent.modelInput.selection || lastHistoryEvent.modelInput.doc || '',
        output: actualMarkdown
    }) : 1;
    const responseTooSimilar = lastHistoryEvent.responseTooSimilar || diffRatio < (0, $8d247c8f9aa8e8b7$export$6874965a4629d745);
    const inputOutputDiffRatio = lastHistoryEvent.inputOutputDiffRatio;
    let markdown = actualMarkdown || '';
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    const enqueuedPreviewStep = (0, $42omo.useRef)(false);
    const errorReported = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    if (markdown && (0, $hX9je.isConfluenceTitleToolbarSuggestTitle)({
        configItem: configItem,
        lastTriggeredFrom: lastTriggeredFrom
    })) markdown = (0, $08307bd80aa5722b$export$8850f5fc4cad5830)(markdown);
    let previewToUse;
    let pmFragment = (0, $5SAOw.Fragment).empty;
    let pmFragmentPreviewData;
    if (adfResponse && adfStreamingEnabled) {
        pmFragment = (0, $5SAOw.Node).fromJSON(schema, adfResponse).content;
        previewToUse = (0, $e63c465153c397bc$export$5ae44876b720d032)({
            adfResponse: adfResponse,
            showTelepointer: false,
            providerFactory: providerFactory,
            schema: schema
        });
    } else {
        pmFragmentPreviewData = (0, $6537ba32a2b947a8$export$a08e8b3dacf7ffcc)({
            markdown: markdown,
            schema: schema,
            source: 'preview',
            fireAIAnalyticsEvent: (event)=>{
                if (!errorReported.current) {
                    errorReported.current = true;
                    fireAIAnalyticsEvent(event);
                }
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            idMap: idMap
        });
        pmFragment = pmFragmentPreviewData?.pmFragment || (0, $5SAOw.Fragment).empty;
        previewToUse = getPreviewElement(pmFragment);
    }
    const preview = previewToUse;
    (0, $e236b1c8cd73e2cd$export$aa79b0abe3dfeaba)({
        modalRef: modalRef,
        userInput: userInput,
        onCancel: ()=>sendToAIExperienceMachine({
                type: 'enable discard'
            }),
        onDiscard: ()=>sendToAIExperienceMachine({
                type: 'enable discard'
            })
    }); /**
       * gets preview JSX element based on fragment
       */ 
    function getPreviewElement(pmFragment) {
        if (responseTooSimilar) {
            const responseTooSimilarMessage = formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).responseTooSimilarMessage);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                as: "p"
            }, responseTooSimilarMessage);
        }
        return (0, $e63c465153c397bc$export$f5e3af6d625de7a)({
            schema: schema,
            pmFragment: pmFragment,
            showTelepointer: false,
            providerFactory: providerFactory
        });
    } // preset prompt or base generate / interrogation
    const localizedLatestPrompt = (0, $62aff15c20d44eff$export$6399b1de54f080ad)(latestPrompt);
    const promptStatistics = (0, $b51c49163805cfe9$export$4e4614f0417d7178)(localizedLatestPrompt);
    (0, $42omo.useEffect)(()=>{
        analyticsFlow.fireQueuedStep('preview');
        let modelIO;
        const stats = new (0, $8nxxM.ProseMirrorContentStatistics)(pmFragment);
        const contentStatistics = stats.collectStatistics();
        if (adfResponse && adfStreamingEnabled) modelIO = {
            selectionSize: lastHistoryEvent.modelInput.selection?.length,
            outputUnclosedTokens: {},
            outputHTMLConvertedToNodes: 0,
            outputHTMLConvertedToFallbackNodes: 0,
            isTextFallbackUsed: false,
            previewNodeCounts: contentStatistics.nodeCounts,
            previewMarkCounts: contentStatistics.markCounts,
            previewTotalCharacterCounts: contentStatistics.totalCharacterCount,
            userInputCharacterCount: promptStatistics?.totalCharacterCount,
            userInputNodeCounts: promptStatistics?.nodeCounts,
            userInputLinksCount: promptStatistics?.linksCount,
            userInputMentionsCount: promptStatistics?.mentionsCount
        };
        else if (pmFragmentPreviewData) modelIO = {
            selectionSize: lastHistoryEvent.modelInput.selection?.length,
            nodesConvertedToHTMLInput: idMap ? Object.keys(idMap).length : undefined,
            outputUnclosedTokens: pmFragmentPreviewData.unclosedTokens,
            outputHTMLConvertedToNodes: pmFragmentPreviewData.htmlConvertedToNodes,
            outputHTMLConvertedToFallbackNodes: pmFragmentPreviewData.htmlConvertedToFallbackNodes,
            isTextFallbackUsed: pmFragmentPreviewData.isTextFallbackUsed,
            previewNodeCounts: contentStatistics.nodeCounts,
            previewMarkCounts: contentStatistics.markCounts,
            previewTotalCharacterCounts: contentStatistics.totalCharacterCount,
            userInputCharacterCount: promptStatistics?.totalCharacterCount,
            userInputNodeCounts: promptStatistics?.nodeCounts,
            userInputLinksCount: promptStatistics?.linksCount,
            userInputMentionsCount: promptStatistics?.mentionsCount
        };
        analyticsFlow.addAttributes({
            editCount: editCount,
            responseTooSimilar: responseTooSimilar,
            modelIO: {
                contextStatistics: contextStatistics,
                ...modelIO
            },
            inputOutputDiffRatio: inputOutputDiffRatio
        }); // Remove below flag when AIFC is fully rolled out in Jira, only required for old experience in Jira.
        if ((0, $dh538.fg)('platform_editor_ai_streaming_ended_analytics_attr')) analyticsFlow.updateCommonAttributes({
            isStreamingEnded: true
        });
        return ()=>{
            // We only want to enqueue the preview step if it hasn't been enqueued
            // already. This is to handle the case where the user clicks on an
            // ai action button where we manually enqueue the analytics event,
            // and then seperately fire a complete step.
            if (enqueuedPreviewStep.current === false) analyticsFlow.enqueueStep({
                stepName: 'preview',
                attributes: undefined
            });
        }; // expecting to enqueue step only once on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireDismissEvent = (0, $42omo.useCallback)(()=>{
        // Introduced in EDF-1443 to track Retry events as AI response dismissal
        fireAIAnalyticsEvent({
            payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                action: (0, $d925B.ACTION).DISMISSED,
                attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                    init: false
                }),
                experienceName: (0, $6gJll.convertExperienceName)(configItem.key.toString(), lastTriggeredFrom),
                interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                isProactive: false,
                isStreamingEnded: (0, $dh538.fg)('platform_editor_ai_streaming_ended_analytics_attr') ? analyticsFlow.getCommonAttributes().isStreamingEnded : undefined
            })
        });
    }, [
        analyticsFlow,
        aiExperienceCommonData.lastTriggeredFrom,
        channelId,
        configItem.key,
        fireAIAnalyticsEvent,
        lastTriggeredFrom
    ]);
    const fireResponseFeedbackEvent = (sentiment, productSuccessState)=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'responseFeedbackButton',
                attributes: {
                    sentiment: sentiment,
                    appearance: appearance,
                    product: product,
                    configItemTitle: configItem.agent?.name || configItem.key,
                    lastTriggeredFrom: lastTriggeredFrom,
                    productSuccessStatus: productSuccessState,
                    inputOutputDiffRatio: inputOutputDiffRatio,
                    retryPromptCount: retryPromptCount,
                    responseTooSimilar: responseTooSimilar,
                    aiInteractionID: analyticsFlow.getLastAiInteractionId()
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
        fireAIAnalyticsEvent({
            payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                action: (0, $d925B.ACTION).SUBMITTED,
                interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                experienceName: (0, $6gJll.convertExperienceName)(configItem.key.toString(), lastTriggeredFrom),
                isProactive: false,
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                attributes: {
                    aiFeedbackResult: sentiment === 'good' ? 'up' : 'down',
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    })
                }
            })
        });
    };
    const handleFiringFeedbackEvent = async (feedbackMetadata)=>{
        analyticsFlow.addAttributes({
            userFeedbackSentiment: feedbackMetadata.sentiment
        }); // we need to update the state machine to reflect the user feedback
        sendToAIExperienceMachine({
            type: 'feedback submitted',
            sentiment: feedbackMetadata.sentiment
        }); // handleFeedbackSubmission is intended to be implemented
        // by all products -- there will be a period where products won't have
        // it implemented (and will be relying on THUMBS_UP/THUMBS_DOWN)
        // in these cases -- we don't know the product response status
        if (!editorPluginAIProvider.handleFeedbackSubmission) {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'unknown');
            return;
        } else try {
            const productResponse = await editorPluginAIProvider.handleFeedbackSubmission(feedbackMetadata);
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, productResponse.status);
        } catch  {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'failed');
        }
    };
    const onEditPromptClick = (0, $42omo.useCallback)(()=>{
        const { userInput: userInput, userADFInput: userADFInput, presetTitle: presetTitle } = localizedLatestPrompt;
        analyticsFlow.addAttributes({
            actionTaken: 'edit-prompt'
        });
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'editPromptButton',
                attributes: {
                    experienceType: (0, $6gJll.convertExperienceName)(configItem.key.toString()),
                    editCount: editCount
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
        fireDismissEvent();
        sendToAIExperienceMachine({
            type: 'edit prompt',
            userInput: userInput,
            userADFInput: userADFInput,
            presetTitle: presetTitle
        });
    }, [
        configItem.key,
        localizedLatestPrompt,
        analyticsFlow,
        fireAIAnalyticsEvent,
        editCount,
        fireDismissEvent,
        sendToAIExperienceMachine
    ]);
    const discardWithoutWarning = (0, $42omo.useCallback)(()=>{
        if ((0, $0051c1ce99634d93$export$f332b66be3f378cc)(promptTrigger, history)) {
            endExperience();
            return;
        }
        const { presetTitle: presetTitle } = localizedLatestPrompt;
        sendToAIExperienceMachine({
            type: 'edit prompt',
            userInput: '',
            userADFInput: undefined,
            presetTitle: presetTitle
        });
    }, [
        endExperience,
        history,
        localizedLatestPrompt,
        promptTrigger,
        sendToAIExperienceMachine
    ]);
    const onBack = (0, $42omo.useCallback)(()=>{
        sendToAIExperienceMachine({
            type: 'enable discard',
            context: {
                onceDiscard: discardWithoutWarning
            }
        });
    }, [
        sendToAIExperienceMachine,
        discardWithoutWarning
    ]);
    const aiExperienceMetadata = {
        configItemTitle: configItem.agent?.name || (0, $6gJll.convertExperienceName)(configItem.key.toString()),
        ...configItem.experienceId && (0, $dh538.fg)('thor_support_google_docs_in_description_improver') ? {
            experienceId: configItem.experienceId
        } : {},
        lastTriggeredFrom: lastTriggeredFrom,
        inputOutputDiffRatio: inputOutputDiffRatio,
        backendModel: backendModel
    };
    const getAIExperience = (hasUserConsent)=>({
            ...aiExperienceMetadata,
            ...hasUserConsent && {
                userPrompt: localizedLatestPrompt.userInput,
                markdownResponse: markdown
            }
        });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        /**
     * When userInput is empty, we need to clear interrogate editor
     *  as setting empty userInput as defaultValue won't clear editor.
     */ if (!userInput) clearInputRef.current?.();
    }, [
        userInput
    ]);
    const onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((inputValue)=>{
        sendToAIExperienceMachine({
            type: 'update user input',
            input: inputValue
        });
    }, [
        sendToAIExperienceMachine
    ]);
    const onADFChange = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((inputValue)=>{
        sendToAIExperienceMachine({
            type: 'update user input adf',
            adf: inputValue
        });
    }, [
        sendToAIExperienceMachine
    ]);
    const disableInterrogation = configItem.disableInterrogation?.() || editorPluginAIProvider.disableInterrogation || history.positionFromEnd > 0;
    const onCancelClick = (0, $42omo.useCallback)(()=>{
        if (userInput) {
            fireDismissEvent();
            sendToAIExperienceMachine({
                type: 'cancel refinement'
            });
        } else {
            fireDismissEvent();
            discardWithoutWarning();
        }
    }, [
        userInput,
        discardWithoutWarning,
        fireDismissEvent,
        sendToAIExperienceMachine
    ]);
    const onRetryPromptClick = (0, $42omo.useCallback)(()=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'retryPromptButton',
                attributes: {
                    experienceType: (0, $6gJll.convertExperienceName)(configItem.key.toString())
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
        fireDismissEvent();
        sendToAIExperienceMachine({
            type: 'retry prompt',
            input: localizedLatestPrompt.userInput,
            adf: localizedLatestPrompt.userADFInput
        });
    }, [
        configItem.key,
        fireAIAnalyticsEvent,
        fireDismissEvent,
        localizedLatestPrompt.userADFInput,
        localizedLatestPrompt.userInput,
        sendToAIExperienceMachine
    ]);
    const [hasClicked, setHasClicked] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const onActionButtonClick = (0, $42omo.useCallback)(({ runFn: runFn, analyticsTitle: analyticsTitle, preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete })=>{
        // We add this condition to ensure we don't run the action multiple times
        // if the user double-clicks quickly (e.g., on slower machines, the re-render
        // might not happen fast enough to disable the button before the second click).
        // Once hasClicked is true, subsequent clicks in the same component lifetime
        // will be ignored—unless we explicitly reset the state after an error, etc.
        if (!hasClicked) try {
            setHasClicked(true);
            analyticsFlow.addAttributes({
                actionTaken: analyticsTitle
            });
            analyticsFlow.enqueueStep({
                stepName: 'preview'
            }); // We set this to true to prevent the preview step from being
            // enqueued again on unmount
            // Note -- in future -- we expect the complete step to be deprecated
            // an replaced with a "content highlighted" step
            enqueuedPreviewStep.current = true;
            analyticsFlow.fireQueuedStep('complete');
            const beforeActionRun = performance.now();
            runFn();
            analyticsFlow.enqueueStep({
                stepName: 'complete',
                attributes: {
                    actionTaken: analyticsTitle,
                    duration: Math.round(performance.now() - beforeActionRun),
                    editCount: editCount,
                    retryPromptCount: retryPromptCount,
                    promptType: promptTrigger,
                    refinementCount: refinementCount,
                    inputOutputDiffRatio: inputOutputDiffRatio,
                    includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage
                }
            }); /**
             * Please check with Ethan/PM upon removing onExperienceEvent
             * calls, to confirm it is no longer used in any ongoing experiments.
             */ 
            editorPluginAIProvider.onExperienceEvent?.EXPERIENCE_COMPLETE();
            endExperience({
                preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete
            });
        } catch (error) {
            setHasClicked(false);
            fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        errorType: 'actionRunError',
                        actionTitle: analyticsTitle,
                        errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                }
            });
            sendToAIExperienceMachine({
                type: 'error',
                errorInfo: {
                    failureReason: (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).UNKNOWN
                }
            });
        }
    }, [
        hasClicked,
        analyticsFlow,
        editCount,
        retryPromptCount,
        promptTrigger,
        refinementCount,
        inputOutputDiffRatio,
        includeKnowledgeFromCurrentPage,
        editorPluginAIProvider.onExperienceEvent,
        endExperience,
        fireAIAnalyticsEvent,
        sendToAIExperienceMachine
    ]);
    const mapMarkdownAction = (0, $42omo.useCallback)((action)=>{
        // For Rovo actions, we only generate a fragment from the suggested content (without bot pleasantries)
        const contentFragment = action.isRovoAgentAction && rovoAction ? (0, $6537ba32a2b947a8$export$a08e8b3dacf7ffcc)({
            markdown: rovoAction.content || '',
            schema: schema,
            source: 'rovo-action',
            // TODO: EDF-1044 - fix markdownParser failed events
            fireAIAnalyticsEvent: ()=>{},
            // Won't be expecting Markdown Plus
            idMap: {}
        }).pmFragment : pmFragment;
        const { isDisabled: isDisabled, tooltip: tooltip } = action.getDisabledState?.({
            markdown: markdown,
            formatMessage: formatMessage
        }) ?? {};
        return {
            label: formatMessage(action.title),
            appearance: action.appearance,
            onClick: ()=>{
                onActionButtonClick({
                    runFn: ()=>{
                        action.run({
                            editorView: editorView,
                            positions: positions,
                            markdown: markdown,
                            pmFragment: contentFragment,
                            triggeredFor: triggeredFor,
                            selectionMetaData: adfStreamingEnabled ? selectionMetaData : undefined
                        });
                        if (configItem.agent && editorPluginAIProvider.onDocChangeByAgent) editorPluginAIProvider.onDocChangeByAgent(configItem.agent);
                    },
                    analyticsTitle: typeof action.title.defaultMessage === 'string' ? action.title.defaultMessage : ''
                });
            },
            isDisabled: isDisabled || hasClicked,
            tooltip: tooltip,
            icon: action.icon
        };
    }, [
        adfStreamingEnabled,
        rovoAction,
        schema,
        pmFragment,
        markdown,
        formatMessage,
        hasClicked,
        onActionButtonClick,
        editorView,
        positions,
        triggeredFor,
        configItem.agent,
        editorPluginAIProvider,
        selectionMetaData
    ]);
    const mapAgentAction = (0, $42omo.useCallback)((action)=>{
        return {
            label: formatMessage(action.title),
            appearance: action.appearance,
            icon: action.icon,
            shortcut: action.shortcut,
            onClick: ()=>{
                onActionButtonClick({
                    runFn: ()=>action.run({
                            channelId: channelId,
                            publish: rovoPublish
                        }),
                    analyticsTitle: typeof action.title.defaultMessage === 'string' ? action.title.defaultMessage : '',
                    preserveEditorSelectionOnComplete: action.preserveEditorSelectionOnComplete
                });
            }
        };
    }, [
        channelId,
        formatMessage,
        onActionButtonClick,
        rovoPublish
    ]);
    const createGenericActionPayload = (0, $6d06a2fc5e272e41$export$2eadb01b889bdc4)();
    const mapGenericChatAction = (0, $42omo.useCallback)(({ title: title, appearance: appearance, icon: icon, shortcut: shortcut, run: run, preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete })=>{
        return {
            label: formatMessage(title),
            appearance: appearance,
            icon: icon,
            shortcut: shortcut,
            onClick: ()=>{
                onActionButtonClick({
                    runFn: ()=>run({
                            publish: rovoPublish,
                            ...createGenericActionPayload(history)
                        }),
                    analyticsTitle: typeof title.defaultMessage === 'string' ? title.defaultMessage : '',
                    preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete
                });
            }
        };
    }, [
        createGenericActionPayload,
        formatMessage,
        history,
        onActionButtonClick,
        rovoPublish
    ]); // We need to use actions from the first config item in history,
    // because during refinement, the user might have selected a different
    // config item, that will have different actions.
    const firstConfigItemActions = (0, $c2200b5407d4af9f$export$a64e27216c5d7416)({
        isEmpty: isEmpty,
        configItem: history.entries[0]?.configItem
    });
    const applications = (0, $42omo.useMemo)(()=>{
        let actions = (0, $c2200b5407d4af9f$export$a64e27216c5d7416)({
            isEmpty: isEmpty,
            configItem: configItem
        });
        actions = firstConfigItemActions || actions;
        return actions.map((action)=>{
            if (action.type === 'agent') return mapAgentAction(action);
            if (action.type === 'generic-chat') return mapGenericChatAction(action);
            return mapMarkdownAction(action);
        });
    }, [
        isEmpty,
        configItem,
        firstConfigItemActions,
        mapMarkdownAction,
        mapAgentAction,
        mapGenericChatAction
    ]);
    const refineDropdownItems = (0, $42omo.useMemo)(()=>{
        const allRefineSuggestions = (0, $c2200b5407d4af9f$export$2527a005bbcba079)({
            configItemWithOptions: editorPluginAIProvider.configItemWithOptions
        }).filter((suggestion)=>suggestion.showInRefineDropdown);
        const result = [];
        const parentForNesting = {};
        const handleClickAnalytics = ({ newConfigItem: newConfigItem })=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'refinementOption',
                    attributes: {
                        experienceType: (0, $6gJll.convertExperienceName)(configItem.key.toString()),
                        refinementType: (0, $6gJll.convertExperienceName)(newConfigItem.key.toString())
                    },
                    eventType: (0, $d925B.EVENT_TYPE).UI
                }
            });
        };
        const handleClick = (configItem)=>()=>{
                handleClickAnalytics({
                    newConfigItem: configItem
                });
                let latestPromptResponse = markdown;
                if (configItem.adfPrompt && adfStreamingEnabled) {
                    if (adfResponse) latestPromptResponse = JSON.stringify(adfResponse);
                    else {
                        const { pmFragment: pmFragment } = (0, $6537ba32a2b947a8$export$a08e8b3dacf7ffcc)({
                            markdown: markdown,
                            schema: schema,
                            source: 'markdown-to-adf-conversion-for-refinement',
                            fireAIAnalyticsEvent: (event)=>{
                                if (!errorReported.current) {
                                    errorReported.current = true;
                                    fireAIAnalyticsEvent(event);
                                }
                            },
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            idMap: idMap
                        });
                        const prosemirrorDocument = schema.nodes.doc.createAndFill({}, pmFragment);
                        if (prosemirrorDocument) {
                            const serializer = new (0, $h9yJL.JSONTransformer)(schema);
                            latestPromptResponse = JSON.stringify(serializer.encode(prosemirrorDocument, {
                                keepNestedTables: true
                            }));
                        }
                    }
                }
                sendToAIExperienceMachine({
                    type: 'refine',
                    configItem: configItem,
                    latestPromptResponse: // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    latestPromptResponse
                });
            };
        for (const suggestion of allRefineSuggestions){
            const { nestingConfig: nestingConfig } = suggestion;
            if (!nestingConfig) result.push({
                title: suggestion.title,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, suggestion.icon?.({
                    formatMessage: formatMessage
                })),
                onClick: handleClick(suggestion)
            });
            else {
                const parentKey = nestingConfig.parentTitle.id ?? JSON.stringify(nestingConfig.parentTitle);
                if (!parentForNesting[parentKey]) {
                    const icon = nestingConfig.icon || suggestion.icon;
                    const parent = {
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, " ", icon?.({
                            formatMessage: formatMessage
                        }), " "),
                        title: nestingConfig.parentTitle,
                        children: []
                    };
                    result.push(parent);
                    parentForNesting[parentKey] = parent;
                }
                parentForNesting[parentKey].children?.push({
                    title: suggestion.nestingConfig?.shortTitle ?? suggestion.title,
                    onClick: handleClick(suggestion)
                });
            }
        }
        return result;
    }, [
        // Remove below 4 dependencies when all experiments for ADF prompts are removed
        adfStreamingEnabled,
        adfResponse,
        idMap,
        schema,
        configItem.key,
        editorPluginAIProvider.configItemWithOptions,
        fireAIAnalyticsEvent,
        formatMessage,
        markdown,
        sendToAIExperienceMachine
    ]);
    const refinementButtonClick = (0, $42omo.useCallback)(()=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'refinementButton',
                attributes: {
                    experienceType: (0, $6gJll.convertExperienceName)(configItem.key.toString())
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
    }, [
        configItem.key,
        fireAIAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6037e01702f2a193$export$9f3706359963c421), {
        key: configItem.key,
        parentPresetPromptLabel: parentPresetPromptLabel,
        childShortTitle: childShortTitle,
        latestPrompt: localizedLatestPrompt,
        preview: preview,
        disableActions: !!responseTooSimilar,
        inputValue: userInput,
        inputADFValue: userADFInput,
        isInputActive: isInputActive,
        onCancel: onCancelClick,
        onInputChange: onInputChange,
        onADFChange: onADFChange,
        onInputFocus: ()=>{
            sendToAIExperienceMachine({
                type: 'start refinement'
            });
        },
        onInputBlur: ()=>{
            if (!userInput) sendToAIExperienceMachine({
                type: 'cancel refinement'
            });
        },
        onSubmit: ()=>{
            /**
     * Do we really need to pass userInput and userADFInput
     *  on firing interrogate event.
     * We should have latest userInput and userADFInput
     *  set by onInputChange and onADFChange.
     */ sendToAIExperienceMachine({
                type: 'interrogate',
                userInput: userInput,
                userADFInput: userADFInput,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                latestPromptResponse: markdown
            });
        },
        onCopy: ()=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'copyButton',
                    attributes: {
                        experienceType: (0, $6gJll.convertExperienceName)(configItem.key.toString()),
                        editCount: editCount
                    },
                    eventType: (0, $d925B.EVENT_TYPE).UI
                }
            }); // Fire ACTION.ACTIONED event for copy action
            fireAIAnalyticsEvent({
                payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                    action: (0, $d925B.ACTION).ACTIONED,
                    interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                    experienceName: (0, $6gJll.convertExperienceName)(configItem.key.toString()),
                    isProactive: false,
                    attributes: {
                        ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        aiResultAction: 'copied'
                    },
                    invokedFrom: lastTriggeredFrom
                })
            });
            analyticsFlow.addAttributes({
                contentCopied: true
            });
            (0, $419edf111d0cfe8d$export$a707cf6ca97554ae)({
                editorView: editorView,
                pmFragment: pmFragment
            });
        },
        onRetry: !configItem.agent ? onRetryPromptClick : undefined,
        onGoodResponseButtonClick: ()=>{
            const feedbackMetadata = {
                sentiment: 'good',
                getAIExperience: getAIExperience,
                editorAttributes: {
                    appearance: appearance,
                    product: product
                }
            }; // Now deprecated - migrate to handleFeedbackSubmission
            editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_UP();
            handleFiringFeedbackEvent(feedbackMetadata);
        },
        onBadResponseButtonClick: ()=>{
            const feedbackMetadata = {
                sentiment: 'bad',
                getAIExperience: getAIExperience,
                editorAttributes: {
                    appearance: appearance,
                    product: product
                }
            }; // Now deprecated - migrate to handleFeedbackSubmission
            editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_DOWN();
            handleFiringFeedbackEvent(feedbackMetadata);
        },
        onEditPromptClick: onEditPromptClick,
        onBack: onBack,
        applications: applications,
        PromptEditor: editorPluginAIProvider.PromptEditor,
        clearInputRef: clearInputRef,
        disclaimer: disclaimer,
        providerFactory: providerFactory,
        schema: schema,
        disableInterrogation: disableInterrogation,
        agent: configItem.agent,
        onRefinementClick: refinementButtonClick,
        refineDropdownItems: refineDropdownItems,
        canInlineStreamChanges: canInlineStreamChanges()
    });
}











/* Prompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























const $b7d00b4e167e7843$export$5bd740881e6fb7a0 = (ref, onEscape)=>{
    (0, $42omo.useLayoutEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        if (!(0, $dh538.fg)('platform_editor_ai_scroll_into_view_fix')) el.scrollIntoView({
            block: 'nearest',
            behavior: 'auto'
        });
        return (0, $fFa3V.bindAll)(el, [
            {
                type: 'keydown',
                listener: (e)=>{
                    if (e.key !== 'Escape') return;
                    e.preventDefault();
                    e.stopPropagation();
                    onEscape();
                }
            },
            {
                type: 'keyup',
                listener: (e)=>{
                    if (e.key !== 'Escape') return;
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        ]);
    }, [
        ref,
        onEscape
    ]);
};
const $b7d00b4e167e7843$export$de98eaf87477cf67 = (submit, text)=>{
    const isDisabled = Boolean(text?.trim().length === 0);
    const onKeyDown = (0, $42omo.useCallback)((e)=>{
        if (e.key === 'Enter' && !e.shiftKey && !isDisabled) {
            e.preventDefault();
            submit();
        }
    }, [
        isDisabled,
        submit
    ]);
    return {
        isDisabled: isDisabled,
        onKeyDown: onKeyDown
    };
};





var $06252a633d71380b$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    insertMenuTriggerLabel: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel",
        defaultMessage: "Insert rich content"
    },
    insertMenuAddLink: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink",
        defaultMessage: "Add link"
    },
    insertMenuMention: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.mention",
        defaultMessage: "Mention user"
    },
    promptRecord: {
        id: "fabric.editor.ai.screens.prompt.streaming.record",
        defaultMessage: "Record"
    },
    promptSubmit: {
        id: "fabric.editor.ai.screens.prompt.streaming.submit",
        defaultMessage: "Submit"
    },
    promptPlaceholder: {
        id: "fabric.editor.ai.screens.prompt.streaming.placeholder",
        defaultMessage: "Describe what you want to do"
    },
    inlineCommentPromptPlaceholder: {
        id: "fabric.editor.ai.screens.prompt.streaming.inlineCommentPlaceholder",
        defaultMessage: "Describe what to do"
    }
});


const $1b4ffd6f52a21bdb$var$container = {
    padding: "_18zrpxbi _1rjcutpp"
};
const $1b4ffd6f52a21bdb$export$eddbff457ab4038b = ({ textInput: textInput, adfInput: adfInput, onTextChange: onTextChange, onADFChange: onADFChange, submit: submit, cancel: cancel, PromptEditor: PromptEditor, appearance: appearance, isAIFC: isAIFC })=>{
    const intl = (0, $8C5kA.default)();
    const screenRef = (0, $42omo.useRef)(null);
    (0, $b7d00b4e167e7843$export$5bd740881e6fb7a0)(screenRef, cancel);
    const { onKeyDown: onKeyDown } = (0, $b7d00b4e167e7843$export$de98eaf87477cf67)(submit, textInput);
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $imfiV.useElementBreakpoints)((0, $imfiV.Breakpoint).SmallChromeless);
    const placeholder = breakpoint <= (0, $imfiV.Breakpoint).SmallChromeless ? `${intl.formatMessage((0, $06252a633d71380b$export$2e2bcd8739ae039).inlineCommentPromptPlaceholder)}...` : `${intl.formatMessage((0, $06252a633d71380b$export$2e2bcd8739ae039).promptPlaceholder)}...`;
    const setRootContainer = (element)=>{
        screenRef.current = element;
        setBreakpointsElement(element);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40sdH.FloatingContainer), {
        ref: setRootContainer,
        "data-testid": "prompt-form-screen",
        disablePadding: true,
        rainbowBorder: false,
        enableMaxHeight: true,
        appearance: appearance,
        isAIFC: isAIFC,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            xcss: $1b4ffd6f52a21bdb$var$container.padding,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2676c5921c742a31$export$b0a649d08575ac09), {
                autoFocus: true,
                PromptEditor: PromptEditor,
                type: "user-input",
                defaultValue: adfInput,
                onInputChange: onTextChange,
                onADFChange: onADFChange,
                placeholder: placeholder,
                enableLinks: true,
                onKeyDown: isAIFC ? undefined : onKeyDown,
                submit: submit,
                isAIFC: isAIFC
            })
        })
    });
};







/*
 * !!! Please see for more details:
 * https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3732210222/Dev+Documentation+Editor+AI+Command+Palette#Current-Implementation
 *
 * This file contains the state machine that models the command palette.
 *
 *
 * If you modify this machine in any way, please look at the visual editor
 * and make sure that it is clear and readable.
 *
 * Include a screenshot of the visual editor in your pull request.
 *
 * If you add a new state to the machine -- you will need to update the
 * CommandPaletteState union type.
 *
 * If you add a new transition to the machine -- you will need to update the
 * CommandPaletteEvent union type.
 */ 


const $31926538a92692f4$export$43aa9d313c05e1e6 = ({ context: context })=>(0, $1466f8e1fdbfbe2b$export$aaa7fa18f8e9b2e8)({
        /** @xstate-layout N4IgpgJg5mDOIC5QGMD2BbdBDAdhABAA5YA2YALuWPrOVlftsgBYCWOYAxKjgCpgAPcgFEcVAE6QA2gAYAuolCFUsVuVY9FIAYgBsAdgCsAOgBMAZkMBOKzJm7zVgBymrAGhABPRAFoLx8ydzU10nK30XJyDDXQBfWI80TFwCYjJKalp6aiY2DmNicXVSIklYChowMmR1HnwU-CTsPHxUQlqcWHwSVloaOipjHFQiLCLWEsIyivLqqgIAMwBXEhJW9o1O7t7ybhwABTHikn3p8gBlKrAa6XktZVUOrR0EABYnXWMnV9eZV-0ZE4ZABGQKWDzeN6g4yGfTmYGhYH6XRWUxOQzxRIYZqpUgUBhZBi5dhgApHCZrKZwGZXGqbeotJoNNodLo9PqE0nDUbjSZnSpzSD4SQkbIEFmbNk7PaHXknM6XQUQWQKJAgB5qTbPRBo4FmMJWXTAmTmV7mULuLyIIKfQym+zA9HGwyuTEgJktNL4zIDHJYFgksly0rU8gC64dBkED3ijY8KUc31B44h8ph2YRoXciXx7a0GXk0inUMAJTA6FQADdbqqlCpNZo1S8gZ8WzJ9K9QnZ9PpgRC9DITOZkXaTfDDDFXm6Y6N0gTfYx-XlSYUU1S0+G6XUGjOc1t2emk6uKamaUr8Nm4-vpTxZcdi2myxXq8rgbX1fWnk3EMCkXr7LYjqvIY-xIuY-YILog4BCO5hjsCE66FOCTutiDRehk-TZIuAb5MefKhpukY7mhLR7gmh7ZMY7CaqQvT0JsnAqvcn5at+CC-k4MIuu2VhgcagIQQ4MgBHaxpGoODjAshWLJJ6eKYZyOHLsmJ7rmeEb0iRcmxqyeaUYMNHHPRHRMW+LGPGxoAvKYjrGHCZoAqYvZwc5+gQXBrzGIOnZRO2Pw9vEKHDBAcBaDOGHzthxIcBZDY4NqCA+D8MJmvYILvHx1ivBBthfH8KKvL+PwIaC06kbic4+tFS6BvhlL8hmW44FGjQVesekHlhVBxV+1mIOYxjASijhOoCvyGOiEFIlxnmhGatl2KYPzlTps7et1fq4SuhYNYRTXEYy7Xkfpm1DCM9WnumtLzPgyyrB1kr6b1VnaIgRUiaavzAfCpggmiOVWggIQmEC-wyKYrgITEHarTi62KQuMU7cG6nXXMWlHWtJ1dZy508mujU3UKIpio9uYHi9jb9Qg8JWMY0kdo6SK9iChi5YaxhGj2E62FYE0yaha2RdVRK1Xhu1XURmPRsdV4UWdl1o0RWYjDjOxUwl7GdqYMK2fz4Rjoa5jgUDk265YcH88aQRhMCcPoQpUVi9tqkERuB0y212Py6deNGRSJmvRqfVvQghh6sNVijRH432B5IL5eDwJooYJoOMh8RAA */ states: {
            'partial preset selection and command options list state': {
                states: {
                    'no partial preset selected full options list': {
                        description: `If no partial preset is selected and there is no text input:
- Show the full options list`,
                        on: {
                            onPartialPresetSelected: {
                                target: 'partial preset selected no options list',
                                actions: [
                                    'removeInputText',
                                    'partialPresetSelected'
                                ]
                            }
                        }
                    },
                    'no partial preset selected related options list': {
                        description: `If no partial preset is selected and the user has entered text:
- Show the related options list`,
                        on: {
                            onPartialPresetSelected: {
                                target: 'partial preset selected no options list',
                                actions: [
                                    'removeInputText',
                                    'partialPresetSelected'
                                ]
                            }
                        }
                    },
                    'partial preset selected no options list': {
                        on: {
                            onPartialPresetRemoved: [
                                {
                                    target: 'no partial preset selected related options list',
                                    guard: 'hasInputText',
                                    actions: 'partialPresetRemoved'
                                },
                                {
                                    target: 'no partial preset selected full options list',
                                    actions: 'partialPresetRemoved'
                                }
                            ]
                        },
                        description: `If a partial preset is already selected:
- Don't show the options list
- Show the selected preset`
                    },
                    initialisation: {
                        always: [
                            {
                                target: 'partial preset selected no options list',
                                guard: 'hasInitialPreset'
                            },
                            'no partial preset selected full options list'
                        ]
                    }
                },
                initial: 'initialisation'
            }
        },
        context: context,
        types: {
            events: {}
        },
        type: 'parallel',
        id: 'command palette state machine',
        on: {
            onTextEntered: {
                actions: 'updateTextInput'
            },
            onADFEntered: {
                actions: 'updateADFInput'
            },
            updateBaseGenerateAndConfigItem: {
                actions: 'updateBaseGenerateAndConfigItem'
            }
        }
    }, {
        guards: {
            /*
				 * There are test cases for this guard in the test suite.
				 * They ensure that the guard is working as expected as
				 * the simulation is not able to test this.
				 */ ['hasInputText']: ({ context: context })=>{
                // context.textInput can be undefined, an empty string, or a non-empty string
                // empty strings are considered to be false in this guard
                return !!context.textInput;
            },
            ['hasInitialPreset']: ({ context: context })=>{
                const hasInitialPreset = context.presetPromptLabel !== undefined;
                return hasInitialPreset;
            }
        },
        actions: {
            updateTextInput: (0, $cPMXw.a)(({ event: event })=>{
                if ('onTextEntered' === event.type) {
                    if ('input' in event) return {
                        textInput: event.input
                    };
                    return {
                        textInput: ''
                    };
                }
                return {};
            }),
            updateADFInput: (0, $cPMXw.a)(({ event: event })=>{
                if ('onADFEntered' === event.type) {
                    if ('adf' in event) return {
                        adfInput: event.adf
                    };
                    return {
                        adfInput: undefined
                    };
                }
                return {};
            }),
            partialPresetSelected: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'onPartialPresetSelected') return {
                    configItem: event.configItem,
                    presetPromptLabel: event.presetPromptLabel
                };
                return {};
            }),
            partialPresetRemoved: (0, $cPMXw.a)(({ context: context, event: event })=>{
                if (event.type === 'onPartialPresetRemoved') return {
                    configItem: context.baseGenerate,
                    presetPromptLabel: undefined
                };
                return {
                    presetPromptLabel: undefined
                };
            }),
            removeInputText: (0, $cPMXw.a)(()=>{
                return {
                    textInput: '',
                    adfInput: undefined
                };
            }),
            updateBaseGenerateAndConfigItem: (0, $cPMXw.a)(({ event: event })=>{
                if (event.type === 'updateBaseGenerateAndConfigItem') return {
                    configItem: event.configItem,
                    baseGenerate: event.baseGenerate
                };
                return {};
            })
        }
    });


function $93df371653f429c9$export$6d6b44d5fef51d81({ startingConfig: startingConfig, startingPresetPromptLabel: startingPresetPromptLabel, baseGenerate: baseGenerate, startingUserInput: startingUserInput, startingUserADFInput: startingUserADFInput }) {
    const machineRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    if (machineRef.current === null) machineRef.current = (0, $31926538a92692f4$export$43aa9d313c05e1e6)({
        context: {
            textInput: startingUserInput,
            adfInput: startingUserADFInput,
            configItem: startingConfig,
            presetPromptLabel: startingPresetPromptLabel,
            baseGenerate: baseGenerate
        }
    });
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const [state, send] = (0, $389f150a524de0cc$export$e0338c4153421160)(machineRef.current);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (baseGenerate) send({
            type: 'updateBaseGenerateAndConfigItem',
            baseGenerate: baseGenerate,
            configItem: startingConfig
        });
    }, [
        baseGenerate,
        startingConfig,
        send
    ]);
    return {
        // In a later version of xstate -- the type gen means the machine
        // has good types, so these assertions are not required
        state: state.value,
        context: state.context,
        // Out of the box -- the type of the event received by the xstate send
        // will allow any "payload".
        // ie. `send("correct event type", {incorrect: "event payload"})`
        //
        // To avoid related issues -- we've limited the type to only allow
        // sending the full event.
        // ie. `send({type: "correct event type", correct: "event payload"})`
        send: send
    };
}






const $3325eacd64d89770$var$usePromptLogic = (ctx, ai)=>{
    const { context: { textInput: textInput, adfInput: adfInput }, send: send } = (0, $93df371653f429c9$export$6d6b44d5fef51d81)({
        baseGenerate: ctx.baseGenerate,
        startingUserInput: ctx.userInput,
        startingUserADFInput: ctx.userADFInput,
        startingConfig: ctx.configItem
    });
    const adfRef = (0, $42omo.useRef)(undefined);
    const textInputRef = (0, $42omo.useRef)(undefined);
    const onTextChange = (0, $42omo.useCallback)((input)=>{
        send({
            type: 'onTextEntered',
            input: input
        });
        textInputRef.current = input;
    }, [
        send
    ]);
    const onADFChange = (0, $42omo.useCallback)((adf)=>{
        send({
            type: 'onADFEntered',
            adf: adf
        });
        adfRef.current = adf;
    }, [
        send
    ]);
    const submit = (0, $42omo.useCallback)(()=>{
        const adfInput = adfRef.current;
        const textInput = textInputRef.current;
        if (!textInput?.trim()) return;
        ai.sendToAIExperienceMachine({
            type: 'kickoff with command palette input',
            context: {
                configItem: ctx.configItem,
                userInput: textInput,
                userADFInput: adfInput
            }
        });
    }, [
        ctx.configItem,
        ai
    ]);
    const cancel = (0, $42omo.useCallback)((options)=>{
        ai.endExperience({
            shouldClearSelectionContext: options?.shouldClearSelectionContext
        });
    }, [
        ai
    ]);
    const discard = (0, $42omo.useCallback)(()=>{
        ai.sendToAIExperienceMachine({
            type: 'update context',
            context: {
                configItem: ctx.configItem,
                userInput: textInput || '',
                userADFInput: adfInput
            }
        });
        ai.sendToAIExperienceMachine({
            type: 'enable discard'
        });
    }, [
        adfInput,
        ai,
        ctx.configItem,
        textInput
    ]);
    return {
        textInput: textInput,
        adfInput: adfInput,
        onTextChange: onTextChange,
        onADFChange: onADFChange,
        submit: submit,
        cancel: cancel,
        discard: discard
    };
};
const $3325eacd64d89770$var$usePromptAnalytics = (ctx)=>{
    const intl = (0, $8C5kA.default)();
    (0, $3adf5d183dded6a4$export$f06fb39743945e19)({
        stepName: 'prompt',
        attributes: {
            experienceName: ctx.configItem.key,
            featureId: ctx.configItem.featureId,
            promptTitle: ctx.configItem.promptLabel ? intl.formatMessage(ctx.configItem.promptLabel) : undefined,
            promptType: 'generate',
            usingCommandPalette: true,
            retryPromptCount: ctx.retryPromptCount,
            editCount: ctx.editCount
        }
    });
};
const $3325eacd64d89770$export$771b2fc999b0757c = ({ context: context })=>{
    const ai = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const { textInput: textInput, adfInput: adfInput, onTextChange: onTextChange, onADFChange: onADFChange, submit: submit, cancel: cancel } = $3325eacd64d89770$var$usePromptLogic(context, ai);
    $3325eacd64d89770$var$usePromptAnalytics(context);
    (0, $e236b1c8cd73e2cd$export$aa79b0abe3dfeaba)({
        modalRef: ai.modalRef,
        onCancel: ()=>{
            // We let the RovoPromptScreenWithLogic handle aborts
            if (!ai.editorPluginAIProvider.onSubmit) cancel();
        },
        onDiscard: ()=>{}
    });
    if (ai.editorPluginAIProvider.onSubmit) {
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52854ee2a6ade060$export$d0c09a27ab507630), {
            cancel: cancel
        });
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b4ffd6f52a21bdb$export$eddbff457ab4038b), {
        textInput: textInput,
        adfInput: adfInput,
        onTextChange: onTextChange,
        onADFChange: onADFChange,
        submit: submit,
        cancel: cancel,
        PromptEditor: ai.editorPluginAIProvider.PromptEditor,
        appearance: ai.appearance,
        isAIFC: isInDocumentStreamingEnabled
    });
};


function $0e63fa28c8b0d96a$export$501630857d1b4132(props) {
    const { api: api } = props;
    /**
   * Note -- because we are on an old version of xstate -- when adding new states
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineState` type in the
   * `get-experience-service.ts` file
   **/ const state = props.state;
    /**
   * Note -- because we are on an old version of xstate -- when adding new events
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineEvent` type in the
   * `get-experience-service.ts` file
   **/ const context = props.context;
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { mountDecorations: mountDecorations, updateStream: updateStream, discardStream: discardStream } = (0, $bc1b0aa0b4af6d11$export$bab543e64bfa5b68)({
        api: api,
        configItem: props.context.configItem,
        isProgrammaticScroll: aiExperienceCommonData.isProgrammaticScroll,
        positions: props.context.positions,
        view: props.context.editorView,
        modalRef: props.modalRef,
        aiSessionId: aiExperienceCommonData.aiSessionId
    });
    const autoAcceptAIChanges = aiExperienceCommonData.canInlineStreamChanges();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const send = aiExperienceCommonData.sendToAIExperienceMachine;
        if (send && state === 'started state') send({
            type: 'kick off'
        });
    }, [
        state,
        aiExperienceCommonData.sendToAIExperienceMachine
    ]);
    /**
   * Used to pass the backendModel to analytics and
   * feedback submission metadata
   */ const backendModel = context?.configItem?.getBackendModel?.(!!context?.latestPromptResponse);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        analyticsFlow.updateCommonAttributes({
            backendModel: backendModel,
            channelId: context.channelId,
            ...analyticsFlow.getUserFlowCommonAttributes(context.configItem),
            autoAcceptAIChanges: autoAcceptAIChanges,
            inlineStreamingAvailable: true
        });
    }, [
        analyticsFlow,
        backendModel,
        context.channelId,
        context.configItem,
        autoAcceptAIChanges
    ]);
    const aiLifeCycleDynamicAttributesGetter = context.aiLifeCycleDynamicAttributesGetter;
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (aiLifeCycleDynamicAttributesGetter) analyticsFlow.registerAiLifeCycleDynamicAttributesGetter(aiLifeCycleDynamicAttributesGetter);
    }, [
        analyticsFlow,
        aiLifeCycleDynamicAttributesGetter
    ]);
    // Note -- the intention is to move the creation of the state machine higher
    // and for the ExperienceApplication (react component that appears in the modal)
    // to only be started once the machine is in the modal active state.
    if (state === 'started state') return null;
    const isModalActiveState = typeof state !== 'string' && state['modal active state'];
    if (!isModalActiveState) throw new Error('AI machine state is not: modal active state or modal error state');
    const experienceState = state['modal active state']['experience'];
    const isLastResponseTooSimilar = context.responseHistory.entries[context.responseHistory.entries.length - 1]?.responseTooSimilar;
    // We use the FG directly here rather then canInlineStreamChanges() because this new screen will be shown regardless if
    // the fallback modal is shown or not.
    if (isLastResponseTooSimilar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $913868fa5814d0bf$export$a283bcbda9880df6), {
        discardStream: discardStream,
        aiExperienceMachineContext: context
    });
    if ((0, $dh538.fg)('platform_editor_ai_handle_invalid_input')) {
        if (typeof experienceState === 'object' && 'error state' in experienceState && experienceState['error state'] === 'active' || typeof experienceState !== 'string' && 'error state' in experienceState) {
            if (context.apiErrorInfo.failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).NO_TEXTUAL_CONTENT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c2b39d1df2126a4$export$124856cc35c13bde), {
                errorInfo: context.apiErrorInfo,
                contextStatistics: context.contextStatistics
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b307a07f626c94fc$export$eec2740903046434), {
                errorInfo: context.apiErrorInfo
            });
        }
    } else {
        if (typeof experienceState === 'object' && 'error state' in experienceState && experienceState['error state'] === 'active') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b307a07f626c94fc$export$eec2740903046434), {
            errorInfo: context.apiErrorInfo
        });
    }
    if (typeof state['modal active state'] === 'object' && state['modal active state']['discard'] === 'active') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1d7b35d3a553d01e$export$643e9e046f871343), {
        state: experienceState,
        channelId: context.channelId,
        editCount: context.editCount,
        retryPromptCount: context.retryPromptCount,
        history: context.responseHistory,
        latestPrompt: context.latestPrompt,
        onceDiscard: context.onceDiscard,
        streamFlowPacer: props.streamFlowPacer,
        discardStream: discardStream,
        api: api
    });
    if (typeof experienceState === 'string' && experienceState === 'command palette state') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3325eacd64d89770$export$771b2fc999b0757c), {
        context: context
    });
    if (typeof experienceState === 'object' && 'loading state' in experienceState) {
        const loadingState = experienceState['loading state'];
        if (loadingState === 'loading') {
            /**
       * Short title for the submenu if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
       * If the user selects a submenu directly, this will be empty (search and select `Change tone to Neutral`)
       */ const childShortTitle = context.parentPresetPromptLabel && context.configItem.nestingConfig ? formatMessage(context.configItem.nestingConfig.shortTitle) : '';
            const loadingMessage = (0, $f67061403a6197ff$export$e51701552d28cc4e)({
                status: context?.loadingStatus,
                formatMessage: formatMessage
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8867d6c0228bd6b5$export$9c279fd5d5bced59), {
                mountDecorations: mountDecorations,
                updateStream: updateStream,
                parentPresetPromptLabel: context.parentPresetPromptLabel,
                childShortTitle: childShortTitle,
                title: loadingMessage ? loadingMessage : formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).loadingTitle),
                markdown: context.markdown,
                adfResponse: context.adfResponse,
                adfResponseNodeWrappers: context.adfResponseNodeWrappers,
                latestPrompt: context.latestPrompt,
                promptTrigger: context.promptTrigger,
                refinementCount: context.refinementCount,
                latestPromptRetried: context.latestPromptRetried,
                idMap: context.idMap,
                contextStatistics: context.contextStatistics,
                hideLoadingScreen: aiExperienceCommonData.hideLoadingScreen,
                api: api
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d523c2c58c9df434$export$90b9d761c76d339a), {
                loadingStatus: context.loadingStatus
            }));
        }
    }
    if (typeof experienceState !== 'string' && 'review state' in experienceState) {
        if (updateStream) {
            let pmFragment;
            if (context.adfResponse && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products')) pmFragment = (0, $5c0ab2c2b5c994a4$export$d53ec95625564c92)({
                schema: context.editorView.state.schema,
                adfResponse: context.adfResponse,
                adfResponseNodeWrappers: context.adfResponseNodeWrappers
            });
            else pmFragment = (0, $6537ba32a2b947a8$export$a08e8b3dacf7ffcc)({
                markdown: context.markdown || '',
                schema: context.editorView.state.schema,
                source: 'preview',
                fireAIAnalyticsEvent: ()=>{},
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                idMap: context.idMap
            }).pmFragment;
            if (pmFragment) // TODO: EDITOR-1814 - this should be in useEffect
            updateStream?.({
                fragment: pmFragment,
                hasUserScrolled: aiExperienceCommonData.isUserScroll.current,
                isFinalStream: true
            });
            const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(context.editorView.state);
            const pmStats = new (0, $8nxxM.ProseMirrorContentStatistics)(pmFragment);
            const contentStatistics = pmStats.collectStatistics();
            // when auto accept is on, end immediately
            // when auto accept is off
            // - if it's staging first-time streaming, withAcceptReject is false, end immediately
            if (autoAcceptAIChanges || !decorationPluginState?.withAcceptReject || context.configItem.key === (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) analyticsFlow.addAttributes({
                    modelIO: {
                        contextStatistics: context.contextStatistics,
                        previewMarkCounts: contentStatistics.markCounts,
                        previewNodeCounts: contentStatistics.nodeCounts,
                        previewTotalCharacterCounts: contentStatistics.totalCharacterCount
                    }
                });
                context.endExperience();
                return null;
            } else // if there is nextSessionId, it means there is an ai session running
            // - we don't show the accept reject screen
            // if there is no nextSessionId, it means the ai session ended or there is no ai session at all (such as IW)
            // - then we can show the accept reject screen
            return decorationPluginState?.nextSessionId ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ca5cb652bdb20bde$export$95a358671d66b6a5), {
                aiExperienceMachineContext: context,
                backendModel: backendModel,
                discardStream: discardStream
            });
        } else {
            const action = context.rovoActions ? context.rovoActions[context.selectionType] : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0082397ce8f9ad9a$export$705df12804ca7004), {
                aiExperienceMachineContext: context,
                isInputActive: experienceState['review state'] === 'refinement',
                backendModel: backendModel,
                rovoAction: action,
                rovoPublish: publish
            });
        }
    }
    // When cleaning up, platform_editor_ai_handle_invalid_input, remove below if block.
    if (!(0, $dh538.fg)('platform_editor_ai_handle_invalid_input')) {
        if (typeof experienceState !== 'string' && 'error state' in experienceState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b307a07f626c94fc$export$eec2740903046434), {
            errorInfo: context.apiErrorInfo
        });
    }
    throw new Error('unhandled state');
}
function $0e63fa28c8b0d96a$var$canReplaceBaseGenerate(aiProvider) {
    return aiProvider.isRovoEnabled && aiProvider.useFreeGenerateEditorAgent;
}
function $0e63fa28c8b0d96a$var$useScrollDetection({ modalRef: modalRef }) {
    const isUserScroll = (0, $42omo.useRef)(false);
    /**
   * isProgrammaticScroll is set to true initially
   * to detect any initial changes on render which affect
   * scroll position. There will be multiple scroll events
   * within a single user scroll so it will be set to false
   * accordingly within a single scroll action.
   */ const isProgrammaticScroll = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        const modalEl = modalRef.current;
        if (!modalEl) return;
        const scrollParentEl = (0, $7YjFd.findOverflowScrollParent)(modalEl);
        if (!scrollParentEl) return;
        isUserScroll.current = false;
        const unbind = (0, $fFa3V.bind)(scrollParentEl, {
            type: 'scroll',
            listener: ()=>{
                if (!isProgrammaticScroll.current) {
                    isUserScroll.current = true;
                    unbind();
                }
                isProgrammaticScroll.current = false;
            }
        });
        return ()=>{
            unbind();
        };
    }, [
        modalRef
    ]);
    return {
        isUserScroll: isUserScroll,
        isProgrammaticScroll: isProgrammaticScroll
    };
}
// can be removed once 'platform_editor_ai_aifc_patch_ga_blockers' is rolled out
function $0e63fa28c8b0d96a$var$focusEditor(editorView, { focusEditorContentArea: focusEditorContentArea } = {
    focusEditorContentArea: false
}) {
    if (!editorView.hasFocus()) editorView.focus();
    // when we disable editor while streaming, document.body will be focused
    // we need to focus editor to make pressing esc to work
    const editorContentArea = editorView?.dom.closest('.ak-editor-content-area');
    if (editorContentArea && !editorContentArea.contains(document.activeElement) && focusEditorContentArea) editorContentArea.focus();
}
function $0e63fa28c8b0d96a$var$focusEditorContentArea(editorView) {
    // if it's already focused, do nothing
    const editorContentArea = editorView?.dom.closest('.ak-editor-content-area');
    if (editorContentArea?.contains(document.activeElement)) return;
    editorView.focus();
    // if the editor is currently disabled, the above focus call may fail (browser dependent)
    if (editorView.hasFocus()) return;
    if (editorContentArea && !editorContentArea?.contains(document.activeElement)) editorContentArea?.focus();
}
// document.body will be focused when we switch from one screen to another
// (can be triggered by clicking button or pressing Esc key)
// which will make pressing Esc not working because we're listening Esc on editor
// so we should focus editor when it's not focused
function $0e63fa28c8b0d96a$var$useFocusEditor({ modalRef: modalRef, editorView: editorView, state: state, cancelRovoPrompt: cancelRovoPrompt }) {
    // state is not stable, but we want to run the effect when we switch screen, so use str as the dependency
    const stateStr = JSON.stringify(state);
    (0, $42omo.useEffect)(()=>{
        if (!modalRef.current) return;
        const modalHasFocus = modalRef.current.contains(document.activeElement);
        if (!modalHasFocus && stateStr.indexOf('modal active state') !== -1) {
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) $0e63fa28c8b0d96a$var$focusEditorContentArea(editorView);
            else $0e63fa28c8b0d96a$var$focusEditor(editorView, {
                focusEditorContentArea: true
            });
        }
    }, [
        modalRef,
        editorView,
        stateStr
    ]);
    (0, $42omo.useEffect)(()=>{
        if (cancelRovoPrompt) {
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) $0e63fa28c8b0d96a$var$focusEditorContentArea(editorView);
            else $0e63fa28c8b0d96a$var$focusEditor(editorView, {
                focusEditorContentArea: true
            });
        }
    }, [
        cancelRovoPrompt,
        editorView
    ]);
    (0, $42omo.useEffect)(()=>()=>{
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) editorView.focus();
        }, [
        editorView
    ]);
}
function $0e63fa28c8b0d96a$var$ExperienceApplicationStateWrapper(props) {
    const { api: api, editorView: editorView, endExperience: endExperience } = props;
    const intl = (0, $8C5kA.default)();
    const modalRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const { cancelRovoPrompt: cancelRovoPrompt } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const positions = props.positions;
    const isEmpty = positions[0] === positions[1];
    const selectionType = isEmpty ? 'empty' : 'range';
    /**
   * baseGenerate configItem is used as default configItem in command palette.
   * Currently for every product, "freeGenarete" is used as baseGenerate.
   * Recently, "useFreeGenerateEditorAgent" is introduced to allow
   * 	freeGenerateEditorAgent configItem to be used as baseGenerate.
   *  freeGenerateEditorAgent is like freeGeneerate, but it uses
   * 	rovo agent instead of standard AI prompt.
   *
   * Can't set "freeGenerateEditorAgent" directly as baseGenerate in prebuilt config,
   * 	because creating configItem requires agent to be passed in.
   * But agents are not available at compile time or event when plugin is loaded.
   * So we need to swap baseGenerate here.
   */ let configItem = props.configItem;
    let baseGenerate = props.editorPluginAIProvider.baseGenerate;
    if (props.defaultAgent && $0e63fa28c8b0d96a$var$canReplaceBaseGenerate(props.editorPluginAIProvider)) {
        baseGenerate = (0, $8dbf3e97af770d28$export$dc3b52bb600cbaa7)({
            agent: props.defaultAgent,
            product: props.editorPluginAIProvider.product,
            isInDocumentStreamingEnabled: props.editorPluginAIProvider.isInDocumentStreamingEnabled
        });
        if (props.configItem.key === (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE) configItem = baseGenerate;
    }
    const { isUserScroll: isUserScroll, isProgrammaticScroll: isProgrammaticScroll } = $0e63fa28c8b0d96a$var$useScrollDetection({
        modalRef: modalRef
    });
    const streamFlowPacerRef = (0, $8d54db085cc5a603$export$ace1671de29eb5ea)(true);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const streamingHandler = (0, $03deff61eb2c4e8b$export$ad256dcfbe275ed5)({
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        aiInteractionID: analyticsFlow.getLastAiInteractionId(),
        streamFlowPacer: streamFlowPacerRef.current
    });
    const { send: send, state: state, context: context } = props;
    // Send this synchronously
    (0, $42omo.useLayoutEffect)(()=>{
        send({
            type: 'initialise context',
            context: {
                analyticsContext: props.analyticsContext,
                aiProvider: props.editorPluginAIProvider,
                intl: intl,
                editorView: props.editorView,
                positions: positions,
                isEmpty: isEmpty,
                selectionType: selectionType,
                baseGenerate: baseGenerate,
                configItem: configItem,
                aiLifeCycleDynamicAttributesGetter: props.editorPluginAIProvider?.aiLifeCycleDynamicAttributesGetter,
                markdown: '',
                latestPromptResponse: undefined,
                editCount: 0,
                refinementCount: 0,
                retryPromptCount: 0,
                latestPromptRetried: false,
                userInput: '',
                apiErrorInfo: {},
                responseHistory: {
                    positionFromEnd: 0,
                    entries: [],
                    totalSize: 0,
                    traversals: 0
                },
                channelId: undefined,
                getMentionNameDetails: props.getMentionNameDetails,
                triggeredFor: props.triggeredFor,
                usePageKnowledge: true,
                endExperience: props.endExperience,
                streamingHandler: streamingHandler
            }
        });
        return ()=>{
            send({
                type: 'reset'
            });
        };
    // This must ONLY run on mount/unmount to replicate the `useRef` behaviour of setting up the
    // machine once. If this re-runs it will reset our current state machine
    // Long term we should refactor this the react lifecycle isn't tied to xstate
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (props.defaultAgent && $0e63fa28c8b0d96a$var$canReplaceBaseGenerate(props.editorPluginAIProvider)) {
            const newBaseGenerate = (0, $8dbf3e97af770d28$export$dc3b52bb600cbaa7)({
                agent: props.defaultAgent,
                product: props.editorPluginAIProvider.product,
                isInDocumentStreamingEnabled: props.editorPluginAIProvider.isInDocumentStreamingEnabled
            });
            send({
                type: 'update baseGenerate and configItem',
                baseGenerate: newBaseGenerate,
                configItem: newBaseGenerate
            });
        }
    }, [
        props.defaultAgent,
        props.editorPluginAIProvider,
        send
    ]);
    const [start, end] = props.positions;
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        // Note -- the intention is to have the state machine created at a higher
        // level, and have the positions updated without being passed into this react
        // component.
        send({
            type: 'update positions',
            positions: [
                start,
                end
            ]
        });
    // Separate start/end as React will recognise tuples recreated
    // as a change, even if the values don't change
    }, [
        send,
        start,
        end
    ]);
    $0e63fa28c8b0d96a$var$useFocusEditor({
        modalRef: modalRef,
        editorView: editorView,
        state: state,
        cancelRovoPrompt: cancelRovoPrompt
    });
    const { lastTriggeredFrom: lastTriggeredFrom } = props;
    // By default when the experience is mounted we allow for an early escape attempt via space or other keys. If any other
    // key is pressed, we disable this early escape behaviour to allow for normal editor usage.
    const canEarlyEscape = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!modalRef.current) return;
        /**
     * KeyDown (as opposed to KeyPress) event is used to handle the escape key so that
     * other escape key handlers will not override this behaviour.
     * Additionally this aligns with other escape listeners e.g. for closing typeahead popup.
     */ function handleEscapeKeyDown(event) {
            /**
       * These are the keys that can be used to trigger lists when typing
       * in the Editor using markdown syntax.
       * • uses Opt+8 in Mac
       */ const MARKDOWN_LIST_KEYS = [
                '-',
                '*',
                "\u2022"
            ];
            const MODIFIER_KEYS = [
                'Shift',
                'Alt'
            ];
            if ((0, $dh538.fg)('platform_editor_ai_aifc_space_shortcut')) {
                // If any key other than the chosen keys are pressed, we cannot early escape so we will disable that behaviour
                if (canEarlyEscape.current && event.key !== ' ' && !MARKDOWN_LIST_KEYS.includes(event.key) && !MODIFIER_KEYS.includes(event.key)) canEarlyEscape.current = false;
                if (!(event.key === 'Escape' || canEarlyEscape.current && lastTriggeredFrom === 'spaceShortcut' && (event.key === ' ' || MARKDOWN_LIST_KEYS.includes(event.key)))) return;
            } else {
                // Exit early if the key is not Escape
                if (event.key !== 'Escape') return;
            }
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            // If nextSessionId exists, let the SessionUIComponent manage the escape behaviour
            if (api?.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.nextSessionId) return;
            event.preventDefault();
            event.stopPropagation();
            const modalActiveState = state?.['modal active state'];
            const experience = modalActiveState?.experience;
            // in command palette screen, AI modal renders RovoInlineChatPrompt component
            // and cancelRovoPrompt is from it
            if (experience === 'command palette state') {
                if (cancelRovoPrompt) cancelRovoPrompt();
                else if ((0, $dh538.fg)('platform_editor_ai_aifc_space_shortcut')) endExperience({
                    shouldIgnoreNextSpaceTrigger: event.key === ' ' && lastTriggeredFrom === 'spaceShortcut' || event.key === 'Escape' && lastTriggeredFrom === 'spaceShortcut'
                });
                else endExperience();
                if (MARKDOWN_LIST_KEYS.includes(event.key) && (0, $dh538.fg)('platform_editor_ai_aifc_space_shortcut')) {
                    editorView.dispatch(editorView.state.tr.insertText(` ${event.key}`));
                    return;
                }
                if (event.key === ' ' && lastTriggeredFrom === 'spaceShortcut' && (0, $dh538.fg)('platform_editor_ai_aifc_space_shortcut')) {
                    editorView.dispatch(editorView.state.tr.insertText(' '));
                    return;
                }
                return;
            }
            const isLoading = 'loading state' in experience && experience['loading state'] === 'loading';
            const isPreview = 'review state' in experience && experience['review state'] === 'preview';
            // pressing ESC in loading or accept/reject screen should show the discard screen
            if (isLoading || isPreview) {
                // don't use `send({ type: 'escape' })` here because it will transition to `command palette state`
                if (modalActiveState?.discard === 'active') send({
                    type: 'disable discard'
                });
                else send({
                    type: 'enable discard'
                });
            }
        }
        /**
     * Handle KeyUp event to prevent unexpected escape behaviours when
     * there are other escape handlers outside of component (e.g. in product)
     */ function handleEscapeKeyUp(event) {
            // Exit early if the key is not Escape
            if (event.key !== 'Escape') return;
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            // If nextSessionId exists, let the SessionUIComponent manage the escape behaviour
            if (api?.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.nextSessionId) return;
            event.preventDefault();
            event.stopPropagation();
        }
        function handleClickOutside(event) {
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            // If nextSessionId exists, let the SessionUIComponent manage the escape behaviour
            if (api?.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.nextSessionId) return;
            const modalActiveState = state?.['modal active state'];
            const experience = modalActiveState?.experience;
            const isPreview = typeof experience === 'object' && 'review state' in experience && experience['review state'] === 'preview';
            // click outside of the accept/reject screen should show the discard screen
            if (isPreview && modalRef.current && event.target && !modalRef.current.contains(event.target) && modalActiveState?.discard === 'inactive') send({
                type: 'enable discard'
            });
        }
        // initially, editor is focused
        // when AI modal is loading and user presses ESC
        // we will show the AI modal discard screen
        // which will make AI modal to be auto focused
        // now if user presses ESC again,
        // we will return to the AI modal loading screen
        // so whenever user presses ESC, either the AI modal or the editor is focused
        // so the listener should be attached to the common ancestor of the AI Modal and the editor
        const node = editorView.dom.closest('.ak-editor-content-area');
        if (!node) return;
        return (0, $fFa3V.bindAll)(node, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            },
            {
                type: 'click',
                listener: handleClickOutside
            }
        ]);
    }, [
        modalRef,
        state,
        send,
        context.promptTrigger,
        context.responseHistory,
        endExperience,
        editorView,
        cancelRovoPrompt,
        api,
        lastTriggeredFrom
    ]);
    const [isMounted, setIsMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_scroll_into_view_fix')) return;
        if (!modalRef.current) return;
        (0, $42omo.startTransition)(()=>{
            setIsMounted(true);
        });
    }, [
        modalRef
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_scroll_into_view_fix')) return;
        if (!modalRef.current) return;
        if (isMounted) modalRef.current?.scrollIntoView({
            block: 'nearest',
            behavior: 'auto'
        });
    }, [
        isMounted,
        modalRef
    ]);
    const aiExperienceCommonData = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            appearance: props.appearance,
            // configItem can be changed within state machine, so always get it from machine context.
            configItem: context.configItem,
            editorPluginAIProvider: props.editorPluginAIProvider,
            endExperience: props.endExperience,
            lastTriggeredFrom: props.lastTriggeredFrom,
            providerFactory: props.providerFactory,
            editorView: props.editorView,
            positions: props.positions,
            triggerMethod: props.triggerMethod,
            triggeredFor: props.triggeredFor,
            sendToAIExperienceMachine: send,
            modalRef: modalRef,
            isUserScroll: isUserScroll,
            isProgrammaticScroll: isProgrammaticScroll,
            engagementPlatformApi: props.engagementPlatformApi,
            includeKnowledgeFromCurrentPage: context.usePageKnowledge,
            canInlineStreamChanges: props.canInlineStreamChanges,
            hideLoadingScreen: props.hideLoadingScreen,
            aiSessionId: props.interactionSessionId
        }), [
        context.configItem,
        context.usePageKnowledge,
        props.editorView,
        props.editorPluginAIProvider,
        props.appearance,
        props.endExperience,
        props.lastTriggeredFrom,
        props.providerFactory,
        props.positions,
        props.triggerMethod,
        props.triggeredFor,
        props.engagementPlatformApi,
        props.canInlineStreamChanges,
        send,
        modalRef,
        isUserScroll,
        isProgrammaticScroll,
        props.hideLoadingScreen,
        props.interactionSessionId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        /**
     * `context.traceIds` is only set in xstate machine context for non freegen prompts
     * 	by streaming handler which makes network call to AI api and receives traceId in response header.
     * For freegen prompt, it is always empty as Rovo chat makes network call to AI api
     * 	and receives traceId in response header. And then response is forwarded to
     * 	orchestrator plugin which then sets traceId in decoration plugin state.
     * And from decoration plugin state, it is passed to ExperienceApplication component as `traceId` prop.
     *
     * In future, we will remove `context.traceIds` and use `traceId` prop instead
     * 	as all prompts will be migrated to minion and will get AI response through orchestrator plugin.
     */ if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) {
            const traceIds = props.traceId ? [
                props.traceId
            ] : context.traceIds;
            if (traceIds) analyticsFlow.updateCommonAttributes({
                traceIds: traceIds
            });
        } else analyticsFlow.updateCommonAttributes({
            traceIds: context.traceIds
        });
    }, [
        analyticsFlow,
        props.traceId,
        context.traceIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // We set these to ensure that when focus initially moves to
        // an element within the modal, that context about the modal
        // (e.g. "Atlassian Intelligence Dialog") is announced too
        role: "dialog",
        // ED-19787
        // We would like to use aria-labelledBy so we can label this
        // dynamically for each screen, however it's not working as expected
        // in Chrome and Firefox (works in Safari). For now we'll use the dialog
        // role and make the first element of each screen a screen-reader accessible
        // heading for the experience.
        "aria-label": intl.formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).dialogAriaLabel),
        ref: modalRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee350c5972abd564$export$cad72db1c520741c).Provider, {
        value: aiExperienceCommonData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e63fa28c8b0d96a$export$501630857d1b4132, {
        api: api,
        state: state,
        context: context,
        initialPrompt: props.initialPrompt,
        modalRef: modalRef,
        streamFlowPacer: streamFlowPacerRef.current
    })));
}
function $0e63fa28c8b0d96a$export$8b0e36b4d2610ae7(props) {
    const { api: api, editorView: editorView, canInlineStreamChanges: canInlineStreamChanges } = props;
    const monitorWatchmenCommands = (0, $42omo.useMemo)(()=>(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? (0, $0f4ccde48208a2ab$export$4783d4d69ea114f3)(editorView) : undefined, [
        editorView
    ]);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$b26e0d212ef01829)({
        invokeAttributes: {
            invokedFrom: props.lastTriggeredFrom,
            invokedFor: props.triggeredFor ? props.triggeredFor.name : 'text',
            triggerMethod: props.triggerMethod,
            experienceName: props.configItem.key,
            featureId: props.configItem.featureId,
            aiGroupId: props.aiGroupId,
            aiSessionId: props.interactionSessionId
        },
        canInlineStreamChanges: props.canInlineStreamChanges,
        isInDocumentStreamingEnabled: true,
        onCommonAttributesUpdated: monitorWatchmenCommands?.syncCommonAttributes
    });
    // initialPositions is updated many times during in-doc streaming,
    // but we only want to update the common analytics attributes once,
    // so we check if they've already been updated
    const commonAnalyticsAttributesUpdatedRef = (0, $42omo.useRef)(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (commonAnalyticsAttributesUpdatedRef.current) return;
        commonAnalyticsAttributesUpdatedRef.current = true;
        const isInvokedFromEmptyPage = (0, $2pjJ5.isEmptyDocument)(props.editorView.state.doc);
        analyticsFlow.updateCommonAttributes({
            isInvokedFromEmptyPage: isInvokedFromEmptyPage,
            /**
       * Confidence score will be used passed in analytics events.
       * It is currently only set when "Improve writing" is triggered from the
       * 	"Improve writing" nudge.
       */ nudgeMetrics: props.nudgeMetrics
        });
        if (props.initialPositions) {
            const selectionCategory = (0, $d465bdc6207b3d88$export$385434a4b24ab280)(props.editorView, props.initialPositions);
            const { charCount: charCount, wordCount: wordCount } = (0, $4SGh1.rangeCharWordCount)(props.editorView.state.doc, props.initialPositions[0], props.initialPositions[1]);
            analyticsFlow.updateCommonAttributes({
                selectionCharCount: charCount,
                selectionWordCount: wordCount
            });
            analyticsFlow.updateCommonAttributes({
                isInvokedFromEmptyPage: isInvokedFromEmptyPage,
                selectionCategory: selectionCategory
            });
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                const selectionNodes = (0, $d465bdc6207b3d88$export$208ac2488b55bf9d)(props.editorView.state, props.initialPositions);
                analyticsFlow.updateCommonAttributes({
                    selectionNodes: selectionNodes
                });
            }
        }
    }, [
        analyticsFlow,
        props.editorView,
        props.initialPositions,
        props.nudgeMetrics
    ]);
    // finish analytics flow and fire remaining steps on unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            // have to postpone until animation frame to make sure we end analytics flow after child components unmount
            // which is where we enqueue last events
            window.requestAnimationFrame(()=>{
                analyticsFlow.fireQueuedStep();
            });
        };
    }, [
        analyticsFlow
    ]);
    // This makes sure that the selection preview is hidden when the experience is unmounted
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            const tr = props.editorView.state.tr;
            tr.setMeta('hideSelectionPreview', true);
            props.editorView.dispatch(tr);
        };
    }, [
        props.editorView
    ]);
    // focus editor when the AI modal is unmounted
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            $0e63fa28c8b0d96a$var$focusEditor(editorView);
            // when we set the selection with AI modal open,
            // prosemirror won't update the selection because editor is not focused
            // and when the selection is empty in a paragraph,
            // the cursor may be (randomly) placed somewhere else within the paragraph when we focus the editor
            // so we need to re-set the selection after we focus the editor to make prosemirror update the selection correctly
            // and we have to set the selection to somewhere else first
            // because prosemirror will skip the selection update if the selection doesn't change
            // https://hello.jira.atlassian.cloud/browse/EDITOR-1269
            if (editorView.state.selection instanceof (0, $ks2lK.TextSelection) && editorView.state.selection.empty && editorView.state.selection.$to.parent.isTextblock && editorView.state.selection.$to.parent.childCount > 0) {
                const to = editorView.state.selection.to;
                let tr = editorView.state.tr;
                tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, 0));
                tr.setMeta('addToHistory', false).setMeta('scrollIntoView', false);
                editorView.dispatch(tr);
                tr = editorView.state.tr;
                tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, to));
                tr.setMeta('addToHistory', false).setMeta('scrollIntoView', false);
                editorView.dispatch(tr);
            }
        };
    }, [
        editorView
    ]);
    // turn diff off when unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            const autoAcceptAIChanges = canInlineStreamChanges();
            if (!autoAcceptAIChanges && api?.trackChanges?.sharedState.currentState()?.isDisplayingChanges) api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        };
    }, [
        api,
        canInlineStreamChanges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $510ce0322de9e3d3$export$61f6bd9fac8ed53), {
        onCloseFallback: ()=>{
            props.endExperience();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3adf5d183dded6a4$export$b8f39b5859612546), {
        value: analyticsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "EditorAICommandPalette"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e63fa28c8b0d96a$var$ExperienceApplicationStateWrapper, {
        ...props,
        analyticsContext: {
            aiSessionId: analyticsFlow.aiSessionId,
            aiGroupId: props.aiGroupId ?? analyticsFlow.aiSessionId
        }
    }))));
}








var $6qdjm = parcelRequire("6qdjm");


















const $8ab9b1b1a4a1d5e9$export$b4ceb5852b486734 = ({ modalDecorationSet: modalDecorationSet, doc: doc })=>{
    const positions = (0, $d465bdc6207b3d88$export$8e313fd1eaf35cec)({
        modalDecorationSet: modalDecorationSet
    });
    return positions ? doc.slice(positions[0], positions[1], true).content : undefined;
};
const $8ab9b1b1a4a1d5e9$export$e4b2c7b98f669fb7 = ({ editorView: editorView, getMentionNameDetails: getMentionNameDetails, editorPluginAIProvider: editorPluginAIProvider, editorApi: editorApi })=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { product: product } = editorPluginAIProvider;
    const publishDocAndSelection = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async ({ doc: doc, selection: selection })=>{
        // This is used as performance optimization since the publish function is called very often
        // and we don't want to block the main thread for this operation.
        // requestIdleCallback is not supported by all browsers, so we fallback to requestAnimationFrame
        const queueTask = window.requestIdleCallback || window.requestAnimationFrame;
        if (!doc || !selection) {
            queueTask(()=>{
                publish({
                    type: 'editor-context-payload',
                    source: 'editor',
                    product: product,
                    data: undefined
                });
            });
            return;
        }
        // Retrieve the modal decoration set from the plugin state to access the selection state,
        // since the editor's selection is cleared when the modal opens.
        const { modalDecorationSet: modalDecorationSet } = (0, $kqrrC.getPluginState)(editorView.state);
        // Initially, assume the selected content from editorView will be used
        let selectionContent = selection.content().content;
        const selectionContentFromDecorations = $8ab9b1b1a4a1d5e9$export$b4ceb5852b486734({
            modalDecorationSet: modalDecorationSet,
            doc: doc
        });
        if (selectionContentFromDecorations) selectionContent = selectionContentFromDecorations;
        let mentionMap = {};
        if (getMentionNameDetails) mentionMap = await (0, $087baae06cf8cdc5$export$922d75f514df28b7)({
            node: doc,
            getMentionNameDetails: getMentionNameDetails
        });
        const { markdown: selectionMD } = (0, $6eZqW.convertProsemirrorNodeToMarkdown)({
            node: (0, $5SAOw.Fragment).from(selectionContent),
            featureToggles: {
                markdownPlus: false
            },
            mentionMap: mentionMap
        });
        queueTask(()=>{
            publish({
                type: 'editor-context-payload',
                source: 'editor',
                product: product,
                data: {
                    document: {
                        type: 'text/adf',
                        content: doc.toJSON()
                    },
                    selection: {
                        type: 'text/markdown',
                        content: selectionMD
                    }
                }
            });
        });
    }, [
        editorView,
        getMentionNameDetails,
        product,
        publish
    ]);
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'focus'
    ], ({ focusState: focusState })=>{
        // this is the same as onBlur
        if (!focusState?.hasFocus) publishDocAndSelection({
            doc: editorView.state.doc,
            selection: editorView.state.selection
        });
    });
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>{
        // When text is selected or deselected, publish the updated selection context to Rovo
        if ((aiExperienceState?.nonCursorSelectionChangeCount ?? 0) >= 1) publishDocAndSelection({
            doc: editorView.state.doc,
            selection: editorView.state.selection
        });
    });
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            publish({
                type: 'editor-context-payload',
                source: 'editor',
                product: product,
                data: undefined
            });
        };
    }, [
        publish,
        product
    ]);
    (0, $eIhC8.updatePublish)(publish)(editorView.state, editorView.dispatch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};






var $aMqwg = parcelRequire("aMqwg");




const $9c7f02ab52bdba8d$export$aa8f4f6cd586f1c7 = ({ editorPluginAIProvider: editorPluginAIProvider })=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $aMqwg.useRovoEntitlement)();
    return !!editorPluginAIProvider.isRovoEnabled && isRovoEnabled && typeof editorPluginAIProvider?.getChannelVariables === 'function';
};
const $9c7f02ab52bdba8d$export$83f18c95a94d1b1e = ({ editorPluginAIProvider: editorPluginAIProvider })=>{
    const isRovoEnabled = $9c7f02ab52bdba8d$export$aa8f4f6cd586f1c7({
        editorPluginAIProvider: editorPluginAIProvider
    });
    return isRovoEnabled && !!editorPluginAIProvider.showRovoAgentsInCommandPalette;
};
const $9c7f02ab52bdba8d$export$6d436ac1332526a3 = (props)=>{
    const { editorView: editorView, children: children } = props;
    const enabled = $9c7f02ab52bdba8d$export$aa8f4f6cd586f1c7({
        editorPluginAIProvider: props.editorPluginAIProvider
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        (0, $eIhC8.updateEnabled)(enabled)(editorView.state, editorView.dispatch);
    }, [
        editorView.dispatch,
        editorView.state,
        enabled
    ]);
    return enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children) : null;
};



























var $ieno2 = parcelRequire("ieno2");





// Singleton variable that we use to globally track whether
// a given editor was the last active ('focused') editor (to narrow
// down editor that should be reacting to Rovo pub-sub messages)
let $16e42b7f4c943338$var$lastActiveEditorView = null;
const $16e42b7f4c943338$export$63e666219b0a303b = (editorView)=>{
    $16e42b7f4c943338$var$lastActiveEditorView = editorView;
};
const $16e42b7f4c943338$export$c9ca68398bbb9d15 = (editorView)=>editorView === $16e42b7f4c943338$var$lastActiveEditorView;
const $16e42b7f4c943338$export$ffc90b19d29ca0a6 = (editorView)=>{
    (0, $42omo.useEffect)(()=>{
        const handleFocus = ()=>$16e42b7f4c943338$export$63e666219b0a303b(editorView);
        const editorDom = editorView.dom;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorDom.addEventListener('focus', handleFocus);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorDom.removeEventListener('focus', handleFocus);
        };
    }, [
        editorView
    ]);
};


const $5e0fbb2bea9f0ffb$var$topic = {
    topic: 'ai-mate'
};
const $5e0fbb2bea9f0ffb$var$SubscribeToRovoLegacy = ({ editorView: editorView, product: product, onDocChangeByAgent: onDocChangeByAgent, onAIProviderChanged: onAIProviderChanged, editorPluginAIProvider: editorPluginAIProvider, positions: positions, editorApi: editorApi })=>{
    const siteId = (0, $42omo.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const agents = (0, $6Vqkv.useAgentsList)({
        assistanceServiceParams: {
            product: (0, $8klLr.mapToAssistanceServiceProduct)(product),
            experienceId: 'ai-mate',
            touchpointSource: 'editor-agent-subscribe-to-rovo',
            siteId: siteId
        }
    });
    (0, $16e42b7f4c943338$export$ffc90b19d29ca0a6)(editorView);
    const callback = (0, $42omo.useCallback)((payload)=>{
        if (payload.type === 'agent-changed' && onAIProviderChanged) onAIProviderChanged('rovo-chat', payload.data.agent ? {
            type: 'rovo',
            agent: payload.data.agent
        } : undefined);
        if (payload.type === 'editor-suggestion' && (0, $16e42b7f4c943338$export$c9ca68398bbb9d15)(editorView)) {
            const { state: state } = editorView;
            switch(payload.data.mode){
                case 'insert':
                    {
                        const { pmFragment: pmFragment } = (0, $hAuc5.convertMarkdownToProsemirror)({
                            markdown: payload.data.content,
                            schema: state.schema,
                            idMap: {}
                        });
                        let tr = (0, $ieno2.insertAIContentAtCurrentPosition)({
                            editorView: editorView,
                            positions: positions ?? [
                                state.selection.from,
                                state.selection.to
                            ],
                            pmFragment: pmFragment
                        });
                        // Queue links for smartlink resolution
                        if (editorApi?.card?.actions.queueCardsFromChangedTr && (0, $dh538.fg)('rovo_chat_editor_suggestion_smartlinks')) tr = editorApi.card.actions.queueCardsFromChangedTr(state, tr, (0, $d925B.INPUT_METHOD).MANUAL);
                        (0, $ieno2.beforeDispatchAIRovoAgentTransaction)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                        break;
                    }
                case 'replace':
                    {
                        const { pmFragment: pmFragment } = (0, $hAuc5.convertMarkdownToProsemirror)({
                            markdown: payload.data.content,
                            schema: state.schema,
                            idMap: {}
                        });
                        let tr = (0, $ieno2.replaceWithAIContent)({
                            editorView: editorView,
                            positions: positions ?? [
                                state.selection.from,
                                state.selection.to
                            ],
                            pmFragment: pmFragment,
                            options: {
                                replaceDocOnEmptySelection: false
                            }
                        });
                        // Queue links for smartlink resolution
                        if (editorApi?.card?.actions.queueCardsFromChangedTr && (0, $dh538.fg)('rovo_chat_editor_suggestion_smartlinks')) tr = editorApi.card.actions.queueCardsFromChangedTr(state, tr, (0, $d925B.INPUT_METHOD).MANUAL);
                        (0, $ieno2.beforeDispatchAIRovoAgentTransaction)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                        break;
                    }
            }
            const matchedAgent = agents.find((agent)=>agent.id === payload.data.agentId);
            if (matchedAgent && onDocChangeByAgent) {
                const agent = (0, $8zG4S.getEditorAgent)(matchedAgent);
                onDocChangeByAgent(agent);
            }
        }
    }, [
        onAIProviderChanged,
        editorView,
        agents,
        onDocChangeByAgent,
        positions,
        editorApi
    ]);
    (0, $i25hX.useSubscribe)($5e0fbb2bea9f0ffb$var$topic, callback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};
const $5e0fbb2bea9f0ffb$var$SubscribeToRovoNew = ({ editorView: editorView, onDocChangeByAgent: onDocChangeByAgent, onAIProviderChanged: onAIProviderChanged, editorPluginAIProvider: editorPluginAIProvider, positions: positions, editorApi: editorApi })=>{
    const siteId = (0, $42omo.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const agents = (0, $01f629ab65a6efb7$export$e37a2e6de6a7fa90)({
        cloudId: siteId,
        editorState: editorView.state
    });
    (0, $16e42b7f4c943338$export$ffc90b19d29ca0a6)(editorView);
    const callback = (0, $42omo.useCallback)((payload)=>{
        if (payload.type === 'agent-changed' && onAIProviderChanged) onAIProviderChanged('rovo-chat', payload.data.agent ? {
            type: 'rovo',
            agent: payload.data.agent
        } : undefined);
        if (payload.type === 'editor-suggestion' && (0, $16e42b7f4c943338$export$c9ca68398bbb9d15)(editorView)) {
            const { state: state } = editorView;
            switch(payload.data.mode){
                case 'insert':
                    {
                        const { pmFragment: pmFragment } = (0, $hAuc5.convertMarkdownToProsemirror)({
                            markdown: payload.data.content,
                            schema: state.schema,
                            idMap: {}
                        });
                        let tr = (0, $ieno2.insertAIContentAtCurrentPosition)({
                            editorView: editorView,
                            positions: positions ?? [
                                state.selection.from,
                                state.selection.to
                            ],
                            pmFragment: pmFragment
                        });
                        // Queue links for smartlink resolution
                        if (editorApi?.card?.actions.queueCardsFromChangedTr && (0, $dh538.fg)('rovo_chat_editor_suggestion_smartlinks')) tr = editorApi.card.actions.queueCardsFromChangedTr(state, tr, (0, $d925B.INPUT_METHOD).MANUAL);
                        (0, $ieno2.beforeDispatchAIRovoAgentTransaction)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                        break;
                    }
                case 'replace':
                    {
                        const { pmFragment: pmFragment } = (0, $hAuc5.convertMarkdownToProsemirror)({
                            markdown: payload.data.content,
                            schema: state.schema,
                            idMap: {}
                        });
                        let tr = (0, $ieno2.replaceWithAIContent)({
                            editorView: editorView,
                            positions: positions ?? [
                                state.selection.from,
                                state.selection.to
                            ],
                            pmFragment: pmFragment,
                            options: {
                                replaceDocOnEmptySelection: false
                            }
                        });
                        // Queue links for smartlink resolution
                        if (editorApi?.card?.actions.queueCardsFromChangedTr && (0, $dh538.fg)('rovo_chat_editor_suggestion_smartlinks')) tr = editorApi.card.actions.queueCardsFromChangedTr(state, tr, (0, $d925B.INPUT_METHOD).MANUAL);
                        (0, $ieno2.beforeDispatchAIRovoAgentTransaction)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                        break;
                    }
            }
            const matchedAgent = agents.data.find((agent)=>agent.id === payload.data.agentId);
            if (matchedAgent && onDocChangeByAgent) onDocChangeByAgent(matchedAgent);
        }
    }, [
        onAIProviderChanged,
        editorView,
        agents,
        onDocChangeByAgent,
        positions,
        editorApi
    ]);
    (0, $i25hX.useSubscribe)($5e0fbb2bea9f0ffb$var$topic, callback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};
const $5e0fbb2bea9f0ffb$export$e7460f646530f5b4 = ({ editorView: editorView, product: product, onDocChangeByAgent: onDocChangeByAgent, onAIProviderChanged: onAIProviderChanged, editorPluginAIProvider: editorPluginAIProvider, positions: positions, editorApi: editorApi })=>{
    return (0, $dh538.fg)('platform_editor_ai_remove_agents_list') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5e0fbb2bea9f0ffb$var$SubscribeToRovoNew, {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView,
        onDocChangeByAgent: onDocChangeByAgent,
        product: product,
        onAIProviderChanged: onAIProviderChanged,
        positions: positions,
        editorApi: editorApi
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5e0fbb2bea9f0ffb$var$SubscribeToRovoLegacy, {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView,
        onDocChangeByAgent: onDocChangeByAgent,
        product: product,
        onAIProviderChanged: onAIProviderChanged,
        positions: positions,
        editorApi: editorApi
    });
};


const $118a836b9e6d54ec$export$2dda1e4a1d1f6a81 = ()=>{
    const { aiOptIn: aiOptIn, editorPluginAIProvider: editorPluginAIProvider, editorView: editorView, api: api, wrapperElement: wrapperElement, appearance: appearance, providerFactory: providerFactory, getMentionNameDetails: getMentionNameDetails, canInlineStreamChanges: canInlineStreamChanges, isRovoLoading: isRovoLoading } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const aiDecorationExperiencePluginState = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiExperience.aiDecorationExperiencePluginState');
    const { isRunning: isRunning } = aiDecorationExperiencePluginState || {};
    const isDecorationSetEmpty = !aiDecorationExperiencePluginState || aiDecorationExperiencePluginState.modalDecorationSet === (0, $ftzrq.DecorationSet).empty;
    const rovoAgentsPluginState = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiExperience.rovoAgentsPluginState');
    const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(editorView.state);
    const intl = (0, $8C5kA.default)();
    const endExperience = (0, $42omo.useCallback)((options)=>{
        // after AI start, there is a chance that the plugin state is not updated yet
        // so we need to check if the plugin state is running before ending the experience
        if (!isRunning) return;
        if (editorPluginAIProvider.onAIProviderChanged) editorPluginAIProvider.onAIProviderChanged('command-palette');
        const state = (0, $kqrrC.getPluginState)(editorView.state);
        const decoSet = (0, $56Rej.hasGeneratedContentDecorations)(state) || options?.preserveEditorSelectionOnComplete ? state.modalDecorationSet : undefined;
        const endAIExperienceCommand = (0, $5SuLc.createEndAIExperienceCommand)(decoSet, options?.preserveEditorSelectionOnComplete, options?.shouldClearSelectionContext, options?.shouldIgnoreNextSpaceTrigger);
        endAIExperienceCommand(editorView.state, editorView.dispatch);
    }, [
        editorView,
        isRunning,
        editorPluginAIProvider
    ]);
    (0, $42omo.useEffect)(()=>{
        /**
     * When isDecorationSetEmpty changes from false to true,
     * we need to end the experience as that ensures all the different AI plugins
     * are ended.
     */ if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        isDecorationSetEmpty) endExperience();
    }, [
        isDecorationSetEmpty,
        endExperience
    ]);
    const { send: send, state: state, context: context } = (0, $c802a1f50ee37760$export$519bc24a166a4cfd)({
        context: {
            analyticsContext: {
                aiSessionId: '',
                aiGroupId: ''
            },
            aiProvider: editorPluginAIProvider,
            intl: intl,
            editorView: editorView,
            positions: [
                0,
                0
            ],
            isEmpty: true,
            selectionType: 'empty',
            configItem: editorPluginAIProvider?.baseGenerate,
            markdown: '',
            latestPromptResponse: undefined,
            editCount: 0,
            refinementCount: 0,
            retryPromptCount: 0,
            latestPromptRetried: false,
            userInput: '',
            apiErrorInfo: {},
            responseHistory: {
                positionFromEnd: 0,
                entries: [],
                totalSize: 0,
                traversals: 0
            },
            channelId: undefined,
            usePageKnowledge: true,
            endExperience: endExperience
        }
    });
    /**
   * We only want to enable directional modal pinning when in the
   * prompt input state.
   */ const isDirectionalPinningEnabled = !isRovoLoading && typeof state === 'object' && state['modal active state']['experience'] === 'command palette state'; // We use this point to render the modal if needed instead of decorators
    // The reason this is preferrable is it has access to mount points
    // where decorators are rendered with a mount point within the Editor content
    // and longer modals get clipped as a result.
    const renderModalRegion = ()=>{
        // If there are no active decorations -- then we don't want to render the ai experience.
        if (isDecorationSetEmpty) return null;
        if ((0, $56Rej.hasGeneratedContentDecorations)(aiDecorationExperiencePluginState)) return null;
         // Get positions from state (calculated by reducer) when feature flag is enabled,
        // otherwise calculate positions inline
        let positions;
        let decoration;
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) {
            positions = aiDecorationExperiencePluginState?.positions;
            if (!positions) return null;
             // Get decoration for modal positioning
            decoration = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'modalMountPointDecoration' || spec.key === 'modalMountPointRangeDecoration').shift();
            if (!decoration) {
                const nodeDecorations = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration');
                decoration = nodeDecorations.shift();
            }
        } else {
            // Original implementation: calculate positions inline
            // Prioritise getting position from inlineDecoration,
            // otherwise get decoration position from start or end widget
            decoration = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'modalMountPointDecoration' || spec.key === 'modalMountPointRangeDecoration').shift();
            if (decoration) {
                // when there is decoration, it means it's text selection
                // we need to use the initial positions
                // as the decoration positions are not accurate when there the selection is empty
                if (!aiDecorationExperiencePluginState?.initialPositions) return null;
                positions = aiDecorationExperiencePluginState?.initialPositions;
            } else {
                const nodeDecorations = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration');
                if (nodeDecorations.length > 0) {
                    const startPos = Math.min(...nodeDecorations.map((decoration)=>decoration.from));
                    const endPos = Math.max(...nodeDecorations.map((decoration)=>decoration.to));
                    positions = [
                        startPos,
                        endPos
                    ];
                }
                decoration = nodeDecorations.shift();
            }
        }
        if (!decoration) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33a4c9b26ac5d24$export$bd71f7a11db32a15), {
            isDirectionalPinningEnabled: isDirectionalPinningEnabled,
            lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
            key: aiDecorationExperiencePluginState.modalMountedTimeStamp,
            decoration: decoration,
            editorView: editorView,
            editorRelativeWrapper: wrapperElement?.offsetParent,
            endExperience: endExperience,
            appearance: appearance,
            decorationSet: aiDecorationExperiencePluginState.modalDecorationSet
        }, aiDecorationExperiencePluginState.configItem && editorView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0e63fa28c8b0d96a$export$8b0e36b4d2610ae7), {
            api: api,
            context: context,
            send: send,
            state: state,
            configItem: aiDecorationExperiencePluginState.configItem,
            editorPluginAIProvider: editorPluginAIProvider,
            endExperience: endExperience,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            positions: positions,
            editorView: editorView,
            providerFactory: providerFactory,
            lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
            triggerMethod: aiDecorationExperiencePluginState.triggerMethod,
            appearance: appearance,
            initialPrompt: aiDecorationExperiencePluginState?.initialPrompt,
            getMentionNameDetails: getMentionNameDetails,
            triggeredFor: aiDecorationExperiencePluginState.triggeredFor,
            engagementPlatformApi: api?.engagementPlatform?.actions,
            initialPositions: aiDecorationExperiencePluginState?.initialPositions,
            nudgeMetrics: aiDecorationExperiencePluginState.nudgeMetrics,
            defaultAgent: rovoAgentsPluginState?.defaultAgent,
            canInlineStreamChanges: canInlineStreamChanges,
            hideLoadingScreen: decorationPluginState?.hideLoadingScreen,
            aiGroupId: aiDecorationExperiencePluginState?.currentSessionId,
            interactionSessionId: aiDecorationExperiencePluginState?.interactionSessionId,
            traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? aiDecorationExperiencePluginState?.traceId : undefined
        }));
    };
    const getPositions = ()=>{
        return (0, $d465bdc6207b3d88$export$8e313fd1eaf35cec)({
            modalDecorationSet: aiDecorationExperiencePluginState?.modalDecorationSet
        });
    };
    const renderedSubscribeToRovo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e0fbb2bea9f0ffb$export$e7460f646530f5b4), {
        editorApi: api,
        positions: getPositions(),
        editorView: editorView,
        product: editorPluginAIProvider.product,
        onDocChangeByAgent: editorPluginAIProvider.onDocChangeByAgent,
        onAIProviderChanged: editorPluginAIProvider.onAIProviderChanged,
        editorPluginAIProvider: editorPluginAIProvider
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $dh538.fg)('platform_editor_ai_remove_agents_list') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c7f02ab52bdba8d$export$6d436ac1332526a3), {
        editorView: editorView,
        editorPluginAIProvider: editorPluginAIProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8ab9b1b1a4a1d5e9$export$e4b2c7b98f669fb7), {
        editorView: editorView,
        getMentionNameDetails: getMentionNameDetails,
        editorPluginAIProvider: editorPluginAIProvider,
        editorApi: api
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56e9515070459f37$export$22e51ab65638ad05), {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView
    }), renderedSubscribeToRovo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $510ce0322de9e3d3$export$61f6bd9fac8ed53), {
        inContentComponent: true,
        onCloseFallback: endExperience
    }, renderModalRegion(), rovoAgentsPluginState?.isBrowseModalOpen && !(0, $dh538.fg)('platform_editor_ai_remove_agents_list') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9096bdf9049f901$export$62821c88a7188481), {
        editorView: editorView,
        aiGlobalOptIn: aiOptIn,
        editorPluginAIProvider: editorPluginAIProvider,
        startingConfig: aiDecorationExperiencePluginState?.configItem,
        positions: rovoAgentsPluginState?.positions
    })));
};


const $800163a44b80a632$var$useSharedPluginStateNoDebounce = (api)=>{
    const [state, setState] = (0, $42omo.useState)(api?.aiExperience?.sharedState.currentState()?.aiDecorationExperiencePluginState.modalMountedTimeStamp);
    (0, $42omo.useLayoutEffect)(()=>{
        const unsub = api?.aiExperience?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
            if (prevSharedState?.aiDecorationExperiencePluginState.modalMountedTimeStamp !== nextSharedState?.aiDecorationExperiencePluginState.modalMountedTimeStamp) setState(nextSharedState?.aiDecorationExperiencePluginState.modalMountedTimeStamp);
        });
        return ()=>{
            unsub?.();
        };
    }, [
        api
    ]);
    return state;
};
const $800163a44b80a632$export$d1314adfeea5c2b2 = (props)=>{
    const modalMountedTimeStamp = $800163a44b80a632$var$useSharedPluginStateNoDebounce(props.api);
    const { targetId: targetId, isDisplayingChanges: isDisplayingChanges, isRunning: isRunning } = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.api, [
        'aiExperience',
        'trackChanges'
    ], (state)=>({
            targetId: state.aiExperienceState?.aiDecorationExperiencePluginState.targetId,
            isDisplayingChanges: state.trackChangesState?.isDisplayingChanges,
            isRunning: state.aiExperienceState?.aiDecorationExperiencePluginState.isRunning
        }));
    const endExperience = (0, $42omo.useCallback)((options)=>{
        // after AI start, there is a chance that the plugin state is not updated yet
        // so we need to check if the plugin state is running before ending the experience
        if (!isRunning) return;
        const state = (0, $kqrrC.getPluginState)(props.editorView.state);
        const decoSet = (0, $56Rej.hasGeneratedContentDecorations)(state) || options?.preserveEditorSelectionOnComplete ? state.modalDecorationSet : undefined;
        const endAIExperienceCommand = (0, $5SuLc.createEndAIExperienceCommand)(decoSet, options?.preserveEditorSelectionOnComplete, options?.shouldClearSelectionContext, options?.shouldIgnoreNextSpaceTrigger);
        endAIExperienceCommand(props.editorView.state, props.editorView.dispatch);
    }, [
        props.editorView,
        isRunning
    ]);
    /**
   * This is to detect the state of the Rovo prompt and loading screens
   * from RovoInlineChatPrompt used in RovoPromptScreenWithLogic,
   * as it does not respect the state value from XState.
   */ const [isRovoLoading, setIsRovoLoading] = (0, $42omo.useState)(false);
    /**
   * Stores Rovo's cancel function from onSubmit callback so ExperienceApplication's
   * ESC handler can call it. Needed because editor loses focus when disabled during
   * streaming, breaking normal ESC handling.
   */ const [cancelRovoPrompt, setCancelRovoPrompt] = (0, $42omo.useState)();
    /* reset the component when start AI again, so that the error boundary will also be reset */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e1f6449d50a03b0$export$214e018fc3e147ea), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3a58a391c8755141$export$9bdba9f1d1439b59), {
        value: {
            ...props,
            isRovoLoading: isRovoLoading,
            setIsRovoLoading: setIsRovoLoading,
            targetId: targetId,
            isDisplayingChanges: isDisplayingChanges,
            setCancelRovoPrompt: setCancelRovoPrompt,
            cancelRovoPrompt: cancelRovoPrompt,
            endExperience: endExperience
        }
    }, !(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $118a836b9e6d54ec$export$2dda1e4a1d1f6a81), {
        key: modalMountedTimeStamp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $89ba6b7b6ab5436d$export$83a775c8cee50de8), {
        api: props.api,
        providerFactory: props.providerFactory,
        appearance: props.appearance
    })), (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') && (0, $dh538.fg)('platform_editor_ai_migrate_from_xstate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ec9029f4dc339f8$export$83a775c8cee50de8), {
        api: props.api,
        providerFactory: props.providerFactory,
        appearance: props.appearance
    })));
};


/* ContentComponentWrapperLegacy.tsx generated by @compiled/babel-plugin v0.36.1 */ 






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 


















function $2f86d52e78255595$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f86d52e78255595$var$highlightStyles = {
    name: "1hbjkx0",
    styles: "background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);border-bottom:var(--ds-border-width-selected, 2px) solid var(--ds-background-accent-blue-subtler, #cce0ff)"
};
const $2f86d52e78255595$var$nodeHighlightStyles = {
    name: "mcqy92",
    styles: "border:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #579DFF);box-shadow:0 0 2px 1px var(--ds-background-accent-blue-subtler, #cce0ff)"
};
const $2f86d52e78255595$var$cellHighlightStyles = /*#__PURE__*/ (0, $9K4OG.css)($2f86d52e78255595$var$nodeHighlightStyles, " ::after{border-left:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #579DFF);border-bottom:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #579DFF);}");
// override standard dropdown max-height 90vh to accomodate for long list of translation languages
const $2f86d52e78255595$var$translationsFloatingToolbarDropdownStyles = {
    name: "735ejv",
    styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{max-height:400px;overflow-x:hidden;[data-testid^='ak-editor-ai-selection-toolbar-translate-button'] [data-item-elem-before]>span{padding:0;}}[data-testid='ak-editor-ai-selection-toolbar-ai-dropdown']>span>span{margin:0;}}"
};
const $2f86d52e78255595$var$dropdownHeadingStyles = /*#__PURE__*/ (0, $9K4OG.css)("[aria-label='Selection toolbar']{[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']{cursor:default;>span{gap:initial;}[data-item-elem-before]>span{padding:0;}[data-item-title]{text-transform:uppercase;font-size:0.75rem;font-weight:var(--ds-font-weight-bold, 653);color:", `var(--ds-text, ${(0, $6fnsQ.N200)})`, ";}}[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']:hover{color:", `var(--ds-text, ${(0, $6fnsQ.N700)})`, ";}}");
const $2f86d52e78255595$var$rovoAgentsFloatingToolbarDropdownStyles = {
    name: "aisf00",
    styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{[data-testid='ak-editor-ai-selection-toolbar-dropdown-view-all-agents']:not(:only-child){border-block-start:var(--ds-border-width-selected, 2px) solid var(--ds-menu-seperator-color, var(--ds-border, #e1e3e7));>span{gap:4px;}}button[data-testid^='ak-editor-ai-selection-toolbar-dropdown-agent'] [data-item-title='true']>span{white-space:normal;}}}"
};
var $2f86d52e78255595$var$_ref = {
    name: "1pr32me",
    styles: "button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus,button[data-testid='ak-editor-annotation-toolbar-create-button'],button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,button[data-testid='ak-editor-annotation-toolbar-create-button']:focus{padding:0px var(--ds-space-100, 8px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button'] svg{padding-right:var(--ds-space-050, 4px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button']>span:only-child{svg{padding:0px var(--ds-space-100, 8px);}}"
};
var $2f86d52e78255595$var$_ref2 = {
    name: "2wdbgh",
    styles: "button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus{padding:0px var(--ds-space-075, 6px);}button[data-testid='ak-editor-annotation-toolbar-create-button'],button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,button[data-testid='ak-editor-annotation-toolbar-create-button']:focus{padding:0px var(--ds-space-075, 6px);span:first-child{margin:0;}span[role='img'],svg{padding:0;}}"
};
const $2f86d52e78255595$var$aiSelectionToolbarButtonStyles = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return $2f86d52e78255595$var$_ref2;
    else return $2f86d52e78255595$var$_ref;
};
const $2f86d52e78255595$var$inlineSuggestionsStyles = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".ak-editor-content-area .", (0, $d4d1598b7faaa41b$export$e510567c2b33e62).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS, "{padding:var(--ds-space-100, 8px);border-radius:var(--ds-space-075, 6px);[class$='-DateLozenge']{margin:0;}}.", (0, $49ae62cb4df29db1$export$3582487b0804e1f6).INLINE_SUGGESTION_DECORATION_CLASSES.underline, "{text-decoration-line:underline;text-decoration-style:dashed;text-decoration-color:var(--ds-border-accent-blue, #1D7AFC);}.", (0, $49ae62cb4df29db1$export$3582487b0804e1f6).INLINE_SUGGESTION_DECORATION_CLASSES.highlight, "{background-color:var(--ds-background-selected, #E9F2FF);}.", (0, $49ae62cb4df29db1$export$3582487b0804e1f6).INLINE_SUGGESTION_DECORATION_CLASSES.completionHint, "{color:", `var(--ds-text, ${(0, $6fnsQ.N800)})`, ";opacity:var(--ds-opacity-disabled, 0.5);pointer-events:none;user-select:none;}");
};
const $2f86d52e78255595$var$userHighlightBackgroundColor = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.akEditor div.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ai-pre-stream-range-selection': {
            backgroundColor: `rgb(from ${"var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)"} r g b / 0.5)`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.ak-editor-annotation-draft, &.ak-editor-annotation-focus, &.ak-editor-annotation-blur': {
                all: 'unset',
                backgroundColor: `rgb(from ${"var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)"} r g b / 0.5)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.annotationView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-annotation-draft, .ak-editor-annotation-focus, .ak-editor-annotation-blur': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '&:has(.ai-pre-stream-selection-highlight)': {
                    all: 'unset',
                    backgroundColor: `rgb(from ${"var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)"} r g b / 0.5)`
                }
            }
        }
    }
});
const $2f86d52e78255595$var$globalStyles = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".akEditor div.ProseMirror{.ai-modal-start-widget,.ai-modal-end-widget{position:relative;&::before{content:'';background-image:url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxSDBMMSAxLjg1NzE0VjE4LjE0MzNMMCAxOS4wMDA0SDNMMiAxOC4xNDMzVjEuODU3MTRMMyAxSDJIMVoiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3QgeT0iMTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iMSIgZmlsbD0iIzU3OURGRiIvPgo8L3N2Zz4K');z-index:1;display:block;position:absolute;top:0;bottom:var(--ds-space-negative-025, -2px);background-repeat:no-repeat;background-position-x:center;background-position-y:center;background-size:contain;aspect-ratio:3/20;}}.ai-modal-start-widget::before{left:0px;margin-left:-0.1em;}.ai-modal-end-widget::before{right:0px;margin-right:-0.1em;}.ai-generated-content-highlight{", $2f86d52e78255595$var$highlightStyles, ";}.ai-selection-highlight{", $2f86d52e78255595$var$highlightStyles, "&.ak-editor-annotation-draft,&.ak-editor-annotation-focus,&.ak-editor-annotation-blur{all:unset;", $2f86d52e78255595$var$highlightStyles, ";}}.ai-selection-node .pm-table-wrapper{table tr td,table tr th{", (0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Border,
        (0, $b38UX.SelectionStyle).Blanket
    ]), ";}}.ai-generated-node-highlight .pm-table-wrapper{table tr td,table tr th{", $2f86d52e78255595$var$cellHighlightStyles, ";}}.annotationView-content-wrap{.ak-editor-annotation-draft,.ak-editor-annotation-focus,.ak-editor-annotation-blur{&:has(.ai-selection-highlight){all:unset;", $2f86d52e78255595$var$highlightStyles, ";}}}}");
};
const $2f86d52e78255595$export$214e018fc3e147ea = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: [
            $2f86d52e78255595$var$translationsFloatingToolbarDropdownStyles,
            $2f86d52e78255595$var$rovoAgentsFloatingToolbarDropdownStyles,
            $2f86d52e78255595$var$inlineSuggestionsStyles(),
            $2f86d52e78255595$var$dropdownHeadingStyles,
            $2f86d52e78255595$var$globalStyles(),
            $2f86d52e78255595$var$userHighlightBackgroundColor,
            $2f86d52e78255595$var$aiSelectionToolbarButtonStyles()
        ]
    }), children);
};


/* ContentComponentLegacy.tsx generated by @compiled/babel-plugin v0.36.1 */ 





























































































const $7808287d3e166156$export$28146c614df26dc4 = ({ formatMessage: formatMessage, experienceState: experienceState })=>{
    const discardPrompt = formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).discardMessagePrompt);
    const discardResponse = formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).discardMessageResponse);
    if (typeof experienceState === 'object' && 'user input state' in experienceState) return discardPrompt;
    if (experienceState === 'review state' || typeof experienceState === 'object' && 'loading state' in experienceState) return discardResponse;
    return discardResponse;
};
function $7808287d3e166156$export$643e9e046f871343({ state: state, editCount: editCount, retryPromptCount: retryPromptCount, history: history, onceDiscard: onceDiscard, channelId: channelId, streamFlowPacer: streamFlowPacer }) {
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, configItem: configItem, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, appearance: appearance } = aiExperienceCommonData;
    const inputOutputDiffRatio = (0, $42omo.useMemo)(()=>{
        const lastHistoryEvent = history.entries[history.positionFromEnd];
        return history.entries.length === 0 ? '' : lastHistoryEvent.inputOutputDiffRatio;
    }, [
        history
    ]);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $3adf5d183dded6a4$export$f06fb39743945e19)({
        stepName: 'discard',
        attributes: {
            editCount: editCount,
            retryPromptCount: retryPromptCount,
            inputOutputDiffRatio: inputOutputDiffRatio,
            includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage
        }
    });
    (0, $42omo.useEffect)(()=>{
        streamFlowPacer?.pause();
        return ()=>{
            streamFlowPacer?.resume();
        };
    }, [
        streamFlowPacer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $01efd7a6722fa820$export$453c0e2ebf820c66), {
        text: $7808287d3e166156$export$28146c614df26dc4({
            formatMessage: formatMessage,
            experienceState: state
        }),
        onCancel: function() {
            sendToAIExperienceMachine({
                type: 'disable discard'
            });
        },
        onDiscard: function() {
            /**
     * Introduced in EDF-1443 to track discard event confirmations
     * separately to normal discard events which get tracked
     * earlier in this file
     */ fireAIAnalyticsEvent({
                payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                    action: (0, $d925B.ACTION).DISMISSED,
                    interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                    experienceName: (0, $6gJll.convertExperienceName)(configItem.key.toString()),
                    isProactive: false,
                    attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    }),
                    invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                    // Remove below flag when AIFC is fully rolled out in Jira, only required for old experience in Jira.
                    isStreamingEnded: (0, $dh538.fg)('platform_editor_ai_streaming_ended_analytics_attr') ? !!analyticsFlow.getCommonAttributes().isStreamingEnded : undefined
                })
            });
            if (onceDiscard) {
                sendToAIExperienceMachine({
                    type: 'disable discard'
                });
                onceDiscard();
            } else endExperience();
        },
        appearance: appearance
    });
}




/* LoadingScreenWithLogicLegacy.tsx generated by @compiled/babel-plugin v0.36.1 */ 




































// the scroll parent element and scrollable content height
const $9f41e7d7fa207e85$var$AK_EDITOR_CONTENT_AREA_SELECTOR = '.ak-editor-content-area'; /**
                                                                    * Scroll margin is used to ensure that the modal won't be
                                                                    * too close to the top of the editor, which may sometimes
                                                                    * cover the modal slightly.
                                                                    */ 
const $9f41e7d7fa207e85$var$scrollMarginStyles = null;
function $9f41e7d7fa207e85$export$9c279fd5d5bced59({ updateStream: updateStream, parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, title: title, latestPrompt: latestPrompt, promptTrigger: promptTrigger, refinementCount: refinementCount, latestPromptRetried: latestPromptRetried, markdown: markdown, adfResponse: adfResponse, idMap: idMap, contextStatistics: contextStatistics, hideLoadingScreen: hideLoadingScreen }) {
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { configItem: configItem, editorView: editorView, providerFactory: providerFactory, sendToAIExperienceMachine: sendToAIExperienceMachine, editorPluginAIProvider: editorPluginAIProvider, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, isUserScroll: isUserScroll, isProgrammaticScroll: isProgrammaticScroll, appearance: appearance } = aiExperienceCommonData;
    const schema = editorView.state.schema;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const disclaimer = (0, $ae9409607dcc8014$export$b38eff301cbfa415)({
        editorPluginAIProvider: editorPluginAIProvider
    });
    const presetPromptLabel = (0, $c2200b5407d4af9f$export$4539b8c6808af330)(configItem, formatMessage);
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const [preview, setPreview] = (0, $42omo.useState)();
    const [hasPreview, setHasPreview] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)(null); // raf is used for debouncing, if useEffect is called
    // multiple times before raf is run this prevents rendering
    // multiple times if we receive streams very quickly
    const raf = (0, $42omo.useRef)();
    const errorReported = (0, $42omo.useRef)(false); /**
                                                 * scrollParentRef is for
                                                 * storing the scroll parent element once its found
                                                 * to be re-used in calculations
                                                 */ 
    const scrollParentRef = (0, $42omo.useRef)(null);
    const initialScrollTop = (0, $42omo.useRef)(0);
    const modalOffsetTop = (0, $42omo.useRef)(0);
    const isModalAtTop = (0, $42omo.useRef)(false);
    const scrollModalAlignBottom = (0, $42omo.useCallback)((modalEl, scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current + modalEl.scrollHeight - scrollParentEl.offsetHeight,
            behavior: 'instant'
        });
    }, [
        isProgrammaticScroll
    ]);
    const scrollModalToTop = (0, $42omo.useCallback)((scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current - (0, $e1bfb729a95c0d28$export$9a9d72a255528f),
            behavior: 'instant'
        });
    }, [
        isProgrammaticScroll
    ]);
    (0, $42omo.useEffect)(()=>{
        /**
     * Set up ResizeObserver to detect cases where the editor content grows,
     * as it will normally trigger a scroll event due to scrollHeight and scrollTop changes.
     * We set isProgrammaticScroll to true to flag it as a non-user scroll.
     */ const editorContentArea = editorView.dom.closest($9f41e7d7fa207e85$var$AK_EDITOR_CONTENT_AREA_SELECTOR);
        if (!editorContentArea) return;
        const resizeObserver = new ResizeObserver(()=>{
            isProgrammaticScroll.current = true;
        });
        resizeObserver.observe(editorContentArea);
        return ()=>resizeObserver.unobserve(editorContentArea);
    }, [
        editorView,
        isProgrammaticScroll
    ]); /**
                                           * Editor AI can be invoked directly into this Loading screen.
                                           * ExperienceApplication calls scrollIntoView
                                           * (currently only when platform_editor_ai_scroll_into_view_fix is on, when off it is triggered from UserInputCommandPalette)
                                           *
                                           * We need to check whether scrollIntoView is complete to determine when to track user scrolling for the auto-scroll logic
                                           * that prevents scroll-jacking when a user scrolls away.
                                           */ 
    const [isScrollIntoViewSettled, setIsScrollIntoViewSettled] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_scroll_into_view_fix')) return;
        const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = (0, $7YjFd.findOverflowScrollParent)(modalEl);
        if (!scrollParentEl) return;
        const settleScroll = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setIsScrollIntoViewSettled(true); /**
                                         * Once it's settled, we can unbind
                                         * as we only need to check when it first loads
                                         *
                                         * This is to emulate scrollEnd which is not supported
                                         * across all browsers at the moment.
                                         *
                                         * unbind taken from the bind function below
                                         */ 
            unbind();
        }, 250);
        const unbind = (0, $fFa3V.bind)(scrollParentEl, {
            type: 'scroll',
            listener: settleScroll
        });
    }, []);
    (0, $42omo.useEffect)(()=>{
        /**
     * Setup init values to calculate scroll distance and
     * scroll the modal into view if it is not already visible.
     */ const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = (0, $7YjFd.findOverflowScrollParent)(modalEl);
        if (!scrollParentEl) return;
        scrollParentRef.current = scrollParentEl; // Calculate the offset of the modal from the top of editor
        modalOffsetTop.current = modalEl.getBoundingClientRect().top - scrollParentEl.getBoundingClientRect().top; // Calculate initial scroll position of editor
        initialScrollTop.current = scrollParentEl.scrollTop; // Calculate position of the bottom of the modal from top of editor
        const modalBottomOffsetTop = modalOffsetTop.current + modalEl.scrollHeight;
        if (modalBottomOffsetTop < 0) // Edge case: if modal above the top of the editor
        scrollModalToTop(scrollParentEl);
        else if (modalOffsetTop.current > scrollParentEl.offsetHeight) /**
       * Edge case: if modal is below the bottom of the editor
       * Call scrollModalAlignBottom to move modal into view.
       */ scrollModalAlignBottom(modalEl, scrollParentEl);
        const unbind = (0, $fFa3V.bind)(scrollParentEl, {
            type: 'scroll',
            listener: ()=>{
                if ((0, $dh538.fg)('platform_editor_ai_scroll_into_view_fix')) {
                    if (isScrollIntoViewSettled && !isProgrammaticScroll.current) {
                        isUserScroll.current = true;
                        unbind();
                    }
                } else if (!isProgrammaticScroll.current) {
                    isUserScroll.current = true;
                    unbind();
                }
                isProgrammaticScroll.current = false;
            }
        });
        return ()=>{
            unbind();
        };
    }, [
        scrollModalToTop,
        scrollModalAlignBottom,
        isScrollIntoViewSettled,
        isProgrammaticScroll,
        isUserScroll
    ]);
    function scrollModalIntoView() {
        /**
     * Early exits:
     * - If user has manually scrolled, stop auto-scrolling
     * - If modal has reached the top of the editor, no more calculations or scrolling needed
     */ if (isUserScroll.current || isModalAtTop.current) return;
        const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = scrollParentRef.current;
        if (!scrollParentEl) return;
         // Check if modal is already fully visible
        const isModalFullyVisible = scrollParentEl.offsetHeight > modalOffsetTop.current + modalEl.scrollHeight; /**
                                                                                                              * Check if modal height exceeds scroll parent's height
                                                                                                              * Scroll margin is used to prevent the modal from being scrolled to the top
                                                                                                              * and should match scroll margin in other modals e.g. from
                                                                                                              * packages/editor/editor-plugin-ai/src/ui/components/FloatingContainer/styles.ts
                                                                                                              */ 
        const isModalFullHeight = scrollParentEl.offsetHeight - (0, $e1bfb729a95c0d28$export$9a9d72a255528f) < modalEl.scrollHeight;
        if (isModalFullyVisible) return;
        if (isModalFullHeight) {
            scrollModalToTop(scrollParentEl);
            isModalAtTop.current = true;
            return;
        }
        scrollModalAlignBottom(modalEl, scrollParentEl);
    }
    const adfResponseRef = (0, $42omo.useRef)(adfResponse);
    adfResponseRef.current = adfResponse;
    (0, $42omo.useEffect)(()=>{
        // only run the callback if the raf has not been set, and then
        // reset raf to undefined
        if (raf.current === undefined) raf.current = window.requestAnimationFrame(()=>{
            let _preview;
            raf.current = undefined;
            if (adfResponseRef.current && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products')) _preview = (0, $e63c465153c397bc$export$5ae44876b720d032)({
                adfResponse: adfResponseRef.current,
                showTelepointer: true,
                providerFactory: providerFactory
            });
            else if (!markdown || markdown === '') // When there is no streamed preview content -- set the preview to
            // undefined.
            // This allows a nicer loading screen (rather than showing an empty paragraph).
            _preview = undefined;
            else {
                const { pmFragment: pmFragment } = (0, $6537ba32a2b947a8$export$a08e8b3dacf7ffcc)({
                    markdown: markdown,
                    schema: schema,
                    source: 'loading',
                    fireAIAnalyticsEvent: (event)=>{
                        if (!errorReported.current) {
                            errorReported.current = true;
                            fireAIAnalyticsEvent(event);
                        }
                    },
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    idMap: idMap
                }); /**
               * Hold off on setting the preview if we appear to be receiving
               * a custom tag through our stream. This is to hide raw tags from
               * users until the tags are complete and can be rendered back into nodes.
               */ 
                if ((0, $a0122b81a4611d41$export$bde720e3489117f9)(markdown)) return;
                _preview = (0, $e63c465153c397bc$export$f5e3af6d625de7a)({
                    schema: schema,
                    pmFragment: pmFragment,
                    showTelepointer: true,
                    providerFactory: providerFactory
                });
            }
            if (_preview) {
                setPreview(_preview);
                setHasPreview(true);
                window.requestAnimationFrame(()=>{
                    scrollModalIntoView();
                });
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        markdown,
        updateStream,
        adfResponse
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // if the component is unmounted before the raf callback
            // has run, we cancel it
            if (raf.current) window.cancelAnimationFrame(raf.current);
        };
    }, []); // preset prompt or base generate / interrogation
    const localizedLatestPrompt = (0, $62aff15c20d44eff$export$6399b1de54f080ad)(latestPrompt);
    const promptStatistics = (0, $b51c49163805cfe9$export$4e4614f0417d7178)(localizedLatestPrompt);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$f06fb39743945e19)({
        needUpdatedArgs: true,
        stepName: 'loading',
        attributes: {
            promptType: promptTrigger,
            latestPromptRetried: latestPromptRetried,
            refinementCount: refinementCount,
            modelIO: {
                contextStatistics: contextStatistics,
                userInputCharacterCount: promptStatistics?.totalCharacterCount,
                userInputNodeCounts: promptStatistics?.nodeCounts,
                userInputLinksCount: promptStatistics?.linksCount,
                userInputMentionsCount: promptStatistics?.mentionsCount
            },
            includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage,
            // Remove below flag when AIFC is fully rolled out in Jira, only required for old experience in Jira.
            isStreamingEnded: (0, $dh538.fg)('platform_editor_ai_streaming_ended_analytics_attr') ? false : undefined
        }
    });
    const previewBecameAvailable = (0, $42omo.useRef)();
    if (!previewBecameAvailable.current && hasPreview) previewBecameAvailable.current = performance.now();
    (0, $42omo.useEffect)(()=>{
        const noPreviewAvailable = performance.now();
        return ()=>{
            if (!previewBecameAvailable.current) return;
            analyticsFlow.addAttributes({
                durations: {
                    timeSpentWithoutPartialPreview: previewBecameAvailable.current - noPreviewAvailable,
                    timeSpentWithPartialPreview: performance.now() - previewBecameAvailable.current
                }
            });
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ $42omo.createElement("div", {
        ref: containerRef,
        className: (0, $gMc0m.default)([
            "_j4orxy5q"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $7JKll.LoadingScreen), {
        parentPresetPromptLabel: parentPresetPromptLabel,
        childShortTitle: childShortTitle,
        presetPromptLabel: presetPromptLabel,
        latestPrompt: localizedLatestPrompt,
        agent: configItem?.agent,
        title: title,
        preview: preview,
        providerFactory: providerFactory,
        disclaimer: disclaimer,
        onCancel: ()=>{
            sendToAIExperienceMachine({
                type: 'enable discard'
            });
        },
        schema: schema,
        isStreaming: !!adfResponse || !!markdown,
        canInlineStreamChanges: true,
        hideLoadingScreen: !!hideLoadingScreen,
        appearance: appearance
    }));
}















var $1A9t2 = parcelRequire("1A9t2");



var $hge3g = parcelRequire("hge3g");


var $9VJDA = parcelRequire("9VJDA");





var $hezkK = parcelRequire("hezkK");

/* UserInputCommandPalette.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ // Entry file
/* eslint-disable @atlaskit/editor/no-re-export */ 


















var $5KVL8 = parcelRequire("5KVL8");


var $cO1el = parcelRequire("cO1el");













/* CommandPaletteLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");















const $df023c99eb7b3c63$var$lozengeContainerStyleBig = {
    default: "_zulpu2gc _1e0c1txw _u5f3utpp _n3tdutpp _19bvutpp _4cvr1h6o"
};
const $df023c99eb7b3c63$var$lozengeContainerStyle = {
    default: "_zulpu2gc _1e0c1txw _4cvr1h6o"
};
const $df023c99eb7b3c63$export$1c1a126042a474aa = ({ onFormSubmit: onFormSubmit, inputValue: inputValue, suggestions: suggestions, setSuggestion: setSuggestion, showButton: showButton })=>{
    const highlightedSuggestion = suggestions.find((suggestion)=>suggestion.value === 'Brainstorm');
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $imfiV.useElementBreakpoints)();
    /**
   * This is a quick spike intermediate solution to determine how many suggestions to display
   */ const howManySuggestionsToDisplay = (s)=>{
        if (!s.length) return 0;
        const isSmall = breakpoint <= (0, $imfiV.Breakpoint).Small;
        const first = s[0];
        if (first.value === 'Brainstorm') return 1;
        const isTopLevel = !first.nestingConfig || first.label === first.nestingConfig.parentTitle;
        if (isTopLevel) return isSmall ? 1 : 3;
        return isSmall ? 1 : s.length;
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        ref: setBreakpointsElement,
        spread: "space-between",
        xcss: $df023c99eb7b3c63$var$lozengeContainerStyleBig.default,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $df023c99eb7b3c63$var$lozengeContainerStyle.default,
                children: !inputValue && suggestions.filter((suggestion)=>suggestion.value !== 'tell-ai' && suggestion.value !== 'show-more').slice(0, howManySuggestionsToDisplay(suggestions)).map((suggestion)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        spacing: "compact",
                        onClick: ()=>suggestion.onSelect(),
                        onMouseEnter: ()=>suggestion.onSuggestionFocused(),
                        onMouseLeave: ()=>setSuggestion(highlightedSuggestion ? highlightedSuggestion : suggestion),
                        children: suggestion.label
                    }, `${suggestion.value}-button`))
            }),
            showButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                spacing: "compact",
                label: "send-icon-command-palette-lozenge",
                isDisabled: inputValue === '',
                onClick: ()=>{
                    onFormSubmit(inputValue);
                }
            })
        ]
    });
};





/* UsePageKnowledgeToggleFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











var $82gXq = parcelRequire("82gXq");


var $giv7U = parcelRequire("giv7U");

const $d6b6d26ba87ef6e1$var$footerStyles = {
    default: "_zulp1b66 _1e0c1txw _ca0q12x7 _19bv12x7 _u5f312x7 _n3td12x7 _uwhke4h9 _15a5nqa1 _1i531l7x _4cvr1h6o"
};
const $d6b6d26ba87ef6e1$var$labelStyles = null;
function $d6b6d26ba87ef6e1$export$c486b1aa62224a41({ onChange: onChange, isChecked: isChecked }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const TOGGLE_ID = 'page-knowledge-toggle';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $d6b6d26ba87ef6e1$var$footerStyles.default,
        backgroundColor: "elevation.surface",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $82gXq.default), {
                id: TOGGLE_ID,
                testId: TOGGLE_ID,
                onChange: onChange,
                isChecked: isChecked
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("label", {
                htmlFor: TOGGLE_ID,
                className: (0, $gMc0m.default)([
                    "_syazazsu"
                ]),
                children: formatMessage((0, $giv7U.default).usePageKnowledgeToggleLabel)
            })
        ]
    });
}




var $bwdMU = parcelRequire("bwdMU");

/* Suggestions.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /** @jsxfrag */ 























/* ListHeading.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







const $d27613aa5204a6b7$var$stickySuggestionsGroupHeadingStyles = null;
const $d27613aa5204a6b7$var$suggestionsGroupHeadingStyles = null;
const $d27613aa5204a6b7$var$groupHeadingStyles = null;
const $d27613aa5204a6b7$export$b7bc1538a6ef0630 = ({ id: id, heading: heading })=>{
    /* Using h3, as the parent element can potentially put in a h2 heading above suggestions
   * TODO: EDF-2349 - double check in branch deploy when migrating to compiled to see if passing in
   * styles directly to css prop in h3 (instead of using classname and nested selector) is still overridden
   * by Confluence styles, or whether compiled migration mitigates that
   */ return /*#__PURE__*/ (0, $l998X.jsx)("h3", {
        id: id,
        "data-testid": id,
        className: (0, $gMc0m.default)([
            (0, $dh538.fg)('ai-smart-button-team-25') ? "_fqoxfhey _1bg4usvi _rcujze3t _o81cze3t _1l6uze3t _149mze3t _if291txw _1dltutpp _1yxxpxbi _w8sqpxbi _fjwr1b66 _12r21wq8 _1w901rpy" : "_fqoxwadc _1bg4usvi _if291txw _rcujze3t _o81cze3t _1l6uze3t _149mze3t _1dltutpp _w8squtpp _fjwr1b66 _1yxxutpp _1y2cwu06 _nmk4angw _1w90azsu",
            "_kqsw1if8 _1bsb1kw7 _154iidpf _bfhkvuon _1pbykb7n"
        ]),
        children: heading
    });
};


/* ListItem.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-html-button */ 


















var $5nBzc = parcelRequire("5nBzc");













/* Logo.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 





const $6e0c8e6ceb97bde0$export$77af5b11f07c3aed = ({ alt: alt, isDisabled: isDisabled = false, isSelected: isSelected = false, className: className, size: size = 24, isPadded: isPadded = true, style: style = {} })=>{
    const stroke = isDisabled ? "var(--ds-icon-disabled, #080F214A)" : isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
    const commonProps = {
        width: size,
        height: size,
        className: className,
        role: alt === '' ? 'presentation' : undefined,
        xmlns: 'http://www.w3.org/2000/svg',
        style: style
    };
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        ...commonProps,
        viewBox: isPadded ? '0 0 24 24' : '0 0 16 16',
        children: [
            alt && /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: alt
            }),
            isPadded ? /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.5 14.5L17.5 17.5",
                        stroke: stroke,
                        strokeWidth: "1.5",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.5 14.5L6.5 17.5",
                        stroke: stroke,
                        strokeWidth: "1.5",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.5 9.5L6.5 6.5",
                        stroke: stroke,
                        strokeWidth: "1.5",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.5 9.5L17.5 6.5",
                        stroke: stroke,
                        strokeWidth: "1.5",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.0001 16V19",
                        stroke: stroke,
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.00012 12L5.00012 12",
                        stroke: stroke,
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.0001 8.00002L12.0001 4.99999",
                        stroke: stroke,
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.0002 12L19.0002 12",
                        stroke: stroke,
                        strokeWidth: "1.5"
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.24999 4V1H8.74999V4H7.24999ZM5.46966 6.53033L1.46966 2.53033L2.53032 1.46967L6.53032 5.46967L5.46966 6.53033ZM9.46966 5.46967L13.4697 1.46967L14.5303 2.53033L10.5303 6.53033L9.46966 5.46967ZM0.999992 7.25H3.99999V8.75H0.999992V7.25ZM12 7.25H15V8.75H12V7.25ZM1.46966 13.4697L5.46966 9.46967L6.53032 10.5303L2.53032 14.5303L1.46966 13.4697ZM13.4697 14.5303L9.46966 10.5303L10.5303 9.46967L14.5303 13.4697L13.4697 14.5303ZM7.24999 15V12H8.74999V15H7.24999Z",
                fill: "currentColor"
            })
        ]
    }));
};





const $40f6ad55199251f8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    tellAILabel: {
        id: "fabric.editor.ai.ui.components.suggestions.tellAILabel",
        defaultMessage: "Tell AI"
    },
    tellAgentLabel: {
        id: "fabric.editor.ai.ui.components.suggestions.tellAgentLabel",
        defaultMessage: "Tell Agent"
    },
    suggestionStatusBeta: {
        id: "fabric.editor.ai.ui.components.suggestions.betaLozenge",
        defaultMessage: "BETA"
    },
    suggestionStatusNew: {
        id: "fabric.editor.ai.ui.components.suggestions.newLozenge",
        defaultMessage: "NEW"
    }
});


const $d9761ba7984b9121$var$contentStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _ct361wug _slp31hna _1ul9l1r9 _1bto1l2s _o5721q9c"
};
const $d9761ba7984b9121$var$chevronIconStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d9761ba7984b9121$var$descriptionStylesUnbounded = null;
const $d9761ba7984b9121$var$descriptionStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d9761ba7984b9121$var$enterStylesUnbounded = null;
const $d9761ba7984b9121$var$enterStyles = null;
const $d9761ba7984b9121$var$statusStyles = {
    default: "_19bv1b66"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d9761ba7984b9121$var$suggestionButtonStylesUnbounded = null;
const $d9761ba7984b9121$var$suggestionButtonStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d9761ba7984b9121$var$suggestionItemStylesUnbounded = null;
const $d9761ba7984b9121$var$suggestionItemStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d9761ba7984b9121$var$suggestionIconStylesUnbounded = null;
const $d9761ba7984b9121$var$suggestionIconStyles = null;
const $d9761ba7984b9121$var$suggestionListItemStyles = null;
const $d9761ba7984b9121$var$tellAILabelStyles = null;
const $d9761ba7984b9121$var$rovoSuggestionButtonStyles = null;
const $d9761ba7984b9121$var$rovoSuggestionIconStyles = null; // Height of ListHeading component, used to calculate the scroll position.
// Kind of a hack, but it's the easiest way to get the height of the sticky group header.
const $d9761ba7984b9121$var$STICKY_GROUP_HEADER_HEIGHT = 32;
const $d9761ba7984b9121$var$ensureElementIsVisibleInScrollContainer = (listItem, stickyHeaderHeight)=>{
    // ensure the structure of suggestions li element > ul (position relative) > scrollable div (overflow auto)
    const scrollContainer = listItem.offsetParent?.parentElement;
    if (!scrollContainer || scrollContainer.tagName !== 'DIV') return;
    const scrollContainerRect = scrollContainer.getBoundingClientRect();
    const itemRect = listItem.getBoundingClientRect(); // if highlighted item is above/below the current scroll viewport
    const itemNotVisible = listItem.offsetTop < scrollContainer.scrollTop || listItem.offsetTop + itemRect.height > scrollContainer.scrollTop + scrollContainerRect.height;
    if (itemNotVisible) // Can't use item.scrollIntoView() because it moves the whole page too
    scrollContainer.scrollTo({
        top: listItem.offsetTop - stickyHeaderHeight,
        behavior: 'smooth'
    });
};
const $d9761ba7984b9121$var$statusLozengeMessages = {
    beta: (0, $40f6ad55199251f8$export$defe85febe8b728c).suggestionStatusBeta,
    new: (0, $40f6ad55199251f8$export$defe85febe8b728c).suggestionStatusNew
};
const $d9761ba7984b9121$var$suggestionIconContainerStylesUnbounded = null;
const $d9761ba7984b9121$var$suggestionIconContainerStyles = null;
const $d9761ba7984b9121$var$suggestionIconContainerBorderStyles = null;
const $d9761ba7984b9121$export$a7b06bfba60a8a78 = ({ suggestion: suggestion, customLabel: customLabel, highlighted: highlighted, setSuggestion: setSuggestion, hasGroupHeading: hasGroupHeading })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const listItemRef = (0, $42omo.useRef)(null);
    const hasChildren = (0, $42omo.useMemo)(()=>{
        return suggestion.childSuggestions && suggestion.childSuggestions.length;
    }, [
        suggestion.childSuggestions
    ]);
    const updateSuggestion = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((eventName)=>{
        if (setSuggestion) setSuggestion(suggestion, eventName);
    }, [
        setSuggestion,
        suggestion
    ]);
    const onFocus = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        updateSuggestion('focus');
        suggestion.onSuggestionFocused();
    }, [
        updateSuggestion,
        suggestion
    ]);
    const onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        updateSuggestion('mousemove');
    }, [
        updateSuggestion
    ]);
    (0, $42omo.useEffect)(()=>{
        // If the item is highlighted and not hovered, scroll it into view
        if (highlighted && listItemRef.current && !listItemRef.current.matches(':hover')) $d9761ba7984b9121$var$ensureElementIsVisibleInScrollContainer(listItemRef.current, hasGroupHeading ? $d9761ba7984b9121$var$STICKY_GROUP_HEADER_HEIGHT : 0);
    }, [
        listItemRef,
        highlighted,
        hasGroupHeading
    ]);
    const chevronRight = (0, $42omo.useMemo)(()=>{
        if (hasChildren && !highlighted) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            className: (0, $gMc0m.default)([
                "_ca0qze3t _n3tdze3t _19bv1b66 _u5f31b66"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            })
        });
        return null;
    }, [
        hasChildren,
        highlighted
    ]);
    const statusLozengeText = suggestion.statusLozengeType && ($d9761ba7984b9121$var$statusLozengeMessages[suggestion.statusLozengeType] ? formatMessage($d9761ba7984b9121$var$statusLozengeMessages[suggestion.statusLozengeType]) : null);
    const ariaLabel = customLabel ? customLabel : typeof suggestion.label === 'string' ? suggestion.label : formatMessage((0, $40f6ad55199251f8$export$defe85febe8b728c).tellAILabel);
    return /*#__PURE__*/ (0, $l998X.jsx)("li", {
        ref: listItemRef,
        className: (0, $gMc0m.default)([
            "_qtt8glyw _19pkze3t"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("button", {
            type: "button",
            onClick: suggestion.onSelect,
            onMouseMove: onMouseMove,
            "data-testid": suggestion.testId || (customLabel ? `tell-ai` : suggestion.label),
            "data-highlighted": highlighted,
            "aria-label": (0, $1oCLl.expValEquals)('platform_editor_drag_handle_aria_label', 'isEnabled', true) ? ariaLabel : '',
            onFocus: onFocus,
            className: (0, $gMc0m.default)([
                "_11c8fhey _1bsb1osq _1tke1ylp _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _19pkze3t _1e0c1txw _2lx2vrvc _1bahv2br _4cvr1h6o _y3gn1e5h _k48pi7a9 _syazi7uo",
                "_19itidpf _2rkoidpf _zulpw1gv _11q7glyw _13liidpf _qrwqidpf _p8yktlke _ga3tfcek _13l41dpa _1jlodfik _1afz1i6y _1b6jby5v _xa3z1gmx _1lo213gf",
                (0, $dh538.fg)('ai-smart-button-team-25') && "_zulputpp _1bsb1osq _19bvv47k _u5f3v47k _ca0q12x7 _n3td12x7 _19pkze3t _otyrze3t _18u0ze3t _2hwxze3t _1e0c1txw _1bahv2br _4cvr1h6o _y3gn1e5h _k48pi7a9 _syazi7uo",
                (0, $dh538.fg)('ai-smart-button-team-25') && "_19itidpf _11q7glyw _1tke1jfw _p8yktlke _ga3tfcek _13l41dpa _1jlodfik _1afz1i6y _1b6jby5v _xa3z1gmx _1lo213gf",
                suggestion.value.includes('agent:') && "_1tke1a70"
            ]),
            children: [
                !suggestion.hideIcon && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_1e0c116y _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg",
                        "_xcdj1tcg _htdvgktf",
                        (0, $dh538.fg)('ai-smart-button-team-25') && "_1e0c1txw _4cvr1h6o _1bah1h6o",
                        (0, $dh538.fg)('ai-smart-button-team-25') && "_4t3ixy5q _1bsbxy5q",
                        !suggestion.isAgent && (0, $dh538.fg)('ai-smart-button-team-25') && "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
                        suggestion.value.includes('agent:') && "_4t3izwfg _1bsbzwfg"
                    ]),
                    children: suggestion.icon || ((0, $dh538.fg)('ai-smart-button-team-25') ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                        spacing: "spacious",
                        label: ""
                    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6e0c8e6ceb97bde0$export$77af5b11f07c3aed), {
                        className: "default-icon",
                        alt: ''
                    }))
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    direction: "column",
                    xcss: $d9761ba7984b9121$var$contentStyles.default,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            alignItems: "center",
                            children: [
                                !customLabel ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    children: suggestion.label
                                }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                            className: (0, $gMc0m.default)([
                                                "_k48p1wq8 _2hwx1b66"
                                            ]),
                                            children: customLabel
                                        }),
                                        ' "',
                                        suggestion.label,
                                        '"'
                                    ]
                                }),
                                statusLozengeText && /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                                    alignItems: "center",
                                    xcss: $d9761ba7984b9121$var$statusStyles.default,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                        appearance: "new",
                                        children: statusLozengeText
                                    })
                                })
                            ]
                        }),
                        suggestion.description && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            className: (0, $gMc0m.default)([
                                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8rymc _ct361wug _slp31hna _1ul9l1r9 _1bto1l2s _o5721q9c _syaz1rpy _1e0c1o8l",
                                "_vwz4dlk8"
                            ]),
                            children: suggestion.description
                        })
                    ]
                }),
                suggestion.rightText && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: suggestion.rightText
                }),
                suggestion.value !== 'no-suggestions' && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_1e0cglyw _4t3igktf _1bsbgktf _syazazsu _bfhk1dpa",
                        "_2rkofajl _jbdb116y _w7a71h6o _1rrh1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b08c7be14e35e8a5$export$2e2bcd8739ae039), {})
                }),
                chevronRight
            ]
        })
    });
};



const $87f440f2126ef949$var$suggestionsContainerStylesUnbounded = null;
const $87f440f2126ef949$var$suggestionsContainerStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $87f440f2126ef949$var$suggestionsHeadingStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $87f440f2126ef949$var$suggestionsGroupStyles = null;
const $87f440f2126ef949$var$suggestionsScrollerPostGAStyles = {
    default: "_16jlidpf _1o9zkb7n _i0dl1wug _18m91wug"
};
const $87f440f2126ef949$var$suggestionsContainerTeam25Styles = null;
function $87f440f2126ef949$export$5b54ed2fa23d62e9(output, suggestion) {
    let suggestionGroup;
    if (typeof suggestion.groupHeading === 'function') suggestionGroup = suggestion.groupHeading();
    else suggestionGroup = suggestion.groupHeading || '';
    let existingRecordIndex = output.findIndex((s)=>s.groupHeading === suggestionGroup); // If the group doesn't exist, create it
    if (existingRecordIndex === -1) {
        const suggestionsLength = output.push({
            groupHeading: suggestionGroup,
            suggestions: []
        });
        existingRecordIndex = suggestionsLength - 1;
    }
    output[existingRecordIndex].suggestions.push(suggestion);
    return output;
}
const $87f440f2126ef949$export$7463f42be087e7d6 = ({ suggestionsHeading: suggestionsHeading, suggestions: suggestions, value: value, setSuggestion: setSuggestion, hideGroupHeading: hideGroupHeading })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); /**
                  * While scrolling with the mouse, the setSuggestion() function can still be
                  * called by the mousemove event in ListItem.
                  *
                  * So while the scrolling is happening, another scrollTo() is started and
                  * conflicts with the current scrolling momentum, causing the experience to
                  * jitter and feel clunky.
                  *
                  * While scrolling with just the mouse, this is the order of events:
                  * - (multiple) scroll
                  * - mousemove
                  * - (multiple) scroll
                  * - mousemove
                  * - scrollend
                  *
                  * However, if the user leaves the cursor over the list while navigating with
                  * the keyboard and it scrolls to ensure items are visible, the order of
                  * events is:
                  * - (multiple) on scroll
                  * - scrollend
                  * - mousemove
                  *
                  * So to avoid the mousemove from triggering a change, we set a flag to
                  * ignore mousemove events until a bit after its over.
                  */ 
    const ignoreMouseMoveRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const smoothSetSuggestion = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((suggestion, eventName)=>{
        if (!setSuggestion) return;
         // Ignore mousemove
        if (eventName === 'mousemove' && ignoreMouseMoveRef.current) return;
        setSuggestion(suggestion);
    }, [
        setSuggestion
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!scrollerRef.current) return;
         // Debounced handler to restore tracking after scrolling
        const allowMouseTracking = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            ignoreMouseMoveRef.current = false;
        }, 75);
        const onScrollEvent = ()=>{
            ignoreMouseMoveRef.current = true;
            allowMouseTracking();
        };
        const scroller = scrollerRef.current;
        scroller.addEventListener('scroll', onScrollEvent);
        scroller.addEventListener('scrollend', onScrollEvent);
        return ()=>{
            scroller.removeEventListener('scroll', onScrollEvent);
            scroller.removeEventListener('scrollend', onScrollEvent);
        };
    }, [
        scrollerRef
    ]);
    const renderedGroupSuggestions = (0, $42omo.useMemo)(()=>{
        const customLabelMap = {
            'tell-ai': formatMessage((0, $40f6ad55199251f8$export$defe85febe8b728c).tellAILabel),
            'tell-agent': formatMessage((0, $40f6ad55199251f8$export$defe85febe8b728c).tellAgentLabel)
        };
        const mapSuggestionsCallback = (suggestionGroup)=>{
            const groupHeadingId = `list-heading-${(0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(suggestionGroup.groupHeading)}`;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    suggestionGroup.groupHeading && !hideGroupHeading && /*#__PURE__*/ (0, $l998X.jsx)((0, $d27613aa5204a6b7$export$b7bc1538a6ef0630), {
                        id: groupHeadingId,
                        heading: suggestionGroup.groupHeading
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("ul", {
                        "aria-labelledby": groupHeadingId,
                        "data-testid": `suggestion-group-${(0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(suggestionGroup.groupHeading || 'Atlassian intelligence')}`,
                        className: (0, $gMc0m.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                        ]),
                        children: suggestionGroup.suggestions.map((suggestion)=>{
                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $d9761ba7984b9121$export$a7b06bfba60a8a78), {
                                suggestion: suggestion,
                                customLabel: customLabelMap[suggestion.value] || undefined,
                                highlighted: suggestion.value === value,
                                setSuggestion: smoothSetSuggestion,
                                hasGroupHeading: !!suggestionGroup.groupHeading && !hideGroupHeading
                            }, suggestion.value);
                        })
                    }, `group_${suggestionGroup.groupHeading}`)
                ]
            });
        };
        return (suggestions || [] // Group suggestions by heading to make mapping to components easier later on
        ).reduce($87f440f2126ef949$export$5b54ed2fa23d62e9, []).map(mapSuggestionsCallback);
    }, [
        formatMessage,
        smoothSetSuggestion,
        suggestions,
        value,
        hideGroupHeading
    ]);
    if (!renderedGroupSuggestions.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "suggestions-container",
        xcss: $87f440f2126ef949$var$suggestionsScrollerPostGAStyles.default,
        ref: scrollerRef,
        style: {
            borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
        },
        children: [
            suggestionsHeading && /*#__PURE__*/ (0, $l998X.jsx)("h2", {
                className: (0, $gMc0m.default)([
                    "_fqoxwadc _rcujze3t _o81cze3t _1l6uze3t _149mze3t _1dlt12x7 _w8squtpp _fjwr12x7 _1yxxutpp _1y2cwu06 _nmk4angw _1w90azsu"
                ]),
                children: suggestionsHeading
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                "data-testid": "editor-plugin-ai-suggestion-list",
                id: "suggestion-list",
                className: (0, $gMc0m.default)([
                    (0, $dh538.fg)('ai-smart-button-team-25') && "_qtt8glyw _kqswh2mm _1bsb1osq _4t3i1osq _19bvze3t _u5f3ze3t _ca0qze3t _n3tdutpp",
                    !(0, $dh538.fg)('ai-smart-button-team-25') && "_qtt8glyw _1bsb1osq _4t3i1osq _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1e0c1o8l _kqswh2mm",
                    !(0, $dh538.fg)('ai-smart-button-team-25') && "_1x7s1kw7 _136z1kw7 _19511kw7 _jb8p1kw7"
                ]),
                children: renderedGroupSuggestions
            })
        ]
    });
};



var $9LxGu = parcelRequire("9LxGu");

/* AnnouncementBanners.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




/* AnnouncementBannerItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










const $44bff6d6a83df6c6$var$announcementStyles = {
    default: "_2rko12b0 _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp _bfhk6vm6 _syazdv2p"
};
function $44bff6d6a83df6c6$export$73d84e9e372a2734({ text: text, onClose: onClose }) {
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $44bff6d6a83df6c6$var$announcementStyles.default,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.050",
        children: [
            text,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                label: 'Close',
                spacing: "compact",
                appearance: "subtle",
                onClick: onClose
            })
        ]
    });
}


const $c31e1dc4f3d04195$var$boxStyles = {
    default: "_ca0qu2gc _19bvu2gc _u5f3u2gc _n3tdu2gc _15a5nqa1 _uwhke4h9 _1i531l7x"
};
function $c31e1dc4f3d04195$export$ea375d4903c4f3dc({ banners: banners }) {
    if (banners.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $c31e1dc4f3d04195$var$boxStyles.default,
        direction: "column",
        gap: "space.100",
        children: banners.map((banner)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $44bff6d6a83df6c6$export$73d84e9e372a2734), {
                text: banner.text,
                onClose: banner.onClose
            }, banner.id))
    });
}


/**
 * This function will return the next suggestion to highlight based on the
 * direction requested.
 *
 * It determines the next suggestion based off the position of the current
 * suggestion in the suggestions list and the direction requested.
 *
 * If the current suggestion is the first item in the list and the requested
 * direction is up, it will wrap around and return the last item. Similarly,
 * requesting down from the last item will wrap return the first item.
 *
 * - If the current suggestion is not found in the suggestions list, it will
 * default to the first suggestion.
 * - If the suggestions list is empty, it will return an empty string.
 * - If the direction is not recognised, it will throw an error.
 *
 * @param suggestions An array of suggestion values to cycle through.
 * @param current Value of the current suggestion highlighted.
 * @param direction Are we moving up or down the list of suggestions?
 * @returns string The next suggestion value to highlight, depending on the direction requested.
 */ const $c308e608484fd78d$export$98f66d46dcfe73ca = (suggestions, current, direction)=>{
    const currentIndex = suggestions.indexOf(current);
    const { length: length } = suggestions;
    // Got nothing to do
    if (length === 0) return '';
    if (direction === 'ArrowUp') {
        /**
     * Visualisation of what the scenarios are covering
     * - Left = out of bounds negative indexes
     * - Right = out of bounds positive indexes
     * - 0-9 = example of valid suggestion indexes
     *       Array items
     * -----[0123456789]++++++
     * <----DCB------>A-->
             Scenarios
     */ // A: Out of bounds
        if (currentIndex > length - 1) return suggestions[0];
        else if (currentIndex > 0) return suggestions[currentIndex - 1];
        else if (currentIndex === 0) return suggestions[length - 1];
        else return suggestions[0];
    } else if (direction === 'ArrowDown') {
        /**
     * Visualisation of what the scenarios are covering
     * - Left = out of bounds negative indexes
     * - Right = out of bounds positive indexes
     * - 0-9 = example of valid suggestion indexes
     *       Array items
     * -----[0123456789]++++++
     * <----BC------->A-->
             Scenarios
     */ // A: Last item or out of bounds
        if (currentIndex >= length - 1) return suggestions[0];
        else if (currentIndex < 0) return suggestions[0];
        else if (currentIndex < length - 1) return suggestions[currentIndex + 1];
    } else throw new Error('Unknown direction');
    return '';
};





var $dbeb184075925821$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    footerText: {
        id: "fabric.editor.ai.screens.UserInputCommamdPalette.footerText",
        defaultMessage: "Atlassian Intelligence"
    },
    suggestionsUpdated: {
        id: "fabric.editor.ai.experience.suggestionsUpdated",
        defaultMessage: "{numberOfSuggestions} suggestions available for typed text"
    },
    rovoProductLabel: {
        id: "fabric.editor.ai.experience.rovoAgents.productLabel",
        defaultMessage: "Rovo"
    },
    rovoProductLogoAltText: {
        id: "fabric.editor.ai.experience.rovoAgents.productLogoAltText",
        defaultMessage: "Rovo Logo"
    },
    rovoAgentsPalettePlaceholder: {
        id: "fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder",
        defaultMessage: "Tell Agent to write anything or choose from the below"
    },
    commandPaletteAriaName: {
        id: "fabric.editor.ai.experience.commandPaletteAriaName",
        defaultMessage: "Atlassian Intelligence"
    },
    commandPaletteV2Placeholder: {
        id: "fabric.editor.ai.experience.commandPaletteV2Placeholder",
        defaultMessage: "Tell AI what to do ..."
    }
});


function $1f9f91191db36d7d$export$e68d35e32242c79b(output, suggestion) {
    const { nestingConfig: nestingConfig } = suggestion;
    if (nestingConfig) {
        const existingIndex = output.findIndex((s)=>s.nestingConfig?.parentTitle === nestingConfig.parentTitle);
        if (existingIndex === -1) {
            const parentNestingConfig = {
                ...nestingConfig
            };
            delete parentNestingConfig.shortTitle;
            output.push({
                ...suggestion,
                testId: nestingConfig.parentTestId,
                label: nestingConfig.parentTitle || '',
                nestingConfig: parentNestingConfig,
                childSuggestions: [
                    suggestion
                ],
                value: suggestion.nestingConfig?.parentTitle || ''
            });
        } else output[existingIndex].childSuggestions?.push(suggestion);
    } else output.push(suggestion);
    return output;
}


const $40b5db5f178d1147$var$columnLayout = null; /**
                            * Scroll margin is used to ensure that the modal won't be
                            * too close to the top of the editor, which may sometimes
                            * cover the modal slightly.
                            */ 
const $40b5db5f178d1147$var$scrollMarginStyles = null;
const $40b5db5f178d1147$var$caretHiddenStyle = null;
const $40b5db5f178d1147$var$PromptHeaderWrapperStyles = {
    default: "_ca0qutpp _u5f3utpp _19bvutpp _n3tdutpp _1tkeidpf _1o9zidpf"
};
const $40b5db5f178d1147$var$PromptHeaderWrapperTeam25Styles = {
    default: "_18zrpxbi _1rjcutpp _1tkeidpf _1o9zidpf"
};
const $40b5db5f178d1147$var$userInputFloatingContainerStyle = null;
const $40b5db5f178d1147$export$9491b5d7f967f421 = ({ appearance: appearance, inputValue: inputValue, inputADFValue: inputADFValue, onInputUpdate: onInputUpdate, onADFUpdate: onADFUpdate, presetPromptLabel: presetPromptLabel, onSubmit: onSubmit, onEscapeKeyPressed: onEscapeKeyPressed, onRefinementTagRemove: onRefinementTagRemove, onBack: onBack, placeholder: placeholder, getSuggestions: getSuggestions, suggestionsHeading: suggestionsHeading, focusInputRef: focusInputRef, PromptEditor: PromptEditor, agent: agent, hideLegacySubmitCancelButtons: hideLegacySubmitCancelButtons, announcementBanners: announcementBanners, pageKnowledgeProps: pageKnowledgeProps, isAIFC: isAIFC })=>{
    const promptWithSuggestionsRef = (0, $42omo.useRef)(null);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); // There is a situation when using the arrow keys to navigate through the suggestions
    // where Prosemirror will move the caret to the end of the prompt input's placeholder
    // as the placeholder is done via a content-editable bit of text. This solution allows
    // the caret to not jump around while pressing 'down' while not having to edit the core
    // functionality of Prosemirror.
    const [isCaretHidden, setIsCaretHidden] = (0, $42omo.useState)(false);
    const [isShowingMoreSuggestions, setIsShowingMoreSuggestions] = (0, $42omo.useState)(false); /**
                                                                                    * Scroll prompt into view as suggestions are not always fully visible
                                                                                    * when PromptInput is autofocused.
                                                                                    *
                                                                                    * Note: We use useLayoutEffect here vs useEffect as it is synchronous and operates
                                                                                    * after the DOM has been updated with all mutations etc. This is important as
                                                                                    * Safari has a bug where it can not correctly calculate scroll positions and glitches
                                                                                    * out causing all content to disappear without it.
                                                                                    *
                                                                                    * Performance implications should be minimal as we are not affecting the rendering
                                                                                    * of content, but rather using it for calculations and triggering scroll events.
                                                                                    *
                                                                                    * https://kentcdodds.com/blog/useeffect-vs-uselayouteffect
                                                                                    *
                                                                                    * ᕕ( ᐛ )ᕗ
                                                                                    */ 
    (0, $42omo.useLayoutEffect)(()=>{
        // Add event listener to handle escape key press
        const { current: element } = promptWithSuggestionsRef; // If the element is not mounted, do nothing
        if (!element) return;
        if (!(0, $dh538.fg)('platform_editor_ai_scroll_into_view_fix')) element.scrollIntoView({
            block: 'nearest',
            behavior: 'auto'
        });
         /**
       * KeyDown (as opposed to KeyPress) event is used to handle the escape key so that
       * other escape key handlers will not override this behaviour.
       * Additionally this aligns with other escape listeners e.g. for closing typeahead popup.
       */ 
        const handleEscapeKeyDown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                onEscapeKeyPressed();
            }
        }; /**
        * Handle KeyUp event to prevent unexpected escape behaviours when
        * there are other escape handlers outside of component (e.g. in product)
        */ 
        const handleEscapeKeyUp = (event)=>{
            if (event.key !== 'Escape') return;
            event.preventDefault();
            event.stopPropagation();
        };
        return (0, $fFa3V.bindAll)(element, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            }
        ]);
    }, [
        promptWithSuggestionsRef,
        onEscapeKeyPressed
    ]);
    const getNestedSuggestions = (0, $42omo.useCallback)((input, presetLabel)=>{
        let nestedSuggestions = getSuggestions(input) ?? [];
        nestedSuggestions = nestedSuggestions.reduce((0, $1f9f91191db36d7d$export$e68d35e32242c79b), []);
        if (presetLabel) nestedSuggestions = nestedSuggestions.find((s)=>s.nestingConfig?.parentTitle === presetLabel)?.childSuggestions ?? [];
        const showMoreSuggestionIndex = nestedSuggestions.findIndex((suggestion)=>suggestion.value === 'show-more');
        if (showMoreSuggestionIndex !== -1) {
            const originalOnSelect = nestedSuggestions[showMoreSuggestionIndex].onSelect;
            nestedSuggestions[showMoreSuggestionIndex].onSelect = ()=>{
                originalOnSelect();
                setIsShowingMoreSuggestions(true);
            };
        }
        return nestedSuggestions;
    }, [
        getSuggestions
    ]);
    const suggestions = (0, $42omo.useMemo)(()=>{
        if (agent) return getSuggestions(inputValue, agent);
        if (!inputValue.length) return getNestedSuggestions(inputValue, presetPromptLabel);
        return getSuggestions(inputValue) ?? [];
    }, [
        agent,
        getSuggestions,
        getNestedSuggestions,
        inputValue,
        presetPromptLabel
    ]);
    const allSuggestions = (0, $42omo.useMemo)(()=>{
        if (isAIFC) return getNestedSuggestions('', presetPromptLabel);
        return [];
    }, [
        getNestedSuggestions,
        presetPromptLabel,
        isAIFC
    ]);
    const hideNestedTag = (0, $42omo.useMemo)(()=>{
        return presetPromptLabel && !!suggestions.length;
    }, [
        suggestions,
        presetPromptLabel
    ]);
    const agentRefinementTagProps = (0, $9LxGu.useAgentRefinementTagProps)(agent);
    const refinementTagRef = (0, $42omo.useRef)(null);
    const tag = (0, $42omo.useMemo)(()=>{
        return presetPromptLabel === undefined ? undefined : /*#__PURE__*/ (0, $l998X.jsx)((0, $bwdMU.RefinementTag // Ignored via go/ees005
        ), {
            ...agentRefinementTagProps,
            label: presetPromptLabel,
            ref: refinementTagRef,
            onClick: onRefinementTagRemove
        });
    }, [
        agentRefinementTagProps,
        presetPromptLabel,
        onRefinementTagRemove,
        refinementTagRef
    ]);
    const suggestionValues = (0, $42omo.useMemo)(()=>{
        return (suggestions || []).map((suggestion)=>suggestion.value);
    }, [
        suggestions
    ]);
    const [currentSuggestion, _setCurrentSuggestion] = (0, $42omo.useState)(suggestionValues.length > 0 ? suggestionValues[0] : ''); /**
                                                                                                                                * Handles the behaviour for when a user changes the suggestion.
                                                                                                                                *
                                                                                                                                * At the moment this is used to highlight the entire editor document for
                                                                                                                                * relevant suggestions.
                                                                                                                                */ 
    const handleSuggestionChanged = (0, $42omo.useCallback)((suggestion)=>{
        const suggestionObject = suggestions.find((s)=>s.value === suggestion);
        suggestionObject?.onSuggestionFocused();
    }, [
        suggestions
    ]);
    const setCurrentSuggestion = (0, $42omo.useCallback)((newValue)=>{
        handleSuggestionChanged(newValue);
        _setCurrentSuggestion(newValue);
    }, [
        _setCurrentSuggestion,
        handleSuggestionChanged
    ]); // Select first option by default
    (0, $42omo.useEffect)(()=>{
        if (suggestionValues.includes(currentSuggestion) || suggestionValues.length === 0) return;
        setCurrentSuggestion(suggestionValues[0]);
    }, [
        currentSuggestion,
        suggestionValues,
        setCurrentSuggestion
    ]); // Calculate visible suggestions list
    const visibleSuggestionValues = (0, $42omo.useMemo)(()=>{
        const allSuggestions = suggestionValues.filter((suggestion)=>suggestion !== 'show-more');
        if (isShowingMoreSuggestions || inputValue.length > 0) return allSuggestions;
        const agentSuggestions = suggestionValues.filter((suggestion)=>suggestion.startsWith('agent:'));
        const minNumOfGeneralSuggestions = 4;
        const maximumResultCount = 9;
        if (agentSuggestions.length === 0 || allSuggestions.length <= maximumResultCount || // If we only have the min. number of suggestions,
        // we return the full list because we don't need to show the show more button
        allSuggestions.length - agentSuggestions.length <= minNumOfGeneralSuggestions) return allSuggestions;
         // The maximum number of suggestions is 8 when agents are present
        // We take the extra 1 so that we can put the show more button in place
        // of the last expected suggestion.
        let remainingSuggestions = maximumResultCount - agentSuggestions.length - 1; // If the user favourites enough agents, the resulting count will be negative and
        // force the entire list to show. We want to encourage it to limit the slicing to 1
        // item in this case.
        if (remainingSuggestions < minNumOfGeneralSuggestions) remainingSuggestions = minNumOfGeneralSuggestions;
        return [
            ...suggestionValues.slice(0, remainingSuggestions),
            'show-more',
            ...agentSuggestions
        ];
    }, [
        inputValue.length,
        isShowingMoreSuggestions,
        suggestionValues
    ]);
    const visibleSuggestions = (0, $42omo.useMemo)(()=>{
        const output = suggestions.filter((suggestion)=>visibleSuggestionValues.includes(suggestion.value));
        return output;
    }, [
        suggestions,
        visibleSuggestionValues
    ]);
    const onArrowKeyDown = (0, $42omo.useCallback)((event)=>{
        // Ignore if any key modifiers are held
        if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
         // If theres one or fewer suggestions, no need to navigate and allow normal
        // multiline text traversal
        if (visibleSuggestionValues.length <= 1) return;
        switch(event.key){
            case 'ArrowUp':
            case 'ArrowDown':
                {
                    setIsCaretHidden(true);
                    const nextSuggestion = (0, $c308e608484fd78d$export$98f66d46dcfe73ca)(visibleSuggestionValues, currentSuggestion, event.key);
                    setCurrentSuggestion(nextSuggestion);
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                }
            default:
                return;
        }
    }, [
        currentSuggestion,
        setCurrentSuggestion,
        visibleSuggestionValues
    ]);
    const debouncedSetIsCaretHidden = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setIsCaretHidden(false);
        }, 300), []);
    const onArrowKeyUp = (0, $42omo.useCallback)(()=>{
        debouncedSetIsCaretHidden();
    }, [
        debouncedSetIsCaretHidden
    ]);
    const setSuggestion = (0, $42omo.useCallback)((suggestion)=>{
        setCurrentSuggestion(suggestion.value);
    }, [
        setCurrentSuggestion
    ]);
    const onFormSubmit = (0, $42omo.useCallback)(()=>{
        if (currentSuggestion === '' || suggestions?.length === 0) {
            onSubmit();
            return;
        }
        const suggestion = (suggestions || []).find((suggestion)=>suggestion.value === currentSuggestion);
        if (suggestion) suggestion.onSelect();
        setCurrentSuggestion('');
    }, [
        currentSuggestion,
        suggestions,
        setCurrentSuggestion,
        onSubmit
    ]); // if a refinement tag like brainstorm was selected, we continue showing these legacy buttons
    const showLegacySubmitCancelButtons = !hideLegacySubmitCancelButtons && Boolean(presetPromptLabel && !agent);
    const promptPlaceholder = (0, $42omo.useMemo)(()=>{
        const defaultPlaceholder = placeholder;
        if (agent) return formatMessage((0, $dbeb184075925821$export$2e2bcd8739ae039).rovoAgentsPalettePlaceholder);
        if (tag) return defaultPlaceholder;
        return defaultPlaceholder;
    }, [
        agent,
        formatMessage,
        placeholder,
        tag
    ]);
    const promptForm = /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        testId: "prompt-header-wrapper",
        xcss: (0, $dh538.fg)('ai-smart-button-team-25') ? $40b5db5f178d1147$var$PromptHeaderWrapperTeam25Styles.default : $40b5db5f178d1147$var$PromptHeaderWrapperStyles.default,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $964c4428d6c8e6f2$export$416523684d97c4ad), {
            type: "user-input",
            showButtons: showLegacySubmitCancelButtons,
            placeholder: isAIFC ? formatMessage((0, $dbeb184075925821$export$2e2bcd8739ae039).commandPaletteV2Placeholder) : promptPlaceholder,
            value: inputValue,
            adfValue: inputADFValue,
            onFormSubmit: onFormSubmit,
            onInputChange: onInputUpdate,
            onADFChange: onADFUpdate,
            tag: hideNestedTag ? undefined : tag,
            focusInputRef: focusInputRef,
            showLogo: false,
            onInputKeyDown: onArrowKeyDown,
            onInputKeyUp: onArrowKeyUp,
            PromptEditor: PromptEditor,
            enableLinks: true,
            showBack: !!presetPromptLabel,
            onBack: onBack,
            refinementTagRef: refinementTagRef,
            isAIFC: isAIFC
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ref: promptWithSuggestionsRef,
        "data-testid": "user-input-command-palette-screen",
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _2lx21bp4 _4cvr1y6m",
            "_j4orxy5q",
            isCaretHidden && "_1n5d1j28",
            `user-input-command-palette-screen ${(0, $kuYGt.AI_MODAL_SCREEN_CLASS)}`
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "large",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: formatMessage((0, $dbeb184075925821$export$2e2bcd8739ae039).commandPaletteAriaName)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $40sdH.FloatingContainer), {
                disablePadding: true,
                "data-testid": "prompt-form-screen",
                rainbowBorder: false,
                enableMaxHeight: true,
                isAIFC: isAIFC,
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _2lx21bp4 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
                ]),
                children: [
                    promptForm,
                    isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df023c99eb7b3c63$export$1c1a126042a474aa), {
                        onFormSubmit: onFormSubmit,
                        inputValue: inputValue,
                        suggestions: allSuggestions,
                        setSuggestion: setSuggestion,
                        showButton: !!!presetPromptLabel
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                        children: [
                            announcementBanners && /*#__PURE__*/ (0, $l998X.jsx)((0, $c31e1dc4f3d04195$export$ea375d4903c4f3dc), {
                                banners: announcementBanners
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5KVL8.AssistiveText), {
                                assistiveText: formatMessage((0, $dbeb184075925821$export$2e2bcd8739ae039).suggestionsUpdated, {
                                    numberOfSuggestions: visibleSuggestions.length
                                }),
                                isInFocus: visibleSuggestions.length > 0,
                                id: "suggestions-updated",
                                "data-testid": "suggestions-updated"
                            }),
                            suggestions || inputValue ? /*#__PURE__*/ (0, $l998X.jsx)((0, $87f440f2126ef949$export$7463f42be087e7d6), {
                                appearance: appearance,
                                suggestions: visibleSuggestions,
                                suggestionsHeading: suggestionsHeading,
                                value: currentSuggestion,
                                setSuggestion: setSuggestion,
                                hideGroupHeading: !!agent
                            }) : null,
                            pageKnowledgeProps?.isVisible && /*#__PURE__*/ (0, $l998X.jsx)((0, $d6b6d26ba87ef6e1$export$c486b1aa62224a41), {
                                onChange: pageKnowledgeProps.onToggle,
                                isChecked: pageKnowledgeProps.isEnabled
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

























var $CV9x9 = parcelRequire("CV9x9");


















var $kpYGL = parcelRequire("kpYGL");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $1026a5c2b28c89c6$var$styles = {
    wrapper: "_195g1b66 _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $1026a5c2b28c89c6$var$CustomGlyph = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "23",
        height: "26",
        viewBox: "0 0 23 26",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.512 1.06137C11.1247 0.713259 11.8753 0.713259 12.488 1.06137L21.488 6.17501C22.1136 6.53043 22.5 7.19446 22.5 7.91392V18.0861C22.5 18.8055 22.1136 19.4696 21.488 19.825L12.488 24.9386C11.8753 25.2867 11.1247 25.2867 10.512 24.9386L1.51198 19.825C0.886437 19.4696 0.5 18.8055 0.5 18.0861V7.91392C0.5 7.19446 0.886437 6.53043 1.51198 6.17501L10.512 1.06137Z",
                fill: props.primaryColor || '#0C66E4'
            }),
            !props.primaryColor && !props.excludeOverlay && /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.3711 9.12845C15.7263 9.30173 16.1726 9.00581 16.3843 9.37104C16.1136 9.2564 16.1496 10.7306 16.5959 10.3814C16.6497 10.1521 16.7793 10.1801 16.551 10.1015C16.9344 10.0988 16.5779 9.84556 16.5907 9.80957C16.7998 9.80424 16.5266 9.68161 16.7254 9.72427C16.8408 9.70027 16.5035 9.39637 16.7318 9.47768C16.8049 9.14711 17.1615 9.14976 17.0819 8.94849C17.0858 9.08578 18.2708 9.11778 17.9425 8.59261C17.7347 8.60328 17.7617 8.36068 17.7309 8.67659C17.668 8.28471 17.5283 8.67658 17.4949 8.66725C17.4641 8.44731 17.4026 8.75122 17.4115 8.53662C17.3808 8.42066 17.1807 8.79121 17.2204 8.54861C16.5292 8.36067 17.096 8.15807 16.6972 7.75019C16.6574 7.56092 16.7549 6.94644 16.3278 7.00376C15.7661 7.17171 16.4214 8.22072 16.088 8.40333C15.9392 8.54195 15.7276 8.71656 15.4467 8.59793C15.3082 8.59527 15.13 9.1831 15.3698 9.12979L15.3711 9.12845Z",
                        fill: "#579DFF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M15.3218 15.6931L14.5291 14.9004C12.9326 16.1142 11.4765 17.4318 10.1783 18.8662C8.3402 17.3566 6.68445 15.6005 5.18662 13.6303L11.4518 7.36515C12.9665 10.1168 15.0426 12.0855 17.5196 13.4953L15.3218 15.6931ZM10.7452 13.7518L10.7452 15.6016L10.7454 15.6016L11.6857 15.6016L11.6857 13.7518L13.4285 13.7518L11.2154 11.5387L9.00236 13.7518L10.7452 13.7518ZM14.5291 14.9007L15.3217 15.6934L11.2855 19.7296C10.9092 19.4518 10.5403 19.1639 10.1783 18.8665C11.4764 17.4323 12.9325 16.1146 14.5291 14.9007Z",
                        fill: "#CCE0FF"
                    })
                ]
            })
        ]
    });
};
const $1026a5c2b28c89c6$var$CustomIcon = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($1026a5c2b28c89c6$var$CustomGlyph, {
        ...props
    });
};
const $1026a5c2b28c89c6$export$e331edd80bbc26a2 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $1026a5c2b28c89c6$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)($1026a5c2b28c89c6$var$CustomIcon, {
            ...props
        })
    });
};


const $04e76442e2875fc8$export$f317c01730aa6ce0 = (agent, length = 3)=>{
    return new Array(length).fill(null).map((_, index)=>{
        return {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            value: `agent:${agent.id}:${(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()}:dummy`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
                width: `${index % 2 !== 0 ? 205 : 180}px`,
                height: "18px",
                borderRadius: 2,
                isShimmering: true
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1026a5c2b28c89c6$export$e331edd80bbc26a2), {
                label: '',
                excludeOverlay: true,
                size: "large",
                width: 32,
                height: 32,
                primaryColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
            }),
            groupHeading: '',
            onSelect: ()=>{},
            onSuggestionFocused: ()=>{}
        };
    });
};



const $7f4d5fb15fd0cb78$var$experienceName = 'Rovo agent conversation starters';
const $7f4d5fb15fd0cb78$var$suggestionCount = 3;
function $7f4d5fb15fd0cb78$export$552fd0249f716349({ handleHighlight: handleHighlight, configItem: configItem, onConversationStarterSelected: onConversationStarterSelected, product: product, editorPluginAIProvider: editorPluginAIProvider }) {
    let agent;
    /**
   * When agent is silently used behind scenes for prompt then don't show agent starter.
   * That's why don't assign agent from configItem to agent variable.
   */ if (!configItem.silentAgentPrompt) agent = configItem.agent;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const siteId = (0, $42omo.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    const [lastAiInteractionID, setLastAiInteractionID] = (0, $42omo.useState)('');
    const getAiLifeCycleDynamicAttributes = analyticsFlow.getAiLifeCycleDynamicAttributes;
    const userDefinedAgentStarters = (0, $42omo.useMemo)(()=>{
        if (!agent) return [];
        return agent.conversationStarters.filter((conversationStarter)=>{
            return conversationStarter.type === 'user-defined';
        });
    }, [
        agent
    ]);
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const onInit = (0, $42omo.useCallback)(()=>{
        setHasError(false);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const aiId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        setLastAiInteractionID(aiId);
        fireAIAnalyticsEvent({
            payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                action: (0, $d925B.ACTION).INITIATED,
                interactionID: aiId,
                experienceName: $7f4d5fb15fd0cb78$var$experienceName,
                isProactive: false,
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                attributes: getAiLifeCycleDynamicAttributes?.({
                    init: true
                })
            })
        });
    }, [
        aiExperienceCommonData.lastTriggeredFrom,
        fireAIAnalyticsEvent,
        getAiLifeCycleDynamicAttributes
    ]);
    const onError = (0, $42omo.useCallback)((error)=>{
        setHasError(true);
        fireAIAnalyticsEvent({
            payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                action: (0, $d925B.ACTION).ERROR,
                interactionID: lastAiInteractionID,
                experienceName: $7f4d5fb15fd0cb78$var$experienceName,
                isProactive: false,
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                attributes: {
                    aiErrorMessage: error.message,
                    aiErrorCode: 500,
                    ...getAiLifeCycleDynamicAttributes?.({
                        init: false
                    })
                }
            })
        });
    }, [
        aiExperienceCommonData.lastTriggeredFrom,
        fireAIAnalyticsEvent,
        lastAiInteractionID,
        getAiLifeCycleDynamicAttributes
    ]);
    const { getDynamicContextualStarters: getDynamicContextualStarters, starters: contextualStarters, isMutating: isMutating } = (0, $CV9x9.useContextualConversationStarters)({
        onInit: onInit,
        onError: onError,
        assistanceServiceParams: {
            touchpointSource: 'editor-ai-conversation-starters',
            product: (0, $8klLr.mapToAssistanceServiceProduct)(product),
            experienceId: 'ai-mate',
            siteId: siteId
        }
    });
    const isPending = (0, $42omo.useMemo)(()=>{
        return isMutating || contextualStarters.some((cs)=>!cs) && userDefinedAgentStarters.length < $7f4d5fb15fd0cb78$var$suggestionCount;
    }, [
        isMutating,
        contextualStarters,
        userDefinedAgentStarters
    ]);
    (0, $42omo.useEffect)(()=>{
        if (agent && userDefinedAgentStarters.length < $7f4d5fb15fd0cb78$var$suggestionCount) getDynamicContextualStarters({
            locationUrl: window.location.href,
            fallbackStarters: agent.conversationStarters.map((conversationStarter)=>{
                if (typeof conversationStarter.message !== 'string') conversationStarter.message = formatMessage(conversationStarter.message);
                return conversationStarter;
            })
        });
    }, [
        agent,
        getDynamicContextualStarters,
        formatMessage,
        userDefinedAgentStarters
    ]);
    const starters = (0, $42omo.useMemo)(()=>{
        if (!agent) return [];
        let conversationStarters = userDefinedAgentStarters;
        if (isPending) return (0, $04e76442e2875fc8$export$f317c01730aa6ce0)(agent, $7f4d5fb15fd0cb78$var$suggestionCount);
        if (conversationStarters.length < $7f4d5fb15fd0cb78$var$suggestionCount) {
            // The linter was being very agressive about this typing for some reason
            // so I had to comfort it and make sure it was aware this variable definitely did
            // not contain nulls.
            // See: How to win friends and influence people by Dale Carnegie
            const nonNullContextualStarters = contextualStarters.filter((conversationStarter)=>conversationStarter !== null);
            const availableContextualStarters = nonNullContextualStarters.slice(0, $7f4d5fb15fd0cb78$var$suggestionCount - conversationStarters.length);
            conversationStarters = [
                ...conversationStarters,
                ...availableContextualStarters
            ];
        }
        return conversationStarters.map(({ message: conversationStarter }, index)=>{
            const translatedMessage = typeof conversationStarter === 'string' ? conversationStarter : formatMessage(conversationStarter);
            return {
                value: `agent:${agent.id}:${index}:${translatedMessage}`,
                label: translatedMessage,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hezkK.AgentAvatar), {
                    agentId: agent.id,
                    agentNamedId: agent.externalConfigReference ?? agent.namedId,
                    agentIdentityAccountId: agent.identityAccountId,
                    isForgeAgent: agent.creatorType === 'FORGE',
                    forgeAgentIconUrl: agent.icon
                }),
                groupHeading: '',
                onSelect: ()=>{
                    onConversationStarterSelected(translatedMessage);
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: configItem
                    });
                },
                ...(0, $dh538.fg)('ai-smart-button-team-25') && {
                    isAgent: true
                }
            };
        });
    }, [
        agent,
        isPending,
        userDefinedAgentStarters,
        contextualStarters,
        formatMessage,
        onConversationStarterSelected,
        handleHighlight,
        configItem
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isPending && !hasError && starters.length) fireAIAnalyticsEvent({
            payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                action: (0, $d925B.ACTION).VIEWED,
                interactionID: lastAiInteractionID,
                experienceName: $7f4d5fb15fd0cb78$var$experienceName,
                isProactive: false,
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                attributes: getAiLifeCycleDynamicAttributes?.({
                    init: true
                })
            })
        });
    }, [
        aiExperienceCommonData.lastTriggeredFrom,
        isPending,
        hasError,
        starters,
        fireAIAnalyticsEvent,
        lastAiInteractionID,
        getAiLifeCycleDynamicAttributes
    ]);
    return {
        starters: starters
    };
}








function $f6034c68dc4782a4$export$f8e8298e44ec1284() {
    const { engagementPlatformApi: engagementPlatformApi } = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    if (!engagementPlatformApi) return {
        startMessage: ()=>{
            return Promise.resolve(false);
        },
        stopMessage: ()=>{
            return Promise.resolve(false);
        }
    };
    return engagementPlatformApi;
}


function $27eabb301b03160d$export$a1cbeeef2ea2e5f5(messageId, text) {
    const { stopMessage: stopMessage, startMessage: startMessage } = (0, $f6034c68dc4782a4$export$f8e8298e44ec1284)();
    const [isStarted, setIsStarted] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        startMessage(messageId).then((isStarted)=>{
            setIsStarted(isStarted);
        });
    }, [
        messageId,
        startMessage
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        // We should hide message immediately without waiting for EngagementPlatform response
        setIsStarted(false);
        stopMessage(messageId);
    }, [
        messageId,
        stopMessage
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (isStarted) return {
            id: messageId,
            text: text,
            onClose: handleClose
        };
        return undefined;
    }, [
        messageId,
        text,
        handleClose,
        isStarted
    ]);
}












const $89e40b7594cde5dd$export$4b8c026161f470e2 = ({ hasInput: hasInput, suggestions: suggestions, agentVisible: agentVisible, nestedMenuSelected: nestedMenuSelected })=>{
    const { sendToAIExperienceMachine: sendToAIExperienceMachine, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage } = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const pageKnowledgeIsVisible = (0, $42omo.useMemo)(()=>{
        /**
		 * Simplify the logic to not rely on the group heading copy and rely on constant values.
		 */ if ((0, $dh538.fg)('ai-smart-button-team-25')) {
            const isGeneralAISuggestionRemaining = [
                (0, $e1bfb729a95c0d28$export$aed4aa2c04f0ff0a),
                (0, $e1bfb729a95c0d28$export$ea35400996401183),
                (0, $e1bfb729a95c0d28$export$e9b50d8f92ed61d4),
                (0, $e1bfb729a95c0d28$export$f94ca114676d6a3f)
            ].includes(suggestions[0]?.value);
            return !!(agentVisible || isGeneralAISuggestionRemaining && !nestedMenuSelected);
        }
        const hasGeneralAiSuggestions = suggestions[0]?.groupHeading === (0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).atlassianIntelligenceGroupHeading.defaultMessage;
        return !!(agentVisible || hasInput && !hasGeneralAiSuggestions && !nestedMenuSelected);
    }, [
        agentVisible,
        nestedMenuSelected,
        hasInput,
        suggestions
    ]);
    const pageKnowledgeProps = (0, $42omo.useMemo)(()=>{
        return {
            isEnabled: !!includeKnowledgeFromCurrentPage,
            isVisible: pageKnowledgeIsVisible,
            onToggle: ()=>sendToAIExperienceMachine({
                    type: 'toggle use page knowledge'
                })
        };
    }, [
        includeKnowledgeFromCurrentPage,
        pageKnowledgeIsVisible,
        sendToAIExperienceMachine
    ]);
    return pageKnowledgeProps;
};






var $1pSma = parcelRequire("1pSma");

const $b40dc98ab0862b48$var$prefix = 'editor-ai.submit-prompt';
const $b40dc98ab0862b48$var$useUfoPromptTracing = ()=>{
    const ufoAtlassianIntelligenceTracing = (0, $1pSma.default)(`${$b40dc98ab0862b48$var$prefix}.atlassian-intelligence`);
    const ufoRovoTracing = (0, $1pSma.default)(`${$b40dc98ab0862b48$var$prefix}.rovo`);
    return (0, $42omo.useCallback)((agent)=>{
        const tracing = agent === 'rovo' ? ufoRovoTracing : ufoAtlassianIntelligenceTracing;
        tracing();
    }, [
        ufoAtlassianIntelligenceTracing,
        ufoRovoTracing
    ]);
};
var $b40dc98ab0862b48$export$2e2bcd8739ae039 = $b40dc98ab0862b48$var$useUfoPromptTracing;



var $jAwX6 = parcelRequire("jAwX6");



var $ljZgt = parcelRequire("ljZgt");





function $edc45ae60c0157d0$export$751495e555be6bbc({ context: experienceAppContext, initialPrompt: initialPrompt }) {
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { appearance: appearance, editorPluginAIProvider: editorPluginAIProvider, endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, modalRef: modalRef } = aiExperienceCommonData;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { configItem: startingConfig, baseGenerate: baseGenerate, userInput: startingUserInput, userADFInput: startingUserADFInput, parentPresetPromptLabel: parentPresetPromptLabel, editCount: editCount, positions: positions, editorView: editorView, isEmpty: isEmpty, latestPromptResponse: latestPromptResponse, aiProvider: aiProvider } = experienceAppContext;
    const [initialPromptTriggered, setInitialPromptTriggered] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const ufoSubmitTracing = (0, $b40dc98ab0862b48$export$2e2bcd8739ae039)();
    // if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
    // we want to use startingConfig and parentPresetPromptLabel to restore the selected parent
    const { context: commandPaletteContext, send: sendToCommandPalette } = (0, $93df371653f429c9$export$6d6b44d5fef51d81)({
        baseGenerate: baseGenerate,
        startingConfig: startingConfig,
        startingPresetPromptLabel: parentPresetPromptLabel || (0, $c2200b5407d4af9f$export$4539b8c6808af330)(startingConfig, formatMessage),
        startingUserInput: startingUserInput,
        startingUserADFInput: startingUserADFInput
    });
    const { textInput: textInput, adfInput: adfInput, configItem: configItem, presetPromptLabel: presetPromptLabel } = commandPaletteContext;
    // if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
    const isParentWithNestedSubmenusSelected = Boolean(presetPromptLabel && configItem.nestingConfig);
    const rovoAgentsPluginState = (0, $f655ac6196582f3d$export$ce428e3c22a00062)({
        editorState: editorView.state
    });
    const { isBrowseModalOpen: isBrowseModalOpen = false } = rovoAgentsPluginState ?? {};
    (0, $e236b1c8cd73e2cd$export$aa79b0abe3dfeaba)({
        disabled: isBrowseModalOpen,
        modalRef: modalRef,
        onCancel: ()=>aiExperienceCommonData.endExperience(),
        onDiscard: ()=>{
            sendToAIExperienceMachine({
                type: 'update context',
                context: {
                    configItem: configItem,
                    userInput: textInput || '',
                    userADFInput: adfInput
                }
            });
            sendToAIExperienceMachine({
                type: 'enable discard'
            });
        }
    });
    const focusInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(undefined);
    const handleCancel = ()=>{
        endExperience();
    };
    const kickoffAiExperience = (0, $42omo.useCallback)(({ configItem: configItem, userInput: userInput, userADFInput: userADFInput })=>{
        // if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
        // we need the parentPresetPromptLabel to restore the selected parent later when we edit prompt in `Preview` screen (onEditPromptClick)
        const parentPresetPromptLabel = isParentWithNestedSubmenusSelected ? presetPromptLabel : '';
        sendToAIExperienceMachine({
            type: 'kickoff with command palette input',
            context: {
                parentPresetPromptLabel: parentPresetPromptLabel,
                configItem: configItem,
                userInput: userInput,
                userADFInput: userADFInput
            }
        });
    }, [
        isParentWithNestedSubmenusSelected,
        presetPromptLabel,
        sendToAIExperienceMachine
    ]);
    const onPartialPresetSelected = (0, $42omo.useCallback)((configItem, { presetPromptLabel: presetPromptLabel } = {})=>{
        // If partial prompt is selected we want to update the command palette
        // And focus the text input
        sendToCommandPalette({
            type: 'onPartialPresetSelected',
            configItem: configItem,
            presetPromptLabel: presetPromptLabel ?? (0, $c2200b5407d4af9f$export$4539b8c6808af330)(configItem, formatMessage)
        });
        focusInputRef.current?.();
    }, [
        sendToCommandPalette,
        formatMessage
    ]);
    const getPromptTitle = (0, $42omo.useCallback)((configItem)=>{
        if (configItem.agent?.creatorType === 'CUSTOMER') return undefined;
        if (configItem.agent?.creatorType === 'SYSTEM') return configItem.agent?.name;
        return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
    }, [
        formatMessage
    ]);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$f06fb39743945e19)({
        stepName: 'prompt',
        attributes: {
            experienceName: configItem.key,
            featureId: configItem.featureId,
            promptTitle: getPromptTitle(configItem),
            promptType: 'generate',
            usingCommandPalette: true,
            retryPromptCount: experienceAppContext.retryPromptCount,
            editCount: editCount
        }
    });
    const isRovoEnabled = (0, $9c7f02ab52bdba8d$export$83f18c95a94d1b1e)({
        editorPluginAIProvider: editorPluginAIProvider
    });
    const updateAnalytics = (0, $42omo.useCallback)((configItem)=>{
        /**
     * Update the backendModel common attribute whenever the configItem changes
     */ analyticsFlow.updateCommonAttributes({
            backendModel: configItem?.getBackendModel?.(!!latestPromptResponse),
            ...analyticsFlow.getUserFlowCommonAttributes(configItem)
        });
        const attributes = {
            experienceName: configItem.key,
            featureId: configItem.featureId,
            promptTitle: getPromptTitle(configItem)
        };
        if ((0, $dh538.fg)('platform_editor_ai_prompt_input_statistics')) {
            let inputNodeCount = {};
            let characterCount = 0;
            if (adfInput) {
                inputNodeCount = (0, $1A9t2.reduce)(adfInput, (accum, node)=>{
                    if (node.type === 'text') characterCount = characterCount + (node.text ?? '').length;
                    accum[node.type] = (accum[node.type] ?? 0) + 1;
                    node?.marks?.forEach((mark)=>{
                        accum[mark.type] = (accum[mark.type] ?? 0) + 1;
                    });
                    return accum;
                }, {});
                attributes.inputNodeCount = inputNodeCount;
                attributes.characterCount = characterCount;
            }
        }
        // update experiencename and title as it changes on selecting suggestion
        analyticsFlow.addAttributes(attributes);
    }, [
        analyticsFlow,
        latestPromptResponse,
        getPromptTitle,
        adfInput
    ]);
    const updateTextInput = (0, $42omo.useCallback)((textInputValue)=>{
        sendToCommandPalette({
            type: 'onTextEntered',
            input: textInputValue
        });
    }, [
        sendToCommandPalette
    ]);
    const updateADFInput = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((text)=>{
        sendToCommandPalette({
            type: 'onADFEntered',
            adf: text
        });
    }, [
        sendToCommandPalette
    ]);
    const onSubmit = (0, $42omo.useCallback)(({ configItem: _configItem } = {})=>{
        // if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
        // they can only trigger the AI experience by selecting a submenu (which can be triggered by pressing enter)
        if (isParentWithNestedSubmenusSelected) return;
        // Register interaction with UFO
        ufoSubmitTracing(!!_configItem?.agent ? 'rovo' : 'atlassian-intelligence');
        kickoffAiExperience({
            configItem: _configItem || commandPaletteContext.configItem,
            userInput: commandPaletteContext.textInput || '',
            userADFInput: commandPaletteContext.adfInput
        });
    }, [
        isParentWithNestedSubmenusSelected,
        kickoffAiExperience,
        commandPaletteContext.configItem,
        commandPaletteContext.textInput,
        commandPaletteContext.adfInput,
        ufoSubmitTracing
    ]);
    const __getSuggestions = (0, $42omo.useMemo)(()=>{
        const getConfigItems = ()=>{
            return (0, $c2200b5407d4af9f$export$2dd2807afbd4a532)({
                configItemWithOptions: editorPluginAIProvider.configItemWithOptions,
                editorView: editorView,
                positions: positions,
                isEmpty: isEmpty
            });
        };
        return getConfigItems;
    }, [
        editorView,
        positions,
        isEmpty,
        editorPluginAIProvider.configItemWithOptions
    ]);
    /**
   * This function is responsible for highlighting the entire document
   * when particular prompts are selected.
   *
   * This only happens if the user has not already made a selection.
   *
   * Currently all prompts highlight the whole document except partial prompts like:
   * - Brainstorm
   * - Ask Search
   */ const handleHighlight = (0, $42omo.useCallback)(({ configItem: configItem, promptLabel: promptLabel })=>{
        // Remove all decorations if the prompt is 'Tell AI' or that it is not defined (brainstorm)
        if (configItem.promptLabel !== undefined && !configItem.agent || promptLabel === (0, $e1bfb729a95c0d28$export$aed4aa2c04f0ff0a) || promptLabel === (0, $e1bfb729a95c0d28$export$e9b50d8f92ed61d4) || promptLabel === (0, $e1bfb729a95c0d28$export$f94ca114676d6a3f) || promptLabel === (0, $e1bfb729a95c0d28$export$3cb19042951e1104)) {
            const removeTransaction = editorView.state.tr;
            removeTransaction.setMeta('hideSelectionPreview', true);
            editorView.dispatch(removeTransaction);
            return;
        }
        // Highlight the entire document for all other prompts
        const setTransaction = editorView.state.tr;
        setTransaction.setMeta('showSelectionPreview', true);
        editorView.dispatch(setTransaction);
    }, [
        editorView
    ]);
    const onConversationStarterSelected = (0, $42omo.useCallback)((conversationStarter)=>{
        const userADFInput = (0, $caRYB.doc)((0, $2FFuS.paragraph)(conversationStarter));
        handleHighlight({
            configItem: configItem
        });
        updateAnalytics(configItem);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onPartialPresetSelected(configItem, {
            presetPromptLabel: `@${configItem.agent.name}`
        });
        kickoffAiExperience({
            userInput: conversationStarter,
            configItem: configItem,
            userADFInput: userADFInput
        });
    }, [
        handleHighlight,
        updateAnalytics,
        onPartialPresetSelected,
        kickoffAiExperience,
        configItem
    ]);
    (0, $42omo.useEffect)(()=>{
        if (initialPrompt && !initialPromptTriggered) {
            if (configItem.agent) onConversationStarterSelected(initialPrompt);
            else if (!experienceAppContext.latestPrompt) {
                const userADFInput = (0, $caRYB.doc)((0, $2FFuS.paragraph)(initialPrompt));
                updateADFInput(userADFInput);
                updateTextInput(initialPrompt);
                setInitialPromptTriggered(true);
                kickoffAiExperience({
                    userInput: initialPrompt,
                    configItem: configItem,
                    userADFInput: userADFInput
                });
            }
            setInitialPromptTriggered(true);
        }
    }, [
        initialPrompt,
        onConversationStarterSelected,
        initialPromptTriggered,
        configItem,
        experienceAppContext.latestPrompt,
        updateADFInput,
        updateTextInput,
        kickoffAiExperience
    ]);
    const { starters: agentConversationStarters } = (0, $7f4d5fb15fd0cb78$export$552fd0249f716349)({
        handleHighlight: handleHighlight,
        configItem: configItem,
        onConversationStarterSelected: onConversationStarterSelected,
        product: editorPluginAIProvider.product,
        editorPluginAIProvider: editorPluginAIProvider
    });
    const getSuggestions = (0, $42omo.useCallback)((inputValue, agent)=>{
        // if like Brainstorm, return nothing
        if (presetPromptLabel && !configItem.nestingConfig && !agent) return [];
        /**
     * knowledge source
     */ function makeUseRovoOrganisationKnowledgeSuggestion(defaultAgent) {
            const agentConfigItem = (0, $ljZgt.createAgentConfigItem)(defaultAgent, editorPluginAIProvider);
            return {
                testId: (0, $e1bfb729a95c0d28$export$f94ca114676d6a3f),
                value: (0, $e1bfb729a95c0d28$export$f94ca114676d6a3f),
                label: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).useRovoOrganisationKnowledgeLabel),
                groupHeading: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).knowledgeSourceGroupHeading),
                rightText: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).useRovoOrganisationKnowledgeRightText),
                hideIcon: true,
                onSelect: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem
                    });
                    updateAnalytics(agentConfigItem);
                    onSubmit({
                        configItem: agentConfigItem
                    });
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem,
                        promptLabel: (0, $e1bfb729a95c0d28$export$f94ca114676d6a3f)
                    });
                }
            };
        }
        // If the user input has more than 3 words, we should show all Rovo Agents suggestions,
        // and suggestions should run free prompt, instead of showing starters.
        // See https://product-fabric.atlassian.net/browse/EDF-1700 for details.
        const isRovoAgentsSuggestionsShouldRunFreePrompt = inputValue.trim().split(' ').length > 3;
        function getRovoAgentsGroupHeading() {
            const matchedAgentCount = getSuggestions(textInput || '').filter((suggestion)=>suggestion.isAgent).length;
            if (matchedAgentCount === 0) return formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).rovoAgentsSuggestionGroupHeading);
            else if (isRovoAgentsSuggestionsShouldRunFreePrompt) return formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).useRovoAgentsCountSuggestionGroupHeading, {
                numberOfAgents: matchedAgentCount.toString()
            });
            else return formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).rovoAgentsCountSuggestionGroupHeading, {
                numberOfAgents: matchedAgentCount.toString()
            });
        }
        function makeKnowledgeSourceSuggestions() {
            const useRovoOrganisationKnowledgeSuggestions = // When showRovoAgentsInCommandPalette is false, don't show "Use knowledge from your organization" suggestion
            !aiProvider.showRovoAgentsInCommandPalette || !rovoAgentsPluginState?.enabled || !rovoAgentsPluginState?.defaultAgent || !aiProvider.getChannelVariables || agent ? [] : // pass defaultAgent to avoid ts check again
            [
                makeUseRovoOrganisationKnowledgeSuggestion(rovoAgentsPluginState.defaultAgent)
            ];
            const actions = (0, $c2200b5407d4af9f$export$a64e27216c5d7416)({
                isEmpty: isEmpty,
                configItem: configItem
            });
            if (isRovoEnabled && !configItem.agent && !actions.find((action)=>action.type === 'generic-chat')) {
                const chatAction = (0, $jAwX6.createContinueInChat)({
                    appearance: 'secondary',
                    product: editorPluginAIProvider.product,
                    actionSideEffect: editorPluginAIProvider.actionSideEffects?.['continueInChat'],
                    factoryOptions: {
                        product: editorPluginAIProvider.product,
                        isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled
                    }
                });
                actions.unshift(chatAction);
            }
            const knowledgeSourceSuggestions = [
                {
                    testId: (0, $e1bfb729a95c0d28$export$e9b50d8f92ed61d4),
                    value: (0, $e1bfb729a95c0d28$export$e9b50d8f92ed61d4),
                    label: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).useGeneralAiKnowledgeLabel),
                    groupHeading: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).knowledgeSourceGroupHeading),
                    rightText: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).useGeneralAiKnowledgeRightText),
                    hideIcon: true,
                    onSelect: ()=>{
                        handleHighlight({
                            configItem: configItem
                        });
                        updateAnalytics(configItem);
                        onSubmit();
                    },
                    onSuggestionFocused: ()=>{
                        handleHighlight({
                            configItem: configItem,
                            promptLabel: (0, $e1bfb729a95c0d28$export$e9b50d8f92ed61d4)
                        });
                    }
                },
                ...useRovoOrganisationKnowledgeSuggestions
            ];
            return knowledgeSourceSuggestions;
        }
        // use this flag to determine if we should show the knowledge source suggestions instead of the 'Tell AI' suggestion
        const showKnowledgeSourceSuggestionsInsteadOfTellAI = // When showRovoAgentsInCommandPalette is false, don't show "Use knowledge from your organization" suggestion
        aiProvider.showRovoAgentsInCommandPalette && rovoAgentsPluginState?.enabled && rovoAgentsPluginState?.defaultAgent && aiProvider.getChannelVariables && !agent && !presetPromptLabel;
        /**
     * do not show TELL_AI
     * - if there is no user input
     * - if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
     *   - they can only trigger the AI experience by selecting a submenu (which can be triggered by pressing enter)
     * Also when configItem.silentAgentPrompt is true, it means rovo agent is used in normal AI prompt.
     */ const tellAIPromptLabel = agent && !configItem.silentAgentPrompt ? (0, $e1bfb729a95c0d28$export$ea35400996401183) : (0, $e1bfb729a95c0d28$export$aed4aa2c04f0ff0a);
        const tellAiSuggestionBase = {
            value: tellAIPromptLabel,
            label: inputValue,
            hideIcon: true,
            onSelect: ()=>{
                handleHighlight({
                    configItem: configItem
                });
                updateAnalytics(configItem);
                onSubmit();
            },
            onSuggestionFocused: ()=>{
                handleHighlight({
                    configItem: configItem,
                    promptLabel: tellAIPromptLabel
                });
            }
        };
        const rovoSuggestionWithFallback = rovoAgentsPluginState?.enabled && rovoAgentsPluginState?.defaultAgent && aiProvider.getChannelVariables ? makeUseRovoOrganisationKnowledgeSuggestion(rovoAgentsPluginState.defaultAgent) : tellAiSuggestionBase;
        rovoSuggestionWithFallback.value = tellAIPromptLabel;
        rovoSuggestionWithFallback.label = inputValue;
        const tellAiSuggestion = !inputValue || isParentWithNestedSubmenusSelected ? [] : showKnowledgeSourceSuggestionsInsteadOfTellAI ? makeKnowledgeSourceSuggestions() : [
            tellAiSuggestionBase
        ];
        const showMoreText = formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).showMoreButton);
        const showMoreSuggestion = [
            {
                value: (0, $e1bfb729a95c0d28$export$95f98990d7202b31),
                label: showMoreText,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                    spacing: "spacious",
                    label: showMoreText
                }),
                onSelect: ()=>{
                    handleHighlight({
                        configItem: configItem
                    });
                    updateAnalytics(configItem);
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: configItem,
                        promptLabel: showMoreText
                    });
                }
            }
        ];
        // The browse agents option is only available when using the new <BrowseAgentsModal>
        // component as we need to use its state to send the selected agent to the command palette
        const browseAgentsSuggestion = // Don't show browse agents suggestion when showRovoAgentsInCommandPalette is false
        !aiProvider.showRovoAgentsInCommandPalette || !rovoAgentsPluginState?.enabled || !aiProvider.getChannelVariables || agent ? [] : {
            value: (0, $e1bfb729a95c0d28$export$3cb19042951e1104),
            label: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).agentsBrowseMore),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                label: "browse-more-agents"
            }),
            groupHeading: getRovoAgentsGroupHeading,
            onSelect: ()=>{
                (0, $eIhC8.openBrowseAgentsModal)(true, positions)(editorView.state, editorView.dispatch);
            },
            onSuggestionFocused: ()=>{
                handleHighlight({
                    configItem: configItem,
                    promptLabel: (0, $e1bfb729a95c0d28$export$3cb19042951e1104)
                });
            }
        };
        /**
     * If an agent is selected, we want to show the agents conversation starters
     * as suggestions in the command palette with the 'Tell Agent' suggestion
     * when there is user input.
     *
     * But when configItem.silentAgentPrompt is true, it means rovo agent is used in normal AI prompt.
     * So don't show the agent conversation starters.
     */ if (agent && !configItem.silentAgentPrompt) {
            if (agentConversationStarters.filter((configItem)=>typeof configItem.label !== 'string').length) return agentConversationStarters;
            const filteredAgentSuggestions = agentConversationStarters.filter((configItem)=>configItem.label.toLowerCase().includes((inputValue || '').toLowerCase()));
            return filteredAgentSuggestions;
        }
        /**
     * If an agent is not selected, we want to show the suggestions
     */ const output = __getSuggestions({
            inputValue: inputValue
        }).map((configItem)=>{
            let icon = configItem.icon?.({
                formatMessage: formatMessage
            });
            // Show the icon for the parent config item if it exists
            if (configItem.nestingConfig && configItem.nestingConfig.icon && !presetPromptLabel && !inputValue) icon = configItem.nestingConfig.icon?.({
                formatMessage: formatMessage
            });
            const actions = (0, $c2200b5407d4af9f$export$a64e27216c5d7416)({
                isEmpty: isEmpty,
                configItem: configItem
            });
            if (isRovoEnabled && !configItem.agent && !actions.find((action)=>action.type === 'generic-chat')) {
                const chatAction = (0, $jAwX6.createContinueInChat)({
                    appearance: 'secondary',
                    product: editorPluginAIProvider.product,
                    actionSideEffect: editorPluginAIProvider.actionSideEffects?.['continueInChat'],
                    factoryOptions: {
                        product: editorPluginAIProvider.product,
                        isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled
                    }
                });
                actions.unshift(chatAction);
            }
            return {
                icon: icon,
                label: configItem.nestingConfig && presetPromptLabel ? formatMessage(configItem.nestingConfig.shortTitle) : (0, $c2200b5407d4af9f$export$d97f37f32ae9d000)(configItem, formatMessage),
                statusLozengeType: configItem.statusLozengeType,
                value: configItem.key,
                nestingConfig: configItem.nestingConfig ? {
                    parentTestId: configItem.nestingConfig.parentTestId,
                    parentTitle: formatMessage(configItem.nestingConfig.parentTitle)
                } : undefined,
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: configItem
                    });
                },
                onSelect: ()=>{
                    // A config item nested parent will have matching config but no prompt label
                    // will be selected
                    if (configItem.nestingConfig && !presetPromptLabel && !inputValue) onPartialPresetSelected(configItem, {
                        presetPromptLabel: formatMessage(configItem.nestingConfig.parentTitle)
                    });
                    else {
                        handleHighlight({
                            configItem: configItem
                        });
                        updateAnalytics(configItem);
                        // If full prompt is selected we want to kickoff the AI experience
                        if (!configItem.promptLabel) kickoffAiExperience({
                            userInput: '',
                            userADFInput: undefined,
                            configItem: configItem
                        });
                        else onPartialPresetSelected(configItem);
                    }
                }
            };
        }).concat(showMoreSuggestion).concat(!agent ? tellAiSuggestion : [])/**
     * Only show the agents if the user hasn't already selected an agent
     */ .concat(!aiProvider.showRovoAgentsInCommandPalette || !rovoAgentsPluginState?.enabled || !aiProvider.getChannelVariables || agent ? [] : rovoAgentsPluginState.agents.map((agent)=>{
            const agentConfigItem = (0, $ljZgt.createAgentConfigItem)(agent, editorPluginAIProvider);
            return {
                value: `agent:${agent.id}`,
                label: agent.name,
                description: agent.description ?? '',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, editorPluginAIProvider.isRovoEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9096bdf9049f901$export$3b4439d273b7f3cc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hezkK.AgentAvatar), {
                    agentId: agent.id,
                    agentNamedId: agent.externalConfigReference ?? agent.namedId,
                    agentIdentityAccountId: agent.identityAccountId,
                    isForgeAgent: agent.creatorType === 'FORGE',
                    forgeAgentIconUrl: agent.icon
                })),
                groupHeading: getRovoAgentsGroupHeading,
                isAgent: true,
                onSelect: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem
                    });
                    updateAnalytics(agentConfigItem);
                    onPartialPresetSelected(agentConfigItem, {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        presetPromptLabel: `@${agentConfigItem.agent.name}`
                    });
                    if (isRovoAgentsSuggestionsShouldRunFreePrompt) kickoffAiExperience({
                        userInput: inputValue,
                        userADFInput: undefined,
                        configItem: agentConfigItem
                    });
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem
                    });
                }
            };
        })).concat(agent ? tellAiSuggestion : []).filter((suggestion)=>{
            if (!suggestion) return false;
            if (typeof suggestion.label !== 'string') return false;
            // Since we move `.concat(tellAiSuggestion)` above, we need to update the filter logic to include these suggestions
            if (suggestion.value === (0, $e1bfb729a95c0d28$export$e9b50d8f92ed61d4) || suggestion.value === (0, $e1bfb729a95c0d28$export$f94ca114676d6a3f)) return true;
            // if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
            // ignore those that don't belong to the parent
            if (isParentWithNestedSubmenusSelected && suggestion.nestingConfig?.parentTitle !== presetPromptLabel) return false;
            // If Rovo Agents should process the user input and run free prompt,
            // show all agents suggestions.
            if (suggestion?.isAgent && isRovoAgentsSuggestionsShouldRunFreePrompt) return true;
            // text filter
            const searchValues = [
                suggestion.label.toLowerCase()
            ];
            searchValues.push((suggestion.description ?? '').toLowerCase());
            if (suggestion?.isAgent) searchValues.push('rovo', 'agent');
            return searchValues.join(' ').includes((inputValue || '').toLowerCase());
        }).concat(!isParentWithNestedSubmenusSelected ? browseAgentsSuggestion : []).map((suggestion)=>{
            if (!suggestion.groupHeading) // If the suggestion is in a submenu, we want to show the parent title as the group heading
            suggestion.groupHeading = isParentWithNestedSubmenusSelected && configItem?.nestingConfig?.parentTitle ? formatMessage(configItem.nestingConfig.parentTitle) : (0, $dh538.fg)('ai-smart-button-team-25') ? formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).actionsGroupHeading) : formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).atlassianIntelligenceGroupHeading);
            return suggestion;
        });
        if (output.length) return output;
        return isParentWithNestedSubmenusSelected ? [
            {
                value: 'no-suggestions',
                label: formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).noResultsSuggestion),
                hideIcon: true,
                icon: undefined,
                onSelect: ()=>{},
                onSuggestionFocused: ()=>{}
            }
        ] : [];
    }, [
        presetPromptLabel,
        configItem,
        rovoAgentsPluginState?.enabled,
        rovoAgentsPluginState?.defaultAgent,
        rovoAgentsPluginState?.agents,
        aiProvider.getChannelVariables,
        aiProvider.showRovoAgentsInCommandPalette,
        isParentWithNestedSubmenusSelected,
        formatMessage,
        __getSuggestions,
        editorPluginAIProvider,
        handleHighlight,
        updateAnalytics,
        onSubmit,
        textInput,
        positions,
        editorView,
        isEmpty,
        agentConversationStarters,
        onPartialPresetSelected,
        kickoffAiExperience,
        isRovoEnabled
    ]);
    const aiToolbarButtonPulseAnnouncement = (0, $27eabb301b03160d$export$a1cbeeef2ea2e5f5)('cc-editor-ai_ai-toolbar-button-pulse', formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).engagementBannerLinksText));
    (0, $42omo.useEffect)(()=>{
        if (aiProvider.onAIProviderChanged) aiProvider.onAIProviderChanged('command-palette', configItem.agent ? {
            type: 'rovo',
            agent: configItem.agent
        } : undefined);
    }, [
        configItem.agent,
        aiProvider
    ]);
    const removeRefinementTag = (0, $42omo.useCallback)(()=>{
        // Set experienceName and promptTitle to default values
        analyticsFlow.addAttributes({
            experienceName: baseGenerate?.key,
            featureId: baseGenerate?.featureId,
            promptTitle: baseGenerate ? (0, $c2200b5407d4af9f$export$4539b8c6808af330)(baseGenerate, formatMessage) : ''
        });
        analyticsFlow.updateCommonAttributes({
            backendModel: baseGenerate?.getBackendModel?.(!!latestPromptResponse)
        });
        sendToCommandPalette({
            type: 'onPartialPresetRemoved'
        });
        focusInputRef.current?.();
    }, [
        analyticsFlow,
        baseGenerate,
        formatMessage,
        latestPromptResponse,
        sendToCommandPalette
    ]);
    const onBack = (0, $42omo.useCallback)(()=>{
        removeRefinementTag();
        updateTextInput('');
        updateADFInput();
    }, [
        removeRefinementTag,
        updateTextInput,
        updateADFInput
    ]);
    const pageKnowledgeProps = (0, $89e40b7594cde5dd$export$4b8c026161f470e2)({
        hasInput: !!(textInput || adfInput),
        suggestions: getSuggestions(textInput || ''),
        agentVisible: !!agentConversationStarters.length,
        nestedMenuSelected: isParentWithNestedSubmenusSelected
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40b5db5f178d1147$export$9491b5d7f967f421), {
        appearance: appearance,
        presetPromptLabel: presetPromptLabel,
        inputValue: textInput || '',
        inputADFValue: adfInput,
        onInputUpdate: updateTextInput,
        onADFUpdate: updateADFInput,
        onEscapeKeyPressed: handleCancel,
        onSubmit: onSubmit,
        onRefinementTagRemove: removeRefinementTag,
        onBack: onBack,
        placeholder: configItem.promptHint ? formatMessage(configItem.promptHint) : '',
        getSuggestions: getSuggestions,
        focusInputRef: focusInputRef,
        PromptEditor: editorPluginAIProvider.PromptEditor,
        agent: /**
     * When editor rovo agent is used behind the scenes for prompt, then don't pass agent.
     */ !configItem.silentAgentPrompt ? configItem.agent : undefined,
        hideLegacySubmitCancelButtons: isParentWithNestedSubmenusSelected,
        announcementBanners: aiToolbarButtonPulseAnnouncement ? [
            aiToolbarButtonPulseAnnouncement
        ] : undefined,
        pageKnowledgeProps: pageKnowledgeProps
    }));
}


function $277b46ea6187801a$export$501630857d1b4132(props) {
    const { api: api } = props;
    /**
   * Note -- because we are on an old version of xstate -- when adding new states
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineState` type in the
   * `get-experience-service.ts` file
   **/ const state = props.state;
    /**
   * Note -- because we are on an old version of xstate -- when adding new events
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineEvent` type in the
   * `get-experience-service.ts` file
   **/ const context = props.context;
    const aiExperienceCommonData = (0, $ee350c5972abd564$export$28c15afa0bc9f86b)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const autoAcceptAIChanges = aiExperienceCommonData.canInlineStreamChanges();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const send = aiExperienceCommonData.sendToAIExperienceMachine;
        if (send && state === 'started state') send({
            type: 'kick off'
        });
    }, [
        state,
        aiExperienceCommonData.sendToAIExperienceMachine
    ]);
    /**
   * Used to pass the backendModel to analytics and
   * feedback submission metadata
   */ const backendModel = context?.configItem?.getBackendModel?.(!!context?.latestPromptResponse);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        analyticsFlow.updateCommonAttributes({
            backendModel: backendModel,
            channelId: context.channelId,
            ...analyticsFlow.getUserFlowCommonAttributes(context.configItem),
            autoAcceptAIChanges: autoAcceptAIChanges,
            inlineStreamingAvailable: false
        });
    }, [
        analyticsFlow,
        backendModel,
        context.channelId,
        context.configItem,
        autoAcceptAIChanges
    ]);
    const aiLifeCycleDynamicAttributesGetter = context.aiLifeCycleDynamicAttributesGetter;
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (aiLifeCycleDynamicAttributesGetter) analyticsFlow.registerAiLifeCycleDynamicAttributesGetter(aiLifeCycleDynamicAttributesGetter);
    }, [
        analyticsFlow,
        aiLifeCycleDynamicAttributesGetter
    ]);
    // Note -- the intention is to move the creation of the state machine higher
    // and for the ExperienceApplication (react component that appears in the modal)
    // to only be started once the machine is in the modal active state.
    if (state === 'started state') return null;
    const isModalActiveState = typeof state !== 'string' && state['modal active state'];
    if (!isModalActiveState) throw new Error('AI machine state is not: modal active state or modal error state');
    const experienceState = state['modal active state']['experience'];
    if ((0, $dh538.fg)('platform_editor_ai_handle_invalid_input')) {
        if (typeof experienceState === 'object' && 'error state' in experienceState && experienceState['error state'] === 'active' || typeof experienceState !== 'string' && 'error state' in experienceState) {
            if (context.apiErrorInfo.failureReason === (0, $a70d178538e2ee9c$export$ab58f948d2b5b95c).NO_TEXTUAL_CONTENT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c2b39d1df2126a4$export$124856cc35c13bde), {
                errorInfo: context.apiErrorInfo,
                contextStatistics: context.contextStatistics
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b307a07f626c94fc$export$eec2740903046434), {
                errorInfo: context.apiErrorInfo
            });
        }
    } else {
        if (typeof experienceState === 'object' && 'error state' in experienceState && experienceState['error state'] === 'active') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b307a07f626c94fc$export$eec2740903046434), {
            errorInfo: context.apiErrorInfo
        });
    }
    if (typeof state['modal active state'] === 'object' && state['modal active state']['discard'] === 'active') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7808287d3e166156$export$643e9e046f871343), {
        state: experienceState,
        channelId: context.channelId,
        editCount: context.editCount,
        retryPromptCount: context.retryPromptCount,
        history: context.responseHistory,
        latestPrompt: context.latestPrompt,
        onceDiscard: context.onceDiscard,
        streamFlowPacer: props.streamFlowPacer,
        api: api
    });
    if (typeof experienceState === 'string' && experienceState === 'command palette state') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $edc45ae60c0157d0$export$751495e555be6bbc), {
        context: context,
        initialPrompt: props.initialPrompt
    });
    if (typeof experienceState === 'object' && 'loading state' in experienceState) {
        const loadingState = experienceState['loading state'];
        if (loadingState === 'loading') {
            /**
       * Short title for the submenu if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
       * If the user selects a submenu directly, this will be empty (search and select `Change tone to Neutral`)
       */ const childShortTitle = context.parentPresetPromptLabel && context.configItem.nestingConfig ? formatMessage(context.configItem.nestingConfig.shortTitle) : '';
            const loadingMessage = (0, $f67061403a6197ff$export$e51701552d28cc4e)({
                status: context?.loadingStatus,
                formatMessage: formatMessage
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9f41e7d7fa207e85$export$9c279fd5d5bced59), {
                parentPresetPromptLabel: context.parentPresetPromptLabel,
                childShortTitle: childShortTitle,
                title: loadingMessage ? loadingMessage : formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).loadingTitle),
                markdown: context.markdown,
                adfResponse: context.adfResponse,
                latestPrompt: context.latestPrompt,
                promptTrigger: context.promptTrigger,
                refinementCount: context.refinementCount,
                latestPromptRetried: context.latestPromptRetried,
                idMap: context.idMap,
                contextStatistics: context.contextStatistics,
                hideLoadingScreen: aiExperienceCommonData.hideLoadingScreen
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d523c2c58c9df434$export$90b9d761c76d339a), {
                loadingStatus: context.loadingStatus
            }));
        }
    }
    if (typeof experienceState !== 'string' && 'review state' in experienceState) {
        const action = context.rovoActions ? context.rovoActions[context.selectionType] : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0082397ce8f9ad9a$export$705df12804ca7004), {
            aiExperienceMachineContext: context,
            isInputActive: experienceState['review state'] === 'refinement',
            backendModel: backendModel,
            rovoAction: action,
            rovoPublish: publish
        });
    }
    // When cleaning up, platform_editor_ai_handle_invalid_input, remove below if block.
    if (!(0, $dh538.fg)('platform_editor_ai_handle_invalid_input')) {
        if (typeof experienceState !== 'string' && 'error state' in experienceState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b307a07f626c94fc$export$eec2740903046434), {
            errorInfo: context.apiErrorInfo
        });
    }
    throw new Error('unhandled state');
}
function $277b46ea6187801a$var$canReplaceBaseGenerate(aiProvider) {
    return aiProvider.isRovoEnabled && aiProvider.useFreeGenerateEditorAgent;
}
function $277b46ea6187801a$var$focusEditor(editorView) {
    if (!editorView.hasFocus()) editorView.focus();
}
// document.body will be focused when we switch from one screen to another
// (can be triggered by clicking button or pressing Esc key)
// which will make pressing Esc not working because we're listening Esc on editor
// so we should focus editor when it's not focused
function $277b46ea6187801a$var$useFocusEditor({ editorView: editorView, cancelRovoPrompt: cancelRovoPrompt }) {
    (0, $42omo.useEffect)(()=>{
        if (cancelRovoPrompt) $277b46ea6187801a$var$focusEditor(editorView);
    }, [
        cancelRovoPrompt,
        editorView
    ]);
}
function $277b46ea6187801a$var$ExperienceApplicationStateWrapper(props) {
    const { api: api, editorView: editorView, endExperience: endExperience } = props;
    const intl = (0, $8C5kA.default)();
    const modalRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const positions = props.positions;
    const isEmpty = positions[0] === positions[1];
    const selectionType = isEmpty ? 'empty' : 'range';
    /**
   * baseGenerate configItem is used as default configItem in command palette.
   * Currently for every product, "freeGenarete" is used as baseGenerate.
   * Recently, "useFreeGenerateEditorAgent" is introduced to allow
   * 	freeGenerateEditorAgent configItem to be used as baseGenerate.
   *  freeGenerateEditorAgent is like freeGeneerate, but it uses
   * 	rovo agent instead of standard AI prompt.
   *
   * Can't set "freeGenerateEditorAgent" directly as baseGenerate in prebuilt config,
   * 	because creating configItem requires agent to be passed in.
   * But agents are not available at compile time or event when plugin is loaded.
   * So we need to swap baseGenerate here.
   */ let configItem = props.configItem;
    let baseGenerate = props.editorPluginAIProvider.baseGenerate;
    if (props.defaultAgent && $277b46ea6187801a$var$canReplaceBaseGenerate(props.editorPluginAIProvider)) {
        baseGenerate = (0, $8dbf3e97af770d28$export$dc3b52bb600cbaa7)({
            agent: props.defaultAgent,
            product: props.editorPluginAIProvider.product,
            isInDocumentStreamingEnabled: props.editorPluginAIProvider.isInDocumentStreamingEnabled
        });
        if (props.configItem.key === (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE) configItem = baseGenerate;
    }
    const isUserScroll = (0, $42omo.useRef)(false);
    const isProgrammaticScroll = (0, $42omo.useRef)(true);
    const streamFlowPacerRef = (0, $8d54db085cc5a603$export$ace1671de29eb5ea)(false);
    const analyticsFlow = (0, $3adf5d183dded6a4$export$8af1809310de64fa)();
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const streamingHandler = (0, $03deff61eb2c4e8b$export$ad256dcfbe275ed5)({
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        aiInteractionID: analyticsFlow.getLastAiInteractionId(),
        streamFlowPacer: streamFlowPacerRef.current
    });
    const { context: context, state: state, send: send } = (0, $c802a1f50ee37760$export$519bc24a166a4cfd)({
        context: {
            analyticsContext: props.analyticsContext,
            aiProvider: props.editorPluginAIProvider,
            intl: intl,
            editorView: props.editorView,
            positions: positions,
            isEmpty: isEmpty,
            selectionType: selectionType,
            baseGenerate: baseGenerate,
            configItem: configItem,
            aiLifeCycleDynamicAttributesGetter: props.editorPluginAIProvider?.aiLifeCycleDynamicAttributesGetter,
            markdown: '',
            latestPromptResponse: undefined,
            editCount: 0,
            refinementCount: 0,
            retryPromptCount: 0,
            latestPromptRetried: false,
            userInput: '',
            apiErrorInfo: {},
            responseHistory: {
                positionFromEnd: 0,
                entries: [],
                totalSize: 0,
                traversals: 0
            },
            channelId: undefined,
            getMentionNameDetails: props.getMentionNameDetails,
            triggeredFor: props.triggeredFor,
            usePageKnowledge: true,
            endExperience: props.endExperience,
            streamingHandler: streamingHandler
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (props.defaultAgent && $277b46ea6187801a$var$canReplaceBaseGenerate(props.editorPluginAIProvider)) {
            const newBaseGenerate = (0, $8dbf3e97af770d28$export$dc3b52bb600cbaa7)({
                agent: props.defaultAgent,
                product: props.editorPluginAIProvider.product,
                isInDocumentStreamingEnabled: props.editorPluginAIProvider.isInDocumentStreamingEnabled
            });
            send({
                type: 'update baseGenerate and configItem',
                baseGenerate: newBaseGenerate,
                configItem: newBaseGenerate
            });
        }
    }, [
        props.defaultAgent,
        props.editorPluginAIProvider,
        send
    ]);
    const [start, end] = props.positions;
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        // Note -- the intention is to have the state machine created at a higher
        // level, and have the positions updated without being passed into this react
        // component.
        send({
            type: 'update positions',
            positions: [
                start,
                end
            ]
        });
    // Separate start/end as React will recognise tuples recreated
    // as a change, even if the values don't change
    }, [
        send,
        start,
        end
    ]);
    $277b46ea6187801a$var$useFocusEditor({
        editorView: editorView
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!modalRef.current) return;
        /**
     * KeyDown (as opposed to KeyPress) event is used to handle the escape key so that
     * other escape key handlers will not override this behaviour.
     * Additionally this aligns with other escape listeners e.g. for closing typeahead popup.
     */ function handleEscapeKeyDown(event) {
            // Exit early if the key is not Escape
            if (event.key !== 'Escape') return;
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            event.preventDefault();
            event.stopPropagation();
            const modalActiveState = state?.['modal active state'];
            const experience = modalActiveState?.experience;
            if (typeof experience === 'object' && 'loading state' in experience && experience['loading state'] === 'loading') {
                if (modalActiveState?.discard === 'active') send({
                    type: 'disable discard'
                });
                else send({
                    type: 'enable discard'
                });
            } else {
                if ((0, $0051c1ce99634d93$export$f332b66be3f378cc)(context.promptTrigger, context.responseHistory)) {
                    endExperience();
                    return;
                }
                send({
                    type: 'escape'
                });
            }
        }
        /**
     * Handle KeyUp event to prevent unexpected escape behaviours when
     * there are other escape handlers outside of component (e.g. in product)
     */ function handleEscapeKeyUp(event) {
            // Exit early if the key is not Escape
            if (event.key !== 'Escape') return;
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            event.preventDefault();
            event.stopPropagation();
        }
        // initially, editor is focused
        // when AI modal is loading and user presses ESC
        // we will show the AI modal discard screen
        // which will make AI modal to be auto focused
        // now if user presses ESC again,
        // we will return to the AI modal loading screen
        // so whenever user presses ESC, either the AI modal or the editor is focused
        // so the listener should be attached to the common ancestor of the AI Modal and the editor
        const node = modalRef.current;
        if (!node) return;
        return (0, $fFa3V.bindAll)(node, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            }
        ]);
    }, [
        modalRef,
        state,
        send,
        context.promptTrigger,
        context.responseHistory,
        endExperience,
        editorView,
        api
    ]);
    const [isMounted, setIsMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_scroll_into_view_fix')) return;
        if (!modalRef.current) return;
        (0, $42omo.startTransition)(()=>{
            setIsMounted(true);
        });
    }, [
        modalRef
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_scroll_into_view_fix')) return;
        if (!modalRef.current) return;
        if (isMounted) modalRef.current?.scrollIntoView({
            block: 'nearest',
            behavior: 'auto'
        });
    }, [
        isMounted,
        modalRef
    ]);
    const aiExperienceCommonData = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            appearance: props.appearance,
            // configItem can be changed within state machine, so always get it from machine context.
            configItem: context.configItem,
            editorPluginAIProvider: props.editorPluginAIProvider,
            endExperience: props.endExperience,
            lastTriggeredFrom: props.lastTriggeredFrom,
            providerFactory: props.providerFactory,
            editorView: props.editorView,
            positions: props.positions,
            triggerMethod: props.triggerMethod,
            triggeredFor: props.triggeredFor,
            sendToAIExperienceMachine: send,
            modalRef: modalRef,
            isUserScroll: isUserScroll,
            isProgrammaticScroll: isProgrammaticScroll,
            engagementPlatformApi: props.engagementPlatformApi,
            includeKnowledgeFromCurrentPage: context.usePageKnowledge,
            canInlineStreamChanges: props.canInlineStreamChanges,
            hideLoadingScreen: props.hideLoadingScreen,
            aiSessionId: props.interactionSessionId
        }), [
        context.configItem,
        context.usePageKnowledge,
        props.editorView,
        props.editorPluginAIProvider,
        props.appearance,
        props.endExperience,
        props.lastTriggeredFrom,
        props.providerFactory,
        props.positions,
        props.triggerMethod,
        props.triggeredFor,
        props.engagementPlatformApi,
        props.canInlineStreamChanges,
        send,
        modalRef,
        isUserScroll,
        isProgrammaticScroll,
        props.hideLoadingScreen,
        props.interactionSessionId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        analyticsFlow.updateCommonAttributes({
            traceIds: context.traceIds
        });
    }, [
        analyticsFlow,
        context.traceIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // We set these to ensure that when focus initially moves to
        // an element within the modal, that context about the modal
        // (e.g. "Atlassian Intelligence Dialog") is announced too
        role: "dialog",
        // ED-19787
        // We would like to use aria-labelledBy so we can label this
        // dynamically for each screen, however it's not working as expected
        // in Chrome and Firefox (works in Safari). For now we'll use the dialog
        // role and make the first element of each screen a screen-reader accessible
        // heading for the experience.
        // aria-label={intl.formatMessage(experienceMessages.dialogAriaLabel)}
        "aria-label": intl.formatMessage((0, $453a2c54e5f1c7c7$export$c73af7ca4a2501ab).dialogAriaLabel),
        ref: modalRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee350c5972abd564$export$cad72db1c520741c).Provider, {
        value: aiExperienceCommonData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($277b46ea6187801a$export$501630857d1b4132, {
        api: api,
        state: state,
        context: context,
        initialPrompt: props.initialPrompt,
        modalRef: modalRef,
        streamFlowPacer: streamFlowPacerRef.current
    })));
}
function $277b46ea6187801a$export$8b0e36b4d2610ae7(props) {
    const analyticsFlow = (0, $3adf5d183dded6a4$export$b26e0d212ef01829)({
        invokeAttributes: {
            invokedFrom: props.lastTriggeredFrom,
            invokedFor: props.triggeredFor ? props.triggeredFor.name : 'text',
            triggerMethod: props.triggerMethod,
            experienceName: props.configItem.key,
            featureId: props.configItem.featureId,
            aiGroupId: props.aiGroupId,
            aiSessionId: props.interactionSessionId
        },
        canInlineStreamChanges: ()=>false,
        isInDocumentStreamingEnabled: false
    });
    // initialPositions is updated many times during in-doc streaming,
    // but we only want to update the common analytics attributes once,
    // so we check if they've already been updated
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const isInvokedFromEmptyPage = (0, $2pjJ5.isEmptyDocument)(props.editorView.state.doc);
        analyticsFlow.updateCommonAttributes({
            isInvokedFromEmptyPage: isInvokedFromEmptyPage,
            /**
       * Confidence score will be used passed in analytics events.
       * It is currently only set when "Improve writing" is triggered from the
       * 	"Improve writing" nudge.
       */ nudgeMetrics: props.nudgeMetrics
        });
        if (props.initialPositions) {
            const selectionCategory = (0, $d465bdc6207b3d88$export$385434a4b24ab280)(props.editorView, props.initialPositions);
            analyticsFlow.updateCommonAttributes({
                isInvokedFromEmptyPage: isInvokedFromEmptyPage,
                selectionCategory: selectionCategory
            });
        }
    }, [
        analyticsFlow,
        props.editorView,
        props.initialPositions,
        props.nudgeMetrics
    ]);
    // finish analytics flow and fire remaining steps on unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            // have to postpone until animation frame to make sure we end analytics flow after child components unmount
            // which is where we enqueue last events
            window.requestAnimationFrame(()=>{
                analyticsFlow.fireQueuedStep();
            });
        };
    }, [
        analyticsFlow
    ]);
    // This makes sure that the selection preview is hidden when the experience is unmounted
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            const tr = props.editorView.state.tr;
            tr.setMeta('hideSelectionPreview', true);
            props.editorView.dispatch(tr);
        };
    }, [
        props.editorView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $510ce0322de9e3d3$export$61f6bd9fac8ed53), {
        onCloseFallback: ()=>{
            props.endExperience();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3adf5d183dded6a4$export$b8f39b5859612546), {
        value: analyticsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "EditorAICommandPalette"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($277b46ea6187801a$var$ExperienceApplicationStateWrapper, {
        ...props,
        analyticsContext: {
            aiSessionId: analyticsFlow.aiSessionId,
            aiGroupId: props.aiGroupId ?? analyticsFlow.aiSessionId
        }
    }))));
}


/* eslint-disable @repo/internal/react/no-class-components */ /* There is no good way to replace ErrorBoundary class components with a
 * functional component; currently no functional hook that can replace
 * 'componentDidCatch'.
 * Source: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 *
 * But I needed to get 'createAnalyticsEvent' via a hook hence
 * the wrapped class component.
 */ 






















const $af7e2893529c6215$export$61f6bd9fac8ed53 = (props)=>{
    const fireAIAnalyticsEvent = (0, $4SGh1.useFireAIAnalyticsEvent)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($af7e2893529c6215$var$ExperienceApplicationErrorBoundaryClass, {
        ...props,
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        formatMessage: formatMessage
    });
};
class $af7e2893529c6215$var$ExperienceApplicationErrorBoundaryClass extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    shouldRecover() {
        return this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-ai-error-boundary'
        });
        if (error.name === (0, $5b1c9f286ba7f166$export$8a78f5c7307b478b)) {
            const errorHasTypeProperty = 'type' in error;
            const errorSubType = errorHasTypeProperty ? error.type : undefined;
            this.props.fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        componentStack: errorInfo.componentStack || '',
                        errorType: 'markdownToProseMirrorError',
                        errorSubType: errorSubType,
                        errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                }
            });
            this.setState({
                errorCaptured: true,
                fallbackMessage: this.getFallbackMessage((0, $7ShCl.aiMessages).markdownErrorMessage)
            });
        } else {
            this.props.fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        componentStack: errorInfo.componentStack || '',
                        errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                }
            });
            this.setState({
                errorCaptured: true,
                fallbackMessage: this.getFallbackMessage((0, $7ShCl.aiMessages).unhandledErrorMessage)
            });
        }
    }
    render() {
        if (this.shouldRecover()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d6a38d051faab504$export$40729e8ab35829ea), {
            text: this.state.fallbackMessage,
            onCancel: this.props.onCloseFallback
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.getFallbackMessage = (descriptor)=>{
            return this.props.formatMessage(descriptor);
        };
        this.state = {
            errorCaptured: false,
            fallbackMessage: this.getFallbackMessage((0, $7ShCl.aiMessages).unhandledErrorMessage)
        };
    }
}


/* ModalRegionLegacy.tsx generated by @compiled/babel-plugin v0.36.1 */ 






















// Where do we get this magic number 500?
// - The lowest product z-index we need to be below is 500 from the Feedback Collector.
// As well as the Editor toolbar popup menu, which is also 500.
// This allows us to be above the floating toolbar, but below the feedback collector.
// +2 because tables floating toolbar is +1.
const $cb685eb5518f0f83$var$MAX_Z_INDEX = 500; // Where do we get this magic number 402?
// - The highest product z-index we need to be above is 401 from the floating toolbar*.
// *in Confluence and Bitbucket. It is 600px in Atlas & 511 in Jira, however that is a more niche case than the Feedback Collector,
// so this is a known trade-off until we have a better solution.
const $cb685eb5518f0f83$var$MIN_Z_INDEX = 402; // Sets the z-index so it is not greater than the maximum, and less than the minimum.
const $cb685eb5518f0f83$var$akAiModalRegionZIndex = Math.min($cb685eb5518f0f83$var$MAX_Z_INDEX, Math.max($cb685eb5518f0f83$var$MIN_Z_INDEX, (0, $aFUXX.akEditorFloatingPanelZIndex) + 2));
const $cb685eb5518f0f83$var$slideFadeIn = null;
const $cb685eb5518f0f83$var$modalStyles = null;
const $cb685eb5518f0f83$var$getModalDecorationElement = (editorView)=>{
    return editorView?.dom.querySelector('.ai-modal-end-widget') || editorView?.dom.querySelector('.ai-selection-node');
};
const $cb685eb5518f0f83$export$bd71f7a11db32a15 = ({ children: children, decoration: decoration, editorView: editorView, editorRelativeWrapper: editorRelativeWrapper, appearance: appearance, endExperience: endExperience, lastTriggeredFrom: lastTriggeredFrom, decorationSet: decorationSet, autoScroll: autoScroll })=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorViewElement = editorView.dom;
    const modalRef = (0, $42omo.useRef)(null);
    const [modalLeft, setModalLeft] = (0, $42omo.useState)(0);
    const [modalTop, setModalTop] = (0, $42omo.useState)(0);
    const [modalWidth, setModalWidth] = (0, $42omo.useState)(0);
    const [transition, setTransition] = (0, $42omo.useState)('');
    const scrollParentRef = (0, $42omo.useRef)(null); // get nearest resizable wrapper or breakout container looking up from the ai decoration position
    const resizableOrBreakoutWrapper = (0, $42omo.useMemo)(()=>(0, $17eb146d0c8e17ac$export$9e4eede810cdf154)(editorView, decoration.to), [
        editorView,
        decoration
    ]);
    const modalDecorationElement = $cb685eb5518f0f83$var$getModalDecorationElement(editorView); // EDF-161: https://product-fabric.atlassian.net/browse/EDF-161
    // If the editor has a max-height set, we need to set position relative for .ak-editor-content-area
    (0, $42omo.useEffect)(()=>{
        if (appearance === 'comment') {
            // editorRelativeWrapper is the closest but can be null
            // fallback to modalDecorationElement if editorRelativeWrapper is null
            let editorContentArea = null;
            if (editorRelativeWrapper) editorContentArea = editorRelativeWrapper.querySelector('.ak-editor-content-area');
            else if (modalDecorationElement) editorContentArea = modalDecorationElement.closest('.ak-editor-content-area');
            if (editorContentArea) {
                const computedStyle = getComputedStyle(editorContentArea);
                const editorHasMaxHeight = computedStyle.maxHeight !== 'none';
                const originalPosition = computedStyle.position;
                if (editorHasMaxHeight) editorContentArea.style.position = 'relative';
                return ()=>{
                    if (editorHasMaxHeight && editorContentArea) editorContentArea.style.position = originalPosition;
                };
            }
        }
    }, [
        modalDecorationElement,
        appearance,
        editorRelativeWrapper
    ]); // listen for editor resize and update modal size and position
    (0, $42omo.useEffect)(()=>{
        const setModalPosition = ()=>{
            if (!modalRef.current || !modalDecorationElement || !modalDecorationElement.offsetParent) // The modalDecorationElement.offsetParent is used when calculating the modal top postion. If it is null
            // the modal will flikcer from top to bottom, because the top position resets to 0.
            return;
            let relativePositionElement = editorViewElement; // When layout resizes / breakout changes, resizableOrBreakoutWrapper remounts
            // We need to wait for resizableOrBreakoutWrapper to update before we can calculate modal positions
            // Return if resizableOrBreakoutWrapper doesn't exist in view as it hasn't been updated yet to avoid flickering
            if (resizableOrBreakoutWrapper && !editorViewElement.contains(resizableOrBreakoutWrapper)) return;
             // position relative to breakout element when its available, or otherwise relative to editor view
            relativePositionElement = resizableOrBreakoutWrapper || editorViewElement;
            const top = (0, $17eb146d0c8e17ac$export$6fabade9f8472f78)({
                appearance: appearance,
                modalElement: modalRef.current,
                editorRelativeWrapper: editorRelativeWrapper,
                modalDecorationElement: modalDecorationElement,
                lastTriggeredFrom: lastTriggeredFrom,
                editorView: editorView
            });
            const left = (0, $17eb146d0c8e17ac$export$f695eeeda1b3ceee)({
                relativePositionElement: relativePositionElement,
                modalElement: modalRef.current
            });
            setModalLeft(left);
            setModalTop(top);
            setModalWidth(relativePositionElement.offsetWidth); //setting width to be animated here to make animation happen only after first positioning
            if (!transition) setTransition('all 0.1s ease-in');
        };
        setModalPosition();
        const setModalPositionDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setModalPosition();
        }, 20);
        const resizeObserver = new ResizeObserver(setModalPositionDebounced);
        resizeObserver.observe(editorViewElement); // editorViewOffsetParent can be undefined when editor is set to display: none
        // (when Confluence switches to Preview mode)
        const editorViewOffsetParent = editorViewElement.offsetParent;
        if (editorViewOffsetParent) // This resize observer is intended to fix the position of the modal region
        // when the config panel (for extensions or templates) is opened/closed
        resizeObserver.observe(editorViewOffsetParent);
         // listen to any changes in the resizableOrBreakoutWrapper if modal was triggered in
        // layout or table with breakout / resizable table
        if (resizableOrBreakoutWrapper) resizeObserver.observe(resizableOrBreakoutWrapper);
        return ()=>{
            resizeObserver.disconnect(); //clearing any potentially running debounced reposition
            setModalPositionDebounced.cancel();
        }; // no need to rerun due to transition change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorViewElement,
        modalDecorationElement,
        editorRelativeWrapper,
        resizableOrBreakoutWrapper
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!modalRef.current) return;
        if (!scrollParentRef.current) {
            const scrollParentEl = (0, $7YjFd.findOverflowScrollParent)(modalRef.current) || null;
            if (!scrollParentEl) return;
            scrollParentRef.current = scrollParentEl;
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!autoScroll || !modalTop) return;
        const modalEl = modalRef.current;
        if (!modalEl || !modalDecorationElement) return;
        if (!scrollParentRef.current) {
            const scrollParentEl = (0, $7YjFd.findOverflowScrollParent)(modalEl) || null;
            if (!scrollParentEl) return;
            scrollParentRef.current = scrollParentEl;
        } // The following values are all absoltue values this way they can all be easily compared to one another.
        const viewportTop = scrollParentRef.current.scrollTop;
        const viewportBottom = scrollParentRef.current.scrollTop + (scrollParentRef.current.offsetHeight - (0, $e1bfb729a95c0d28$export$9a9d72a255528f));
        const modalTippyTop = Math.max(0, modalTop - modalDecorationElement.offsetHeight);
        const modalBottom = modalTop + modalEl.offsetHeight; // Check if modal is already fully visible within the viewport.
        const isModalWithinViewport = modalTippyTop >= viewportTop && modalBottom <= viewportBottom;
        const isModalAboveViewport = modalTippyTop < viewportTop; // We should be able to surmise that if the modal is not within the viewport or above it, then it's below it.
        /**
     * Check if modal height exceeds scroll parent's height
     * Scroll margin is used to prevent the modal from being scrolled to the top
     * and should match scroll margin in other modals e.g. from
     * packages/editor/editor-plugin-ai/src/ui/components/FloatingContainer/styles.ts
     */ const isModalFullHeight = scrollParentRef.current.offsetHeight - (0, $e1bfb729a95c0d28$export$9a9d72a255528f) < modalEl.scrollHeight;
        if (isModalWithinViewport) // If the model fits in the view then we should not scroll at all
        return;
        if (isModalFullHeight || isModalAboveViewport) {
            // If the modal is bigger then the viewport, or above it, then we will scroll to the top of it
            scrollParentRef.current.scroll({
                top: Math.max(0, modalTippyTop - (0, $e1bfb729a95c0d28$export$9a9d72a255528f)),
                // @ts-ignore Type '"instant"' is not assignable to type 'ScrollBehavior | undefined'.
                behavior: 'instant'
            });
            return;
        } // If the modal is not within the viewport, or above it, then it must off the bottom or below it. So we will
        // want to scroll the page down, just enough to bring the bottom of the modal into view. This should just be
        // a matter of gettting the delta between the btm of the modal and the btm of the viewport and adding that
        // onto the current viewport top.
        scrollParentRef.current.scroll({
            top: viewportTop + Math.max(modalBottom - viewportBottom, 0) + (0, $e1bfb729a95c0d28$export$9a9d72a255528f),
            // @ts-ignore Type '"instant"' is not assignable to type 'ScrollBehavior | undefined'.
            behavior: 'instant'
        });
    }, [
        autoScroll,
        modalTop,
        modalDecorationElement
    ]);
    // sync modal height with editor content area height
    (0, $64b8432229a36001$export$a5441b49687f80f6)({
        modalElement: modalRef.current,
        editorViewElement: editorViewElement,
        isInDocumentStreamingEnabled: false
    }); // Check for the modal decoration which is used for positioning
    // If there is none the modal should be removed from the DOM & return early
    // This is intended to make the code more resilient to bugs caused by the
    // editor AI plugin not being reinstantiated correctly when the editor is closed/opened
    // See https://product-fabric.atlassian.net/browse/EDITOR-52
    if (decorationSet === (0, $ftzrq.DecorationSet).empty) {
        endExperience();
        return null;
    }
    const style = {
        top: modalTop,
        transition: transition,
        left: modalLeft,
        '--content-width': `${modalWidth}px`,
        display: modalWidth ? 'block' : 'none'
    };
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_19pkpxbi _kqswstnw _1pby1kbs _2hwxmgjw _18u0mgjw _1bsbxj84 _j7hq1w10 _5sagfnf5 _1pgl6ui8 _1o51q7pw _ta6yglyw",
            "ak-editor-plugin-ai-modal"
        ]),
        "data-testid": "ai-plugin-modal",
        ref: modalRef,
        // Otherwise, content selection will be prevented in packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
        "data-editor-popup": true,
        style: {
            ...style,
            "--_1dsp0pi": (0, $7sObp.default)($cb685eb5518f0f83$var$akAiModalRegionZIndex)
        }
    }, children);
};





const $995b21245e04b22e$export$2dda1e4a1d1f6a81 = ()=>{
    const { aiOptIn: aiOptIn, editorPluginAIProvider: editorPluginAIProvider, editorView: editorView, api: api, wrapperElement: wrapperElement, appearance: appearance, providerFactory: providerFactory, getMentionNameDetails: getMentionNameDetails, canInlineStreamChanges: canInlineStreamChanges, isRovoLoading: isRovoLoading } = (0, $3a58a391c8755141$export$c8b5a1f09cc4bb85)();
    const aiDecorationExperiencePluginState = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState);
    const isDecorationSetEmpty = !aiDecorationExperiencePluginState || aiDecorationExperiencePluginState.modalDecorationSet === (0, $ftzrq.DecorationSet).empty;
    const rovoAgentsPluginState = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.rovoAgentsPluginState);
    const decorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(editorView.state);
    const intl = (0, $8C5kA.default)();
    const endExperience = (0, $42omo.useCallback)((options)=>{
        if (editorPluginAIProvider.onAIProviderChanged) editorPluginAIProvider.onAIProviderChanged('command-palette');
        const state = (0, $kqrrC.getPluginState)(editorView.state);
        const decoSet = (0, $56Rej.hasGeneratedContentDecorations)(state) || options?.preserveEditorSelectionOnComplete ? state.modalDecorationSet : undefined;
        const endAIExperienceCommand = (0, $5SuLc.createEndAIExperienceCommand)(decoSet, options?.preserveEditorSelectionOnComplete, options?.shouldClearSelectionContext);
        endAIExperienceCommand(editorView.state, editorView.dispatch);
        editorView.focus();
    }, [
        editorView,
        editorPluginAIProvider
    ]);
    const { send: send, state: state, context: context } = (0, $c802a1f50ee37760$export$519bc24a166a4cfd)({
        context: {
            analyticsContext: {
                aiSessionId: '',
                aiGroupId: ''
            },
            aiProvider: editorPluginAIProvider,
            intl: intl,
            editorView: editorView,
            positions: [
                0,
                0
            ],
            isEmpty: true,
            selectionType: 'empty',
            configItem: editorPluginAIProvider?.baseGenerate,
            markdown: '',
            latestPromptResponse: undefined,
            editCount: 0,
            refinementCount: 0,
            retryPromptCount: 0,
            latestPromptRetried: false,
            userInput: '',
            apiErrorInfo: {},
            responseHistory: {
                positionFromEnd: 0,
                entries: [],
                totalSize: 0,
                traversals: 0
            },
            channelId: undefined,
            usePageKnowledge: true,
            endExperience: endExperience
        }
    }); /**
       * We only want to enable directional modal pinning when in the
       * prompt input state.
       */ 
    const isDirectionalPinningEnabled = !isRovoLoading && typeof state === 'object' && state['modal active state']['experience'] === 'command palette state'; // We use this point to render the modal if needed instead of decorators
    // The reason this is preferrable is it has access to mount points
    // where decorators are rendered with a mount point within the Editor content
    // and longer modals get clipped as a result.
    const renderModalRegion = ()=>{
        // If there are no active decorations -- then we don't want to render the ai experience.
        if (isDecorationSetEmpty) return null;
        if ((0, $56Rej.hasGeneratedContentDecorations)(aiDecorationExperiencePluginState)) return null;
         // Prioritise getting position from inlineDecoration,
        // otherwise get decoration position from start or end widget
        let positions;
        let decoration = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration').shift() || aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'startWidgetDecoration' || spec.key === 'endWidgetDecoration').shift();
        if (decoration) {
            // when there is decoration, it means it's text selection
            // we need to use the initial positions
            // as the decoration positions are not accurate when there the selection is empty
            if (!aiDecorationExperiencePluginState?.initialPositions) return null;
            positions = aiDecorationExperiencePluginState?.initialPositions;
        } else {
            const nodeDecorations = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration');
            if (nodeDecorations.length > 0) {
                const startPos = Math.min(...nodeDecorations.map((decoration)=>decoration.from));
                const endPos = Math.max(...nodeDecorations.map((decoration)=>decoration.to));
                positions = [
                    startPos,
                    endPos
                ];
            }
            decoration = nodeDecorations.shift();
        }
        if (!decoration) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb685eb5518f0f83$export$bd71f7a11db32a15), {
            isDirectionalPinningEnabled: isDirectionalPinningEnabled,
            lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
            key: aiDecorationExperiencePluginState.modalMountedTimeStamp,
            decoration: decoration,
            editorView: editorView,
            editorRelativeWrapper: wrapperElement?.offsetParent,
            endExperience: endExperience,
            appearance: appearance,
            decorationSet: aiDecorationExperiencePluginState.modalDecorationSet
        }, aiDecorationExperiencePluginState.configItem && editorView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $277b46ea6187801a$export$8b0e36b4d2610ae7), {
            api: api,
            context: context,
            send: send,
            state: state,
            configItem: aiDecorationExperiencePluginState.configItem,
            editorPluginAIProvider: editorPluginAIProvider,
            endExperience: endExperience,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            positions: positions,
            editorView: editorView,
            providerFactory: providerFactory,
            lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
            triggerMethod: aiDecorationExperiencePluginState.triggerMethod,
            appearance: appearance,
            initialPrompt: aiDecorationExperiencePluginState?.initialPrompt,
            getMentionNameDetails: getMentionNameDetails,
            triggeredFor: aiDecorationExperiencePluginState.triggeredFor,
            engagementPlatformApi: api?.engagementPlatform?.actions,
            initialPositions: aiDecorationExperiencePluginState?.initialPositions,
            nudgeMetrics: aiDecorationExperiencePluginState.nudgeMetrics,
            defaultAgent: rovoAgentsPluginState?.defaultAgent,
            canInlineStreamChanges: canInlineStreamChanges,
            hideLoadingScreen: decorationPluginState?.hideLoadingScreen,
            aiGroupId: aiDecorationExperiencePluginState?.currentSessionId,
            interactionSessionId: aiDecorationExperiencePluginState?.interactionSessionId
        }));
    };
    const getPositions = ()=>{
        return (0, $d465bdc6207b3d88$export$8e313fd1eaf35cec)({
            modalDecorationSet: aiDecorationExperiencePluginState?.modalDecorationSet
        });
    };
    const renderedSubscribeToRovo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e0fbb2bea9f0ffb$export$e7460f646530f5b4), {
        editorApi: api,
        positions: getPositions(),
        editorView: editorView,
        product: editorPluginAIProvider.product,
        onDocChangeByAgent: editorPluginAIProvider.onDocChangeByAgent,
        onAIProviderChanged: editorPluginAIProvider.onAIProviderChanged,
        editorPluginAIProvider: editorPluginAIProvider
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c7f02ab52bdba8d$export$6d436ac1332526a3), {
        editorView: editorView,
        editorPluginAIProvider: editorPluginAIProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8ab9b1b1a4a1d5e9$export$e4b2c7b98f669fb7), {
        editorView: editorView,
        getMentionNameDetails: getMentionNameDetails,
        editorPluginAIProvider: editorPluginAIProvider,
        editorApi: api
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56e9515070459f37$export$22e51ab65638ad05), {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView
    }), renderedSubscribeToRovo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $af7e2893529c6215$export$61f6bd9fac8ed53), {
        inContentComponent: true,
        onCloseFallback: endExperience
    }, renderModalRegion(), rovoAgentsPluginState?.isBrowseModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9096bdf9049f901$export$62821c88a7188481), {
        editorView: editorView,
        aiGlobalOptIn: aiOptIn,
        editorPluginAIProvider: editorPluginAIProvider,
        startingConfig: aiDecorationExperiencePluginState?.configItem,
        positions: rovoAgentsPluginState?.positions
    })));
};


const $ecbdd1db4b4fae37$export$d1314adfeea5c2b2 = (props)=>{
    const aiDecorationExperiencePluginState = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState);
    const modalMountedTimeStamp = aiDecorationExperiencePluginState?.modalMountedTimeStamp;
    /**
   * This is to detect the state of the Rovo prompt and loading screens
   * from RovoInlineChatPrompt used in RovoPromptScreenWithLogic,
   * as it does not respect the state value from XState.
   */ const [isRovoLoading, setIsRovoLoading] = (0, $42omo.useState)(false);
    /* reset the component when start AI again, so that the error boundary will also be reset */ return /*#__PURE__*/ $42omo.createElement((0, $2f86d52e78255595$export$214e018fc3e147ea), null, /*#__PURE__*/ $42omo.createElement((0, $3a58a391c8755141$export$9bdba9f1d1439b59), {
        value: {
            ...props,
            isRovoLoading: isRovoLoading,
            setIsRovoLoading: setIsRovoLoading
        }
    }, /*#__PURE__*/ $42omo.createElement((0, $995b21245e04b22e$export$2dda1e4a1d1f6a81), {
        key: modalMountedTimeStamp
    })));
};










var $3ZqD0 = parcelRequire("3ZqD0");





function $124112c4faaee370$export$f3e5bb240cf24df5({ configItems: configItems, formatMessage: formatMessage, aiGlobalOptIn: aiGlobalOptIn, editorView: editorView, locale: locale }) {
    const aiPriorities = 9000;
    const dispatch = editorView.dispatch;
    return configItems.map((configItem)=>({
            priority: configItem.quickInsertPriority ?? aiPriorities,
            categories: [
                'AI'
            ],
            title: (0, $c2200b5407d4af9f$export$d97f37f32ae9d000)(configItem, formatMessage),
            description: formatMessage(configItem.description || configItem.title),
            keywords: [
                'ai',
                'generate',
                'rovo',
                (0, $c2200b5407d4af9f$export$d97f37f32ae9d000)(configItem, formatMessage)
            ],
            icon: ()=>{
                return configItem.icon ? configItem.icon({
                    formatMessage: formatMessage
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ZqD0.default), {
                    label: "",
                    size: "small"
                });
            },
            action: (insert, editorState)=>{
                // We set the openAIModalCommand to run on the next tick -- as it then
                // performs additional transactions to update the document
                requestAnimationFrame(()=>{
                    const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
                        state: editorView.state,
                        configItem: configItem,
                        lastTriggeredFrom: 'quickInsert',
                        aiGlobalOptIn: aiGlobalOptIn,
                        locale: locale
                    });
                    openAIModalCommand(editorView.state, dispatch);
                });
                // Insert empty string to remove the typeahead raw text
                // close the quick insert immediately
                const transaction = insert('');
                return transaction;
            },
            isDisabledOffline: true
        }));
}






var $91bcx = parcelRequire("91bcx");




































var $gzUv9 = parcelRequire("gzUv9");

var $biAkr = parcelRequire("biAkr");

var $cPCP8 = parcelRequire("cPCP8");


var $kDB94 = parcelRequire("kDB94");

var $6UWPx = parcelRequire("6UWPx");

var $48SU7 = parcelRequire("48SU7");


var $cf8NL = parcelRequire("cf8NL");


var $lW0cT = parcelRequire("lW0cT");


var $lAFHW = parcelRequire("lAFHW");

















var $iBSwI = parcelRequire("iBSwI");

/* toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $iyDxB = parcelRequire("iyDxB");







var $bpQiY = parcelRequire("bpQiY");















var $4Chin = parcelRequire("4Chin");

var $4Dsx2 = parcelRequire("4Dsx2");
















var $oeZjt = parcelRequire("oeZjt");

var $j398X = parcelRequire("j398X");

var $iulqN = parcelRequire("iulqN");

var $9J8UT = parcelRequire("9J8UT");



var $j8LwF = parcelRequire("j8LwF");

var $eugUs = parcelRequire("eugUs");

var $cH4SO = parcelRequire("cH4SO");

var $dLjaJ = parcelRequire("dLjaJ");

var $3tLv0 = parcelRequire("3tLv0");

var $EJKmu = parcelRequire("EJKmu");



parcelRequire("42omo");




const $5ffb15ca4586b021$export$e350497c7f50f900 = ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });




var $aro2m = parcelRequire("aro2m");

var $7ERUE = parcelRequire("7ERUE");



var $2GVu1 = parcelRequire("2GVu1");

var $bTiiT = parcelRequire("bTiiT");

var $5v3PK = parcelRequire("5v3PK");

var $87Gms = parcelRequire("87Gms");

var $iIVVb = parcelRequire("iIVVb");


var $cbtR4 = parcelRequire("cbtR4");


var $8tSmd = parcelRequire("8tSmd");

















var $abUsF = parcelRequire("abUsF");











var $l5nYy = parcelRequire("l5nYy");



















const $ec6521fa80869090$export$80f4f0d1d6bfe69e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15 6H9C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15 9H9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11 12H9C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7 4V20H17V4H7ZM5 3.99C5 2.892 5.897 2 7.006 2H16.994C18.102 2 19 2.898 19 3.99V20.01C19 21.109 18.103 22 16.994 22H7.006C6.4765 22.0008 5.96822 21.7919 5.59231 21.419C5.21639 21.0461 5.00344 20.5395 5 20.01V3.99Z"
    }));
};











const $abc1f7db1c607172$var$getIssueType = (issueType)=>{
    switch(issueType){
        case 'bug':
            return 'Bug';
        case 'story':
            return 'Story';
        case 'epic':
            return 'Epic';
        case 'task':
        default:
            return 'Task'; // Default to 'Task' if issueType is not recognized
    }
};
const $abc1f7db1c607172$export$74b0275d64d18c50 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).ADD_STRUCTURE,
        title: (0, $AMCQl.aiConfigItemMessages).improveDescription,
        description: (0, $AMCQl.aiConfigItemMessages).reformatWithTemplateDescription,
        icon: ({ formatMessage: formatMessage })=>options.isInDocumentStreamingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))), {
                label: formatMessage((0, $AMCQl.aiConfigItemMessages).improveDescription),
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ec6521fa80869090$export$80f4f0d1d6bfe69e), null),
        endpoint: (0, $klIiV.jiraIssueReformatterApiURL),
        experienceId: 'issue-reformatter',
        intentSchemaId: 'issue_reformatter_intent_schema.json',
        featureId: 'issue_reformatter',
        alwaysNeedDoc: true,
        getRequestPayload: ({ locale: locale, doc: doc })=>{
            // additional props come from Issue View
            const additionalProps = options.getAdditionalProps?.() || {};
            const { issue_summary: issue_summary, project_id: project_id, issue_type_label: issue_type_label, linked_urls: linked_urls, linked_confluence_page_urls: linked_confluence_page_urls } = additionalProps;
            // Only include Confluence page URLs if feature gate is enabled
            // Note: Feature gate check must be last to ensure exposure tracking
            const shouldIncludeConfluenceUrls = linked_confluence_page_urls && linked_confluence_page_urls.length > 0 && (0, $dh538.fg)('linked_confluence_page_context_enabled');
            // all context is required except linked_urls and linked_confluence_page_urls
            const context = {
                project_id: project_id,
                summary: issue_summary,
                description: doc,
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                ...{
                    links: linked_urls
                } ?? [],
                // Add linked_confluence_page_urls to context only if feature gate is enabled
                ...shouldIncludeConfluenceUrls ? {
                    linked_confluence_page_urls: linked_confluence_page_urls
                } : {}
            };
            const issue_type = $abc1f7db1c607172$var$getIssueType(issue_type_label);
            // see https://hello.atlassian.net/wiki/spaces/AIDO/pages/5306581134/PWDC+Issue+Reformatter+API+Contracts
            const ai_feature_input = {
                source: 'JIRA',
                locale: locale,
                context: context,
                response_type: 'NO_SCHEMA',
                suggested_issues_config: {
                    use_template: true,
                    max_issues: 1,
                    suggested_issue_field_types: [
                        {
                            issue_type: issue_type,
                            fields: [
                                {
                                    field_name: 'Description',
                                    field_type: 'Paragraph'
                                }
                            ]
                        }
                    ]
                }
            };
            return {
                ai_feature_input: ai_feature_input
            };
        },
        actions: {
            empty: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>'assistance-service'
    });
const $abc1f7db1c607172$export$b8d167b10029e62f = (options)=>({
        config: $abc1f7db1c607172$export$74b0275d64d18c50(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });



var $2KJU8 = parcelRequire("2KJU8");


var $96Uu5 = parcelRequire("96Uu5");


var $kOMDA = parcelRequire("kOMDA");


var $6PN31 = parcelRequire("6PN31");


var $8vIZB = parcelRequire("8vIZB");

/**
 * What this file does:
 * It's a helper "component" to render AI sections based on the page mode
 * i.e live view mode or live edit mode
 */ 








const $d8acc5c15465fa66$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $d8acc5c15465fa66$export$f5cfdae51cfc6704 = ({ api: api, children: children, hasSeparator: hasSeparator })=>{
    const { editorViewMode: editorViewMode } = $d8acc5c15465fa66$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit' || editorViewMode === undefined;
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
        hasSeparator: hasSeparator
    }, children);
};
const $d8acc5c15465fa66$export$b6c70219ecf96242 = ({ api: api, children: children, hasSeparator: hasSeparator })=>{
    const { editorViewMode: editorViewMode } = $d8acc5c15465fa66$var$usePluginState(api);
    const isView = editorViewMode === 'view';
    if (!isView) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
        hasSeparator: hasSeparator
    }, children);
};








const $5f8c803dcf17d4c9$export$3a340db26fb18948 = ({ api: api, state: state, enabled: enabled, actionSubjectId: actionSubjectId })=>{
    (0, $42omo.useEffect)(()=>{
        if (!enabled || !state) return;
        const { charCount: charCount, wordCount: wordCount } = (0, $4SGh1.selectionCharWordCount)(state);
        (0, $4SGh1.fireButtonViewedAnalyticsEvent)({
            api: api,
            actionSubjectId: actionSubjectId,
            attributes: {
                selectionCharCount: charCount,
                selectionWordCount: wordCount
            }
        });
    }, [
        actionSubjectId,
        api,
        enabled,
        state
    ]);
};


const $15e4cd2cdf37fbe6$var$rovoButtonStyles = {
    container: "_d4lfxy5q"
};
const $15e4cd2cdf37fbe6$var$RovoSplitButtonWrapper = ({ isNewToolbarEnabled: isNewToolbarEnabled, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, children: children })=>!isNewToolbarEnabled && isInDocumentStreamingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: $15e4cd2cdf37fbe6$var$rovoButtonStyles.container
    }, children) : children; // Component for Primary Toolbar AI Section with conditional rendering
const $15e4cd2cdf37fbe6$var$PrimaryToolbarAISection = ({ api: api, children: children, editorAppearance: editorAppearance, hasSeparator: hasSeparator = false })=>{
    const { editorAppearance: currentAppearance } = (0, $gzUv9.useEditorToolbar)(); // Only show for the specified editor appearance
    if (currentAppearance !== editorAppearance) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8acc5c15465fa66$export$f5cfdae51cfc6704), {
        api: api,
        hasSeparator: hasSeparator ? (0, $48SU7.SeparatorPosition).END : undefined
    }, children);
};
const $15e4cd2cdf37fbe6$var$useIsOffline = (api)=>{
    const { disabled: disabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], ({ connectivityState: connectivityState })=>(0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? {
            disabled: (0, $91bcx.isOfflineMode)(connectivityState?.mode)
        } : {
            disabled: false
        });
    return disabled;
};
const $15e4cd2cdf37fbe6$var$RovoButton = ({ aiGlobalOptIn: aiGlobalOptIn, isNewToolbarEnabled: isNewToolbarEnabled, editorPluginAIProvider: { baseGenerate: baseGenerate, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled }, parents: parents, api: api })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const isDisabled = $15e4cd2cdf37fbe6$var$useIsOffline(api);
    const { editorView: editorView, editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)(); // This component gets registered twice, once for the full size toolbar and once for the display small toolbar
    // We need to exclude the display small toolbar from the analytics to prevent double counting
    const onDisplaySmall = parents.some((parent)=>parent.key === (0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).key);
    (0, $5f8c803dcf17d4c9$export$3a340db26fb18948)({
        api: api,
        state: editorView?.state,
        enabled: isInDocumentStreamingEnabled && !onDisplaySmall,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_ASK_ROVO_BUTTON
    });
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    const metaKey = browser.mac ? "\u2318" : 'Ctrl';
    const onPrimaryToolbar = parents.at(0)?.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR;
    let buttonTitle = ''; // Determine button title based on toolbar location and editor appearance
    if (onPrimaryToolbar) // Primary toolbar: Only show "Write" text in full-page editor when AIFC patch beta is enabled
    {
        if (editorAppearance === 'full-page' && isInDocumentStreamingEnabled) buttonTitle = formatMessage((0, $SFzFl.default).aiUniversalShortCallToAction);
         // For comment editor or when AIFC patch beta is disabled, show no text
    } else // Inline/floating toolbar: Always show "Ask Rovo" text
    buttonTitle = formatMessage((0, $7ShCl.aiMessages).askRovoToolbarIconTitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoSplitButtonWrapper, {
        isNewToolbarEnabled: isNewToolbarEnabled,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: (0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true) ? formatMessage((0, $7ShCl.aiMessages).askRovoToolbarIconTooltipQuickCommand, {
            key: metaKey
        }) : formatMessage((0, $7ShCl.aiMessages).askRovoToolbarIconTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9J8UT.AIChatIcon), {
            label: formatMessage((0, $7ShCl.aiMessages).askRovoToolbarIconTitle)
        }),
        testId: "editor-toolbar__ask-rovo",
        isDisabled: isDisabled,
        onClick: (event)=>{
            if (!editorView) return;
            const isKeyboardTrigger = event?.nativeEvent?.detail === 0;
            const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click'; // Fire analytics event for button click
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_ASK_ROVO_BUTTON,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    inputMethod: (0, $4Dsx2.getInputMethodFromParentKeys)(parents)
                }
            });
            const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
                state: editorView.state,
                configItem: baseGenerate,
                lastTriggeredFrom: onPrimaryToolbar ? 'mainToolbar' : 'floatingToolbar',
                triggerMethod: triggerMethod,
                aiGlobalOptIn: aiGlobalOptIn,
                locale: locale
            });
            openAIModalCommand(editorView.state, editorView.dispatch);
        }
    }, buttonTitle)));
};
const $15e4cd2cdf37fbe6$var$AskRovoChatButton = ({ api: api, editorPluginAIProvider: editorPluginAIProvider })=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const { product: product } = editorPluginAIProvider;
    let selectedContentADF = (0, $b4emg.getEmptyADF)(); // convert the selected content to ADF
    const selectedContent = (0, $5SAOw.Fragment).from(editorView?.state.selection.content().content);
    if (selectedContent) {
        const doc = (0, $iyDxB.defaultSchema).nodes.doc.create({}, selectedContent);
        selectedContentADF = new (0, $h9yJL.JSONTransformer)().encode(doc);
    }
    const handleClickChat = ()=>{
        // set the selection to the end of the current selection to remove the selection toolbar
        if (editorView?.dispatch) {
            const tr = editorView.state.tr;
            tr.setSelection((0, $ks2lK.TextSelection).create(editorView.state.doc, Math.min(editorView.state.selection.to, editorView.state.doc.content.size)));
            editorView.dispatch(tr);
        }
        api?.core.actions.blur(); // open rovo chat with the selected content
        publish({
            type: 'chat-new',
            source: 'editor',
            product: product,
            data: {
                dialogues: []
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abUsF.RovoChatHighlightActions), {
        selectedContent: selectedContentADF,
        product: product.toLowerCase(),
        onClickChat: handleClickChat
    });
};
const $15e4cd2cdf37fbe6$export$4b24d5b721b89a5c = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const isInDocumentStreamingEnabled = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState.isInDocumentStreamingEnabled);
    (0, $5f8c803dcf17d4c9$export$3a340db26fb18948)({
        api: api,
        state: editorView?.state,
        enabled: isInDocumentStreamingEnabled,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_DEFINITIONS_DEFINE_BUTTON
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: formatMessage((0, $7ShCl.aiMessages).DefineDropdownIconTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        isDisabled: api?.aiDefinitions?.actions.selectionExceedsMaxWordCount() || false,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
            label: "",
            size: "small"
        }),
        onClick: ()=>{
            api?.aiDefinitions?.actions.openReadingAidsPopup();
        }
    }, formatMessage((0, $7ShCl.aiMessages).DefineDropdownIconTitle)));
}; // Reusable hero prompt button that extracts details from heroConfigItem
const $15e4cd2cdf37fbe6$export$9041c40b25483898 = ({ aiGlobalOptIn: aiGlobalOptIn, parents: parents, api: api, heroConfigItem: heroConfigItem })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const disabled = $15e4cd2cdf37fbe6$var$useIsOffline(api);
    const hasVisibleContent = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.hasVisibleContent);
    const isInDocumentStreamingEnabled = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState.isInDocumentStreamingEnabled);
    (0, $5f8c803dcf17d4c9$export$3a340db26fb18948)({
        api: api,
        state: editorView?.state,
        enabled: isInDocumentStreamingEnabled,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_HERO_PROMPT_BUTTON
    });
    const configItem = heroConfigItem.config;
    const title = formatMessage(configItem.title);
    const name = configItem.key.toLowerCase().split('_').join('-').split(' ').join('-');
    const testId = `editor-toolbar__${name}`;
    const enabledOnEmptyDoc = heroConfigItem.triggers.empty.docMinSize === 0 && heroConfigItem.triggers.empty.enabled;
    const isSuggestReplyConfigItemEnabled = heroConfigItem.config.key === (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_RESPONSE && (0, $dh538.fg)('draft_reply_contextual_pills_gate');
    let isDisabled = disabled || !hasVisibleContent;
    if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) isDisabled = disabled || !hasVisibleContent && !enabledOnEmptyDoc;
     // Specific to JSM - Suggest Reply Hero Prompt
    if (isSuggestReplyConfigItemEnabled) isDisabled = disabled || !!hasVisibleContent;
    const onPrimaryToolbar = parents.at(0)?.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR;
    const IconComponent = configItem.icon ? configItem.icon({
        formatMessage: formatMessage
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        isDisabled: isDisabled,
        iconBefore: IconComponent,
        testId: testId,
        onClick: (event)=>{
            if (!editorView) return;
            const lastTriggeredFrom = onPrimaryToolbar ? 'mainToolbar' : 'floatingToolbar';
            const isKeyboardTrigger = event?.nativeEvent?.detail === 0;
            const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click';
            const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
                state: editorView.state,
                configItem: configItem,
                lastTriggeredFrom: lastTriggeredFrom,
                triggerMethod: triggerMethod,
                aiGlobalOptIn: aiGlobalOptIn,
                locale: locale
            });
            openAIModalCommand(editorView.state, editorView.dispatch);
        }
    }, title);
}; // Legacy version with conditional logic (will be removed when platform_editor_ai_aifc_streaming is cleaned up)
const $15e4cd2cdf37fbe6$export$2df6fac7793eedd9 = ({ aiGlobalOptIn: aiGlobalOptIn, parents: parents, shouldShowImproveDescription: shouldShowImproveDescription, getAdditionalProps: getAdditionalProps, api: api })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const disabled = $15e4cd2cdf37fbe6$var$useIsOffline(api);
    const hasVisibleContent = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.hasVisibleContent);
    const isInDocumentStreamingEnabled = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState.isInDocumentStreamingEnabled);
    (0, $5f8c803dcf17d4c9$export$3a340db26fb18948)({
        api: api,
        state: editorView?.state,
        enabled: isInDocumentStreamingEnabled,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_HERO_PROMPT_BUTTON
    });
    const onPrimaryToolbar = parents.at(0)?.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR;
    const onJiraDescriptionPrimaryToolbar = shouldShowImproveDescription && onPrimaryToolbar;
    const title = formatMessage(onJiraDescriptionPrimaryToolbar ? (0, $AMCQl.aiConfigItemMessages).improveDescription : (0, $7ShCl.aiMessages).improveWritingToolbarIconTitle);
    const testId = onJiraDescriptionPrimaryToolbar ? 'editor-toolbar__improve-description' : 'editor-toolbar__improve-writing';
    const isDisabled = disabled || !hasVisibleContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        isDisabled: isDisabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))), {
            label: title,
            size: "small"
        }),
        testId: testId,
        onClick: (event)=>{
            if (!editorView) return;
            const configItem = onJiraDescriptionPrimaryToolbar ? (0, $abc1f7db1c607172$export$74b0275d64d18c50)({
                getAdditionalProps: getAdditionalProps
            }) : (0, $iBSwI.improveWriting)();
            const lastTriggeredFrom = onPrimaryToolbar ? 'mainToolbar' : 'floatingToolbar';
            const isKeyboardTrigger = event?.nativeEvent?.detail === 0;
            const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click';
            const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
                state: editorView.state,
                configItem: configItem,
                lastTriggeredFrom: lastTriggeredFrom,
                triggerMethod: triggerMethod,
                aiGlobalOptIn: aiGlobalOptIn,
                locale: locale
            });
            openAIModalCommand(editorView.state, editorView.dispatch);
        }
    }, title);
};
const $15e4cd2cdf37fbe6$var$RovoMenu = ({ children: children, isNewToolbarEnabled: isNewToolbarEnabled, api: api, parents: parents, testId: testId, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const hasVisibleContent = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.hasVisibleContent);
    const disabled = $15e4cd2cdf37fbe6$var$useIsOffline(api);
    const isDisabled = disabled || !hasVisibleContent;
    const onClick = (_event, isOpen)=>{
        if (!editorView) return;
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_MORE_ROVO_OPTIONS,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                inputMethod: (0, $4Dsx2.getInputMethodFromParentKeys)(parents),
                opened: isOpen
            }
        });
    };
    if ((0, $1oCLl.expValEquals)('platform_editor_hide_toolbar_tooltips_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoSplitButtonWrapper, {
        isNewToolbarEnabled: isNewToolbarEnabled,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5v3PK.ToolbarDropdownMenuProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bTiiT.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $EJKmu.MoreItemsIcon), {
            label: formatMessage((0, $7ShCl.aiMessages).moreRovoOptionsMenuLabel)
        }),
        testId: testId ?? 'editor-toolbar__ask-rovo-menu',
        isDisabled: isDisabled,
        onClick: onClick,
        tooltipComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: formatMessage((0, $7ShCl.aiMessages).moreRovoOptionsMenuLabel)
        })
    }, children)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoSplitButtonWrapper, {
        isNewToolbarEnabled: isNewToolbarEnabled,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5v3PK.ToolbarDropdownMenuProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bTiiT.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $EJKmu.MoreItemsIcon), {
            label: formatMessage((0, $7ShCl.aiMessages).moreRovoOptionsMenuLabel)
        }),
        testId: testId ?? 'editor-toolbar__ask-rovo-menu',
        isDisabled: isDisabled,
        onClick: onClick
    }, children)));
};
const $15e4cd2cdf37fbe6$var$RovoPromptNestedMenu = ({ itemKey: itemKey, icon: icon, messageDescriptor: messageDescriptor, children: children, api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const Icon = icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $87Gms.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            size: "small",
            label: formatMessage(messageDescriptor)
        }),
        text: formatMessage(messageDescriptor),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ffb15ca4586b021$export$e350497c7f50f900), {
            label: formatMessage(messageDescriptor)
        }),
        testId: `dropdown-item__${itemKey}`,
        onClick: ()=>{
            const actionSubjectId = itemKey === (0, $cPCP8.CHANGE_TONE_NESTED_MENU).key ? (0, $d925B.ACTION_SUBJECT_ID).AI_CHANGE_TONE : itemKey === (0, $cPCP8.TRANSLATE_NESTED_MENU).key ? (0, $d925B.ACTION_SUBJECT_ID).AI_TRANSLATE : undefined;
            if (!actionSubjectId) return;
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR_DROPDOWN_MENU_ITEM,
                actionSubjectId: actionSubjectId,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    inputMethod: (0, $4Dsx2.getInputMethodFromParentKeys)(parents)
                }
            });
        }
    }, children);
};
const $15e4cd2cdf37fbe6$var$RovoPromptItem = ({ api: api, aiGlobalOptIn: aiGlobalOptIn, itemKey: itemKey, icon: icon, messageDescriptor: messageDescriptor, configItem: configItem, parents: parents, onClick: onClick })=>{
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const isDisabled = $15e4cd2cdf37fbe6$var$useIsOffline(api);
    const Icon = icon;
    const onPrimaryToolbar = parents.at(0)?.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            size: "small",
            label: formatMessage(messageDescriptor)
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null),
        testId: `dropdown-item__${itemKey}`,
        isDisabled: isDisabled,
        onClick: (event)=>{
            if (onClick) return onClick();
            if (!editorView) return;
            const isKeyboardTrigger = event?.nativeEvent?.detail === 0;
            const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click';
            const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
                state: editorView.state,
                configItem: configItem,
                lastTriggeredFrom: onPrimaryToolbar ? 'primaryToolbar' : 'floatingToolbar',
                triggerMethod: triggerMethod,
                aiGlobalOptIn: aiGlobalOptIn,
                locale: locale
            });
            openAIModalCommand(editorView.state, editorView.dispatch);
        }
    }, formatMessage(messageDescriptor));
};
const $15e4cd2cdf37fbe6$export$611b6feb29f5c606 = ({ editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, shouldShowImproveDescription: shouldShowImproveDescription, getAdditionalProps: getAdditionalProps, isNewToolbarEnabled: isNewToolbarEnabled, api: api })=>{
    const breakpointPreset = api?.toolbar?.actions.getBreakpointPreset();
    return [
        // AI SECTION
        {
            type: (0, $cPCP8.AI_SECTION).type,
            key: (0, $cPCP8.AI_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.AI_SECTION).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8acc5c15465fa66$export$f5cfdae51cfc6704), {
                    api: api,
                    hasSeparator: (0, $48SU7.SeparatorPosition).END
                }, children)
        },
        // AI SECTION FOR FULL PAGE PRIMARY TOOLBAR
        {
            type: (0, $cPCP8.AI_SECTION).type,
            key: (0, $cPCP8.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
            parents: [
                ...!editorPluginAIProvider.hidePrimaryToolbarButton && !editorPluginAIProvider.isInDocumentStreamingEnabled && // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                !(!editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true)) ? [
                    {
                        type: 'toolbar',
                        key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                        rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.AI_SECTION).key]
                    }
                ] : []
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$PrimaryToolbarAISection, {
                    api: api,
                    editorAppearance: "full-page"
                }, children)
        },
        // AI SECTION FOR COMMENT PRIMARY TOOLBAR
        {
            type: (0, $cPCP8.AI_SECTION).type,
            key: (0, $cPCP8.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
            parents: [
                ...!editorPluginAIProvider.hidePrimaryToolbarButton ? [
                    {
                        type: 'toolbar',
                        key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                        rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.AI_SECTION).key]
                    }
                ] : []
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$PrimaryToolbarAISection, {
                    api: api,
                    editorAppearance: "comment"
                }, children)
        },
        // AI SECTION FOR FULL PAGE PRIMARY TOOLBAR AIFC (only Rovo button with "Write")
        {
            type: (0, $cPCP8.AI_SECTION_PRIMARY_TOOLBAR).type,
            key: (0, $cPCP8.AI_SECTION_PRIMARY_TOOLBAR).key,
            parents: [
                // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                ...!editorPluginAIProvider.hidePrimaryToolbarButton && editorPluginAIProvider.isInDocumentStreamingEnabled && // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                !(!editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true)) ? [
                    {
                        type: 'toolbar',
                        key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                        rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.AI_SECTION).key]
                    }
                ] : []
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$PrimaryToolbarAISection, {
                    api: api,
                    editorAppearance: "full-page",
                    hasSeparator: true
                }, children)
        },
        // AI VIEW SECTION
        {
            type: (0, $cPCP8.AI_VIEW_SECTION).type,
            key: (0, $cPCP8.AI_VIEW_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.AI_VIEW_SECTION).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8acc5c15465fa66$export$b6c70219ecf96242), {
                    api: api,
                    hasSeparator: (0, $48SU7.SeparatorPosition).END
                }, children)
        },
        {
            type: (0, $cPCP8.AI_VIEW_SECTION).type,
            key: (0, $cPCP8.AI_VIEW_SECTION).key,
            parents: [
                ...editorPluginAIProvider.hidePrimaryToolbarButton ? [] : [
                    {
                        type: 'toolbar',
                        key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                        rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.AI_VIEW_SECTION).key]
                    }
                ]
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8acc5c15465fa66$export$b6c70219ecf96242), {
                    api: api
                }, children)
        },
        // ROVO GROUP
        {
            type: (0, $cPCP8.ROVO_GROUP).type,
            key: (0, $cPCP8.ROVO_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION).key,
                    // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                    rank: !editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true) ? 400 : (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.ROVO_GROUP).key]
                },
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.ROVO_GROUP).key]
                },
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.ROVO_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
                    above: breakpointPreset === 'jsm-comment' ? 'sm' : 'lg'
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children))
        },
        // ROVO GROUP DISPLAY SMALL
        {
            type: (0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).type,
            key: (0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).key,
            parents: [
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).key]
                },
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).key]
                },
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
                    below: breakpointPreset === 'jsm-comment' ? 'sm' : 'lg'
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children))
        },
        // ROVO HERO BUTTON
        {
            type: (0, $cPCP8.ROVO_HERO_BUTTON).type,
            key: (0, $cPCP8.ROVO_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_GROUP).type,
                    key: (0, $cPCP8.ROVO_GROUP).key,
                    rank: (0, $4Chin.ROVO_GROUP_RANK)[(0, $cPCP8.ROVO_HERO_BUTTON).key]
                },
                {
                    type: (0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).type,
                    key: (0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).key,
                    rank: (0, $4Chin.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $cPCP8.ROVO_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoButton, {
                    editorPluginAIProvider: editorPluginAIProvider,
                    aiGlobalOptIn: aiGlobalOptIn,
                    parents: parents,
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    api: api
                })
        },
        // ROVO GROUP FOR PRIMARY TOOLBAR AIFC
        {
            type: (0, $cPCP8.ROVO_GROUP_PRIMARY_TOOLBAR).type,
            key: (0, $cPCP8.ROVO_GROUP_PRIMARY_TOOLBAR).key,
            parents: [
                {
                    type: (0, $cPCP8.AI_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.AI_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.ROVO_GROUP_PRIMARY_TOOLBAR).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children)
        },
        {
            type: (0, $cPCP8.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).type,
            key: (0, $cPCP8.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_GROUP_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.ROVO_GROUP_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.ROVO_GROUP_RANK)[(0, $cPCP8.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoButton, {
                    editorPluginAIProvider: editorPluginAIProvider,
                    aiGlobalOptIn: aiGlobalOptIn,
                    parents: parents,
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    api: api
                })
        },
        {
            type: (0, $cPCP8.ROVO_MENU).type,
            key: (0, $cPCP8.ROVO_MENU).key,
            parents: [
                // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                ...!editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true) ? [] : [
                    {
                        type: (0, $cPCP8.ROVO_GROUP).type,
                        key: (0, $cPCP8.ROVO_GROUP).key,
                        rank: (0, $4Chin.ROVO_GROUP_RANK)[(0, $cPCP8.ROVO_MENU).key]
                    }
                ]
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoMenu, {
                    api: api,
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled,
                    parents: parents,
                    testId: "editor-toolbar__ask-rovo-menu"
                }, children)
        },
        {
            type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).type,
            key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_MENU).type,
                    key: (0, $cPCP8.ROVO_MENU).key,
                    rank: (0, $4Chin.ROVO_MENU_RANK)[(0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key]
                }
            ]
        },
        // ROVO MENU DISPLAY SMALL + MENU SECTION
        {
            type: (0, $cPCP8.ROVO_MENU_DISPLAY_SMALL).type,
            key: (0, $cPCP8.ROVO_MENU_DISPLAY_SMALL).key,
            parents: [
                // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                ...!editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true) ? [] : [
                    {
                        type: (0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).type,
                        key: (0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).key,
                        rank: (0, $4Chin.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $cPCP8.ROVO_MENU_DISPLAY_SMALL).key]
                    }
                ]
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoMenu, {
                    api: api,
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    parents: parents,
                    testId: "editor-toolbar__ask-rovo-menu-display-small"
                }, children)
        },
        {
            type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
            key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_MENU_DISPLAY_SMALL).type,
                    key: (0, $cPCP8.ROVO_MENU_DISPLAY_SMALL).key,
                    rank: (0, $4Chin.ROVO_MENU_RANK)[(0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key]
                }
            ]
        },
        // FROM HERE ONWARDS ARE MENU ITEMS
        ...editorPluginAIProvider.heroConfigItem && editorPluginAIProvider.isInDocumentStreamingEnabled ? [
            // New dynamic implementation: uses heroConfigItem
            {
                type: (0, $cPCP8.HERO_PROMPT_MENU_ITEM).type,
                key: (0, $cPCP8.HERO_PROMPT_MENU_ITEM).key,
                parents: [
                    {
                        type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                        key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                        rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.HERO_PROMPT_MENU_ITEM).key]
                    }
                ],
                component: ({ parents: parents })=>{
                    if (!editorPluginAIProvider.heroConfigItem) return null;
                    const configItem = editorPluginAIProvider.heroConfigItem.config;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                        api: api,
                        aiGlobalOptIn: aiGlobalOptIn,
                        itemKey: (0, $cPCP8.HERO_PROMPT_MENU_ITEM).key,
                        icon: $15e4cd2cdf37fbe6$var$createHeroPromptIcon(configItem),
                        messageDescriptor: configItem.title,
                        configItem: configItem,
                        parents: parents
                    });
                }
            }
        ] : editorPluginAIProvider.isInDocumentStreamingEnabled ? [
            // Previous implementation: hardcoded improve writing
            {
                type: (0, $cPCP8.IMPROVE_WRITING_MENU_ITEM).type,
                key: (0, $cPCP8.IMPROVE_WRITING_MENU_ITEM).key,
                parents: [
                    {
                        type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                        key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                        rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.IMPROVE_WRITING_MENU_ITEM).key]
                    }
                ],
                component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                        api: api,
                        aiGlobalOptIn: aiGlobalOptIn,
                        itemKey: (0, $cPCP8.IMPROVE_WRITING_MENU_ITEM).key,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))),
                        messageDescriptor: (0, $7ShCl.aiMessages).improveWritingToolbarIconTitle,
                        configItem: (0, $iBSwI.improveWriting)(),
                        parents: parents
                    })
            }
        ] : [],
        {
            type: (0, $cPCP8.SPELLING_AND_GRAMMAR_MENU_ITEM).type,
            key: (0, $cPCP8.SPELLING_AND_GRAMMAR_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.SPELLING_AND_GRAMMAR_MENU_ITEM).key]
                },
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.SPELLING_AND_GRAMMAR_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $cPCP8.SPELLING_AND_GRAMMAR_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dLjaJ))),
                    messageDescriptor: (0, $7ShCl.aiMessages).spellingAndGrammarToolbarDropdownIconTitle,
                    configItem: (0, $iBSwI.fixSpellingAndGrammar)(),
                    parents: parents
                })
        },
        {
            type: (0, $cPCP8.CHANGE_TONE_NESTED_MENU).type,
            key: (0, $cPCP8.CHANGE_TONE_NESTED_MENU).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.CHANGE_TONE_NESTED_MENU).key]
                },
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.CHANGE_TONE_NESTED_MENU).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptNestedMenu, {
                    itemKey: (0, $cPCP8.CHANGE_TONE_NESTED_MENU).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iulqN))),
                    messageDescriptor: (0, $7ShCl.aiMessages).changeToneToolbarDropdownIconTitle,
                    api: api,
                    parents: parents
                }, children)
        },
        {
            type: (0, $cPCP8.CHANGE_TONE_MENU_SECTION).type,
            key: (0, $cPCP8.CHANGE_TONE_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.CHANGE_TONE_NESTED_MENU).type,
                    key: (0, $cPCP8.CHANGE_TONE_NESTED_MENU).key,
                    rank: (0, $4Chin.CHANGE_TONE_MENU_RANK)[(0, $cPCP8.CHANGE_TONE_MENU_SECTION).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.MORE_PROFESSIONAL_MENU_ITEM).type,
            key: (0, $cPCP8.MORE_PROFESSIONAL_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.CHANGE_TONE_MENU_SECTION).type,
                    key: (0, $cPCP8.CHANGE_TONE_MENU_SECTION).key,
                    rank: (0, $4Chin.CHANGE_TONE_MENU_SECTION_RANK)[(0, $cPCP8.MORE_PROFESSIONAL_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $cPCP8.MORE_PROFESSIONAL_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))),
                    messageDescriptor: (0, $7ShCl.aiMessages).moreProfessionalToneToolbarDropdownIconTitle,
                    configItem: (0, $l5nYy.changeToneToProfessional)(),
                    parents: parents
                })
        },
        {
            type: (0, $cPCP8.MORE_CASUAL_MENU_ITEM).type,
            key: (0, $cPCP8.MORE_CASUAL_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.CHANGE_TONE_MENU_SECTION).type,
                    key: (0, $cPCP8.CHANGE_TONE_MENU_SECTION).key,
                    rank: (0, $4Chin.CHANGE_TONE_MENU_SECTION_RANK)[(0, $cPCP8.MORE_CASUAL_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $cPCP8.MORE_CASUAL_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($j398X))),
                    messageDescriptor: (0, $7ShCl.aiMessages).moreCasualToneToolbarDropdownIconTitle,
                    configItem: (0, $l5nYy.changeToneToCasual)(),
                    parents: parents
                })
        },
        {
            type: (0, $cPCP8.MORE_EMPATHETIC_MENU_ITEM).type,
            key: (0, $cPCP8.MORE_EMPATHETIC_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.CHANGE_TONE_MENU_SECTION).type,
                    key: (0, $cPCP8.CHANGE_TONE_MENU_SECTION).key,
                    rank: (0, $4Chin.CHANGE_TONE_MENU_SECTION_RANK)[(0, $cPCP8.MORE_EMPATHETIC_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $cPCP8.MORE_EMPATHETIC_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($j8LwF))),
                    messageDescriptor: (0, $7ShCl.aiMessages).moreEmpatheticToneToolbarDropdownIconTitle,
                    configItem: (0, $l5nYy.changeToneToEmpathetic)(),
                    parents: parents
                })
        },
        {
            type: (0, $cPCP8.MAKE_SHORTER_MENU_ITEM).type,
            key: (0, $cPCP8.MAKE_SHORTER_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.MAKE_SHORTER_MENU_ITEM).key]
                },
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.MAKE_SHORTER_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $cPCP8.MAKE_SHORTER_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($cH4SO))),
                    messageDescriptor: (0, $7ShCl.aiMessages).makeShorterToolbarDropdownIconTitle,
                    configItem: (0, $96Uu5.makeShorter)(),
                    parents: parents
                })
        },
        {
            type: (0, $cPCP8.MAKE_LONGER_MENU_ITEM).type,
            key: (0, $cPCP8.MAKE_LONGER_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.MAKE_LONGER_MENU_ITEM).key]
                },
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.MAKE_LONGER_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $cPCP8.MAKE_LONGER_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eugUs))),
                    messageDescriptor: (0, $7ShCl.aiMessages).makeLongerToolbarDropdownIconTitle,
                    configItem: (0, $2KJU8.makeLonger)(),
                    parents: parents
                })
        },
        {
            type: (0, $cPCP8.TRANSLATE_NESTED_MENU).type,
            key: (0, $cPCP8.TRANSLATE_NESTED_MENU).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.TRANSLATE_NESTED_MENU).key]
                },
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.TRANSLATE_NESTED_MENU).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptNestedMenu, {
                    itemKey: (0, $cPCP8.TRANSLATE_NESTED_MENU).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3tLv0))),
                    messageDescriptor: (0, $7ShCl.aiMessages).translateOptionsIconLabel,
                    api: api,
                    parents: parents
                }, children)
        },
        {
            type: (0, $cPCP8.TRANSLATE_MENU_SECTION).type,
            key: (0, $cPCP8.TRANSLATE_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.TRANSLATE_NESTED_MENU).type,
                    key: (0, $cPCP8.TRANSLATE_NESTED_MENU).key,
                    rank: (0, $4Chin.TRANSLATE_MENU_RANK)[(0, $cPCP8.TRANSLATE_MENU_SECTION).key]
                }
            ]
        },
        // Dynamic translation language menu items
        ...$15e4cd2cdf37fbe6$var$getTranslationLanguagesToolbarItems(api, aiGlobalOptIn),
        // DEFINE MENU ITEM
        ...editorPluginAIProvider.isInDocumentStreamingEnabled ? [
            {
                type: (0, $cPCP8.DEFINE_MENU_ITEM).type,
                key: (0, $cPCP8.DEFINE_MENU_ITEM).key,
                parents: [
                    {
                        type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).type,
                        key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key,
                        rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.DEFINE_MENU_ITEM).key]
                    },
                    {
                        type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                        key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                        rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.DEFINE_MENU_ITEM).key]
                    }
                ],
                component: ({ parents: parents })=>{
                    if (!Boolean(api?.aiDefinitions) && (0, $dh538.fg)('platform_editor_ai_conditional_define_item')) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                        api: api,
                        aiGlobalOptIn: aiGlobalOptIn,
                        itemKey: (0, $cPCP8.DEFINE_MENU_ITEM).key,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))),
                        messageDescriptor: (0, $7ShCl.aiMessages).DefineDropdownIconTitle,
                        onClick: ()=>{
                            api?.aiDefinitions?.actions.openReadingAidsPopup();
                        },
                        parents: parents
                    });
                }
            }
        ] : [],
        // HERO BUTTON (with its own group based on heroConfigItem or legacy implementation)
        ...isNewToolbarEnabled && editorPluginAIProvider.heroConfigItem && (editorPluginAIProvider.isInDocumentStreamingEnabled || (0, $dh538.fg)('draft_reply_contextual_pills_gate')) ? [
            // New dynamic implementation: uses heroConfigItem
            {
                type: (0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).type,
                key: (0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key,
                parents: [
                    {
                        type: (0, $cPCP8.AI_SECTION).type,
                        key: (0, $cPCP8.AI_SECTION).key,
                        rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key]
                    },
                    {
                        type: (0, $cPCP8.AI_SECTION).type,
                        key: (0, $cPCP8.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                        rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key]
                    },
                    {
                        type: (0, $cPCP8.AI_SECTION).type,
                        key: (0, $cPCP8.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                        rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key]
                    }
                ],
                component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
                        above: breakpointPreset === 'jsm-comment' ? 'sm' : 'lg'
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children))
            },
            {
                type: (0, $cPCP8.HERO_PROMPT_BUTTON).type,
                key: (0, $cPCP8.HERO_PROMPT_BUTTON).key,
                parents: [
                    {
                        type: (0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).type,
                        key: (0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key,
                        rank: (0, $4Chin.HERO_PROMPT_BUTTON_GROUP_RANK)[(0, $cPCP8.HERO_PROMPT_BUTTON).key]
                    }
                ],
                component: ({ parents: parents })=>editorPluginAIProvider.heroConfigItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$export$9041c40b25483898, {
                        aiGlobalOptIn: aiGlobalOptIn,
                        parents: parents,
                        api: api,
                        heroConfigItem: editorPluginAIProvider.heroConfigItem
                    }) : null
            }
        ] : isNewToolbarEnabled ? [
            {
                type: 'group',
                key: 'improve-writing-group',
                parents: [
                    {
                        type: (0, $cPCP8.AI_SECTION).type,
                        key: (0, $cPCP8.AI_SECTION).key,
                        rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.IMPROVE_WRITING_GROUP).key]
                    },
                    {
                        type: (0, $cPCP8.AI_SECTION).type,
                        key: (0, $cPCP8.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                        rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.IMPROVE_WRITING_GROUP).key]
                    },
                    {
                        type: (0, $cPCP8.AI_SECTION).type,
                        key: (0, $cPCP8.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                        rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.IMPROVE_WRITING_GROUP).key]
                    }
                ],
                component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
                        above: breakpointPreset === 'jsm-comment' ? 'sm' : 'lg'
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children))
            },
            {
                type: (0, $cPCP8.IMPROVE_WRITING_BUTTON).type,
                key: (0, $cPCP8.IMPROVE_WRITING_BUTTON).key,
                parents: [
                    {
                        type: (0, $cPCP8.IMPROVE_WRITING_GROUP).type,
                        key: (0, $cPCP8.IMPROVE_WRITING_GROUP).key,
                        rank: (0, $4Chin.IMPROVE_WRITING_GROUP_RANK)[(0, $cPCP8.IMPROVE_WRITING_BUTTON).key]
                    }
                ],
                component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$export$2df6fac7793eedd9, {
                        aiGlobalOptIn: aiGlobalOptIn,
                        parents: parents,
                        shouldShowImproveDescription: shouldShowImproveDescription,
                        getAdditionalProps: getAdditionalProps,
                        api: api
                    })
            }
        ] : [],
        {
            type: (0, $cPCP8.ROVO_GROUP_VIEW).type,
            key: (0, $cPCP8.ROVO_GROUP_VIEW).key,
            parents: [
                {
                    type: (0, $cPCP8.AI_VIEW_SECTION).type,
                    key: (0, $cPCP8.AI_VIEW_SECTION).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.ROVO_GROUP).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.ROVO_HERO_BUTTON).type,
            key: (0, $cPCP8.ROVO_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_GROUP_VIEW).type,
                    key: (0, $cPCP8.ROVO_GROUP_VIEW).key,
                    rank: (0, $4Chin.ROVO_GROUP_RANK)[(0, $cPCP8.ROVO_HERO_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$AskRovoChatButton, {
                    api: api,
                    editorPluginAIProvider: editorPluginAIProvider
                })
        },
        // DEFINE GROUP + DEFINE BUTTON
        {
            type: (0, $cPCP8.DEFINE_GROUP).type,
            key: (0, $cPCP8.DEFINE_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.AI_VIEW_SECTION).type,
                    key: (0, $cPCP8.AI_VIEW_SECTION).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.DEFINE_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                if (!Boolean(api?.aiDefinitions) && (0, $dh538.fg)('platform_editor_ai_conditional_define_item')) return null;
                return api?.aiDefinitions?.actions.selectionExceedsMaxWordCount() ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
                    above: "lg"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children));
            }
        },
        {
            type: (0, $cPCP8.DEFINE_BUTTON).type,
            key: (0, $cPCP8.DEFINE_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.DEFINE_GROUP).type,
                    key: (0, $cPCP8.DEFINE_GROUP).key,
                    rank: (0, $4Chin.DEFINE_GROUP_RANK)[(0, $cPCP8.DEFINE_BUTTON).key]
                }
            ],
            component: ()=>{
                if (!Boolean(api?.aiDefinitions) && (0, $dh538.fg)('platform_editor_ai_conditional_define_item')) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$export$4b24d5b721b89a5c, {
                    api: api
                });
            }
        },
        ...(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? [
            {
                type: (0, $cPCP8.ADD_POLISH_MENU_ITEM).type,
                key: (0, $cPCP8.ADD_POLISH_MENU_ITEM).key,
                parents: [
                    {
                        type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).type,
                        key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key,
                        rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.ADD_POLISH_MENU_ITEM).key]
                    },
                    {
                        type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                        key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                        rank: (0, $4Chin.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $cPCP8.ADD_POLISH_MENU_ITEM).key]
                    }
                ],
                component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                        api: api,
                        aiGlobalOptIn: aiGlobalOptIn,
                        itemKey: (0, $cPCP8.ADD_POLISH_MENU_ITEM).key,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cbtR4))),
                        messageDescriptor: (0, $AMCQl.aiConfigItemMessages).addPolishTitle,
                        configItem: (0, $kOMDA.addPolish)(),
                        parents: parents
                    })
            }
        ] : []
    ];
};
const $15e4cd2cdf37fbe6$var$getTranslationLanguagesToolbarItems = (api, aiGlobalOptIn)=>{
    const translationConfigItemsMap = (0, $6PN31.createTranslationConfigItems)();
    return (0, $8vIZB.getSortedSupportedTranslationLanguages)().map((lang, index)=>({
            type: 'menu-item',
            key: `${lang}-language-menu-item`,
            parents: [
                {
                    type: (0, $cPCP8.TRANSLATE_MENU_SECTION).type,
                    key: (0, $cPCP8.TRANSLATE_MENU_SECTION).key,
                    rank: (index + 1) * 100
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($15e4cd2cdf37fbe6$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: `${lang}-language-menu-item`,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3tLv0))),
                    messageDescriptor: (0, $bpQiY.aiLanguageMessages)[lang],
                    configItem: translationConfigItemsMap[lang],
                    parents: parents
                })
        }));
};
const $15e4cd2cdf37fbe6$var$createHeroPromptIcon = (configItem)=>{
    const IconComponent = Object.assign(()=>{
        const { formatMessage: formatMessage } = (0, $8C5kA.default)();
        if (configItem.icon) {
            const iconElement = configItem.icon({
                formatMessage: formatMessage
            });
            if (iconElement) return iconElement;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))), {
            label: formatMessage(configItem.title),
            size: "small"
        });
    }, {
        displayName: 'HeroPromptIcon'
    });
    return IconComponent;
};


const $e139379dc978801b$export$ef1d0b9899d7de5 = `ak-editor-ai-selection-toolbar-ai-button`;
const $e139379dc978801b$export$a3e7258dd93ab690 = ({ intl: intl, rangeBaseGenerate: rangeBaseGenerate, hideTitle: hideTitle, aiGlobalOptIn: aiGlobalOptIn, icon: icon, title: title, tooltip: tooltip, triggeredFor: triggeredFor, pulse: pulse, onMount: onMount, onClick: onClick, disabled: disabled })=>{
    let didMouseEnter = false;
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    const metaKey = browser.mac ? "\u2318" : 'Ctrl';
    const Icon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            size: "small"
        });
    return {
        type: 'button',
        isRadioButton: false,
        pulse: pulse,
        showTitle: true,
        testId: $e139379dc978801b$export$ef1d0b9899d7de5,
        icon: icon ?? Icon,
        ...!hideTitle && {
            title: intl.formatMessage(title ?? (0, $7ShCl.aiMessages).aiToolbarTitle)
        },
        ariaLabel: (0, $1oCLl.expValEquals)('platform_editor_drag_handle_aria_label', 'isEnabled', true) ? intl.formatMessage(title ?? (0, $7ShCl.aiMessages).aiToolbarTitle) : '',
        tooltipContent: intl.formatMessage(tooltip ?? (0, $SFzFl.default).aiUniversalShortCallToAction, {
            key: metaKey
        }),
        onMount: onMount,
        onMouseEnter: ()=>{
            didMouseEnter = true;
            return false;
        },
        onClick: (state, dispatch, view)=>{
            const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
                state: state,
                configItem: rangeBaseGenerate,
                lastTriggeredFrom: 'floatingToolbar',
                // ED-18194 Added analytics for floating toolbar to determine
                // the % of users who click the button vs shift tab to it
                triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
                aiGlobalOptIn: aiGlobalOptIn,
                triggeredFor: triggeredFor,
                locale: intl.locale
            });
            openAIModalCommand(state, dispatch);
            if (onClick) onClick();
            return false;
        },
        disabled: disabled
    };
};
const $e139379dc978801b$export$c93a3969a7894772 = ({ intl: intl, hideTitle: hideTitle, aiGlobalOptIn: aiGlobalOptIn, disabled: disabled, onMount: onMount, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled })=>{
    let didMouseEnter = false;
    return {
        type: 'button',
        isRadioButton: false,
        showTitle: true,
        testId: `${$e139379dc978801b$export$ef1d0b9899d7de5}-improve-writing`,
        ariaLabel: (0, $1oCLl.expValEquals)('platform_editor_floating_toolbar_button_aria_label', 'isEnabled', true) ? intl.formatMessage((0, $7ShCl.aiMessages).improveWritingToolbarIconTitle) : undefined,
        icon: (0, $dh538.fg)('ai-smart-button-team-25') || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))) : undefined,
        ...!hideTitle && {
            title: intl.formatMessage((0, $7ShCl.aiMessages).improveWritingToolbarIconTitle)
        },
        tooltipContent: isInDocumentStreamingEnabled ? undefined : intl.formatMessage((0, $7ShCl.aiMessages).improveWritingToolbarIconTooltip),
        onMouseEnter: ()=>{
            didMouseEnter = true;
            return false;
        },
        onClick: (state, dispatch, view)=>{
            const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
                state: state,
                configItem: (0, $iBSwI.improveWriting)(),
                lastTriggeredFrom: 'floatingToolbar',
                triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
                aiGlobalOptIn: aiGlobalOptIn,
                locale: intl.locale
            });
            openAIModalCommand(state, dispatch);
            return false;
        },
        disabled: disabled,
        onMount: onMount
    };
};
const $e139379dc978801b$export$b8d5d3cc3902e265 = ({ intl: intl, rangeBaseGenerate: rangeBaseGenerate, aiGlobalOptIn: aiGlobalOptIn, triggeredFor: triggeredFor, pulse: pulse, onMount: onMount, onClick: onClick, disabled: disabled })=>{
    const Icon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            size: "small"
        });
    return $e139379dc978801b$export$a3e7258dd93ab690({
        intl: intl,
        rangeBaseGenerate: rangeBaseGenerate,
        hideTitle: false,
        aiGlobalOptIn: aiGlobalOptIn,
        icon: Icon,
        title: (0, $7ShCl.aiMessages).askRovoToolbarIconTitle,
        tooltip: (0, $7ShCl.aiMessages).askRovoToolbarIconTooltipQuickCommand,
        triggeredFor: triggeredFor,
        pulse: pulse,
        onMount: onMount,
        onClick: onClick,
        disabled: disabled
    });
};
// Renderer component to allow React hooks for memoization
const $e139379dc978801b$var$RovoSplitButtonRenderer = ({ view: view, api: api, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, onMount: onMount })=>{
    const registeredComponents = api?.toolbar?.actions.getComponents?.();
    const components = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>registeredComponents ?? (0, $15e4cd2cdf37fbe6$export$611b6feb29f5c606)({
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiGlobalOptIn,
            isNewToolbarEnabled: false,
            api: api
        }), [
        registeredComponents,
        editorPluginAIProvider,
        aiGlobalOptIn,
        api
    ]);
    const toolbarConfig = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            type: 'toolbar',
            key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)
        }), []);
    const fallbacks = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            group: (0, $kDB94.ToolbarButtonGroup),
            section: (0, $48SU7.ToolbarSection),
            menuSection: (0, $6UWPx.ToolbarDropdownItemSection)
        }), []);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        onMount?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gzUv9.EditorToolbarProvider), {
        editorView: view ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biAkr.EditorToolbarUIProvider), {
        api: api
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf8NL.ToolbarModelRenderer), {
        toolbar: toolbarConfig,
        components: components,
        fallbacks: fallbacks
    })));
};
const $e139379dc978801b$export$a85fdf32e150e9f2 = (props)=>{
    const { intl: intl, rangeBaseGenerate: rangeBaseGenerate, aiGlobalOptIn: aiGlobalOptIn, editorPluginAIProvider: editorPluginAIProvider, disabled: disabled, api: api, triggeredFor: triggeredFor, pulse: pulse, onMount: onMount } = props;
    return {
        type: 'custom',
        fallback: [
            $e139379dc978801b$export$b8d5d3cc3902e265({
                intl: intl,
                rangeBaseGenerate: rangeBaseGenerate,
                aiGlobalOptIn: props.aiGlobalOptIn,
                triggeredFor: triggeredFor,
                pulse: pulse,
                onMount: onMount,
                disabled: disabled
            })
        ],
        render: (view)=>{
            if (!view) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e139379dc978801b$var$RovoSplitButtonRenderer, {
                onMount: onMount,
                view: view,
                api: api,
                editorPluginAIProvider: editorPluginAIProvider,
                aiGlobalOptIn: aiGlobalOptIn
            });
        }
    };
};


const $2368fa8f5f72e4ad$var$getAIButton = ({ intl: intl, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, nodeType: nodeType, disabled: disabled, api: api, state: state })=>{
    const isAIEnabled = aiGlobalOptIn.status === 'enabled';
    if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
        const handleAiButtonMount = ()=>{
            const { charCount: charCount, wordCount: wordCount } = (0, $4SGh1.selectionCharWordCount)(state);
            (0, $4SGh1.fireButtonViewedAnalyticsEvent)({
                api: api,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_ASK_ROVO_BUTTON,
                attributes: {
                    selectionCharCount: charCount,
                    selectionWordCount: wordCount
                }
            });
        };
        return (0, $e139379dc978801b$export$a85fdf32e150e9f2)({
            intl: intl,
            rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
            aiGlobalOptIn: aiGlobalOptIn,
            triggeredFor: nodeType,
            disabled: disabled,
            editorPluginAIProvider: editorPluginAIProvider,
            api: api,
            onMount: handleAiButtonMount
        });
    }
    if (isAIEnabled && (0, $dh538.fg)('ai-smart-button-team-25') || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return (0, $e139379dc978801b$export$b8d5d3cc3902e265)({
        intl: intl,
        rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
        aiGlobalOptIn: aiGlobalOptIn,
        triggeredFor: nodeType,
        disabled: disabled
    });
    return (0, $e139379dc978801b$export$a3e7258dd93ab690)({
        intl: intl,
        rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
        hideTitle: true,
        aiGlobalOptIn: aiGlobalOptIn,
        triggeredFor: nodeType,
        disabled: disabled
    });
};
const $2368fa8f5f72e4ad$export$add2b8f99d5aac = ({ aiGlobalOptIn: aiGlobalOptIn, editorPluginAIProvider: editorPluginAIProvider, api: api })=>// eslint-disable-next-line @typescript-eslint/max-params
    (state, intl, _providerFactory, processedConfigs)=>{
        const aiDecorationPluginState = (0, $3yUTv.aiExperienceDecorationPluginKey).getState(state);
        const aiModalDecorationSet = aiDecorationPluginState?.modalDecorationSet ?? (0, $ftzrq.DecorationSet).empty;
        const isAIModalOpen = aiModalDecorationSet !== (0, $ftzrq.DecorationSet).empty;
        if (isAIModalOpen && editorPluginAIProvider.isInDocumentStreamingEnabled) return {
            title: '',
            visible: false,
            items: [],
            nodeType: Object.values(state.schema.nodes).reduce((acc, cur)=>{
                if (cur.isBlock) acc.push(cur);
                return acc;
            }, [])
        };
        // Following line is to ensure that the inline suggestion toolbar is always shown when the AI modal is open
        const suggestionToolbar = (0, $d4d1598b7faaa41b$export$e510567c2b33e62).maybeBuild(state, api);
        if (suggestionToolbar) return suggestionToolbar;
        /**
   * Add AI button in nodes supported (currently only table is supported).
   * List of supported node can be found in implementation of getSupportedNodesForAIModal.
   */ const { selection: selection } = state;
        const { from: from, to: to } = selection;
        const isNodeSelection = selection instanceof (0, $ks2lK.NodeSelection);
        const isCellSelection = selection.toJSON().type === 'cell';
        const getParentSupportedForAIButton = ()=>{
            const supportedNodesForAI = (0, $jdR93.getSupportedNodesForAIModal)(state);
            if (isNodeSelection) return supportedNodesForAI.has(selection.node.type) ? selection.node : undefined;
            else {
                const parentNodeFindResult = (0, $8m4tT.findParentNode)((node)=>supportedNodesForAI.has(node.type))(selection);
                return parentNodeFindResult?.node;
            }
        };
        const disabled = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) && (0, $91bcx.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode);
        const parentSupportedForAIButton = getParentSupportedForAIButton();
        const isAIEnabled = aiGlobalOptIn.status === 'enabled';
        if ((from === to || isNodeSelection || isCellSelection) && parentSupportedForAIButton) {
            const canAddAIButton = isNodeSelection || parentSupportedForAIButton;
            const nodeType = parentSupportedForAIButton?.type;
            if (canAddAIButton && nodeType) {
                const aiIconButton = $2368fa8f5f72e4ad$var$getAIButton({
                    intl: intl,
                    editorPluginAIProvider: editorPluginAIProvider,
                    aiGlobalOptIn: aiGlobalOptIn,
                    nodeType: nodeType,
                    disabled: disabled,
                    api: api,
                    state: state
                });
                const separator = {
                    type: 'separator',
                    fullHeight: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')
                };
                const addAIButtonToConfig = (title)=>{
                    const toolbarConfig = processedConfigs?.find((config)=>config.title === title);
                    const items = Array.isArray(toolbarConfig?.items) ? toolbarConfig?.items : [];
                    if (toolbarConfig && items.length) {
                        const withAIItems = isAIEnabled && (0, $dh538.fg)('ai-smart-button-team-25') || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? [
                            aiIconButton,
                            separator,
                            ...items
                        ] : [
                            ...items.slice(0, items.length - 3),
                            aiIconButton,
                            separator,
                            ...items.slice(items.length - 3, items.length)
                        ];
                        /**
           * Updating items of table, panel, layout or expand config item.
           * Injecting updated items in same config object.
           */ toolbarConfig.items = withAIItems;
                        return toolbarConfig;
                    }
                };
                /**
       * Here we are updating items of table, panel, expand and layout
       * 	floaingToolbarConfig.
       * This will only work when editor-plugin-ai is added after these plugins.
       * Proper solution will be implemented when outcome
       * 	of https://hello.atlassian.net/wiki/spaces/EDITOR/pages/4166466469/Editor+RFC+058+Easier+way+to+insert+items+in+floating+toolbar
       *  RFC is finalised.
       */ if (!editorPluginAIProvider.isInDocumentStreamingEnabled) return addAIButtonToConfig('Table floating controls');
            }
        }
        return;
    };














/* AtlassianIntelligenceToolbarButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $8TW6I = parcelRequire("8TW6I");





var $jN96M = parcelRequire("jN96M");


var $a4eZN = parcelRequire("a4eZN");
















const $824ce495353fd9b0$export$cf19468c196a204d = (ButtonWrapper)=>{
    const [toolbarMutationCount, setToolbarMutationCount] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        if (!ButtonWrapper) return;
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                const { addedNodes: addedNodes, removedNodes: removedNodes } = mutation;
                // @ts-ignore error TS2488: Type 'NodeList' must have a '[Symbol.iterator]()' method that returns an iterator.
                // This was required when enrolling this package into JFE local consumption
                const isRelevantMutation = [
                    ...addedNodes,
                    ...removedNodes
                ].some((node)=>node.nodeType === 1 && node.nodeName === 'DIV');
                if (isRelevantMutation) setToolbarMutationCount(toolbarMutationCount + 1);
            });
        });
        const mainToolBar = document.querySelector(`[data-testid="ak-editor-main-toolbar"]`);
        if (mainToolBar) observer.observe(mainToolBar, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        toolbarMutationCount,
        ButtonWrapper
    ]);
    return toolbarMutationCount;
};


const $195c42f2a6329270$var$rovoIconContainerStyle = null;
const $195c42f2a6329270$var$iconMinWidthStyle = null;
const $195c42f2a6329270$var$wrapperStyle = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $195c42f2a6329270$var$wrapperStylesUnbounded = null; // This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
const $195c42f2a6329270$var$AI_BUTTON_WIDTH_BREAKPOINT = 1076;
const $195c42f2a6329270$var$shouldShowSeparator = (node)=>{
    if (!node) return false;
     // NOTE: Compiled CSS results in the previous sibling being a style tag rather then what was previously expected to be
    // another span/div tag. This is a temporary fix to ensure the separator is shown correctly.
    // As noted in the SSR compiled doco here (https://compiledcssinjs.com/docs/server-side-rendering) style elements are
    // inlined in the dom markup.
    const element = node.previousElementSibling?.tagName === 'STYLE' ? node.previousElementSibling?.previousElementSibling : node.previousElementSibling;
    const prevSeparator = element?.querySelector(`:scope > span:last-child:empty`);
    const prevSeparatorVisible = prevSeparator && prevSeparator.clientWidth > 0;
    return !prevSeparatorVisible;
};
const $195c42f2a6329270$var$WriteAIButton = ({ api: api, view: view, onClick: onClick, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const title = formatMessage((0, $SFzFl.default).aiUniversalDescriptor);
    const { width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'width'
    ], (states)=>{
        return {
            width: states.widthState?.width
        };
    });
    const shouldShowLabel = width ? width >= $195c42f2a6329270$var$AI_BUTTON_WIDTH_BREAKPOINT : true;
    return /*#__PURE__*/ $42omo.createElement((0, $a4eZN.default), {
        onClick: onClick,
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).AI,
        "aria-label": title,
        testId: "atlassian-intelligence-toolbar-button",
        title: title,
        iconBefore: (0, $dh538.fg)('platform_editor_old_main_toolbar_rovo_icon_update') ? /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                "_1ul97vkz _1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $9J8UT.AIChatIcon), {
            label: "atlassian-intelligence-toolbar-button-icon"
        })) : /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                "_1ul91tcg"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.RovoIcon), {
            label: "atlassian-intelligence-toolbar-button-icon",
            size: "small",
            appearance: "neutral"
        })),
        disabled: isDisabled
    }, shouldShowLabel && formatMessage((0, $SFzFl.default).aiUniversalShortCallToAction));
};
const $195c42f2a6329270$export$d680bd36e1545039 = ({ onClick: onClick, disabled: disabled, ButtonWrapper: ButtonWrapper, api: api, view: view })=>{
    const [showSeparator, setShowSeperator] = (0, $42omo.useState)(false);
    const callbackRef = (node)=>{
        const result = $195c42f2a6329270$var$shouldShowSeparator(node);
        setShowSeperator(result);
    };
    const aiButton = /*#__PURE__*/ $42omo.createElement($195c42f2a6329270$var$WriteAIButton, {
        api: api,
        view: view,
        onClick: onClick,
        isDisabled: disabled
    });
    const toolbarMutationCount = (0, $824ce495353fd9b0$export$cf19468c196a204d)(ButtonWrapper);
    return /*#__PURE__*/ $42omo.createElement("span", {
        ref: callbackRef,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _18u0idpf _1ul91wug",
            "_p7r11txw _1xdi1txw _1ylx1txw _1fvdglyw _1c1bglyw"
        ])
    }, showSeparator && /*#__PURE__*/ $42omo.createElement((0, $jN96M.ToolbarSeparator), null), ButtonWrapper ? /*#__PURE__*/ $42omo.createElement(ButtonWrapper, {
        key: `${toolbarMutationCount}-key-wrapper`
    }, aiButton) : aiButton);
};


const $85df90712bd49f87$var$PrimaryToolbarComponent = ({ editorView: editorView, api: api, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, disabled: disabled })=>{
    const mode = (0, $b3YrF.useSharedPluginStateSelector)(api, 'connectivity.mode');
    const aiButtonState = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiExperience.aiButtonState');
    const onClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        const configItem = editorPluginAIProvider.baseGenerate;
        const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: 'mainToolbar',
            aiGlobalOptIn: aiGlobalOptIn,
            triggeredFor: aiButtonState?.triggeredFor
        });
        openAIModalCommand(state, dispatch);
    };
    const isOffline = (0, $91bcx.isOfflineMode)(mode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $195c42f2a6329270$export$d680bd36e1545039), {
        api: api,
        ButtonWrapper: editorPluginAIProvider?.AIButtonWrapper,
        onClick: onClick,
        disabled: disabled || isOffline || !aiButtonState?.isSelectionValidForAIExperience,
        view: editorView
    });
};
const $85df90712bd49f87$export$1867437946169f9f = ({ api: api, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn })=>({ editorView: editorView, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($85df90712bd49f87$var$PrimaryToolbarComponent, {
            editorView: editorView,
            api: api,
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiGlobalOptIn,
            disabled: disabled
        });
    };












const $6d89b70284814d64$var$PrimaryToolbarLegacyComponent = ({ api: api, editorView: editorView, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn })=>{
    const aiButtonState = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiExperience.aiButtonState');
    const onClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        const configItem = editorPluginAIProvider.baseGenerate;
        const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: 'mainToolbar',
            aiGlobalOptIn: aiGlobalOptIn,
            triggeredFor: aiButtonState?.triggeredFor
        });
        openAIModalCommand(state, dispatch);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $195c42f2a6329270$export$d680bd36e1545039), {
        ButtonWrapper: editorPluginAIProvider?.AIButtonWrapper,
        onClick: onClick,
        disabled: !aiButtonState?.isSelectionValidForAIExperience,
        view: editorView
    });
};
const $6d89b70284814d64$export$d26e7f34c50ada62 = ({ api: api, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn })=>({ editorView: editorView })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d89b70284814d64$var$PrimaryToolbarLegacyComponent, {
            api: api,
            editorView: editorView,
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiGlobalOptIn
        });
    };





















const $f886084167a12901$export$50f5e6709d50619a = ({ editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, api: api })=>(state, intl)=>{
        if (editorPluginAIProvider.disableAISelectionToolbar) return;
        const disabled = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) && (0, $91bcx.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode);
        const isAiButtonPulse = api?.engagementPlatform?.sharedState.currentState()?.messageStates['cc-editor-ai_ai-toolbar-button-pulse'];
        const handleAiButtonMount = ()=>{
            if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
                const { charCount: charCount, wordCount: wordCount } = (0, $4SGh1.selectionCharWordCount)(state);
                (0, $4SGh1.fireButtonViewedAnalyticsEvent)({
                    api: api,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_ASK_ROVO_BUTTON,
                    attributes: {
                        selectionCharCount: charCount,
                        selectionWordCount: wordCount
                    }
                });
            }
            // Multiple calls to startMessage with the same message key will not result in multiple messages being shown.
            // That's why we can call it here without worrying about it being called multiple times.
            api?.engagementPlatform?.actions.startMessage('cc-editor-ai_ai-toolbar-button-pulse');
        };
        let handleImproveWritingButtonMount;
        if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
            const { charCount: charCount, wordCount: wordCount } = (0, $4SGh1.selectionCharWordCount)(state);
            handleImproveWritingButtonMount = ()=>{
                (0, $4SGh1.fireButtonViewedAnalyticsEvent)({
                    api: api,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_HERO_PROMPT_BUTTON,
                    attributes: {
                        selectionCharCount: charCount,
                        selectionWordCount: wordCount
                    }
                });
            };
        }
        const improveWritingBtn = (0, $e139379dc978801b$export$c93a3969a7894772)({
            intl: intl,
            hideTitle: false,
            aiGlobalOptIn: aiGlobalOptIn,
            disabled: disabled,
            onMount: handleImproveWritingButtonMount,
            isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled
        });
        if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
            const aIButton = (0, $e139379dc978801b$export$a85fdf32e150e9f2)({
                intl: intl,
                rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
                aiGlobalOptIn: aiGlobalOptIn,
                disabled: disabled,
                editorPluginAIProvider: editorPluginAIProvider,
                api: api,
                pulse: isAiButtonPulse,
                onMount: handleAiButtonMount
            });
            return {
                rank: 10,
                isToolbarAbove: true,
                items: [
                    aIButton,
                    improveWritingBtn
                ]
            };
        }
        if ((0, $dh538.fg)('ai-smart-button-team-25') || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
            const askAIButton = (0, $e139379dc978801b$export$b8d5d3cc3902e265)({
                intl: intl,
                rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
                aiGlobalOptIn: aiGlobalOptIn,
                pulse: isAiButtonPulse,
                onMount: handleAiButtonMount,
                disabled: disabled
            });
            const separator = {
                type: 'separator',
                fullHeight: true
            };
            /**
			 * We want to show AI button on left most side of floating toolbar.
			 * Higher the rank, the more left it will be.
			 * We are setting rank to 10 to show AI button on left most side.
			 */ return {
                rank: 10,
                isToolbarAbove: true,
                items: [
                    improveWritingBtn,
                    askAIButton,
                    ...(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? [
                        separator
                    ] : []
                ]
            };
        } else {
            const aiExperienceBtn = (0, $e139379dc978801b$export$a3e7258dd93ab690)({
                intl: intl,
                rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
                hideTitle: true,
                aiGlobalOptIn: aiGlobalOptIn,
                title: (0, $7ShCl.aiMessages).tryAIToolbarIconTitle,
                tooltip: (0, $7ShCl.aiMessages).tryAIToolbarIconTooltip,
                pulse: isAiButtonPulse,
                onMount: handleAiButtonMount,
                disabled: disabled
            });
            return {
                rank: -10,
                isToolbarAbove: true,
                items: [
                    improveWritingBtn,
                    aiExperienceBtn
                ]
            };
        }
    };







const $d9883f2ea6a20e2e$export$da9fe52c4382b67d = (0, $1466f8e1fdbfbe2b$export$aaa7fa18f8e9b2e8)({
    /** @xstate-layout N4IgpgJg5mDOIC5QFEIEsAuB7ATgBQBsBXKNAOwEEBJAYgGUAVCgJQYH1q3kANPZZqsgByAYWQBtAAwBdRKAAOWWJjRYyckAA9EAWgCMkgKwAOAHQBmAEzHJAFmOWrtgGx7LAGhABPXc9OWATlsAdj1zY2cAy2dDMOMAX3jPVExcQhJyalNqAAIAWSwIAEMCHKKAYww0ADcwGk4RAHkhBmF2KiE6flaAESlZJBBFZSq1DW0EHXtg0z1bEODDcwDJZ0tDTx8EPWMzG0t14xMdw0MYxOT0bHxiUkoqbKp8wpKyypq6vMaeigAZNh6VDoIhYPWQfRkGmGKjGgwmOmCtkM-ii6xMKyRRk2uj0zhmlkkK0swRW5nCkiMFxAKWu6TuWVyBWKpQqVVqNC+P3+HQAan8qD9ev0oUoYeo4bpzCZTMFzLY9EtjMFic5drZsZM9FFZrtLEjlUjzJFnFSaWlbpkHrkRGoMGAyBgcgAJNBQAAWBFdbrtEHoyF+yBEDCozTYIidFCEAHFwcLBtDRuLQBN7KYzs41qtJNYAgEMxr9HoZWtbOZJFLVnLYsFEkkQGRCnANGabhl7iKRqok1ocQY-FYbPZHHrXB5vL5s6Y8UFgs5bI4DAk6y26ZbTEIsDlcmBNPIwDg0PbymA3mywB2xeNfLj-MFFkrjCs1htx5Nln49CSXEsAm5c7ZTSuc02wZJ4mVeVkPgvRMr0mVw-GJe9gkfVZ1g1ZxzBlAJFkMQIkSiZxJBrZcgNbekrSeG0HXtR0XXdT13R9aCu1gnR4NvWcwnlAlcT0DVoksUwHEkT9Vi1O9sPMWt4iAA */ id: 'EditorPluginAI',
    description: `This machine models the high level functionality of the EditorPluginAI.

Currently this logic is split across prosemirror, xstate, and elsewhere.

The intention is to migrate to a single source of truth, backed by a state machine.`,
    states: {
        'No AI experience active': {
            description: `When an Editor is first started up with an editor-plugin-ai EditorPlugin - it will start in this state.

This state will be returned to when an ai experience is either discarded or completed.`
        },
        'AI Modal active': {
            on: {
                AI_CONTENT_INSERTED: 'AI Content Highlighted',
                MODAL_DISCARDED: {
                    target: 'No AI experience active',
                    description: `This transition is intended to model when a user makes an explicit decision to clear the modal.`
                },
                MODAL_INVALIDATED: {
                    target: 'No AI experience active',
                    description: `This transition is intended to model when an AI experience is ended due to the modal no longer being valid.

For example, if it's been linked to a selection, and another user collaborating on the document deletes the selected content.

In future we might expect this to go to an alternate state.`
                }
            },
            description: `Currently there is a seperate xstate state machine which is run when the ai modal is active.
Over time we can expect to link these state machines.`
        },
        'AI Content Highlighted': {
            on: {
                SELECTION_CHANGED: {
                    target: 'No AI experience active',
                    description: `This transition models when a user interacts with a document following the insertion of content via AI.`
                }
            },
            description: `Following content being inserted, the inserted content is highlighted so the user is able to understand the impact of inserting the generated content into the document.

This highlight is persisted either until the user changes makes a selection change in the document or the content is removed from the document (ie. via collab editing sessions)`
        }
    },
    on: {
        START_AI_EXPERIENCE: {
            target: '#EditorPluginAI.AI Modal active',
            description: `We expect AI Experiences to be started in a variety of ways including;
- via the slash command/typeahead
- via the toolbar quick insert menu
- via the toolbar ai button
- via external actions (ie. atlas have a button outside the editor which starts an ai experience)

Only one AI experience can be active at a single time in an Editor.  If another AI experience is active when the user starts a new AI experience, the prior experience is replaced/reset with the new experience details.`
        }
    },
    initial: 'No AI experience active'
});


/**
 * Weakmap cache for caching an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
 * per EditorView.
 *
 * It contains a convenience function for returning an actor if it exists in the cache (`getActor`)
 */ class $50ed9c4cc065f547$var$AIActorCache extends WeakMap {
    /**
   * Returns an actor if it exists in the cache or creates and starts a new one.
   *
   * @param editorView
   * @returns [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
   */ getActor(editorView) {
        if (this.has(editorView)) return this.get(editorView);
        const editorPluginAIActor = (0, $d0N4G.A)((0, $d9883f2ea6a20e2e$export$da9fe52c4382b67d));
        editorPluginAIActor.start();
        $50ed9c4cc065f547$export$eca6b7572eaa53aa.set(editorView, editorPluginAIActor);
        return editorPluginAIActor;
    }
}
const $50ed9c4cc065f547$export$eca6b7572eaa53aa = new $50ed9c4cc065f547$var$AIActorCache();



const $dfc2f6d166cc5144$export$7825a101a7e6b70b = ({ config: config, api: api })=>{
    const editorPluginAIProvider = config;
    const aiGlobalOptIn = config.aiGlobalOptIn;
    let editorView;
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    // Determine wehther or not a preview modal will be shown, if it is then the user must manually accept/reject the changes.
    // if canInlineStreamChanges() => true, then the preview will not be shown and the changes will be applied automatically
    // If the canInlineStreamChanges() => false, then the changes will not be applied automatically, and the user will have to accept/reject the changes.
    const canInlineStreamChanges = ()=>{
        // The plugin can be passed a user prefs callback which could contain a setting which would disable in-document streaming.
        // We will default to true if this setting is not provided.
        const { isInDocumentStreamingAllowed: isInDocumentStreamingAllowed = true } = editorPluginAIProvider?.getUserPreferences?.() ?? {};
        return(// We only allow auto-accepting AI changes if the in-document streaming feature flag is enabled
        !!editorPluginAIProvider.isInDocumentStreamingEnabled && isInDocumentStreamingAllowed);
    };
    let providerFactory;
    const setProviderFactory = (newProviderFactory)=>{
        providerFactory = newProviderFactory;
    };
    let mentionProvider;
    /**
	 * Helper function to retrieve the name details for a mention from the mentionProvider
	 * @param id - The mention ID to resolve
	 * @returns The mention name details or undefined if not found
	 * @example
	 * ```ts
	 * const mentionDetails = await getMentionNameDetails('user-123');
	 * ```
	 */ const getMentionNameDetails = async (id)=>{
        if (!mentionProvider || !(0, $bqMS3.isResolvingMentionProvider)(mentionProvider)) return;
        const nameDetails = mentionProvider.resolveMentionName(id);
        if ((0, $6mYMS.isPromise)(nameDetails)) {
            const mention = await nameDetails;
            return mention;
        }
        return nameDetails;
    };
    const setMentionProvider = ()=>{
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                mentionProvider = provider;
                providerFactory.unsubscribe('mentionProvider', handler);
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    };
    const setMediaProvider = ()=>{
        if (editorPluginAIProvider?.providers?.mediaProvider) providerFactory.setProvider('mediaProvider', Promise.resolve(editorPluginAIProvider.providers.mediaProvider));
    };
    const setEmojiProvider = ()=>{
        const { emojiProvider: emojiProvider } = api?.emoji?.sharedState.currentState() || {};
        if (!!emojiProvider) providerFactory.setProvider('emojiProvider', Promise.resolve(emojiProvider));
        else {
            const unsub = api?.emoji?.sharedState.onChange((sharedState)=>{
                if (!!sharedState.nextSharedState?.emojiProvider) {
                    providerFactory.setProvider('emojiProvider', Promise.resolve(sharedState.nextSharedState.emojiProvider));
                    unsub?.();
                }
            });
        }
    };
    const setExtensionProvider = ()=>{
        const { extensionProvider: extensionProvider } = api?.extension?.sharedState.currentState() || {};
        if (!!extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
        else {
            const unsub = api?.extension?.sharedState.onChange((sharedState)=>{
                if (!!sharedState.nextSharedState?.extensionProvider) {
                    providerFactory.setProvider('extensionProvider', Promise.resolve(sharedState.nextSharedState.extensionProvider));
                    unsub?.();
                }
            });
        }
    };
    const aiOptIn = aiGlobalOptIn || {
        status: 'enabled',
        triggerOptInFlow: ()=>{}
    };
    const quickInsert = (intl)=>{
        const configItems = [];
        if (!editorPluginAIProvider.disableQuickInsert) {
            if (editorPluginAIProvider.isInDocumentStreamingEnabled) configItems.push(editorPluginAIProvider.baseGenerate);
            else configItems.push(editorPluginAIProvider.baseGenerate, ...(0, $c2200b5407d4af9f$export$2dd2807afbd4a532)({
                configItemWithOptions: editorPluginAIProvider.configItemWithOptions,
                // The editor view will always be available when quick insert items are being created
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                editorView: editorView,
                positions: [
                    0,
                    0
                ],
                isEmpty: true
            }));
        }
        const quickInsertItems = (0, $124112c4faaee370$export$f3e5bb240cf24df5)({
            configItems: configItems,
            formatMessage: intl.formatMessage,
            aiGlobalOptIn: aiOptIn,
            // The editor view will always be available when quick insert items are being created
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            editorView: editorView,
            locale: intl.locale
        });
        return quickInsertItems;
    };
    quickInsert.disableMemo = true;
    if (isToolbarAIFCEnabled) {
        const shouldShowImproveDescription = config.configItemWithOptions?.[0]?.config?.key === (0, $bwpRs.CONFIG_ITEM_KEYS).ADD_STRUCTURE;
        api?.toolbar?.actions.registerComponents((0, $15e4cd2cdf37fbe6$export$611b6feb29f5c606)({
            aiGlobalOptIn: aiOptIn,
            editorPluginAIProvider: editorPluginAIProvider,
            shouldShowImproveDescription: shouldShowImproveDescription,
            getAdditionalProps: config.getAdditionalProps,
            isNewToolbarEnabled: true,
            api: api
        }));
    } else if (!editorPluginAIProvider?.hidePrimaryToolbarButton) api?.primaryToolbar?.actions.registerComponent({
        name: 'aiExperience',
        component: (0, $85df90712bd49f87$export$1867437946169f9f)({
            api: api,
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiOptIn
        })
    });
    const adfStreamingEnabled = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    return {
        name: 'aiExperience',
        pmPlugins: ()=>{
            const plugins = [
                {
                    name: 'ai-content-state',
                    plugin: ()=>(0, $6d81f3f6e54d61c8$export$ea83d625c73fdf28)()
                },
                {
                    name: 'ai-experience-actor',
                    plugin: ()=>new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                // This sets up an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api) using
                                // the editor-plugin-ai machine and starts it up.
                                const editorPluginAIActor = (0, $50ed9c4cc065f547$export$eca6b7572eaa53aa).getActor(editorView);
                                return {
                                    destroy: ()=>{
                                        // This cleansup any listeners from the actor -- to ensure we don't leak memory.
                                        editorPluginAIActor?.stop();
                                        (0, $50ed9c4cc065f547$export$eca6b7572eaa53aa).delete(editorView);
                                    }
                                };
                            }
                        })
                },
                {
                    name: 'aiExperience',
                    plugin: (options)=>{
                        const payload = {
                            action: 'init',
                            actionSubject: 'editor',
                            actionSubjectId: 'editorPluginAI',
                            eventType: (0, $d925B.EVENT_TYPE).TRACK,
                            attributes: {
                                aiGlobalOptIn: aiOptIn?.status
                            }
                        };
                        // @ts-expect-error - This prevent type errors when trying to pass EditorPluginAI payload to AnalyticsEventPayload
                        options.dispatchAnalyticsEvent(payload);
                        return (0, $93128a3776147250$export$f99722d744184238)({
                            dispatchAnalyticsEvent: options.dispatchAnalyticsEvent,
                            dispatch: options.dispatch,
                            api: api,
                            isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled
                        });
                    }
                },
                {
                    name: 'ai-experience-get-editor-view-and-provider-factory',
                    plugin: (options)=>{
                        setProviderFactory(options.providerFactory);
                        setMentionProvider();
                        setMediaProvider();
                        setEmojiProvider();
                        if (adfStreamingEnabled) setExtensionProvider();
                        return (0, $327f80136292b9fb$export$3de1ac9a9cd13933)({
                            setEditorView: setEditorView
                        });
                    }
                },
                {
                    name: 'ai-experience-ai-button',
                    plugin: ()=>(0, $a84cc97c8c45c622$export$e65c99dea6a50353)()
                },
                {
                    name: 'ai-experience-selection-preview',
                    plugin: ()=>(0, $904968b6cb52c4fa$export$6b0a857b1a5189ef)()
                },
                {
                    name: 'inline-suggestions',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $de4b3e800a5062e7$export$21cd6432d1e2d949)({
                            dispatch: dispatch,
                            getIntl: getIntl,
                            api: api
                        })
                }
            ];
            if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) plugins.push({
                name: 'ai-session-context',
                plugin: (options)=>(0, $278237b840ae0e27$export$3332615281a18d68)(options)
            });
            if (editorPluginAIProvider.isInDocumentStreamingEnabled) plugins.push({
                name: 'ai-experience-placeholder-controller',
                plugin: ()=>(0, $97bd9a9bc8d6fe47$export$1d8514938d526e53)({
                        api: api,
                        editorPluginAIProvider: editorPluginAIProvider
                    })
            });
            plugins.push({
                name: 'ai-event-hub',
                plugin: ({ getIntl: getIntl })=>(0, $bd3d20f153868f6f$export$c83eff15443f700)({
                        aiGlobalOptIn: aiOptIn,
                        editorPluginAIProvider: editorPluginAIProvider,
                        getIntl: getIntl,
                        api: api
                    })
            });
            if (editorPluginAIProvider.isRovoEnabled) {
                plugins.push({
                    name: 'editor-ai-rovo-agents',
                    plugin: (options)=>(0, $e9052fc7b27acce4$export$c72f28d9e4137cea)(options)
                });
                plugins.push({
                    name: 'ai-experience-selection',
                    plugin: ()=>(0, $344063b249c0a0e4$export$adbe0f8e0f3704d5)({
                            api: api,
                            editorPluginAIProvider: editorPluginAIProvider
                        })
                });
            }
            if (editorPluginAIProvider.auditLogSettings && editorPluginAIProvider.auditLogSettings.enabled && (0, $dh538.fg)('platform_editor_ai_audit_logs_events')) {
                const eventData = editorPluginAIProvider.auditLogSettings.eventData;
                plugins.push({
                    name: 'ai-audit-log',
                    plugin: ({ dispatch: dispatch })=>(0, $46038edb0783e562$export$b07b9a8a474c46fb)({
                            dispatch: dispatch,
                            eventData: eventData
                        })
                });
            }
            const { aiSmartButtonOptions: aiSmartButtonOptions, dynamicSurfaceConfigItems: dynamicSurfaceConfigItems } = editorPluginAIProvider;
            if (aiSmartButtonOptions && dynamicSurfaceConfigItems && (0, $dh538.fg)('ai-smart-button-team-25')) plugins.push({
                name: 'ai-smart-button-api',
                plugin: ({ getIntl: getIntl, dispatch: dispatch })=>(0, $aad534496f5c8757$export$b43aba46e2a0894)({
                        aiGlobalOptIn: aiOptIn,
                        aiSmartButtonOptions: aiSmartButtonOptions,
                        api: api,
                        dispatch: dispatch,
                        dynamicSurfaceConfigItems: dynamicSurfaceConfigItems,
                        getIntl: getIntl,
                        product: editorPluginAIProvider.product,
                        getMentionNameDetails: getMentionNameDetails
                    })
            });
            if ((0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true, {
                exposure: true
            })) plugins.push({
                name: 'ai-quickstart-command',
                plugin: ({ getIntl: getIntl })=>(0, $aee682b977e525bb$export$75dff2601176292f)({
                        aiGlobalOptIn: aiOptIn,
                        editorPluginAIProvider: editorPluginAIProvider,
                        getIntl: getIntl
                    })
            });
            if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
                const canAutoAcceptAIChanges = canInlineStreamChanges();
                if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) plugins.push({
                    name: 'pure-pm-in-editor-direct-streaming',
                    plugin: ({ getIntl: getIntl })=>(0, $4df545aa292d26a2$export$465eeb0611517dc)({
                            getIntl: getIntl,
                            api: api,
                            canAutoAcceptAIChanges: canAutoAcceptAIChanges
                        })
                });
                else plugins.push({
                    name: 'in-editor-direct-streaming',
                    plugin: ({ getIntl: getIntl })=>(0, $ef407fc59b6ca435$export$465eeb0611517dc)({
                            getIntl: getIntl,
                            api: api
                        })
                });
                plugins.push({
                    name: 'ai-annotation-watchmen',
                    plugin: ()=>(0, $59f25d3bacd6bee4$export$120e869ffea6ac01)({
                            onAnnotationsRemoved: editorPluginAIProvider.onAnnotationsRemoved
                        })
                });
                plugins.push({
                    name: 'ai-monitor-watchmen',
                    plugin: ()=>(0, $290ed39dc9fde36a$export$d5f2dba636afec41)(api, canInlineStreamChanges)
                });
                if (editorPluginAIProvider.product === 'CONFLUENCE' && (0, $dh538.fg)('platform_editor_ai_aifc_space_shortcut')) plugins.push({
                    name: 'ai-space-shortcut',
                    plugin: ({ getIntl: getIntl })=>(0, $3eb5e2a10123a78c$export$1f64fead470ce6a8)({
                            aiGlobalOptIn: aiOptIn,
                            editorPluginAIProvider: editorPluginAIProvider,
                            getIntl: getIntl
                        })
                });
            }
            return plugins;
        },
        actions: {
            openAIModal: ({ invokedFrom: invokedFrom, configItem: configItem = editorPluginAIProvider.baseGenerate, withAcceptReject: withAcceptReject, withStreamingHighlight: withStreamingHighlight, hideLoadingScreen: hideLoadingScreen, traceId: traceId, isCreate: isCreate })=>{
                (0, $2b0668eaf60a5292$export$e49a2031d0d2ff07)({
                    invokedFrom: invokedFrom,
                    editorView: editorView,
                    aiOptIn: aiOptIn,
                    configItem: configItem,
                    withAcceptReject: withAcceptReject,
                    withStreamingHighlight: withStreamingHighlight,
                    isExternal: true,
                    hideLoadingScreen: hideLoadingScreen,
                    traceId: traceId,
                    isCreate: isCreate
                });
            },
            endAIExperience: ()=>{
                (0, $2b0668eaf60a5292$export$eb7c7403500d1c40)({
                    editorView: editorView
                });
            },
            getAiExperienceActor: ()=>{
                if (!editorView) throw new Error('editorView is not defined');
                const actor = (0, $fb64f67e895c15d9$export$a6342417f9492df1).getActor(editorView);
                if (!actor) throw new Error('No cached item found');
                return actor;
            },
            getAISelectionContext: ()=>{
                const currentSelection = api?.selection?.sharedState.currentState()?.selection?.content().content;
                return api?.aiExperience?.sharedState.currentState()?.selectionContext ?? {
                    selectionFragment: api?.selection?.actions.getSelectionFragment() ?? null,
                    localIds: api?.selection?.actions.getSelectionLocalIds() ?? null,
                    selectionMarkdown: currentSelection ? (0, $6eZqW.convertProsemirrorNodeToMarkdown)({
                        node: currentSelection
                    })?.markdown : null
                };
            },
            getPartialDocumentFromSelection: (maxSize)=>{
                return (0, $2b0668eaf60a5292$export$cb4bd847e3d154fe)({
                    selection: editorView?.state.selection,
                    maxSize: maxSize
                });
            },
            getPartialMarkdownFromSelection: (maxSize)=>{
                return (0, $2b0668eaf60a5292$export$3e64d26c171d92fc)({
                    selection: editorView?.state.selection,
                    maxSize: maxSize
                });
            },
            startSession: (sessionId, traceId)=>{
                api?.core?.actions.execute(api?.history?.commands?.startHistorySlice('ai'));
                (0, $2b0668eaf60a5292$export$254dcf4812f17c19)({
                    editorView: editorView,
                    sessionId: sessionId,
                    traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceId : undefined
                });
            },
            endSession: (sessionId)=>{
                (0, $2b0668eaf60a5292$export$3a08ee9ddec0cdee)({
                    editorView: editorView,
                    sessionId: sessionId
                });
                api?.core?.actions.execute(api?.history?.commands?.endHistorySlice('ai'));
            },
            updateTargetId: (targetId)=>{
                (0, $2b0668eaf60a5292$export$955fdaa156e3249e)({
                    editorView: editorView,
                    targetId: targetId
                });
            },
            dispatchAIEvent: (event)=>{
                if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) api?.core.actions.execute((0, $7d27e28955fa0757$export$6725e2cbda5e459c)(event));
                else {
                    const normalisedEvent = (0, $1xicG.normaliseAIExperienceEvent)(event);
                    api?.aiExperience?.actions.getAiExperienceActor()?.send(normalisedEvent);
                }
            },
            tagAsAIStreamingTransformation: $2b0668eaf60a5292$export$99447d9e0d76b7ef
        },
        getSharedState (state) {
            if (!state) return {
                nonCursorSelectionChangeCount: 0,
                aiButtonState: {
                    triggeredFor: undefined,
                    isSelectionValidForAIExperience: true
                },
                aiDecorationExperiencePluginState: {
                    isRunning: false,
                    interactionSessionId: undefined,
                    modalDecorationSet: (0, $ftzrq.DecorationSet).empty,
                    configItem: undefined,
                    lastTriggeredFrom: undefined,
                    modalMountedTimeStamp: undefined,
                    triggerMethod: undefined,
                    initialPrompt: undefined,
                    triggeredFor: undefined,
                    initialPositions: undefined,
                    nudgeMetrics: undefined,
                    hideLoadingScreen: false,
                    targetId: undefined,
                    isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled,
                    traceId: undefined
                },
                rovoAgentsPluginState: {
                    positions: undefined,
                    isBrowseModalOpen: false
                },
                isStreaming: false,
                isShowingAcceptRejectScreen: false,
                chunkNumber: 0,
                selectionContext: undefined,
                hasVisibleContent: false,
                aiSessionPluginState: (0, $278237b840ae0e27$export$d4c72bab9d6cc13a)
            };
            return {
                nonCursorSelectionChangeCount: ((0, $fXyZM.selectionPluginKey).getState(state) ?? {})?.nonCursorSelectionChangeCount,
                aiButtonState: {
                    triggeredFor: ((0, $97a626d9dbcaa4c0$export$521879fd431ff390).getState(state) ?? {}).triggeredFor,
                    isSelectionValidForAIExperience: ((0, $97a626d9dbcaa4c0$export$521879fd431ff390).getState(state) ?? {}).isSelectionValidForAIExperience
                },
                aiDecorationExperiencePluginState: {
                    isRunning: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).isRunning ?? false,
                    modalDecorationSet: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).modalDecorationSet ?? (0, $ftzrq.DecorationSet).empty,
                    configItem: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).configItem,
                    lastTriggeredFrom: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).lastTriggeredFrom,
                    modalMountedTimeStamp: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).modalMountedTimeStamp,
                    triggerMethod: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).triggerMethod,
                    initialPrompt: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).initialPrompt,
                    triggeredFor: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).triggeredFor,
                    initialPositions: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).initialPositions,
                    positions: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).positions,
                    nudgeMetrics: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).nudgeMetrics,
                    currentSessionId: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).currentSessionId,
                    nextSessionId: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).nextSessionId,
                    interactionSessionId: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).interactionSessionId,
                    hideLoadingScreen: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).hideLoadingScreen,
                    targetId: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).targetId,
                    isInDocumentStreamingEnabled: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).isInDocumentStreamingEnabled,
                    traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).traceId : undefined
                },
                rovoAgentsPluginState: {
                    positions: ((0, $47Psn.rovoAgentsPluginKey).getState(state) ?? {}).positions,
                    isBrowseModalOpen: ((0, $47Psn.rovoAgentsPluginKey).getState(state) ?? {}).isBrowseModalOpen ?? false,
                    defaultAgent: ((0, $47Psn.rovoAgentsPluginKey).getState(state) ?? {}).defaultAgent
                },
                isStreaming: (0, $dh538.fg)('platform_editor_ai_migrate_from_xstate') ? (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state)?.isStreaming ?? false : (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(state)?.isStreaming ?? false,
                isShowingAcceptRejectScreen: ((0, $3yUTv.aiExperienceDecorationPluginKey).getState(state) ?? {}).isShowingAcceptRejectScreen ?? false,
                chunkNumber: (0, $dh538.fg)('platform_editor_ai_migrate_from_xstate') ? (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state)?.chunkNumber ?? 0 : (0, $5vNOi.inEditorDirectStreamingPluginKey).getState(state)?.chunkNumber ?? 0,
                // Streaming plugin state for React hooks (scroll, mount effects, etc.)
                streamingState: (0, $dh538.fg)('platform_editor_ai_migrate_from_xstate') ? {
                    streamStartPos: (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state)?.streamStartPos,
                    scrollTargetPos: (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state)?.scrollTargetPos,
                    streamPhase: (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state)?.streamPhase,
                    currentSessionId: (0, $ly5a2.purePmInEditorDirectStreamingPluginKey).getState(state)?.currentSessionId
                } : undefined,
                selectionContext: (0, $fXyZM.selectionPluginKey).getState(state)?.lastSelectionContext ?? undefined,
                hasVisibleContent: (0, $6d81f3f6e54d61c8$export$59c835e23d1ad13).getState(state)?.hasVisibleContent ?? false,
                aiSessionPluginState: (0, $5oqzu.aiSessionContextPluginKey).getState(state) ?? (0, $278237b840ae0e27$export$d4c72bab9d6cc13a)
            };
        },
        pluginsOptions: {
            ...!isToolbarAIFCEnabled && {
                selectionToolbar: (0, $f886084167a12901$export$50f5e6709d50619a)({
                    aiGlobalOptIn: aiOptIn,
                    editorPluginAIProvider: editorPluginAIProvider,
                    api: api
                })
            },
            quickInsert: quickInsert,
            floatingToolbar: (0, $2368fa8f5f72e4ad$export$add2b8f99d5aac)({
                aiGlobalOptIn: aiOptIn,
                editorPluginAIProvider: editorPluginAIProvider,
                api: api
            })
        },
        contentComponent: ({ editorView: editorView, wrapperElement: wrapperElement, appearance: appearance, providerFactory: providerFactory, popupsMountPoint: popupsMountPoint })=>{
            if (!editorView) return null;
            // We're going to use a different collection of components for the AIFC experience. This should allow for
            // a better SoC and easier cleanup in the future and it will provide clear separation between the two, old/new experiences.
            // This also means we do not need to reference the AIFC feature flag in multiple places throughout the UI.
            const C = editorPluginAIProvider.isInDocumentStreamingEnabled ? (0, $800163a44b80a632$export$d1314adfeea5c2b2) : (0, $ecbdd1db4b4fae37$export$d1314adfeea5c2b2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
                aiOptIn: aiOptIn,
                api: api,
                editorView: editorView,
                wrapperElement: wrapperElement,
                appearance: appearance,
                editorPluginAIProvider: editorPluginAIProvider,
                providerFactory: providerFactory,
                getMentionNameDetails: getMentionNameDetails,
                canInlineStreamChanges: canInlineStreamChanges,
                isInDocumentStreamingEnabled: !!editorPluginAIProvider.isInDocumentStreamingEnabled,
                popupsMountPoint: popupsMountPoint,
                endExperience: ()=>{}
            });
        },
        primaryToolbarComponent: !api?.primaryToolbar && !editorPluginAIProvider.hidePrimaryToolbarButton ? (0, $6d89b70284814d64$export$d26e7f34c50ada62)({
            api: api,
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiOptIn
        }) : undefined
    };
};


const $b8e98ae92883425b$export$9cf35b434a79b498 = (0, $dfc2f6d166cc5144$export$7825a101a7e6b70b);
module.exports["aiPlugin"] = $b8e98ae92883425b$export$9cf35b434a79b498;

});

parcelRegister("1xicG", function(module, exports) {
function $6d214e2fef899580$export$f5f3c97efd684238(event) {
    switch(event.type){
        case 'complete':
            return {
                markdown: '',
                cacheKey: '',
                modelInput: {},
                ...event
            };
        case 'stream':
            return {
                markdown: '',
                ...event
            };
        case 'error':
            return {
                cacheKey: '',
                modelInput: {},
                ...event
            };
    }
}
module.exports["normaliseAIExperienceEvent"] = $6d214e2fef899580$export$f5f3c97efd684238;

});

parcelRegister("5SuLc", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $d925B = parcelRequire("d925B");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $ftzrq = parcelRequire("ftzrq");


var $dh538 = parcelRequire("dh538");


var $lzcvT = parcelRequire("lzcvT");


var $hX9je = parcelRequire("hX9je");


var $jdR93 = parcelRequire("jdR93");


var $6gJll = parcelRequire("6gJll");


var $4SGh1 = parcelRequire("4SGh1");


var $kTCUV = parcelRequire("kTCUV");


var $5oqzu = parcelRequire("5oqzu");


var $eyHC2 = parcelRequire("eyHC2");


var $7XFGZ = parcelRequire("7XFGZ");


var $LmqWp = parcelRequire("LmqWp");





var $cVxBN = parcelRequire("cVxBN");

function $bea841f054a8bba0$var$getWordsFromTextUsingSegmenter(text, locale) {
    const segmenter = new Intl.Segmenter(locale, {
        granularity: 'word'
    });
    const segments = Array.from(segmenter.segment(text));
    const words = segments.filter((segment)=>segment.isWordLike);
    return words.map((word)=>({
            text: word.segment,
            index: word.index
        }));
}
function $bea841f054a8bba0$var$getWordsFromTextUsingRegex(text) {
    const result = [];
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    const regex = /\S+/gu;
    const matches = text.matchAll(regex);
    for (const match of matches)result.push({
        text: match[0],
        index: match.index
    });
    return result;
}
function $bea841f054a8bba0$var$getWordsFromText(text, locale) {
    if (Intl.Segmenter) return $bea841f054a8bba0$var$getWordsFromTextUsingSegmenter(text, locale);
    return $bea841f054a8bba0$var$getWordsFromTextUsingRegex(text);
}
const $bea841f054a8bba0$var$expandSelectionToCompleteWords = (selectionPositions, { locale: locale })=>{
    const startPos = selectionPositions.startPos.pos;
    const endPos = selectionPositions.endPos.pos;
    const doc = selectionPositions.startPos.doc;
    let newStartPos = startPos;
    let newEndPos = endPos;
    let startPosTextNode;
    let endPosTextNode;
    let startPosTextNodePos;
    let endPosTextNodePos;
    doc.nodesBetween(startPos, endPos, (node, nodePos)=>{
        if (!startPosTextNode && node.isText) {
            startPosTextNode = node;
            startPosTextNodePos = nodePos;
        }
        if (node.isText) {
            endPosTextNode = node;
            endPosTextNodePos = nodePos;
        }
    });
    if (startPosTextNode && startPosTextNode.isText && startPosTextNode.text && startPosTextNodePos) {
        const words = $bea841f054a8bba0$var$getWordsFromText(startPosTextNode.text, locale);
        const startPosInText = startPos - startPosTextNodePos;
        const selectionStartWord = words.find((word)=>word.index < startPosInText && word.index + word.text.length > startPosInText);
        newStartPos = selectionStartWord ? selectionStartWord.index + startPosTextNodePos : startPos;
    }
    if (endPosTextNode && endPosTextNode.isText && endPosTextNode.text && endPosTextNodePos) {
        const words = $bea841f054a8bba0$var$getWordsFromText(endPosTextNode.text, locale);
        const endPosInText = endPos - endPosTextNodePos;
        const selectionEndWord = words.find((word)=>word.index < endPosInText && word.index + word.text.length > endPosInText);
        newEndPos = selectionEndWord ? selectionEndWord.index + selectionEndWord.text.length + endPosTextNodePos : endPos;
    }
    return {
        startPos: doc.resolve(newStartPos),
        endPos: doc.resolve(newEndPos)
    };
};
/**
 * If selection starts in caption, we need to wrap it into a valid media parent node as
 * it is the only way to inject it back into the doc.
 */ const $bea841f054a8bba0$var$expandSelectionToMediaIfInCaption = (selectionPositions)=>{
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const doc = startPos.doc;
    if (startPos.parent.type.name === 'caption') return {
        startPos: doc.resolve(startPos.start(Math.max(startPos.depth - 1, 1))),
        endPos: doc.resolve(endPos.end(Math.max(endPos.depth, 1)))
    };
    return selectionPositions;
};
/**
 * This transformer will expand the selection to the nearest ancestor block.
 * @see https://hello.atlassian.net/wiki/spaces/ac8/pages/5422770750/Selection+Streaming
 */ const $bea841f054a8bba0$var$expandSelectionToCommonBlockAncestor = (selectionPositions)=>{
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const doc = startPos.doc;
    if (startPos.parent !== endPos.parent) {
        // We want to quickly scan the range and check that the range encapsulates only specific items. If it doesn't
        // then we want to expand the selection to the nearest ancestor block.
        let expandRange = false;
        doc.nodesBetween(startPos.pos, endPos.pos, (node)=>{
            // We only want to expand the selection if the selection contains anything other than an inline element or a paragraph
            // This means this is a list of what is acceptable to be in a selection and not trigger an expansion of the selection.
            if (!(node.isInline || node.type.name === 'paragraph')) expandRange = true;
            return !expandRange;
        });
        if (expandRange) {
            const nodeRange = startPos.blockRange(endPos);
            if (!!nodeRange) return {
                startPos: doc.resolve(nodeRange.start),
                endPos: doc.resolve(nodeRange.end)
            };
        }
    }
    return selectionPositions;
};
const $bea841f054a8bba0$var$expandSelectionToNearestBlockNode = (selectionPositions)=>{
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const doc = startPos.doc;
    const { paragraph: paragraph, tableRow: tableRow } = doc.type.schema.nodes;
    if (startPos.parent !== endPos.parent) {
        /**
		 * We treat cells as a defining range so if the selection starts and ends in the same cell,
		 * we simply expand to the start and end of the position's blocks.
		 */ const isSameCell = (0, $cVxBN.isWithinSameCell)({
            $from: startPos,
            $to: endPos,
            schema: doc.type.schema
        });
        if (isSameCell) {
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) return {
                startPos: doc.resolve(startPos.start()),
                endPos: doc.resolve(endPos.end())
            };
            const sharedDepth = startPos.sharedDepth(endPos.pos);
            return {
                startPos: doc.resolve(startPos.start(sharedDepth)),
                endPos: doc.resolve(endPos.end(sharedDepth))
            };
        }
        // We want to quickly scan the range and check that the range encapsulates only specific items. If it doesn't
        // then we want to expand the selection to the nearest ancestor block.
        let expandRange = false;
        doc.nodesBetween(startPos.pos, endPos.pos, (node)=>{
            // We only want to expand the selection if the selection contains anything other than an inline element or a paragraph
            // This means this is a list of what is acceptable to be in a selection and not trigger an expansion of the selection.
            if (!(node.isInline || node.type === paragraph)) expandRange = true;
            return !expandRange;
        });
        if (expandRange) {
            let newStartPos = doc.resolve(startPos.start(Math.max(startPos.depth - 1, 1)));
            let newEndPos = doc.resolve(endPos.end());
            /**
			 * If we are expanding the range, if either end are inside a table we want to expand to the full row.
			 * This is important for streaming stability as it simplifies some of the conditions for streaming.
			 */ const startPosTableRowDepth = (0, $cVxBN.getPositionNodeTypeDepth)({
                resolvedPos: newStartPos,
                nodeType: tableRow
            });
            if (startPosTableRowDepth) // Extend by -1 to fully include the table row
            newStartPos = doc.resolve(newStartPos.start(startPosTableRowDepth) - ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? 1 : 0));
            const endPosTableRowDepth = (0, $cVxBN.getPositionNodeTypeDepth)({
                resolvedPos: newEndPos,
                nodeType: tableRow
            });
            if (endPosTableRowDepth) // Extend by +1 to fully include the table row
            newEndPos = doc.resolve(newEndPos.end(endPosTableRowDepth) + ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? 1 : 0));
            return {
                startPos: newStartPos,
                endPos: newEndPos
            };
        }
    }
    return selectionPositions;
};
const $bea841f054a8bba0$var$lookBackwardsForUnmergedRow = (mapByRow, startingIndex)=>{
    for(let i = startingIndex; i > 0; i--){
        // We keep checking the next row to see if there are any duplicate positions
        // If there are, it means that there are vertically merged cells and we want to extend the position
        const rowA = mapByRow[i - 1];
        const rowB = mapByRow[i];
        if (rowA.every((val, idx)=>val !== rowB[idx])) return i;
    }
    return 0;
};
const $bea841f054a8bba0$var$lookAheadForUnmergedRow = (mapByRow, startingIndex)=>{
    for(let i = startingIndex; i < mapByRow.length - 1; i++){
        // We keep checking the next row to see if there are any duplicate positions
        // If there are, it means that there are vertically merged cells and we want to extend the position
        const rowA = mapByRow[i];
        const rowB = mapByRow[i + 1];
        if (rowA.every((val, idx)=>val !== rowB[idx])) return i;
    }
    /**
	 * If the table is one row high OR everything is merged, we just return the last row
	 */ return mapByRow.length - 1;
};
const $bea841f054a8bba0$var$getCellPosFromDirectDescendant = (schema, $pos)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    for(let depth = $pos.depth; depth > 0; depth--){
        if ([
            tableCell,
            tableHeader
        ].includes($pos.node(depth).type)) return $pos.start(depth - 1);
    }
};
/**
 * Transforms a CellSelection's positions into normal ProseMirror positions.
 */ const $bea841f054a8bba0$var$transformCellSelectionToTextRange = (selectionPositions, context)=>{
    let selection = context.selection;
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const { doc: doc } = startPos;
    const { table: table, tableRow: tableRow } = doc.type.schema.nodes;
    if (!(selection instanceof (0, $7XFGZ.CellSelection)) && [
        table,
        tableRow
    ].includes(startPos.node(startPos.sharedDepth(endPos.pos)).type)) {
        /**
		 * If a selection spans across the same table, we want to convert it into a CellSelection.
		 * CellSelections aren't always created when dragging across cells with multiple child blocks for some reason...
		 */ const anchorCellPos = $bea841f054a8bba0$var$getCellPosFromDirectDescendant(doc.type.schema, startPos);
        const headCellPos = $bea841f054a8bba0$var$getCellPosFromDirectDescendant(doc.type.schema, endPos);
        if (anchorCellPos && headCellPos) selection = (0, $7XFGZ.CellSelection).create(doc, anchorCellPos, headCellPos);
    }
    if (selection instanceof (0, $7XFGZ.CellSelection)) {
        const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
        if ($headCell.pos === $anchorCell.pos) /**
			 * If the selection is a single cell selection, use the inner positions
			 */ return {
            startPos: doc.resolve($anchorCell.pos + 1),
            endPos: doc.resolve($anchorCell.pos + ($anchorCell.nodeAfter?.nodeSize || 0) - 1)
        };
        const tableNode = $anchorCell.node(-1);
        const tablePos = $anchorCell.start(-1);
        const map = (0, $LmqWp.TableMap).get(tableNode);
        const { mapByRow: mapByRow } = map;
        const rowIndexContainingAnchorCell = mapByRow.findIndex((r)=>r.includes($anchorCell.pos - tablePos));
        const rowIndexContainingHeadCell = mapByRow.findIndex((r)=>r.includes($headCell.pos - tablePos));
        let smallerRowIndex = Math.min(rowIndexContainingAnchorCell, rowIndexContainingHeadCell);
        let largerRowIndex = Math.max(rowIndexContainingAnchorCell, rowIndexContainingHeadCell);
        if (smallerRowIndex === -1 || largerRowIndex === -1) // we should always be able to find the rows, but if not, we return the original positions
        return selectionPositions;
        smallerRowIndex = $bea841f054a8bba0$var$lookBackwardsForUnmergedRow(mapByRow, smallerRowIndex);
        largerRowIndex = $bea841f054a8bba0$var$lookAheadForUnmergedRow(mapByRow, largerRowIndex);
        const startingCellIndex = Math.min(...mapByRow[smallerRowIndex]);
        const endingCellIndex = Math.max(...mapByRow[largerRowIndex]);
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
            const { map: allCells } = map;
            const veryFirstCellIndex = allCells[0];
            const veryLastCellIndex = allCells[allCells.length - 1];
            const entireTableSelected = startingCellIndex === veryFirstCellIndex && endingCellIndex === veryLastCellIndex;
            if (entireTableSelected) {
                const tableStart = doc.resolve(tablePos - 1);
                return {
                    startPos: tableStart,
                    endPos: doc.resolve(tableStart.pos + tableNode.nodeSize)
                };
            }
        }
        const startingCellPos = doc.resolve(tablePos + startingCellIndex);
        const endingCellPos = doc.resolve(tablePos + endingCellIndex);
        return {
            startPos: doc.resolve(startingCellPos.start(startingCellPos.depth + 1)),
            endPos: doc.resolve(endingCellPos.end(endingCellPos.depth))
        };
    }
    return selectionPositions;
};
/**
 * We need to expand any selections that cross over to multiple columns as the
 * layout plugin automatically repairs columns, but this can mean replacing a user's
 * column outside the selection to make room for the AI generated column.
 */ const $bea841f054a8bba0$var$expandSelectionToEntireLayout = (selectionPositions)=>{
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const doc = startPos.doc;
    const { layoutColumn: layoutColumn } = doc.type.schema.nodes;
    const startPosLayoutColumnDepth = (0, $cVxBN.getPositionNodeTypeDepth)({
        resolvedPos: startPos,
        nodeType: layoutColumn
    });
    const endPosLayoutColumnDepth = (0, $cVxBN.getPositionNodeTypeDepth)({
        resolvedPos: endPos,
        nodeType: layoutColumn
    });
    // If both are in layoutColumn, check if they're in the same layoutColumn
    if (startPosLayoutColumnDepth && endPosLayoutColumnDepth) {
        // Check if both positions are within the same layoutColumn by comparing
        // the start position of the layoutColumn at that depth
        const startLayoutColumnStart = startPos.start(startPosLayoutColumnDepth);
        const endLayoutColumnStart = endPos.start(endPosLayoutColumnDepth);
        if (startLayoutColumnStart === endLayoutColumnStart) // Both are in the same layoutColumn, don't expand
        return selectionPositions;
    }
    let newStartPos = startPos;
    let newEndPos = endPos;
    // If startPos is in layoutColumn, extend to start of layoutSection
    if (startPosLayoutColumnDepth && startPos.node(startPosLayoutColumnDepth - 1).childCount > 1) newStartPos = doc.resolve(startPos.start(startPosLayoutColumnDepth - 1));
    // If endPos is in layoutColumn, extend to end of layoutSection
    if (endPosLayoutColumnDepth && endPos.node(endPosLayoutColumnDepth - 1).childCount > 1) newEndPos = doc.resolve(endPos.end(endPosLayoutColumnDepth - 1));
    return {
        startPos: newStartPos,
        endPos: newEndPos
    };
};
const $bea841f054a8bba0$var$selectionTransformer = (transformers)=>(selectionPositions, context)=>{
        return transformers.reduce((newSelectionPositions, transformer)=>transformer(newSelectionPositions, context), selectionPositions);
    };
function $bea841f054a8bba0$export$188100af2e354326({ selectionPositions: selectionPositions, context: context, options: options }) {
    /**
	 * If there is no selection then don't expand it
	 */ if (selectionPositions.startPos.pos === selectionPositions.endPos.pos) return [
        selectionPositions.startPos.pos,
        selectionPositions.endPos.pos
    ];
    const { startPos: startPos, endPos: endPos } = $bea841f054a8bba0$var$selectionTransformer([
        /**
			 * Keep transformCellSelectionToTextRange first as it converts CellSelection into regular positions.
			 * This allows further transformations to happen if desired.
			 */ (!options || options.shouldTransformCellSelectionToTextRange) && $bea841f054a8bba0$var$transformCellSelectionToTextRange,
        (!options || options.shouldExpandSelectionToCompleteWords) && $bea841f054a8bba0$var$expandSelectionToCompleteWords,
        (!options || options.shouldExpandSelectionToMediaIfInCaption) && $bea841f054a8bba0$var$expandSelectionToMediaIfInCaption,
        (!options || options.shouldExpandSelectionToNearestBlockNode) && $bea841f054a8bba0$var$expandSelectionToNearestBlockNode,
        (!options || options.shouldExpandSelectionToCommonBlockAncestor) && $bea841f054a8bba0$var$expandSelectionToCommonBlockAncestor,
        (!options || options.shouldExpandSelectionToEntireLayout) && $bea841f054a8bba0$var$expandSelectionToEntireLayout
    ].filter((transformers)=>!!transformers))(selectionPositions, context);
    // Bound the positions by min and max
    const [min, max] = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? [
        0,
        startPos.doc.content.size
    ] : [
        1,
        startPos.doc.content.size - 1
    ];
    return [
        Math.max(min, startPos.pos),
        Math.min(max, endPos.pos)
    ];
}



var $1DOVk = parcelRequire("1DOVk");


var $fXyZM = parcelRequire("fXyZM");


var $kqrrC = parcelRequire("kqrrC");

const $ec256264b0897786$export$6428b9f2a07e29a5 = (isInDocumentStreamingEnabled)=>(pos, type, key)=>{
        const widgetSpanElement = document.createElement('span');
        // Firefox needs content inside the span in order to add height to the element.
        // Otherwise, the height is set to 0 which prevents the start and
        // end widgets from rendering correctly and produces incorrect measurements
        // when we need to determine where to place the modal under the content.
        // Zero width spaces have been known to introduce some strange selection
        // behaviour in the Editor, however this approach works for our use case
        // in the ai-plugin where we do not expect users to be making selections
        // over ai-highlighted content in the same way they select regular content
        // in the Editor, this is also not intended to be a permanent fix post EAP.
        if (!isInDocumentStreamingEnabled) widgetSpanElement.appendChild(document.createTextNode('\u200b'));
        widgetSpanElement.setAttribute('data-testid', `ai-modal-${type}-widget`);
        widgetSpanElement.className = `ai-modal-${type}-widget`;
        widgetSpanElement.contentEditable = 'false';
        return (0, $ftzrq.Decoration).widget(pos, widgetSpanElement, {
            side: type === 'start' ? 1 : -1,
            key: key ?? `${type}WidgetDecoration`
        });
    };
const $ec256264b0897786$export$846ae3cda2c26d54 = (pos)=>{
    const widgetSpanElement = document.createElement('span');
    widgetSpanElement.setAttribute('data-testid', `ai-modal-mount-point-widget`);
    widgetSpanElement.className = `ai-modal-mount-point-widget`;
    widgetSpanElement.contentEditable = 'false';
    return (0, $ftzrq.Decoration).widget(pos, widgetSpanElement, {
        side: 1,
        key: 'modalMountPointDecoration'
    });
};
const $ec256264b0897786$export$1690e22aee311809 = (from, to)=>{
    return (0, $ftzrq.Decoration).inline(from, to, {
        class: 'ai-selection-highlight',
        'data-testid': 'ai-selection-highlight'
    }, {
        key: 'inlineDecoration'
    });
};
const $ec256264b0897786$export$ee67e3280dab453d = (from, to, isInDocumentStreamingEnabled)=>{
    const startWidgetDecoration = $ec256264b0897786$export$6428b9f2a07e29a5(isInDocumentStreamingEnabled)(from, 'start', 'generatedStartWidget');
    const highlightInlineDecoration = (0, $ftzrq.Decoration).inline(from, to, {
        class: 'ai-generated-content-highlight',
        'data-testid': 'ai-generated-content-highlight'
    }, {
        key: 'generatedInlineDecoration'
    });
    const endWidgetDecoration = $ec256264b0897786$export$6428b9f2a07e29a5(isInDocumentStreamingEnabled)(to, 'end', 'generatedEndWidget');
    return [
        startWidgetDecoration,
        highlightInlineDecoration,
        endWidgetDecoration
    ];
};
const $ec256264b0897786$export$50894b1f0083184 = (from, to)=>{
    return (0, $ftzrq.Decoration).node(from, to, {
        class: 'ai-selection-node',
        'data-testid': 'ai-selection-node'
    }, {
        key: 'ai-nodeDecoration'
    });
};
const $ec256264b0897786$export$21c5d318062e995c = (from, to)=>{
    return (0, $ftzrq.Decoration).node(from, to, {
        class: 'ai-generated-node-highlight',
        'data-testid': 'ai-generated-node-highlight'
    }, {
        key: 'generatedNodeDecoration'
    });
};
function $ec256264b0897786$var$getInitialPositions(selection) {
    switch(true){
        case selection instanceof (0, $ks2lK.AllSelection):
            return {
                startPos: selection.from + 1,
                endPos: selection.to - 1
            };
        default:
            return {
                startPos: selection.from,
                endPos: selection.to
            };
    }
}
const $ec256264b0897786$export$4379c9f48a526c4d = ({ state: state })=>{
    const { selection: selection } = state;
    let from, to;
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        from = selection.from;
        to = selection.to;
    } else if ((0, $jdR93.isCellSelection)(state)) {
        const findResult = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.table)(selection);
        if (findResult) {
            const { depth: depth } = findResult;
            from = selection.$from.before(depth);
            to = selection.$from.after(depth);
        }
    } else {
        const { selection: selection } = state;
        const supportedNodes = (0, $jdR93.getSupportedNodesForAIModal)(state);
        const findResult = (0, $8m4tT.findParentNode)((node)=>supportedNodes.has(node.type))(selection);
        if (findResult) {
            const { depth: depth } = findResult;
            from = selection.$from.before(depth);
            to = selection.$from.after(depth);
        }
    }
    if (from !== undefined && to !== undefined) return [
        $ec256264b0897786$export$50894b1f0083184(from, to)
    ];
    return [];
};
const $ec256264b0897786$export$8b0c0139da7bc378 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, initialPositions: initialPositions })=>{
    /**
   * We add selection highlight decoration based on the current selection state of the document and the config item in the command palette
   * If the selection is empty and the document is not empty -> we decorate the entire document unless the config item specifies otherwise
   */ let useCurrentSelectionForHighlight = true;
    // when clicking `browse agents` then selecting an agent, the state.selection is already cleared
    // so we need to use initialPositions to check if the selection is empty
    if (initialPositions[0] === initialPositions[1] && state.doc.content.size !== 0) useCurrentSelectionForHighlight = !!configItem.doNotHighlightDocWhenSelectionIsEmpty;
    /**
   * EXPERIMENTAL: For experimental flow where 'Suggest title' in
   * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
   * Forces whole document selection, even if an existing selection exists.
   */ if ((0, $hX9je.isConfluenceTitleToolbarSuggestTitle)({
        configItem: configItem,
        lastTriggeredFrom: lastTriggeredFrom
    })) useCurrentSelectionForHighlight = false;
    const { startPos: startPos, endPos: endPos } = useCurrentSelectionForHighlight ? {
        startPos: initialPositions[0],
        endPos: initialPositions[1]
    } : $ec256264b0897786$var$getInitialPositions(new (0, $ks2lK.AllSelection)(state.doc));
    let decorations = [];
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $kqrrC.getPluginState)(state);
    const startWidgetDecoration = $ec256264b0897786$export$6428b9f2a07e29a5(isInDocumentStreamingEnabled)(initialPositions[0], 'start');
    const endWidgetDecoration = $ec256264b0897786$export$6428b9f2a07e29a5(isInDocumentStreamingEnabled)(initialPositions[1], 'end');
    decorations = initialPositions[0] === initialPositions[1] ? [
        endWidgetDecoration
    ] : [
        startWidgetDecoration,
        endWidgetDecoration
    ];
    decorations.push($ec256264b0897786$export$1690e22aee311809(startPos, endPos));
    return decorations;
};
function $ec256264b0897786$var$createEmptySelectionDecoration(startPos) {
    const widgetSpanElement = document.createElement('span');
    widgetSpanElement.setAttribute('data-testid', 'ai-pre-stream-empty-selection-caret');
    widgetSpanElement.className = 'ai-pre-stream-empty-selection-caret';
    widgetSpanElement.contentEditable = 'false';
    return (0, $ftzrq.Decoration).widget(startPos, widgetSpanElement, {
        side: 1,
        key: 'ai-pre-stream-empty-selection-caret'
    });
}
const $ec256264b0897786$export$2640287a220c13b0 = ({ state: state, configItem: configItem, initialPositions: initialPositions })=>{
    // We add selection highlight decoration based on the current selection of the document
    // when clicking `browse agents` then selecting an agent, the state.selection is cleared
    // so we need to use initialPositions to get the selection positions
    const startPos = initialPositions[0];
    const endPos = initialPositions[1];
    const isEmptySelection = startPos === endPos;
    const isSuggestTitle = (0, $hX9je.isSuggestTitleForConfluence)(configItem);
    const needSelectionDecoration = !isSuggestTitle;
    const decorations = [];
    if (needSelectionDecoration) {
        if (isEmptySelection) decorations.push($ec256264b0897786$var$createEmptySelectionDecoration(startPos));
        else {
            const preStreamRangeDecorations = (0, $ftzrq.Decoration).inline(startPos, endPos, {
                class: 'ai-pre-stream-range-selection',
                'data-testid': 'ai-pre-stream-range-selection'
            }, {
                key: 'ai-pre-stream-range-selection'
            });
            const mountPointRangeDecorations = (0, $ftzrq.Decoration).inline(startPos, endPos, {}, {
                key: 'modalMountPointRangeDecoration'
            });
            decorations.push(preStreamRangeDecorations, mountPointRangeDecorations);
        }
    }
    /**
   * Set the mount point of the widget to be directly after the endPos so that
   * replace steps during streaming will not remove the decoration as
   * that would unmount the modal + state machine
   */ const mountPos = isSuggestTitle ? 1 : isEmptySelection && !configItem.insertOnEmptySelection ? state.doc.content.size : Math.min(endPos, state.doc.content.size);
    const mountPointDecoration = $ec256264b0897786$export$846ae3cda2c26d54(mountPos);
    decorations.push(mountPointDecoration);
    return decorations;
};
const $ec256264b0897786$export$2c80ad35b3530be1 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, triggerMethod: triggerMethod, aiGlobalOptIn: aiGlobalOptIn, initialPrompt: initialPrompt, triggeredFor: triggeredFor, nudgeMetrics: /**
   * Nudge metrics will be used passed in analytics events.
   * It includes detailed metrics for improve writing nudge.
   * It is currently only set when "Improve writing" is triggered from the
   * "Improve writing" nudge.
   */ nudgeMetrics, locale: locale, isExternal: isExternal = false, withAcceptReject: withAcceptReject = true, withStreamingHighlight: withStreamingHighlight = true, hideLoadingScreen: hideLoadingScreen = false, traceId: traceId, isCreate: isCreate })=>{
    /**
   * WARNING: Do not remove the isFedRamp check.
   * This is to ensure that AI functionality is not enabled in FedRamp environments.
   */ if (aiGlobalOptIn.status === 'disabled' || (0, $lzcvT.isFedRamp)()) /**
     * If the user has opted out of AI, or if user is in FedRamp environment,
     * do not show the modal it's unclear how this function would be triggered as
     * all entry points should be removed already
     */ return ()=>false;
    if (aiGlobalOptIn.status === 'disabled-opt-in') {
        aiGlobalOptIn.triggerOptInFlow();
        return (0, $kqrrC.createCommand)({}, (tr)=>{
            (0, $4SGh1.addAnalytics)({
                editorState: state,
                tr: tr,
                payload: {
                    action: 'triggerOptInFlow',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'aiGlobalOptIn',
                    attributes: {
                        experienceType: (0, $6gJll.convertExperienceName)(configItem.key),
                        lastTriggeredFrom: lastTriggeredFrom,
                        selectionType: state.selection.empty ? 'empty' : 'range'
                    },
                    eventType: (0, $d925B.EVENT_TYPE).UI
                }
            });
            return tr;
        });
    }
    const { from: from, to: to } = state.selection;
    const aiDecorationExperiencePluginState = (0, $kqrrC.getPluginState)(state);
    const decorationPluginStateInitialPositions = aiDecorationExperiencePluginState.initialPositions;
    // For external commands respect the current selection
    let initialPositions = isExternal && aiDecorationExperiencePluginState.isInDocumentStreamingEnabled ? [
        from,
        to
    ] : decorationPluginStateInitialPositions || [
        from,
        to
    ];
    const adfStreamingEnabled = configItem.adfPrompt && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    // No need to expand selection for block nodes
    if (!triggeredFor?.isBlock && (adfStreamingEnabled || aiDecorationExperiencePluginState.isInDocumentStreamingEnabled)) {
        // For external commands respect the current selection
        if (isExternal) {
            const [start, end] = (0, $bea841f054a8bba0$export$188100af2e354326)({
                selectionPositions: {
                    startPos: state.selection.$from,
                    endPos: state.selection.$to
                },
                /**
         * Currently locale is optional because making it mandatory will require
         * 	big changes across many files and change in public api as well.
         * So we will currently fallback to "en-GB" if it is not provided.
         */ context: {
                    locale: locale ?? 'en-GB',
                    selection: state.selection
                },
                options: {
                    shouldExpandSelectionToCompleteWords: true,
                    shouldExpandSelectionToMediaIfInCaption: true,
                    shouldExpandSelectionToNearestBlockNode: true,
                    shouldTransformCellSelectionToTextRange: true
                }
            });
            initialPositions = [
                start,
                end
            ];
        } else {
            const selectionPositions = decorationPluginStateInitialPositions ? {
                startPos: state.doc.resolve(decorationPluginStateInitialPositions[0]),
                endPos: state.doc.resolve(decorationPluginStateInitialPositions[1])
            } : {
                startPos: state.selection.$from,
                endPos: state.selection.$to
            };
            const [start, end] = (0, $bea841f054a8bba0$export$188100af2e354326)({
                selectionPositions: selectionPositions,
                /**
         * Currently locale is optional because making it mandatory will require
         * 	big changes across many files and change in public api as well.
         * So we will currently fallback to "en-GB" if it is not provided.
         */ context: {
                    locale: locale ?? 'en-GB',
                    selection: state.selection
                },
                options: {
                    shouldExpandSelectionToCompleteWords: true,
                    shouldExpandSelectionToMediaIfInCaption: true,
                    shouldExpandSelectionToNearestBlockNode: true,
                    shouldTransformCellSelectionToTextRange: true,
                    shouldExpandSelectionToEntireLayout: aiDecorationExperiencePluginState.isInDocumentStreamingEnabled
                }
            });
            initialPositions = [
                start,
                end
            ];
        }
    }
    let modalDecorationSet = (0, $ftzrq.DecorationSet).empty;
    if (triggeredFor?.isBlock) {
        // First get the positions that the decorations will be added to the document at
        const decorations = $ec256264b0897786$export$4379c9f48a526c4d({
            state: state
        });
        if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
    } else {
        const decorations = aiDecorationExperiencePluginState.isInDocumentStreamingEnabled ? $ec256264b0897786$export$2640287a220c13b0({
            state: state,
            configItem: configItem,
            initialPositions: initialPositions
        }) : $ec256264b0897786$export$8b0c0139da7bc378({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: lastTriggeredFrom,
            initialPositions: initialPositions
        });
        if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
    }
    // This "command" is later picked up by a state reducer
    const action = {
        type: 'SHOW_MODAL',
        data: {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            interactionSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
            lastTriggeredFrom: lastTriggeredFrom,
            triggerMethod: triggerMethod,
            modalDecorationSet: modalDecorationSet,
            configItem: configItem,
            modalMountedTimeStamp: Date.now(),
            initialPrompt: initialPrompt,
            triggeredFor: triggeredFor,
            initialPositions: initialPositions,
            initialSelection: aiDecorationExperiencePluginState.initialSelection || state.selection,
            nudgeMetrics: nudgeMetrics,
            withAcceptReject: withAcceptReject,
            withStreamingHighlight: withStreamingHighlight,
            hideLoadingScreen: hideLoadingScreen,
            traceId: traceId,
            isCreate: isCreate
        }
    };
    if (aiDecorationExperiencePluginState.isInDocumentStreamingEnabled) return (0, $kqrrC.createCommand)(action, (tr)=>{
        // This is a special use case where we want to clear the selection locally, but inform the collab users that a selection
        // range was selected. The useSelectionBookmarkForRemote will be sent to collab users instead of the local setSelection.
        // We don't want to have a selection range in the editor when we start replacing the content with AI generated content.
        // This is because the FocusLock will keep draging focus away which will break selection ranges.
        // See: https://hello.jira.atlassian.cloud/browse/EDITOR-1090 for more details.
        const selection = tr.selection;
        const { to: to, from: from } = selection;
        if (!triggeredFor?.isBlock && to !== from) {
            tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, to));
            // There will be weird selection highlight if we don't clear the selection manually
            // see https://hello.jira.atlassian.cloud/browse/EDITOR-1405
            const domSelection = window.getSelection();
            if (domSelection) domSelection.removeAllRanges();
        }
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) // the orchestrator can send COMPLETE -> COMPLETE so we do this to reset the streaming state
        // and handle new content on the second COMPLETE
        tr.setMeta((0, $5oqzu.aiSessionContextPluginKey), {
            type: !isExternal ? 'PROMPT' : 'STREAM'
        });
        // when ai orchestrator endStreamCommand timeout, we need endStream to reset streaming state
        let endStreamCommand = (0, $eyHC2.endStream);
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) endStreamCommand = (0, $1DOVk.endStream);
        return endStreamCommand(tr).setMeta('useSelectionBookmarkForRemote', (0, $ks2lK.TextSelection).between(tr.doc.resolve(initialPositions[0]), tr.doc.resolve(initialPositions[1])).getBookmark()).setMeta((0, $fXyZM.selectionPluginKey), {
            action: 'lastSelectionContext',
            selection: selection
        }).setMeta('scrollIntoView', false);
    });
    else // Clear the selection after opening the modal to hide annotation toolbar
    return (0, $kqrrC.createCommand)(action, (tr)=>{
        const selection = tr.selection;
        const { to: to, from: from } = selection;
        if (!triggeredFor?.isBlock && to !== from) tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, to));
        return tr;
    });
};
const $ec256264b0897786$export$d547a4e9ddb6b51 = (modalDecorationSet, preserveEditorSelectionOnComplete, shouldClearSelectionContext, shouldIgnoreNextSpaceTrigger)=>{
    return (0, $kqrrC.createCommand)((state)=>{
        if (modalDecorationSet && !preserveEditorSelectionOnComplete) return {
            type: 'END_EXPERIENCE',
            data: {
                modalDecorationSet: modalDecorationSet,
                ignoredSpaceTriggerSelection: shouldIgnoreNextSpaceTrigger ? state.selection : undefined
            }
        };
        return {
            type: 'END_EXPERIENCE',
            data: {
                ignoredSpaceTriggerSelection: shouldIgnoreNextSpaceTrigger ? state.selection : undefined
            }
        };
    }, (tr, state)=>{
        if (preserveEditorSelectionOnComplete) {
            const inlineDeco = modalDecorationSet?.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration')?.[0];
            if (inlineDeco) tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, inlineDeco.from, Math.min(inlineDeco.to, tr.doc.content.size)));
        }
        const aiDecorationExperiencePluginState = (0, $kqrrC.getPluginState)(state);
        if (aiDecorationExperiencePluginState.isInDocumentStreamingEnabled) {
            if (shouldClearSelectionContext === false) tr.setMeta((0, $fXyZM.selectionPluginKey), {
                action: 'lastSelectionContextPending'
            });
            else tr.setMeta((0, $fXyZM.selectionPluginKey), {
                action: 'lastSelectionContext',
                selection: undefined
            });
            let endStreamCommand = (0, $eyHC2.endStream);
            if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) endStreamCommand = (0, $1DOVk.endStream);
            return endStreamCommand((0, $kTCUV.endWatchingAnnotationChanges)(tr));
        }
        return tr;
    });
};
const $ec256264b0897786$export$c93852418d091f41 = (state)=>{
    const aiDecorationExperiencePluginState = (0, $kqrrC.getPluginState)(state);
    const modalDecorationSet = aiDecorationExperiencePluginState.modalDecorationSet;
    const selectionDecorations = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-pre-stream-range-selection' || spec.key === 'ai-pre-stream-empty-selection-caret');
    return (0, $kqrrC.createCommand)({
        type: 'UPDATE_MODAL_DECORATION_SET',
        data: {
            modalDecorationSet: modalDecorationSet.remove(selectionDecorations)
        }
    });
};
const $ec256264b0897786$export$e580b88af920547a = (state, endWidgetDecorationPosition)=>{
    const aiDecorationExperiencePluginState = (0, $kqrrC.getPluginState)(state);
    const modalDecorationSet = aiDecorationExperiencePluginState.modalDecorationSet;
    const decorationWidget = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'endWidgetDecoration');
    let updated = modalDecorationSet.remove(decorationWidget);
    const updatedEndWidgetDecoration = $ec256264b0897786$export$6428b9f2a07e29a5(aiDecorationExperiencePluginState.isInDocumentStreamingEnabled)(endWidgetDecorationPosition, 'end');
    updated = updated.add(state.doc, [
        updatedEndWidgetDecoration
    ]);
    return (0, $kqrrC.createCommand)({
        type: 'UPDATE_MODAL_DECORATION_SET',
        data: {
            modalDecorationSet: updated
        }
    });
};
const $ec256264b0897786$export$5df233d57d4cef3c = (sessionId, traceId)=>{
    return (0, $kqrrC.createCommand)({
        type: 'START_SESSION',
        data: {
            sessionId: sessionId,
            traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceId : undefined
        }
    }, (tr)=>{
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) tr.setMeta((0, $5oqzu.aiSessionContextPluginKey), {
            type: 'START_SESSION',
            sessionId: sessionId
        });
        return tr;
    });
};
const $ec256264b0897786$export$785a49ccc46447ff = (sessionId)=>{
    return (0, $kqrrC.createCommand)((state)=>{
        const aiDecorationExperiencePluginState = (0, $kqrrC.getPluginState)(state);
        const nextSessionId = aiDecorationExperiencePluginState.nextSessionId;
        // If a sessions which is not the next session is trying to be ended then we should abort trying to end the session.
        if (sessionId !== nextSessionId) return false;
        return {
            type: 'END_SESSION',
            data: {
                sessionId: undefined
            }
        };
    });
};
const $ec256264b0897786$export$39f1b50f1a2d2906 = (targetId)=>{
    return (0, $kqrrC.createCommand)({
        type: 'UPDATE_TARGET_ID',
        data: {
            targetId: targetId
        }
    });
};
module.exports["createWidgetDecoration"] = $ec256264b0897786$export$6428b9f2a07e29a5;
module.exports["createModalMountPointDecoration"] = $ec256264b0897786$export$846ae3cda2c26d54;
module.exports["createInlineDecoration"] = $ec256264b0897786$export$1690e22aee311809;
module.exports["createGeneratedContentDecorations"] = $ec256264b0897786$export$ee67e3280dab453d;
module.exports["createGeneratedNodeDecorations"] = $ec256264b0897786$export$21c5d318062e995c;
module.exports["createOpenAIModalCommand"] = $ec256264b0897786$export$2c80ad35b3530be1;
module.exports["createEndAIExperienceCommand"] = $ec256264b0897786$export$d547a4e9ddb6b51;
module.exports["clearSelectionDecorations"] = $ec256264b0897786$export$c93852418d091f41;
module.exports["createStartAISessionCommand"] = $ec256264b0897786$export$5df233d57d4cef3c;
module.exports["createUpdateTargetIdCommand"] = $ec256264b0897786$export$39f1b50f1a2d2906;

});

parcelRegister("bwpRs", function(module, exports) {

var $hgTYG = parcelRequire("hgTYG");

var $86066e5809be062e$export$a48b28ab7ec6401c = /*#__PURE__*/ function(CONFIG_ITEM_KEYS) {
    CONFIG_ITEM_KEYS["ADD_STRUCTURE"] = "Add structure";
    CONFIG_ITEM_KEYS["BRAINSTORM"] = "Brainstorm";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_CASUAL"] = "Change tone to casual";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EDUCATIONAL"] = "Change tone to educational";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EMPATHETIC"] = "Change tone to empathetic";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_NEUTRAL"] = "Change tone to neutral";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_PROFESSIONAL"] = "Change tone to professional";
    CONFIG_ITEM_KEYS["CREATE_PULL_REQUEST_DESCRIPTION"] = "Create pull request description";
    CONFIG_ITEM_KEYS["DESCRIBE_YOUR_PULL_REQUEST"] = "Describe your pull request";
    CONFIG_ITEM_KEYS["FIND_ACTION_ITEMS"] = "Find action items";
    CONFIG_ITEM_KEYS["FIX_SPELLING_AND_GRAMMAR"] = "Fix spelling & grammar";
    CONFIG_ITEM_KEYS["FREE_GENERATE"] = "AI (Atlassian Intelligence)";
    CONFIG_ITEM_KEYS["FREE_GENERATE_EDITOR_AGENT"] = "AI (Atlassian Intelligence) Editor Agent";
    CONFIG_ITEM_KEYS["FREE_GENERATE_AIFC"] = "AI (Atlassian Intelligence) AIFC";
    CONFIG_ITEM_KEYS["IMPROVE_WRITING"] = "Improve writing";
    CONFIG_ITEM_KEYS["MAKE_SHORTER"] = "Make shorter";
    CONFIG_ITEM_KEYS["ROVO_AGENT"] = "Rovo agent";
    CONFIG_ITEM_KEYS["SHORTEN_UPDATE"] = "Shorten update";
    CONFIG_ITEM_KEYS["SUGGEST_A_TITLE"] = "Suggest a title";
    CONFIG_ITEM_KEYS["SUGGEST_RESPONSE"] = "Draft a Reply";
    CONFIG_ITEM_KEYS["DRAFT_REPLY_PILL"] = "Draft a Reply Pill";
    CONFIG_ITEM_KEYS["GENERATE_ESCALATION_NOTES"] = "Generate escalation notes";
    CONFIG_ITEM_KEYS["INCIDENT_SMART_COMMENTS"] = "Incident smart comments";
    CONFIG_ITEM_KEYS["SUMMARISE_WRITING"] = "Summarize writing";
    CONFIG_ITEM_KEYS["MAKE_LONGER"] = "Make longer";
    CONFIG_ITEM_KEYS["REPHRASE"] = "Rephrase";
    CONFIG_ITEM_KEYS["ADD_INTRODUCTION"] = "Add introduction";
    CONFIG_ITEM_KEYS["ADD_CONCLUSION"] = "Add conclusion";
    CONFIG_ITEM_KEYS["CONVERT_TO_BULLETED_LIST"] = "Convert to bulleted list";
    CONFIG_ITEM_KEYS["CONVERT_TO_TABLE"] = "Convert to table";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_SIMPLIFIED"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).ChineseSimplified}`] = "TRANSLATE_TO_CHINESE_SIMPLIFIED";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_TRADITIONAL"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).ChineseTraditional}`] = "TRANSLATE_TO_CHINESE_TRADITIONAL";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CZECH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Czech}`] = "TRANSLATE_TO_CZECH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_DANISH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Danish}`] = "TRANSLATE_TO_DANISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_DUTCH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Dutch}`] = "TRANSLATE_TO_DUTCH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_ENGLISH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).English}`] = "TRANSLATE_TO_ENGLISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_FINNISH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Finnish}`] = "TRANSLATE_TO_FINNISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_FRENCH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).French}`] = "TRANSLATE_TO_FRENCH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_GERMAN"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).German}`] = "TRANSLATE_TO_GERMAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_HUNGARIAN"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Hungarian}`] = "TRANSLATE_TO_HUNGARIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_ITALIAN"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Italian}`] = "TRANSLATE_TO_ITALIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_JAPANESE"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Japanese}`] = "TRANSLATE_TO_JAPANESE";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_KOREAN"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Korean}`] = "TRANSLATE_TO_KOREAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_NORWEGIAN"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Norwegian}`] = "TRANSLATE_TO_NORWEGIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_POLISH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Polish}`] = "TRANSLATE_TO_POLISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_PORTUGUESE_BRAZILIAN"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).PortugueseBrazilian}`] = "TRANSLATE_TO_PORTUGUESE_BRAZILIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_RUSSIAN"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Russian}`] = "TRANSLATE_TO_RUSSIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_SPANISH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Spanish}`] = "TRANSLATE_TO_SPANISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_SWEDISH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Swedish}`] = "TRANSLATE_TO_SWEDISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_TURKISH"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Turkish}`] = "TRANSLATE_TO_TURKISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_THAI"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Thai}`] = "TRANSLATE_TO_THAI";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_UKRAINIAN"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Ukrainian}`] = "TRANSLATE_TO_UKRAINIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_VIETNAMESE"] = `Translate to ${(0, $hgTYG.SupportedTranslationLanguages).Vietnamese}`] = "TRANSLATE_TO_VIETNAMESE";
    CONFIG_ITEM_KEYS["EXPERIMENTAL_PROMPT_PLACEHOLDER"] = "Experimental prompt placeholder";
    CONFIG_ITEM_KEYS["ADD_POLISH"] = "Add polish";
    return CONFIG_ITEM_KEYS;
}({});
module.exports["CONFIG_ITEM_KEYS"] = $86066e5809be062e$export$a48b28ab7ec6401c;

});

parcelRegister("klIiV", function(module, exports) {
// Note -- when updating this function -- also update
// the one used in packages/editor/editor-plugin-ai/examples/utils/getDevFetchCustomHeaders.ts
function $251b7a95a2e91930$export$bd1a8b310b130c9d() {
    const currentHost = window.location.origin;
    switch(true){
        case currentHost === 'https://statlas.prod.atl-paas.net':
            // Update this to add custom headers when run in atlaskit branch deploys
            // ie.
            // {
            //   'X-CloudID': 'Magic string'
            // }
            return {};
        default:
            return {};
    }
}
function $251b7a95a2e91930$export$9167f99f9be83b24() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window.location !== 'undefined' ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
const $251b7a95a2e91930$export$4388fb67ca0987b2 = `${$251b7a95a2e91930$export$9167f99f9be83b24()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
const $251b7a95a2e91930$export$fab0701b0fe45e18 = `${$251b7a95a2e91930$export$9167f99f9be83b24()}/gateway/api/assist/api/ai/v2/ai-feature/editor-ai/stream`;
const $251b7a95a2e91930$export$90e6b91c68d8e307 = `${$251b7a95a2e91930$export$9167f99f9be83b24()}/gateway/api/assist/rovo/v1/editor/conversation`; // + `/${channelID}/message/stream` at the end;
const $251b7a95a2e91930$export$603c96e42632fe6 = `${$251b7a95a2e91930$export$9167f99f9be83b24()}/gateway/api/ai/v2/ai-feature/audit-logs`;
const $251b7a95a2e91930$export$73e2b01807265672 = `${$251b7a95a2e91930$export$9167f99f9be83b24()}/gateway/api/assist/ai/v2/ai-feature/jira/issue/source-type/work-item/suggestions/stream`;
const $251b7a95a2e91930$export$8ee8ab4f2557589a = (endpoint)=>{
    switch(endpoint){
        case $251b7a95a2e91930$export$4388fb67ca0987b2:
            return 'assistance-service';
        case $251b7a95a2e91930$export$fab0701b0fe45e18:
            return 'convo-ai';
        case $251b7a95a2e91930$export$90e6b91c68d8e307:
            return 'rovo-agent';
        case $251b7a95a2e91930$export$603c96e42632fe6:
            return 'audit-logs';
        case $251b7a95a2e91930$export$73e2b01807265672:
            return 'jira-issue-reformatter';
        default:
            return 'unknown-api';
    }
};
module.exports["_getFetchCustomHeaders"] = $251b7a95a2e91930$export$bd1a8b310b130c9d;
module.exports["convoAIApiUrl"] = $251b7a95a2e91930$export$fab0701b0fe45e18;
module.exports["convoAIRovoApiURL"] = $251b7a95a2e91930$export$90e6b91c68d8e307;
module.exports["convoAIAuditLogApiURL"] = $251b7a95a2e91930$export$603c96e42632fe6;
module.exports["jiraIssueReformatterApiURL"] = $251b7a95a2e91930$export$73e2b01807265672;
module.exports["getAPIName"] = $251b7a95a2e91930$export$8ee8ab4f2557589a;

});

parcelRegister("70Lwl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");





var $f8c3d = parcelRequire("f8c3d");

const $e83a229f765541ed$export$2f25f69a3a44bbd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f8c3d))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });



var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $292411170d097ac6$export$f5df73dd633122b = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE,
        title: (0, $AMCQl.aiConfigItemMessages).suggestTitleTitle,
        description: (0, $AMCQl.aiConfigItemMessages).suggestTitleDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e83a229f765541ed$export$2f25f69a3a44bbd), null),
        intentSchemaId: 'suggest_title_intent_schema.json',
        featureId: 'suggest_title',
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'secondary'
                }),
                (0, $jc4DP.createInsertAtTop)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'secondary'
                }),
                (0, $jc4DP.createInsertAtTop)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $292411170d097ac6$export$42af4e6510e5964c = (options)=>({
        config: $292411170d097ac6$export$f5df73dd633122b(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $292411170d097ac6$export$eb5de8f75f72ed26 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE,
        title: (0, $AMCQl.aiConfigItemMessages).suggestTitleTitle,
        description: (0, $AMCQl.aiConfigItemMessages).suggestTitleDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e83a229f765541ed$export$2f25f69a3a44bbd), null),
        intentSchemaId: 'suggest_title_intent_schema.json',
        featureId: 'suggest_title',
        actions: {
            empty: [
                (0, $jc4DP.createReplaceExistingConfluenceTitle)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createReplaceExistingConfluenceTitle)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $292411170d097ac6$export$c844ceeb1848ab8d = (options)=>({
        config: $292411170d097ac6$export$eb5de8f75f72ed26(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["suggestTitleWithOptions"] = $292411170d097ac6$export$42af4e6510e5964c;
module.exports["suggestTitleForConfluenceTitleToolbar"] = $292411170d097ac6$export$eb5de8f75f72ed26;
module.exports["suggestTitleForConfluenceTitleToolbarWithOptions"] = $292411170d097ac6$export$c844ceeb1848ab8d;

});

parcelRegister("AMCQl", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $4c27f3ac5270dc35$export$e990f5ed7dd48de5 = (0, $cgtv4.defineMessages)({
    // Agent config messages
    agentConfigTitle: {
        id: "fabric.editor.ai.config.item.agent.title",
        defaultMessage: "Atlassian Intelligence Rovo Agent"
    },
    agentConfigDescription: {
        id: "fabric.editor.ai.config.item.range.agent.description",
        defaultMessage: "No description"
    },
    agentConfigPromptHint: {
        id: "fabric.editor.ai.config.item.range.agent.prompt.hint",
        defaultMessage: "Tell the Agent to write anything or choose from below"
    },
    // Config action messages
    configActionInsert: {
        id: "fabric.editor.ai.config.item.action.insert",
        defaultMessage: "Insert"
    },
    configActionInsertAtTop: {
        id: "fabric.editor.ai.config.item.action.insertAtTop",
        defaultMessage: "Insert at top"
    },
    configActionInsertBelow: {
        id: "fabric.editor.ai.config.item.action.insertBelow",
        defaultMessage: "Insert below"
    },
    configActionInsertBelowOriginal: {
        id: "fabric.editor.ai.config.item.action.insertBelowOriginal",
        defaultMessage: "Insert below original"
    },
    configActionReplace: {
        id: "fabric.editor.ai.config.item.action.replace",
        defaultMessage: "Replace"
    },
    configActionReplaceTitle: {
        id: "fabric.editor.ai.config.item.action.replaceTitle",
        defaultMessage: "Replace title"
    },
    configActionReplaceTitleTooLongDisabledTooltip: {
        id: "fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip",
        defaultMessage: "Title cannot exceed {maxLength} characters"
    },
    configActionContinueInChatLabel: {
        id: "fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel",
        defaultMessage: "Open in Chat"
    },
    configActionContinueChatLabel: {
        id: "fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel",
        defaultMessage: "Continue in chat"
    },
    configActionEdit: {
        id: "fabric.editor.ai.config.item.action.edit",
        defaultMessage: "Edit"
    },
    // Atlas shorten update messages
    atlasShortenUpdatetitle: {
        id: "fabric.editor.ai.config.item.atlas-shorten-update.title",
        defaultMessage: "Shorten update"
    },
    atlasShortenUpdateDescription: {
        id: "fabric.editor.ai.config.item.atlas-shorten-update.description",
        defaultMessage: "Shortens the content to make it more concise"
    },
    // Brainstorm messages
    brainstormTitle: {
        id: "fabric.editor.ai.config.item.brainstorm.title",
        defaultMessage: "Brainstorm"
    },
    brainstormDescription: {
        id: "fabric.editor.ai.config.item.brainstorm.description",
        defaultMessage: "Generates a list of ideas for a topic you provide"
    },
    brainstormPromptLabel: {
        id: "fabric.editor.ai.config.item.brainstorm.promptLabel",
        defaultMessage: "Brainstorm"
    },
    brainstormPromptHint: {
        id: "fabric.editor.ai.config.item.brainstorm.promptHint",
        defaultMessage: "Tell me the topic..."
    },
    // Adjust Length
    adjustLengthNestingParentTitle: {
        id: "fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle",
        defaultMessage: "Adjust length"
    },
    adjustLengthNestingParentShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle",
        defaultMessage: "Length"
    },
    // Change tone messages
    changeToneNestingParentTitlePostGA: {
        id: "fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA",
        defaultMessage: "Change tone to ..."
    },
    changeToneNeutralToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.neutralTone.title",
        defaultMessage: "Change tone to neutral"
    },
    changeToneNeutralToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle",
        defaultMessage: "Neutral"
    },
    changeToneNeutralToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.neutralTone.description",
        defaultMessage: "Changes the tone of the content to neutral"
    },
    changeToneNeutralToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Neutral"
    },
    changeToneProfessionalToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.professionalTone.title",
        defaultMessage: "Change tone to professional"
    },
    changeToneProfessionalToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle",
        defaultMessage: "Professional"
    },
    changeToneProfessionalToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.professionalTone.description",
        defaultMessage: "Changes the tone of the content to professional"
    },
    changeToneProfessionalToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Professional"
    },
    changeToneCasualToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.casualTone.title",
        defaultMessage: "Change tone to casual"
    },
    changeToneCasualToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.casualTone.shortTitle",
        defaultMessage: "Casual"
    },
    changeToneCasualToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.casualTone.description",
        defaultMessage: "Changes the tone of the content to casual"
    },
    changeToneCasualToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Casual"
    },
    changeToneEducationalToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.educationalTone.title",
        defaultMessage: "Change tone to educational"
    },
    changeToneEducationalToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle",
        defaultMessage: "Educational"
    },
    changeToneEducationalToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.educationalTone.description",
        defaultMessage: "Changes the tone of the content to educational"
    },
    changeToneEducationalToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Educational"
    },
    changeToneEmpatheticToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.empatheticTone.title",
        defaultMessage: "Change tone to empathetic"
    },
    changeToneEmpatheticToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle",
        defaultMessage: "Empathetic"
    },
    changeToneEmpatheticToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.empatheticTone.description",
        defaultMessage: "Changes the tone of the content to empathetic"
    },
    changeToneEmpatheticToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Empathetic"
    },
    // Convert to bullet list messages
    convertToBulletListTitle: {
        id: "fabric.editor.ai.config.item.convertToBulletList.title",
        defaultMessage: "Convert to bulleted list"
    },
    convertToBulletListDescription: {
        id: "fabric.editor.ai.config.item.convertToBulletList.description",
        defaultMessage: "Reformats content to a bulleted list"
    },
    // Convert to table messages
    convertToTableTitle: {
        id: "fabric.editor.ai.config.item.convertToTable.title",
        defaultMessage: "Convert to table"
    },
    convertToTableDescription: {
        id: "fabric.editor.ai.config.item.convertToTable.description",
        defaultMessage: "Reformats content to a table with headings"
    },
    // Draft reply messages
    draftReplyTitle: {
        id: "fabric.editor.ai.config.item.draftReply.title",
        defaultMessage: "Draft reply"
    },
    draftReplyDescription: {
        id: "fabric.editor.ai.config.item.draftReply.description",
        defaultMessage: "Drafts a reply based on issues similar to the one you\u2019re working on"
    },
    // Draft reply pill messages
    draftReplyHeroPromptTitle: {
        id: "fabric.editor.ai.config.item.draftReply.heroPromptTitle",
        defaultMessage: "Suggest reply"
    },
    draftReplyHeroPromptDescription: {
        id: "fabric.editor.ai.config.item.draftReply.heroPromptDescription",
        defaultMessage: "Enhances the reply based on issues similar to the one you\u2019re working on"
    },
    // Generate Escalation Notes messages
    generateEscalationNotesTitle: {
        id: "fabric.editor.ai.config.item.generateEscalationNotes.title",
        defaultMessage: "Generate escalation notes"
    },
    generateEscalationNotesDescription: {
        id: "fabric.editor.ai.config.item.generateEscalationNotes.description",
        defaultMessage: "Generates escalation notes based on the issue context"
    },
    // Enhance messages
    improveWritingTitle: {
        id: "fabric.editor.ai.config.item.enhance.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title",
        defaultMessage: "Improve writing"
    },
    fixSpellingGrammarTitle: {
        id: "fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title",
        defaultMessage: "Fix spelling & grammar"
    },
    improveWritingDescription: {
        id: "fabric.editor.ai.config.item.enhance.improveWriting.description",
        defaultMessage: "Enhances clarity, structure, and tone for better engagement and comprehension"
    },
    fixSpellingGrammarDescription: {
        id: "fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description",
        defaultMessage: "Fixes spelling and grammar mistakes"
    },
    fixSpellingGrammarSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title",
        defaultMessage: "Spelling & grammar"
    },
    // Find action items messages
    findActionItemsTitle: {
        id: "fabric.editor.ai.config.item.findActionItems.title",
        defaultMessage: "Find action items"
    },
    findActionItemsDescription: {
        id: "fabric.editor.ai.config.item.findActionItems.description",
        defaultMessage: "Finds action items in the content you provide"
    },
    // Free generate messages
    freeGeneratePromptHint: {
        id: "fabric.editor.ai.config.item.generateContent.promptHint",
        defaultMessage: "Write with AI or select from below"
    },
    freeGenerateRovoPromptHint: {
        id: "fabric.editor.ai.config.item.generateContent.rovoPromptHint",
        defaultMessage: "Write with Rovo or select from below"
    },
    // Free generate disabled messages
    freeGenerateDisabledPromptHint: {
        id: "fabric.editor.ai.config.item.freeGenerate.disabled.promptHint",
        defaultMessage: "Select from below (free generate is disabled in Elevate at this time)"
    },
    // Improve description messages
    reformatWithTemplateDescription: {
        id: "fabric.editor.ai.config.item.improveDescription.default.description",
        defaultMessage: "Restructure the issue description based on the issue type"
    },
    improveDescription: {
        id: "fabric.editor.ai.config.item.improveDescription.default.title.experiment.one",
        defaultMessage: "Improve description"
    },
    // Make longer messages
    makeLongerTitle: {
        id: "fabric.editor.ai.config.item.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeLongerDescription: {
        id: "fabric.editor.ai.config.item.makeLonger.description",
        defaultMessage: "Expands the content based on the context you provide"
    },
    // Make shorter messages
    makeShorterTitle: {
        id: "fabric.editor.ai.config.item.shorten.title",
        defaultMessage: "Make shorter"
    },
    makeShorterDescription: {
        id: "fabric.editor.ai.config.item.shorten.description",
        defaultMessage: "Shortens the content to make it more concise"
    },
    makeShorterSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title",
        defaultMessage: "Make shorter"
    },
    // PR Description messages
    prDescriptionTitle: {
        id: "fabric.editor.ai.config.item.bb.pr.description.title",
        defaultMessage: "Create pull request description"
    },
    prDescriptionDescription: {
        id: "fabric.editor.ai.config.item.bb.pr.description.description",
        defaultMessage: "Creates a pull request description with a summary of changes"
    },
    // Rephrase messages
    rephraseTitle: {
        id: "fabric.editor.ai.config.item.rephrase.title",
        defaultMessage: "Rephrase"
    },
    rephraseDescription: {
        id: "fabric.editor.ai.config.item.rephrase.description",
        defaultMessage: "Creates a suggestion for rewriting your sentences"
    },
    // Suggest title messages
    suggestTitleTitle: {
        id: "fabric.editor.ai.config.item.suggest.title",
        defaultMessage: "Suggest a title"
    },
    suggestTitleDescription: {
        id: "fabric.editor.ai.config.item.suggest.description",
        defaultMessage: "Suggests a title for content you provide"
    },
    // Summarize writing messages
    summarizeWritingtitle: {
        id: "fabric.editor.ai.config.item.summarize.title",
        defaultMessage: "Summarize writing"
    },
    summarizeWritingDescription: {
        id: "fabric.editor.ai.config.item.summarize.description",
        defaultMessage: "Creates a summary of the text you're working on, highlighting key points"
    },
    summarizeWritingSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.summarize.dropdownItem.title",
        defaultMessage: "Summarize writing"
    },
    addPolishTitle: {
        id: "fabric.editor.ai.config.item.addPolish.title",
        defaultMessage: "Add polish"
    },
    addPolishDescription: {
        id: "fabric.editor.ai.config.item.addPolish.description",
        defaultMessage: "Polishes the content to make it more polished"
    }
});
module.exports["aiConfigItemMessages"] = $4c27f3ac5270dc35$export$e990f5ed7dd48de5;

});

parcelRegister("jc4DP", function(module, exports) {

var $AMCQl = parcelRequire("AMCQl");


var $zT4ZO = parcelRequire("zT4ZO");


var $sxTNo = parcelRequire("sxTNo");


var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");


var $jOIil = parcelRequire("jOIil");


var $2e7rb = parcelRequire("2e7rb");


var $42omo = parcelRequire("42omo");


var $fUwkU = parcelRequire("fUwkU");

const $903fa0def847602f$export$d91f61e80e507e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUwkU))), {
        label: "",
        spacing: "spacious"
    });






var $4zFET = parcelRequire("4zFET");

const $73ef849765ef7d8c$export$d8090035f79e82b5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4zFET))), {
        label: "",
        spacing: "spacious"
    });



var $ieno2 = parcelRequire("ieno2");

const $b3997a54e2c6ceac$export$9e309baaf0e9d41b = ({ appearance: appearance })=>({
        type: 'markdown',
        title: (0, $AMCQl.aiConfigItemMessages).configActionInsertAtTop,
        appearance: appearance,
        run ({ editorView: editorView, pmFragment: pmFragment }) {
            const { state: state } = editorView;
            const transaction = state.tr;
            const slice = new (0, $5SAOw.Slice)(pmFragment, 0, 0);
            transaction.replace(0, 0, slice);
            (0, $ieno2.beforeDispatchAITransaction)(transaction, state);
            editorView.dispatch(transaction);
        },
        icon: (0, $73ef849765ef7d8c$export$d8090035f79e82b5)
    });
const $b3997a54e2c6ceac$export$2a99e23257616a3 = ({ appearance: appearance, factoryOptions: factoryOptions })=>({
        type: 'markdown',
        title: factoryOptions?.isInDocumentStreamingEnabled ? (0, $AMCQl.aiConfigItemMessages).configActionInsertBelowOriginal : (0, $AMCQl.aiConfigItemMessages).configActionInsertBelow,
        appearance: appearance,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor }) {
            const { state: state } = editorView;
            const transaction = state.tr;
            if ((0, $zT4ZO.fragmentContainsNodeType)(pmFragment, state.schema.nodes.table) && (0, $ieno2.shouldInsertAfterTable)({
                selection: state.selection,
                tableSchema: state.schema.nodes.table
            }) && (0, $sxTNo.isNestedTablesSupported)(state.schema)) (0, $ieno2.insertContentAfterTable)({
                pmFragment: pmFragment,
                transaction: transaction
            });
            else if (triggeredFor?.isBlock) {
                const insertPos = positions[1];
                (0, $8m4tT.safeInsert)(pmFragment, insertPos)(transaction);
                (0, $ieno2.beforeDispatchingTransactionForBlocks)(pmFragment, transaction, editorView.state);
            } else {
                let insertPos;
                /* eslint-disable no-unused-vars */ try {
                    insertPos = state.doc.resolve(positions[1]).after();
                } catch (error) {
                    insertPos = positions[1];
                }
                /* eslint-enable no-unused-vars */ (0, $8m4tT.safeInsert)(pmFragment, insertPos)(transaction);
            }
            (0, $ieno2.beforeDispatchAITransaction)(transaction, state);
            editorView.dispatch(transaction);
        },
        icon: (0, $903fa0def847602f$export$d91f61e80e507e8e)
    });
const $b3997a54e2c6ceac$export$6641dbc1b651cf28 = ({ appearance: appearance, isRovoAgentAction: isRovoAgentAction, title: title = (0, $AMCQl.aiConfigItemMessages).configActionInsert })=>({
        type: 'markdown',
        title: title,
        appearance: appearance,
        isRovoAgentAction: isRovoAgentAction,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment }) {
            const tr = (0, $ieno2.insertAIContentAtCurrentPosition)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment
            });
            if (isRovoAgentAction) (0, $ieno2.beforeDispatchAIRovoAgentTransaction)(tr);
            editorView.dispatch(tr);
        },
        icon: (0, $903fa0def847602f$export$d91f61e80e507e8e)
    });
const $b3997a54e2c6ceac$export$ab7194c13d7567bc = ({ appearance: appearance, isRovoAgentAction: isRovoAgentAction })=>({
        type: 'markdown',
        title: (0, $AMCQl.aiConfigItemMessages).configActionReplace,
        appearance: appearance,
        isRovoAgentAction: isRovoAgentAction,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, selectionMetaData: selectionMetaData, triggeredFor: triggeredFor }) {
            const tr = triggeredFor?.isBlock ? (0, $ieno2.replaceWithAIContentForBlock)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment
            }) : (0, $ieno2.replaceWithAIContent)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment,
                selectionMetaData: selectionMetaData
            });
            if (isRovoAgentAction) (0, $ieno2.beforeDispatchAIRovoAgentTransaction)(tr);
            editorView.dispatch(tr);
        }
    });
const $b3997a54e2c6ceac$export$bac6a2ed25caf91c = ({ appearance: appearance })=>({
        type: 'markdown',
        title: (0, $AMCQl.aiConfigItemMessages).configActionReplaceTitle,
        appearance: appearance,
        getDisabledState: ({ markdown: markdown, formatMessage: formatMessage })=>{
            const responseLength = markdown?.length ?? 0;
            // Source: next/packages/editor-title/src/EditorTitle.tsx
            const MAX_TITLE_LENGTH = 255;
            if (responseLength >= MAX_TITLE_LENGTH) return {
                isDisabled: true,
                tooltip: formatMessage((0, $AMCQl.aiConfigItemMessages).configActionReplaceTitleTooLongDisabledTooltip, {
                    maxLength: MAX_TITLE_LENGTH
                })
            };
            return {
                isDisabled: false
            };
        },
        run ({ editorView: editorView, pmFragment: pmFragment }) {
            const fragmentToInsert = pmFragment;
            let textContent = '';
            fragmentToInsert.forEach((node)=>{
                textContent += node.textContent;
            });
            const confluenceTitle = document.querySelector('textarea[data-ai-suggest-title-target="true"]');
            if (confluenceTitle) {
                const sourceEditorId = (0, $2e7rb.findEditorIdFromView)(editorView);
                if (sourceEditorId) (0, $jOIil.eventHub).publishFromEditor({
                    event: 'replace title in confluence',
                    data: {
                        analyticSourceId: 'confluenceTitleToolbar',
                        sourceEditorId: sourceEditorId,
                        title: textContent
                    }
                });
                confluenceTitle.scrollIntoView();
            }
        }
    });
module.exports["createInsertAtTop"] = $b3997a54e2c6ceac$export$9e309baaf0e9d41b;
module.exports["createInsertBelow"] = $b3997a54e2c6ceac$export$2a99e23257616a3;
module.exports["createInsertAtCurrentPosition"] = $b3997a54e2c6ceac$export$6641dbc1b651cf28;
module.exports["createReplace"] = $b3997a54e2c6ceac$export$ab7194c13d7567bc;
module.exports["createReplaceExistingConfluenceTitle"] = $b3997a54e2c6ceac$export$bac6a2ed25caf91c;

});

parcelRegister("8klLr", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $32e1a3aceab10983$export$9611928cf0c457d7 = (product)=>{
    switch(product){
        case 'CONFLUENCE':
            return 'confluence';
        case 'JSW':
            return 'jira-software';
        case 'JWM':
            return 'jira-core';
        case 'JSM':
            return 'jsm';
        case 'JPD':
            return 'jpd';
        case 'CSM':
            return (0, $dh538.fg)('csm_bridging_ai_feature_gaps') ? 'csm' : 'unknown';
        case 'ATLAS':
            return 'atlas';
        case 'JIRA_FAMILY':
            return 'jira';
        case 'BITBUCKET':
            return 'bitbucket';
        case 'TRELLO':
            return 'trello';
        case 'ELEVATE':
            return 'elevate';
        case 'RECRUIT':
            return 'recruit';
        case 'MERCURY':
            return 'mercury';
        case 'TOWNSQUARE':
            return 'townsquare';
        case 'ADMINHUB':
            return 'admin-hub';
        case 'GOAL':
            return 'goal';
        case 'PROJECT':
            return 'project';
        default:
            return 'unknown';
    }
};
module.exports["mapToAssistanceServiceProduct"] = $32e1a3aceab10983$export$9611928cf0c457d7;

});

parcelRegister("cSGOW", function(module, exports) {
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $6F6hl = parcelRequire("6F6hl");


var $imfiV = parcelRequire("imfiV");


var $BPkYg = parcelRequire("BPkYg");


var $4pXOZ = parcelRequire("4pXOZ");

const $e3ccda8699f33536$export$42f84e610f279c31 = ({ onCancel: onCancel, onRetry: onRetry, text: text, showRetryButton: showRetryButton = true, appearance: appearance, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $imfiV.useElementBreakpoints)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $BPkYg.ErrorFloatingContainer), {
        ref: setBreakpointsElement,
        breakpoint: breakpoint,
        appearance: appearance,
        isAIFC: isAIFC,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $4pXOZ.default).ariaErrorTitle)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $BPkYg.ErrorMessage), {
                breakpoint: breakpoint,
                isAIFC: isAIFC,
                children: text
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $BPkYg.ErrorButtonContainer), {
                isAIFC: isAIFC,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $BPkYg.ErrorButton), {
                        autoFocus: true,
                        testId: "cancel-button",
                        onClick: onCancel,
                        appearance: onRetry && showRetryButton ? 'subtle' : 'primary',
                        isAIFC: isAIFC,
                        children: formatMessage(isAIFC ? (0, $4pXOZ.default).closeLabel : (0, $4pXOZ.default).cancelLabel)
                    }),
                    onRetry && showRetryButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $BPkYg.ErrorButton), {
                        testId: 'retry',
                        onClick: onRetry,
                        appearance: "primary",
                        isAIFC: isAIFC,
                        children: formatMessage((0, $4pXOZ.default).retryLabel)
                    })
                ]
            })
        ]
    });
};
module.exports["ErrorScreen"] = $e3ccda8699f33536$export$42f84e610f279c31;

});

parcelRegister("7JKll", function(module, exports) {
/* Loading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $6F6hl = parcelRequire("6F6hl");


var $jO3S6 = parcelRequire("jO3S6");


var $kuYGt = parcelRequire("kuYGt");

/* Ellipses.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $bf61d89dc72580a8$var$animation = null;
const $bf61d89dc72580a8$var$animation1 = null;
const $bf61d89dc72580a8$var$animation2 = null;
const $bf61d89dc72580a8$var$dot1 = null;
const $bf61d89dc72580a8$var$dot2 = null;
const $bf61d89dc72580a8$var$dot3 = null;
const $bf61d89dc72580a8$var$ellipsesStyles = null;
const $bf61d89dc72580a8$var$EllipsesAnimation = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $gMc0m.default)([
            "_1tfpidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path" /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766*/ , {
                className: (0, $gMc0m.default)([
                    "_y44v1gpk",
                    "dot"
                ]),
                d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                className: (0, $gMc0m.default)([
                    "_y44v18gg",
                    "dot"
                ]),
                d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                className: (0, $gMc0m.default)([
                    "_y44voqx9",
                    "dot"
                ]),
                d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
                fill: "#FCA700"
            })
        ]
    });
};
var $bf61d89dc72580a8$export$2e2bcd8739ae039 = $bf61d89dc72580a8$var$EllipsesAnimation;



var $d7r2R = parcelRequire("d7r2R");


var $3ZqD0 = parcelRequire("3ZqD0");

/* CancelEscButton.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-unsafe-style-overrides */ 


parcelRequire("42omo");








var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $5lVpa = parcelRequire("5lVpa");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $cgtv4 = parcelRequire("cgtv4");

var $0e0c5056f7820d62$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    labelCancel: {
        id: "fabric.editor.ai.components.cancelEscButton.cancelLabel",
        defaultMessage: "Cancel"
    },
    labelEsc: {
        id: "fabric.editor.ai.components.cancelEscButton.escLabel",
        defaultMessage: "Esc"
    }
});


// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $723a53eab17e0848$var$escTextStylesUnbounded = null; // no tokens for 3px exist, so using raw values
const $723a53eab17e0848$var$escTextStyles = null;
const $723a53eab17e0848$var$inlineStyles = {
    container: "_stfgia51",
    escapeLabel: "_2rko12b0 _11c8wadc _19bv1b66 _u5f31b66 _ca0qv77o _n3tdv77o _bfhkysee _syaz1rpy",
    codeMd: "_2rko12b0 _11c8wadc _bfhkplhp _4t3igktf _1bsbd4y9 _y3gn1h6o _syaz1rpy _1e0c1o8l _ae4v1h6o"
};
const $723a53eab17e0848$export$d17714f4f279b358 = ({ onCancel: onCancel, autoFocus: autoFocus, shape: shape = 'default', isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return isAIFC ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $723a53eab17e0848$var$inlineStyles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: isAIFC ? $723a53eab17e0848$var$inlineStyles.escapeLabel : $723a53eab17e0848$var$inlineStyles.codeMd,
                children: formatMessage((0, $0e0c5056f7820d62$export$2e2bcd8739ae039).labelEsc)
            }, 'escape-command-text'),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                label: isAIFC ? formatMessage((0, $0e0c5056f7820d62$export$2e2bcd8739ae039).labelCancel) : 'video stop overlay icon',
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lVpa))), {
                        label: isAIFC ? '' : 'video-stop-overlay-icon',
                        color: "var(--ds-icon-danger, #C9372C)"
                    }),
                shape: shape,
                onClick: onCancel,
                autoFocus: autoFocus,
                appearance: "subtle"
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $ccHMk.default), {
        autoFocus: autoFocus,
        testId: "cancel-esc-button",
        type: "button",
        onClick: onCancel,
        children: [
            formatMessage((0, $0e0c5056f7820d62$export$2e2bcd8739ae039).labelCancel),
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_2rko12b0 _syazazsu _bfhki8nm _k48pi7a9",
                    "_ca0q1l7b _u5f31l7b _n3td1l7b _19bv1l7b _18u014y2"
                ]),
                children: formatMessage((0, $0e0c5056f7820d62$export$2e2bcd8739ae039).labelEsc)
            })
        ]
    });
};



var $40sdH = parcelRequire("40sdH");


var $jHWjW = parcelRequire("jHWjW");


var $8PgnR = parcelRequire("8PgnR");


var $imfiV = parcelRequire("imfiV");




var $f8cb9369b02c2766$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    iconAltText: {
        id: "fabric.editor.ai.screens.loading.iconAltText",
        defaultMessage: "Generating icon"
    },
    liveRegionDescription: {
        id: "fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription",
        defaultMessage: "Live updating content:"
    },
    loadingAriaTitle: {
        id: "fabric.editor.ai.experience.loadingAriaTitle",
        defaultMessage: "Generating"
    },
    loadingAriaNewTitle: {
        id: "fabric.editor.ai.experience.loadingAriaNewTitle",
        defaultMessage: "Rovo is working"
    },
    loadingAnalyzing: {
        id: "fabric.editor.ai.experience.loadingAnalyzing",
        defaultMessage: "Rovo is analyzing"
    },
    inlineCommentLoadingAnalyzing: {
        id: "fabric.editor.ai.experience.inlineCommentLoadingAnalyzing",
        defaultMessage: "Analyzing"
    },
    loadingEditingTitle: {
        id: "fabric.editor.ai.experience.loadingEditingTitle",
        defaultMessage: "Rovo is editing"
    },
    inlineCommentLoadingEditingTitle: {
        id: "fabric.editor.ai.experience.inlineCommentLoadingEditingTitle",
        defaultMessage: "Editing"
    },
    loadingShortening: {
        id: "fabric.editor.ai.experience.loadingShortening",
        defaultMessage: "Rovo is shortening"
    },
    loadingLengthening: {
        id: "fabric.editor.ai.experience.loadingLengthening",
        defaultMessage: "Rovo is lengthening"
    },
    loadingChangingTone: {
        id: "fabric.editor.ai.experience.loadingChangingTone",
        defaultMessage: "Rovo is changing the tone"
    },
    loadingFixingSpellingAndGrammar: {
        id: "fabric.editor.ai.experience.loadingFixingSpellingAndGrammar",
        defaultMessage: "Rovo is fixing spelling and grammar"
    },
    loadingTranslating: {
        id: "fabric.editor.ai.experience.loadingTranslating",
        defaultMessage: "Rovo is translating"
    },
    loadingPolishing: {
        id: "fabric.editor.ai.experience.loadingPolishing",
        defaultMessage: "Rovo is polishing"
    },
    loadingSummarizing: {
        id: "fabric.editor.ai.experience.loadingSummarizing",
        defaultMessage: "Rovo is summarizing"
    }
});



const $3a96ab104e914a9c$export$90359a624c464c3b = (title, formatMessage)=>{
    if (!title) return formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingEditingTitle);
    if (title.includes('Translate')) return formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingTranslating);
    if (title.includes('Change tone')) return formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingChangingTone);
    switch(title){
        case 'Make shorter':
            return formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingShortening);
        case 'Make longer':
            return formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingLengthening);
        case 'Fix spelling & grammar':
            return formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingFixingSpellingAndGrammar);
        case 'Add polish':
            return formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingPolishing);
        case 'Summarize':
            return formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingSummarizing);
        default:
            return formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingEditingTitle);
    }
};


const $74f9cd7e4fd10d1a$var$defaultPaddingStyles = null;
const $74f9cd7e4fd10d1a$var$loadingPaddingStyles = null;
const $74f9cd7e4fd10d1a$var$defaultPaddingNoInlineStreamChangesStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $74f9cd7e4fd10d1a$var$previewContainer = null;
const $74f9cd7e4fd10d1a$var$layoutStyles = null;
const $74f9cd7e4fd10d1a$var$layoutStylesPatchGa = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $74f9cd7e4fd10d1a$var$logoStyles = null;
const $74f9cd7e4fd10d1a$var$newLogoStyles = null;
const $74f9cd7e4fd10d1a$var$animatedLogoStyles = null;
const $74f9cd7e4fd10d1a$var$titleLayoutStyles = null;
const $74f9cd7e4fd10d1a$var$commonTextStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $74f9cd7e4fd10d1a$var$titleStyles = [
    $74f9cd7e4fd10d1a$var$titleLayoutStyles,
    $74f9cd7e4fd10d1a$var$commonTextStyles
];
const $74f9cd7e4fd10d1a$var$loadingIconStyles = null;
const $74f9cd7e4fd10d1a$var$ellipsesAnimationStyles = null;
const $74f9cd7e4fd10d1a$var$previewLoadingScreenStyles = null; /**
                                          * Could be either:
                                          * - userInput only (free form generate / interrogate)
                                          * - presetTitle only (summarize)
                                          * - both presetTitle and userInput (brainstorm)
                                          */ 
const $74f9cd7e4fd10d1a$export$e2b0760399e6dece = ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, title: title, latestPrompt: latestPrompt, preview: preview, providerFactory: providerFactory, schema: schema, onCancel: onCancel, agent: agent, disclaimer: disclaimer, isStreaming: isStreaming, canInlineStreamChanges: canInlineStreamChanges, hideLoadingScreen: hideLoadingScreen, appearance: appearance, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $imfiV.useElementBreakpoints)((0, $imfiV.Breakpoint).SmallChromeless);
    const setRootContainer = (element)=>{
        setBreakpointsElement(element);
    };
    const CommonFooter = ({ agent: agent, disclaimer: disclaimer })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $jHWjW.Footer), {
            brand: agent ? 'rovo' : 'atlassian-intelligence',
            disclaimer: disclaimer,
            showDisclaimer: true,
            isAIFC: isAIFC
        });
    const RovoIconSection = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "rovo-icon",
            className: (0, $gMc0m.default)([
                "_zulpftgi",
                "_2hwxv77o _1e0c1txw _4cvr1h6o",
                (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') && "_1bsb1tcg _4t3i1tcg"
            ]),
            children: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $jO3S6.LazyAnimatedRovoIcon), {
                alt: "Rovo",
                testId: "rovo-loading-animation"
            }) : isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                label: "",
                shouldUseHexLogo: true,
                size: "small"
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3ZqD0.default), {
                label: 'RovoIcon'
            })
        }), [
        isAIFC
    ]);
    const LoadingAnimationSection = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                isAIFC ? "_ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi" : "_ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp",
                "_1e0c1txw _2lx2vrvc _1bah1e5h _4cvr1h6o _1n261g80",
                (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') && "_1bah1yb4"
            ]),
            children: isAIFC ? /**
     * If aifc is on, we show the new loading modal
     */ /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                children: [
                    RovoIconSection,
                    /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                            "_11c8fhey _1nmz1hna"
                        ]),
                        children: [
                            isStreaming ? breakpoint <= (0, $imfiV.Breakpoint).SmallChromeless ? formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).inlineCommentLoadingEditingTitle) : (0, $3a96ab104e914a9c$export$90359a624c464c3b)(latestPrompt?.presetTitle, formatMessage) : formatMessage(breakpoint <= (0, $imfiV.Breakpoint).SmallChromeless ? (0, $f8cb9369b02c2766$export$2e2bcd8739ae039).inlineCommentLoadingAnalyzing : (0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingAnalyzing),
                            (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                className: (0, $gMc0m.default)([
                                    "_18u01b66"
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bf61d89dc72580a8$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    !(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bf61d89dc72580a8$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $723a53eab17e0848$export$d17714f4f279b358), {
                        onCancel: onCancel,
                        shape: "circle",
                        isAIFC: true
                    })
                ]
            }) : /**
     * Old loading modal
     */ /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        "data-testid": "loading-icon",
                        className: (0, $gMc0m.default)([
                            "_2hwxv77o _1e0c1txw _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d7r2R.default), {
                            alt: formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).iconAltText)
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                            "_11c8fhey _1nmz1hna"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $723a53eab17e0848$export$d17714f4f279b358), {
                        autoFocus: true,
                        onCancel: onCancel,
                        isAIFC: isAIFC
                    })
                ]
            })
        }), [
        RovoIconSection,
        isStreaming,
        breakpoint,
        formatMessage,
        latestPrompt?.presetTitle,
        onCancel,
        title,
        isAIFC
    ]);
    const LiveRegion = ({ preview: preview })=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingAriaTitle)
                }),
                preview && (isAIFC ? /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    "data-testid": "adf-content-live-region",
                    "aria-atomic": "false",
                    "aria-live": "polite",
                    className: (0, $gMc0m.default)([
                        "_ca0qutpp _19bvutpp _u5f3utpp"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                            testId: "description",
                            children: formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).liveRegionDescription)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                "_ca0q12x7"
                            ]),
                            children: preview
                        })
                    ]
                }) : /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    "data-testid": "adf-content-live-region",
                    "aria-atomic": "false",
                    "aria-live": "polite",
                    className: (0, $gMc0m.default)([
                        "_x3doia51 _n7zlia51",
                        "_ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                            testId: "description",
                            children: formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).liveRegionDescription)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            children: preview
                        })
                    ]
                }))
            ]
        });
    };
    if (hideLoadingScreen && canInlineStreamChanges && isAIFC) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40sdH.FloatingContainer), {
        ref: setRootContainer,
        "data-testid": "loading-screen",
        className: `loading-screen ${(0, $kuYGt.AI_MODAL_SCREEN_CLASS)}`,
        rainbowBorderAnimation: !isAIFC,
        rainbowBorder: !isAIFC,
        disablePadding: true,
        enableMaxWidth: isAIFC && canInlineStreamChanges,
        appearance: appearance,
        isAIFC: isAIFC,
        children: isAIFC ? canInlineStreamChanges ? /**
     * inline streaming route
     */ !hideLoadingScreen && LoadingAnimationSection : /**
     * fall back modal
     */ /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(LiveRegion, {
                    preview: preview
                }),
                LoadingAnimationSection,
                /*#__PURE__*/ (0, $l998X.jsx)(CommonFooter, {
                    agent: agent,
                    disclaimer: disclaimer
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: formatMessage((0, $f8cb9369b02c2766$export$2e2bcd8739ae039).loadingAriaTitle)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8PgnR.LatestPromptHeader), {
                    parentPresetPromptLabel: parentPresetPromptLabel,
                    childShortTitle: childShortTitle,
                    prompt: latestPrompt?.userInput,
                    promptADF: latestPrompt?.userADFInput,
                    presetTitle: latestPrompt?.presetTitle,
                    providerFactory: providerFactory,
                    schema: schema,
                    agent: agent,
                    showBack: true
                }),
                /*#__PURE__*/ (0, $l998X.jsx)(LiveRegion, {
                    preview: preview
                }),
                LoadingAnimationSection,
                /*#__PURE__*/ (0, $l998X.jsx)(CommonFooter, {
                    agent: agent,
                    disclaimer: disclaimer
                })
            ]
        })
    });
};
const $74f9cd7e4fd10d1a$export$f7ad13998187cb81 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($74f9cd7e4fd10d1a$export$e2b0760399e6dece);
module.exports["LoadingScreen"] = $74f9cd7e4fd10d1a$export$e2b0760399e6dece;
module.exports["MemoLoadingScreen"] = $74f9cd7e4fd10d1a$export$f7ad13998187cb81;

});

parcelRegister("8zG4S", function(module, exports) {
// Entry file
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jMZdB = parcelRequire("jMZdB");


var $9uNdP = parcelRequire("9uNdP");

const $f1322d34aaa32e3f$export$c1402aba00d7d987 = (agent)=>{
    const { id: id, name: name, description: description, named_id: named_id, creator_type: creator_type, system_prompt_template: system_prompt_template, creator: creator, visibility: visibility, is_default: is_default, identity_account_id: identity_account_id, icon: icon } = agent;
    return {
        id: id,
        name: name,
        description: description,
        namedId: named_id,
        creatorType: creator_type,
        systemPromptTemplate: system_prompt_template,
        creator: creator ?? undefined,
        visibility: visibility,
        isDefault: is_default,
        identityAccountId: identity_account_id,
        icon: icon,
        conversationStarters: (0, $jMZdB.getConversationStarters)({
            isAgentDefault: is_default,
            userDefinedConversationStarters: agent.user_defined_conversation_starters?.map((starter)=>{
                return {
                    message: starter,
                    type: 'user-defined'
                };
            })
        }).combinedConversationStarters,
        externalConfigReference: agent.external_config_reference
    };
};
module.exports["getEditorAgent"] = $f1322d34aaa32e3f$export$c1402aba00d7d987;

});

parcelRegister("eIhC8", function(module, exports) {

var $6bKwm = parcelRequire("6bKwm");


var $la6aw = parcelRequire("la6aw");

const $dd45787eb8cf0c02$export$457e869d5657c541 = ({ agents: agents, defaultAgent: defaultAgent })=>(0, $6bKwm.createCommand)(()=>{
        return {
            type: (0, $la6aw.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                // Exclude the default agent from the list of agents
                // See https://product-fabric.atlassian.net/browse/EDF-881
                agents: agents.filter((agent)=>agent.namedId !== 'ai_mate_agent'),
                defaultAgent: defaultAgent,
                initialised: true
            }
        };
    });
const $dd45787eb8cf0c02$export$fdede0d4e32ae86b = (open, rawPositions)=>{
    // Convert rawPositions into a structured format if provided.
    // This ensures that when the browse agents modal is closed,
    // the selection is restored correctly.
    const positions = rawPositions && {
        startPos: rawPositions[0],
        endPos: rawPositions[1]
    };
    return (0, $6bKwm.createCommand)(()=>{
        return {
            type: (0, $la6aw.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                isBrowseModalOpen: open,
                positions: positions
            }
        };
    });
};
const $dd45787eb8cf0c02$export$1fed3848898af3ea = (publish)=>{
    return (0, $6bKwm.createCommand)(()=>{
        return {
            type: (0, $la6aw.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                publish: publish
            }
        };
    });
};
const $dd45787eb8cf0c02$export$5947fe5279aaebd6 = (enabled)=>{
    return (0, $6bKwm.createCommand)(()=>{
        return {
            type: (0, $la6aw.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                enabled: enabled
            }
        };
    });
};
module.exports["updateAgents"] = $dd45787eb8cf0c02$export$457e869d5657c541;
module.exports["openBrowseAgentsModal"] = $dd45787eb8cf0c02$export$fdede0d4e32ae86b;
module.exports["updatePublish"] = $dd45787eb8cf0c02$export$1fed3848898af3ea;
module.exports["updateEnabled"] = $dd45787eb8cf0c02$export$5947fe5279aaebd6;

});

parcelRegister("cmDmV", function(module, exports) {

let $900613f33494ee70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $900613f33494ee70$var$load("hpUn4"),
    $900613f33494ee70$var$load("8Qv5g"),
    $900613f33494ee70$var$load("4Jbf1"),
    $900613f33494ee70$var$load("6wr18"),
    $900613f33494ee70$var$load("fKqF3"),
    $900613f33494ee70$var$load("ffEVr"),
    $900613f33494ee70$var$load("b2FtX"),
    $900613f33494ee70$var$load("6z3SN")
]).then(()=>parcelRequire('ckdGi'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("SFzFl", function(module, exports) {
$parcel$export(module.exports, "default", () => $e475b7743411e2ea$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $e475b7743411e2ea$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    aiUniversalLongCallToAction: {
        id: "fabric.editor.ai.shared.aiUniversalLongCallToAction",
        defaultMessage: "Let Atlassian Intelligence assist your writing"
    },
    rovoUniversalLongCallToAction: {
        id: "fabric.editor.ai.shared.rovoUniversalLongCallToAction",
        defaultMessage: "Collaborate with AI"
    },
    aiUniversalShortCallToAction: {
        id: "fabric.editor.ai.shared.aiUniversalShortCallToAction",
        defaultMessage: "Write"
    },
    aiProactiveButtonLabel: {
        id: "fabric.editor.ai.shared.aiProactiveButtonLabel",
        defaultMessage: "Suggestions"
    },
    aiProactiveDescriptor: {
        id: "fabric.editor.ai.shared.aiProactiveDescriptor.non-final",
        defaultMessage: "{count, plural, =0 {Open suggested edits} =1 {New suggested edit} =2 {Two new suggested edits} =3 {Three new suggested edits} =4 {Four new suggested edits} other {More than four new suggested edits}}"
    },
    aiProactiveCloseDescriptor: {
        id: "fabric.editor.ai.shared.aiProactiveDescriptorClose.non-final",
        defaultMessage: "Close suggested edits"
    },
    aiUniversalDescriptor: {
        id: "fabric.editor.ai.shared.aiUniversalDescriptor",
        defaultMessage: "Writing assistant"
    },
    aiButtonTitle: {
        id: "fabric.editor.ai.shared.generateContent.aiButtonTitle",
        defaultMessage: "AI (Atlassian Intelligence)"
    },
    rovoButtonTitle: {
        id: "fabric.editor.ai.shared.generateContent.rovoButtonTitle",
        defaultMessage: "Ask Rovo"
    },
    betaLabel: {
        id: "fabric.editor.ai.shared.betaLabel",
        defaultMessage: "Beta"
    }
});

});

parcelRegister("e83av", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

var $6jPem = parcelRequire("6jPem");


var $dh538 = parcelRequire("dh538");

class $3326de0ef316f293$var$Count {
    eq(other) {
        return this.chars === other.chars && this.length === other.length;
    }
    sub(other) {
        return new $3326de0ef316f293$var$Count(this.chars - other.chars, this.length - other.length);
    }
    gte(other) {
        return this.chars >= other.chars && this.length >= other.length;
    }
    constructor(chars, length){
        this.chars = chars;
        this.length = length;
    }
}
class $3326de0ef316f293$export$1511b8f647c790e {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setEmit(emit) {
        this.emit = emit;
    }
    setTickMs(tickMs) {
        this.cfg.tickMs = tickMs;
    }
    setCharsPerTick(charsPerTick) {
        this.charsPerTick = charsPerTick;
    }
    setMaxCharsPerTick(maxCharsPerTick) {
        this.cfg.maxCharsPerTick = maxCharsPerTick;
    }
    /**
   * you need to call setEmit before calling start
   *
   * @example
   * streamFlowPacer.setEmit();
   * streamFlowPacer.start();
   */ start() {
        if (this.destroyed) return;
        if (this.emit) this.timer = setInterval(()=>this.tick(), this.cfg.tickMs);
    }
    pause() {
        this.paused = true;
        this.stop();
    }
    resume() {
        this.paused = false;
        this.start();
    }
    destroy() {
        this.reset();
        this.destroyed = true;
    }
    onComplete(handler) {
        this.onCompleteHandlers.push(handler);
    }
    reset() {
        this.stop();
        this.emit = null;
        this.streamEvt = null;
        this.terminalEvt = null;
        this.charsPerTick = this.cfg.initialCharsPerTick;
        this.delivered = new $3326de0ef316f293$var$Count(0, 0);
        this.prevTickTime = 0;
        this.currTickTime = 0;
        this.ticksSinceRamp = 0;
        this.ramped = 0;
        this.paused = false;
        this.destroyed = false;
        this.onCompleteHandlers.length = 0;
    }
    isRunning() {
        return this.timer !== null;
    }
    stop() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
    tick() {
        this.prevTickTime = this.currTickTime;
        this.currTickTime = Date.now();
        if (this.paused || !(this.streamEvt || this.terminalEvt)) return;
        this.maybeRamp();
        this.deliverChunk();
        this.maybeFlushTerminal();
    }
    deliverChunk() {
        if (!this.streamEvt) return;
        const total = this.semanticLen(this.streamEvt);
        if (this.delivered.gte(total)) return;
        let slice;
        if (this.prevTickTime > 0 && this.currTickTime > 0 && this.currTickTime - this.prevTickTime >= 3000 && (0, $dh538.fg)('platform_editor_ai_aifc_background')) // If it's been more than 3 seconds since last tick,
        // assume the tab is in background, so we flush everything
        slice = this.sliceStreamEvt(this.streamEvt, -1);
        else if (this.delivered.chars >= total.chars && this.delivered.length < total.length) // No more text chars can be found we should flush the entire latest response
        slice = this.sliceStreamEvt(this.streamEvt, -1);
        else slice = this.sliceStreamEvt(this.streamEvt, Math.min(this.delivered.chars + this.charsPerTick, total.chars));
        if (!slice) return;
        this.emit?.(slice);
        this.delivered = this.semanticLen(slice);
        if (this.delivered.eq(total) && !!this.onCompleteHandlers.length) {
            this.onCompleteHandlers.forEach((handler)=>handler());
            this.onCompleteHandlers.length = 0;
        }
    }
    canFlushTerminal() {
        if (!this.terminalEvt) return false;
        // For "complete" we must wait until every char is flushed
        // For mock, the final response can be less than the sum of previous responses, so backlog can be negative
        if (this.terminalEvt.type === 'complete' || this.terminalEvt.type === 'response too similar') return this.backlog().chars <= 0;
        // All other terminal kinds (error, abort, etc.) bypass the backlog
        return true;
    }
    maybeFlushTerminal() {
        if (!this.canFlushTerminal()) return;
        if (this.terminalEvt) {
            this.emit?.(this.terminalEvt);
            this.destroy();
        }
    }
    maybeRamp() {
        if (!this.shouldRamp()) {
            this.ticksSinceRamp++;
            return;
        }
        this.charsPerTick = Math.min(Math.ceil(this.charsPerTick * this.cfg.ramp.growthFactor), this.cfg.maxCharsPerTick);
        this.ticksSinceRamp = 0;
        this.ramped++;
    }
    shouldRamp() {
        const wait = this.secondsToTicks(this.getRampDelay(this.cfg.ramp, this.ramped, this.terminalEvt));
        return (this.backlog().chars > this.cfg.backlogRampThreshold || this.terminalEvt?.type === 'response too similar') && this.ticksSinceRamp >= wait && this.charsPerTick < this.cfg.maxCharsPerTick;
    }
    backlog() {
        if (!this.streamEvt) return new $3326de0ef316f293$var$Count(0, 0);
        const result = this.semanticLen(this.streamEvt);
        return result.sub(this.delivered);
    }
    getRampDelay(rampConfig, rampedCnt, response) {
        if (response?.type === 'response too similar') return rampConfig.flushDelaySec;
        return rampedCnt > 0 ? rampConfig.stepDelaySec : rampConfig.initialDelaySec;
    }
    secondsToTicks(sec) {
        return sec * 1000 / this.cfg.tickMs;
    }
    semanticLen(evt) {
        if (!!evt.markdown && typeof evt.markdown === 'string') return new $3326de0ef316f293$var$Count(evt.markdown.length, evt.markdown.length);
        return this.adfTextLen(evt.adfResponse);
    }
    /**
   *
   * @param evt
   * @param chars
   * @returns
   */ sliceStreamEvt(evt, chars) {
        if (evt.adfResponse) {
            if (chars < 0) return {
                ...evt,
                adfResponse: evt.adfResponse
            };
            return {
                ...evt,
                adfResponse: this.truncateAdf(evt.adfResponse, chars)
            };
        }
        if (evt.markdown?.length) return {
            ...evt,
            markdown: evt.markdown.slice(0, chars < 0 ? undefined : chars)
        };
        return null;
    }
    adfTextLen(root) {
        if (!root) return new $3326de0ef316f293$var$Count(0, 0);
        const { chars: chars, length: length } = (0, $1A9t2.reduce)(root, (result, node)=>node.type === 'text' && typeof node.text === 'string' ? {
                chars: result.chars + node.text.length,
                length: result.length + node.text.length + 2
            } : {
                chars: result.chars,
                length: result.length + 2
            }, {
            chars: 0,
            length: 0
        });
        return new $3326de0ef316f293$var$Count(chars, length);
    }
    truncateAdf(root, budget) {
        let remaining = Math.max(0, budget);
        /**
     * Some older browsers like chrome 97 doesn't support structuredClone.
     * So using JSON.parse(JSON.stringify()) as a fallback.
     */ const clone = typeof window !== 'undefined' && typeof window.structuredClone === 'function' ? structuredClone(root) : JSON.parse(JSON.stringify(root));
        let lastTableRowLocalId;
        let remainingMergedRows = 1;
        return (0, $6jPem.traverse)(clone, {
            any (node, parent) {
                if (node.type === 'tableCell' || node.type === 'tableHeader') // merge information is stored inside cells, so we keep track of the largest rowspan we encounter
                remainingMergedRows = Math.max(remainingMergedRows, node.attrs?.rowspan || 1);
                // We subtract the 'merged rows' count as we encounter rows
                if (remainingMergedRows > 0 && node.type === 'tableRow') {
                    remainingMergedRows--;
                    if (!(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) return;
                }
                if (node.type === 'tableRow' && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) /**
           * Upon parsing a table row, we mark it as seen using the localId
           * so we can check when descending into the node whether to keep the row structure
           * or drop it entirely (if no chars are remaining when entering a table row)
           */ lastTableRowLocalId = node.attrs?.localId;
                if (remaining === 0) {
                    if (node.type === 'tableRow' && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                        if (remainingMergedRows === 0) return false;
                        return;
                    }
                    let ancestor = parent;
                    while(ancestor){
                        if (ancestor?.node?.type === 'tableRow') {
                            if (// if we're in the middle of a table row that has been parsed, we want to keep the rest of the cells
                            ancestor.node?.attrs?.localId === lastTableRowLocalId || // if there are still merged rows to be processed, we want to keep the following rows and cells too
                            remainingMergedRows > 0) {
                                if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                                    if (node.type === 'tableCell' || node.type === 'tableHeader') /**
                     * We return all cells in the current row that's being streamed to
                     * ensure the table row structure is maintained.
                     * We also keep table cell structures if there are still merged rows to be processed.
                     */ return;
                                    return false;
                                } else {
                                    if (node.type === 'text') /**
                     * If the row has been parsed (localId stored in lastTableRowLocalId), then
                     * we want to keep the empty cell but remove the text node
                     * to keep the structure of the table row valid.
                     */ return false;
                                    /**
                   * We don't return false here to keep non-text content inside a parsed row
                   * (tableHeader, tableCell). This ensures integrity of the row structure.
                   */ return;
                                }
                            }
                            return false;
                        }
                        ancestor = ancestor.parent;
                    }
                    return false;
                } else if (node.type === 'tableRow') /**
           * Clean up the whole else if statement.
           * When platform_editor_ai_aifc_patch_ga_blockers is on this is handled above
           */ {
                    if (!(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                        /**
             * Upon parsing a table row, we mark it as seen using the localId
             * so we can check when descending into the node whether to keep the row structure
             * or drop it entirely (if no chars are remaining when entering a table row)
             */ lastTableRowLocalId = node.attrs?.localId;
                        return {
                            ...node
                        };
                    }
                }
                if (node.type !== 'text' || typeof node.text !== 'string') return;
                if (node.text.length <= remaining) {
                    remaining -= node.text.length;
                    return;
                }
                const text = node.text.slice(0, remaining);
                remaining = 0;
                return {
                    ...node,
                    text: text
                };
            }
        });
    }
    constructor(cfg){
        this.cfg = cfg;
        this.push = (evt)=>{
            if (evt.type === 'stream') this.streamEvt = evt;
            else this.terminalEvt = evt;
        };
        this.timer = null;
        this.streamEvt = null;
        this.terminalEvt = null;
        this.charsPerTick = void 0;
        this.delivered = new $3326de0ef316f293$var$Count(0, 0);
        this.prevTickTime = 0;
        this.currTickTime = 0;
        this.ticksSinceRamp = 0;
        this.ramped = 0;
        this.paused = false;
        this.destroyed = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.emit = null;
        this.onCompleteHandlers = [];
        this.charsPerTick = cfg.initialCharsPerTick;
    }
}
module.exports["StreamFlowPacer"] = $3326de0ef316f293$export$1511b8f647c790e;

});

parcelRegister("ljZgt", function(module, exports) {
// import React from 'react';

var $AMCQl = parcelRequire("AMCQl");


var $jc4DP = parcelRequire("jc4DP");


var $jAwX6 = parcelRequire("jAwX6");


var $bwpRs = parcelRequire("bwpRs");

const $892f76d3f504c23a$export$23164faf8d4f39a5 = (agent, editorPluginAIProvider)=>{
    const continueInChat = (0, $jAwX6.createContinueInChatForAgent)({
        appearance: 'secondary',
        agent: agent,
        product: editorPluginAIProvider.product,
        actionSideEffect: editorPluginAIProvider.actionSideEffects?.['continueInChat'],
        actionOverride: editorPluginAIProvider.actionOverrides?.['continueInChat'],
        factoryOptions: {
            product: editorPluginAIProvider.product,
            isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled
        }
    });
    return {
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).ROVO_AGENT,
        title: (0, $AMCQl.aiConfigItemMessages).agentConfigTitle,
        description: (0, $AMCQl.aiConfigItemMessages).agentConfigDescription,
        statusLozengeType: 'beta',
        promptHint: (0, $AMCQl.aiConfigItemMessages).agentConfigPromptHint,
        // Required, since hasInitialPreset guard in palette state machine
        // checks this property for whether to transition to 'preset label'
        // (agent palette mode) during initialisation.
        promptLabel: {
            defaultMessage: agent?.name,
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            id: `fabric.editor.ai.config.item.range.agent.${agent?.name.toLocaleLowerCase().replace(/\s+/g, '.') || 'label'}`
        },
        disableInterrogation: ()=>false,
        agent: agent,
        intentSchemaId: 'DISABLED',
        getBackendModel: ()=>'assistance-service',
        actions: {
            empty: [
                continueInChat,
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary',
                    isRovoAgentAction: true
                })
            ],
            selection: [
                continueInChat,
                (0, $jc4DP.createReplace)({
                    appearance: 'primary',
                    isRovoAgentAction: true
                })
            ]
        }
    };
};
module.exports["createAgentConfigItem"] = $892f76d3f504c23a$export$23164faf8d4f39a5;

});

parcelRegister("iBSwI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");


var $lW0cT = parcelRequire("lW0cT");


var $dh538 = parcelRequire("dh538");





var $dLjaJ = parcelRequire("dLjaJ");

const $18f75d8831f5fb69$export$34a519f008c9006c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dLjaJ))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });








const $303d62aacb470601$export$1be00499caf729a1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });



var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $5bae4319dbc8890e$export$144a75c8acc1ab6b = (options)=>{
    const featureId = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? 'improve_writing_adf_gpt41mini' : 'improve_writing';
    const adfPrompt = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    return {
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).IMPROVE_WRITING,
        title: (0, $AMCQl.aiConfigItemMessages).improveWritingTitle,
        description: (0, $AMCQl.aiConfigItemMessages).improveWritingDescription,
        icon: ({ formatMessage: formatMessage })=>options?.isInDocumentStreamingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))), {
                label: formatMessage((0, $AMCQl.aiConfigItemMessages).improveWritingTitle),
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $303d62aacb470601$export$1be00499caf729a1), null),
        intentSchemaId: 'improve_quality_intent_schema.json',
        featureId: featureId,
        adfPrompt: adfPrompt,
        requiresTextualContent: adfPrompt,
        actions: {
            empty: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        },
        canToggleDiffPreview: true
    };
};
const $5bae4319dbc8890e$export$d332380ea195650 = (options)=>({
        config: $5bae4319dbc8890e$export$144a75c8acc1ab6b(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $5bae4319dbc8890e$export$f6fbbd65001c33d0 = ()=>{
    const featureId = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? 'fix_spelling_grammar_adf_gpt41mini' : 'fix_spelling_grammar';
    const adfPrompt = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    return {
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).FIX_SPELLING_AND_GRAMMAR,
        title: (0, $AMCQl.aiConfigItemMessages).fixSpellingGrammarTitle,
        description: (0, $AMCQl.aiConfigItemMessages).fixSpellingGrammarDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18f75d8831f5fb69$export$34a519f008c9006c), null),
        intentSchemaId: 'grammar_spelling_intent_schema.json',
        featureId: featureId,
        adfPrompt: adfPrompt,
        requiresTextualContent: adfPrompt,
        actions: {
            empty: [
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    };
};
const $5bae4319dbc8890e$export$76de7c1ccbf13f30 = (options)=>({
        config: $5bae4319dbc8890e$export$f6fbbd65001c33d0(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["improveWriting"] = $5bae4319dbc8890e$export$144a75c8acc1ab6b;
module.exports["improveWritingWithOptions"] = $5bae4319dbc8890e$export$d332380ea195650;
module.exports["fixSpellingAndGrammar"] = $5bae4319dbc8890e$export$f6fbbd65001c33d0;
module.exports["fixSpellingAndGrammarWithOptions"] = $5bae4319dbc8890e$export$76de7c1ccbf13f30;

});

parcelRegister("bpQiY", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $cgtv4 = parcelRequire("cgtv4");

const $36887e11a3be6176$export$b71056f6af7927e9 = (0, $cgtv4.defineMessages)({
    // Language Messages
    nestingParentTitle: {
        id: "fabric.editor.ai.config.item.translate.nestingParentTitle.ga",
        defaultMessage: "Translate"
    },
    nestingParentTitlePostGA: {
        id: "fabric.editor.ai.config.item.translate.nestingParentTitlePostGA",
        defaultMessage: "Translate to ..."
    },
    chineseSimplified: {
        id: "fabric.editor.ai.config.item.translate.chineseSimplified",
        defaultMessage: "Chinese (Simplified)"
    },
    chineseTraditional: {
        id: "fabric.editor.ai.config.item.translate.chineseTraditional",
        defaultMessage: "Chinese (Traditional)"
    },
    czech: {
        id: "fabric.editor.ai.config.item.translate.czech",
        defaultMessage: "Czech"
    },
    danish: {
        id: "fabric.editor.ai.config.item.translate.danish",
        defaultMessage: "Danish"
    },
    dutch: {
        id: "fabric.editor.ai.config.item.translate.dutch",
        defaultMessage: "Dutch"
    },
    english: {
        id: "fabric.editor.ai.config.item.translate.english",
        defaultMessage: "English"
    },
    finnish: {
        id: "fabric.editor.ai.config.item.translate.finnish",
        defaultMessage: "Finnish"
    },
    french: {
        id: "fabric.editor.ai.config.item.translate.french",
        defaultMessage: "French"
    },
    german: {
        id: "fabric.editor.ai.config.item.translate.german",
        defaultMessage: "German"
    },
    hungarian: {
        id: "fabric.editor.ai.config.item.translate.hungarian",
        defaultMessage: "Hungarian"
    },
    italian: {
        id: "fabric.editor.ai.config.item.translate.italian",
        defaultMessage: "Italian"
    },
    japanese: {
        id: "fabric.editor.ai.config.item.translate.japanese",
        defaultMessage: "Japanese"
    },
    korean: {
        id: "fabric.editor.ai.config.item.translate.korean",
        defaultMessage: "Korean"
    },
    norwegian: {
        id: "fabric.editor.ai.config.item.translate.norwegian",
        defaultMessage: "Norwegian"
    },
    polish: {
        id: "fabric.editor.ai.config.item.translate.polish",
        defaultMessage: "Polish"
    },
    portugueseBrazilian: {
        id: "fabric.editor.ai.config.item.translate.portugueseBrazilian",
        defaultMessage: "Portuguese (Brazilian)"
    },
    russian: {
        id: "fabric.editor.ai.config.item.translate.russian",
        defaultMessage: "Russian"
    },
    spanish: {
        id: "fabric.editor.ai.config.item.translate.spanish",
        defaultMessage: "Spanish"
    },
    swedish: {
        id: "fabric.editor.ai.config.item.translate.swedish",
        defaultMessage: "Swedish"
    },
    turkish: {
        id: "fabric.editor.ai.config.item.translate.turkish",
        defaultMessage: "Turkish"
    },
    thai: {
        id: "fabric.editor.ai.config.item.translate.thai",
        defaultMessage: "Thai"
    },
    ukrainian: {
        id: "fabric.editor.ai.config.item.translate.ukrainian",
        defaultMessage: "Ukrainian"
    },
    vietnamese: {
        id: "fabric.editor.ai.config.item.translate.vietnamese",
        defaultMessage: "Vietnamese"
    },
    // Translate to messages
    chineseSimplifiedTitle: {
        id: "fabric.editor.ai.config.item.translateTo.chineseSimplified.title",
        defaultMessage: "Translate to Chinese (Simplified)"
    },
    chineseSimplifiedDescription: {
        id: "fabric.editor.ai.config.item.translateTo.chineseSimplified.description",
        defaultMessage: "Translates the text you're working on to Chinese (Simplified)"
    },
    chineseTraditionalTitle: {
        id: "fabric.editor.ai.config.item.translateTo.chineseTraditional.title",
        defaultMessage: "Translate to Chinese (Traditional)"
    },
    chineseTraditionalDescription: {
        id: "fabric.editor.ai.config.item.translateTo.chineseTraditional.description",
        defaultMessage: "Translates the text you're working on to Chinese (Traditional)"
    },
    czechTitle: {
        id: "fabric.editor.ai.config.item.translateTo.czech.title",
        defaultMessage: "Translate to Czech"
    },
    czechDescription: {
        id: "fabric.editor.ai.config.item.translateTo.czech.description",
        defaultMessage: "Translates the text you're working on to Czech"
    },
    danishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.danish.title",
        defaultMessage: "Translate to Danish"
    },
    danishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.danish.description",
        defaultMessage: "Translates the text you're working on to Danish"
    },
    dutchTitle: {
        id: "fabric.editor.ai.config.item.translateTo.dutch.title",
        defaultMessage: "Translate to Dutch"
    },
    dutchDescription: {
        id: "fabric.editor.ai.config.item.translateTo.dutch.description",
        defaultMessage: "Translates the text you're working on to Dutch"
    },
    englishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.english.title",
        defaultMessage: "Translate to English"
    },
    englishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.english.description",
        defaultMessage: "Translates the text you're working on to English"
    },
    finnishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.finnish.title",
        defaultMessage: "Translate to Finnish"
    },
    finnishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.finnish.description",
        defaultMessage: "Translates the text you're working on to Finnish"
    },
    frenchTitle: {
        id: "fabric.editor.ai.config.item.translateTo.french.title",
        defaultMessage: "Translate to French"
    },
    frenchDescription: {
        id: "fabric.editor.ai.config.item.translateTo.french.description",
        defaultMessage: "Translates the text you're working on to French"
    },
    germanTitle: {
        id: "fabric.editor.ai.config.item.translateTo.german.title",
        defaultMessage: "Translate to German"
    },
    germanDescription: {
        id: "fabric.editor.ai.config.item.translateTo.german.description",
        defaultMessage: "Translates the text you're working on to German"
    },
    hungarianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.hungarian.title",
        defaultMessage: "Translate to Hungarian"
    },
    hungarianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.hungarian.description",
        defaultMessage: "Translates the text you're working on to Hungarian"
    },
    italianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.italian.title",
        defaultMessage: "Translate to Italian"
    },
    italianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.italian.description",
        defaultMessage: "Translates the text you're working on to Italian"
    },
    japaneseTitle: {
        id: "fabric.editor.ai.config.item.translateTo.japanese.title",
        defaultMessage: "Translate to Japanese"
    },
    japaneseDescription: {
        id: "fabric.editor.ai.config.item.translateTo.japanese.description",
        defaultMessage: "Translates the text you're working on to Japanese"
    },
    koreanTitle: {
        id: "fabric.editor.ai.config.item.translateTo.korean.title",
        defaultMessage: "Translate to Korean"
    },
    koreanDescription: {
        id: "fabric.editor.ai.config.item.translateTo.korean.description",
        defaultMessage: "Translates the text you're working on to Korean"
    },
    norwegianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.norwegian.title",
        defaultMessage: "Translate to Norwegian"
    },
    norwegianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.norwegian.description",
        defaultMessage: "Translates the text you're working on to Norwegian"
    },
    polishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.polish.title",
        defaultMessage: "Translate to Polish"
    },
    polishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.polish.description",
        defaultMessage: "Translates the text you're working on to Polish"
    },
    portugueseBrazilianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title",
        defaultMessage: "Translate to Portuguese (Brazilian)"
    },
    portugueseBrazilianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description",
        defaultMessage: "Translates the text you're working on to Portuguese (Brazilian)"
    },
    russianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.russian.title",
        defaultMessage: "Translate to Russian"
    },
    russianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.russian.description",
        defaultMessage: "Translates the text you're working on to Russian"
    },
    spanishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.spanish.title",
        defaultMessage: "Translate to Spanish"
    },
    spanishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.spanish.description",
        defaultMessage: "Translates the text you're working on to Spanish"
    },
    swedishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.swedish.title",
        defaultMessage: "Translate to Swedish"
    },
    swedishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.swedish.description",
        defaultMessage: "Translates the text you're working on to Swedish"
    },
    turkishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.turkish.title",
        defaultMessage: "Translate to Turkish"
    },
    turkishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.turkish.description",
        defaultMessage: "Translates the text you're working on to Turkish"
    },
    thaiTitle: {
        id: "fabric.editor.ai.config.item.translateTo.thai.title",
        defaultMessage: "Translate to Thai"
    },
    thaiDescription: {
        id: "fabric.editor.ai.config.item.translateTo.thai.description",
        defaultMessage: "Translates the text you're working on to Thai"
    },
    ukrainianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.ukrainian.title",
        defaultMessage: "Translate to Ukrainian"
    },
    ukrainianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.ukrainian.description",
        defaultMessage: "Translates the text you're working on to Ukrainian"
    },
    vietnameseTitle: {
        id: "fabric.editor.ai.config.item.translateTo.vietnamese.title",
        defaultMessage: "Translate to Vietnamese"
    },
    vietnameseDescription: {
        id: "fabric.editor.ai.config.item.translateTo.vietnamese.description",
        defaultMessage: "Translates the text you're working on to Vietnamese"
    }
});
module.exports["aiLanguageMessages"] = $36887e11a3be6176$export$b71056f6af7927e9;

});

parcelRegister("eugUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14d3508a57d0950b33e5e611a6d67b81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8c0fbec8ff90f28$var$_react = $a8c0fbec8ff90f28$var$_interopRequireDefault((parcelRequire("42omo")));

var $a8c0fbec8ff90f28$var$_baseNew = $a8c0fbec8ff90f28$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a8c0fbec8ff90f28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLengthen".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Lengthening text content with Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8c0fbec8ff90f28$var$TextLengthenIcon = (props)=>/*#__PURE__*/ $a8c0fbec8ff90f28$var$_react.default.createElement($a8c0fbec8ff90f28$var$_baseNew.default, Object.assign({
        name: "TextLengthenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm0 4.167H1v-1.5h14zm0 4.166H1v-1.5h14zM8 15H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$a8c0fbec8ff90f28$var$TextLengthenIcon.displayName = 'TextLengthenIcon';
var $a8c0fbec8ff90f28$var$_default = module.exports.default = $a8c0fbec8ff90f28$var$TextLengthenIcon;

});

parcelRegister("cbtR4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e145ebbd6eaf2e0b8e4930467ce4a33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8dedabaf09e709a0$var$_react = $8dedabaf09e709a0$var$_interopRequireDefault((parcelRequire("42omo")));

var $8dedabaf09e709a0$var$_baseNew = $8dedabaf09e709a0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8dedabaf09e709a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeCleanup".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for automated cleanup and tidy functionality
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8dedabaf09e709a0$var$AiGenerativeCleanupIcon = (props)=>/*#__PURE__*/ $8dedabaf09e709a0$var$_react.default.createElement($8dedabaf09e709a0$var$_baseNew.default, Object.assign({
        name: "AiGenerativeCleanupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.23.44 12.22 8h1.58a2 2 0 0 1 1.91 2.59l-1.23 4a2 2 0 0 1-1.9 1.41H4.75a.75.75 0 0 1-.28-1.45h-.01l.02-.01q.03-.01.1-.06c.09-.06.23-.16.39-.32.31-.32.71-.88.93-1.84l.03-.09L7 9.3A2 2 0 0 1 8.87 8h1.8L12.78.06zM8.87 9.5a.5.5 0 0 0-.47.33l-1.06 2.89a5.7 5.7 0 0 1-.73 1.78h5.97a.5.5 0 0 0 .48-.35l1.23-4a.5.5 0 0 0-.48-.65zM4.62 1.01a.75.75 0 0 1 .54.38l.05.11.54 1.47.05.1a.5.5 0 0 0 .25.2l1.47.54.11.05a.75.75 0 0 1 0 1.31l-.11.05-1.47.54a.5.5 0 0 0-.3.3l-.54 1.47a.75.75 0 0 1-1.36.11l-.05-.1-.54-1.47a.5.5 0 0 0-.2-.25l-.1-.05-1.47-.53a.75.75 0 0 1-.48-.59L1 4.5l.01-.12a.75.75 0 0 1 .48-.59l1.47-.54.1-.05a.5.5 0 0 0 .2-.25l.54-1.47.05-.11A.75.75 0 0 1 4.5 1z"/>`
    }, props));
$8dedabaf09e709a0$var$AiGenerativeCleanupIcon.displayName = 'AiGenerativeCleanupIcon';
var $8dedabaf09e709a0$var$_default = module.exports.default = $8dedabaf09e709a0$var$AiGenerativeCleanupIcon;

});

parcelRegister("l5nYy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");

var $7ShCl = parcelRequire("7ShCl");


var $bAxHS = parcelRequire("bAxHS");


var $dh538 = parcelRequire("dh538");





var $j398X = parcelRequire("j398X");

const $bef4a50ba85ef080$export$8b4784439604ca83 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j398X))), {
        color: "currentColor",
        label: "",
        spacing: "spacious"
    });






var $gWb8i = parcelRequire("gWb8i");

const $334f53e1c24ec9cf$export$61c3f03f8b900938 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gWb8i))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });






var $j8LwF = parcelRequire("j8LwF");

const $f6488db947ac5932$export$e378d926184098e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j8LwF))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });






var $kMl1Y = parcelRequire("kMl1Y");

const $57520f0cde7fe260$export$53c14326c671fdf0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMl1Y))), {
        color: "currentColor",
        label: "",
        spacing: "spacious"
    });






var $oeZjt = parcelRequire("oeZjt");

const $d144fa220b28cd85$export$d11b06b5c6e28f63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });



var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

function $681a4e3834a0476d$var$createChangeToneOption({ key: key, title: title, description: description, intentSchemaId: intentSchemaId, featureId: featureId, icon: icon, shortTitle: shortTitle, adfPrompt: adfPrompt, factoryOptions: factoryOptions }) {
    return {
        key: key,
        title: title,
        description: description,
        icon: icon,
        showInRefineDropdown: true,
        intentSchemaId: intentSchemaId,
        featureId: featureId,
        adfPrompt: adfPrompt,
        requiresTextualContent: adfPrompt,
        nestingConfig: {
            id: 'change-tone-to',
            parentTestId: 'change-tone-to',
            parentTitle: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? (0, $7ShCl.aiMessages).changeToneToolbarDropdownIconTitle : (0, $AMCQl.aiConfigItemMessages).changeToneNestingParentTitlePostGA,
            shortTitle: shortTitle,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAxHS))), {
                    label: "",
                    spacing: "spacious"
                })
        },
        actions: {
            empty: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: factoryOptions
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: factoryOptions
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    };
}
const $681a4e3834a0476d$export$6f5f338379adfef = (options)=>{
    const featureId = 'change_tone_neutral';
    const adfPrompt = false;
    return $681a4e3834a0476d$var$createChangeToneOption({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_NEUTRAL,
        title: (0, $AMCQl.aiConfigItemMessages).changeToneNeutralToneTitle,
        shortTitle: (0, $AMCQl.aiConfigItemMessages).changeToneNeutralToneShortTitle,
        description: (0, $AMCQl.aiConfigItemMessages).changeToneNeutralToneDescription,
        intentSchemaId: 'change_tone_neutral_intent_schema.json',
        featureId: featureId,
        adfPrompt: adfPrompt,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57520f0cde7fe260$export$53c14326c671fdf0), null),
        factoryOptions: options
    });
};
const $681a4e3834a0476d$export$13defcd58be14c80 = (options)=>({
        config: $681a4e3834a0476d$export$6f5f338379adfef(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $681a4e3834a0476d$export$9db9bd2fafdb3554 = (options)=>{
    const featureId = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? 'change_tone_professional_adf_gpt41mini' : 'change_tone_professional';
    const adfPrompt = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    return $681a4e3834a0476d$var$createChangeToneOption({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_PROFESSIONAL,
        title: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? (0, $7ShCl.aiMessages).moreProfessionalToneToolbarDropdownIconTitle : (0, $AMCQl.aiConfigItemMessages).changeToneProfessionalToneTitle,
        shortTitle: (0, $AMCQl.aiConfigItemMessages).changeToneProfessionalToneShortTitle,
        description: (0, $AMCQl.aiConfigItemMessages).changeToneProfessionalToneDescription,
        intentSchemaId: 'change_tone_professional_intent_schema.json',
        featureId: featureId,
        adfPrompt: adfPrompt,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d144fa220b28cd85$export$d11b06b5c6e28f63), null),
        factoryOptions: options
    });
};
const $681a4e3834a0476d$export$12bb87036588b312 = (options)=>({
        config: $681a4e3834a0476d$export$9db9bd2fafdb3554(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $681a4e3834a0476d$export$86a519e0af50dd89 = (options)=>{
    const featureId = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? 'change_tone_casual_adf_gpt41mini' : 'change_tone_casual';
    const adfPrompt = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    return $681a4e3834a0476d$var$createChangeToneOption({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_CASUAL,
        title: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? (0, $7ShCl.aiMessages).moreCasualToneToolbarDropdownIconTitle : (0, $AMCQl.aiConfigItemMessages).changeToneCasualToneTitle,
        shortTitle: (0, $AMCQl.aiConfigItemMessages).changeToneCasualToneShortTitle,
        description: (0, $AMCQl.aiConfigItemMessages).changeToneCasualToneDescription,
        intentSchemaId: 'change_tone_business_casual_intent_schema.json',
        featureId: featureId,
        adfPrompt: adfPrompt,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bef4a50ba85ef080$export$8b4784439604ca83), null),
        factoryOptions: options
    });
};
const $681a4e3834a0476d$export$124661226d751077 = (options)=>({
        config: $681a4e3834a0476d$export$86a519e0af50dd89(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $681a4e3834a0476d$export$693b6bda4adcfa2a = (options)=>{
    const featureId = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? 'change_tone_educational_adf_gpt41mini' : 'change_tone_educational';
    const adfPrompt = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    return $681a4e3834a0476d$var$createChangeToneOption({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EDUCATIONAL,
        title: (0, $AMCQl.aiConfigItemMessages).changeToneEducationalToneTitle,
        shortTitle: (0, $AMCQl.aiConfigItemMessages).changeToneEducationalToneShortTitle,
        description: (0, $AMCQl.aiConfigItemMessages).changeToneEducationalToneDescription,
        intentSchemaId: 'change_tone_educational_intent_schema.json',
        featureId: featureId,
        adfPrompt: adfPrompt,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $334f53e1c24ec9cf$export$61c3f03f8b900938), null),
        factoryOptions: options
    });
};
const $681a4e3834a0476d$export$bc06489e9b94a1b8 = (options)=>({
        config: $681a4e3834a0476d$export$693b6bda4adcfa2a(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $681a4e3834a0476d$export$a20a30955e450d41 = (options)=>{
    const featureId = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? 'change_tone_empathetic_adf_gpt41mini' : 'change_tone_empathetic';
    const adfPrompt = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    return $681a4e3834a0476d$var$createChangeToneOption({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EMPATHETIC,
        title: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? (0, $7ShCl.aiMessages).moreEmpatheticToneToolbarDropdownIconTitle : (0, $AMCQl.aiConfigItemMessages).changeToneEmpatheticToneTitle,
        shortTitle: (0, $AMCQl.aiConfigItemMessages).changeToneEmpatheticToneShortTitle,
        description: (0, $AMCQl.aiConfigItemMessages).changeToneEmpatheticToneDescription,
        intentSchemaId: 'change_tone_empathetic_intent_schema.json',
        featureId: featureId,
        adfPrompt: adfPrompt,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6488db947ac5932$export$e378d926184098e), null),
        factoryOptions: options
    });
};
const $681a4e3834a0476d$export$6c0e9fb8d5e538d3 = (options)=>({
        config: $681a4e3834a0476d$export$a20a30955e450d41(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["changeToneToNeutral"] = $681a4e3834a0476d$export$6f5f338379adfef;
module.exports["changeToneToProfessional"] = $681a4e3834a0476d$export$9db9bd2fafdb3554;
module.exports["changeToneToProfessionalWithOptions"] = $681a4e3834a0476d$export$12bb87036588b312;
module.exports["changeToneToCasual"] = $681a4e3834a0476d$export$86a519e0af50dd89;
module.exports["changeToneToCasualWithOptions"] = $681a4e3834a0476d$export$124661226d751077;
module.exports["changeToneToEducational"] = $681a4e3834a0476d$export$693b6bda4adcfa2a;
module.exports["changeToneToEducationalWithOptions"] = $681a4e3834a0476d$export$bc06489e9b94a1b8;
module.exports["changeToneToEmpathetic"] = $681a4e3834a0476d$export$a20a30955e450d41;
module.exports["changeToneToEmpatheticWithOptions"] = $681a4e3834a0476d$export$6c0e9fb8d5e538d3;

});

parcelRegister("2KJU8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");


var $drPNW = parcelRequire("drPNW");


var $dh538 = parcelRequire("dh538");




const $a43ef58130f146e7$export$ffe14b080d2065b6 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5 5.75L19 5.75M5 9.91667L19 9.91667M5 14.0833L19 14.0833M5 18.25L12 18.25",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }));
};



var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $906dc63f2e8ca274$var$intentSchemaId = 'make_longer.json';
const $906dc63f2e8ca274$export$11363e713b339cda = (options)=>{
    const featureId = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? 'make_longer_adf_gpt41mini' : 'make_longer';
    const adfPrompt = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    return {
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).MAKE_LONGER,
        title: (0, $AMCQl.aiConfigItemMessages).makeLongerTitle,
        description: (0, $AMCQl.aiConfigItemMessages).makeLongerDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a43ef58130f146e7$export$ffe14b080d2065b6), null),
        statusLozengeType: 'beta',
        intentSchemaId: $906dc63f2e8ca274$var$intentSchemaId,
        featureId: featureId,
        adfPrompt: adfPrompt,
        requiresTextualContent: adfPrompt,
        getBackendModel: ()=>'assistance-service',
        showInRefineDropdown: true,
        actions: {
            empty: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        get nestingConfig () {
            if (options?.isInDocumentStreamingEnabled) return {
                id: 'adjust-length',
                parentTestId: 'adjust-length',
                parentTitle: (0, $AMCQl.aiConfigItemMessages).adjustLengthNestingParentTitle,
                shortTitle: (0, $AMCQl.aiConfigItemMessages).adjustLengthNestingParentShortTitle,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($drPNW))), {
                        label: "",
                        spacing: "spacious"
                    })
            };
            return undefined;
        }
    };
};
const $906dc63f2e8ca274$export$5f725895b60131b1 = (options)=>({
        config: $906dc63f2e8ca274$export$11363e713b339cda(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["makeLonger"] = $906dc63f2e8ca274$export$11363e713b339cda;
module.exports["makeLongerWithOptions"] = $906dc63f2e8ca274$export$5f725895b60131b1;

});

parcelRegister("drPNW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82d552d61ccd8c1190c5c2c0bad87309>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ca5fb42d6d8d172$var$_react = $9ca5fb42d6d8d172$var$_interopRequireDefault((parcelRequire("42omo")));

var $9ca5fb42d6d8d172$var$_baseNew = $9ca5fb42d6d8d172$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9ca5fb42d6d8d172$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextAdjustLength".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for accessing text length generative AI actions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ca5fb42d6d8d172$var$TextAdjustLengthIcon = (props)=>/*#__PURE__*/ $9ca5fb42d6d8d172$var$_react.default.createElement($9ca5fb42d6d8d172$var$_baseNew.default, Object.assign({
        name: "TextAdjustLengthIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M3.25 1c.199 0 .39.08.53.22l2.5 2.5-1.06 1.06L4 3.56v8.88l1.22-1.22 1.06 1.06-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5 1.06-1.06 1.22 1.22V3.56L1.28 4.78.22 3.72l2.5-2.5.114-.094A.75.75 0 0 1 3.25 1M13 11.5V13H8v-1.5zm3-4.25v1.5H8v-1.5zM16 3v1.5H8V3z"/>`
    }, props));
$9ca5fb42d6d8d172$var$TextAdjustLengthIcon.displayName = 'TextAdjustLengthIcon';
var $9ca5fb42d6d8d172$var$_default = module.exports.default = $9ca5fb42d6d8d172$var$TextAdjustLengthIcon;

});

parcelRegister("96Uu5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");


var $drPNW = parcelRequire("drPNW");


var $dh538 = parcelRequire("dh538");


var $8vLXI = parcelRequire("8vLXI");


var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $6acfbfb2c7c30654$export$1792ed3292533f02 = (options)=>{
    const featureId = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? 'make_shorter_adf_gpt41mini' : 'make_shorter';
    const adfPrompt = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    return {
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).MAKE_SHORTER,
        title: (0, $AMCQl.aiConfigItemMessages).makeShorterTitle,
        description: (0, $AMCQl.aiConfigItemMessages).makeShorterDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8vLXI.MakeShorterIcon), null),
        showInRefineDropdown: true,
        intentSchemaId: 'shorten_intent_schema.json',
        featureId: featureId,
        adfPrompt: adfPrompt,
        requiresTextualContent: adfPrompt,
        actions: {
            empty: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        },
        get nestingConfig () {
            if (options?.isInDocumentStreamingEnabled) return {
                id: 'adjust-length',
                parentTestId: 'adjust-length',
                parentTitle: (0, $AMCQl.aiConfigItemMessages).adjustLengthNestingParentTitle,
                shortTitle: (0, $AMCQl.aiConfigItemMessages).adjustLengthNestingParentShortTitle,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($drPNW))), {
                        label: "",
                        spacing: "spacious"
                    })
            };
            return undefined;
        }
    };
};
const $6acfbfb2c7c30654$export$cf8706c71bd8ab7d = (options)=>({
        config: $6acfbfb2c7c30654$export$1792ed3292533f02(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["makeShorter"] = $6acfbfb2c7c30654$export$1792ed3292533f02;
module.exports["makeShorterWithOptions"] = $6acfbfb2c7c30654$export$cf8706c71bd8ab7d;

});

parcelRegister("8vLXI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cH4SO = parcelRequire("cH4SO");

const $2319bb603db66f12$export$bd44f97e799f79a6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cH4SO))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });
module.exports["MakeShorterIcon"] = $2319bb603db66f12$export$bd44f97e799f79a6;

});

parcelRegister("kOMDA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");


var $cbtR4 = parcelRequire("cbtR4");


var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $e4ee2a20401bd010$export$aa2f740770614b48 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).ADD_POLISH,
        title: (0, $AMCQl.aiConfigItemMessages).addPolishTitle,
        description: (0, $AMCQl.aiConfigItemMessages).addPolishDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cbtR4))), {
                label: ""
            }),
        showInRefineDropdown: true,
        /**
	 * Polish prompt doesn't exist in assistance-service, so using shorten_intent_schema.json.
	 * Once migration to convo-ai is complete, we will remove intentShemaId option.
	 */ intentSchemaId: 'shorten_intent_schema.json',
        featureId: 'add_polish_adf',
        adfPrompt: true,
        requiresTextualContent: true,
        actions: {
            empty: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $e4ee2a20401bd010$export$2e578cc386d5ec11 = (options)=>({
        config: $e4ee2a20401bd010$export$aa2f740770614b48(),
        triggers: {
            empty: {
                enabled: options?.isInDocumentStreamingEnabled ?? false,
                docMinSize: 1
            },
            selection: {
                enabled: options?.isInDocumentStreamingEnabled ?? false,
                selectionMinSize: 1
            }
        }
    });
module.exports["addPolish"] = $e4ee2a20401bd010$export$aa2f740770614b48;
module.exports["addPolishWithOptions"] = $e4ee2a20401bd010$export$2e578cc386d5ec11;

});

parcelRegister("6PN31", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bpQiY = parcelRequire("bpQiY");


var $dh538 = parcelRequire("dh538");





var $3tLv0 = parcelRequire("3tLv0");

const $9149bea7610d8843$export$d1fe1d52e2885c4e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3tLv0))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });



var $jc4DP = parcelRequire("jc4DP");


var $8vIZB = parcelRequire("8vIZB");

const $28ae8808f18418eb$var$supportedTranslationLanguages = (0, $8vIZB.getSortedSupportedTranslationLanguages)();
const $28ae8808f18418eb$export$e74e7aa094cc7ad6 = (options)=>{
    const featureId = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products') ? 'translate_adf_gpt41mini' : 'translate';
    const adfPrompt = (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products');
    const translationConfigItems = $28ae8808f18418eb$var$supportedTranslationLanguages.map((language)=>{
        const lang = (0, $bpQiY.aiLanguageMessages)[language];
        if (!lang) return false;
        const configItem = {
            key: `Translate to ${language}`,
            title: (0, $bpQiY.aiLanguageMessages)[`${language}Title`],
            description: (0, $bpQiY.aiLanguageMessages)[`${language}Description`],
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9149bea7610d8843$export$d1fe1d52e2885c4e), null),
            showInRefineDropdown: (0, $8vIZB.isRefinementSupport)(language),
            nestingConfig: {
                id: 'translate-to',
                parentTestId: 'translate-to',
                parentTitle: (0, $bpQiY.aiLanguageMessages).nestingParentTitlePostGA,
                shortTitle: lang,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9149bea7610d8843$export$d1fe1d52e2885c4e), null)
            },
            intentSchemaId: 'translate_intent_schema.json',
            featureId: featureId,
            adfPrompt: adfPrompt,
            requiresTextualContent: adfPrompt,
            lang: lang.defaultMessage,
            actions: {
                empty: [
                    (0, $jc4DP.createInsertBelow)({
                        appearance: 'secondary',
                        factoryOptions: options
                    }),
                    (0, $jc4DP.createReplace)({
                        appearance: 'primary'
                    })
                ],
                selection: [
                    (0, $jc4DP.createInsertBelow)({
                        appearance: 'secondary',
                        factoryOptions: options
                    }),
                    (0, $jc4DP.createReplace)({
                        appearance: 'primary'
                    })
                ]
            }
        };
        return [
            language,
            configItem
        ];
    }).filter(Boolean);
    return Object.fromEntries(translationConfigItems);
};
const $28ae8808f18418eb$export$c9f99cf066285ff1 = (options)=>Object.values($28ae8808f18418eb$export$e74e7aa094cc7ad6(options));
const $28ae8808f18418eb$export$f79e42233d7b78a9 = (options)=>$28ae8808f18418eb$export$c9f99cf066285ff1(options).map((config)=>({
            config: config,
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        }));
const $28ae8808f18418eb$export$58be4f46859bb368 = (options)=>$28ae8808f18418eb$export$c9f99cf066285ff1(options).map((config)=>({
            config: config,
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        }));
module.exports["createTranslationConfigItems"] = $28ae8808f18418eb$export$e74e7aa094cc7ad6;
module.exports["translationConfigItemWithOptions"] = $28ae8808f18418eb$export$f79e42233d7b78a9;
module.exports["translationConfigItemWithOptionsEnabledForSelectionOnly"] = $28ae8808f18418eb$export$58be4f46859bb368;

});

parcelRegister("8vIZB", function(module, exports) {

var $hgTYG = parcelRequire("hgTYG");

const $b137d6ce9b3b79b4$export$a288aff1b8104a05 = ()=>{
    return 0, $hgTYG.supportedTranslationLanguagesPopularOrder;
};
const $b137d6ce9b3b79b4$export$f54f1bab33a30a3f = (latestPrompt)=>typeof latestPrompt?.presetTitle?.title?.defaultMessage === 'string' && latestPrompt?.presetTitle?.title?.defaultMessage?.includes('Translate to');
const $b137d6ce9b3b79b4$export$9429b43310621fcf = (language)=>(0, $hgTYG.refinementSupportedTranslationLanguages).includes(language);
module.exports["getSortedSupportedTranslationLanguages"] = $b137d6ce9b3b79b4$export$a288aff1b8104a05;
module.exports["isRefinementSupport"] = $b137d6ce9b3b79b4$export$9429b43310621fcf;

});

parcelRegister("ihTS4", function(module, exports) {
/* prompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $7ShCl = parcelRequire("7ShCl");


var $7iE7T = parcelRequire("7iE7T");


var $e6Iiv = parcelRequire("e6Iiv");


var $auTg8 = parcelRequire("auTg8");


var $1JdaQ = parcelRequire("1JdaQ");


var $ks2lK = parcelRequire("ks2lK");


var $euUgw = parcelRequire("euUgw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $kw19Z = parcelRequire("kw19Z");

/* AddItemButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");





var $c4sKh = parcelRequire("c4sKh");





var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $d925B = parcelRequire("d925B");


var $807Mc = parcelRequire("807Mc");


var $g5gZt = parcelRequire("g5gZt");


var $1bY7o = parcelRequire("1bY7o");


var $6767u = parcelRequire("6767u");







var $cgtv4 = parcelRequire("cgtv4");

var $9bbe385fe77be4c2$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    label: {
        id: "fabric.editor.ai.screens.prompt.addButton.label",
        defaultMessage: "Add"
    },
    insertMenuTriggerLabel: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel",
        defaultMessage: "Insert rich content"
    },
    insertMenuUpload: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.upload",
        defaultMessage: "Upload file"
    },
    insertMenuAddLink: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink",
        defaultMessage: "Add link"
    },
    insertMenuMention: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.mention",
        defaultMessage: "Mention user"
    },
    promptRecord: {
        id: "fabric.editor.ai.screens.prompt.streaming.record",
        defaultMessage: "Record"
    },
    promptSubmit: {
        id: "fabric.editor.ai.screens.prompt.streaming.submit",
        defaultMessage: "Submit"
    },
    promptPlaceholder: {
        id: "fabric.editor.ai.screens.prompt.streaming.placeholder",
        defaultMessage: "Describe what you want to do"
    }
});






var $inPa6 = parcelRequire("inPa6");


var $ajtqX = parcelRequire("ajtqX");

function $4c0ddc9a366e9fb6$export$eed8c476984ddfad() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useMemo)(()=>(0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent), [
        createAnalyticsEvent
    ]);
}


const $e91b9a02c36ed91f$var$insertMenu = {
    menuWidth: "_1ul9gx0z"
};
const $e91b9a02c36ed91f$var$insertMenuItem = {
    grow: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $e91b9a02c36ed91f$var$rotatedIcon = {
    rotated: "_v564f4ca _t9eczk8b",
    base: "_v564f4ca _t9ec1ul7"
};
const $e91b9a02c36ed91f$var$shortcutLabel = null;
const $e91b9a02c36ed91f$export$6cb731ac7be1981a = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const fireAnalyticsEvent = (0, $4c0ddc9a366e9fb6$export$eed8c476984ddfad)();
    const isToolbarAIFCEnabled = Boolean(editorApi?.toolbar);
    const handleLinkClick = (0, $42omo.useCallback)(()=>{
        if (editorApi) {
            const showLinkToolbarAction = editorApi.hyperlink?.commands.showLinkToolbar((0, $d925B.INPUT_METHOD).QUICK_INSERT);
            if (showLinkToolbarAction) editorApi.core.actions.execute(showLinkToolbarAction);
        }
        fireAnalyticsEvent({
            payload: {
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_PROMPT_LINK_PICKER_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    const handleMentionClick = (0, $42omo.useCallback)(()=>{
        if (editorApi) editorApi.mention?.actions.openTypeAhead((0, $d925B.INPUT_METHOD).QUICK_INSERT);
        fireAnalyticsEvent({
            payload: {
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_PROMPT_MENTION_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    const INSERT_ITEMS = [
        {
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            message: 'insertMenuAddLink',
            onClick: ()=>handleLinkClick()
        },
        {
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6767u))),
            message: 'insertMenuMention',
            shortcut: '@',
            onClick: ()=>handleMentionClick()
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...trigProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                isSelected: trigProps.isSelected,
                onClick: trigProps.onClick,
                onFocus: trigProps.onFocus,
                onBlur: trigProps.onBlur,
                testId: trigProps.testId,
                "aria-controls": trigProps['aria-controls'],
                "aria-expanded": trigProps['aria-expanded'],
                "aria-haspopup": trigProps['aria-haspopup'],
                "data-ds--level": trigProps['data-ds--level'],
                ref: triggerRef,
                appearance: "subtle",
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: trigProps['aria-expanded'] ? $e91b9a02c36ed91f$var$rotatedIcon.rotated : $e91b9a02c36ed91f$var$rotatedIcon.base,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                            label: iconProps.label
                        })
                    }),
                label: formatMessage((0, $9bbe385fe77be4c2$export$2e2bcd8739ae039).label),
                shape: "circle",
                isTooltipDisabled: false,
                tooltip: {
                    position: 'top'
                }
            }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $e91b9a02c36ed91f$var$insertMenu.menuWidth,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                children: INSERT_ITEMS.map(({ Icon: Icon, message: message, shortcut: shortcut, onClick: onClick })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: ()=>{
                            onClick();
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.200",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                                    label: ""
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $e91b9a02c36ed91f$var$insertMenuItem.grow,
                                    children: formatMessage((0, $9bbe385fe77be4c2$export$2e2bcd8739ae039)[message])
                                }),
                                shortcut && (isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
                                    children: shortcut
                                }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    className: (0, $gMc0m.default)([
                                        "_vwz4utpp"
                                    ]),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $807Mc.Shortcut), {
                                        children: shortcut
                                    })
                                }))
                            ]
                        })
                    }, message))
            })
        })
    });
};


/* LinkPickerButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $eiA8Z = parcelRequire("eiA8Z");








var $a2ad1e52dd1c557c$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    label: {
        id: "fabric.editor.ai.screens.prompt.linkPickerButton.label",
        defaultMessage: "Add link"
    }
});


const $adbf74255a44e378$export$b665e181ecd1797 = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { activeLinkMark: activeLinkMark } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorApi, [
        'hyperlink'
    ], (states)=>{
        return {
            activeLinkMark: states.hyperlinkState?.activeLinkMark
        };
    });
    const fireAnalyticsEvent = (0, $4c0ddc9a366e9fb6$export$eed8c476984ddfad)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (editorApi) {
            const showLinkToolbarAction = editorApi.hyperlink?.commands.showLinkToolbar((0, $d925B.INPUT_METHOD).QUICK_INSERT);
            if (showLinkToolbarAction) editorApi.core.actions.execute(showLinkToolbarAction);
        }
        fireAnalyticsEvent({
            payload: {
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_PROMPT_LINK_PICKER_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    // The editor can be wrapped in a component that process keyboard events,
    // but we don't need to propagate `Enter`, `Space`, and `Tab` key event to the editor.
    const stopPropagationForActionKeys = (0, $42omo.useCallback)((event)=>{
        if ([
            'Enter',
            ' ',
            'Tab'
        ].includes(event.key)) event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $a2ad1e52dd1c557c$export$2e2bcd8739ae039).label),
        testId: "link-picker-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
        isSelected: !!activeLinkMark,
        spacing: "compact",
        appearance: "subtle",
        onClick: handleClick,
        onKeyDown: stopPropagationForActionKeys,
        onKeyUp: stopPropagationForActionKeys
    });
};


/* MentionButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $b4wUN = parcelRequire("b4wUN");





var $62d56a9c73c9cc75$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    label: {
        id: "fabric.editor.ai.screens.prompt.mentionButton.label",
        defaultMessage: "Mention someone or a team"
    }
});


const $20fdd2d17448b63f$export$d16f16312388c7e = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { currentHandler: currentHandler, typeAheadHandler: typeAheadHandler } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorApi, [
        'typeAhead',
        'mention'
    ], (states)=>{
        return {
            currentHandler: states.typeAheadState?.currentHandler,
            typeAheadHandler: states.mentionState?.typeAheadHandler
        };
    });
    const fireAnalyticsEvent = (0, $4c0ddc9a366e9fb6$export$eed8c476984ddfad)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (editorApi) editorApi.mention?.actions.openTypeAhead((0, $d925B.INPUT_METHOD).QUICK_INSERT);
        fireAnalyticsEvent({
            payload: {
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_PROMPT_MENTION_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    const stopPropagationForActionKeys = (0, $42omo.useCallback)((event)=>{
        if ([
            'Enter',
            ' ',
            'Tab'
        ].includes(event.key)) event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $62d56a9c73c9cc75$export$2e2bcd8739ae039).label),
        testId: "mention-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))),
        isSelected: currentHandler?.id && typeAheadHandler?.id && currentHandler.id === typeAheadHandler.id,
        spacing: "compact",
        appearance: "subtle",
        onClick: handleClick,
        onKeyDown: stopPropagationForActionKeys,
        onKeyUp: stopPropagationForActionKeys
    });
};



var $bupcf = parcelRequire("bupcf");


var $jmHSv = parcelRequire("jmHSv");


var $fi7Vj = parcelRequire("fi7Vj");


var $55skd = parcelRequire("55skd");


var $khxQ7 = parcelRequire("khxQ7");


var $agrUc = parcelRequire("agrUc");


var $kXH7i = parcelRequire("kXH7i");


var $acwPl = parcelRequire("acwPl");


var $gyXPd = parcelRequire("gyXPd");


var $kIhx9 = parcelRequire("kIhx9");


var $4KTOl = parcelRequire("4KTOl");


var $lgjGE = parcelRequire("lgjGE");


var $l7rln = parcelRequire("l7rln");


var $7sK9h = parcelRequire("7sK9h");


var $jS0a0 = parcelRequire("jS0a0");


var $fYKTL = parcelRequire("fYKTL");


var $HYzBP = parcelRequire("HYzBP");


var $gATpw = parcelRequire("gATpw");


var $5u7tz = parcelRequire("5u7tz");


var $36iDo = parcelRequire("36iDo");


var $kYgUn = parcelRequire("kYgUn");


var $gCiM9 = parcelRequire("gCiM9");


var $bULcr = parcelRequire("bULcr");


var $fMaLE = parcelRequire("fMaLE");


var $kw2eg = parcelRequire("kw2eg");


var $3O0YV = parcelRequire("3O0YV");


var $fI6T7 = parcelRequire("fI6T7");


var $dZ8uq = parcelRequire("dZ8uq");

function $0148df2354c693a1$export$cd6e43a807ff0e0d(options) {
    const cardPluginData = {
        ...options.linking?.smartLinks,
        linkPicker: options.linking?.linkPicker,
        lpLinkPicker: options.featureFlags?.lpLinkPicker ?? false,
        disableFloatingToolbar: true,
        showUpgradeDiscoverability: false,
        // We don't want to show block cards and embed cards in prompt editor.
        allowBlockCards: false,
        allowEmbeds: false
    };
    const preset = new (0, $bupcf.EditorPresetBuilder)()// Handles feature flagging in Editor.
    .add([
        (0, $l7rln.featureFlagsPlugin),
        options.featureFlags
    ])// Most of analytics events in editor are fired by appending
    //  AnalyticsStep in transaction.
    // Without this plugin, none of those events will be fired.
    // If allowAnalyticsGASV3 is truthy, then analytics plugin will be added.
    .maybeAdd([
        (0, $jmHSv.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent
        }
    ], Boolean(options.allowAnalyticsGASV3))// Dependency of paste plugin
    .add((0, $55skd.betterTypeHistoryPlugin))// we need paste plugin to handle paste event.
    .add([
        (0, $36iDo.pastePlugin),
        {}
    ])// We need clipboard to handle cut and copy and clipboard serialization.
    .add((0, $acwPl.default))// Handles focus and blur events.
    .add((0, $jS0a0.focusPlugin))// This plugin handles composition events and take care nuances of composition.
    // Need this plugin to have sleek composition support for languages such as Japanese, Chinese
    .add((0, $gyXPd.compositionPlugin))// Editor can't function without this plugin.
    // It takes care of doc, paragraph and text nodes, backbone of any document.
    .add([
        (0, $fi7Vj.default),
        {}
    ])// Dependency of cardPlugin, floatingToolbarPlugin
    .add((0, $4KTOl.decorationsPlugin))// Depdency of undoRedoButtons
    .add((0, $fMaLE.typeAheadPlugin))// Depdency of undoRedoButtons
    .maybeAdd((0, $HYzBP.default), true)// We want to support undo/redo through shortcuts.
    .maybeAdd((0, $kw2eg.undoRedoPlugin), true)// We should keep this plugin. It will remove all the marks when doc is empty.
    // It's very lightweight plugin.
    .add((0, $kXH7i.clearMarksOnEmptyDocPlugin))// Dependency of cardPlugin
    .maybeAdd([
        (0, $gATpw.hyperlinkPlugin),
        {
            disableFloatingToolbar: !options.linkPicker,
            linkPicker: options.linkPicker
        }
    ], !!options.enableLinks).maybeAdd([
        (0, $5u7tz.mentionsPlugin)
    ], !!options.mentionProvider)// Dependency of cardPlugin, gridPlugin
    .add((0, $fI6T7.widthPlugin))// Need placeholder plugin to show placeholder
    .add([
        (0, $kYgUn.placeholderPlugin),
        options.placeholder
    ])// Dependency of floatingToolbarPlugin
    .add((0, $lgjGE.editorDisabledPlugin))// Dependency of floatingToolbarPlugin
    .add((0, $kIhx9.copyButtonPlugin))// Dependency of cardPlugin
    .add((0, $7sK9h.floatingToolbarPlugin))// Need selections plugin to handle selection nuances in editor, support gap cursor and keyboard handling for selection.
    .add([
        (0, $bULcr.selectionPlugin),
        {}
    ])// Need to have save on enter functionality. Without this plugin, on enter editor will add line break and then prompt is submited.
    .maybeAdd([
        (0, $gCiM9.saveOnEnterPlugin),
        options.onSave
    ], !!options.onSave)// Dependency of cardPlugin
    .maybeAdd([
        (0, $fYKTL.gridPlugin),
        {}
    ], true)// Need card plugin to show smart links.
    .maybeAdd([
        (0, $agrUc.cardPlugin),
        cardPluginData
    ], !!options.enableLinks)// Need this plugin for adding new line on `Shift + Enter` keymap
    .add([
        (0, $khxQ7.blockTypePlugin),
        {
            allowBlockType: {
                exclude: [
                    'heading',
                    'blockquote'
                ]
            }
        }
    ])// Dependency for correct toolbars showing up
    .maybeAdd((0, $3O0YV.userIntentPlugin), (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_lovability_user_intent', 'isEnabled', true));
    return preset;
}


const $24ba94fce89dcbfd$export$4732a5aefd77a6d8 = (adf)=>{
    // Check if the first paragraph has content with hardBreak type
    const firstParagraph = adf.content?.[0];
    if (firstParagraph?.type === 'paragraph' && firstParagraph.content) return firstParagraph.content.some((item)=>item?.type === 'hardBreak');
    return false;
};



const $e62134659a8be745$var$styles = {
    insertMenuContainer: "_ahbq1wug _1pfh1wug",
    editorBase: "_1pfh1b66 _1nmz1hna _16jlkb7n _1o9zkb7n _o5721jtm _slp31hna _1bsb1wug",
    editorMultiline: "_1pfh1b66 _1nmz1hna _16jlkb7n _1o9zkb7n _o5721jtm _slp31hna _1bsb1osq"
};
const $e62134659a8be745$var$EditorWrapper = (props)=>{
    const appearance = 'chromeless';
    const { editorProps: editorProps, options: options } = props;
    const { type: type = 'user-input', onChange: onChange, onInputChange: onInputChange, onADFChange: onADFChange, defaultValue: defaultValue, enableLinks: enableLinks, setFocusHandlers: setFocusHandlers, setClearHandler: setClearHandler, ariaLabel: ariaLabel, submit: submit, isAIFC: isAIFC } = editorProps;
    const { onSubmit: onSubmit } = options;
    const adfRef = (0, $42omo.useRef)(undefined);
    const textRef = (0, $42omo.useRef)(undefined);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, $42omo.useState)(true);
    const [hasLinebreak, setHasLinebreak] = (0, $42omo.useState)(false);
    const handleChange = (0, $42omo.useCallback)((editorView)=>{
        const textSerializer = (0, $kw19Z.default).fromSchema(editorView.state.schema);
        const text = textSerializer.serializeFragment(editorView.state.doc.content);
        const adf = (0, $7iE7T.toJSON)(editorView.state.doc);
        onChange?.({
            text: text,
            adf: adf
        });
        onADFChange?.(adf);
        onInputChange?.(text);
        adfRef.current = adf;
        textRef.current = text;
        const hasHardBreak = (0, $24ba94fce89dcbfd$export$4732a5aefd77a6d8)(adf);
        setHasLinebreak(hasHardBreak);
        if (text) setIsSubmitDisabled(false);
        else setIsSubmitDisabled(true);
    }, [
        onChange,
        onADFChange,
        onInputChange
    ]);
    const onSave = (0, $42omo.useCallback)((editorView)=>{
        handleChange(editorView);
    }, [
        handleChange
    ]);
    const onSaveSubmit = (0, $42omo.useCallback)(()=>{
        if (onSubmit) onSubmit?.({
            adf: adfRef.current,
            text: textRef.current
        });
        else submit?.();
    }, [
        submit,
        onSubmit
    ]); // We could have created preset outside PromptEditor component,
    //  but currently placeholder prop ComposableEditor is not working.
    // We have to pass placeholder to placeholder plugin.
    // That's why using usePreset, who memoize preset.
    const { preset: preset, editorApi: editorApi } = (0, $1JdaQ.usePreset)(()=>(0, $0148df2354c693a1$export$cd6e43a807ff0e0d)({
            ...options,
            placeholder: {
                placeholder: editorProps.placeholder
            },
            onSave: editorProps.isAIFC ? onSaveSubmit : onSave,
            enableLinks: enableLinks
        }), [
        options,
        editorProps.placeholder,
        editorProps.isAIFC
    ]);
    const editorViewRef = (0, $42omo.useRef)(null);
    const onEditorReady = (0, $42omo.useCallback)((editorActions)=>{
        if (setClearHandler) setClearHandler(()=>editorActions.clear());
        const editorView = editorActions._privateGetEditorView();
        if (editorView) {
            editorViewRef.current = editorView;
            if (!editorActions.isDocumentEmpty()) editorView.dispatch(editorView.state.tr.setSelection(new (0, $ks2lK.AllSelection)(editorView.state.doc)));
        }
    }, [
        setClearHandler
    ]);
    (0, $42omo.useEffect)(()=>{
        if (setFocusHandlers) /**
       * We need to expose clear function through ref because
       *  changing defaultValue does not clear editor.
       */ setFocusHandlers(editorApi?.core?.actions.blur, editorApi?.core?.actions.focus);
    }, [
        editorApi,
        setFocusHandlers
    ]); // Skip any toolbars that displays in the editor, like Link Picker toolbar
    // Yes, it's ugly, but it's easier way, because we can't have access to the PromptEditor
    // floating toolbar.
    const stopPropagationForFloatingToolbar = (0, $42omo.useCallback)((event)=>{
        const eventFloatingToolbar = event.target instanceof HTMLElement ? event.target.closest('[data-testid="editor-floating-toolbar"]') : null; // Check that floating toolbar is a child of the current target,
        // i.e. it's a child of current the editor.
        if (eventFloatingToolbar && event.currentTarget.contains(eventFloatingToolbar)) event.stopPropagation();
    }, []);
    const addItemButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $e91b9a02c36ed91f$export$6cb731ac7be1981a), {
        editorApi: editorApi,
        promptType: type
    });
    const submitButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        testId: "submit-icon-button",
        shape: "circle",
        appearance: "primary",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
        isDisabled: isSubmitDisabled,
        onClick: isAIFC ? onSaveSubmit : submit,
        isTooltipDisabled: isSubmitDisabled,
        label: formatMessage((0, $9bbe385fe77be4c2$export$2e2bcd8739ae039).promptSubmit),
        tooltip: {
            position: 'top'
        }
    });
    const editor = /*#__PURE__*/ (0, $l998X.jsx)((0, $e6Iiv.ComposableEditor), {
        mentionProvider: options.mentionProvider,
        appearance: appearance,
        minHeight: 20,
        maxHeight: 200,
        preset: preset,
        assistiveLabel: ariaLabel ?? formatMessage((0, $7ShCl.aiMessages).promptbuilderAriaLabel),
        shouldFocus: editorProps.autoFocus ?? true,
        defaultValue: defaultValue,
        onChange: handleChange,
        onEditorReady: onEditorReady
    });
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        onKeyDown: stopPropagationForFloatingToolbar,
        onKeyUp: stopPropagationForFloatingToolbar,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            gap: "space.050",
            /**
                          * Note wrap and direction is purely added for the new modals multiline behaviour
                          */ wrap: isAIFC ? 'wrap' : undefined,
            direction: isAIFC ? 'row' : undefined,
            children: [
                isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: hasLinebreak ? $e62134659a8be745$var$styles.editorMultiline : $e62134659a8be745$var$styles.editorBase,
                    children: editor
                }) : editor,
                isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    xcss: $e62134659a8be745$var$styles.insertMenuContainer,
                    space: "space.050",
                    children: [
                        addItemButton,
                        submitButton
                    ]
                }) : (type === 'user-input' || type === 'interrogate') && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        options.enableLinks && options.linkPicker && /*#__PURE__*/ (0, $l998X.jsx)((0, $adbf74255a44e378$export$b665e181ecd1797), {
                            editorApi: editorApi,
                            promptType: type
                        }),
                        options.mentionProvider && /*#__PURE__*/ (0, $l998X.jsx)((0, $20fdd2d17448b63f$export$d16f16312388c7e), {
                            editorApi: editorApi,
                            promptType: type
                        })
                    ]
                })
            ]
        })
    }));
};
function $e62134659a8be745$export$df4eed2eacb29ddb(options) {
    return (props)=>{
        const editorProps = {
            editorProps: props,
            options: options
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $auTg8.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($e62134659a8be745$var$EditorWrapper // Ignored via go/ees005
            , {
                ...editorProps
            })
        });
    };
}
module.exports["createPromptEditor"] = $e62134659a8be745$export$df4eed2eacb29ddb;

});

parcelRegister("i5NyM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");


var $3ZqD0 = parcelRequire("3ZqD0");


var $SFzFl = parcelRequire("SFzFl");


var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $1439361e5ac5825d$export$647e613dda1ecf45 = (options)=>{
    return {
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE,
        title: (0, $SFzFl.default).rovoButtonTitle,
        description: (0, $SFzFl.default).rovoUniversalLongCallToAction,
        promptHint: (0, $AMCQl.aiConfigItemMessages).freeGenerateRovoPromptHint,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ZqD0.default), {
                label: "",
                size: "small"
            }),
        doNotHighlightDocWhenSelectionIsEmpty: true,
        insertOnEmptySelection: true,
        agentId: 'editor_agent',
        canTogglePageKnowledge: true,
        quickInsertPriority: Number.NEGATIVE_INFINITY,
        intentSchemaId: 'custom_free_generate_intent_schema.json',
        featureId: 'free_generate',
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        },
        withContextMutation: (configItem, { latestPromptResponse: latestPromptResponse })=>{
            return latestPromptResponse ? {
                ...configItem,
                intentSchemaId: 'custom_with_interrogation_intent_schema.json',
                featureId: 'interrogation'
            } : configItem;
        }
    };
};
module.exports["freeGenerate"] = $1439361e5ac5825d$export$647e613dda1ecf45;

});

parcelRegister("iipo1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AMCQl = parcelRequire("AMCQl");

var $7ShCl = parcelRequire("7ShCl");





var $a6IPc = parcelRequire("a6IPc");

const $10bc0acff53e45f1$export$71f01d1a809741f7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });



var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $54f98e8273f8bf25$export$5dae1cd728cdd936 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).SUMMARISE_WRITING,
        title: (0, $AMCQl.aiConfigItemMessages).summarizeWritingtitle,
        description: (0, $AMCQl.aiConfigItemMessages).summarizeWritingDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10bc0acff53e45f1$export$71f01d1a809741f7), null),
        showInRefineDropdown: true,
        intentSchemaId: 'summarize_intent_schema.json',
        featureId: 'summarize_writing',
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $54f98e8273f8bf25$export$a0bf62522ec7a604 = (options)=>({
        config: $54f98e8273f8bf25$export$5dae1cd728cdd936(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $54f98e8273f8bf25$export$afe1e087747ab29 = (options)=>({
        config: {
            ...$54f98e8273f8bf25$export$5dae1cd728cdd936(options),
            description: (0, $7ShCl.aiMessages).atlasSummarizePageConfigItemDescription
        },
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: false
            }
        }
    });
module.exports["summarizeWriting"] = $54f98e8273f8bf25$export$5dae1cd728cdd936;
module.exports["summarizeWritingWithOptions"] = $54f98e8273f8bf25$export$a0bf62522ec7a604;
module.exports["summarizeWritingWithOptionsForAtlas"] = $54f98e8273f8bf25$export$afe1e087747ab29;

});

parcelRegister("3Ev1M", function(module, exports) {

var $d0N4G = parcelRequire("d0N4G");

parcelRequire("2gWl9");

/**
 * Represents an actor created by `fromTransition`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromTransition,
 *   createActor,
 *   type AnyActorSystem
 * } from 'xstate';
 *
 * //* The actor's stored context.
 * type Context = {
 *   // The current count.
 *   count: number;
 *   // The amount to increase `count` by.
 *   step: number;
 * };
 * // The events the actor receives.
 * type Event = { type: 'increment' };
 * // The actor's input.
 * type Input = { step?: number };
 *
 * // Actor logic that increments `count` by `step` when it receives an event of
 * // type `increment`.
 * const logic = fromTransition<Context, Event, AnyActorSystem, Input>(
 *   (state, event, actorScope) => {
 *     actorScope.self;
 *     //         ^? TransitionActorRef<Context, Event>
 *
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + state.step
 *       };
 *     }
 *     return state;
 *   },
 *   ({ input, self }) => {
 *     self;
 *     // ^? TransitionActorRef<Context, Event>
 *
 *     return {
 *       count: 0,
 *       step: input.step ?? 1
 *     };
 *   }
 * );
 *
 * const actor = createActor(logic, { input: { step: 10 } });
 * //    ^? TransitionActorRef<Context, Event>
 * ```
 *
 * @see {@link fromTransition}
 */ /**
 * Returns actor logic given a transition function and its initial state.
 *
 * A “transition function” is a function that takes the current `state` and
 * received `event` object as arguments, and returns the next state, similar to
 * a reducer.
 *
 * Actors created from transition logic (“transition actors”) can:
 *
 * - Receive events
 * - Emit snapshots of its state
 *
 * The transition function’s `state` is used as its transition actor’s
 * `context`.
 *
 * Note that the "state" for a transition function is provided by the initial
 * state argument, and is not the same as the State object of an actor or a
 * state within a machine configuration.
 *
 * @example
 *
 * ```ts
 * const transitionLogic = fromTransition(
 *   (state, event) => {
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + 1
 *       };
 *     }
 *     return state;
 *   },
 *   { count: 0 }
 * );
 *
 * const transitionActor = createActor(transitionLogic);
 * transitionActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * transitionActor.start();
 * // => {
 * //   status: 'active',
 * //   context: { count: 0 },
 * //   ...
 * // }
 *
 * transitionActor.send({ type: 'increment' });
 * // => {
 * //   status: 'active',
 * //   context: { count: 1 },
 * //   ...
 * // }
 * ```
 *
 * @param transition The transition function used to describe the transition
 *   logic. It should return the next state given the current state and event.
 *   It receives the following arguments:
 *
 *   - `state` - the current state.
 *   - `event` - the received event.
 *   - `actorScope` - the actor scope object, with properties like `self` and
 *       `system`.
 *
 * @param initialContext The initial state of the transition function, either an
 *   object representing the state, or a function which returns a state object.
 *   If a function, it will receive as its only argument an object with the
 *   following properties:
 *
 *   - `input` - the `input` provided to its parent transition actor.
 *   - `self` - a reference to its parent transition actor.
 *
 * @returns Actor logic
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $2a8d2cfec624a43b$export$439a4be7208a15ca(transition, initialContext) {
    return {
        config: transition,
        transition: (snapshot, event, actorScope)=>{
            return {
                ...snapshot,
                context: transition(snapshot.context, event, actorScope)
            };
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: typeof initialContext === 'function' ? initialContext({
                    input: input
                }) : initialContext
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
}
const $2a8d2cfec624a43b$var$instanceStates = /* #__PURE__ */ new WeakMap();
/**
 * Represents an actor created by `fromCallback`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromCallback, createActor } from 'xstate';
 *
 * // The events the actor receives.
 * type Event = { type: 'someEvent' };
 * // The actor's input.
 * type Input = { name: string };
 *
 * // Actor logic that logs whenever it receives an event of type `someEvent`.
 * const logic = fromCallback<Event, Input>(({ self, input, receive }) => {
 *   self;
 *   // ^? CallbackActorRef<Event, Input>
 *
 *   receive((event) => {
 *     if (event.type === 'someEvent') {
 *       console.log(`${input.name}: received "someEvent" event`);
 *       // logs 'myActor: received "someEvent" event'
 *     }
 *   });
 * });
 *
 * const actor = createActor(logic, { input: { name: 'myActor' } });
 * //    ^? CallbackActorRef<Event, Input>
 * ```
 *
 * @see {@link fromCallback}
 */ /**
 * An actor logic creator which returns callback logic as defined by a callback
 * function.
 *
 * @remarks
 * Useful for subscription-based or other free-form logic that can send events
 * back to the parent actor.
 *
 * Actors created from callback logic (“callback actors”) can:
 *
 * - Receive events via the `receive` function
 * - Send events to the parent actor via the `sendBack` function
 *
 * Callback actors are a bit different from other actors in that they:
 *
 * - Do not work with `onDone`
 * - Do not produce a snapshot using `.getSnapshot()`
 * - Do not emit values when used with `.subscribe()`
 * - Can not be stopped with `.stop()`
 *
 * @example
 *
 * ```typescript
 * const callbackLogic = fromCallback(({ sendBack, receive }) => {
 *   let lockStatus = 'unlocked';
 *
 *   const handler = (event) => {
 *     if (lockStatus === 'locked') {
 *       return;
 *     }
 *     sendBack(event);
 *   };
 *
 *   receive((event) => {
 *     if (event.type === 'lock') {
 *       lockStatus = 'locked';
 *     } else if (event.type === 'unlock') {
 *       lockStatus = 'unlocked';
 *     }
 *   });
 *
 *   document.body.addEventListener('click', handler);
 *
 *   return () => {
 *     document.body.removeEventListener('click', handler);
 *   };
 * });
 * ```
 *
 * @param callback - The callback function used to describe the callback logic
 *   The callback function is passed an object with the following properties:
 *
 *   - `receive` - A function that can send events back to the parent actor; the
 *       listener is then called whenever events are received by the callback
 *       actor
 *   - `sendBack` - A function that can send events back to the parent actor
 *   - `input` - Data that was provided to the callback actor
 *   - `self` - The parent actor of the callback actor
 *   - `system` - The actor system to which the callback actor belongs The callback
 *       function can (optionally) return a cleanup function, which is called
 *       when the actor is stopped.
 *
 * @returns Callback logic
 * @see {@link CallbackLogicFunction} for more information about the callback function and its object argument
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $2a8d2cfec624a43b$export$d0deb4828877173(callback) {
    const logic = {
        config: callback,
        start: (state, actorScope)=>{
            const { self: self, system: system, emit: emit } = actorScope;
            const callbackState = {
                receivers: undefined,
                dispose: undefined
            };
            $2a8d2cfec624a43b$var$instanceStates.set(self, callbackState);
            callbackState.dispose = callback({
                input: state.input,
                system: system,
                self: self,
                sendBack: (event)=>{
                    if (self.getSnapshot().status === 'stopped') return;
                    if (self._parent) system._relay(self, self._parent, event);
                },
                receive: (listener)=>{
                    var _callbackState;
                    (_callbackState = callbackState).receivers ?? (_callbackState.receivers = new Set());
                    callbackState.receivers.add(listener);
                },
                emit: emit
            });
        },
        transition: (state, event, actorScope)=>{
            const callbackState = $2a8d2cfec624a43b$var$instanceStates.get(actorScope.self);
            if (event.type === (0, $d0N4G.X)) {
                state = {
                    ...state,
                    status: 'stopped',
                    error: undefined
                };
                callbackState.dispose?.();
                return state;
            }
            callbackState.receivers?.forEach((receiver)=>receiver(event));
            return state;
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_NEXT = 'xstate.observable.next';
const $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_ERROR = 'xstate.observable.error';
const $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_COMPLETE = 'xstate.observable.complete';
/**
 * Represents an actor created by `fromObservable` or `fromEventObservable`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * // The type of the value observed by the actor's logic.
 * type Context = number;
 * // The actor's input.
 * type Input = { period?: number };
 *
 * // Actor logic that observes a number incremented every `input.period`
 * // milliseconds (default: 1_000).
 * const logic = fromObservable<Context, Input>(({ input, self }) => {
 *   self;
 *   // ^? ObservableActorRef<Event, Input>
 *
 *   return interval(input.period ?? 1_000);
 * });
 *
 * const actor = createActor(logic, { input: { period: 2_000 } });
 * //    ^? ObservableActorRef<Event, Input>
 * ```
 *
 * @see {@link fromObservable}
 * @see {@link fromEventObservable}
 */ /**
 * Observable actor logic is described by an observable stream of values. Actors
 * created from observable logic (“observable actors”) can:
 *
 * - Emit snapshots of the observable’s emitted value
 *
 * The observable’s emitted value is used as its observable actor’s `context`.
 *
 * Sending events to observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * const logic = fromObservable((obj) => interval(1000));
 *
 * const actor = createActor(logic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot.context);
 * });
 *
 * actor.start();
 * // At every second:
 * // Logs 0
 * // Logs 1
 * // Logs 2
 * // ...
 * ```
 *
 * @param observableCreator A function that creates an observable. It receives
 *   one argument, an object with the following properties:
 *
 *   - `input` - Data that was provided to the observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the observable actor belongs
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 * @see {@link https://rxjs.dev} for documentation on RxJS Observable and observable creators.
 * @see {@link Subscribable} interface in XState, which is based on and compatible with RxJS Observable.
 */ function $2a8d2cfec624a43b$export$4b2432e2d8723823(observableCreator) {
    // TODO: add event types
    const logic = {
        config: observableCreator,
        transition: (snapshot, event)=>{
            if (snapshot.status !== 'active') return snapshot;
            switch(event.type){
                case $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_NEXT:
                    {
                        const newSnapshot = {
                            ...snapshot,
                            context: event.data
                        };
                        return newSnapshot;
                    }
                case $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...snapshot,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...snapshot,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $d0N4G.X:
                    snapshot._subscription.unsubscribe();
                    return {
                        ...snapshot,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return snapshot;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = observableCreator({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    system._relay(self, self, {
                        type: $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_NEXT,
                        data: value
                    });
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...state })=>state,
        restoreSnapshot: (state)=>({
                ...state,
                _subscription: undefined
            })
    };
    return logic;
}
/**
 * Creates event observable logic that listens to an observable that delivers
 * event objects.
 *
 * Event observable actor logic is described by an observable stream of
 * {@link https://stately.ai/docs/transitions#event-objects | event objects}.
 * Actors created from event observable logic (“event observable actors”) can:
 *
 * - Implicitly send events to its parent actor
 * - Emit snapshots of its emitted event objects
 *
 * Sending events to event observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromEventObservable,
 *   Subscribable,
 *   EventObject,
 *   createMachine,
 *   createActor
 * } from 'xstate';
 * import { fromEvent } from 'rxjs';
 *
 * const mouseClickLogic = fromEventObservable(
 *   () => fromEvent(document.body, 'click') as Subscribable<EventObject>
 * );
 *
 * const canvasMachine = createMachine({
 *   invoke: {
 *     // Will send mouse `click` events to the canvas actor
 *     src: mouseClickLogic
 *   }
 * });
 *
 * const canvasActor = createActor(canvasMachine);
 * canvasActor.start();
 * ```
 *
 * @param lazyObservable A function that creates an observable that delivers
 *   event objects. It receives one argument, an object with the following
 *   properties:
 *
 *   - `input` - Data that was provided to the event observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the event observable actor belongs.
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 */ function $2a8d2cfec624a43b$export$32b16bdebc365919(lazyObservable) {
    // TODO: event types
    const logic = {
        config: lazyObservable,
        transition: (state, event)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...state,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $d0N4G.X:
                    state._subscription.unsubscribe();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return state;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = lazyObservable({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    if (self._parent) system._relay(self, self._parent, value);
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $2a8d2cfec624a43b$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...snapshot })=>snapshot,
        restoreSnapshot: (snapshot)=>({
                ...snapshot,
                _subscription: undefined
            })
    };
    return logic;
}
const $2a8d2cfec624a43b$var$XSTATE_PROMISE_RESOLVE = 'xstate.promise.resolve';
const $2a8d2cfec624a43b$var$XSTATE_PROMISE_REJECT = 'xstate.promise.reject';
/**
 * Represents an actor created by `fromPromise`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromPromise, createActor } from 'xstate';
 *
 * // The actor's resolved output
 * type Output = string;
 * // The actor's input.
 * type Input = { message: string };
 *
 * // Actor logic that fetches the url of an image of a cat saying `input.message`.
 * const logic = fromPromise<Output, Input>(async ({ input, self }) => {
 *   self;
 *   // ^? PromiseActorRef<Output, Input>
 *
 *   const data = await fetch(
 *     `https://cataas.com/cat/says/${input.message}`
 *   );
 *   const url = await data.json();
 *   return url;
 * });
 *
 * const actor = createActor(logic, { input: { message: 'hello world' } });
 * //    ^? PromiseActorRef<Output, Input>
 * ```
 *
 * @see {@link fromPromise}
 */ const $2a8d2cfec624a43b$var$controllerMap = new WeakMap();
/**
 * An actor logic creator which returns promise logic as defined by an async
 * process that resolves or rejects after some time.
 *
 * Actors created from promise actor logic (“promise actors”) can:
 *
 * - Emit the resolved value of the promise
 * - Output the resolved value of the promise
 *
 * Sending events to promise actors will have no effect.
 *
 * @example
 *
 * ```ts
 * const promiseLogic = fromPromise(async () => {
 *   const result = await fetch('https://example.com/...').then((data) =>
 *     data.json()
 *   );
 *
 *   return result;
 * });
 *
 * const promiseActor = createActor(promiseLogic);
 * promiseActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * promiseActor.start();
 * // => {
 * //   output: undefined,
 * //   status: 'active'
 * //   ...
 * // }
 *
 * // After promise resolves
 * // => {
 * //   output: { ... },
 * //   status: 'done',
 * //   ...
 * // }
 * ```
 *
 * @param promiseCreator A function which returns a Promise, and accepts an
 *   object with the following properties:
 *
 *   - `input` - Data that was provided to the promise actor
 *   - `self` - The parent actor of the promise actor
 *   - `system` - The actor system to which the promise actor belongs
 *
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $2a8d2cfec624a43b$export$60f45028237c39d1(promiseCreator) {
    const logic = {
        config: promiseCreator,
        transition: (state, event, scope)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $2a8d2cfec624a43b$var$XSTATE_PROMISE_RESOLVE:
                    {
                        const resolvedValue = event.data;
                        return {
                            ...state,
                            status: 'done',
                            output: resolvedValue,
                            input: undefined
                        };
                    }
                case $2a8d2cfec624a43b$var$XSTATE_PROMISE_REJECT:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined
                    };
                case 0, $d0N4G.X:
                    $2a8d2cfec624a43b$var$controllerMap.get(scope.self)?.abort();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined
                    };
                default:
                    return state;
            }
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            // TODO: determine how to allow customizing this so that promises
            // can be restarted if necessary
            if (state.status !== 'active') return;
            const controller = new AbortController();
            $2a8d2cfec624a43b$var$controllerMap.set(self, controller);
            const resolvedPromise = Promise.resolve(promiseCreator({
                input: state.input,
                system: system,
                self: self,
                signal: controller.signal,
                emit: emit
            }));
            resolvedPromise.then((response)=>{
                if (self.getSnapshot().status !== 'active') return;
                $2a8d2cfec624a43b$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $2a8d2cfec624a43b$var$XSTATE_PROMISE_RESOLVE,
                    data: response
                });
            }, (errorData)=>{
                if (self.getSnapshot().status !== 'active') return;
                $2a8d2cfec624a43b$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $2a8d2cfec624a43b$var$XSTATE_PROMISE_REJECT,
                    data: errorData
                });
            });
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $2a8d2cfec624a43b$var$emptyLogic = $2a8d2cfec624a43b$export$439a4be7208a15ca((_)=>undefined, undefined);
function $2a8d2cfec624a43b$export$302970cd5518279b() {
    return (0, $d0N4G.A)($2a8d2cfec624a43b$var$emptyLogic);
}
module.exports["fromCallback"] = $2a8d2cfec624a43b$export$d0deb4828877173;

});

parcelRegister("d0N4G", function(module, exports) {

var $2gWl9 = parcelRequire("2gWl9");

class $9791579b13d7afab$var$Mailbox {
    start() {
        this._active = true;
        this.flush();
    }
    clear() {
        // we can't set _current to null because we might be currently processing
        // and enqueue following clear shouldnt start processing the enqueued item immediately
        if (this._current) {
            this._current.next = null;
            this._last = this._current;
        }
    }
    enqueue(event) {
        const enqueued = {
            value: event,
            next: null
        };
        if (this._current) {
            this._last.next = enqueued;
            this._last = enqueued;
            return;
        }
        this._current = enqueued;
        this._last = enqueued;
        if (this._active) this.flush();
    }
    flush() {
        while(this._current){
            // atm the given _process is responsible for implementing proper try/catch handling
            // we assume here that this won't throw in a way that can affect this mailbox
            const consumed = this._current;
            this._process(consumed.value);
            this._current = consumed.next;
        }
        this._last = null;
    }
    constructor(_process){
        this._process = _process;
        this._active = false;
        this._current = null;
        this._last = null;
    }
}
const $9791579b13d7afab$export$25ce5a424b770e84 = '.';
const $9791579b13d7afab$var$TARGETLESS_KEY = '';
const $9791579b13d7afab$export$a07804094c3ecf2d = '';
const $9791579b13d7afab$var$STATE_IDENTIFIER = '#';
const $9791579b13d7afab$var$WILDCARD = '*';
const $9791579b13d7afab$var$XSTATE_INIT = 'xstate.init';
const $9791579b13d7afab$export$e7c866399fa523f5 = 'xstate.error';
const $9791579b13d7afab$export$78acf4525d8a74c4 = 'xstate.stop';
/**
 * Returns an event that represents an implicit event that is sent after the
 * specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $9791579b13d7afab$var$createAfterEvent(delayRef, id) {
    return {
        type: `xstate.after.${delayRef}.${id}`
    };
}
/**
 * Returns an event that represents that a final state node has been reached in
 * the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param output The data to pass into the event
 */ function $9791579b13d7afab$var$createDoneStateEvent(id, output) {
    return {
        type: `xstate.done.state.${id}`,
        output: output
    };
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state
 * node, but not when it is canceled.
 *
 * @param invokeId The invoked service ID
 * @param output The data to pass into the event
 */ function $9791579b13d7afab$var$createDoneActorEvent(invokeId, output) {
    return {
        type: `xstate.done.actor.${invokeId}`,
        output: output,
        actorId: invokeId
    };
}
function $9791579b13d7afab$export$71cec2538cb2c617(id, error) {
    return {
        type: `xstate.error.actor.${id}`,
        error: error,
        actorId: id
    };
}
function $9791579b13d7afab$export$9e5f44173e64f162(input) {
    return {
        type: $9791579b13d7afab$var$XSTATE_INIT,
        input: input
    };
}
/**
 * This function makes sure that unhandled errors are thrown in a separate
 * macrotask. It allows those errors to be detected by global error handlers and
 * reported to bug tracking services without interrupting our own stack of
 * execution.
 *
 * @param err Error to be thrown
 */ function $9791579b13d7afab$var$reportUnhandledError(err) {
    setTimeout(()=>{
        throw err;
    });
}
const $9791579b13d7afab$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
function $9791579b13d7afab$export$b4171a6734a65d42(parentStateId, childStateId) {
    const parentStateValue = $9791579b13d7afab$var$toStateValue(parentStateId);
    const childStateValue = $9791579b13d7afab$var$toStateValue(childStateId);
    if (typeof childStateValue === 'string') {
        if (typeof parentStateValue === 'string') return childStateValue === parentStateValue;
        // Parent more specific than child
        return false;
    }
    if (typeof parentStateValue === 'string') return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every((key)=>{
        if (!(key in childStateValue)) return false;
        return $9791579b13d7afab$export$b4171a6734a65d42(parentStateValue[key], childStateValue[key]);
    });
}
function $9791579b13d7afab$export$90a7f3efeed30595(stateId) {
    if ($9791579b13d7afab$var$isArray(stateId)) return stateId;
    const result = [];
    let segment = '';
    for(let i = 0; i < stateId.length; i++){
        const char = stateId.charCodeAt(i);
        switch(char){
            // \
            case 92:
                // consume the next character
                segment += stateId[i + 1];
                // and skip over it
                i++;
                continue;
            // .
            case 46:
                result.push(segment);
                segment = '';
                continue;
        }
        segment += stateId[i];
    }
    result.push(segment);
    return result;
}
function $9791579b13d7afab$var$toStateValue(stateValue) {
    if ($9791579b13d7afab$export$7f8ddf7c7c20b3cd(stateValue)) return stateValue.value;
    if (typeof stateValue !== 'string') return stateValue;
    const statePath = $9791579b13d7afab$export$90a7f3efeed30595(stateValue);
    return $9791579b13d7afab$export$3466f893ebf79586(statePath);
}
function $9791579b13d7afab$export$3466f893ebf79586(statePath) {
    if (statePath.length === 1) return statePath[0];
    const value = {};
    let marker = value;
    for(let i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        const previous = marker;
        marker = {};
        previous[statePath[i]] = marker;
    }
    return value;
}
function $9791579b13d7afab$export$953cecd6e717a553(collection, iteratee) {
    const result = {};
    const collectionKeys = Object.keys(collection);
    for(let i = 0; i < collectionKeys.length; i++){
        const key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $9791579b13d7afab$var$toArrayStrict(value) {
    if ($9791579b13d7afab$var$isArray(value)) return value;
    return [
        value
    ];
}
function $9791579b13d7afab$export$625550452a3fa3ec(value) {
    if (value === undefined) return [];
    return $9791579b13d7afab$var$toArrayStrict(value);
}
function $9791579b13d7afab$var$resolveOutput(mapper, context, event, self) {
    if (typeof mapper === 'function') return mapper({
        context: context,
        event: event,
        self: self
    });
    return mapper;
}
function $9791579b13d7afab$var$isArray(value) {
    return Array.isArray(value);
}
function $9791579b13d7afab$var$isErrorActorEvent(event) {
    return event.type.startsWith('xstate.error.actor');
}
function $9791579b13d7afab$export$407448d2b89b1813(configLike) {
    return $9791579b13d7afab$var$toArrayStrict(configLike).map((transitionLike)=>{
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string') return {
            target: transitionLike
        };
        return transitionLike;
    });
}
function $9791579b13d7afab$var$normalizeTarget(target) {
    if (target === undefined || target === $9791579b13d7afab$var$TARGETLESS_KEY) return undefined;
    return $9791579b13d7afab$export$625550452a3fa3ec(target);
}
function $9791579b13d7afab$export$61196ced6d74a310(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
function $9791579b13d7afab$export$db3b6bfb95261072(stateNodeId, index) {
    return `${index}.${stateNodeId}`;
}
function $9791579b13d7afab$export$df995fae86a55f06(machine, src) {
    const match = src.match(/^xstate\.invoke\.(\d+)\.(.*)/);
    if (!match) return machine.implementations.actors[src];
    const [, indexStr, nodeId] = match;
    const node = machine.getStateNodeById(nodeId);
    const invokeConfig = node.config.invoke;
    return (Array.isArray(invokeConfig) ? invokeConfig[indexStr] : invokeConfig).src;
}
function $9791579b13d7afab$export$9bb611d729802a56(snapshot) {
    return [
        ...new Set([
            ...snapshot._nodes.flatMap((sn)=>sn.ownEvents)
        ])
    ];
}
function $9791579b13d7afab$var$createScheduledEventId(actorRef, id) {
    return `${actorRef.sessionId}.${id}`;
}
let $9791579b13d7afab$var$idCounter = 0;
function $9791579b13d7afab$var$createSystem(rootActor, options) {
    const children = new Map();
    const keyedActors = new Map();
    const reverseKeyedActors = new WeakMap();
    const inspectionObservers = new Set();
    const timerMap = {};
    const { clock: clock, logger: logger } = options;
    const scheduler = {
        schedule: (source, target, event, delay, id = Math.random().toString(36).slice(2))=>{
            const scheduledEvent = {
                source: source,
                target: target,
                event: event,
                delay: delay,
                id: id,
                startedAt: Date.now()
            };
            const scheduledEventId = $9791579b13d7afab$var$createScheduledEventId(source, id);
            system._snapshot._scheduledEvents[scheduledEventId] = scheduledEvent;
            const timeout = clock.setTimeout(()=>{
                delete timerMap[scheduledEventId];
                delete system._snapshot._scheduledEvents[scheduledEventId];
                system._relay(source, target, event);
            }, delay);
            timerMap[scheduledEventId] = timeout;
        },
        cancel: (source, id)=>{
            const scheduledEventId = $9791579b13d7afab$var$createScheduledEventId(source, id);
            const timeout = timerMap[scheduledEventId];
            delete timerMap[scheduledEventId];
            delete system._snapshot._scheduledEvents[scheduledEventId];
            if (timeout !== undefined) clock.clearTimeout(timeout);
        },
        cancelAll: (actorRef)=>{
            for(const scheduledEventId in system._snapshot._scheduledEvents){
                const scheduledEvent = system._snapshot._scheduledEvents[scheduledEventId];
                if (scheduledEvent.source === actorRef) scheduler.cancel(actorRef, scheduledEvent.id);
            }
        }
    };
    const sendInspectionEvent = (event)=>{
        if (!inspectionObservers.size) return;
        const resolvedInspectionEvent = {
            ...event,
            rootId: rootActor.sessionId
        };
        inspectionObservers.forEach((observer)=>observer.next?.(resolvedInspectionEvent));
    };
    const system = {
        _snapshot: {
            _scheduledEvents: (options?.snapshot && options.snapshot.scheduler) ?? {}
        },
        _bookId: ()=>`x:${$9791579b13d7afab$var$idCounter++}`,
        _register: (sessionId, actorRef)=>{
            children.set(sessionId, actorRef);
            return sessionId;
        },
        _unregister: (actorRef)=>{
            children.delete(actorRef.sessionId);
            const systemId = reverseKeyedActors.get(actorRef);
            if (systemId !== undefined) {
                keyedActors.delete(systemId);
                reverseKeyedActors.delete(actorRef);
            }
        },
        get: (systemId)=>{
            return keyedActors.get(systemId);
        },
        _set: (systemId, actorRef)=>{
            const existing = keyedActors.get(systemId);
            if (existing && existing !== actorRef) throw new Error(`Actor with system ID '${systemId}' already exists.`);
            keyedActors.set(systemId, actorRef);
            reverseKeyedActors.set(actorRef, systemId);
        },
        inspect: (observerOrFn)=>{
            const observer = $9791579b13d7afab$export$61196ced6d74a310(observerOrFn);
            inspectionObservers.add(observer);
            return {
                unsubscribe () {
                    inspectionObservers.delete(observer);
                }
            };
        },
        _sendInspectionEvent: sendInspectionEvent,
        _relay: (source, target, event)=>{
            system._sendInspectionEvent({
                type: '@xstate.event',
                sourceRef: source,
                actorRef: target,
                event: event
            });
            target._send(event);
        },
        scheduler: scheduler,
        getSnapshot: ()=>{
            return {
                _scheduledEvents: {
                    ...system._snapshot._scheduledEvents
                }
            };
        },
        start: ()=>{
            const scheduledEvents = system._snapshot._scheduledEvents;
            system._snapshot._scheduledEvents = {};
            for(const scheduledId in scheduledEvents){
                const { source: source, target: target, event: event, delay: delay, id: id } = scheduledEvents[scheduledId];
                scheduler.schedule(source, target, event, delay, id);
            }
        },
        _clock: clock,
        _logger: logger
    };
    return system;
}
let $9791579b13d7afab$var$executingCustomAction = false;
const $9791579b13d7afab$export$3d8c2f653ac9d0b9 = 1;
// those values are currently used by @xstate/react directly so it's important to keep the assigned values in sync
let $9791579b13d7afab$export$971d5caa766a69d7 = /*#__PURE__*/ function(ProcessingStatus) {
    ProcessingStatus[ProcessingStatus["NotStarted"] = 0] = "NotStarted";
    ProcessingStatus[ProcessingStatus["Running"] = 1] = "Running";
    ProcessingStatus[ProcessingStatus["Stopped"] = 2] = "Stopped";
    return ProcessingStatus;
}({});
const $9791579b13d7afab$var$defaultOptions = {
    clock: {
        setTimeout: (fn, ms)=>{
            return setTimeout(fn, ms);
        },
        clearTimeout: (id)=>{
            return clearTimeout(id);
        }
    },
    logger: console.log.bind(console),
    devTools: false
};
/**
 * An Actor is a running process that can receive events, send events and change
 * its behavior based on the events it receives, which can cause effects outside
 * of the actor. When you run a state machine, it becomes an actor.
 */ class $9791579b13d7afab$export$ef35774e6d314e91 {
    _initState(persistedState) {
        try {
            this._snapshot = persistedState ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(persistedState, this._actorScope) : persistedState : this.logic.getInitialSnapshot(this._actorScope, this.options?.input);
        } catch (err) {
            // if we get here then it means that we assign a value to this._snapshot that is not of the correct type
            // we can't get the true `TSnapshot & { status: 'error'; }`, it's impossible
            // so right now this is a lie of sorts
            this._snapshot = {
                status: 'error',
                output: undefined,
                error: err
            };
        }
    }
    update(snapshot, event) {
        // Update state
        this._snapshot = snapshot;
        // Execute deferred effects
        let deferredFn;
        while(deferredFn = this._deferred.shift())try {
            deferredFn();
        } catch (err) {
            // this error can only be caught when executing *initial* actions
            // it's the only time when we call actions provided by the user through those deferreds
            // when the actor is already running we always execute them synchronously while transitioning
            // no "builtin deferred" should actually throw an error since they are either safe
            // or the control flow is passed through the mailbox and errors should be caught by the `_process` used by the mailbox
            this._deferred.length = 0;
            this._snapshot = {
                ...snapshot,
                status: 'error',
                error: err
            };
        }
        switch(this._snapshot.status){
            case 'active':
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $9791579b13d7afab$var$reportUnhandledError(err);
                }
                break;
            case 'done':
                // next observers are meant to be notified about done snapshots
                // this can be seen as something that is different from how observable work
                // but with observables `complete` callback is called without any arguments
                // it's more ergonomic for XState to treat a done snapshot as a "next" value
                // and the completion event as something that is separate,
                // something that merely follows emitting that done snapshot
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $9791579b13d7afab$var$reportUnhandledError(err);
                }
                this._stopProcedure();
                this._complete();
                this._doneEvent = $9791579b13d7afab$var$createDoneActorEvent(this.id, this._snapshot.output);
                if (this._parent) this.system._relay(this, this._parent, this._doneEvent);
                break;
            case 'error':
                this._error(this._snapshot.error);
                break;
        }
        this.system._sendInspectionEvent({
            type: '@xstate.snapshot',
            actorRef: this,
            event: event,
            snapshot: snapshot
        });
    }
    /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */ subscribe(nextListenerOrObserver, errorListener, completeListener) {
        const observer = $9791579b13d7afab$export$61196ced6d74a310(nextListenerOrObserver, errorListener, completeListener);
        if (this._processingStatus !== $9791579b13d7afab$export$971d5caa766a69d7.Stopped) this.observers.add(observer);
        else switch(this._snapshot.status){
            case 'done':
                try {
                    observer.complete?.();
                } catch (err) {
                    $9791579b13d7afab$var$reportUnhandledError(err);
                }
                break;
            case 'error':
                {
                    const err = this._snapshot.error;
                    if (!observer.error) $9791579b13d7afab$var$reportUnhandledError(err);
                    else try {
                        observer.error(err);
                    } catch (err) {
                        $9791579b13d7afab$var$reportUnhandledError(err);
                    }
                    break;
                }
        }
        return {
            unsubscribe: ()=>{
                this.observers.delete(observer);
            }
        };
    }
    on(type, handler) {
        let listeners = this.eventListeners.get(type);
        if (!listeners) {
            listeners = new Set();
            this.eventListeners.set(type, listeners);
        }
        const wrappedHandler = handler.bind(undefined);
        listeners.add(wrappedHandler);
        return {
            unsubscribe: ()=>{
                listeners.delete(wrappedHandler);
            }
        };
    }
    /** Starts the Actor from the initial state */ start() {
        if (this._processingStatus === $9791579b13d7afab$export$971d5caa766a69d7.Running) // Do not restart the service if it is already started
        return this;
        if (this._syncSnapshot) this.subscribe({
            next: (snapshot)=>{
                if (snapshot.status === 'active') this.system._relay(this, this._parent, {
                    type: `xstate.snapshot.${this.id}`,
                    snapshot: snapshot
                });
            },
            error: ()=>{}
        });
        this.system._register(this.sessionId, this);
        if (this._systemId) this.system._set(this._systemId, this);
        this._processingStatus = $9791579b13d7afab$export$971d5caa766a69d7.Running;
        // TODO: this isn't correct when rehydrating
        const initEvent = $9791579b13d7afab$export$9e5f44173e64f162(this.options.input);
        this.system._sendInspectionEvent({
            type: '@xstate.event',
            sourceRef: this._parent,
            actorRef: this,
            event: initEvent
        });
        const status = this._snapshot.status;
        switch(status){
            case 'done':
                // a state machine can be "done" upon initialization (it could reach a final state using initial microsteps)
                // we still need to complete observers, flush deferreds etc
                this.update(this._snapshot, initEvent);
                // TODO: rethink cleanup of observers, mailbox, etc
                return this;
            case 'error':
                this._error(this._snapshot.error);
                return this;
        }
        if (!this._parent) this.system.start();
        if (this.logic.start) try {
            this.logic.start(this._snapshot, this._actorScope);
        } catch (err) {
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return this;
        }
        // TODO: this notifies all subscribers but usually this is redundant
        // there is no real change happening here
        // we need to rethink if this needs to be refactored
        this.update(this._snapshot, initEvent);
        if (this.options.devTools) this.attachDevTools();
        this.mailbox.start();
        return this;
    }
    _process(event) {
        let nextState;
        let caughtError;
        try {
            nextState = this.logic.transition(this._snapshot, event, this._actorScope);
        } catch (err) {
            // we wrap it in a box so we can rethrow it later even if falsy value gets caught here
            caughtError = {
                err: err
            };
        }
        if (caughtError) {
            const { err: err } = caughtError;
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return;
        }
        this.update(nextState, event);
        if (event.type === $9791579b13d7afab$export$78acf4525d8a74c4) {
            this._stopProcedure();
            this._complete();
        }
    }
    _stop() {
        if (this._processingStatus === $9791579b13d7afab$export$971d5caa766a69d7.Stopped) return this;
        this.mailbox.clear();
        if (this._processingStatus === $9791579b13d7afab$export$971d5caa766a69d7.NotStarted) {
            this._processingStatus = $9791579b13d7afab$export$971d5caa766a69d7.Stopped;
            return this;
        }
        this.mailbox.enqueue({
            type: $9791579b13d7afab$export$78acf4525d8a74c4
        });
        return this;
    }
    /** Stops the Actor and unsubscribe all listeners. */ stop() {
        if (this._parent) throw new Error('A non-root actor cannot be stopped directly.');
        return this._stop();
    }
    _complete() {
        for (const observer of this.observers)try {
            observer.complete?.();
        } catch (err) {
            $9791579b13d7afab$var$reportUnhandledError(err);
        }
        this.observers.clear();
    }
    _reportError(err) {
        if (!this.observers.size) {
            if (!this._parent) $9791579b13d7afab$var$reportUnhandledError(err);
            return;
        }
        let reportError = false;
        for (const observer of this.observers){
            const errorListener = observer.error;
            reportError || (reportError = !errorListener);
            try {
                errorListener?.(err);
            } catch (err2) {
                $9791579b13d7afab$var$reportUnhandledError(err2);
            }
        }
        this.observers.clear();
        if (reportError) $9791579b13d7afab$var$reportUnhandledError(err);
    }
    _error(err) {
        this._stopProcedure();
        this._reportError(err);
        if (this._parent) this.system._relay(this, this._parent, $9791579b13d7afab$export$71cec2538cb2c617(this.id, err));
    }
    // TODO: atm children don't belong entirely to the actor so
    // in a way - it's not even super aware of them
    // so we can't stop them from here but we really should!
    // right now, they are being stopped within the machine's transition
    // but that could throw and leave us with "orphaned" active actors
    _stopProcedure() {
        if (this._processingStatus !== $9791579b13d7afab$export$971d5caa766a69d7.Running) // Actor already stopped; do nothing
        return this;
        // Cancel all delayed events
        this.system.scheduler.cancelAll(this);
        // TODO: mailbox.reset
        this.mailbox.clear();
        // TODO: after `stop` we must prepare ourselves for receiving events again
        // events sent *after* stop signal must be queued
        // it seems like this should be the common behavior for all of our consumers
        // so perhaps this should be unified somehow for all of them
        this.mailbox = new $9791579b13d7afab$var$Mailbox(this._process.bind(this));
        this._processingStatus = $9791579b13d7afab$export$971d5caa766a69d7.Stopped;
        this.system._unregister(this);
        return this;
    }
    /** @internal */ _send(event) {
        if (this._processingStatus === $9791579b13d7afab$export$971d5caa766a69d7.Stopped) return;
        this.mailbox.enqueue(event);
    }
    /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */ send(event) {
        this.system._relay(undefined, this, event);
    }
    attachDevTools() {
        const { devTools: devTools } = this.options;
        if (devTools) {
            const resolvedDevToolsAdapter = typeof devTools === 'function' ? devTools : (0, $2gWl9.devToolsAdapter);
            resolvedDevToolsAdapter(this);
        }
    }
    toJSON() {
        return {
            xstate$$type: $9791579b13d7afab$export$3d8c2f653ac9d0b9,
            id: this.id
        };
    }
    /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */ getPersistedSnapshot(options) {
        return this.logic.getPersistedSnapshot(this._snapshot, options);
    }
    [$9791579b13d7afab$var$symbolObservable]() {
        return this;
    }
    /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */ getSnapshot() {
        return this._snapshot;
    }
    /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */ constructor(logic, options){
        this.logic = logic;
        /** The current internal state of the actor. */ this._snapshot = void 0;
        /**
     * The clock that is responsible for setting and clearing timeouts, such as
     * delayed events and transitions.
     */ this.clock = void 0;
        this.options = void 0;
        /** The unique identifier for this actor relative to its parent. */ this.id = void 0;
        this.mailbox = new $9791579b13d7afab$var$Mailbox(this._process.bind(this));
        this.observers = new Set();
        this.eventListeners = new Map();
        this.logger = void 0;
        /** @internal */ this._processingStatus = $9791579b13d7afab$export$971d5caa766a69d7.NotStarted;
        // Actor Ref
        this._parent = void 0;
        /** @internal */ this._syncSnapshot = void 0;
        this.ref = void 0;
        // TODO: add typings for system
        this._actorScope = void 0;
        this._systemId = void 0;
        /** The globally unique process ID for this invocation. */ this.sessionId = void 0;
        /** The system to which this actor belongs. */ this.system = void 0;
        this._doneEvent = void 0;
        this.src = void 0;
        // array of functions to defer
        this._deferred = [];
        const resolvedOptions = {
            ...$9791579b13d7afab$var$defaultOptions,
            ...options
        };
        const { clock: clock, logger: logger, parent: parent, syncSnapshot: syncSnapshot, id: id, systemId: systemId, inspect: inspect } = resolvedOptions;
        this.system = parent ? parent.system : $9791579b13d7afab$var$createSystem(this, {
            clock: clock,
            logger: logger
        });
        if (inspect && !parent) // Always inspect at the system-level
        this.system.inspect($9791579b13d7afab$export$61196ced6d74a310(inspect));
        this.sessionId = this.system._bookId();
        this.id = id ?? this.sessionId;
        this.logger = options?.logger ?? this.system._logger;
        this.clock = options?.clock ?? this.system._clock;
        this._parent = parent;
        this._syncSnapshot = syncSnapshot;
        this.options = resolvedOptions;
        this.src = resolvedOptions.src ?? logic;
        this.ref = this;
        this._actorScope = {
            self: this,
            id: this.id,
            sessionId: this.sessionId,
            logger: this.logger,
            defer: (fn)=>{
                this._deferred.push(fn);
            },
            system: this.system,
            stopChild: (child)=>{
                if (child._parent !== this) throw new Error(`Cannot stop child actor ${child.id} of ${this.id} because it is not a child`);
                child._stop();
            },
            emit: (emittedEvent)=>{
                const listeners = this.eventListeners.get(emittedEvent.type);
                const wildcardListener = this.eventListeners.get('*');
                if (!listeners && !wildcardListener) return;
                const allListeners = [
                    ...listeners ? listeners.values() : [],
                    ...wildcardListener ? wildcardListener.values() : []
                ];
                for (const handler of allListeners)handler(emittedEvent);
            },
            actionExecutor: (action)=>{
                const exec = ()=>{
                    this._actorScope.system._sendInspectionEvent({
                        type: '@xstate.action',
                        actorRef: this,
                        action: {
                            type: action.type,
                            params: action.params
                        }
                    });
                    if (!action.exec) return;
                    const saveExecutingCustomAction = $9791579b13d7afab$var$executingCustomAction;
                    try {
                        $9791579b13d7afab$var$executingCustomAction = true;
                        action.exec(action.info, action.params);
                    } finally{
                        $9791579b13d7afab$var$executingCustomAction = saveExecutingCustomAction;
                    }
                };
                if (this._processingStatus === $9791579b13d7afab$export$971d5caa766a69d7.Running) exec();
                else this._deferred.push(exec);
            }
        };
        // Ensure that the send method is bound to this Actor instance
        // if destructured
        this.send = this.send.bind(this);
        this.system._sendInspectionEvent({
            type: '@xstate.actor',
            actorRef: this
        });
        if (systemId) {
            this._systemId = systemId;
            this.system._set(systemId, this);
        }
        this._initState(options?.snapshot ?? options?.state);
        if (systemId && this._snapshot.status !== 'active') this.system._unregister(this);
    }
}
/**
 * Creates a new actor instance for the given actor logic with the provided
 * options, if any.
 *
 * @remarks
 * When you create an actor from actor logic via `createActor(logic)`, you
 * implicitly create an actor system where the created actor is the root actor.
 * Any actors spawned from this root actor and its descendants are part of that
 * actor system.
 * @example
 *
 * ```ts
 * import { createActor } from 'xstate';
 * import { someActorLogic } from './someActorLogic.ts';
 *
 * // Creating the actor, which implicitly creates an actor system with itself as the root actor
 * const actor = createActor(someActorLogic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * // Actors must be started by calling `actor.start()`, which will also start the actor system.
 * actor.start();
 *
 * // Actors can receive events
 * actor.send({ type: 'someEvent' });
 *
 * // You can stop root actors by calling `actor.stop()`, which will also stop the actor system and all actors in that system.
 * actor.stop();
 * ```
 *
 * @param logic - The actor logic to create an actor from. For a state machine
 *   actor logic creator, see {@link createMachine}. Other actor logic creators
 *   include {@link fromCallback}, {@link fromEventObservable},
 *   {@link fromObservable}, {@link fromPromise}, and {@link fromTransition}.
 * @param options - Actor options
 */ function $9791579b13d7afab$export$ebd11618f299a286(logic, ...[options]) {
    return new $9791579b13d7afab$export$ef35774e6d314e91(logic, options);
}
/**
 * Creates a new Interpreter instance for the given machine with the provided
 * options, if any.
 *
 * @deprecated Use `createActor` instead
 * @alias
 */ const $9791579b13d7afab$export$e7094788287c5e9b = $9791579b13d7afab$export$ebd11618f299a286;
/**
 * @deprecated Use `Actor` instead.
 * @alias
 */ function $9791579b13d7afab$var$resolveCancel(_, snapshot, actionArgs, actionParams, { sendId: sendId }) {
    const resolvedSendId = typeof sendId === 'function' ? sendId(actionArgs, actionParams) : sendId;
    return [
        snapshot,
        {
            sendId: resolvedSendId
        },
        undefined
    ];
}
function $9791579b13d7afab$var$executeCancel(actorScope, params) {
    actorScope.defer(()=>{
        actorScope.system.scheduler.cancel(actorScope.self, params.sendId);
    });
}
/**
 * Cancels a delayed `sendTo(...)` action that is waiting to be executed. The
 * canceled `sendTo(...)` action will not send its event or execute, unless the
 * `delay` has already elapsed before `cancel(...)` is called.
 *
 * @example
 *
 * ```ts
 * import { createMachine, sendTo, cancel } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     sendEvent: {
 *       actions: sendTo(
 *         'some-actor',
 *         { type: 'someEvent' },
 *         {
 *           id: 'some-id',
 *           delay: 1000
 *         }
 *       )
 *     },
 *     cancelEvent: {
 *       actions: cancel('some-id')
 *     }
 *   }
 * });
 * ```
 *
 * @param sendId The `id` of the `sendTo(...)` action to cancel.
 */ function $9791579b13d7afab$export$3a1a48c8f6ef640e(sendId) {
    function cancel(_args, _params) {}
    cancel.type = 'xstate.cancel';
    cancel.sendId = sendId;
    cancel.resolve = $9791579b13d7afab$var$resolveCancel;
    cancel.execute = $9791579b13d7afab$var$executeCancel;
    return cancel;
}
function $9791579b13d7afab$var$resolveSpawn(actorScope, snapshot, actionArgs, _actionParams, { id: id, systemId: systemId, src: src, input: input, syncSnapshot: syncSnapshot }) {
    const logic = typeof src === 'string' ? $9791579b13d7afab$export$df995fae86a55f06(snapshot.machine, src) : src;
    const resolvedId = typeof id === 'function' ? id(actionArgs) : id;
    let actorRef;
    let resolvedInput = undefined;
    if (logic) {
        resolvedInput = typeof input === 'function' ? input({
            context: snapshot.context,
            event: actionArgs.event,
            self: actorScope.self
        }) : input;
        actorRef = $9791579b13d7afab$export$ebd11618f299a286(logic, {
            id: resolvedId,
            src: src,
            parent: actorScope.self,
            syncSnapshot: syncSnapshot,
            systemId: systemId,
            input: resolvedInput
        });
    }
    return [
        $9791579b13d7afab$export$3a6d5c9ae78a2c08(snapshot, {
            children: {
                ...snapshot.children,
                [resolvedId]: actorRef
            }
        }),
        {
            id: id,
            systemId: systemId,
            actorRef: actorRef,
            src: src,
            input: resolvedInput
        },
        undefined
    ];
}
function $9791579b13d7afab$var$executeSpawn(actorScope, { actorRef: actorRef }) {
    if (!actorRef) return;
    actorScope.defer(()=>{
        if (actorRef._processingStatus === $9791579b13d7afab$export$971d5caa766a69d7.Stopped) return;
        actorRef.start();
    });
}
function $9791579b13d7afab$export$56c0d5a1e737357d(...[src, { id: id, systemId: systemId, input: input, syncSnapshot: syncSnapshot = false } = {}]) {
    function spawnChild1(_args, _params) {}
    spawnChild1.type = 'xstate.spawnChild';
    spawnChild1.id = id;
    spawnChild1.systemId = systemId;
    spawnChild1.src = src;
    spawnChild1.input = input;
    spawnChild1.syncSnapshot = syncSnapshot;
    spawnChild1.resolve = $9791579b13d7afab$var$resolveSpawn;
    spawnChild1.execute = $9791579b13d7afab$var$executeSpawn;
    return spawnChild1;
}
function $9791579b13d7afab$var$resolveStop(_, snapshot, args, actionParams, { actorRef: actorRef }) {
    const actorRefOrString = typeof actorRef === 'function' ? actorRef(args, actionParams) : actorRef;
    const resolvedActorRef = typeof actorRefOrString === 'string' ? snapshot.children[actorRefOrString] : actorRefOrString;
    let children = snapshot.children;
    if (resolvedActorRef) {
        children = {
            ...children
        };
        delete children[resolvedActorRef.id];
    }
    return [
        $9791579b13d7afab$export$3a6d5c9ae78a2c08(snapshot, {
            children: children
        }),
        resolvedActorRef,
        undefined
    ];
}
function $9791579b13d7afab$var$executeStop(actorScope, actorRef) {
    if (!actorRef) return;
    // we need to eagerly unregister it here so a new actor with the same systemId can be registered immediately
    // since we defer actual stopping of the actor but we don't defer actor creations (and we can't do that)
    // this could throw on `systemId` collision, for example, when dealing with reentering transitions
    actorScope.system._unregister(actorRef);
    // this allows us to prevent an actor from being started if it gets stopped within the same macrostep
    // this can happen, for example, when the invoking state is being exited immediately by an always transition
    if (actorRef._processingStatus !== $9791579b13d7afab$export$971d5caa766a69d7.Running) {
        actorScope.stopChild(actorRef);
        return;
    }
    // stopping a child enqueues a stop event in the child actor's mailbox
    // we need for all of the already enqueued events to be processed before we stop the child
    // the parent itself might want to send some events to a child (for example from exit actions on the invoking state)
    // and we don't want to ignore those events
    actorScope.defer(()=>{
        actorScope.stopChild(actorRef);
    });
}
/**
 * Stops a child actor.
 *
 * @param actorRef The actor to stop.
 */ function $9791579b13d7afab$export$db202ddc8be9136(actorRef) {
    function stop(_args, _params) {}
    stop.type = 'xstate.stopChild';
    stop.actorRef = actorRef;
    stop.resolve = $9791579b13d7afab$var$resolveStop;
    stop.execute = $9791579b13d7afab$var$executeStop;
    return stop;
}
/**
 * Stops a child actor.
 *
 * @deprecated Use `stopChild(...)` instead
 * @alias
 */ const $9791579b13d7afab$export$3722cfe417b6ed86 = $9791579b13d7afab$export$db202ddc8be9136;
function $9791579b13d7afab$var$checkStateIn(snapshot, _, { stateValue: stateValue }) {
    if (typeof stateValue === 'string' && $9791579b13d7afab$export$efccba1c4a2ef57b(stateValue)) {
        const target = snapshot.machine.getStateNodeById(stateValue);
        return snapshot._nodes.some((sn)=>sn === target);
    }
    return snapshot.matches(stateValue);
}
function $9791579b13d7afab$export$2329c99376c9d0a4(stateValue) {
    function stateIn() {
        return false;
    }
    stateIn.check = $9791579b13d7afab$var$checkStateIn;
    stateIn.stateValue = stateValue;
    return stateIn;
}
function $9791579b13d7afab$var$checkNot(snapshot, { context: context, event: event }, { guards: guards }) {
    return !$9791579b13d7afab$export$f1e1789686576879(guards[0], context, event, snapshot);
}
/**
 * Higher-order guard that evaluates to `true` if the `guard` passed to it
 * evaluates to `false`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, not } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => false
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: not('someNamedGuard'),
 *       actions: () => {
 *         // will be executed if guard in `not(...)`
 *         // evaluates to `false`
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard
 */ function $9791579b13d7afab$export$a9c23c6ac3fc3eca(guard) {
    function not(_args, _params) {
        return false;
    }
    not.check = $9791579b13d7afab$var$checkNot;
    not.guards = [
        guard
    ];
    return not;
}
function $9791579b13d7afab$var$checkAnd(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.every((guard)=>$9791579b13d7afab$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if all `guards` passed to it
 * evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, and } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: and([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if all guards in `and(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $9791579b13d7afab$export$96f57966bedc81b4(guards) {
    function and(_args, _params) {
        return false;
    }
    and.check = $9791579b13d7afab$var$checkAnd;
    and.guards = guards;
    return and;
}
function $9791579b13d7afab$var$checkOr(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.some((guard)=>$9791579b13d7afab$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if any of the `guards` passed to
 * it evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, or } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: or([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if any of the guards in `or(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $9791579b13d7afab$export$d66501df72047452(guards) {
    function or(_args, _params) {
        return false;
    }
    or.check = $9791579b13d7afab$var$checkOr;
    or.guards = guards;
    return or;
}
// TODO: throw on cycles (depth check should be enough)
function $9791579b13d7afab$export$f1e1789686576879(guard, context, event, snapshot) {
    const { machine: machine } = snapshot;
    const isInline = typeof guard === 'function';
    const resolved = isInline ? guard : machine.implementations.guards[typeof guard === 'string' ? guard : guard.type];
    if (!isInline && !resolved) throw new Error(`Guard '${typeof guard === 'string' ? guard : guard.type}' is not implemented.'.`);
    if (typeof resolved !== 'function') return $9791579b13d7afab$export$f1e1789686576879(resolved, context, event, snapshot);
    const guardArgs = {
        context: context,
        event: event
    };
    const guardParams = isInline || typeof guard === 'string' ? undefined : 'params' in guard ? typeof guard.params === 'function' ? guard.params({
        context: context,
        event: event
    }) : guard.params : undefined;
    if (!('check' in resolved)) // the existing type of `.guards` assumes non-nullable `TExpressionGuard`
    // inline guards expect `TExpressionGuard` to be set to `undefined`
    // it's fine to cast this here, our logic makes sure that we call those 2 "variants" correctly
    return resolved(guardArgs, guardParams);
    const builtinGuard = resolved;
    return builtinGuard.check(snapshot, guardArgs, resolved // this holds all params
    );
}
const $9791579b13d7afab$var$isAtomicStateNode = (stateNode)=>stateNode.type === 'atomic' || stateNode.type === 'final';
function $9791579b13d7afab$var$getChildren(stateNode) {
    return Object.values(stateNode.states).filter((sn)=>sn.type !== 'history');
}
function $9791579b13d7afab$var$getProperAncestors(stateNode, toStateNode) {
    const ancestors = [];
    if (toStateNode === stateNode) return ancestors;
    // add all ancestors
    let m = stateNode.parent;
    while(m && m !== toStateNode){
        ancestors.push(m);
        m = m.parent;
    }
    return ancestors;
}
function $9791579b13d7afab$export$23f2a1d2818174ef(stateNodes) {
    const nodeSet = new Set(stateNodes);
    const adjList = $9791579b13d7afab$var$getAdjList(nodeSet);
    // add descendants
    for (const s of nodeSet)// if previously active, add existing child nodes
    if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) $9791579b13d7afab$var$getInitialStateNodesWithTheirAncestors(s).forEach((sn)=>nodeSet.add(sn));
    else {
        if (s.type === 'parallel') for (const child of $9791579b13d7afab$var$getChildren(s)){
            if (child.type === 'history') continue;
            if (!nodeSet.has(child)) {
                const initialStates = $9791579b13d7afab$var$getInitialStateNodesWithTheirAncestors(child);
                for (const initialStateNode of initialStates)nodeSet.add(initialStateNode);
            }
        }
    }
    // add all ancestors
    for (const s of nodeSet){
        let m = s.parent;
        while(m){
            nodeSet.add(m);
            m = m.parent;
        }
    }
    return nodeSet;
}
function $9791579b13d7afab$var$getValueFromAdj(baseNode, adjList) {
    const childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        const childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($9791579b13d7afab$var$isAtomicStateNode(childStateNode)) return childStateNode.key;
        } else return {};
    }
    const stateValue = {};
    for (const childStateNode of childStateNodes)stateValue[childStateNode.key] = $9791579b13d7afab$var$getValueFromAdj(childStateNode, adjList);
    return stateValue;
}
function $9791579b13d7afab$var$getAdjList(stateNodes) {
    const adjList = new Map();
    for (const s of stateNodes){
        if (!adjList.has(s)) adjList.set(s, []);
        if (s.parent) {
            if (!adjList.has(s.parent)) adjList.set(s.parent, []);
            adjList.get(s.parent).push(s);
        }
    }
    return adjList;
}
function $9791579b13d7afab$var$getStateValue(rootNode, stateNodes) {
    const config = $9791579b13d7afab$export$23f2a1d2818174ef(stateNodes);
    return $9791579b13d7afab$var$getValueFromAdj(rootNode, $9791579b13d7afab$var$getAdjList(config));
}
function $9791579b13d7afab$export$882b5998b3b9117c(stateNodeSet, stateNode) {
    if (stateNode.type === 'compound') return $9791579b13d7afab$var$getChildren(stateNode).some((s)=>s.type === 'final' && stateNodeSet.has(s));
    if (stateNode.type === 'parallel') return $9791579b13d7afab$var$getChildren(stateNode).every((sn)=>$9791579b13d7afab$export$882b5998b3b9117c(stateNodeSet, sn));
    return stateNode.type === 'final';
}
const $9791579b13d7afab$export$efccba1c4a2ef57b = (str)=>str[0] === $9791579b13d7afab$var$STATE_IDENTIFIER;
function $9791579b13d7afab$export$dda1d9f60106f0e9(stateNode, receivedEventType) {
    const candidates = stateNode.transitions.get(receivedEventType) || [
        ...stateNode.transitions.keys()
    ].filter((eventDescriptor)=>{
        // check if transition is a wildcard transition,
        // which matches any non-transient events
        if (eventDescriptor === $9791579b13d7afab$var$WILDCARD) return true;
        if (!eventDescriptor.endsWith('.*')) return false;
        const partialEventTokens = eventDescriptor.split('.');
        const eventTokens = receivedEventType.split('.');
        for(let tokenIndex = 0; tokenIndex < partialEventTokens.length; tokenIndex++){
            const partialEventToken = partialEventTokens[tokenIndex];
            const eventToken = eventTokens[tokenIndex];
            if (partialEventToken === '*') {
                const isLastToken = tokenIndex === partialEventTokens.length - 1;
                return isLastToken;
            }
            if (partialEventToken !== eventToken) return false;
        }
        return true;
    }).sort((a, b)=>b.length - a.length).flatMap((key)=>stateNode.transitions.get(key));
    return candidates;
}
/** All delayed transitions from the config. */ function $9791579b13d7afab$export$39b482c5e57630a8(stateNode) {
    const afterConfig = stateNode.config.after;
    if (!afterConfig) return [];
    const mutateEntryExit = (delay)=>{
        const afterEvent = $9791579b13d7afab$var$createAfterEvent(delay, stateNode.id);
        const eventType = afterEvent.type;
        stateNode.entry.push($9791579b13d7afab$export$c4ce752e73470fba(afterEvent, {
            id: eventType,
            delay: delay
        }));
        stateNode.exit.push($9791579b13d7afab$export$3a1a48c8f6ef640e(eventType));
        return eventType;
    };
    const delayedTransitions = Object.keys(afterConfig).flatMap((delay)=>{
        const configTransition = afterConfig[delay];
        const resolvedTransition = typeof configTransition === 'string' ? {
            target: configTransition
        } : configTransition;
        const resolvedDelay = Number.isNaN(+delay) ? delay : +delay;
        const eventType = mutateEntryExit(resolvedDelay);
        return $9791579b13d7afab$export$625550452a3fa3ec(resolvedTransition).map((transition)=>({
                ...transition,
                event: eventType,
                delay: resolvedDelay
            }));
    });
    return delayedTransitions.map((delayedTransition)=>{
        const { delay: delay } = delayedTransition;
        return {
            ...$9791579b13d7afab$export$8b22cf2602fb60ce(stateNode, delayedTransition.event, delayedTransition),
            delay: delay
        };
    });
}
function $9791579b13d7afab$export$8b22cf2602fb60ce(stateNode, descriptor, transitionConfig) {
    const normalizedTarget = $9791579b13d7afab$var$normalizeTarget(transitionConfig.target);
    const reenter = transitionConfig.reenter ?? false;
    const target = $9791579b13d7afab$var$resolveTarget(stateNode, normalizedTarget);
    const transition = {
        ...transitionConfig,
        actions: $9791579b13d7afab$export$625550452a3fa3ec(transitionConfig.actions),
        guard: transitionConfig.guard,
        target: target,
        source: stateNode,
        reenter: reenter,
        eventType: descriptor,
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: target ? target.map((t)=>`#${t.id}`) : undefined
            })
    };
    return transition;
}
function $9791579b13d7afab$export$2d1720544b23b823(stateNode) {
    const transitions = new Map();
    if (stateNode.config.on) for (const descriptor of Object.keys(stateNode.config.on)){
        if (descriptor === $9791579b13d7afab$export$a07804094c3ecf2d) throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
        const transitionsConfig = stateNode.config.on[descriptor];
        transitions.set(descriptor, $9791579b13d7afab$export$407448d2b89b1813(transitionsConfig).map((t)=>$9791579b13d7afab$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    if (stateNode.config.onDone) {
        const descriptor = `xstate.done.state.${stateNode.id}`;
        transitions.set(descriptor, $9791579b13d7afab$export$407448d2b89b1813(stateNode.config.onDone).map((t)=>$9791579b13d7afab$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    for (const invokeDef of stateNode.invoke){
        if (invokeDef.onDone) {
            const descriptor = `xstate.done.actor.${invokeDef.id}`;
            transitions.set(descriptor, $9791579b13d7afab$export$407448d2b89b1813(invokeDef.onDone).map((t)=>$9791579b13d7afab$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onError) {
            const descriptor = `xstate.error.actor.${invokeDef.id}`;
            transitions.set(descriptor, $9791579b13d7afab$export$407448d2b89b1813(invokeDef.onError).map((t)=>$9791579b13d7afab$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onSnapshot) {
            const descriptor = `xstate.snapshot.${invokeDef.id}`;
            transitions.set(descriptor, $9791579b13d7afab$export$407448d2b89b1813(invokeDef.onSnapshot).map((t)=>$9791579b13d7afab$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
    }
    for (const delayedTransition of stateNode.after){
        let existing = transitions.get(delayedTransition.eventType);
        if (!existing) {
            existing = [];
            transitions.set(delayedTransition.eventType, existing);
        }
        existing.push(delayedTransition);
    }
    return transitions;
}
function $9791579b13d7afab$export$4368d992c4eafac0(stateNode, _target) {
    const resolvedTarget = typeof _target === 'string' ? stateNode.states[_target] : _target ? stateNode.states[_target.target] : undefined;
    if (!resolvedTarget && _target) throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
    `Initial state node "${_target}" not found on parent state node #${stateNode.id}`);
    const transition = {
        source: stateNode,
        actions: !_target || typeof _target === 'string' ? [] : $9791579b13d7afab$export$625550452a3fa3ec(_target.actions),
        eventType: null,
        reenter: false,
        target: resolvedTarget ? [
            resolvedTarget
        ] : [],
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: resolvedTarget ? [
                    `#${resolvedTarget.id}`
                ] : []
            })
    };
    return transition;
}
function $9791579b13d7afab$var$resolveTarget(stateNode, targets) {
    if (targets === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
    return undefined;
    return targets.map((target)=>{
        if (typeof target !== 'string') return target;
        if ($9791579b13d7afab$export$efccba1c4a2ef57b(target)) return stateNode.machine.getStateNodeById(target);
        const isInternalTarget = target[0] === $9791579b13d7afab$export$25ce5a424b770e84;
        // If internal target is defined on machine,
        // do not include machine key on target
        if (isInternalTarget && !stateNode.parent) return $9791579b13d7afab$export$d141bba7fdc215a3(stateNode, target.slice(1));
        const resolvedTarget = isInternalTarget ? stateNode.key + target : target;
        if (stateNode.parent) try {
            const targetStateNode = $9791579b13d7afab$export$d141bba7fdc215a3(stateNode.parent, resolvedTarget);
            return targetStateNode;
        } catch (err) {
            throw new Error(`Invalid transition definition for state node '${stateNode.id}':\n${err.message}`);
        }
        else throw new Error(`Invalid target: "${target}" is not a valid target from the root node. Did you mean ".${target}"?`);
    });
}
function $9791579b13d7afab$var$resolveHistoryDefaultTransition(stateNode) {
    const normalizedTarget = $9791579b13d7afab$var$normalizeTarget(stateNode.config.target);
    if (!normalizedTarget) return stateNode.parent.initial;
    return {
        target: normalizedTarget.map((t)=>typeof t === 'string' ? $9791579b13d7afab$export$d141bba7fdc215a3(stateNode.parent, t) : t)
    };
}
function $9791579b13d7afab$var$isHistoryNode(stateNode) {
    return stateNode.type === 'history';
}
function $9791579b13d7afab$var$getInitialStateNodesWithTheirAncestors(stateNode) {
    const states = $9791579b13d7afab$export$3b14a55fb2447963(stateNode);
    for (const initialState of states)for (const ancestor of $9791579b13d7afab$var$getProperAncestors(initialState, stateNode))states.add(ancestor);
    return states;
}
function $9791579b13d7afab$export$3b14a55fb2447963(stateNode) {
    const set = new Set();
    function iter(descStateNode) {
        if (set.has(descStateNode)) return;
        set.add(descStateNode);
        if (descStateNode.type === 'compound') iter(descStateNode.initial.target[0]);
        else if (descStateNode.type === 'parallel') for (const child of $9791579b13d7afab$var$getChildren(descStateNode))iter(child);
    }
    iter(stateNode);
    return set;
}
/** Returns the child state node from its relative `stateKey`, or throws. */ function $9791579b13d7afab$var$getStateNode(stateNode, stateKey) {
    if ($9791579b13d7afab$export$efccba1c4a2ef57b(stateKey)) return stateNode.machine.getStateNodeById(stateKey);
    if (!stateNode.states) throw new Error(`Unable to retrieve child state '${stateKey}' from '${stateNode.id}'; no child states exist.`);
    const result = stateNode.states[stateKey];
    if (!result) throw new Error(`Child state '${stateKey}' does not exist on '${stateNode.id}'`);
    return result;
}
/**
 * Returns the relative state node from the given `statePath`, or throws.
 *
 * @param statePath The string or string array relative path to the state node.
 */ function $9791579b13d7afab$export$d141bba7fdc215a3(stateNode, statePath) {
    if (typeof statePath === 'string' && $9791579b13d7afab$export$efccba1c4a2ef57b(statePath)) try {
        return stateNode.machine.getStateNodeById(statePath);
    } catch  {
    // try individual paths
    // throw e;
    }
    const arrayStatePath = $9791579b13d7afab$export$90a7f3efeed30595(statePath).slice();
    let currentStateNode = stateNode;
    while(arrayStatePath.length){
        const key = arrayStatePath.shift();
        if (!key.length) break;
        currentStateNode = $9791579b13d7afab$var$getStateNode(currentStateNode, key);
    }
    return currentStateNode;
}
/**
 * Returns the state nodes represented by the current state value.
 *
 * @param stateValue The state value or State instance
 */ function $9791579b13d7afab$export$35e795649ee09318(stateNode, stateValue) {
    if (typeof stateValue === 'string') {
        const childStateNode = stateNode.states[stateValue];
        if (!childStateNode) throw new Error(`State '${stateValue}' does not exist on '${stateNode.id}'`);
        return [
            stateNode,
            childStateNode
        ];
    }
    const childStateKeys = Object.keys(stateValue);
    const childStateNodes = childStateKeys.map((subStateKey)=>$9791579b13d7afab$var$getStateNode(stateNode, subStateKey)).filter(Boolean);
    return [
        stateNode.machine.root,
        stateNode
    ].concat(childStateNodes, childStateKeys.reduce((allSubStateNodes, subStateKey)=>{
        const subStateNode = $9791579b13d7afab$var$getStateNode(stateNode, subStateKey);
        if (!subStateNode) return allSubStateNodes;
        const subStateNodes = $9791579b13d7afab$export$35e795649ee09318(subStateNode, stateValue[subStateKey]);
        return allSubStateNodes.concat(subStateNodes);
    }, []));
}
function $9791579b13d7afab$var$transitionAtomicNode(stateNode, stateValue, snapshot, event) {
    const childStateNode = $9791579b13d7afab$var$getStateNode(stateNode, stateValue);
    const next = childStateNode.next(snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $9791579b13d7afab$var$transitionCompoundNode(stateNode, stateValue, snapshot, event) {
    const subStateKeys = Object.keys(stateValue);
    const childStateNode = $9791579b13d7afab$var$getStateNode(stateNode, subStateKeys[0]);
    const next = $9791579b13d7afab$export$ae1af26003f05816(childStateNode, stateValue[subStateKeys[0]], snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $9791579b13d7afab$var$transitionParallelNode(stateNode, stateValue, snapshot, event) {
    const allInnerTransitions = [];
    for (const subStateKey of Object.keys(stateValue)){
        const subStateValue = stateValue[subStateKey];
        if (!subStateValue) continue;
        const subStateNode = $9791579b13d7afab$var$getStateNode(stateNode, subStateKey);
        const innerTransitions = $9791579b13d7afab$export$ae1af26003f05816(subStateNode, subStateValue, snapshot, event);
        if (innerTransitions) allInnerTransitions.push(...innerTransitions);
    }
    if (!allInnerTransitions.length) return stateNode.next(snapshot, event);
    return allInnerTransitions;
}
function $9791579b13d7afab$export$ae1af26003f05816(stateNode, stateValue, snapshot, event) {
    // leaf node
    if (typeof stateValue === 'string') return $9791579b13d7afab$var$transitionAtomicNode(stateNode, stateValue, snapshot, event);
    // compound node
    if (Object.keys(stateValue).length === 1) return $9791579b13d7afab$var$transitionCompoundNode(stateNode, stateValue, snapshot, event);
    // parallel node
    return $9791579b13d7afab$var$transitionParallelNode(stateNode, stateValue, snapshot, event);
}
function $9791579b13d7afab$var$getHistoryNodes(stateNode) {
    return Object.keys(stateNode.states).map((key)=>stateNode.states[key]).filter((sn)=>sn.type === 'history');
}
function $9791579b13d7afab$var$isDescendant(childStateNode, parentStateNode) {
    let marker = childStateNode;
    while(marker.parent && marker.parent !== parentStateNode)marker = marker.parent;
    return marker.parent === parentStateNode;
}
function $9791579b13d7afab$var$hasIntersection(s1, s2) {
    const set1 = new Set(s1);
    const set2 = new Set(s2);
    for (const item of set1){
        if (set2.has(item)) return true;
    }
    for (const item of set2){
        if (set1.has(item)) return true;
    }
    return false;
}
function $9791579b13d7afab$var$removeConflictingTransitions(enabledTransitions, stateNodeSet, historyValue) {
    const filteredTransitions = new Set();
    for (const t1 of enabledTransitions){
        let t1Preempted = false;
        const transitionsToRemove = new Set();
        for (const t2 of filteredTransitions)if ($9791579b13d7afab$var$hasIntersection($9791579b13d7afab$var$computeExitSet([
            t1
        ], stateNodeSet, historyValue), $9791579b13d7afab$var$computeExitSet([
            t2
        ], stateNodeSet, historyValue))) {
            if ($9791579b13d7afab$var$isDescendant(t1.source, t2.source)) transitionsToRemove.add(t2);
            else {
                t1Preempted = true;
                break;
            }
        }
        if (!t1Preempted) {
            for (const t3 of transitionsToRemove)filteredTransitions.delete(t3);
            filteredTransitions.add(t1);
        }
    }
    return Array.from(filteredTransitions);
}
function $9791579b13d7afab$var$findLeastCommonAncestor(stateNodes) {
    const [head, ...tail] = stateNodes;
    for (const ancestor of $9791579b13d7afab$var$getProperAncestors(head, undefined)){
        if (tail.every((sn)=>$9791579b13d7afab$var$isDescendant(sn, ancestor))) return ancestor;
    }
}
function $9791579b13d7afab$var$getEffectiveTargetStates(transition, historyValue) {
    if (!transition.target) return [];
    const targets = new Set();
    for (const targetNode of transition.target)if ($9791579b13d7afab$var$isHistoryNode(targetNode)) {
        if (historyValue[targetNode.id]) for (const node of historyValue[targetNode.id])targets.add(node);
        else for (const node of $9791579b13d7afab$var$getEffectiveTargetStates($9791579b13d7afab$var$resolveHistoryDefaultTransition(targetNode), historyValue))targets.add(node);
    } else targets.add(targetNode);
    return [
        ...targets
    ];
}
function $9791579b13d7afab$var$getTransitionDomain(transition, historyValue) {
    const targetStates = $9791579b13d7afab$var$getEffectiveTargetStates(transition, historyValue);
    if (!targetStates) return;
    if (!transition.reenter && targetStates.every((target)=>target === transition.source || $9791579b13d7afab$var$isDescendant(target, transition.source))) return transition.source;
    const lca = $9791579b13d7afab$var$findLeastCommonAncestor(targetStates.concat(transition.source));
    if (lca) return lca;
    // at this point we know that it's a root transition since LCA couldn't be found
    if (transition.reenter) return;
    return transition.source.machine.root;
}
function $9791579b13d7afab$var$computeExitSet(transitions, stateNodeSet, historyValue) {
    const statesToExit = new Set();
    for (const t of transitions)if (t.target?.length) {
        const domain = $9791579b13d7afab$var$getTransitionDomain(t, historyValue);
        if (t.reenter && t.source === domain) statesToExit.add(domain);
        for (const stateNode of stateNodeSet)if ($9791579b13d7afab$var$isDescendant(stateNode, domain)) statesToExit.add(stateNode);
    }
    return [
        ...statesToExit
    ];
}
function $9791579b13d7afab$var$areStateNodeCollectionsEqual(prevStateNodes, nextStateNodeSet) {
    if (prevStateNodes.length !== nextStateNodeSet.size) return false;
    for (const node of prevStateNodes){
        if (!nextStateNodeSet.has(node)) return false;
    }
    return true;
}
/** https://www.w3.org/TR/scxml/#microstepProcedure */ function $9791579b13d7afab$export$2408f22a0fab9ae5(transitions, currentSnapshot, actorScope, event, isInitial, internalQueue) {
    if (!transitions.length) return currentSnapshot;
    const mutStateNodeSet = new Set(currentSnapshot._nodes);
    let historyValue = currentSnapshot.historyValue;
    const filteredTransitions = $9791579b13d7afab$var$removeConflictingTransitions(transitions, mutStateNodeSet, historyValue);
    let nextState = currentSnapshot;
    // Exit states
    if (!isInitial) [nextState, historyValue] = $9791579b13d7afab$var$exitStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, historyValue, internalQueue, actorScope.actionExecutor);
    // Execute transition content
    nextState = $9791579b13d7afab$export$ffb5f4729a158638(nextState, event, actorScope, filteredTransitions.flatMap((t)=>t.actions), internalQueue, undefined);
    // Enter states
    nextState = $9791579b13d7afab$var$enterStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial);
    const nextStateNodes = [
        ...mutStateNodeSet
    ];
    if (nextState.status === 'done') nextState = $9791579b13d7afab$export$ffb5f4729a158638(nextState, event, actorScope, nextStateNodes.sort((a, b)=>b.order - a.order).flatMap((state)=>state.exit), internalQueue, undefined);
    // eslint-disable-next-line no-useless-catch
    try {
        if (historyValue === currentSnapshot.historyValue && $9791579b13d7afab$var$areStateNodeCollectionsEqual(currentSnapshot._nodes, mutStateNodeSet)) return nextState;
        return $9791579b13d7afab$export$3a6d5c9ae78a2c08(nextState, {
            _nodes: nextStateNodes,
            historyValue: historyValue
        });
    } catch (e) {
        // TODO: Refactor this once proper error handling is implemented.
        // See https://github.com/statelyai/rfcs/pull/4
        throw e;
    }
}
function $9791579b13d7afab$var$getMachineOutput(snapshot, event, actorScope, rootNode, rootCompletionNode) {
    if (rootNode.output === undefined) return;
    const doneStateEvent = $9791579b13d7afab$var$createDoneStateEvent(rootCompletionNode.id, rootCompletionNode.output !== undefined && rootCompletionNode.parent ? $9791579b13d7afab$var$resolveOutput(rootCompletionNode.output, snapshot.context, event, actorScope.self) : undefined);
    return $9791579b13d7afab$var$resolveOutput(rootNode.output, snapshot.context, doneStateEvent, actorScope.self);
}
function $9791579b13d7afab$var$enterStates(currentSnapshot, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial) {
    let nextSnapshot = currentSnapshot;
    const statesToEnter = new Set();
    // those are states that were directly targeted or indirectly targeted by the explicit target
    // in other words, those are states for which initial actions should be executed
    // when we target `#deep_child` initial actions of its ancestors shouldn't be executed
    const statesForDefaultEntry = new Set();
    $9791579b13d7afab$var$computeEntrySet(filteredTransitions, historyValue, statesForDefaultEntry, statesToEnter);
    // In the initial state, the root state node is "entered".
    if (isInitial) statesForDefaultEntry.add(currentSnapshot.machine.root);
    const completedNodes = new Set();
    for (const stateNodeToEnter of [
        ...statesToEnter
    ].sort((a, b)=>a.order - b.order)){
        mutStateNodeSet.add(stateNodeToEnter);
        const actions = [];
        // Add entry actions
        actions.push(...stateNodeToEnter.entry);
        for (const invokeDef of stateNodeToEnter.invoke)actions.push($9791579b13d7afab$export$56c0d5a1e737357d(invokeDef.src, {
            ...invokeDef,
            syncSnapshot: !!invokeDef.onSnapshot
        }));
        if (statesForDefaultEntry.has(stateNodeToEnter)) {
            const initialActions = stateNodeToEnter.initial.actions;
            actions.push(...initialActions);
        }
        nextSnapshot = $9791579b13d7afab$export$ffb5f4729a158638(nextSnapshot, event, actorScope, actions, internalQueue, stateNodeToEnter.invoke.map((invokeDef)=>invokeDef.id));
        if (stateNodeToEnter.type === 'final') {
            const parent = stateNodeToEnter.parent;
            let ancestorMarker = parent?.type === 'parallel' ? parent : parent?.parent;
            let rootCompletionNode = ancestorMarker || stateNodeToEnter;
            if (parent?.type === 'compound') internalQueue.push($9791579b13d7afab$var$createDoneStateEvent(parent.id, stateNodeToEnter.output !== undefined ? $9791579b13d7afab$var$resolveOutput(stateNodeToEnter.output, nextSnapshot.context, event, actorScope.self) : undefined));
            while(ancestorMarker?.type === 'parallel' && !completedNodes.has(ancestorMarker) && $9791579b13d7afab$export$882b5998b3b9117c(mutStateNodeSet, ancestorMarker)){
                completedNodes.add(ancestorMarker);
                internalQueue.push($9791579b13d7afab$var$createDoneStateEvent(ancestorMarker.id));
                rootCompletionNode = ancestorMarker;
                ancestorMarker = ancestorMarker.parent;
            }
            if (ancestorMarker) continue;
            nextSnapshot = $9791579b13d7afab$export$3a6d5c9ae78a2c08(nextSnapshot, {
                status: 'done',
                output: $9791579b13d7afab$var$getMachineOutput(nextSnapshot, event, actorScope, nextSnapshot.machine.root, rootCompletionNode)
            });
        }
    }
    return nextSnapshot;
}
function $9791579b13d7afab$var$computeEntrySet(transitions, historyValue, statesForDefaultEntry, statesToEnter) {
    for (const t of transitions){
        const domain = $9791579b13d7afab$var$getTransitionDomain(t, historyValue);
        for (const s of t.target || []){
            if (!$9791579b13d7afab$var$isHistoryNode(s) && // if the target is different than the source then it will *definitely* be entered
            (t.source !== s || // we know that the domain can't lie within the source
            // if it's different than the source then it's outside of it and it means that the target has to be entered as well
            t.source !== domain || // reentering transitions always enter the target, even if it's the source itself
            t.reenter)) {
                statesToEnter.add(s);
                statesForDefaultEntry.add(s);
            }
            $9791579b13d7afab$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
        }
        const targetStates = $9791579b13d7afab$var$getEffectiveTargetStates(t, historyValue);
        for (const s of targetStates){
            const ancestors = $9791579b13d7afab$var$getProperAncestors(s, domain);
            if (domain?.type === 'parallel') ancestors.push(domain);
            $9791579b13d7afab$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, !t.source.parent && t.reenter ? undefined : domain);
        }
    }
}
function $9791579b13d7afab$var$addDescendantStatesToEnter(stateNode, historyValue, statesForDefaultEntry, statesToEnter) {
    if ($9791579b13d7afab$var$isHistoryNode(stateNode)) {
        if (historyValue[stateNode.id]) {
            const historyStateNodes = historyValue[stateNode.id];
            for (const s of historyStateNodes){
                statesToEnter.add(s);
                $9791579b13d7afab$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyStateNodes)$9791579b13d7afab$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        } else {
            const historyDefaultTransition = $9791579b13d7afab$var$resolveHistoryDefaultTransition(stateNode);
            for (const s of historyDefaultTransition.target){
                statesToEnter.add(s);
                if (historyDefaultTransition === stateNode.parent?.initial) statesForDefaultEntry.add(stateNode.parent);
                $9791579b13d7afab$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyDefaultTransition.target)$9791579b13d7afab$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        }
    } else {
        if (stateNode.type === 'compound') {
            const [initialState] = stateNode.initial.target;
            if (!$9791579b13d7afab$var$isHistoryNode(initialState)) {
                statesToEnter.add(initialState);
                statesForDefaultEntry.add(initialState);
            }
            $9791579b13d7afab$var$addDescendantStatesToEnter(initialState, historyValue, statesForDefaultEntry, statesToEnter);
            $9791579b13d7afab$var$addProperAncestorStatesToEnter(initialState, stateNode, statesToEnter, historyValue, statesForDefaultEntry);
        } else if (stateNode.type === 'parallel') {
            for (const child of $9791579b13d7afab$var$getChildren(stateNode).filter((sn)=>!$9791579b13d7afab$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$9791579b13d7afab$var$isDescendant(s, child))) {
                if (!$9791579b13d7afab$var$isHistoryNode(child)) {
                    statesToEnter.add(child);
                    statesForDefaultEntry.add(child);
                }
                $9791579b13d7afab$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $9791579b13d7afab$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, reentrancyDomain) {
    for (const anc of ancestors){
        if (!reentrancyDomain || $9791579b13d7afab$var$isDescendant(anc, reentrancyDomain)) statesToEnter.add(anc);
        if (anc.type === 'parallel') {
            for (const child of $9791579b13d7afab$var$getChildren(anc).filter((sn)=>!$9791579b13d7afab$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$9791579b13d7afab$var$isDescendant(s, child))) {
                statesToEnter.add(child);
                $9791579b13d7afab$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $9791579b13d7afab$var$addProperAncestorStatesToEnter(stateNode, toStateNode, statesToEnter, historyValue, statesForDefaultEntry) {
    $9791579b13d7afab$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, $9791579b13d7afab$var$getProperAncestors(stateNode, toStateNode));
}
function $9791579b13d7afab$var$exitStates(currentSnapshot, event, actorScope, transitions, mutStateNodeSet, historyValue, internalQueue, _actionExecutor) {
    let nextSnapshot = currentSnapshot;
    const statesToExit = $9791579b13d7afab$var$computeExitSet(transitions, mutStateNodeSet, historyValue);
    statesToExit.sort((a, b)=>b.order - a.order);
    let changedHistory;
    // From SCXML algorithm: https://www.w3.org/TR/scxml/#exitStates
    for (const exitStateNode of statesToExit)for (const historyNode of $9791579b13d7afab$var$getHistoryNodes(exitStateNode)){
        let predicate;
        if (historyNode.history === 'deep') predicate = (sn)=>$9791579b13d7afab$var$isAtomicStateNode(sn) && $9791579b13d7afab$var$isDescendant(sn, exitStateNode);
        else predicate = (sn)=>{
            return sn.parent === exitStateNode;
        };
        changedHistory ?? (changedHistory = {
            ...historyValue
        });
        changedHistory[historyNode.id] = Array.from(mutStateNodeSet).filter(predicate);
    }
    for (const s of statesToExit){
        nextSnapshot = $9791579b13d7afab$export$ffb5f4729a158638(nextSnapshot, event, actorScope, [
            ...s.exit,
            ...s.invoke.map((def)=>$9791579b13d7afab$export$db202ddc8be9136(def.id))
        ], internalQueue, undefined);
        mutStateNodeSet.delete(s);
    }
    return [
        nextSnapshot,
        changedHistory || historyValue
    ];
}
function $9791579b13d7afab$var$getAction(machine, actionType) {
    return machine.implementations.actions[actionType];
}
function $9791579b13d7afab$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, extra, retries) {
    const { machine: machine } = currentSnapshot;
    let intermediateSnapshot = currentSnapshot;
    for (const action of actions){
        const isInline = typeof action === 'function';
        const resolvedAction = isInline ? action : // the existing type of `.actions` assumes non-nullable `TExpressionAction`
        // it's fine to cast this here to get a common type and lack of errors in the rest of the code
        // our logic below makes sure that we call those 2 "variants" correctly
        $9791579b13d7afab$var$getAction(machine, typeof action === 'string' ? action : action.type);
        const actionArgs = {
            context: intermediateSnapshot.context,
            event: event,
            self: actorScope.self,
            system: actorScope.system
        };
        const actionParams = isInline || typeof action === 'string' ? undefined : 'params' in action ? typeof action.params === 'function' ? action.params({
            context: intermediateSnapshot.context,
            event: event
        }) : action.params : undefined;
        if (!resolvedAction || !('resolve' in resolvedAction)) {
            actorScope.actionExecutor({
                type: typeof action === 'string' ? action : typeof action === 'object' ? action.type : action.name || '(anonymous)',
                info: actionArgs,
                params: actionParams,
                exec: resolvedAction
            });
            continue;
        }
        const builtinAction = resolvedAction;
        const [nextState, params, actions] = builtinAction.resolve(actorScope, intermediateSnapshot, actionArgs, actionParams, resolvedAction, // this holds all params
        extra);
        intermediateSnapshot = nextState;
        if ('retryResolve' in builtinAction) retries?.push([
            builtinAction,
            params
        ]);
        if ('execute' in builtinAction) actorScope.actionExecutor({
            type: builtinAction.type,
            info: actionArgs,
            params: params,
            exec: builtinAction.execute.bind(null, actorScope, params)
        });
        if (actions) intermediateSnapshot = $9791579b13d7afab$var$resolveAndExecuteActionsWithContext(intermediateSnapshot, event, actorScope, actions, extra, retries);
    }
    return intermediateSnapshot;
}
function $9791579b13d7afab$export$ffb5f4729a158638(currentSnapshot, event, actorScope, actions, internalQueue, deferredActorIds) {
    const retries = deferredActorIds ? [] : undefined;
    const nextState = $9791579b13d7afab$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, {
        internalQueue: internalQueue,
        deferredActorIds: deferredActorIds
    }, retries);
    retries?.forEach(([builtinAction, params])=>{
        builtinAction.retryResolve(actorScope, nextState, params);
    });
    return nextState;
}
function $9791579b13d7afab$export$7ccc53e8f1e7dfc5(snapshot, event, actorScope, internalQueue) {
    let nextSnapshot = snapshot;
    const microstates = [];
    function addMicrostate(microstate, event, transitions) {
        actorScope.system._sendInspectionEvent({
            type: '@xstate.microstep',
            actorRef: actorScope.self,
            event: event,
            snapshot: microstate,
            _transitions: transitions
        });
        microstates.push(microstate);
    }
    // Handle stop event
    if (event.type === $9791579b13d7afab$export$78acf4525d8a74c4) {
        nextSnapshot = $9791579b13d7afab$export$3a6d5c9ae78a2c08($9791579b13d7afab$var$stopChildren(nextSnapshot, event, actorScope), {
            status: 'stopped'
        });
        addMicrostate(nextSnapshot, event, []);
        return {
            snapshot: nextSnapshot,
            microstates: microstates
        };
    }
    let nextEvent = event;
    // Assume the state is at rest (no raised events)
    // Determine the next state based on the next microstep
    if (nextEvent.type !== $9791579b13d7afab$var$XSTATE_INIT) {
        const currentEvent = nextEvent;
        const isErr = $9791579b13d7afab$var$isErrorActorEvent(currentEvent);
        const transitions = $9791579b13d7afab$var$selectTransitions(currentEvent, nextSnapshot);
        if (isErr && !transitions.length) {
            // TODO: we should likely only allow transitions selected by very explicit descriptors
            // `*` shouldn't be matched, likely `xstate.error.*` shouldnt be either
            // similarly `xstate.error.actor.*` and `xstate.error.actor.todo.*` have to be considered too
            nextSnapshot = $9791579b13d7afab$export$3a6d5c9ae78a2c08(snapshot, {
                status: 'error',
                error: currentEvent.error
            });
            addMicrostate(nextSnapshot, currentEvent, []);
            return {
                snapshot: nextSnapshot,
                microstates: microstates
            };
        }
        nextSnapshot = $9791579b13d7afab$export$2408f22a0fab9ae5(transitions, snapshot, actorScope, nextEvent, false, // isInitial
        internalQueue);
        addMicrostate(nextSnapshot, currentEvent, transitions);
    }
    let shouldSelectEventlessTransitions = true;
    while(nextSnapshot.status === 'active'){
        let enabledTransitions = shouldSelectEventlessTransitions ? $9791579b13d7afab$var$selectEventlessTransitions(nextSnapshot, nextEvent) : [];
        // eventless transitions should always be selected after selecting *regular* transitions
        // by assigning `undefined` to `previousState` we ensure that `shouldSelectEventlessTransitions` gets always computed to true in such a case
        const previousState = enabledTransitions.length ? nextSnapshot : undefined;
        if (!enabledTransitions.length) {
            if (!internalQueue.length) break;
            nextEvent = internalQueue.shift();
            enabledTransitions = $9791579b13d7afab$var$selectTransitions(nextEvent, nextSnapshot);
        }
        nextSnapshot = $9791579b13d7afab$export$2408f22a0fab9ae5(enabledTransitions, nextSnapshot, actorScope, nextEvent, false, internalQueue);
        shouldSelectEventlessTransitions = nextSnapshot !== previousState;
        addMicrostate(nextSnapshot, nextEvent, enabledTransitions);
    }
    if (nextSnapshot.status !== 'active') $9791579b13d7afab$var$stopChildren(nextSnapshot, nextEvent, actorScope);
    return {
        snapshot: nextSnapshot,
        microstates: microstates
    };
}
function $9791579b13d7afab$var$stopChildren(nextState, event, actorScope) {
    return $9791579b13d7afab$export$ffb5f4729a158638(nextState, event, actorScope, Object.values(nextState.children).map((child)=>$9791579b13d7afab$export$db202ddc8be9136(child)), [], undefined);
}
function $9791579b13d7afab$var$selectTransitions(event, nextState) {
    return nextState.machine.getTransitionData(nextState, event);
}
function $9791579b13d7afab$var$selectEventlessTransitions(nextState, event) {
    const enabledTransitionSet = new Set();
    const atomicStates = nextState._nodes.filter($9791579b13d7afab$var$isAtomicStateNode);
    for (const stateNode of atomicStates)loop: for (const s of [
        stateNode
    ].concat($9791579b13d7afab$var$getProperAncestors(stateNode, undefined))){
        if (!s.always) continue;
        for (const transition of s.always)if (transition.guard === undefined || $9791579b13d7afab$export$f1e1789686576879(transition.guard, nextState.context, event, nextState)) {
            enabledTransitionSet.add(transition);
            break loop;
        }
    }
    return $9791579b13d7afab$var$removeConflictingTransitions(Array.from(enabledTransitionSet), new Set(nextState._nodes), nextState.historyValue);
}
/**
 * Resolves a partial state value with its full representation in the state
 * node's machine.
 *
 * @param stateValue The partial state value to resolve.
 */ function $9791579b13d7afab$export$43caf9889c228507(rootNode, stateValue) {
    const allStateNodes = $9791579b13d7afab$export$23f2a1d2818174ef($9791579b13d7afab$export$35e795649ee09318(rootNode, stateValue));
    return $9791579b13d7afab$var$getStateValue(rootNode, [
        ...allStateNodes
    ]);
}
function $9791579b13d7afab$export$7f8ddf7c7c20b3cd(value) {
    return !!value && typeof value === 'object' && 'machine' in value && 'value' in value;
}
const $9791579b13d7afab$var$machineSnapshotMatches = function matches(testValue) {
    return $9791579b13d7afab$export$b4171a6734a65d42(testValue, this.value);
};
const $9791579b13d7afab$var$machineSnapshotHasTag = function hasTag(tag) {
    return this.tags.has(tag);
};
const $9791579b13d7afab$var$machineSnapshotCan = function can(event) {
    const transitionData = this.machine.getTransitionData(this, event);
    return !!transitionData?.length && // Check that at least one transition is not forbidden
    transitionData.some((t)=>t.target !== undefined || t.actions.length);
};
const $9791579b13d7afab$var$machineSnapshotToJSON = function toJSON() {
    const { _nodes: nodes, tags: tags, machine: machine, getMeta: getMeta, toJSON: toJSON, can: can, hasTag: hasTag, matches: matches, ...jsonValues } = this;
    return {
        ...jsonValues,
        tags: Array.from(tags)
    };
};
const $9791579b13d7afab$var$machineSnapshotGetMeta = function getMeta() {
    return this._nodes.reduce((acc, stateNode)=>{
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
};
function $9791579b13d7afab$export$342063e11d6c3cad(config, machine) {
    return {
        status: config.status,
        output: config.output,
        error: config.error,
        machine: machine,
        context: config.context,
        _nodes: config._nodes,
        value: $9791579b13d7afab$var$getStateValue(machine.root, config._nodes),
        tags: new Set(config._nodes.flatMap((sn)=>sn.tags)),
        children: config.children,
        historyValue: config.historyValue || {},
        matches: $9791579b13d7afab$var$machineSnapshotMatches,
        hasTag: $9791579b13d7afab$var$machineSnapshotHasTag,
        can: $9791579b13d7afab$var$machineSnapshotCan,
        getMeta: $9791579b13d7afab$var$machineSnapshotGetMeta,
        toJSON: $9791579b13d7afab$var$machineSnapshotToJSON
    };
}
function $9791579b13d7afab$export$3a6d5c9ae78a2c08(snapshot, config = {}) {
    return $9791579b13d7afab$export$342063e11d6c3cad({
        ...snapshot,
        ...config
    }, snapshot.machine);
}
function $9791579b13d7afab$export$4a5767248b18ef41(snapshot, options) {
    const { _nodes: nodes, tags: tags, machine: machine, children: children, context: context, can: can, hasTag: hasTag, matches: matches, getMeta: getMeta, toJSON: toJSON, ...jsonValues } = snapshot;
    const childrenJson = {};
    for(const id in children){
        const child = children[id];
        childrenJson[id] = {
            snapshot: child.getPersistedSnapshot(options),
            src: child.src,
            systemId: child._systemId,
            syncSnapshot: child._syncSnapshot
        };
    }
    const persisted = {
        ...jsonValues,
        context: $9791579b13d7afab$var$persistContext(context),
        children: childrenJson
    };
    return persisted;
}
function $9791579b13d7afab$var$persistContext(contextPart) {
    let copy;
    for(const key in contextPart){
        const value = contextPart[key];
        if (value && typeof value === 'object') {
            if ('sessionId' in value && 'send' in value && 'ref' in value) {
                copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                    ...contextPart
                });
                copy[key] = {
                    xstate$$type: $9791579b13d7afab$export$3d8c2f653ac9d0b9,
                    id: value.id
                };
            } else {
                const result = $9791579b13d7afab$var$persistContext(value);
                if (result !== value) {
                    copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                        ...contextPart
                    });
                    copy[key] = result;
                }
            }
        }
    }
    return copy ?? contextPart;
}
function $9791579b13d7afab$var$resolveRaise(_, snapshot, args, actionParams, { event: eventOrExpr, id: id, delay: delay }, { internalQueue: internalQueue }) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with raise; use raise({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    if (typeof resolvedDelay !== 'number') internalQueue.push(resolvedEvent);
    return [
        snapshot,
        {
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $9791579b13d7afab$var$executeRaise(actorScope, params) {
    const { event: event, delay: delay, id: id } = params;
    if (typeof delay === 'number') {
        actorScope.defer(()=>{
            const self = actorScope.self;
            actorScope.system.scheduler.schedule(self, self, event, delay, id);
        });
        return;
    }
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $9791579b13d7afab$export$c4ce752e73470fba(eventOrExpr, options) {
    function raise(_args, _params) {}
    raise.type = 'xstate.raise';
    raise.event = eventOrExpr;
    raise.id = options?.id;
    raise.delay = options?.delay;
    raise.resolve = $9791579b13d7afab$var$resolveRaise;
    raise.execute = $9791579b13d7afab$var$executeRaise;
    return raise;
}
module.exports["S"] = $9791579b13d7afab$export$25ce5a424b770e84;
module.exports["N"] = $9791579b13d7afab$export$a07804094c3ecf2d;
module.exports["V"] = $9791579b13d7afab$export$e7c866399fa523f5;
module.exports["X"] = $9791579b13d7afab$export$78acf4525d8a74c4;
module.exports["W"] = $9791579b13d7afab$export$71cec2538cb2c617;
module.exports["q"] = $9791579b13d7afab$export$9e5f44173e64f162;
module.exports["v"] = $9791579b13d7afab$export$90a7f3efeed30595;
module.exports["m"] = $9791579b13d7afab$export$953cecd6e717a553;
module.exports["t"] = $9791579b13d7afab$export$625550452a3fa3ec;
module.exports["a"] = $9791579b13d7afab$export$407448d2b89b1813;
module.exports["L"] = $9791579b13d7afab$export$61196ced6d74a310;
module.exports["c"] = $9791579b13d7afab$export$db3b6bfb95261072;
module.exports["z"] = $9791579b13d7afab$export$df995fae86a55f06;
module.exports["$"] = $9791579b13d7afab$export$3d8c2f653ac9d0b9;
module.exports["T"] = $9791579b13d7afab$export$971d5caa766a69d7;
module.exports["A"] = $9791579b13d7afab$export$ebd11618f299a286;
module.exports["M"] = $9791579b13d7afab$export$3a1a48c8f6ef640e;
module.exports["U"] = $9791579b13d7afab$export$3a6d5c9ae78a2c08;
module.exports["P"] = $9791579b13d7afab$export$56c0d5a1e737357d;
module.exports["R"] = $9791579b13d7afab$export$db202ddc8be9136;
module.exports["w"] = $9791579b13d7afab$export$efccba1c4a2ef57b;
module.exports["e"] = $9791579b13d7afab$export$f1e1789686576879;
module.exports["i"] = $9791579b13d7afab$export$23f2a1d2818174ef;
module.exports["l"] = $9791579b13d7afab$export$882b5998b3b9117c;
module.exports["h"] = $9791579b13d7afab$export$dda1d9f60106f0e9;
module.exports["g"] = $9791579b13d7afab$export$39b482c5e57630a8;
module.exports["O"] = $9791579b13d7afab$export$c4ce752e73470fba;
module.exports["b"] = $9791579b13d7afab$export$8b22cf2602fb60ce;
module.exports["f"] = $9791579b13d7afab$export$2d1720544b23b823;
module.exports["d"] = $9791579b13d7afab$export$4368d992c4eafac0;
module.exports["x"] = $9791579b13d7afab$export$d141bba7fdc215a3;
module.exports["u"] = $9791579b13d7afab$export$3b14a55fb2447963;
module.exports["j"] = $9791579b13d7afab$export$35e795649ee09318;
module.exports["o"] = $9791579b13d7afab$export$ae1af26003f05816;
module.exports["s"] = $9791579b13d7afab$export$2408f22a0fab9ae5;
module.exports["p"] = $9791579b13d7afab$export$ffb5f4729a158638;
module.exports["n"] = $9791579b13d7afab$export$7ccc53e8f1e7dfc5;
module.exports["r"] = $9791579b13d7afab$export$43caf9889c228507;
module.exports["k"] = $9791579b13d7afab$export$342063e11d6c3cad;
module.exports["y"] = $9791579b13d7afab$export$4a5767248b18ef41;

});

parcelRegister("cPMXw", function(module, exports) {

var $d0N4G = parcelRequire("d0N4G");

function $958039aea9590b3b$var$createSpawner(actorScope, { machine: machine, context: context }, event, spawnedChildren) {
    const spawn = (src, options = {})=>{
        const { systemId: systemId, input: input } = options;
        if (typeof src === 'string') {
            const logic = (0, $d0N4G.z)(machine, src);
            if (!logic) throw new Error(`Actor logic '${src}' not implemented in machine '${machine.id}'`);
            const actorRef = (0, $d0N4G.A)(logic, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: typeof input === 'function' ? input({
                    context: context,
                    event: event,
                    self: actorScope.self
                }) : input,
                src: src,
                systemId: systemId
            });
            spawnedChildren[actorRef.id] = actorRef;
            return actorRef;
        } else {
            const actorRef = (0, $d0N4G.A)(src, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: options.input,
                src: src,
                systemId: systemId
            });
            return actorRef;
        }
    };
    return (src, options)=>{
        const actorRef = spawn(src, options); // TODO: fix types
        spawnedChildren[actorRef.id] = actorRef;
        actorScope.defer(()=>{
            if (actorRef._processingStatus === (0, $d0N4G.T).Stopped) return;
            actorRef.start();
        });
        return actorRef;
    };
}
function $958039aea9590b3b$var$resolveAssign(actorScope, snapshot, actionArgs, actionParams, { assignment: assignment }) {
    if (!snapshot.context) throw new Error('Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.');
    const spawnedChildren = {};
    const assignArgs = {
        context: snapshot.context,
        event: actionArgs.event,
        spawn: $958039aea9590b3b$var$createSpawner(actorScope, snapshot, actionArgs.event, spawnedChildren),
        self: actorScope.self,
        system: actorScope.system
    };
    let partialUpdate = {};
    if (typeof assignment === 'function') partialUpdate = assignment(assignArgs, actionParams);
    else for (const key of Object.keys(assignment)){
        const propAssignment = assignment[key];
        partialUpdate[key] = typeof propAssignment === 'function' ? propAssignment(assignArgs, actionParams) : propAssignment;
    }
    const updatedContext = Object.assign({}, snapshot.context, partialUpdate);
    return [
        (0, $d0N4G.U)(snapshot, {
            context: updatedContext,
            children: Object.keys(spawnedChildren).length ? {
                ...snapshot.children,
                ...spawnedChildren
            } : snapshot.children
        }),
        undefined,
        undefined
    ];
}
/**
 * Updates the current context of the machine.
 *
 * @example
 *
 * ```ts
 * import { createMachine, assign } from 'xstate';
 *
 * const countMachine = createMachine({
 *   context: {
 *     count: 0,
 *     message: ''
 *   },
 *   on: {
 *     inc: {
 *       actions: assign({
 *         count: ({ context }) => context.count + 1
 *       })
 *     },
 *     updateMessage: {
 *       actions: assign(({ context, event }) => {
 *         return {
 *           message: event.message.trim()
 *         };
 *       })
 *     }
 *   }
 * });
 * ```
 *
 * @param assignment An object that represents the partial context to update, or
 *   a function that returns an object that represents the partial context to
 *   update.
 */ function $958039aea9590b3b$export$407448d2b89b1813(assignment) {
    function assign(_args, _params) {}
    assign.type = 'xstate.assign';
    assign.assignment = assignment;
    assign.resolve = $958039aea9590b3b$var$resolveAssign;
    return assign;
}
function $958039aea9590b3b$var$resolveEmit(_, snapshot, args, actionParams, { event: eventOrExpr }) {
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    return [
        snapshot,
        {
            event: resolvedEvent
        },
        undefined
    ];
}
function $958039aea9590b3b$var$executeEmit(actorScope, { event: event }) {
    actorScope.defer(()=>actorScope.emit(event));
}
/**
 * Emits an event to event handlers registered on the actor via `actor.on(event,
 * handler)`.
 *
 * @example
 *
 * ```ts
 * import { emit } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     something: {
 *       actions: emit({
 *         type: 'emitted',
 *         some: 'data'
 *       })
 *     }
 *   }
 *   // ...
 * });
 *
 * const actor = createActor(machine).start();
 *
 * actor.on('emitted', (event) => {
 *   console.log(event);
 * });
 *
 * actor.send({ type: 'something' });
 * // logs:
 * // {
 * //   type: 'emitted',
 * //   some: 'data'
 * // }
 * ```
 */ function $958039aea9590b3b$export$f1e1789686576879(/** The event to emit, or an expression that returns an event to emit. */ eventOrExpr) {
    function emit(_args, _params) {}
    emit.type = 'xstate.emit';
    emit.event = eventOrExpr;
    emit.resolve = $958039aea9590b3b$var$resolveEmit;
    emit.execute = $958039aea9590b3b$var$executeEmit;
    return emit;
}
/**
 * @remarks
 * `T | unknown` reduces to `unknown` and that can be problematic when it comes
 * to contextual typing. It especially is a problem when the union has a
 * function member, like here:
 *
 * ```ts
 * declare function test(
 *   cbOrVal: ((arg: number) => unknown) | unknown
 * ): void;
 * test((arg) => {}); // oops, implicit any
 * ```
 *
 * This type can be used to avoid this problem. This union represents the same
 * value space as `unknown`.
 */ // https://github.com/microsoft/TypeScript/issues/23182#issuecomment-379091887
// @TODO: Replace with native `NoInfer` when TS issue gets fixed:
// https://github.com/microsoft/TypeScript/pull/57673
/** @deprecated Use the built-in `NoInfer` type instead */ /** The full definition of an event, with a string `type`. */ /**
 * The string or object representing the state value relative to the parent
 * state node.
 *
 * @remarks
 * - For a child atomic state node, this is a string, e.g., `"pending"`.
 * - For complex state nodes, this is an object, e.g., `{ success:
 *   "someChildState" }`.
 */ /** @deprecated Use `AnyMachineSnapshot` instead */ // TODO: possibly refactor this somehow, use even a simpler type, and maybe even make `machine.options` private or something
/** @ignore */ let $958039aea9590b3b$export$25ce5a424b770e84 = /*#__PURE__*/ function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
    return SpecialTargets;
}({});
/** @deprecated Use `AnyActor` instead. */ // Based on RxJS types
// TODO: in v6, this should only accept AnyActorLogic, like ActorRefFromLogic
/** @deprecated Use `Actor<T>` instead. */ /**
 * Represents logic which can be used by an actor.
 *
 * @template TSnapshot - The type of the snapshot.
 * @template TEvent - The type of the event object.
 * @template TInput - The type of the input.
 * @template TSystem - The type of the actor system.
 */ /** @deprecated */ // TODO: cover all that can be actually returned
function $958039aea9590b3b$var$resolveSendTo(actorScope, snapshot, args, actionParams, { to: to, event: eventOrExpr, id: id, delay: delay }, extra) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with sendTo; use sendTo({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    const resolvedTarget = typeof to === 'function' ? to(args, actionParams) : to;
    let targetActorRef;
    if (typeof resolvedTarget === 'string') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (resolvedTarget === $958039aea9590b3b$export$25ce5a424b770e84.Parent) targetActorRef = actorScope.self._parent;
        else if (resolvedTarget === $958039aea9590b3b$export$25ce5a424b770e84.Internal) targetActorRef = actorScope.self;
        else if (resolvedTarget.startsWith('#_')) // SCXML compatibility: https://www.w3.org/TR/scxml/#SCXMLEventProcessor
        // #_invokeid. If the target is the special term '#_invokeid', where invokeid is the invokeid of an SCXML session that the sending session has created by <invoke>, the Processor must add the event to the external queue of that session.
        targetActorRef = snapshot.children[resolvedTarget.slice(2)];
        else targetActorRef = extra.deferredActorIds?.includes(resolvedTarget) ? resolvedTarget : snapshot.children[resolvedTarget];
        if (!targetActorRef) throw new Error(`Unable to send event to actor '${resolvedTarget}' from machine '${snapshot.machine.id}'.`);
    } else targetActorRef = resolvedTarget || actorScope.self;
    return [
        snapshot,
        {
            to: targetActorRef,
            targetId: typeof resolvedTarget === 'string' ? resolvedTarget : undefined,
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $958039aea9590b3b$var$retryResolveSendTo(_, snapshot, params) {
    if (typeof params.to === 'string') params.to = snapshot.children[params.to];
}
function $958039aea9590b3b$var$executeSendTo(actorScope, params) {
    // this forms an outgoing events queue
    // thanks to that the recipient actors are able to read the *updated* snapshot value of the sender
    actorScope.defer(()=>{
        const { to: to, event: event, delay: delay, id: id } = params;
        if (typeof delay === 'number') {
            actorScope.system.scheduler.schedule(actorScope.self, to, event, delay, id);
            return;
        }
        actorScope.system._relay(actorScope.self, // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
        // if it initially started as a string
        to, event.type === (0, $d0N4G.V) ? (0, $d0N4G.W)(actorScope.self.id, event.data) : event);
    });
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event
 *   to send
 * @param options Send action options
 *
 *   - `id` - The unique send event identifier (used with `cancel()`).
 *   - `delay` - The number of milliseconds to delay the sending of the event.
 */ function $958039aea9590b3b$export$db3b6bfb95261072(to, eventOrExpr, options) {
    function sendTo(_args, _params) {}
    sendTo.type = 'xstate.sendTo';
    sendTo.to = to;
    sendTo.event = eventOrExpr;
    sendTo.id = options?.id;
    sendTo.delay = options?.delay;
    sendTo.resolve = $958039aea9590b3b$var$resolveSendTo;
    sendTo.retryResolve = $958039aea9590b3b$var$retryResolveSendTo;
    sendTo.execute = $958039aea9590b3b$var$executeSendTo;
    return sendTo;
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $958039aea9590b3b$export$2408f22a0fab9ae5(event, options) {
    return $958039aea9590b3b$export$db3b6bfb95261072($958039aea9590b3b$export$25ce5a424b770e84.Parent, event, options);
}
/**
 * Forwards (sends) an event to the `target` actor.
 *
 * @param target The target actor to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $958039aea9590b3b$export$2d1720544b23b823(target, options) {
    return $958039aea9590b3b$export$db3b6bfb95261072(target, ({ event: event })=>event, options);
}
function $958039aea9590b3b$var$resolveEnqueueActions(actorScope, snapshot, args, actionParams, { collect: collect }) {
    const actions = [];
    const enqueue = function enqueue(action) {
        actions.push(action);
    };
    enqueue.assign = (...args)=>{
        actions.push($958039aea9590b3b$export$407448d2b89b1813(...args));
    };
    enqueue.cancel = (...args)=>{
        actions.push((0, $d0N4G.M)(...args));
    };
    enqueue.raise = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay`
        actions.push((0, $d0N4G.O)(...args));
    };
    enqueue.sendTo = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay
        actions.push($958039aea9590b3b$export$db3b6bfb95261072(...args));
    };
    enqueue.sendParent = (...args)=>{
        actions.push($958039aea9590b3b$export$2408f22a0fab9ae5(...args));
    };
    enqueue.spawnChild = (...args)=>{
        actions.push((0, $d0N4G.P)(...args));
    };
    enqueue.stopChild = (...args)=>{
        actions.push((0, $d0N4G.R)(...args));
    };
    enqueue.emit = (...args)=>{
        actions.push($958039aea9590b3b$export$f1e1789686576879(...args));
    };
    collect({
        context: args.context,
        event: args.event,
        enqueue: enqueue,
        check: (guard)=>(0, $d0N4G.e)(guard, snapshot.context, args.event, snapshot),
        self: actorScope.self,
        system: actorScope.system
    }, actionParams);
    return [
        snapshot,
        undefined,
        actions
    ];
}
/**
 * Creates an action object that will execute actions that are queued by the
 * `enqueue(action)` function.
 *
 * @example
 *
 * ```ts
 * import { createMachine, enqueueActions } from 'xstate';
 *
 * const machine = createMachine({
 *   entry: enqueueActions(({ enqueue, check }) => {
 *     enqueue.assign({ count: 0 });
 *
 *     if (check('someGuard')) {
 *       enqueue.assign({ count: 1 });
 *     }
 *
 *     enqueue('someAction');
 *   })
 * });
 * ```
 */ function $958039aea9590b3b$export$8b22cf2602fb60ce(collect) {
    function enqueueActions(_args, _params) {}
    enqueueActions.type = 'xstate.enqueueActions';
    enqueueActions.collect = collect;
    enqueueActions.resolve = $958039aea9590b3b$var$resolveEnqueueActions;
    return enqueueActions;
}
function $958039aea9590b3b$var$resolveLog(_, snapshot, actionArgs, actionParams, { value: value, label: label }) {
    return [
        snapshot,
        {
            value: typeof value === 'function' ? value(actionArgs, actionParams) : value,
            label: label
        },
        undefined
    ];
}
function $958039aea9590b3b$var$executeLog({ logger: logger }, { value: value, label: label }) {
    if (label) logger(label, value);
    else logger(value);
}
/**
 * @param expr The expression function to evaluate which will be logged. Takes
 *   in 2 arguments:
 *
 *   - `ctx` - the current state context
 *   - `event` - the event that caused this action to be executed.
 *
 * @param label The label to give to the logged expression.
 */ function $958039aea9590b3b$export$882b5998b3b9117c(value = ({ context: context, event: event })=>({
        context: context,
        event: event
    }), label) {
    function log1(_args, _params) {}
    log1.type = 'xstate.log';
    log1.value = value;
    log1.label = label;
    log1.resolve = $958039aea9590b3b$var$resolveLog;
    log1.execute = $958039aea9590b3b$var$executeLog;
    return log1;
}
module.exports["a"] = $958039aea9590b3b$export$407448d2b89b1813;
module.exports["b"] = $958039aea9590b3b$export$8b22cf2602fb60ce;

});

parcelRegister("9uNdP", function(module, exports) {
const $e1ab3e5e291b0506$export$198c236a78ec089b = {
    actor_type: 'AGENT',
    available_plugins: {
        'Content-Read-Plugin': {},
        'Ethical-Filtering-Plugin': {},
        'Jira-JQL-Plugin': {},
        'Jira-NL-JQL-Plugin': {},
        'Jira-Software-Plugin': {},
        'Page-Search-Plugin': {},
        'People-Plugin': {},
        'Search-QA-Plugin': {}
    },
    creator: 'mock',
    creator_cloud_id: null,
    creator_type: 'SYSTEM',
    description: 'Mocking: Get answers, generate new ideas, and accelerate everyday work. Write a prompt to get started.',
    external_files: null,
    follow_up_prompt_template: '\nYour task is to generate follow-up questions for the given conversation from the user\'s perspective.\nThe conversation history is provided in triple backticks.\n\nConversation History:\n```\n{message_history}\n```\n\nWhen you generate follow-up questions, follow these steps closely:\n1. Read the conversation history carefully to understand the user\'s intent. Keep it open and refer back to it as necessary.\n2. Pretend that you are the user and think about what you would ask next based on the conversation history and the original intent.\n3. Generate 3 follow-up questions from the perspective of the user that meet the following criteria.\n    - Relevant to the conversation.\n    - Unique and different from previously asked questions.\n    - Requests new information.\n    - Insightful and enhances the engagement of the conversation.\n    - Succinct and straight to the point.\n    - Specific and avoids being too general.\n    - Less than 9 words.\n    - When the subject of the question is the user asking questions, use the first-person pronoun "I".\n4. Read your follow-up questions again and remove the ones that do not meet ALL of the listed criteria.\n5. If there are no follow-up questions left, return an empty list.\n6. If there are follow-up questions left, paraphrase them to make them more concise.\n7. Return your paraphrased follow-up questions.\n',
    id: 'f3a534d9-1498-e0d4-8b50-e058a8fb8156',
    is_default: true,
    // model: null,
    name: 'Mock Chat',
    named_id: 'ai_mate_agent',
    plugin_routing_type: 'DEFAULT',
    // preferred_plugin: null,
    system_prompt_template: '\nYou are Rovo Chat, an AI assistant built by Atlassian, you can do everything in the list of functions available. \nTreat the human in a friendly and personalised way, if what they ask is completely nonsensical, ask for clarification.  \n\nFollowing are the details of the human user:\n\nName: {{ user_name }}\n{{ location_info }}\n\nCurrent Time: {{ current_time }}\n\n{{ browsing_context }}\n\nFollow these rules:\n- Respond with names in the following format [name](/people/id) when appropriate.\n- Always use a function to find information, even if you know the answer.\n- Prioritise the Search-QA-Plugin when the function to use is not obvious.\n- Never answer the user directly without results from a function, unless they asked to reformat an existing answer.\n- Do not use your pretrained knowledge to answer.\n- Do not return function details in your answer.\n- If the answer is not available from the current function, always call another function.\n',
    visibility: 'PUBLIC',
    user_defined_conversation_starters: [],
    favourite: false,
    deactivated: false
};
const $e1ab3e5e291b0506$export$2036d10b5adbaa07 = {
    actor_type: 'AGENT',
    available_plugins: {
        'Confluence-Suggestion-Plugin': {
            is_terminal: true,
            raise_no_answer_exception: true
        },
        'Page-Search-Plugin': {}
    },
    creator: null,
    creator_cloud_id: null,
    creator_type: 'SYSTEM',
    description: "Craft and refine all things blogs, external comms, and announcements. Align with your brand's voice.",
    external_files: null,
    follow_up_prompt_template: null,
    id: '3506f1fa-13ab-0c9c-d645-f26c759ef903',
    is_default: false,
    // model: null,
    name: 'Comms crafter',
    named_id: 'confluence_reviewer_agent',
    plugin_routing_type: 'DEFAULT',
    // preferred_plugin: null,
    system_prompt_template: 'You are the Comms crafter, a helpful assistant for reviewing Confluence documents. You are tasked with providing suggestions to improve a Confluence document.\n\nA user may highlight an important part of the document for you to focus on using a document selection.\n\nFollow these rules:\n- Always use a function to provide a suggested replacement for the current document selection when there is a suggested replacement.\n- If the user asks for similar documents, you rely on the document selection.\n- If there is a suggested replacement to a document selection, the final answer should be only a 1 sentence summary of the changes suggested, not the update itself.\n- Do not return function details in your answer.\n- Respond with names in the following format [name](/people/id) if at all possible.\n- Do not use your pretrained knowledge to answer.\n\nFollowing are the details of the users session:\n\nName: {{ user_name }}\nLocation: {{ location_info }}\nCurrent Time: {{ current_time }}\nDocument Selection: {{ additional_context.confluence.selection }}\nDocument: {{ additional_context.confluence.document }}\n',
    visibility: 'PRIVATE',
    user_defined_conversation_starters: [
        "Can you help me with this blog post I'm working on?",
        "Help me with this announcement I'm drafting."
    ],
    favourite: false,
    deactivated: false
};
const $e1ab3e5e291b0506$export$c6b96d4ac6b48aa6 = {
    actor_type: 'AGENT',
    available_plugins: {
        'Confluence-Suggestion-Plugin': {},
        'Content-Read-Plugin': {},
        'Page-Search-Plugin': {}
    },
    creator: null,
    creator_cloud_id: null,
    creator_type: 'SYSTEM',
    description: 'Crafts job descriptions that align with corporate guidelines and ensures they promote inclusivity and diversity.',
    external_files: null,
    follow_up_prompt_template: null,
    id: '5692d6dd-3045-499f-b08b-77ed2d253941',
    is_default: false,
    // model: 'gpt-3-5-turbo-atlassian-0125',
    name: 'Job writer',
    named_id: 'job_writer_agent',
    plugin_routing_type: 'DEFAULT',
    // preferred_plugin: null,
    system_prompt_template: 'You are the Job writer agent, a helpful assistant for hiring managers and recruitment teams to standardize on job descriptions which follow diversity and inclusion guidelines. \nYou are tasked with providing suggestions to improve a Confluence document for job descriptions.\n\nA user may highlight an important part of the document for you to focus on using a document selection.\n\nFollow these rules:\n- You must always provide a suggested replacement for insertion when asked to create, insert or draft job descriptions, summaries or any unique content.\n- You must always use a function to provide a suggested replacement for the current document selection when there is a suggested replacement.\n- If the user asks for similar documents, you rely on the document selection.\n- If there is a suggested replacement to a document selection, the final answer should be only a 1 sentence summary of the changes suggested, not the update itself.\n- Do not return function details in your answer.\n- Respond with names in the following format [name](/people/id) if at all possible.\n- Do not use your pretrained knowledge to answer.\n\nFollowing are the details of the users session:\n\nName: {{ user_name }}\nLocation: {{ location_info }}\nCurrent Time: {{ current_time }}\nDocument Selection: {{ additional_context.confluence.selection }}\nDocument: {{ additional_context.confluence.document }}\nBrowsing Context: {{ browsing_context }}',
    visibility: 'PRIVATE',
    user_defined_conversation_starters: [],
    favourite: false,
    deactivated: false
};
const $e1ab3e5e291b0506$export$3b92ff78ca28a6e3 = {
    actor_type: 'AGENT',
    available_plugins: {
        'Search-QA-Plugin': {
            space_filter: [
                'A11YKB'
            ]
        }
    },
    creator: 'ari:cloud:identity::user/557057:db25fe7e-23f8-4e0f-aa1d-74a8c29bbc10',
    creator_cloud_id: 'a436116f-02ce-4520-8fbb-7301462a1674',
    creator_type: 'CUSTOMER',
    description: 'Accessibility help by Central Accessibility Team',
    external_files: [],
    follow_up_prompt_template: null,
    id: 'a7f547de-aa39-4d25-9234-65ac13c19acd',
    is_default: false,
    // model: null,
    name: 'A11Y Mate Long Name for Selection Toolbar',
    named_id: 'A11Y Mate',
    plugin_routing_type: null,
    // preferred_plugin: null,
    system_prompt_template: '',
    visibility: 'PUBLIC',
    user_defined_conversation_starters: [
        'What can you help me with?',
        'What can you help me with?',
        'What can you help me with?'
    ],
    favourite: false,
    deactivated: false
};
module.exports["ChatAgent"] = $e1ab3e5e291b0506$export$198c236a78ec089b;
module.exports["CommsCrafterAgent"] = $e1ab3e5e291b0506$export$2036d10b5adbaa07;
module.exports["JobWriterAgent"] = $e1ab3e5e291b0506$export$c6b96d4ac6b48aa6;
module.exports["A11yMateAgent"] = $e1ab3e5e291b0506$export$3b92ff78ca28a6e3;

});

parcelRegister("hX9je", function(module, exports) {

var $bwpRs = parcelRequire("bwpRs");

const $8e55a3d6bd1cab06$export$fc21f0ec31fe4ec0 = ({ configItem: configItem, lastTriggeredFrom: lastTriggeredFrom })=>{
    if (!configItem || !lastTriggeredFrom) return false;
    return configItem.key === (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE && lastTriggeredFrom === 'confluenceTitleToolbar';
};
const $8e55a3d6bd1cab06$export$bde142b94ad13256 = (configItem)=>{
    return configItem.key === (0, $bwpRs.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE;
};
module.exports["isConfluenceTitleToolbarSuggestTitle"] = $8e55a3d6bd1cab06$export$fc21f0ec31fe4ec0;
module.exports["isSuggestTitleForConfluence"] = $8e55a3d6bd1cab06$export$bde142b94ad13256;

});

parcelRegister("jdR93", function(module, exports) {
const $fee511088fd88ff9$export$74e7028cbce2b0e1 = ({ schema: { nodes: nodes } })=>new Set([
        nodes.table
    ]);
const $fee511088fd88ff9$export$73f561bc8b894934 = (state, selection)=>{
    const { tableHeader: tableHeader, tableCell: tableCell, tabeRow: tabeRow, table: table } = state.schema.nodes;
    const { $from: $from } = selection || state.selection;
    const parent = $from.parent;
    return [
        tableHeader,
        tableCell,
        tabeRow,
        table
    ].includes(parent.type);
};
module.exports["getSupportedNodesForAIModal"] = $fee511088fd88ff9$export$74e7028cbce2b0e1;
module.exports["isCellSelection"] = $fee511088fd88ff9$export$73f561bc8b894934;

});

parcelRegister("6gJll", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $k7eoe = parcelRequire("k7eoe");


var $d925B = parcelRequire("d925B");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $ilIeg = parcelRequire("ilIeg");


var $bwpRs = parcelRequire("bwpRs");


var $4SGh1 = parcelRequire("4SGh1");

function $fb87067b4e981564$export$42373263ca9a5144(experienceName, invokedFrom) {
    // The Proactive Description Completer are using the shared config item key with issue reformatter
    // Need to get the correct experience name from invokedFrom
    // This is temp solution to distinguish two experience
    // We are planning to add a new config item key for Proactive Description Completer
    if (invokedFrom === 'jiraProactiveDescriptionCompleterFooterButton' && experienceName === (0, $bwpRs.CONFIG_ITEM_KEYS).ADD_STRUCTURE) return 'proactiveDescriptionCompleter';
    if (experienceName === (0, $bwpRs.CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER) {
        /**
		 * We only check for experiment value here as the config item would not exist
		 * if the experiment is not enabled / is misconfigured.
		 */ const getExperimentValue = (0, $c6GJD.default).getExperimentValue;
        const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
        return analyticsExperienceName || experienceName;
    }
    return experienceName;
}
function $fb87067b4e981564$export$7e715b9b9acf423a({ fireAIAnalyticsEvent: fireAIAnalyticsEvent, invokeAttributes: invokeAttributes, canInlineStreamChanges: canInlineStreamChanges, onCommonAttributesUpdated: onCommonAttributesUpdated, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled }) {
    const startTime = performance.now();
    const stepTracker = {};
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const aiSessionId = invokeAttributes.aiSessionId ?? (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
    const aiGroupId = invokeAttributes.aiGroupId ?? aiSessionId;
    let prevStepEnd = performance.now();
    let prevStepName;
    let experienceName;
    let adhocAttributes = {};
    let commonAttributes = {};
    let dynamicAttributes = {};
    let aiLifeCycleDynamicAttributesGetter;
    let finished = false;
    let contentCopiedSometime = false;
    const sawAupViolation = false;
    let interactionsCounter = 0;
    let lastAiInteractionID;
    let queuedStepArgs = {
        stepName: 'invoke',
        attributes: invokeAttributes
    };
    /**
	 * A util function to get dynamic attributes for the AI lifecyle
	 * The previously registered getter is invoked when the lifecyle begins
	 * The resolved attributes are then used until the lifecycle ends
	 */ const getAiLifeCycleDynamicAttributes = ({ init: init })=>{
        if (init && aiLifeCycleDynamicAttributesGetter) dynamicAttributes = aiLifeCycleDynamicAttributesGetter();
        return dynamicAttributes;
    };
    const getAgentAttributes = ()=>{
        return {
            agentName: commonAttributes.agentName,
            agentId: commonAttributes.agentId,
            agentCreatorType: commonAttributes.agentCreatorType,
            agentExternalConfigReference: commonAttributes.agentExternalConfigReference,
            agentIsDefault: commonAttributes.agentIsDefault
        };
    };
    const analyticsFlow = {
        aiSessionId: aiSessionId,
        aiGroupId: aiGroupId,
        /**
		 * Add a step to the queue to be fired on next screen.
		 * @example
		 * ```tsx
		 * const analyticsFlow = useAnalyticsFlow();
		 * analyticsFlow.enqueueStep({ stepName, attributes });
		 * ```
		 */ enqueueStep: (stepArgs)=>{
            // If the user has already finished the experience, we fire an operational error and return
            if (finished) {
                fireAIAnalyticsEvent($fb87067b4e981564$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            if (stepArgs.stepName === 'loading') {
                lastAiInteractionID = `${aiSessionId}-${++interactionsCounter}`;
                if ((!isInDocumentStreamingEnabled || invokeAttributes.invokedFrom !== 'streamingApi') && invokeAttributes.invokedFrom !== 'confluenceTitleGenOnPaste') fireAIAnalyticsEvent({
                    payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                        action: (0, $d925B.ACTION).INITIATED,
                        interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                        experienceName: $fb87067b4e981564$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                        isProactive: false,
                        invokedFrom: invokeAttributes.invokedFrom,
                        nudgeMetrics: commonAttributes.nudgeMetrics,
                        attributes: {
                            ...getAiLifeCycleDynamicAttributes({
                                init: true
                            }),
                            ...getAgentAttributes()
                        }
                    })
                });
            }
            if (stepArgs.stepName === 'complete') {
                const attributes = stepArgs?.attributes ?? {};
                const actionTaken = 'actionTaken' in attributes ? attributes.actionTaken : undefined;
                const promptType = 'promptType' in attributes ? attributes.promptType : undefined;
                const refinementCount = 'refinementCount' in attributes ? attributes.refinementCount : undefined;
                fireAIAnalyticsEvent({
                    payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                        action: (0, $d925B.ACTION).ACTIONED,
                        interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                        experienceName: $fb87067b4e981564$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                        isProactive: false,
                        invokedFrom: invokeAttributes.invokedFrom,
                        nudgeMetrics: commonAttributes.nudgeMetrics,
                        attributes: {
                            ...getAiLifeCycleDynamicAttributes({
                                init: false
                            }),
                            ...getAgentAttributes(),
                            promptType: promptType,
                            refinementCount: refinementCount,
                            aiResultAction: actionTaken?.toLowerCase()
                        },
                        traceIds: commonAttributes.traceIds
                    })
                });
            }
            // If there is already a queued step, we fire an operational error and return
            if (queuedStepArgs !== undefined) {
                fireAIAnalyticsEvent($fb87067b4e981564$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'cannotEnqueueMoreThanOneEvent',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            queuedStepArgs = stepArgs;
        },
        fireQueuedStep: (target)=>{
            // If the user has already finished the experience, we fire an operational error and return
            if (finished) {
                fireAIAnalyticsEvent($fb87067b4e981564$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        target: target,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            // If there is no queued step, we fire an operational error and return
            if (!queuedStepArgs) {
                fireAIAnalyticsEvent($fb87067b4e981564$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'noEventExistsToBeFired',
                    errorProperties: {
                        target: target
                    }
                }));
                return;
            }
            queuedStepArgs.attributes = {
                ...queuedStepArgs.attributes,
                ...adhocAttributes,
                ...commonAttributes,
                invokedFrom: invokeAttributes.invokedFrom,
                nudgeMetrics: commonAttributes.nudgeMetrics,
                invokedFor: invokeAttributes.invokedFor,
                triggerMethod: invokeAttributes.triggerMethod,
                target: target,
                // Remove below flag when AIFC is fully rolled out in Jira, only required for old experience in Jira.
                ...(0, $dh538.fg)('platform_editor_ai_streaming_ended_analytics_attr') ? {
                    isStreamingEnded: !!commonAttributes.isStreamingEnded
                } : undefined
            };
            if (target === 'failed' || target === 'apiError') fireAIAnalyticsEvent({
                payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                    action: (0, $d925B.ACTION).ERROR,
                    interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                    experienceName: $fb87067b4e981564$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                    isProactive: false,
                    invokedFrom: invokeAttributes.invokedFrom,
                    nudgeMetrics: commonAttributes.nudgeMetrics,
                    attributes: {
                        ...getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        ...getAgentAttributes(),
                        aiErrorMessage: (0, $4SGh1.isErrorStepAttributes)(queuedStepArgs?.attributes) ? queuedStepArgs?.attributes?.errorKey ?? queuedStepArgs?.attributes?.errorType : 'Unknown error',
                        aiErrorCode: (0, $4SGh1.isErrorStepAttributes)(queuedStepArgs.attributes) ? queuedStepArgs.attributes?.statusCode ?? 500 : 500
                    },
                    traceIds: commonAttributes.traceIds
                })
            });
            // By default, if the preview is shown then we can assume that the user will be given and accept/reject option
            // However, if canInlineStreamChanges() => true, then the preview will not be shown and the changes will be applied automatically
            // If the canInlineStreamChanges() => false, then the changes will not be applied automatically, and the user will have to accept/reject the changes.
            if (target === 'preview' && !canInlineStreamChanges()) fireAIAnalyticsEvent({
                payload: (0, $ilIeg.createUnifiedAnalyticsPayload)({
                    action: (0, $d925B.ACTION).VIEWED,
                    interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                    experienceName: $fb87067b4e981564$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                    isProactive: false,
                    invokedFrom: invokeAttributes.invokedFrom,
                    nudgeMetrics: commonAttributes.nudgeMetrics,
                    attributes: {
                        ...getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        ...getAgentAttributes()
                    },
                    traceIds: commonAttributes.traceIds
                })
            });
            // Add target to attributes and fire the event
            fireUserFlowStep(queuedStepArgs);
            // Remove the queued event
            queuedStepArgs = undefined;
        },
        /**
		 * This is useful when you want to add attributes to the current step
		 * but you don't know them at the time of enqueuing the step.
		 *
		 * It's safe to fire this on dismount -- because the step is enqueued in the dismount
		 * of a parent component (where AnalyticsFlowContextProvider is setup).
		 *
		 * @example
		 * ```tsx
		 * const analyticsFlow = useAnalyticsFlow();
		 * React.useEffect(() => {
		 *  return () => {
		 *    // add attribute on dismount
		 *    analyticsFlow.addAttributes({ loadingTime })
		 *  }
		 * })
		 * ```
		 */ addAttributes: (attributes)=>{
            // The user copying the content is being treated as a potential success indicator
            // This is a weak signal as we don't know if the user actually used the copied content
            // and might expect the user to copy the content in cases where the generation failed.
            if ('contentCopied' in attributes && attributes.contentCopied) contentCopiedSometime = true;
            adhocAttributes = {
                ...adhocAttributes,
                ...attributes
            };
        },
        getAiLifeCycleDynamicAttributes: getAiLifeCycleDynamicAttributes,
        /**
		 * Editor-AI can be invoked in various contexts.
		 * In some of those scenarios, we want to register additional attributes to understand how the respective feature is performing.
		 *
		 * For example, when the Issue Reformatter is used, we want to understand analytics such as
		 *  - The issue-type of the issue where the issue reformatter was invoked
		 *  - Whether the feature was used from Issue-View or GIC
		 *  - Product type such as JWM and JSW
		 *
		 * This method registers a attribute getter function.
		 * The function will be invoked when the feature is first run (i.e. along with `aiInteraction Initiated`)
		 * The resolved values will then be unchanged until the AI lifecyle is completed
		 * i.e. The same values will be used for all events such as `aiResult Viewed` and `aiResult dismissed`
		 *
		 * In the current version, this method accepts one getter function, and assumes that there aren't multiple functions.
		 * In future, this can be tweaked to allow multiple getters.
		 * Such improvements need to be done carefully so that the getters are also unregistered accordingly
		 */ registerAiLifeCycleDynamicAttributesGetter: (getter)=>{
            aiLifeCycleDynamicAttributesGetter = getter;
        },
        /**
		 * Common attributes will be retained for the rest of the analytics flow
		 * until it is updated again
		 *
		 * Example uses: keeping track of which backendModel has been selected
		 */ updateCommonAttributes: (attributes)=>{
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                const updatedCommonAttributes = {
                    ...commonAttributes,
                    ...attributes
                };
                commonAttributes = updatedCommonAttributes;
                onCommonAttributesUpdated?.(updatedCommonAttributes);
            } else commonAttributes = {
                ...commonAttributes,
                ...attributes
            };
        },
        getLastAiInteractionId: ()=>lastAiInteractionID,
        getUnifiedEventData: ()=>{
            return {
                interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                experienceName: $fb87067b4e981564$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                invokedFrom: invokeAttributes.invokedFrom,
                traceIds: commonAttributes.traceIds,
                attributes: {
                    ...getAiLifeCycleDynamicAttributes({
                        init: false
                    }),
                    ...getAgentAttributes()
                }
            };
        },
        getUserFlowCommonAttributes: (configItem)=>{
            return {
                agentName: configItem.agent?.creatorType === 'SYSTEM' ? configItem.agent?.name : undefined,
                agentId: configItem.agent?.id,
                agentCreatorType: configItem.agent?.creatorType,
                agentExternalConfigReference: configItem.agent?.externalConfigReference,
                agentIsDefault: configItem.agent?.isDefault,
                // Doing double negation to convert undefined to false
                adfPrompt: !!configItem.adfPrompt
            };
        },
        getCommonAttributes: ()=>commonAttributes
    };
    return analyticsFlow;
    function fireUserFlowStep({ stepName: stepName, attributes: attributes = {} }) {
        if (!stepTracker[stepName]) stepTracker[stepName] = 1;
        else stepTracker[stepName] = stepTracker[stepName] + 1;
        if (attributes.experienceName) experienceName = $fb87067b4e981564$export$42373263ca9a5144(attributes.experienceName, invokeAttributes.invokedFrom);
        const stepAttributes = {
            ...commonAttributes,
            // the duration is currently being overriden in the complete step
            duration: Math.round(performance.now() - prevStepEnd),
            ...attributes,
            aiSessionId: aiSessionId,
            aiGroupId: aiGroupId,
            experienceName: experienceName,
            featureId: attributes.featureId || invokeAttributes.featureId,
            source: prevStepName,
            invokedFrom: attributes.invokedFrom,
            nudgeMetrics: attributes.nudgeMetrics,
            triggerMethod: attributes.triggerMethod,
            isInvokedFromEmptyPage: attributes.isInvokedFromEmptyPage,
            stepOccurrence: String(stepTracker[stepName]),
            sawAupViolation: sawAupViolation,
            includeKnowledgeFromCurrentPage: attributes.includeKnowledgeFromCurrentPage
        };
        // add totalDuration only to the final step
        // and set the experience as finished
        if (!attributes.target) {
            stepAttributes.totalDuration = Math.round(performance.now() - startTime);
            stepAttributes.contentCopiedSometime = contentCopiedSometime;
            finished = true;
        }
        // adding interaction ID to the events coming after the loading step, + final complete step
        if (stepAttributes.source === 'loading' || stepName === 'complete') stepAttributes.aiInteractionID = lastAiInteractionID;
        const payload = {
            action: stepName,
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'userFlow',
            attributes: stepAttributes,
            eventType: (0, $d925B.EVENT_TYPE).UI
        };
        //each step is a starting point for measuring duration for next step
        prevStepEnd = performance.now();
        //reset previous step name and custom attributes
        prevStepName = stepName;
        const modelIO = 'modelIO' in adhocAttributes ? adhocAttributes.modelIO : undefined;
        adhocAttributes = {};
        fireAIAnalyticsEvent({
            payload: payload
        });
        if (finished) fireAIAnalyticsEvent({
            payload: {
                ...payload,
                action: 'finished',
                attributes: {
                    ...payload.attributes,
                    // override source to be the previous last step in the flow
                    source: stepName,
                    modelIO: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? modelIO : undefined
                }
            }
        });
    }
}
/**
 * Creates an operational error payload
 */ function $fb87067b4e981564$var$createErrorPayload({ errorSubType: errorSubType, errorProperties: errorProperties }) {
    return {
        payload: {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'experienceApplication',
            attributes: {
                errorType: 'userFlowAnalyticsError',
                errorSubType: errorSubType,
                ...errorProperties
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        },
        channel: (0, $k7eoe.FabricChannel).editor
    };
}
module.exports["convertExperienceName"] = $fb87067b4e981564$export$42373263ca9a5144;
module.exports["createAnalyticsFlow"] = $fb87067b4e981564$export$7e715b9b9acf423a;

});

parcelRegister("4SGh1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jy7VG = parcelRequire("jy7VG");


var $k7eoe = parcelRequire("k7eoe");


var $inPa6 = parcelRequire("inPa6");


var $d925B = parcelRequire("d925B");

var $e2wMq = parcelRequire("e2wMq");


var $4NrmI = parcelRequire("4NrmI");

function $e72784a8bb3f6c6b$export$e65dc2451c080d01(payload) {
    const packageInfo = (0, $4NrmI.getPackageInfo)();
    const attributes = payload.attributes || {};
    return {
        ...payload,
        attributes: {
            ...attributes,
            aiPluginPackageName: packageInfo.packageName,
            aiPluginPackageVersion: packageInfo.packageVersion
        }
    };
}
// This utils is referenced from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
// Note: this adds extra step to a transaction which effectively marks it as docChanged and can cause editor onchange to fire on dispatch
function $e72784a8bb3f6c6b$var$attachPayloadIntoTransaction({ editorState: editorState, payload: payload, channel: channel = (0, $k7eoe.FabricChannel).editor }) {
    return (tr)=>{
        const { storedMarks: storedMarks } = tr;
        const pos = tr.mapping.map(editorState.selection.$from.pos, -1);
        tr.step(new (0, $jy7VG.AnalyticsStep)([
            {
                payload: $e72784a8bb3f6c6b$export$e65dc2451c080d01(payload),
                channel: channel
            }
        ], [], // We don't understand now why we need position in AnalyticsStep.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // We need to create the step based on a position, this prevent split history for relative changes.
        pos));
        // We don't understand now why we need to store marks again in transaction.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // When you add a new step all the storedMarks are removed it
        if (storedMarks) tr.setStoredMarks(storedMarks);
        return true;
    };
}
function $e72784a8bb3f6c6b$export$5bef18c22bfe95d({ editorState: editorState, tr: tr, payload: payload, channel: channel = (0, $k7eoe.FabricChannel).editor, addToHistory: addToHistory = true }) {
    $e72784a8bb3f6c6b$var$attachPayloadIntoTransaction({
        editorState: editorState,
        payload: payload,
        channel: channel
    })(tr);
    if (!addToHistory) tr.setMeta('addToHistory', false);
    return tr;
}
function $e72784a8bb3f6c6b$export$af9baadf0e4f6e13({ payload: payload, channel: channel = (0, $k7eoe.FabricChannel).editor }) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state);
                        if (dynamicPayload) dispatch($e72784a8bb3f6c6b$export$5bef18c22bfe95d({
                            editorState: state,
                            tr: tr,
                            payload: dynamicPayload,
                            channel: channel
                        }));
                    } else dispatch($e72784a8bb3f6c6b$export$5bef18c22bfe95d({
                        editorState: state,
                        tr: tr,
                        payload: payload,
                        channel: channel
                    }));
                }
            }, view);
}
function $e72784a8bb3f6c6b$export$12ef4e1e68d53406(createAnalyticsEvent) {
    return ({ payload: payload, channel: channel = (0, $k7eoe.FabricChannel).editor })=>{
        if (!createAnalyticsEvent) return;
        const fireEvent = ()=>createAnalyticsEvent($e72784a8bb3f6c6b$export$e65dc2451c080d01(payload))?.fire(channel);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fireEvent);
        else if (window.requestAnimationFrame) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestAnimationFrame(fireEvent);
        else setTimeout(fireEvent, 0);
    };
}
function $e72784a8bb3f6c6b$export$5098b64908ee530() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAIAnalyticsEvent = (0, $42omo.useCallback)((args)=>$e72784a8bb3f6c6b$export$12ef4e1e68d53406(createAnalyticsEvent)(args), [
        createAnalyticsEvent
    ]);
    return fireAIAnalyticsEvent;
}
function $e72784a8bb3f6c6b$export$511854ca6705eca5(channelId, lastAiInteractionID) {
    return channelId ?? lastAiInteractionID ?? '';
}
function $e72784a8bb3f6c6b$export$1256d4293be5e625(step) {
    if (!step) return false;
    return 'errorKey' in step || 'errorType' in step || 'statusCode' in step;
}
const $e72784a8bb3f6c6b$export$2cdad03d12648c8e = ({ api: api, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).VIEWED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: actionSubjectId,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
            mode: (0, $e2wMq.MODE).EDITOR,
            selectionCharCount: attributes.selectionCharCount,
            selectionWordCount: attributes.selectionWordCount
        }
    });
};
function $e72784a8bb3f6c6b$var$countSegments(input, granularity) {
    const seg = new Intl.Segmenter('und', {
        granularity: granularity
    });
    let n = 0;
    for (const _ of seg.segment(input))n++;
    return n;
}
function $e72784a8bb3f6c6b$var$countWordLike(input) {
    const seg = new Intl.Segmenter('und', {
        granularity: 'word'
    });
    let n = 0;
    for (const part of seg.segment(input))if (part.isWordLike) n++;
    return n;
}
const $e72784a8bb3f6c6b$var$computeCharWordCounts = (raw)=>{
    // drop all whitespace for char count
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    const noWhitespace = raw.replace(/\s+/gu, '');
    // normalize whitespace for word count
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    const normalized = raw.replace(/\s+/gu, ' ').trim();
    const hasSegmenter = typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function';
    const charCount = hasSegmenter ? $e72784a8bb3f6c6b$var$countSegments(noWhitespace, 'grapheme') : Array.from(noWhitespace).length;
    const wordCount = normalized === '' ? 0 : hasSegmenter ? $e72784a8bb3f6c6b$var$countWordLike(normalized) : // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    normalized.split(/\s+/u).length;
    return {
        charCount: charCount,
        wordCount: wordCount
    };
};
const $e72784a8bb3f6c6b$export$980a72be63484695 = (doc, from, to)=>{
    if (from === to) return {
        charCount: 0,
        wordCount: 0
    };
    // keep line breaks as newlines and leaf nodes as spaces
    const raw = doc.textBetween(from, to, '\n', ' ');
    return $e72784a8bb3f6c6b$var$computeCharWordCounts(raw);
};
const $e72784a8bb3f6c6b$export$a78a3dabcec86737 = (state)=>{
    const { from: from, to: to } = state.selection;
    if (state.selection.empty) return {
        charCount: 0,
        wordCount: 0
    };
    const raw = state.doc.textBetween(from, to, '\n', ' ');
    return $e72784a8bb3f6c6b$var$computeCharWordCounts(raw);
};
module.exports["addAnalytics"] = $e72784a8bb3f6c6b$export$5bef18c22bfe95d;
module.exports["useFireAIAnalyticsEvent"] = $e72784a8bb3f6c6b$export$5098b64908ee530;
module.exports["isErrorStepAttributes"] = $e72784a8bb3f6c6b$export$1256d4293be5e625;
module.exports["fireButtonViewedAnalyticsEvent"] = $e72784a8bb3f6c6b$export$2cdad03d12648c8e;
module.exports["rangeCharWordCount"] = $e72784a8bb3f6c6b$export$980a72be63484695;
module.exports["selectionCharWordCount"] = $e72784a8bb3f6c6b$export$a78a3dabcec86737;

});

parcelRegister("kTCUV", function(module, exports) {

var $9OCYt = parcelRequire("9OCYt");


var $3tFte = parcelRequire("3tFte");

const $70171f62d41c1615$export$625aacfa684c775d = ({ from: from, to: to })=>(tr)=>{
        return tr.setMeta((0, $3tFte.aiAnnotationWatchmenPluginKey), {
            action: (0, $9OCYt.ACTIONS).START_WATCHING_REGION,
            from: from,
            to: to
        });
    };
const $70171f62d41c1615$export$3047f3abb1985cb0 = (tr)=>{
    return tr.setMeta((0, $3tFte.aiAnnotationWatchmenPluginKey), {
        action: (0, $9OCYt.ACTIONS).END_WATCHING_REGION
    });
};
module.exports["startWatchingAnnotationChanges"] = $70171f62d41c1615$export$625aacfa684c775d;
module.exports["endWatchingAnnotationChanges"] = $70171f62d41c1615$export$3047f3abb1985cb0;

});

parcelRegister("5oqzu", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $521b6ed6d8b42015$export$f6970e69e9507693 = new (0, $ks2lK.PluginKey)('aiSessionContext');
module.exports["aiSessionContextPluginKey"] = $521b6ed6d8b42015$export$f6970e69e9507693;

});

parcelRegister("eyHC2", function(module, exports) {

var $9F9dO = parcelRequire("9F9dO");


var $5vNOi = parcelRequire("5vNOi");

const $ad57ab56f54de990$export$a7cd1c3a87df6616 = ({ start: start, end: end, showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, telepointerPos: telepointerPos })=>(tr)=>{
        return tr.setMeta((0, $5vNOi.inEditorDirectStreamingPluginKey), {
            action: (0, $9F9dO.ACTIONS).INIT_POSITIONS,
            positions: {
                startPos: start,
                userContentEndPos: end,
                telepointerPos: telepointerPos
            },
            showHighlight: showHighlight,
            showAIContentHighlight: showAIContentHighlight,
            showTelepointer: showTelepointer
        });
    };
const $ad57ab56f54de990$export$ce0702981dd140ff = ({ start: start, end: end })=>(tr)=>{
        return tr.setMeta((0, $5vNOi.inEditorDirectStreamingPluginKey), {
            action: (0, $9F9dO.ACTIONS).ADJUST_INIT_POSITIONS,
            positions: {
                startPos: start,
                userContentEndPos: end
            }
        });
    };
const $ad57ab56f54de990$export$54977414c1e0bf76 = ({ aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, isFinalStream: isFinalStream })=>(tr)=>{
        return tr.setMeta((0, $5vNOi.inEditorDirectStreamingPluginKey), {
            action: (0, $9F9dO.ACTIONS).UPDATE_STREAM_POSITIONS,
            positions: {
                aiContentEndPos: aiContentEndPos,
                telepointerPos: telepointerPos
            },
            isFinalStream: isFinalStream
        });
    };
const $ad57ab56f54de990$export$2786c982b834f104 = (tr)=>{
    return tr.setMeta((0, $5vNOi.inEditorDirectStreamingPluginKey), {
        action: (0, $9F9dO.ACTIONS).UPDATE_LOADING_POSITIONS
    });
};
const $ad57ab56f54de990$export$7dbd7b4332a8fca6 = (tr)=>{
    return tr.setMeta((0, $5vNOi.inEditorDirectStreamingPluginKey), {
        action: (0, $9F9dO.ACTIONS).END_STREAM
    });
};
const $ad57ab56f54de990$export$a07eda0a8c017081 = ({ tr: tr, isFinalStream: isFinalStream, stackTime: stackTime })=>{
    tr = tr.setMeta('isAIStreamingTransformation', true).setMeta('isAIFinalStreamingTransformation', !!isFinalStream).setMeta('scrollIntoView', false);
    if (stackTime) tr.setTime(stackTime);
    return tr;
};
module.exports["initPositions"] = $ad57ab56f54de990$export$a7cd1c3a87df6616;
module.exports["adjustInitPositions"] = $ad57ab56f54de990$export$ce0702981dd140ff;
module.exports["updateStreamPositions"] = $ad57ab56f54de990$export$54977414c1e0bf76;
module.exports["updateLoadingPositions"] = $ad57ab56f54de990$export$2786c982b834f104;
module.exports["endStream"] = $ad57ab56f54de990$export$7dbd7b4332a8fca6;
module.exports["metaTransaction"] = $ad57ab56f54de990$export$a07eda0a8c017081;

});

parcelRegister("cVxBN", function(module, exports) {
function $b1ee088083c187bc$export$fc8b8d4530cea304({ $from: $from, $to: $to, schema: schema }) {
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    let startMaybeCellNode;
    for(let depth = $from.depth; depth > 0; depth--)if ([
        tableCell,
        tableHeader
    ].includes($from.node(depth).type)) {
        startMaybeCellNode = $from.node(depth);
        break;
    }
    if (!startMaybeCellNode) // Early exit as $from is not in a cell
    return false;
    let endMaybeCellNode;
    for(let depth = $to.depth; depth > 0; depth--)if ([
        tableCell,
        tableHeader
    ].includes($to.node(depth).type)) {
        endMaybeCellNode = $to.node(depth);
        break;
    }
    if (!endMaybeCellNode) // Early exit as $to is not in a cell
    return false;
    return startMaybeCellNode.eq(endMaybeCellNode);
}
function $b1ee088083c187bc$export$22042c55165155fc({ resolvedPos: resolvedPos, nodeType: nodeType }) {
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        if (resolvedPos.node(depth).type === nodeType) return depth;
    }
    return;
}
module.exports["isWithinSameCell"] = $b1ee088083c187bc$export$fc8b8d4530cea304;
module.exports["getPositionNodeTypeDepth"] = $b1ee088083c187bc$export$22042c55165155fc;

});

parcelRegister("1DOVk", function(module, exports) {

var $ly5a2 = parcelRequire("ly5a2");

var $88e3b10169687331$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["INIT_POSITIONS"] = "INIT_POSITIONS";
    ACTIONS["ADJUST_INIT_POSITIONS"] = "ADJUST_INIT_POSITIONS";
    ACTIONS["UPDATE_LOADING_POSITIONS"] = "UPDATE_LOADING_POSITIONS";
    ACTIONS["UPDATE_STREAM_POSITIONS"] = "UPDATE_STREAM_POSITIONS";
    ACTIONS["END_STREAM"] = "END_STREAM";
    return ACTIONS;
}({});
const $88e3b10169687331$export$a7cd1c3a87df6616 = ({ start: start, end: end, showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, telepointerPos: telepointerPos, originalUserContentSlice: originalUserContentSlice, streamStartPos: streamStartPos, sessionId: sessionId })=>(tr)=>{
        return tr.setMeta((0, $ly5a2.purePmInEditorDirectStreamingPluginKey), {
            action: "INIT_POSITIONS",
            start: start,
            end: end,
            showHighlight: showHighlight,
            showAIContentHighlight: showAIContentHighlight,
            showTelepointer: showTelepointer,
            telepointerPos: telepointerPos,
            originalUserContentSlice: originalUserContentSlice,
            streamStartPos: streamStartPos,
            sessionId: sessionId
        });
    };
const $88e3b10169687331$export$ce0702981dd140ff = ({ start: start, end: end })=>(tr)=>{
        return tr.setMeta((0, $ly5a2.purePmInEditorDirectStreamingPluginKey), {
            action: "ADJUST_INIT_POSITIONS",
            start: start,
            end: end
        });
    };
const $88e3b10169687331$export$2786c982b834f104 = (tr)=>{
    return tr.setMeta((0, $ly5a2.purePmInEditorDirectStreamingPluginKey), {
        action: "UPDATE_LOADING_POSITIONS"
    });
};
const $88e3b10169687331$export$54977414c1e0bf76 = ({ aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, isFinalStream: isFinalStream, lastProcessedVersion: lastProcessedVersion, aiContentSlice: aiContentSlice, scrollTargetPos: scrollTargetPos, posAdjusted: posAdjusted, startPos: startPos, userContentEndPos: userContentEndPos })=>(tr)=>{
        return tr.setMeta((0, $ly5a2.purePmInEditorDirectStreamingPluginKey), {
            action: "UPDATE_STREAM_POSITIONS",
            positions: {
                aiContentEndPos: aiContentEndPos,
                telepointerPos: telepointerPos,
                isFinalStream: isFinalStream,
                lastProcessedVersion: lastProcessedVersion,
                aiContentSlice: aiContentSlice,
                scrollTargetPos: scrollTargetPos,
                posAdjusted: posAdjusted,
                startPos: startPos,
                userContentEndPos: userContentEndPos
            }
        });
    };
const $88e3b10169687331$export$7dbd7b4332a8fca6 = (tr)=>{
    return tr.setMeta((0, $ly5a2.purePmInEditorDirectStreamingPluginKey), {
        action: "END_STREAM"
    });
};
const $88e3b10169687331$export$a07eda0a8c017081 = ({ tr: tr, isFinalStream: isFinalStream, stackTime: stackTime })=>{
    tr = tr.setMeta('isAIStreamingTransformation', true).setMeta('isAIFinalStreamingTransformation', isFinalStream).setMeta('scrollIntoView', false);
    if (stackTime) tr.setTime(stackTime);
    return tr;
};
module.exports["ACTIONS"] = $88e3b10169687331$export$92a1a3b7554e9387;
module.exports["initPositions"] = $88e3b10169687331$export$a7cd1c3a87df6616;
module.exports["updateLoadingPositions"] = $88e3b10169687331$export$2786c982b834f104;
module.exports["updateStreamPositions"] = $88e3b10169687331$export$54977414c1e0bf76;
module.exports["endStream"] = $88e3b10169687331$export$7dbd7b4332a8fca6;
module.exports["metaTransaction"] = $88e3b10169687331$export$a07eda0a8c017081;

});

parcelRegister("fXyZM", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $71b0880b1bcf6f01$export$e530ba00b008a680 = new (0, $ks2lK.PluginKey)('aiExperienceSelection');
module.exports["selectionPluginKey"] = $71b0880b1bcf6f01$export$e530ba00b008a680;

});

parcelRegister("kqrrC", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $lkJUe = parcelRequire("lkJUe");


var $ftzrq = parcelRequire("ftzrq");


var $2QlXt = parcelRequire("2QlXt");


var $5SuLc = parcelRequire("5SuLc");


var $3yUTv = parcelRequire("3yUTv");


var $99IPz = parcelRequire("99IPz");


var $56Rej = parcelRequire("56Rej");


var $j51b9 = parcelRequire("j51b9");

/**
 * This creates a function which is called inside the prosemirror plugin state apply method via the
 * pluginFactory.
 *
 * The docChanged is called for every transaction where the docChanged property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * It takes a dispatchAnalyticsEvent in order to track whether the mapping we use to build a new PluginState
 * is throwing any errors.  This is a temporary measure to track whether we are hitting any edge cases
 * where the mapping is throwing errors. If we find that this is happening, we will revisit the approach
 * to building a new PluginState.
 *
 * The state being built here is used to  from the document used to;
 * - both apply and remove decorations to display the AI modal,
 * - apply decorations following the insertion of AI generated content, to highlight the inserted content (these are removed in the selectionChanged below).
 *
 * In future the intention is to seperate these concerns into seperate plugins.
 */ function $67da9bb54268f4c5$var$onDocChangedModal(tr, pluginState) {
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pluginState;
    // In some collab edge cases mapping decorations could throw an error
    // The ProseMirror .mapping approach has a “dangerous” axiom:
    // Besides the initial state, a document will always “change” through a Transaction
    // However, in some conditions we may reconfigure the EditorState, and a new document
    // will be created without a transaction.
    // This try/catch intends to track cases of this happening and see if it impacts users
    try {
        // Check if transaction is from inserting AI generated content for blocks
        const isAiContentTransformationForBlocks = tr.getMeta('isAiContentTransformationForBlocks');
        // Return with generated content decoration for blocks
        if (isAiContentTransformationForBlocks) {
            const newDecorations = (0, $j51b9.getGeneratedNodeDecorationsFromTransaction)(tr);
            if (newDecorations.length) return {
                ...pluginState,
                modalDecorationSet: (0, $ftzrq.DecorationSet).create(tr.doc, newDecorations)
            };
        }
        // Check if transaction is from inserting AI generated content
        const generatedContentMeta = tr.getMeta('isAiContentTransformation');
        // Return with generated content decoration
        if (generatedContentMeta) {
            const newDecoration = (0, $j51b9.getGeneratedDecorationFromTransaction)(tr, pluginState.isInDocumentStreamingEnabled);
            if (!newDecoration) throw new Error('Did not expect not to find new content in a `isAiContentTransformation` transaction?');
            return {
                ...pluginState,
                modalDecorationSet: (0, $ftzrq.DecorationSet).create(tr.doc, newDecoration)
            };
        }
        // If there is no existing modal decoration -- exit early
        if (pluginState.modalDecorationSet === (0, $ftzrq.DecorationSet).empty) return pluginState;
        // Check if generated AI decorations already exist
        const hasGeneratedContentDecoration = (0, $56Rej.hasGeneratedContentDecorations)(pluginState);
        const isRemote = tr.getMeta('isRemote') ?? false;
        /**
		 * Make sure it isn't a selection change from an appendTransaction
		 */ const selectionWasSet = tr.selectionSet && tr.getMeta('appendedTransaction') === undefined;
        /**
		 * Remove decorations if
		 * - current user interacts with doc
		 *   - and it is not an appendedTransaction
		 */ if (hasGeneratedContentDecoration && !isRemote && selectionWasSet) return {
            ...pluginState,
            modalDecorationSet: (0, $ftzrq.DecorationSet).empty
        };
        // Map the modal decorationSet against the transaction
        const mappedModalDecorationSet = pluginState.modalDecorationSet.map(tr.mapping, tr.doc);
        // return mapped decoration set for case where other users in collab are making changes to doc
        if (hasGeneratedContentDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet
        };
        // Find the start/inline/end decoration
        const decorations = mappedModalDecorationSet.find();
        let inlineDecoration = decorations.find((d)=>d.spec.key === 'inlineDecoration');
        let startDecoration = decorations.find((d)=>d.spec.key === 'startWidgetDecoration');
        let endDecoration = decorations.find((d)=>d.spec.key === 'endWidgetDecoration');
        const nodeDecoration = decorations.find((d)=>d.spec.key === 'ai-nodeDecoration');
        // AI experience was triggered by quick insert, no start widget or inline decoration
        if (nodeDecoration || endDecoration && !startDecoration && !inlineDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet
        };
        /**
		 * If document change, it will cause inlineDecoration to collapse to same position.
		 * We then won't need the AI model as all content between position has been deleted.
		 */ const inlineDecorationHasContent = !!inlineDecoration && inlineDecoration.from !== inlineDecoration.to;
        // Return with no decorations if inline decoration does not exist
        // Handles edge case where the inline decoration can't be deleted at the start
        // of a doc even when it has no content
        // OR if it has no content (eg. selection is just empty paragraphs)
        if (!inlineDecoration || !inlineDecorationHasContent) return {
            ...pluginState,
            modalDecorationSet: (0, $ftzrq.DecorationSet).empty
        };
        // Handle the case where doc changes move inlineDecoration to position 0
        // We cannot add text before inline decoration if from position is 0
        // Remove and recreate inline decoration starting at position 1
        if (inlineDecoration.from === 0) inlineDecoration = (0, $5SuLc.createInlineDecoration)(inlineDecoration.from || 1, inlineDecoration.to || 1);
        // Create and add start widget into DecorationSet if it's been deleted
        if (!startDecoration) startDecoration = (0, $5SuLc.createWidgetDecoration)(pluginState.isInDocumentStreamingEnabled)(inlineDecoration.from, 'start');
        // Create and add end widget into DecorationSet if it doesn't exist
        if (!endDecoration) endDecoration = (0, $5SuLc.createWidgetDecoration)(pluginState.isInDocumentStreamingEnabled)(inlineDecoration.to, 'end');
        return {
            ...pluginState,
            modalDecorationSet: (0, $ftzrq.DecorationSet).create(tr.doc, [
                startDecoration,
                inlineDecoration,
                endDecoration
            ])
        };
    } catch (error) {
        const analyticsPayload = {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'decorationPluginFactory',
            attributes: {
                errorType: 'handleDocChangedError',
                errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        };
        dispatchAnalyticsEvent(analyticsPayload);
        return {
            ...pluginState,
            modalDecorationSet: (0, $ftzrq.DecorationSet).empty
        };
    }
}
function $67da9bb54268f4c5$var$onDocChangedStreaming(tr, pluginState) {
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pluginState;
    // In some collab edge cases mapping decorations could throw an error
    // The ProseMirror .mapping approach has a “dangerous” axiom:
    // Besides the initial state, a document will always “change” through a Transaction
    // However, in some conditions we may reconfigure the EditorState, and a new document
    // will be created without a transaction.
    // This try/catch intends to track cases of this happening and see if it impacts users
    try {
        // If there is no existing modal decoration -- exit early
        if (pluginState.modalDecorationSet === (0, $ftzrq.DecorationSet).empty) {
            if (!!pluginState.ignoredSpaceTriggerSelection) return {
                ...pluginState,
                ignoredSpaceTriggerSelection: undefined
            };
            return pluginState;
        }
        // Map the modal decorationSet against the transaction
        const mappedModalDecorationSet = pluginState.modalDecorationSet.map(tr.mapping, tr.doc);
        const decorations = mappedModalDecorationSet.find();
        const modalRangeMountPointDecorations = decorations.find((d)=>d.spec.key === 'modalMountPointRangeDecoration');
        const modalMountPointDecoration = decorations.find((d)=>d.spec.key === 'modalMountPointDecoration');
        if (modalMountPointDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet,
            ignoredSpaceTriggerSelection: undefined
        };
        const hasRange = modalRangeMountPointDecorations && modalRangeMountPointDecorations.from !== modalRangeMountPointDecorations.to;
        // If there is no modal mount point decoration, we need to create one
        const appendedTransaction = tr.getMeta('appendedTransaction');
        if (tr.getMeta('isAIStreamingTransformation') || appendedTransaction && appendedTransaction.getMeta('isAIStreamingTransformation')) return {
            ...pluginState,
            modalDecorationSet: (0, $ftzrq.DecorationSet).create(tr.doc, [
                ...decorations,
                (0, $5SuLc.createModalMountPointDecoration)(Math.max(1, Math.min(tr.doc.content.size, tr.steps[0].to)))
            ]),
            ignoredSpaceTriggerSelection: undefined
        };
        else if (hasRange) return {
            ...pluginState,
            modalDecorationSet: (0, $ftzrq.DecorationSet).create(tr.doc, [
                ...decorations,
                (0, $5SuLc.createModalMountPointDecoration)(Math.max(1, Math.min(tr.doc.content.size, modalRangeMountPointDecorations.to)))
            ]),
            ignoredSpaceTriggerSelection: undefined
        };
        return {
            ...pluginState,
            modalDecorationSet: (0, $ftzrq.DecorationSet).empty,
            ignoredSpaceTriggerSelection: undefined
        };
    } catch (error) {
        const analyticsPayload = {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'decorationPluginFactory',
            attributes: {
                errorType: 'handleDocChangedError',
                errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        };
        dispatchAnalyticsEvent(analyticsPayload);
        return {
            ...pluginState,
            modalDecorationSet: (0, $ftzrq.DecorationSet).empty,
            ignoredSpaceTriggerSelection: undefined
        };
    }
}
function $67da9bb54268f4c5$var$onDocChanged(tr, pluginState) {
    if (pluginState.isInDocumentStreamingEnabled) return $67da9bb54268f4c5$var$onDocChangedStreaming(tr, pluginState);
    return $67da9bb54268f4c5$var$onDocChangedModal(tr, pluginState);
}
/**
 * This function is called inside the prosemirror plugin state apply method via the pluginFactory.
 *
 * The docChanged is called for every transaction where the selectionSet property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * The state transformation here is being used to remove the decorations that are added when the AI experience has inserted content.
 *
 * These are added inside docChanged above.
 *
 * In future the intention is to seperate this concerns into seperate plugin (currently the majority of this file is dealing
 * with decorations related to the presentation of a modal for the AI experience).
 */ function $67da9bb54268f4c5$var$onSelectionChanged(_tr, pluginState) {
    if (pluginState.modalDecorationSet === (0, $ftzrq.DecorationSet).empty || pluginState.configItem) return pluginState;
    if ((0, $56Rej.hasGeneratedContentDecorations)(pluginState)) return {
        ...pluginState,
        modalDecorationSet: (0, $ftzrq.DecorationSet).empty
    };
    return pluginState;
}
// if in the future we need to map other state, we can rename this to mappingInitialPositions
// and add another mapping function for the other state
// this is to avoid having a single function that does too many things
function $67da9bb54268f4c5$var$mapping(tr, pluginState) {
    const { initialPositions: initialPositions } = pluginState;
    if (!initialPositions) return pluginState;
    // do not map initial positions for streaming transactions
    // because after mapping, they are not initial positions anymore
    // but we do need to map the initial positions for non-streaming remote transactions
    if (pluginState.isInDocumentStreamingEnabled) {
        const appendedTransaction = tr.getMeta('appendedTransaction');
        if (tr.getMeta('isAIStreamingTransformation') || appendedTransaction && appendedTransaction.getMeta('isAIStreamingTransformation')) return pluginState;
    }
    const mappedInitialPositions = [
        tr.mapping.map(initialPositions[0]),
        tr.mapping.map(initialPositions[1])
    ];
    if (mappedInitialPositions[0] === initialPositions[0] && mappedInitialPositions[1] === initialPositions[1]) return pluginState;
    return {
        ...pluginState,
        initialPositions: mappedInitialPositions
    };
}
const $67da9bb54268f4c5$export$de5e90bd767c5d82 = (dispatchAnalyticsEvent, isInDocumentStreamingEnabled)=>(state)=>{
        return {
            isRunning: false,
            /**
			 * Longer term it would be good to expand the decorationset to include
			 * the entire selection, as well as the 'valid inline position' to place
			 * an inline widget visualising start+end of valid selections
			 */ modalDecorationSet: (0, $ftzrq.DecorationSet).empty,
            dispatchAnalyticsEvent: /**
			 * This takes a dispatchAnalyticsEvent in order to support firing analytics events in case
			 * mapping logic used in the onDocChanged passed to the pluginFactory throws an error.
			 */ dispatchAnalyticsEvent,
            isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
        };
    };
const { createPluginState: $67da9bb54268f4c5$export$656c7661095efe2e, createCommand: $67da9bb54268f4c5$export$8d4021544bdece00, getPluginState: $67da9bb54268f4c5$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $3yUTv.aiExperienceDecorationPluginKey), (0, $99IPz.reducer), {
    mapping: $67da9bb54268f4c5$var$mapping,
    onDocChanged: $67da9bb54268f4c5$var$onDocChanged,
    onSelectionChanged: $67da9bb54268f4c5$var$onSelectionChanged
});
module.exports["createInitialState"] = $67da9bb54268f4c5$export$de5e90bd767c5d82;
module.exports["createPluginState"] = $67da9bb54268f4c5$export$656c7661095efe2e;
module.exports["createCommand"] = $67da9bb54268f4c5$export$8d4021544bdece00;
module.exports["getPluginState"] = $67da9bb54268f4c5$export$f05434c51e3762e;

});

parcelRegister("2e7rb", function(module, exports) {
const $039a6d5d0dbb8511$export$700cb401385d6bf2 = (editorView)=>{
    return editorView.dom?.dataset?.editorId;
};
module.exports["findEditorIdFromView"] = $039a6d5d0dbb8511$export$700cb401385d6bf2;

});

parcelRegister("fUwkU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5299dae51933827bfdc2b6fdbe7310d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9552b4737f0e927$var$_react = $b9552b4737f0e927$var$_interopRequireDefault((parcelRequire("42omo")));

var $b9552b4737f0e927$var$_baseNew = $b9552b4737f0e927$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b9552b4737f0e927$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextConclusionAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Confluence Editor AI action for generating a conclusion
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9552b4737f0e927$var$TextConclusionAddIcon = (props)=>/*#__PURE__*/ $b9552b4737f0e927$var$_react.default.createElement($b9552b4737f0e927$var$_baseNew.default, Object.assign({
        name: "TextConclusionAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 6.5H1V5h14zm0-4H1V1h14z" clip-rule="evenodd"/><path fill="currentcolor" d="M1.75 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 4a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.88-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M4.88 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.87-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.88-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.37.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"/>`
    }, props));
$b9552b4737f0e927$var$TextConclusionAddIcon.displayName = 'TextConclusionAddIcon';
var $b9552b4737f0e927$var$_default = module.exports.default = $b9552b4737f0e927$var$TextConclusionAddIcon;

});

parcelRegister("4zFET", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55735126425816215b54d18f917a5070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $354abecf1ffa70bc$var$_react = $354abecf1ffa70bc$var$_interopRequireDefault((parcelRequire("42omo")));

var $354abecf1ffa70bc$var$_baseNew = $354abecf1ffa70bc$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $354abecf1ffa70bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIntroductionAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Confluence Editor AI action for generating an introduction
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $354abecf1ffa70bc$var$TextIntroductionAddIcon = (props)=>/*#__PURE__*/ $354abecf1ffa70bc$var$_react.default.createElement($354abecf1ffa70bc$var$_baseNew.default, Object.assign({
        name: "TextIntroductionAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 9.5H1V11h14zm-7 4H1V15h7z" clip-rule="evenodd"/><path fill="currentcolor" d="M1.75 5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-4a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3.88 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M4.88 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3.87 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M8 1a.75.75 0 1 1 0 1.5A.75.75 0 0 1 8 1m3.88 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M11.13 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M15 5.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M14.25 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"/>`
    }, props));
$354abecf1ffa70bc$var$TextIntroductionAddIcon.displayName = 'TextIntroductionAddIcon';
var $354abecf1ffa70bc$var$_default = module.exports.default = $354abecf1ffa70bc$var$TextIntroductionAddIcon;

});

parcelRegister("ieno2", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $zT4ZO = parcelRequire("zT4ZO");


var $sxTNo = parcelRequire("sxTNo");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $2QlXt = parcelRequire("2QlXt");


var $j51b9 = parcelRequire("j51b9");


var $jdR93 = parcelRequire("jdR93");


var $4SGh1 = parcelRequire("4SGh1");

function $5aec95f5904f6326$export$336eb673e6d24058(tr, editorState) {
    /**
	 * DO NOT REMOVE isAiContentTransformation from transaction meta.
	 * Proactive AI S+G rely on isAiContentTransformation meta to
	 * 	ignore changes in document made by AI modal.
	 * Why ignore it?
	 * - Response returned from AI does not require Spelling and Grammar check.
	 * - We have assumed that it's already correct from S+G perspective.
	 */ tr.setMeta('isAiContentTransformation', true);
    const firstReplaceStep = (0, $j51b9.findFirstReplaceStep)(tr.steps);
    if (!firstReplaceStep) {
        // Ideally we should always have replace step for for AI transaction.
        // But in case if there isn't we want to fire analytic event so we can monitor it.
        (0, $4SGh1.addAnalytics)({
            editorState: editorState,
            tr: tr,
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'experienceApplication',
                attributes: {
                    errorType: 'replaceStepNotFound'
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            }
        });
        return tr;
    }
    const validPositionToSet = (0, $j51b9.getValidEndTextPosition)({
        step: firstReplaceStep,
        doc: tr.doc
    });
    if (validPositionToSet !== 0) tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, validPositionToSet));
    return tr;
}
function $5aec95f5904f6326$export$7b46ef9a312ebccb(fragment, tr, state) {
    const supportedNodeTypes = (0, $jdR93.getSupportedNodesForAIModal)(state);
    // Here we are checking if there is text node at first level.
    // Then we will highlight all nodes.
    let areTopLevelBlockElements = true;
    fragment.forEach((node)=>{
        areTopLevelBlockElements = areTopLevelBlockElements && supportedNodeTypes.has(node.type);
    });
    if (areTopLevelBlockElements) return tr.setMeta('isAiContentTransformationForBlocks', true);
    return tr;
}
function $5aec95f5904f6326$export$cfdd8b8691129358(tr) {
    /**
	 * DO NOT REMOVE
	 * This is used when distinguishing content generated by a Rovo agent
	 */ tr.setMeta('isAiRovoAgentContentTransformation', true);
    return tr;
}
function $5aec95f5904f6326$var$getLastContentDepth({ pmFragment: pmFragment }) {
    let depth = 0;
    let currentNode = pmFragment;
    while(currentNode.firstChild){
        depth++;
        currentNode = currentNode.firstChild;
    }
    return depth;
}
function $5aec95f5904f6326$var$isSelectionAtParagraphStart($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'paragraph' || node.type.name === 'heading') && !$pos.parentOffset;
}
function $5aec95f5904f6326$var$isFragmentSingleParagraph(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return fragment.childCount === 1 && fragment.firstChild.type.name === 'paragraph';
}
function $5aec95f5904f6326$var$isSelectionInTaskOrDecisionNode($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'decisionList' || node.type.name === 'decisionItem' || node.type.name === 'taskList' || node.type.name === 'taskItem');
}
function $5aec95f5904f6326$export$f00c638dfda8b9e2({ selection: selection, tableSchema: tableSchema }) {
    const isNestedTablesDisabled = (0, $iu6m9.editorExperiment)('nested-tables-in-tables', false, {
        exposure: true
    });
    const parentTableCount = (0, $sxTNo.getParentOfTypeCount)(tableSchema)(selection.$from);
    const hasParentTable = (0, $8m4tT.hasParentNodeOfType)(tableSchema)(selection);
    return hasParentTable && (isNestedTablesDisabled || parentTableCount > 1);
}
const $5aec95f5904f6326$export$a6a8eefd91a14ea5 = ({ pmFragment: pmFragment, transaction: transaction })=>{
    const tableSchema = transaction.doc.type.schema.nodes.table;
    const fromPos = transaction.selection.$from;
    const positionAfterTopTable = (0, $sxTNo.getPositionAfterTopParentNodeOfType)(tableSchema)(fromPos);
    return (0, $8m4tT.safeInsert)(pmFragment, positionAfterTopTable)(transaction);
};
const $5aec95f5904f6326$export$841048b11479358 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment })=>{
    const { state: state } = editorView;
    let transaction = state.tr;
    const slice = pmFragment.size === 0 && (0, $dh538.fg)('platform_editor_ai_replace_content_empty_slice') ? (0, $5SAOw.Slice).empty : new (0, $5SAOw.Slice)(pmFragment, 0, 0);
    if (pmFragment.size === 0 && (0, $dh538.fg)('platform_editor_ai_replace_content_empty_slice')) transaction = (0, $4SGh1.addAnalytics)({
        editorState: state,
        tr: transaction,
        payload: {
            action: 'fallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'replaceWithEmptyAIContent',
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                isBlock: true,
                isSelectionEmpty: positions[0] === positions[1]
            }
        }
    });
    try {
        // If you can't replace the range, use safeInsert
        transaction = transaction.replaceRange(positions[0], positions[1], slice);
    } catch (error) {
        // If you can't replace the range, use safeInsert
        transaction = (0, $8m4tT.safeInsert)(pmFragment, undefined, true)((0, $4SGh1.addAnalytics)({
            editorState: state,
            tr: transaction,
            payload: {
                action: 'fallback',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'proseMirrorReplace',
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    target: 'replaceWithAIContentForBlock',
                    isSelectionEmpty: positions[0] === positions[1],
                    errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error),
                    isReplacementEmpty: pmFragment.size === 0
                }
            }
        }));
    }
    return $5aec95f5904f6326$export$336eb673e6d24058($5aec95f5904f6326$export$7b46ef9a312ebccb(pmFragment, transaction, state), state);
};
const $5aec95f5904f6326$export$60bccdedcf767536 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, selectionMetaData: selectionMetaData, options: options = {
    replaceDocOnEmptySelection: true
} })=>{
    const { state: state } = editorView;
    let transaction = state.tr;
    const endPositionDepth = state.doc.resolve(positions[1]).depth;
    const lastFragmentDepth = $5aec95f5904f6326$var$getLastContentDepth({
        pmFragment: pmFragment
    });
    // selectionMetaData will always be undefined when adf streaming is disabled
    const sliceOpenStart = selectionMetaData?.sliceOpenStart || 1;
    const sliceOpenEnd = selectionMetaData?.sliceOpenEnd || Math.min(endPositionDepth, lastFragmentDepth);
    const slice = pmFragment.size === 0 && (0, $dh538.fg)('platform_editor_ai_replace_content_empty_slice') ? (0, $5SAOw.Slice).empty : new (0, $5SAOw.Slice)(pmFragment, sliceOpenStart, sliceOpenEnd);
    if (pmFragment.size === 0 && (0, $dh538.fg)('platform_editor_ai_replace_content_empty_slice')) transaction = (0, $4SGh1.addAnalytics)({
        editorState: state,
        tr: transaction,
        payload: {
            action: 'fallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'replaceWithEmptyAIContent',
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                isBlock: false,
                isSelectionEmpty: positions[0] === positions[1]
            }
        }
    });
    if ((0, $zT4ZO.fragmentContainsNodeType)(pmFragment, transaction.doc.type.schema.nodes.table) && $5aec95f5904f6326$export$f00c638dfda8b9e2({
        selection: transaction.selection,
        tableSchema: transaction.doc.type.schema.nodes.table
    }) && (0, $sxTNo.isNestedTablesSupported)(state.schema)) return $5aec95f5904f6326$export$a6a8eefd91a14ea5({
        pmFragment: pmFragment,
        transaction: transaction
    });
    else {
        // We check if the positions are the same if so we replace the whole document
        // This is a quick spike so real implementation might need to be different
        // You might need to create a new replace action
        if (options.replaceDocOnEmptySelection && positions[0] === positions[1]) transaction = transaction.replaceRange(0, state.doc.content.size, slice);
        else try {
            transaction = transaction.replaceRange(positions[0], positions[1], slice);
        // If you can't replace the range, use safeInsert
        } catch (error) {
            transaction = (0, $8m4tT.safeInsert)(pmFragment, undefined, true)((0, $4SGh1.addAnalytics)({
                editorState: state,
                tr: transaction,
                payload: {
                    action: 'fallback',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'proseMirrorReplace',
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        target: 'replaceWithAIContent',
                        isSelectionEmpty: positions[0] === positions[1],
                        errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error),
                        isReplacementEmpty: pmFragment.size === 0
                    }
                }
            }));
        }
        return $5aec95f5904f6326$export$336eb673e6d24058(transaction, state);
    }
};
const $5aec95f5904f6326$export$7dc11dddc9c93a89 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment })=>{
    const { state: state } = editorView;
    const transaction = state.tr;
    const pos = positions[0];
    const $pos = state.doc.resolve(pos);
    const isParagraphStart = $5aec95f5904f6326$var$isSelectionAtParagraphStart($pos);
    // if selection is at the beginning of paragraph,
    // insert before the cursor so that it inserts without an extra new line
    const insertPos = isParagraphStart ? pos - 1 : pos;
    // if selection is inside decision or task node AND pmFragment is a single paragraph
    // strip the paragraph so it can insert inside the decision/task
    let fragmentToInsert = pmFragment;
    if ($5aec95f5904f6326$var$isSelectionInTaskOrDecisionNode($pos) && $5aec95f5904f6326$var$isFragmentSingleParagraph(pmFragment)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragmentToInsert = pmFragment.firstChild.content;
    if ((0, $zT4ZO.fragmentContainsNodeType)(pmFragment, transaction.doc.type.schema.nodes.table) && $5aec95f5904f6326$export$f00c638dfda8b9e2({
        selection: transaction.selection,
        tableSchema: transaction.doc.type.schema.nodes.table
    }) && (0, $sxTNo.isNestedTablesSupported)(state.schema)) return $5aec95f5904f6326$export$a6a8eefd91a14ea5({
        pmFragment: pmFragment,
        transaction: transaction
    });
    else return $5aec95f5904f6326$export$336eb673e6d24058(transaction.insert(insertPos, fragmentToInsert), state);
};
module.exports["beforeDispatchAITransaction"] = $5aec95f5904f6326$export$336eb673e6d24058;
module.exports["beforeDispatchingTransactionForBlocks"] = $5aec95f5904f6326$export$7b46ef9a312ebccb;
module.exports["beforeDispatchAIRovoAgentTransaction"] = $5aec95f5904f6326$export$cfdd8b8691129358;
module.exports["shouldInsertAfterTable"] = $5aec95f5904f6326$export$f00c638dfda8b9e2;
module.exports["insertContentAfterTable"] = $5aec95f5904f6326$export$a6a8eefd91a14ea5;
module.exports["replaceWithAIContentForBlock"] = $5aec95f5904f6326$export$841048b11479358;
module.exports["replaceWithAIContent"] = $5aec95f5904f6326$export$60bccdedcf767536;
module.exports["insertAIContentAtCurrentPosition"] = $5aec95f5904f6326$export$7dc11dddc9c93a89;

});

parcelRegister("imfiV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dMzWS = parcelRequire("dMzWS");

var $3271ec8cc5d31acc$export$114247090b0aae30 = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint[Breakpoint["SmallChromeless"] = 258] = "SmallChromeless";
    Breakpoint[Breakpoint["Small"] = 320] = "Small";
    Breakpoint[Breakpoint["Large"] = Infinity] = "Large";
    return Breakpoint;
}({});
function $3271ec8cc5d31acc$export$4d88d8cc8b24eb33(smallBreakpoint = 320) {
    const [setElement, { width: width }] = (0, $dMzWS.useElementSize)();
    const breakpoint = width < smallBreakpoint ? smallBreakpoint : Infinity;
    return (0, $42omo.useMemo)(()=>[
            setElement,
            {
                breakpoint: breakpoint,
                isSmall: breakpoint <= smallBreakpoint,
                isLarge: breakpoint > smallBreakpoint
            }
        ], [
        breakpoint,
        setElement,
        smallBreakpoint
    ]);
}
module.exports["Breakpoint"] = $3271ec8cc5d31acc$export$114247090b0aae30;
module.exports["useElementBreakpoints"] = $3271ec8cc5d31acc$export$4d88d8cc8b24eb33;

});

parcelRegister("BPkYg", function(module, exports) {
/* error-screen-parts.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $a3fRD = parcelRequire("a3fRD");


var $ebrpi = parcelRequire("ebrpi");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $kuYGt = parcelRequire("kuYGt");


var $40sdH = parcelRequire("40sdH");


var $imfiV = parcelRequire("imfiV");


var $4pXOZ = parcelRequire("4pXOZ");

const $c4df1a880a13e405$var$buttonContainerStyles = null;
const $c4df1a880a13e405$var$cmdPaletteButtonContainerStyles = {
    container: "_zulp1b66 _1e0c1txw _1n261g80 _2lx2vrvc _1bahesu3 _4cvr1h6o _zs121b66 _jq8gxy5q _xlob1h6o",
    primaryButton: "_stfgia51"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $c4df1a880a13e405$var$divWrapperContainerStyleUnbounded = null;
const $c4df1a880a13e405$var$divWrapperContainerStyle = null;
const $c4df1a880a13e405$var$smallBreakPointAlignItems = null;
const $c4df1a880a13e405$var$errorFloatingContainerStyle = null;
const $c4df1a880a13e405$var$smallErrorFloatingContainerStyle = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $c4df1a880a13e405$var$spanWrapperStyleUnbounded = null;
const $c4df1a880a13e405$var$spanWrapperStyle = null;
const $c4df1a880a13e405$var$smallBreakPointTop = null;
const $c4df1a880a13e405$var$dangerIconPaddingStyle = null;
function $c4df1a880a13e405$export$915e9e7bd4f0f96d({ children: children, breakpoint: breakpoint, isAIFC: isAIFC }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx2vrvc _1bah1y6m _4cvr1h6o",
            "_zulp19bv",
            breakpoint <= (0, $imfiV.Breakpoint).Small && "_4cvr1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_1e0c116y _4cvr1h6o _1bah1h6o _kqswh2mm _1o9zidpf _154ize3t",
                    "_vwz4kb7n",
                    breakpoint <= (0, $imfiV.Breakpoint).Small && "_154i1i6y"
                ]),
                children: isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                        label: formatMessage((0, $4pXOZ.default).warningIconLabel),
                        color: "var(--ds-icon-danger, #C9372C)"
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                    label: formatMessage((0, $4pXOZ.default).warningIconLabel),
                    color: "var(--ds-icon-warning, #E06C00)"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                children: children
            })
        ]
    });
}
function $c4df1a880a13e405$export$a359b30953f5499e({ children: children, onClick: onClick, appearance: appearance, testId: testId, autoFocus: autoFocus, disabled: disabled = false, isAIFC: isAIFC }) {
    const shouldUseSubtleStyle = isAIFC && appearance === 'primary';
    const finalAppearance = shouldUseSubtleStyle ? 'subtle' : appearance;
    const button = /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
        autoFocus: autoFocus,
        testId: testId,
        spacing: "compact",
        onClick: onClick,
        type: "button",
        appearance: finalAppearance,
        isDisabled: disabled,
        children: children
    });
    if (shouldUseSubtleStyle) return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: $c4df1a880a13e405$var$cmdPaletteButtonContainerStyles.primaryButton,
        children: button
    });
    return button;
}
function $c4df1a880a13e405$export$e7ce0c27e387222f({ children: children, isAIFC: isAIFC }) {
    return isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: $c4df1a880a13e405$var$cmdPaletteButtonContainerStyles.container,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _1n261g80 _2lx2vrvc _1bahesu3 _4cvr1h6o"
        ]),
        children: children
    });
} // Need to use forwardRef because functional component cannot be passed a ref
const $c4df1a880a13e405$export$f31c7963ee61af = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, breakpoint: breakpoint, appearance: appearance, isAIFC: isAIFC }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40sdH.FloatingContainer), {
        ref: ref,
        "data-testid": "error-screen",
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _2lx2vrvc",
            breakpoint <= (0, $imfiV.Breakpoint).Small && "_zulppxbi _1e0c1txw _2lx21bp4",
            `error-screen ${(0, $kuYGt.AI_MODAL_SCREEN_CLASS)}`
        ]),
        paddingAdjustments: isAIFC ? {
            right: 4,
            left: 4
        } : {
            top: 1,
            bottom: 1
        },
        rainbowBorder: false,
        appearance: appearance,
        isAIFC: isAIFC,
        children: children
    });
});
module.exports["ErrorMessage"] = $c4df1a880a13e405$export$915e9e7bd4f0f96d;
module.exports["ErrorButton"] = $c4df1a880a13e405$export$a359b30953f5499e;
module.exports["ErrorButtonContainer"] = $c4df1a880a13e405$export$e7ce0c27e387222f;
module.exports["ErrorFloatingContainer"] = $c4df1a880a13e405$export$f31c7963ee61af;

});

parcelRegister("4pXOZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e460e0007319cff$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $6e460e0007319cff$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    cancelLabel: {
        id: "fabric.editor.ai.screens.error.cancelLabel",
        defaultMessage: "Cancel"
    },
    closeLabel: {
        id: "fabric.editor.ai.screens.error.closeLabel",
        defaultMessage: "Close"
    },
    retryLabel: {
        id: "fabric.editor.ai.screens.error.retryLabel",
        defaultMessage: "Try again"
    },
    warningIconLabel: {
        id: "fabric.editor.ai.screens.error.warningIconLabel",
        defaultMessage: "Warning"
    },
    ariaErrorTitle: {
        id: "fabric.editor.ai.screens.error.ariaErrorTitle",
        defaultMessage: "Error"
    }
});

});

parcelRegister("kuYGt", function(module, exports) {
// Request from Trello to add a single selector for all modal screens
// This is to prevent click events within the Editor AI plugin screens
// from triggering a “close” event hiding the Editor while in edit mode.
// See https://hello.atlassian.net/browse/EDITOR-75
const $5876e00d86eabc1e$export$9df59400d72ad68f = 'ai-modal-screen';
module.exports["AI_MODAL_SCREEN_CLASS"] = $5876e00d86eabc1e$export$9df59400d72ad68f;

});

parcelRegister("3ZqD0", function(module, exports) {
/* RovoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f52771a65fd08593$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $f52771a65fd08593$var$svgStyles = null;
const $f52771a65fd08593$var$rovoIconPath = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
    children: [
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M10.7601 0.338448C11.5933 -0.121106 12.6101 -0.112663 13.4365 0.363775L19.9352 4.11317L21.4762 5.0023C22.3177 5.4874 22.8385 6.3874 22.8385 7.35696V16.6341C22.8385 17.6075 22.3208 18.5036 21.4769 18.9884L15.4334 22.4752C15.4466 22.438 15.4592 22.4006 15.4713 22.363C15.5834 22.0154 15.6429 21.6481 15.6429 21.2727V11.9955C15.6429 10.7211 14.9646 9.5458 13.8581 8.91002L12.7419 8.26625L9.35306 6.31196V2.71838C9.35306 2.43521 9.39687 2.1586 9.47978 1.89674C9.68356 1.26299 10.117 0.714353 10.7101 0.371867L10.7119 0.37083C10.7288 0.361022 10.745 0.350144 10.7601 0.338448Z",
            fill: "#FCA700"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M8.71417 1.52478L2.67066 5.01159C1.82674 5.49643 1.30908 6.39246 1.30908 7.36586V16.643C1.30908 17.6126 1.82979 18.5125 2.67121 18.9976L4.10412 19.8243L10.7111 23.6362C11.5374 24.1126 12.5543 24.1211 13.3875 23.6616C13.4026 23.6499 13.4186 23.639 13.4356 23.6292C14.0293 23.287 14.4634 22.7381 14.6675 22.1041C14.7506 21.842 14.7945 21.5651 14.7945 21.2816V17.688L11.2974 15.6713L10.2897 15.0901C9.18348 14.4543 8.50468 13.2788 8.50468 12.0044V2.72728C8.50468 2.35237 8.56398 1.98558 8.67586 1.63842C8.68799 1.60029 8.70078 1.56241 8.71417 1.52478Z",
            fill: "#FCA700"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.2974 15.6713L4.10412 19.8243L2.67121 18.9976C1.82979 18.5125 1.30908 17.6126 1.30908 16.643V7.36586C1.30908 6.39246 1.82674 5.49643 2.67066 5.01159L8.71417 1.52478C8.70078 1.56241 8.68799 1.60029 8.67586 1.63842C8.56398 1.98558 8.50468 2.35237 8.50468 2.72728V12.0044C8.50468 13.2788 9.18348 14.4543 10.2897 15.0901L11.2974 15.6713Z",
            fill: "#1868DB"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.7419 8.26625L9.35306 6.31196V2.71838C9.35306 2.43521 9.39687 2.15859 9.47978 1.89674C9.68356 1.26299 10.117 0.714353 10.7101 0.371867L10.7119 0.37083C10.7288 0.361022 10.745 0.350144 10.7601 0.338447C11.5933 -0.121106 12.6101 -0.112663 13.4365 0.363775L19.9352 4.11317L12.7419 8.26625Z",
            fill: "#FCA700"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M21.4762 5.00229L19.9352 4.11316L12.7419 8.26624L13.8581 8.91001C14.9646 9.54579 15.6429 10.721 15.6429 11.9955V21.2727C15.6429 21.6481 15.5834 22.0154 15.4713 22.363C15.4592 22.4006 15.4466 22.438 15.4334 22.4752L21.4769 18.9884C22.3208 18.5036 22.8385 17.6075 22.8385 16.6341V7.35695C22.8385 6.38739 22.3177 5.48739 21.4762 5.00229Z",
            fill: "#AF59E0"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.2975 15.6713L4.10413 19.8244L10.7111 23.6362C11.5375 24.1126 12.5544 24.1211 13.3875 23.6616C13.4026 23.6499 13.4186 23.639 13.4356 23.6292C14.0293 23.287 14.4634 22.7381 14.6675 22.1041C14.7506 21.842 14.7945 21.5651 14.7945 21.2816V17.688L11.2975 15.6713Z",
            fill: "#6A9A23"
        })
    ]
});
const $f52771a65fd08593$var$RovoIcon = (props)=>{
    const { primaryColor: primaryColor, size: size = 'small', label: label } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $f52771a65fd08593$var$sizeStyles[size]
        ]),
        children: $f52771a65fd08593$var$rovoIconPath
    });
};
const $f52771a65fd08593$var$rovoIconJiraPath = /*#__PURE__*/ (0, $l998X.jsxs)("g", {
    transform: "translate(4, 4)",
    children: [
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.53094 10.4476L2.73541 13.2163L1.78022 12.6652C1.21927 12.3418 0.872135 11.7418 0.872135 11.0954V4.91066C0.872135 4.26173 1.21724 3.66437 1.77985 3.34114L5.80885 1.01662C5.79992 1.0417 5.7914 1.06696 5.78331 1.09238C5.70872 1.32382 5.66919 1.56834 5.66919 1.81828V8.00304C5.66919 8.8526 6.12173 9.63628 6.85921 10.0602L7.53094 10.4476Z",
            fill: "#357DE8"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.53076 10.4476L2.73523 13.2163L7.13984 15.7575C7.69076 16.0751 8.36871 16.0808 8.92411 15.7744C8.93417 15.7666 8.94488 15.7594 8.95621 15.7529C9.35198 15.5247 9.6414 15.1588 9.77748 14.7361C9.83287 14.5614 9.86214 14.3768 9.86214 14.1878V11.7921L7.53076 10.4476Z",
            fill: "#82B536"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M14.3184 3.33501L13.291 2.74227L8.49549 5.51098L9.23969 5.94015C9.97729 6.36401 10.4295 7.14752 10.4295 7.99717V14.1819C10.4295 14.4322 10.3899 14.6771 10.3151 14.9088C10.3071 14.9339 10.2987 14.9588 10.2899 14.9836L14.3189 12.6591C14.8815 12.3358 15.2266 11.7385 15.2266 11.0895V4.90479C15.2266 4.25842 14.8794 3.65842 14.3184 3.33501Z",
            fill: "#BF63F3"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.49384 5.51082L6.23466 4.20796V1.81225C6.23466 1.62347 6.26387 1.43906 6.31913 1.26449C6.455 0.841993 6.74398 0.476235 7.13931 0.247911L7.14051 0.247219C7.15185 0.240681 7.16263 0.233429 7.17269 0.225631C7.72811 -0.0807372 8.40603 -0.0751089 8.95696 0.242516L13.2894 2.74211L8.49384 5.51082Z",
            fill: "#FCA700"
        })
    ]
});
const $f52771a65fd08593$export$70b609cdd5be83af = (props)=>{
    const { primaryColor: primaryColor, size: size = 'large', label: label } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $f52771a65fd08593$var$sizeStyles[size]
        ]),
        children: $f52771a65fd08593$var$rovoIconJiraPath
    });
};
var $f52771a65fd08593$export$2e2bcd8739ae039 = $f52771a65fd08593$var$RovoIcon;
module.exports["default"] = $f52771a65fd08593$export$2e2bcd8739ae039;

});

parcelRegister("40sdH", function(module, exports) {
/* FloatingContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5zdke = parcelRequire("5zdke");


var $7YjFd = parcelRequire("7YjFd");


var $1oCLl = parcelRequire("1oCLl");

const $09db0abbbd70bd3d$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $09db0abbbd70bd3d$var$PRISM_BORDER_STEP_1 = '#0065FF';
const $09db0abbbd70bd3d$var$PRISM_BORDER_STEP_2 = '#0469FF';
const $09db0abbbd70bd3d$var$PRISM_BORDER_STEP_3 = '#BF63F3';
const $09db0abbbd70bd3d$var$PRISM_BORDER_STEP_4 = '#FFA900';
const $09db0abbbd70bd3d$var$defaultPadding = {
    top: 12,
    bottom: 12,
    left: 12,
    right: 12
}; // ED-20633, DSP-14045: Avoid space tokens for now as space tokens are currently using rem units
// and Safari has a bug where rem is incorrectly calculated when there are
// animations involved
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $09db0abbbd70bd3d$var$prismBorderStyles = null;
const $09db0abbbd70bd3d$var$newPrismBorderStyles = null;
const $09db0abbbd70bd3d$var$staticStyles = {
    default: "_16r2w4bv _1s6kw4bv",
    firefox: "_16r21l3w _1s6k1l3w _19h915ob _1ank15ob"
};
const $09db0abbbd70bd3d$var$fireFoxBgPosition = null;
const $09db0abbbd70bd3d$var$rotationAnimation = null;
const $09db0abbbd70bd3d$var$animationStyles = {
    default: "_19oh1jq7 _10881jq7 _kwc0ymdr _joxlymdr _18lgp3kn _zo24p3kn _18f312c5 _evp612c5",
    firefox: "_19oh1nnn _10881nnn _kwc09cwz _joxl9cwz _18lgp3kn _zo24p3kn _18f312c5 _evp612c5 _unfq4jg8 _9nev4jg8"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $09db0abbbd70bd3d$var$constantStyles = null;
const $09db0abbbd70bd3d$var$newConstantStyles = null;
const $09db0abbbd70bd3d$var$maxHeightCSS = null;
const $09db0abbbd70bd3d$var$maxWidthCSS = null; // EDITOR-3718: Responsive width fix for narrow screens.
// Clamp to 400px or the container width. Set both `width` (preferred/base size)
// and `maxWidth` (hard cap + overrides existing rules) to keep sizing consistent.
const $09db0abbbd70bd3d$var$responsiveMaxWidthOverrideCSS = null;
const $09db0abbbd70bd3d$var$chromelessWidth = {
    width: `calc(100% - ${"var(--ds-space-300, 24px)"})`,
    justifySelf: 'center'
}; /**
    * FocusLock adds a focus trap so that users can keep tabbing through the
    * command palette without leaving it unless when pressing escape or clicking outside.
    */ 
const $09db0abbbd70bd3d$var$GatedFocusLock = ({ children: children, isAIFC: isAIFC })=>{
    const scrollParentRef = (0, $42omo.useRef)();
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (ref.current) scrollParentRef.current = (0, $7YjFd.findOverflowScrollParent)(ref.current) || undefined;
    }, []);
    if (!isAIFC) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5zdke.default), {
        ref: ref,
        noFocusGuards: true,
        returnFocus: {
            preventScroll: true
        },
        whiteList: (activeElement)=>{
            if (activeElement === scrollParentRef.current) return false;
            return true;
        },
        focusOptions: {
            preventScroll: true
        },
        className: (0, $gMc0m.default)([
            "_1bsb1osq"
        ]),
        children: children
    });
    return children;
};
const $09db0abbbd70bd3d$export$4ddaad941c29ad29 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance, paddingAdjustments: paddingAdjustments, rainbowBorder: rainbowBorder = true, rainbowBorderAnimation: rainbowBorderAnimation, disablePadding: disablePadding, children: children, enableMaxHeight: enableMaxHeight, enableMaxWidth: enableMaxWidth, className: className, style: style, isAIFC: isAIFC, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($09db0abbbd70bd3d$var$GatedFocusLock, {
        isAIFC: isAIFC,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ref: ref,
            style: {
                ...style,
                // Apply chromeless width styles inline to ensure precedence over CSS classes for screen components (Discard, NoImprovement, etc.)
                ...appearance === 'chromeless' && isAIFC ? $09db0abbbd70bd3d$var$chromelessWidth : null,
                ...disablePadding ? null : paddingAdjustments ? {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingTop: `${$09db0abbbd70bd3d$var$defaultPadding.top + (paddingAdjustments.top ?? 0)}px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingRight: `${$09db0abbbd70bd3d$var$defaultPadding.right + (paddingAdjustments.right ?? 0)}px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingBottom: `${$09db0abbbd70bd3d$var$defaultPadding.bottom + (paddingAdjustments.bottom ?? 0)}px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingLeft: `${$09db0abbbd70bd3d$var$defaultPadding.left + (paddingAdjustments.left ?? 0)}px`
                } : {
                    padding: `${$09db0abbbd70bd3d$var$defaultPadding.top}px ${$09db0abbbd70bd3d$var$defaultPadding.left}px`
                }
            },
            className: (0, $gMc0m.default)([
                rainbowBorder && !isAIFC && "_2rko1mok _kqswh2mm _16qsglyw _14mj22xm _rfx322xm _aetrb3bt _1kt9b3bt _18postnw _1cs8stnw _1bqq1mrw _1g0v1mrw _z0ai1b4h _1mp41b4h _1qdg1b4h _kfgt1b4h _15l21n1a _1auk1n1a _19do1n1a _qnec1n1a _clh3161g _7dwz161g _32rxt94y _1x88t94y _15l21pry _1peq105o _ta6yglyw",
                rainbowBorder && isAIFC && "_2rko1j6v _kqswh2mm _16qsglyw _14mj3ubj _rfx33ubj _aetrb3bt _1kt9b3bt _18postnw _1cs8stnw _1bqq1mrw _1g0v1mrw _z0ai1b4h _1mp41b4h _1qdg1b4h _kfgt1b4h _15l21n1a _1auk1n1a _19do1n1a _qnec1n1a _clh3161g _7dwz161g _32rxt94y _1x88t94y _15l21pry _1peq105o _ta6yglyw",
                $09db0abbbd70bd3d$var$staticStyles[$09db0abbbd70bd3d$var$isFirefox ? 'firefox' : 'default'],
                isAIFC ? "_2rko1tm3 _16qs130s _1bsb1osq _vchhusvi _bfhk1bhr" : "_2rko1mok _16qs130s _4t3i1osq _1bsb1osq _vchhusvi _bfhk1bhr _10kl1kw7 _ktt71kw7",
                rainbowBorderAnimation && $09db0abbbd70bd3d$var$animationStyles[$09db0abbbd70bd3d$var$isFirefox ? 'firefox' : 'default'],
                enableMaxHeight && "_c71ldgin",
                enableMaxWidth && "_1bsb1kdj _p12f1kdj _10fp1h6o",
                enableMaxWidth && (0, $1oCLl.expValEquals)('platform_editor_ai_loading_responsive_width', 'isEnabled', true) && "_1bsb1vrw _p12f1vrw _vchhusvi",
                className
            ]),
            ...rest,
            children: children
        })
    });
});
module.exports["FloatingContainer"] = $09db0abbbd70bd3d$export$4ddaad941c29ad29;

});

parcelRegister("jHWjW", function(module, exports) {
/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $dMzWS = parcelRequire("dMzWS");


var $fIl5U = parcelRequire("fIl5U");


var $4dHlE = parcelRequire("4dHlE");


var $kLoWi = parcelRequire("kLoWi");


var $giv7U = parcelRequire("giv7U");

const $71e6f7e617533af7$var$footerStyles = {
    default: "_zulp1b66 _1e0c1txw _1n261g80 _19bvpxbi _u5f3pxbi _ca0qu2gc _n3tdu2gc _15a5nqa1 _4cvr1h6o _1bah1yb4 _1i531l7x _uwhke4h9"
};
function $71e6f7e617533af7$export$a06f1c675e846f6f({ brand: brand, showDisclaimer: showDisclaimer, disclaimer: disclaimer, showBetaLozenge: showBetaLozenge, showFeedback: showFeedback, feedbackForm: feedbackForm, isAIFC: isAIFC }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [setElement, { width: width }] = (0, $dMzWS.useElementSize)();
    const appearance = (0, $42omo.useMemo)(()=>{
        if (brand === 'atlassian-intelligence') {
            if (width < (0, $kLoWi.AI_BREAKPOINTS).medium) return 'small';
            if (width < (0, $kLoWi.AI_BREAKPOINTS).large) return 'medium';
            return 'large';
        } else {
            if (width < (0, $kLoWi.ROVO_BREAKPOINTS).medium) return 'small';
            if (width < (0, $kLoWi.ROVO_BREAKPOINTS).large) return 'medium';
            return 'large';
        }
    }, [
        width,
        brand
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        ref: setElement,
        xcss: $71e6f7e617533af7$var$footerStyles.default,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                children: [
                    showBetaLozenge && /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        testId: "beta-lozenge",
                        children: formatMessage((0, $giv7U.default).betaLabel)
                    }),
                    showDisclaimer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4dHlE.FooterDisclaimer), {
                        disclaimer: disclaimer,
                        appearance: appearance,
                        isAIFC: isAIFC
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {})
                ]
            }),
            !(0, $dh538.fg)('ai-smart-button-team-25') && !isAIFC && !showFeedback && /*#__PURE__*/ (0, $l998X.jsx)((0, $fIl5U.FooterAIBrand), {
                brand: brand,
                appearance: appearance
            }),
            showFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        children: formatMessage((0, $giv7U.default).compactFeedbackText)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        children: feedbackForm
                    })
                ]
            })
        ]
    });
}
module.exports["Footer"] = $71e6f7e617533af7$export$a06f1c675e846f6f;

});

parcelRegister("8PgnR", function(module, exports) {
/* LatestPromptHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Note: If deleting this file please also delete the exceptions in this file:
 * `packages/editor/generative-ai-modal/src/ui/screens/Preview/__tests__/vr-tests/Preview.vr.ts`
 * ```ts
 * a11y: {
 *	skip: true,
 * },
 * ```
 *
 * These exceptions were made because we have nested buttons inside the EditPrompt button which is a violation.
 * However, we expect these will be resolved with the completion of this work:
 * https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-96926/updates
 */ /** @jsxFrag */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $9LxGu = parcelRequire("9LxGu");


var $9q1Mo = parcelRequire("9q1Mo");


var $c95RC = parcelRequire("c95RC");


var $fMe2J = parcelRequire("fMe2J");


var $99fFg = parcelRequire("99fFg");


var $bwdMU = parcelRequire("bwdMU");


var $5tKPe = parcelRequire("5tKPe");

const $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID = 'ai-latest-prompt-content'; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e9a2eb33803b70e9$var$headerEditStylesUnbounded = null;
const $e9a2eb33803b70e9$var$headerEditStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e9a2eb33803b70e9$var$contentContainerStylesUnbounded = null;
const $e9a2eb33803b70e9$var$contentContainerStyles = null;
const $e9a2eb33803b70e9$var$fullWidth = {
    default: "_1bsb1osq"
};
const $e9a2eb33803b70e9$var$titleContentWrapper = {
    default: "_16jlkb7n _1ul9idpf"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e9a2eb33803b70e9$var$headerStylesUnbounded = null;
const $e9a2eb33803b70e9$var$headerStyles = null; // header has width/padding at the same time
// if there is very long prompt, header will be wider than parent
// so it should be border-box
const $e9a2eb33803b70e9$var$headerBoxSizingStyles = null;
const $e9a2eb33803b70e9$export$289e4ad0cf050b01 = ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, prompt: prompt, promptADF: promptADF, presetTitle: presetTitle, providerFactory: providerFactory, onEditPromptClick: onEditPromptClick, isClearTitle: isClearTitle, agent: agent, showBack: showBack, onBack: onBack, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); // when used in Loading screen, there is no onEditPromptClick
    const canEdit = !!onEditPromptClick;
    const promptContent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (promptADF) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $99fFg.LatestPromptRenderer), {
                    promptADF: promptADF,
                    providerFactory: providerFactory
                }),
                !presetTitle && /*#__PURE__*/ (0, $l998X.jsx)((0, $fMe2J.EditPromptHoverTag), {
                    isClearMode: !presetTitle && !prompt,
                    isPlaceholder: !canEdit
                })
            ]
        });
        if (prompt) return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _ct361wug _slp31hna"
            ]),
            children: prompt
        });
        return null;
    }, [
        canEdit,
        prompt,
        promptADF,
        providerFactory,
        presetTitle
    ]);
    const refinementTagProps = (0, $9LxGu.useAgentRefinementTagProps)(agent);
    const header = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            children: [
                showBack && /*#__PURE__*/ (0, $l998X.jsx)((0, $9q1Mo.BackIconButton), {
                    inPromptHeader: true,
                    isDisabled: !canEdit,
                    stopPropagation: true,
                    onClick: onBack
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    direction: "column",
                    gap: "space.050",
                    xcss: $e9a2eb33803b70e9$var$titleContentWrapper.default,
                    children: [
                        presetTitle && /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        e.preventDefault();
                                    },
                                    children: isClearTitle ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        weight: 'semibold',
                                        children: presetTitle
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $bwdMU.RefinementTag), {
                                        label: presetTitle,
                                        ...refinementTagProps,
                                        onClick: canEdit ? ()=>{
                                            if (onBack) onBack();
                                        } : undefined
                                    })
                                }),
                                presetTitle && /*#__PURE__*/ (0, $l998X.jsx)((0, $fMe2J.EditPromptHoverTag), {
                                    isClearMode: !!presetTitle && !prompt,
                                    isPlaceholder: !canEdit
                                })
                            ]
                        }),
                        promptContent
                    ]
                }),
                !!onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $c95RC.ClosePreviewIconButton), {
                    onClick: onClose
                })
            ]
        });
    }, [
        showBack,
        canEdit,
        onBack,
        presetTitle,
        isClearTitle,
        refinementTagProps,
        prompt,
        promptContent,
        onClose
    ]);
    if (!(prompt || presetTitle)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "prompt-header",
        xcss: $e9a2eb33803b70e9$var$fullWidth.default,
        children: !canEdit ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            id: $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
            "data-testid": $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp _1i4q1hna _1bsb1osq",
                "_gh0qgktf",
                "_vchhusvi",
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _ct361wug _slp31hna",
                "_vwz4gktf"
            ]),
            children: header
        }) : /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            "data-testid": "edit-prompt-button",
            onClick: onEditPromptClick,
            "aria-label": formatMessage((0, $5tKPe.messages).editPrompt),
            "aria-describedby": $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp _1i4q1hna _1bsb1osq",
                "_gh0qgktf",
                "_vchhusvi",
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _ct361wug _slp31hna",
                "_vwz4gktf",
                "_19itglyw _2rko1mok _80omtlke _1bsb1osq _bfhk1j28 _y3gnv2br",
                "_syaz1kw7 _1wybn7od _vwz41kw7 _mrkbidpf _1o0zidpf _gemckb7n _y2mvdfik _1bg41i6y _irr31dpa _1di6fcek"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                id: $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
                "data-testid": $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
                children: header
            })
        })
    });
};
module.exports["LatestPromptHeader"] = $e9a2eb33803b70e9$export$289e4ad0cf050b01;

});

parcelRegister("6bKwm", function(module, exports) {

var $lkJUe = parcelRequire("lkJUe");


var $47Psn = parcelRequire("47Psn");


var $6R7jM = parcelRequire("6R7jM");

const { createPluginState: $370b154d41fb860a$export$656c7661095efe2e, createCommand: $370b154d41fb860a$export$8d4021544bdece00 } = (0, $lkJUe.pluginFactory)((0, $47Psn.rovoAgentsPluginKey), (0, $6R7jM.reducer));
const $370b154d41fb860a$export$a5538d14da6605ff = (state)=>{
    const pluginState = (0, $47Psn.rovoAgentsPluginKey).getState(state);
    return pluginState;
};
module.exports["createPluginState"] = $370b154d41fb860a$export$656c7661095efe2e;
module.exports["createCommand"] = $370b154d41fb860a$export$8d4021544bdece00;
module.exports["getRovoAgentsPluginState"] = $370b154d41fb860a$export$a5538d14da6605ff;

});

parcelRegister("la6aw", function(module, exports) {
var $79918431c8a973f9$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["UPDATE_PLUGIN_STATE"] = 0] = "UPDATE_PLUGIN_STATE";
    return ACTIONS;
}({});
module.exports["ACTIONS"] = $79918431c8a973f9$export$92a1a3b7554e9387;

});

parcelRegister("jAwX6", function(module, exports) {

var $AMCQl = parcelRequire("AMCQl");


var $hgeg8 = parcelRequire("hgeg8");


var $2JNmf = parcelRequire("2JNmf");

const $34695b6faa925ccf$export$8979ff6e494800b3 = ({ appearance: appearance, product: product, actionSideEffect: actionSideEffect, factoryOptions: factoryOptions })=>({
        type: 'generic-chat',
        title: factoryOptions?.isInDocumentStreamingEnabled ? (0, $AMCQl.aiConfigItemMessages).configActionContinueChatLabel : (0, $AMCQl.aiConfigItemMessages).configActionContinueInChatLabel,
        appearance: appearance,
        shortcut: (0, $hgeg8.continueInRovoChat),
        run: ({ name: name, dialogues: dialogues, publish: publish })=>{
            if (!publish || !dialogues.length) return;
            publish({
                type: 'chat-new',
                product: product,
                data: {
                    dialogues: dialogues,
                    name: name
                },
                source: 'editor'
            });
            actionSideEffect?.();
        },
        preserveEditorSelectionOnComplete: true,
        icon: (0, $2JNmf.ChatIcon)
    });
const $34695b6faa925ccf$export$176ad462aa0e7770 = ({ appearance: appearance, agent: agent, product: product, actionSideEffect: actionSideEffect, actionOverride: actionOverride, factoryOptions: factoryOptions })=>({
        type: 'agent',
        title: factoryOptions?.isInDocumentStreamingEnabled ? (0, $AMCQl.aiConfigItemMessages).configActionContinueChatLabel : (0, $AMCQl.aiConfigItemMessages).configActionContinueInChatLabel,
        shortcut: (0, $hgeg8.continueInRovoChat),
        appearance: appearance,
        run: ({ channelId: channelId, publish: publish })=>{
            if (!channelId || !publish) return;
            if (typeof actionOverride === 'function') {
                actionOverride({
                    channelId: channelId
                });
                return;
            }
            publish({
                type: 'chat-open',
                product: product,
                data: {
                    channelId: channelId,
                    agentId: agent.namedId
                },
                source: 'editor'
            });
            actionSideEffect?.();
        },
        preserveEditorSelectionOnComplete: true,
        icon: (0, $2JNmf.ChatIcon)
    });
module.exports["createContinueInChat"] = $34695b6faa925ccf$export$8979ff6e494800b3;
module.exports["createContinueInChatForAgent"] = $34695b6faa925ccf$export$176ad462aa0e7770;

});

parcelRegister("hgTYG", function(module, exports) {
var $faa76e567c65cfd0$export$c5e4fced70735903 = /*#__PURE__*/ function(SupportedTranslationLanguages) {
    SupportedTranslationLanguages["ChineseSimplified"] = "chineseSimplified";
    SupportedTranslationLanguages["ChineseTraditional"] = "chineseTraditional";
    SupportedTranslationLanguages["Czech"] = "czech";
    SupportedTranslationLanguages["Danish"] = "danish";
    SupportedTranslationLanguages["Dutch"] = "dutch";
    SupportedTranslationLanguages["English"] = "english";
    SupportedTranslationLanguages["Finnish"] = "finnish";
    SupportedTranslationLanguages["French"] = "french";
    SupportedTranslationLanguages["German"] = "german";
    SupportedTranslationLanguages["Hungarian"] = "hungarian";
    SupportedTranslationLanguages["Italian"] = "italian";
    SupportedTranslationLanguages["Japanese"] = "japanese";
    SupportedTranslationLanguages["Korean"] = "korean";
    SupportedTranslationLanguages["Norwegian"] = "norwegian";
    SupportedTranslationLanguages["Polish"] = "polish";
    SupportedTranslationLanguages["PortugueseBrazilian"] = "portugueseBrazilian";
    SupportedTranslationLanguages["Russian"] = "russian";
    SupportedTranslationLanguages["Spanish"] = "spanish";
    SupportedTranslationLanguages["Swedish"] = "swedish";
    SupportedTranslationLanguages["Turkish"] = "turkish";
    SupportedTranslationLanguages["Thai"] = "thai";
    SupportedTranslationLanguages["Ukrainian"] = "ukrainian";
    SupportedTranslationLanguages["Vietnamese"] = "vietnamese";
    return SupportedTranslationLanguages;
}({});
const $faa76e567c65cfd0$export$20cfed69f1ef38ea = [
    "english",
    "german",
    "japanese",
    "french",
    "korean",
    "spanish",
    "portugueseBrazilian",
    "russian",
    "dutch",
    "chineseSimplified",
    "polish",
    "italian",
    "chineseTraditional",
    "norwegian",
    "swedish",
    "czech",
    "finnish",
    "danish",
    "hungarian",
    "turkish",
    "thai",
    "ukrainian",
    "vietnamese"
];
const $faa76e567c65cfd0$export$9e88c4e080b12be6 = [
    "english",
    "german",
    "french",
    "spanish",
    "japanese",
    "portugueseBrazilian",
    "chineseSimplified",
    "korean"
];
module.exports["SupportedTranslationLanguages"] = $faa76e567c65cfd0$export$c5e4fced70735903;
module.exports["supportedTranslationLanguagesPopularOrder"] = $faa76e567c65cfd0$export$20cfed69f1ef38ea;
module.exports["refinementSupportedTranslationLanguages"] = $faa76e567c65cfd0$export$9e88c4e080b12be6;

});

parcelRegister("2gWl9", function(module, exports) {
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $1a7a548e9b491523$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
}
function $1a7a548e9b491523$var$getDevTools() {
    const w = $1a7a548e9b491523$export$a4e55266d2135a7f();
    if (w.__xstate__) return w.__xstate__;
    return undefined;
}
function $1a7a548e9b491523$export$4d7a7d14704ebc13(service) {
    if (typeof window === 'undefined') return;
    const devTools = $1a7a548e9b491523$var$getDevTools();
    if (devTools) devTools.register(service);
}
const $1a7a548e9b491523$export$3ee8010769463234 = (service)=>{
    if (typeof window === 'undefined') return;
    const devTools = $1a7a548e9b491523$var$getDevTools();
    if (devTools) devTools.register(service);
};
module.exports["devToolsAdapter"] = $1a7a548e9b491523$export$3ee8010769463234;

});

parcelRegister("ilIeg", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $dh538 = parcelRequire("dh538");

function $951fbaee997f5802$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics) {
    return {
        singleInstrumentationID: interactionID ?? '',
        aiInteractionID: interactionID ?? '',
        aiFeatureName: 'Editor AI',
        aiExperienceName: experienceName ?? 'unknown',
        isAIFeature: 1,
        proactiveAIGenerated: !!isProactive ? 1 : 0,
        userGeneratedAI: !isProactive ? 1 : 0,
        traceIds: traceIds,
        invokedFrom: invokedFrom,
        nudgeMetrics: nudgeMetrics
    };
}
function $951fbaee997f5802$export$b0cd7b0ace1e359d({ action: action, interactionID: interactionID, attributes: attributes, experienceName: experienceName, isProactive: isProactive, invokedFrom: invokedFrom, traceIds: traceIds, nudgeMetrics: nudgeMetrics, isStreamingEnded: // Remove below flag when AIFC is fully rolled out in Jira, only required for old experience in Jira.
isStreamingEnded, aiGroupId: aiGroupId, isPayloadCreate: isPayloadCreate }) {
    let unifiedAnalyticsAttributes = $951fbaee997f5802$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics);
    // Remove below flag when AIFC is fully rolled out in Jira, only required for old experience in Jira.
    if ((0, $dh538.fg)('platform_editor_ai_streaming_ended_analytics_attr')) unifiedAnalyticsAttributes = {
        ...unifiedAnalyticsAttributes,
        isStreamingEnded: isStreamingEnded
    };
    switch(action){
        case (0, $d925B.ACTION).ACTIONED:
            return {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    aiResultAction: 'unknown',
                    aiGroupId: aiGroupId,
                    ...isPayloadCreate !== undefined && {
                        isPayloadCreate: isPayloadCreate
                    },
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $d925B.ACTION).VIEWED:
        case (0, $d925B.ACTION).ERROR:
            return {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $d925B.ACTION).INITIATED:
        case (0, $d925B.ACTION).DISMISSED:
            return {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_INTERACTION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $d925B.ACTION).SUBMITTED:
            return {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_FEEDBACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    // If feedback result is not explicitly set then we should assume negative, since people are more likely to
                    // report negative experiences than they are positive ones.
                    aiFeedbackResult: 'down',
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $d925B.ACTION).DISCARDED:
            return {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
    }
}
module.exports["createUnifiedAnalyticsPayload"] = $951fbaee997f5802$export$b0cd7b0ace1e359d;

});

parcelRegister("4NrmI", function(module, exports) {
const $5c90024cb64bc549$var$packageName = "platform-pkg";
const $5c90024cb64bc549$var$packageVersion = "0.0.0-use.local";
function $5c90024cb64bc549$export$cd17d76da7967240() {
    return {
        packageName: $5c90024cb64bc549$var$packageName,
        packageVersion: $5c90024cb64bc549$var$packageVersion
    };
}
module.exports["getPackageInfo"] = $5c90024cb64bc549$export$cd17d76da7967240;

});

parcelRegister("9OCYt", function(module, exports) {
var $61e3d7d4d520c723$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["START_WATCHING_REGION"] = "START_WATCHING_REGION";
    ACTIONS["END_WATCHING_REGION"] = "END_WATCHING_REGION";
    return ACTIONS;
}({});
module.exports["ACTIONS"] = $61e3d7d4d520c723$export$92a1a3b7554e9387;

});

parcelRegister("3tFte", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $e804be830cc6f8eb$export$3e0658d2a785b1da = new (0, $ks2lK.PluginKey)('aiAnnotationWatchmen');
module.exports["aiAnnotationWatchmenPluginKey"] = $e804be830cc6f8eb$export$3e0658d2a785b1da;

});

parcelRegister("9F9dO", function(module, exports) {
var $003cfd8cd776afbf$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["INIT_POSITIONS"] = "initPositions";
    ACTIONS["ADJUST_INIT_POSITIONS"] = "adjustInitPositions";
    ACTIONS["UPDATE_STREAM_POSITIONS"] = "updateStream";
    ACTIONS["UPDATE_LOADING_POSITIONS"] = "updateLoadingPos";
    ACTIONS["END_STREAM"] = "endStream";
    return ACTIONS;
}({});
module.exports["ACTIONS"] = $003cfd8cd776afbf$export$92a1a3b7554e9387;

});

parcelRegister("5vNOi", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $14418ebe22b947f3$export$a61c34149e930535 = new (0, $ks2lK.PluginKey)('inEditorDirectStreaming');
module.exports["inEditorDirectStreamingPluginKey"] = $14418ebe22b947f3$export$a61c34149e930535;

});

parcelRegister("ly5a2", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $09a5d833f1781cb6$export$1a0aec8c8b578c93 = new (0, $ks2lK.PluginKey)('purePmInEditorDirectStreaming');
module.exports["purePmInEditorDirectStreamingPluginKey"] = $09a5d833f1781cb6$export$1a0aec8c8b578c93;

});

parcelRegister("3yUTv", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $6f3ffed7a038f55b$export$32db9543f41e636c = new (0, $ks2lK.PluginKey)('aiExperienceDecoration');
module.exports["aiExperienceDecorationPluginKey"] = $6f3ffed7a038f55b$export$32db9543f41e636c;

});

parcelRegister("99IPz", function(module, exports) {

var $ftzrq = parcelRequire("ftzrq");


var $dh538 = parcelRequire("dh538");

/**
 * Calculates positions from modalDecorationSet and initialPositions.
 * This logic mirrors the calculation done in ContentComponent.
 */ function $3db5aed15ab8cc2f$var$calculatePositions(modalDecorationSet, initialPositions) {
    // Prioritise getting position from inlineDecoration,
    // otherwise get decoration position from start or end widget
    let positions = [
        0,
        0
    ];
    const decoration = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'modalMountPointDecoration' || spec.key === 'modalMountPointRangeDecoration').shift();
    if (decoration) {
        // when there is decoration, it means it's text selection
        // we need to use the initial positions
        // as the decoration positions are not accurate when there the selection is empty
        if (!initialPositions) return undefined;
        positions = initialPositions;
    } else {
        const nodeDecorations = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration');
        if (nodeDecorations.length > 0) {
            const startPos = Math.min(...nodeDecorations.map((decoration)=>decoration.from));
            const endPos = Math.max(...nodeDecorations.map((decoration)=>decoration.to));
            positions = [
                startPos,
                endPos
            ];
        } else return undefined;
    }
    return positions;
}
function $3db5aed15ab8cc2f$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        case 'END_EXPERIENCE':
            // When the experience ends the plugin state needs to reset everything back to the initial plugin state
            return {
                modalDecorationSet: (0, $ftzrq.DecorationSet).empty,
                dispatchAnalyticsEvent: state.dispatchAnalyticsEvent,
                initialPositions: undefined,
                initialSelection: undefined,
                positions: undefined,
                ...action.data,
                isRunning: false,
                isShowingAcceptRejectScreen: false,
                targetId: state.targetId,
                currentSessionId: state.currentSessionId === state.nextSessionId ? state.currentSessionId : undefined,
                nextSessionId: state.nextSessionId,
                hideLoadingScreen: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? state.nextSessionId ? state.hideLoadingScreen : false : undefined,
                sessionEnded: false,
                isInDocumentStreamingEnabled: state.isInDocumentStreamingEnabled,
                isCreate: undefined
            };
        case 'SHOW_MODAL':
            return {
                ...state,
                ...action.data,
                isRunning: true,
                isShowingAcceptRejectScreen: action.data.withAcceptReject && !state.nextSessionId,
                currentSessionId: state.nextSessionId,
                // if somehow END_EXPERIENCE is called before END_SESSION, reset sessionEnded to false here
                sessionEnded: false,
                positions: $3db5aed15ab8cc2f$var$calculatePositions(action.data.modalDecorationSet, action.data.initialPositions),
                ignoredSpaceTriggerSelection: undefined,
                isCreate: action.data.isCreate
            };
        case 'UPDATE_MODAL_DECORATION_SET':
            return {
                ...state,
                modalDecorationSet: action.data.modalDecorationSet,
                positions: $3db5aed15ab8cc2f$var$calculatePositions(action.data.modalDecorationSet, state.initialPositions)
            };
        case 'START_SESSION':
            return {
                ...state,
                nextSessionId: action.data.sessionId,
                traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? action.data.traceId : undefined,
                sessionStarted: true,
                sessionEnded: false,
                isShowingAcceptRejectScreen: false
            };
        case 'END_SESSION':
            return {
                ...state,
                nextSessionId: action.data.sessionId,
                currentSessionId: state.isRunning ? state.currentSessionId : action.data.sessionId,
                hideLoadingScreen: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? false : state.hideLoadingScreen,
                sessionStarted: false,
                sessionEnded: true,
                traceId: undefined
            };
        case 'UPDATE_TARGET_ID':
            return {
                ...state,
                targetId: action.data.targetId
            };
        default:
            return state;
    }
}
module.exports["reducer"] = $3db5aed15ab8cc2f$export$1650419e431d3ba3;

});

parcelRegister("56Rej", function(module, exports) {
const $b51dfe8b83a6e266$export$4306d8811b2d2e31 = (state)=>state.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'generatedInlineDecoration' || spec.key === 'generatedNodeDecoration' || spec.key === 'generatedStartWidget' || spec.key === 'generatedEndWidget').length > 0;
module.exports["hasGeneratedContentDecorations"] = $b51dfe8b83a6e266$export$4306d8811b2d2e31;

});

parcelRegister("j51b9", function(module, exports) {
/**
 * Figure out what to do with these, possibly export/shift into editor-common
 * during move into editor-core
 */ 
var $aXG5V = parcelRequire("aXG5V");


var $5SuLc = parcelRequire("5SuLc");

function $4d34e7990dfafd26$var$getClosestValidTextPositionBefore({ pos: pos, doc: doc }) {
    let validPos = pos;
    while(validPos > 0){
        if (doc.resolve(validPos).parent.inlineContent) break;
        validPos--;
    }
    return validPos;
}
function $4d34e7990dfafd26$var$getClosestValidTextPositionAfter({ pos: pos, doc: doc }) {
    let validPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.resolve(validPos).parent.inlineContent) {
            isValidPos = true;
            break;
        }
        validPos++;
    }
    return validPos;
}
function $4d34e7990dfafd26$var$findLastChildWithTextContent(content) {
    if (content.childCount <= 0) return null;
    let count = content.childCount - 1;
    const validNode = content.child(count);
    while(count >= 0){
        if (content.child(count).textContent !== '') break;
        count--;
    }
    return validNode;
}
function $4d34e7990dfafd26$var$getEndPosition({ step: step, doc: doc }) {
    let validPos = step.from + step.slice.size;
    let isValidPos = false;
    // Fragments can contain empty nodes, find the last childNode that has textContent
    const validNode = $4d34e7990dfafd26$var$findLastChildWithTextContent(step.slice.content);
    // Return start position if there are no valid nodes
    if (!validNode) return step.from;
    // Find textContent of last childNode with textContent
    const textContent = validNode.textContent;
    // Loop through endPos and find position where textBetween start and endPos matches textContent from last childNode in step
    // Check slice created between the positions to ensure no empty child nodes
    while(isValidPos === false && validPos > 0){
        const textBetween = doc.textBetween(step.from, validPos);
        const slice = doc.slice(step.from, validPos);
        if (textBetween.endsWith(textContent) && slice.content.lastChild?.textContent !== '') {
            isValidPos = true;
            break;
        }
        validPos--;
    }
    return validPos;
}
function $4d34e7990dfafd26$var$getValidStartTextPosition({ pos: pos, doc: doc }) {
    let startPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.nodeAt(startPos)) {
            isValidPos = true;
            break;
        }
        startPos++;
    }
    return $4d34e7990dfafd26$var$getClosestValidTextPositionAfter({
        pos: startPos,
        doc: doc
    });
}
function $4d34e7990dfafd26$export$a2bf0757549da456({ step: step, doc: doc }) {
    const endPos = $4d34e7990dfafd26$var$getEndPosition({
        step: step,
        doc: doc
    });
    return $4d34e7990dfafd26$var$getClosestValidTextPositionBefore({
        pos: endPos,
        doc: doc
    });
}
function $4d34e7990dfafd26$export$ec5fde712084a8ed(steps) {
    const step = steps.find((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
    if (!step) return null;
    return step;
}
function $4d34e7990dfafd26$export$9d1e89ce90c0a9a(transaction, isInDocumentStreamingEnabled) {
    const step = $4d34e7990dfafd26$export$ec5fde712084a8ed(transaction.steps);
    if (!step) return null;
    const validStartDecorationPos = $4d34e7990dfafd26$var$getValidStartTextPosition({
        pos: step.from,
        doc: transaction.doc
    });
    const validEndDecorationPos = $4d34e7990dfafd26$export$a2bf0757549da456({
        step: step,
        doc: transaction.doc
    });
    return (0, $5SuLc.createGeneratedContentDecorations)(validStartDecorationPos, validEndDecorationPos, isInDocumentStreamingEnabled);
}
function $4d34e7990dfafd26$export$a6a2b5778b599ea1(transaction) {
    const replaceSteps = transaction.steps.filter((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
    if (replaceSteps.length === 0) return [];
    return replaceSteps.map((step)=>{
        const startPos = step.from;
        const node = transaction.doc.nodeAt(startPos);
        if (node) {
            const endPos = startPos + node.nodeSize;
            return (0, $5SuLc.createGeneratedNodeDecorations)(startPos, endPos);
        }
    }).filter((decoration)=>decoration !== undefined);
}
module.exports["getValidEndTextPosition"] = $4d34e7990dfafd26$export$a2bf0757549da456;
module.exports["findFirstReplaceStep"] = $4d34e7990dfafd26$export$ec5fde712084a8ed;
module.exports["getGeneratedDecorationFromTransaction"] = $4d34e7990dfafd26$export$9d1e89ce90c0a9a;
module.exports["getGeneratedNodeDecorationsFromTransaction"] = $4d34e7990dfafd26$export$a6a2b5778b599ea1;

});

parcelRegister("dMzWS", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $9fbdeaf1889c5c72$export$2b86bedf890eab8() {
    const [element, setElement] = (0, $42omo.useState)(null);
    const [width, setWidth] = (0, $42omo.useState)(0);
    const [height, setHeight] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        if (!element) return;
        // Do no use here ResizeObserverEntry.contentRect as it is only a content size (without padding and border)
        // and we need the size of the whole element.
        const updateSize = ()=>{
            const { width: width, height: height } = element.getBoundingClientRect();
            setWidth(width);
            setHeight(height);
        };
        const resizeObserver = new ResizeObserver(updateSize);
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        element
    ]);
    return (0, $42omo.useMemo)(()=>[
            setElement,
            {
                width: width,
                height: height
            }
        ], [
        width,
        height
    ]);
}
module.exports["useElementSize"] = $9fbdeaf1889c5c72$export$2b86bedf890eab8;

});

parcelRegister("fIl5U", function(module, exports) {
/* FooterAIBrand.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $giv7U = parcelRequire("giv7U");

function $6a177a0de5eb3ba4$export$e0578d9df5b50dd4({ appearance: appearance }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        children: [
            appearance !== 'small' && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    color: "color.text.subtle",
                    children: formatMessage((0, $giv7U.default).rovoCopyright)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                label: formatMessage((0, $giv7U.default).rovoCopyright),
                appearance: "neutral",
                size: "small"
            })
        ]
    });
}
module.exports["FooterAIBrand"] = $6a177a0de5eb3ba4$export$e0578d9df5b50dd4;

});

parcelRegister("4dHlE", function(module, exports) {
/* FooterDisclaimer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8tSmd = parcelRequire("8tSmd");


var $eXmBZ = parcelRequire("eXmBZ");


var $auNCB = parcelRequire("auNCB");

var $u9agA = parcelRequire("u9agA");


var $giv7U = parcelRequire("giv7U");


var $94WvO = parcelRequire("94WvO");

const $4e57ea65134cd5ef$var$linkStyles = {
    default: "_11c8wadc _syazazsu _1053azsu"
};
function $4e57ea65134cd5ef$export$d8e84a6a42a1313b({ disclaimer: disclaimer, appearance: appearance, isAIFC: isAIFC }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return disclaimer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $94WvO.CustomDisclaimer), {
        disclaimer: disclaimer
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        children: [
            isAIFC ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
                label: formatMessage((0, $giv7U.default).infoIconLabel),
                color: "var(--ds-text-subtle, #505258)",
                size: "small"
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: formatMessage((0, $giv7U.default).infoIconLabel),
                color: "var(--ds-text-subtle, #505258)",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                color: "var(--ds-text-subtle, #505258)",
                href: "https://www.atlassian.com/trust/atlassian-intelligence",
                xcss: $4e57ea65134cd5ef$var$linkStyles.default,
                children: formatMessage((0, $giv7U.default).disclaimerTextUpdated)
            })
        ]
    });
}
module.exports["FooterDisclaimer"] = $4e57ea65134cd5ef$export$d8e84a6a42a1313b;

});

parcelRegister("kLoWi", function(module, exports) {
// Source: https://www.figma.com/design/2do7MeD1hEmSftXLGER1Xy/AI-Patterns-2024?node-id=82-12683&t=bPIR0f4r8UiwwCr1-4
const $887802c4558e1c09$export$3d1352baed9f774a = {
    medium: 328,
    large: 624
};
const $887802c4558e1c09$export$f859a198decf7af = {
    medium: 300,
    large: 480
};
module.exports["AI_BREAKPOINTS"] = $887802c4558e1c09$export$3d1352baed9f774a;
module.exports["ROVO_BREAKPOINTS"] = $887802c4558e1c09$export$f859a198decf7af;

});

parcelRegister("giv7U", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fe1157c18e790dc$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $1fe1157c18e790dc$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    betaLabel: {
        id: "fabric.editor.ai.screens.preview.betaLabel",
        defaultMessage: "Beta"
    },
    infoIconLabel: {
        id: "fabric.editor.ai.commandPalette.footer.infoIconLabel",
        defaultMessage: "Information"
    },
    atlassianIntelligenceCopyrightShort: {
        id: "fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort",
        defaultMessage: "Powered by AI"
    },
    atlassianIntelligenceCopyright: {
        id: "fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    rovoCopyright: {
        id: "fabric.editor.ai.commandPalette.footer.rovoCopyright",
        defaultMessage: "Rovo"
    },
    /**
   * https://hello.atlassian.net/wiki/spaces/AAI/pages/5055352099/Footer+guidelines+for+AI+Updated+Mar+2025
   * Updated Mar 2025
   * However this is put behind a feature flag along with a11y updates.
   * Can use this as a default once the feature flag is removed, make sure to get rid of disclaimerTextShort & disclaimerText
   * See thread: https://atlassian.slack.com/archives/C04039CJ003/p1743571543775729
   */ disclaimerTextUpdated: {
        id: "fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated",
        defaultMessage: "Uses AI. Verify results."
    },
    usePageKnowledgeToggleLabel: {
        id: "fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel",
        defaultMessage: "Include knowledge from current page"
    },
    compactFeedbackText: {
        id: "fabric.editor.ai.screens.preview.compactFeedbackText",
        defaultMessage: "Helpful?"
    }
});

});

parcelRegister("9LxGu", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hezkK = parcelRequire("hezkK");

function $ba8341fac4d94d12$export$e8e2b5fd4b3854f2(agent) {
    const props = (0, $42omo.useMemo)(()=>{
        if (agent) return {
            elemBefore: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                "data-testId": "command-palette-rovo-agent-icon",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hezkK.AgentAvatar), {
                    agentId: agent.id,
                    agentNamedId: agent.externalConfigReference ?? agent.namedId,
                    agentIdentityAccountId: agent.identityAccountId,
                    isForgeAgent: agent.creatorType === 'FORGE',
                    forgeAgentIconUrl: agent.icon,
                    label: agent.name,
                    size: "xsmall"
                })
            }),
            appearance: 'rounded'
        };
        else return undefined;
    }, [
        agent
    ]);
    return props;
}
module.exports["useAgentRefinementTagProps"] = $ba8341fac4d94d12$export$e8e2b5fd4b3854f2;

});

parcelRegister("9q1Mo", function(module, exports) {
/* BackIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $laHi9 = parcelRequire("laHi9");


var $1s5hv = parcelRequire("1s5hv");


var $aYaJs = parcelRequire("aYaJs");

const $b8ba0bd35619d8be$var$inPromptHeaderStyles = {
    default: "_1e0c116y _2hwx1b66"
};
const $b8ba0bd35619d8be$var$toolTipProps = {
    position: 'top'
};
const $b8ba0bd35619d8be$export$dcf44e0bed76850 = ({ inPromptHeader: inPromptHeader, isDisabled: isDisabled = false, stopPropagation: stopPropagation, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onClickIconButton = (0, $42omo.useCallback)((event)=>{
        if (stopPropagation) event.stopPropagation();
        onClick?.();
    }, [
        stopPropagation,
        onClick
    ]);
    const btn = /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        isDisabled: isDisabled,
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                label: iconProps.label,
                testId: iconProps.testId,
                size: "small"
            }),
        label: formatMessage((0, $aYaJs.default).backLabel),
        spacing: "compact",
        isTooltipDisabled: isDisabled,
        onClick: onClickIconButton,
        testId: "back-icon-button",
        tooltip: $b8ba0bd35619d8be$var$toolTipProps
    });
    if (inPromptHeader) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $b8ba0bd35619d8be$var$inPromptHeaderStyles.default,
        children: btn
    });
    return btn;
};
module.exports["BackIconButton"] = $b8ba0bd35619d8be$export$dcf44e0bed76850;

});

parcelRegister("c95RC", function(module, exports) {
/* ClosePreviewIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $1s5hv = parcelRequire("1s5hv");


var $8lt1y = parcelRequire("8lt1y");

const $75921729b8ea3338$var$inPromptHeaderStyles = {
    default: "_1e0c116y _2hwx1b66"
};
const $75921729b8ea3338$var$toolTipProps = {
    position: 'top'
};
const $75921729b8ea3338$export$d428cfd0d6a2b2ec = 'close-preview-icon-button';
const $75921729b8ea3338$export$777abcc87b2abd7a = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $75921729b8ea3338$var$inPromptHeaderStyles.default,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            label: formatMessage((0, $8lt1y.default).closePreviewLabel),
            spacing: "compact",
            onClick: onClick,
            testId: $75921729b8ea3338$export$d428cfd0d6a2b2ec,
            tooltip: $75921729b8ea3338$var$toolTipProps,
            isTooltipDisabled: false
        })
    });
};
module.exports["ClosePreviewIconButton"] = $75921729b8ea3338$export$777abcc87b2abd7a;

});

parcelRegister("fMe2J", function(module, exports) {
/* EditPromptHoverTag.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ho4zm = parcelRequire("ho4zm");


var $du2CF = parcelRequire("du2CF");

const $414d03f659b34c15$var$containerStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $414d03f659b34c15$var$containerStylesUnbounded = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $414d03f659b34c15$var$placeholderStyles = null;
const $414d03f659b34c15$export$3a1fe5569d8f8994 = ({ isClearMode: isClearMode = false, isPlaceholder: isPlaceholder })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const text = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return isClearMode ? formatMessage((0, $du2CF.messages).clearPromptHover) : formatMessage((0, $du2CF.messages).editPromptHover);
    }, [
        isClearMode,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        id: "edit-prompt-hover-button",
        "data-testid": "edit-prompt-hover-button",
        className: (0, $gMc0m.default)([
            "_1o9zidpf _18u01wug _19pk1i6y _otyr1i6y _1e0c116y _tzy4idpf",
            "_1npcidpf _1gicidpf _1e09idpf _1mspidpf _1vf2tlke _1at8v77o _1cjov77o _1yg612x7 _hjaq12x7",
            isPlaceholder && "_1vf273ad"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ho4zm.default), {
            text: text
        })
    });
};
module.exports["EditPromptHoverTag"] = $414d03f659b34c15$export$3a1fe5569d8f8994;

});

parcelRegister("99fFg", function(module, exports) {
/* LatestPromptRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $67O0h = parcelRequire("67O0h");


var $lspPP = parcelRequire("lspPP");

const $89b92009584e8b14$var$rendererContainerStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $89b92009584e8b14$var$rendererDocumentStyles = null;
const $89b92009584e8b14$var$RendererWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _l0ms15vq _1aiy15vq _btic1l2s _pkxt1q9c _1wzj1wug _usad1hna _ceky1ufz _hgabu2gc _1vmmkb7n _hgakkb7n _p8i3j915 _1a6vb3bt _1mrdf705 _q3ck1q9c",
            "_c71l1xlq _motn1m6u _1u151tcg"
        ]),
        children: children
    });
};
const $89b92009584e8b14$export$308e8087851b72a3 = ({ promptADF: promptADF, providerFactory: providerFactory })=>{
    const jsonDocument = promptADF;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lspPP.RendererActionsContext), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($89b92009584e8b14$var$RendererWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
                document: jsonDocument,
                media: {
                    // We don't currently support images with captions
                    allowLinking: false
                },
                // the nodes and marks the markdown transformer can create.
                // see packages/editor/adf-schema/src/schema/default-schema.ts for details.
                useSpecBasedValidator: true,
                dataProviders: providerFactory,
                maxHeight: 20
            })
        })
    });
};
module.exports["LatestPromptRenderer"] = $89b92009584e8b14$export$308e8087851b72a3;

});

parcelRegister("bwdMU", function(module, exports) {
/* RefinementTag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $3WVxj = parcelRequire("3WVxj");

var $ho4zm = parcelRequire("ho4zm");


var $b4FAJ = parcelRequire("b4FAJ");

const $4d07a272adce5f25$var$cssVars = {
    alignItems: '--align-items',
    elemBeforeHeight: '--elem-before-height'
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $4d07a272adce5f25$var$refinementTagStylesVisualRefresh = null; /**
                                                * RefinementTag is the component which renders the
                                                * title of preset prompts such as
                                                * - Brainstorm
                                                * - Summarize
                                                *
                                                * When rendered as part of a user input field, it should provide an
                                                * onClick to display the remove button to allow users to remove the tag.
                                                * When rendered as a presentational element to show which
                                                * preset prompt has been used, it should not provide an onClick
                                                * to keep the tag presentational.
                                                */ 
const $4d07a272adce5f25$export$21c661408d518ab6 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ label: label, onClick: onClick, elemBefore: elemBefore, appearance: appearance }, ref)=>{
    const styles = {
        [$4d07a272adce5f25$var$cssVars.alignItems]: appearance === 'rounded' ? 'center' : 'flex-start',
        [$4d07a272adce5f25$var$cssVars.elemBeforeHeight]: appearance === 'rounded' ? '100%' : 'auto'
    };
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _18vq4x5u _1k2cidpf _b3iiidpf _spsw16ko _qxh5o3gi",
            "refinement-tag"
        ]),
        "data-testid": "command-palette-refinement-tag",
        role: "status",
        "aria-atomic": "true",
        "aria-label": formatMessage((0, $b4FAJ.default).promptSelected, {
            promptName: label
        }),
        "aria-live": "assertive",
        ref: ref,
        children: !onClick ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ho4zm.default), {
            testId: 'refinement-tag',
            text: label,
            elemBefore: elemBefore,
            appearance: appearance
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3WVxj.default), {
            appearance: appearance,
            elemBefore: elemBefore,
            testId: 'refinement-tag',
            removeButtonLabel: formatMessage((0, $b4FAJ.default).removeLabel),
            text: label,
            onBeforeRemoveAction: ()=>{
                onClick();
                return false;
            }
        })
    });
});
module.exports["RefinementTag"] = $4d07a272adce5f25$export$21c661408d518ab6;

});

parcelRegister("5tKPe", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $a6ad6c004f3a0bb1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    editPrompt: {
        id: "fabric.editor.ai.screens.preview.header.edit",
        defaultMessage: "Edit prompt"
    }
});
module.exports["messages"] = $a6ad6c004f3a0bb1$export$defe85febe8b728c;

});

parcelRegister("47Psn", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $c3d2dc9e3a604529$export$90eb11e11e5cf6f9 = new (0, $ks2lK.PluginKey)('rovoAgentsPlugin');
module.exports["rovoAgentsPluginKey"] = $c3d2dc9e3a604529$export$90eb11e11e5cf6f9;

});

parcelRegister("6R7jM", function(module, exports) {

var $la6aw = parcelRequire("la6aw");

const $6c3e873edc18f3a0$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case (0, $la6aw.ACTIONS).UPDATE_PLUGIN_STATE:
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
};
module.exports["reducer"] = $6c3e873edc18f3a0$export$1650419e431d3ba3;

});

parcelRegister("2JNmf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");

const $0a007a21b2770402$export$52cd484a7ef4f2b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        label: "",
        spacing: "spacious"
    });
module.exports["ChatIcon"] = $0a007a21b2770402$export$52cd484a7ef4f2b9;

});

parcelRegister("94WvO", function(module, exports) {
/* CustomDisclaimer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");

const $8b239a68aa67d8d0$var$footerInformationStylesUnbounded = null;
const $8b239a68aa67d8d0$var$footerInformationStyles = null;
function $8b239a68aa67d8d0$export$2cebd3bbd14f5ea6({ disclaimer: disclaimer }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o",
            "_1ul9idpf _1tke1ejb _1yp2wadc _55c6wadc _tml1azsu _17mnazsu _1bchidpf _1rbcidpf _1npc1b66 _1gic1b66 _1e091b66"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: "custom-disclaimer",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: disclaimer.tooltip,
                position: "top",
                children: disclaimer.url ? (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__editor-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: disclaimer.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: disclaimer.text
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $l998X.jsx)("a", {
                    href: disclaimer.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: disclaimer.text
                }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    children: disclaimer.text
                })
            })
        })
    });
}
module.exports["CustomDisclaimer"] = $8b239a68aa67d8d0$export$2cebd3bbd14f5ea6;

});

parcelRegister("aYaJs", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf82cabcf0fa8110$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $cf82cabcf0fa8110$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    backLabel: {
        id: "fabric.editor.ai.components.backIconButton.backLabel",
        defaultMessage: "Back"
    }
});

});

parcelRegister("8lt1y", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c9ff14148143af2$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $5c9ff14148143af2$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    closePreviewLabel: {
        id: "fabric.editor.ai.components.closePreviewIconButton.closePreviewLabel.non-final",
        defaultMessage: "Close preview"
    }
});

});

parcelRegister("du2CF", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $3a77c66a57ad2118$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    editPromptHover: {
        id: "fabric.editor.ai.screens.preview.header.edit.hover",
        defaultMessage: "Edit"
    },
    clearPromptHover: {
        id: "fabric.editor.ai.screens.preview.header.clear.hover",
        defaultMessage: "Clear"
    }
});
module.exports["messages"] = $3a77c66a57ad2118$export$defe85febe8b728c;

});

parcelRegister("b4FAJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $36b144a94efd45fa$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $36b144a94efd45fa$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    removeLabel: {
        id: "fabric.editor.ai.screens.promptWithSelectedOption.removeLabel",
        defaultMessage: "Remove"
    },
    promptSelected: {
        id: "fabric.editor.ai.screens.promptWithSelectedOption.promptSelected",
        defaultMessage: "{promptName} - Selected"
    }
});

});


//# sourceMappingURL=FullPageEditorComponent.1efbaa77.js.map
